export type Maybe<T> = T | null;
export type InputMaybe<T> = T | null;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Date: { input: string; output: string; }
  DateTime: { input: string; output: string; }
  Decimal: { input: number; output: number; }
  JSON: { input: Record<string, any>; output: Record<string, any>; }
  NaiveDateTime: { input: string; output: string; }
  Numrange: { input: string; output: string; }
  PlainDecimal: { input: number; output: number; }
  Price: { input: number; output: number; }
  Time: { input: string; output: string; }
  Truthy: { input: boolean; output: boolean; }
  Upload: { input: unknown; output: unknown; }
};

export type AccountCreditHistoryOrderBy = {
  amount?: InputMaybe<OrderByDirection>;
  datetime?: InputMaybe<OrderByDirection>;
  insertedAt?: InputMaybe<OrderByDirection>;
};

export type AccountCreditHistoryResponse = {
  __typename?: 'AccountCreditHistoryResponse';
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  hasPreviousPage?: Maybe<Scalars['Boolean']['output']>;
  payments?: Maybe<Array<Maybe<Payment>>>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type AccountsFilters = {
  addressCity?: InputMaybe<Scalars['String']['input']>;
  addressLine1?: InputMaybe<Scalars['String']['input']>;
  addressState?: InputMaybe<Scalars['String']['input']>;
  appointmentEnd?: InputMaybe<Scalars['NaiveDateTime']['input']>;
  appointmentStart?: InputMaybe<Scalars['NaiveDateTime']['input']>;
  billingGroupId?: InputMaybe<Scalars['ID']['input']>;
  coownerEmail?: InputMaybe<Scalars['String']['input']>;
  coownerName?: InputMaybe<Scalars['String']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  familyName?: InputMaybe<Scalars['String']['input']>;
  givenName?: InputMaybe<Scalars['String']['input']>;
  insertedAtEnd?: InputMaybe<Scalars['NaiveDateTime']['input']>;
  insertedAtStart?: InputMaybe<Scalars['NaiveDateTime']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  /** Primary location */
  locationId?: InputMaybe<Scalars['ID']['input']>;
  microchipNumber?: InputMaybe<Scalars['String']['input']>;
  patientBreed?: InputMaybe<Scalars['String']['input']>;
  patientIsDeceased?: InputMaybe<Scalars['Boolean']['input']>;
  patientName?: InputMaybe<Scalars['String']['input']>;
  patientOnlyActive?: InputMaybe<Scalars['Boolean']['input']>;
  patientSpecies?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  rabiesTagNumber?: InputMaybe<Scalars['String']['input']>;
  tag?: InputMaybe<Scalars['String']['input']>;
  updatedAtEnd?: InputMaybe<Scalars['NaiveDateTime']['input']>;
  updatedAtStart?: InputMaybe<Scalars['NaiveDateTime']['input']>;
};

export type AccountsOrderBy = {
  familyName?: InputMaybe<OrderByDirection>;
  givenName?: InputMaybe<OrderByDirection>;
  insertedAt?: InputMaybe<OrderByDirection>;
};

export type AccountsReceivableBalance = {
  __typename?: 'AccountsReceivableBalance';
  accountsReceivable: Scalars['Decimal']['output'];
  id: Scalars['ID']['output'];
};

export enum ActionsEnum {
  Delete = 'DELETE',
  Insert = 'INSERT',
  Update = 'UPDATE'
}

/** A client's address. Fields are used for each section of the address */
export type Address = {
  __typename?: 'Address';
  city?: Maybe<Scalars['String']['output']>;
  clientId?: Maybe<Scalars['ID']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  county?: Maybe<Scalars['String']['output']>;
  historicalId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  insertedAt?: Maybe<Scalars['NaiveDateTime']['output']>;
  isPrimary?: Maybe<Scalars['Boolean']['output']>;
  line1?: Maybe<Scalars['String']['output']>;
  line2?: Maybe<Scalars['String']['output']>;
  mailingName?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  use?: Maybe<AddressUse>;
};

export type AddressInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  county?: InputMaybe<Scalars['String']['input']>;
  historicalId?: InputMaybe<Scalars['String']['input']>;
  isPrimary?: InputMaybe<Scalars['Boolean']['input']>;
  line1?: InputMaybe<Scalars['String']['input']>;
  line2?: InputMaybe<Scalars['String']['input']>;
  mailingName?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  use?: InputMaybe<AddressUse>;
};

export enum AddressUse {
  Home = 'HOME',
  Old = 'OLD',
  Temp = 'TEMP',
  Work = 'WORK'
}

export enum AdminTag {
  ComingSoon = 'COMING_SOON',
  Enabled = 'ENABLED'
}

export type AdministrationRoute = {
  __typename?: 'AdministrationRoute';
  abbrev: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type AgedAccountsReceivable = {
  __typename?: 'AgedAccountsReceivable';
  asAt: Scalars['Date']['output'];
  client: Client;
  clientName?: Maybe<Scalars['String']['output']>;
  daysNinetyoneToOnetwentyCents: Scalars['Int']['output'];
  daysOnetwentyonePlusCents: Scalars['Int']['output'];
  daysSixtyoneToNinetyCents: Scalars['Int']['output'];
  daysThirtyoneToSixtyCents: Scalars['Int']['output'];
  daysZeroToThirtyCents: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  location?: Maybe<Location>;
  locationName?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Order>;
  org: Org;
  totalArCents: Scalars['Int']['output'];
};

export type AgedAccountsReceivableTotals = {
  __typename?: 'AgedAccountsReceivableTotals';
  asAt: Scalars['Date']['output'];
  count: Scalars['Int']['output'];
  daysNinetyoneToOnetwentyCents: Scalars['Int']['output'];
  daysNinetyoneToOnetwentyCentsCount: Scalars['Int']['output'];
  daysOnetwentyonePlusCents: Scalars['Int']['output'];
  daysOnetwentyonePlusCentsCount: Scalars['Int']['output'];
  daysSixtyoneToNinetyCents: Scalars['Int']['output'];
  daysSixtyoneToNinetyCentsCount: Scalars['Int']['output'];
  daysThirtyoneToSixtyCents: Scalars['Int']['output'];
  daysThirtyoneToSixtyCentsCount: Scalars['Int']['output'];
  daysZeroToThirtyCents: Scalars['Int']['output'];
  daysZeroToThirtyCentsCount: Scalars['Int']['output'];
  id?: Maybe<Scalars['ID']['output']>;
  totalArCents: Scalars['Int']['output'];
};

export type AgedArReportGeneration = {
  __typename?: 'AgedArReportGeneration';
  status: AgedArReportStatus;
  topic: Scalars['String']['output'];
};

export enum AgedArReportStatus {
  /** Report data is cached and ready */
  Ready = 'READY',
  /** Report generation is in progress */
  Running = 'RUNNING',
  /** Report cannot be generated due to overlapping batch job */
  Unavailable = 'UNAVAILABLE'
}

export type AgedBucket = {
  __typename?: 'AgedBucket';
  amountCents?: Maybe<Scalars['Int']['output']>;
  enabled: Scalars['Boolean']['output'];
  percent?: Maybe<Scalars['Decimal']['output']>;
  statementNote?: Maybe<Scalars['String']['output']>;
  type?: Maybe<BillingGroupFeeType>;
};

export type AgedBucketConfig = {
  __typename?: 'AgedBucketConfig';
  ninetyOneToOneTwenty?: Maybe<AgedBucket>;
  oneTwentyOnePlus?: Maybe<AgedBucket>;
  sixtyOneToNinety?: Maybe<AgedBucket>;
  thirtyOneToSixty?: Maybe<AgedBucket>;
  type?: Maybe<BillingGroupFeeType>;
  zeroToThirty?: Maybe<AgedBucket>;
};

export type AgedBucketConfigInput = {
  ninetyOneToOneTwenty?: InputMaybe<AgedBucketInput>;
  oneTwentyOnePlus?: InputMaybe<AgedBucketInput>;
  sixtyOneToNinety?: InputMaybe<AgedBucketInput>;
  thirtyOneToSixty?: InputMaybe<AgedBucketInput>;
  type?: InputMaybe<BillingGroupFeeType>;
  zeroToThirty?: InputMaybe<AgedBucketInput>;
};

export type AgedBucketInput = {
  amountCents?: InputMaybe<Scalars['Int']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  percent?: InputMaybe<Scalars['Decimal']['input']>;
  statementNote?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<BillingGroupFeeType>;
};

export type Alert = {
  __typename?: 'Alert';
  color?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  position?: Maybe<Scalars['Int']['output']>;
};

export type AlertInput = {
  color?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type Allergy = {
  __typename?: 'Allergy';
  id?: Maybe<Scalars['ID']['output']>;
  insertedAt?: Maybe<Scalars['NaiveDateTime']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type AllergyInput = {
  name?: InputMaybe<Scalars['String']['input']>;
};

export enum AnalyticsBreakdown {
  AppointmentTypeId = 'APPOINTMENT_TYPE_ID',
  Count = 'COUNT',
  Dow = 'DOW',
  Hour = 'HOUR',
  LocationId = 'LOCATION_ID',
  ProductCategoryId = 'PRODUCT_CATEGORY_ID',
  ProductTypeId = 'PRODUCT_TYPE_ID',
  ProviderId = 'PROVIDER_ID',
  Status = 'STATUS'
}

export type AnalyticsData = {
  __typename?: 'AnalyticsData';
  data?: Maybe<Array<Maybe<AnalyticsDataRow>>>;
  field?: Maybe<AnalyticsField>;
};

export type AnalyticsDataRow = {
  __typename?: 'AnalyticsDataRow';
  breakdowns?: Maybe<Array<Maybe<AnalyticsDataRowBreakdown>>>;
  date?: Maybe<Scalars['String']['output']>;
  modifiers?: Maybe<Array<Maybe<AnalyticsDataRowModifier>>>;
  total?: Maybe<Scalars['String']['output']>;
};

export type AnalyticsDataRowBreakdown = {
  __typename?: 'AnalyticsDataRowBreakdown';
  name?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export enum AnalyticsDataRowModifier {
  AppointmentTypeId = 'APPOINTMENT_TYPE_ID',
  ClientId = 'CLIENT_ID',
  ClientIsActive = 'CLIENT__IS_ACTIVE',
  ClientTags = 'CLIENT__TAGS',
  DiscountType = 'DISCOUNT_TYPE',
  InPackage = 'IN_PACKAGE',
  LocationId = 'LOCATION_ID',
  PatientId = 'PATIENT_ID',
  PatientBreed = 'PATIENT__BREED',
  PatientClientId = 'PATIENT__CLIENT_ID',
  PatientClientIsActive = 'PATIENT__CLIENT__IS_ACTIVE',
  PatientClientTags = 'PATIENT__CLIENT______TAGS',
  PatientNeutered = 'PATIENT__NEUTERED',
  PatientSpecies = 'PATIENT__SPECIES',
  ProviderId = 'PROVIDER_ID',
  Status = 'STATUS'
}

export enum AnalyticsField {
  Appointments = 'APPOINTMENTS',
  AvgPatientInvoice = 'AVG_PATIENT_INVOICE',
  Events = 'EVENTS',
  EventHours = 'EVENT_HOURS',
  EventLogs = 'EVENT_LOGS',
  GrossRevenue = 'GROSS_REVENUE',
  OrderItems = 'ORDER_ITEMS',
  PatientInvoices = 'PATIENT_INVOICES',
  ProviderEvents = 'PROVIDER_EVENTS',
  Revenue = 'REVENUE',
  Sales = 'SALES'
}

export type AnalyticsFieldModifier = {
  field?: InputMaybe<AnalyticsField>;
  modifiers?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export enum AnalyticsSegment {
  Day = 'DAY',
  Month = 'MONTH',
  Week = 'WEEK',
  Year = 'YEAR'
}

/** An API key */
export type ApiKey = {
  __typename?: 'ApiKey';
  expireDate?: Maybe<Scalars['NaiveDateTime']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  provider: Provider;
  title?: Maybe<Scalars['String']['output']>;
  token?: Maybe<Scalars['String']['output']>;
};

/** An appointment */
export type Appointment = {
  __typename?: 'Appointment';
  additionalProviders?: Maybe<Array<Maybe<Provider>>>;
  admittedAt?: Maybe<Scalars['DateTime']['output']>;
  arrivalTimeAt?: Maybe<Scalars['DateTime']['output']>;
  bookedOnline?: Maybe<Scalars['Boolean']['output']>;
  cage?: Maybe<Cage>;
  checkInLink?: Maybe<Scalars['String']['output']>;
  checkedInAt?: Maybe<Scalars['DateTime']['output']>;
  checkedOutAt?: Maybe<Scalars['DateTime']['output']>;
  checkingOutAt?: Maybe<Scalars['DateTime']['output']>;
  comments?: Maybe<Array<Comment>>;
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  confirmedAt?: Maybe<Scalars['DateTime']['output']>;
  creator?: Maybe<Provider>;
  customFields?: Maybe<Array<Maybe<CustomAppointmentFieldValue>>>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedBy?: Maybe<Provider>;
  deletionReason?: Maybe<Scalars['String']['output']>;
  department?: Maybe<Department>;
  departmentId?: Maybe<Scalars['ID']['output']>;
  /** The latest a patient can be dropped off before an appointment */
  dropOffEnd?: Maybe<Scalars['DateTime']['output']>;
  /** The earliest a patient can be dropped off before an appointment */
  dropOffStart?: Maybe<Scalars['DateTime']['output']>;
  /** Duration of the appointment (in minutes) */
  duration?: Maybe<Scalars['Int']['output']>;
  encounters?: Maybe<Array<Maybe<Encounter>>>;
  fieldServiceAddress?: Maybe<FieldServiceAddress>;
  /** The patient's field service visit address this appointment travels to, when the visit type is field service. Cleared if the address is later deleted. */
  fieldServiceAddressId?: Maybe<Scalars['ID']['output']>;
  fieldServiceClientAddress?: Maybe<Address>;
  fieldServiceClientAddressId?: Maybe<Scalars['ID']['output']>;
  group?: Maybe<AppointmentGroup>;
  historicalId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  insertedAt?: Maybe<Scalars['NaiveDateTime']['output']>;
  intake?: Maybe<Array<Maybe<AppointmentIntakeData>>>;
  isConfirmed?: Maybe<Scalars['Boolean']['output']>;
  linkedAppointmentCount?: Maybe<Scalars['Int']['output']>;
  location?: Maybe<Location>;
  note?: Maybe<Scalars['String']['output']>;
  patient?: Maybe<Patient>;
  patientId?: Maybe<Scalars['ID']['output']>;
  pickupTime?: Maybe<Scalars['DateTime']['output']>;
  position?: Maybe<Scalars['Int']['output']>;
  provider?: Maybe<Provider>;
  providerId?: Maybe<Scalars['ID']['output']>;
  readyAt?: Maybe<Scalars['DateTime']['output']>;
  /** Reason for the appointment */
  reason?: Maybe<Scalars['String']['output']>;
  reasonCategory?: Maybe<AppointmentReasonCategory>;
  reasonCategoryId?: Maybe<Scalars['ID']['output']>;
  recurrence?: Maybe<Recurrence>;
  repeatingEvent?: Maybe<RepeatingEvent>;
  reviewed?: Maybe<Scalars['Boolean']['output']>;
  room?: Maybe<Scalars['String']['output']>;
  schedule?: Maybe<LocationSchedule>;
  scheduleId?: Maybe<Scalars['ID']['output']>;
  selfCheckInSent?: Maybe<Scalars['Boolean']['output']>;
  selfCheckedIn?: Maybe<Scalars['Boolean']['output']>;
  sentPickup?: Maybe<Scalars['Boolean']['output']>;
  /** Date and time of the start of the appointment */
  start?: Maybe<Scalars['DateTime']['output']>;
  startedAt?: Maybe<Scalars['DateTime']['output']>;
  status?: Maybe<AppointmentStatus>;
  teleSessionCreated?: Maybe<Scalars['Boolean']['output']>;
  type?: Maybe<AppointmentType>;
  updatedAt?: Maybe<Scalars['NaiveDateTime']['output']>;
  visitType?: Maybe<VisitType>;
  vitals?: Maybe<Vitals>;
  waitedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The travel zone's color, with the same freshness rules as `zoneName`. */
  zoneColorHex?: Maybe<Scalars['String']['output']>;
  /** The travel zone assigned to this appointment. Not a foreign key: the id survives the zone being deleted, so an appointment that has already happened still reports the zone it was carried out under. */
  zoneId?: Maybe<Scalars['ID']['output']>;
  /** The travel zone's name, copied onto the appointment so a day's schedule needs no zone lookup. Kept current while the appointment is upcoming; frozen once it has happened. */
  zoneName?: Maybe<Scalars['String']['output']>;
};

export type AppointmentGroup = {
  __typename?: 'AppointmentGroup';
  appointments?: Maybe<Array<Maybe<Appointment>>>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type AppointmentInput = {
  additionalProviderIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  appointmentTypeId?: InputMaybe<Scalars['ID']['input']>;
  bookedOnline?: InputMaybe<Scalars['Boolean']['input']>;
  cageId?: InputMaybe<Scalars['ID']['input']>;
  departmentId?: InputMaybe<Scalars['ID']['input']>;
  dropOffEnd?: InputMaybe<Scalars['DateTime']['input']>;
  dropOffStart?: InputMaybe<Scalars['DateTime']['input']>;
  duration?: InputMaybe<Scalars['Int']['input']>;
  /** One of the patient's field service visit addresses to travel to. Must belong to the appointment's patient. Setting this clears `fieldServiceClientAddressId`, which is the alternative rather than an addition. Cleared automatically if the visit type is changed away from field service. */
  fieldServiceAddressId?: InputMaybe<Scalars['ID']['input']>;
  fieldServiceClientAddressId?: InputMaybe<Scalars['ID']['input']>;
  historicalId?: InputMaybe<Scalars['String']['input']>;
  intake?: InputMaybe<Array<InputMaybe<AppointmentIntakeDataInput>>>;
  isConfirmed?: InputMaybe<Scalars['Boolean']['input']>;
  locationId?: InputMaybe<Scalars['ID']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  patientId?: InputMaybe<Scalars['ID']['input']>;
  patientLocation?: InputMaybe<PatientLocationInput>;
  pickupTime?: InputMaybe<Scalars['DateTime']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
  providerId?: InputMaybe<Scalars['ID']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
  reasonCategoryId?: InputMaybe<Scalars['ID']['input']>;
  recurrence?: InputMaybe<RecurrenceInput>;
  recurrenceEditScope?: InputMaybe<RecurrenceEditScope>;
  repeatingEvent?: InputMaybe<RepeatingEventInput>;
  room?: InputMaybe<Scalars['String']['input']>;
  scheduleId?: InputMaybe<Scalars['ID']['input']>;
  selfCheckInSent?: InputMaybe<Scalars['Boolean']['input']>;
  sendConfirmation?: InputMaybe<Scalars['Boolean']['input']>;
  start?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<AppointmentStatus>;
  visitType?: InputMaybe<VisitType>;
  /** Assigns a travel zone to the appointment, or clears it if null */
  zoneId?: InputMaybe<Scalars['ID']['input']>;
};

export type AppointmentIntakeData = {
  __typename?: 'AppointmentIntakeData';
  name?: Maybe<Scalars['String']['output']>;
  options?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  type?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type AppointmentIntakeDataInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  options?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type AppointmentPositionInput = {
  /** Input for updating an appointment's position in queue */
  id: Scalars['ID']['input'];
  position: Scalars['Int']['input'];
};

export type AppointmentReasonCategory = {
  __typename?: 'AppointmentReasonCategory';
  id: Scalars['ID']['output'];
  reason: Scalars['String']['output'];
};

export type AppointmentReminder = {
  __typename?: 'AppointmentReminder';
  appointmentType?: Maybe<AppointmentType>;
  date?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  location?: Maybe<Location>;
  patient?: Maybe<Patient>;
  reason?: Maybe<Scalars['String']['output']>;
};

export type AppointmentReminderInput = {
  appointmentTypeId?: InputMaybe<Scalars['ID']['input']>;
  date?: InputMaybe<Scalars['Date']['input']>;
  locationId?: InputMaybe<Scalars['ID']['input']>;
  patientId?: InputMaybe<Scalars['ID']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
};

export enum AppointmentStatus {
  Admitted = 'ADMITTED',
  Cancelled = 'CANCELLED',
  CheckedIn = 'CHECKED_IN',
  CheckedOut = 'CHECKED_OUT',
  CheckingOut = 'CHECKING_OUT',
  Completed = 'COMPLETED',
  Confirmed = 'CONFIRMED',
  Daycare = 'DAYCARE',
  Inprogress = 'INPROGRESS',
  Medboard = 'MEDBOARD',
  Noshow = 'NOSHOW',
  Pending = 'PENDING',
  Planned = 'PLANNED',
  ReadyForDischarge = 'READY_FOR_DISCHARGE',
  Waitlist = 'WAITLIST'
}

export type AppointmentType = {
  __typename?: 'AppointmentType';
  canBookOnline?: Maybe<Scalars['Boolean']['output']>;
  color?: Maybe<Scalars['String']['output']>;
  consentForms?: Maybe<Array<Maybe<ConsentForm>>>;
  defaultProducts?: Maybe<Array<Maybe<Product>>>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['NaiveDateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  doubleBookableAppointmentTypes?: Maybe<Array<Maybe<AppointmentType>>>;
  doubleBookingConstraint?: Maybe<DoubleBookingConstraint>;
  dropoffTime?: Maybe<Scalars['String']['output']>;
  duration?: Maybe<Scalars['Int']['output']>;
  encounterType?: Maybe<EncounterType>;
  encounterTypeId?: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  insertedAt?: Maybe<Scalars['NaiveDateTime']['output']>;
  isBlockoff?: Maybe<Scalars['Boolean']['output']>;
  isDaycare?: Maybe<Scalars['Boolean']['output']>;
  isDefault?: Maybe<Scalars['Boolean']['output']>;
  isDropoff?: Maybe<Scalars['Boolean']['output']>;
  isExam?: Maybe<Scalars['Boolean']['output']>;
  isSick?: Maybe<Scalars['Boolean']['output']>;
  isSurgery?: Maybe<Scalars['Boolean']['output']>;
  isTelemedicine?: Maybe<Scalars['Boolean']['output']>;
  isUniversal?: Maybe<Scalars['Boolean']['output']>;
  isWellness?: Maybe<Scalars['Boolean']['output']>;
  locations?: Maybe<Array<Maybe<Location>>>;
  name?: Maybe<Scalars['String']['output']>;
  position?: Maybe<Scalars['Int']['output']>;
  preventVisitCreation?: Maybe<Scalars['Boolean']['output']>;
  providerLimits?: Maybe<Array<Maybe<ProviderAppointmentTypeLimit>>>;
  remindersDisabled?: Maybe<Scalars['Boolean']['output']>;
  revenueCenter?: Maybe<RevenueCenter>;
  scheduleName?: Maybe<Scalars['String']['output']>;
  showOnKiosk?: Maybe<Scalars['Boolean']['output']>;
  steps?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  tags?: Maybe<Array<Maybe<AppointmentTypeTag>>>;
  updatedAt?: Maybe<Scalars['NaiveDateTime']['output']>;
};


export type AppointmentTypeProviderLimitsArgs = {
  providerId: Scalars['ID']['input'];
};

export type AppointmentTypeInput = {
  canBookOnline?: InputMaybe<Scalars['Boolean']['input']>;
  color?: InputMaybe<Scalars['String']['input']>;
  consentFormIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  defaultProductIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  description?: InputMaybe<Scalars['String']['input']>;
  doubleBookableAppointmentTypeIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  doubleBookingConstraint?: InputMaybe<DoubleBookingConstraint>;
  dropoffTime?: InputMaybe<Scalars['String']['input']>;
  duration?: InputMaybe<Scalars['Int']['input']>;
  encounterTypeId?: InputMaybe<Scalars['ID']['input']>;
  isBlockoff?: InputMaybe<Scalars['Boolean']['input']>;
  isDaycare?: InputMaybe<Scalars['Boolean']['input']>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  isDropoff?: InputMaybe<Scalars['Boolean']['input']>;
  isExam?: InputMaybe<Scalars['Boolean']['input']>;
  isSick?: InputMaybe<Scalars['Boolean']['input']>;
  isSurgery?: InputMaybe<Scalars['Boolean']['input']>;
  isTelemedicine?: InputMaybe<Scalars['Boolean']['input']>;
  isUniversal?: InputMaybe<Scalars['Boolean']['input']>;
  isWellness?: InputMaybe<Scalars['Boolean']['input']>;
  locationIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
  preventVisitCreation?: InputMaybe<Scalars['Boolean']['input']>;
  remindersDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  revenueCenterId?: InputMaybe<Scalars['ID']['input']>;
  scheduleName?: InputMaybe<Scalars['String']['input']>;
  showOnKiosk?: InputMaybe<Scalars['Boolean']['input']>;
  steps?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

export type AppointmentTypeTag = {
  __typename?: 'AppointmentTypeTag';
  appointmentTypes: Array<AppointmentType>;
  color: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  locations: Array<Location>;
  name: Scalars['String']['output'];
};

export type AppointmentTypeTagInput = {
  appointmentTypeIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  color?: InputMaybe<Scalars['String']['input']>;
  locationIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type ApproveCubexDiagnosticInput = {
  encounterId?: InputMaybe<Scalars['ID']['input']>;
  providerId: Scalars['ID']['input'];
};

export type ApproveCubexEncounterProductInput = {
  encounterId?: InputMaybe<Scalars['ID']['input']>;
  providerId: Scalars['ID']['input'];
};

export type ApproveCubexImmunizationInput = {
  date?: InputMaybe<Scalars['Date']['input']>;
  doseQuantity?: InputMaybe<Scalars['String']['input']>;
  dueDate?: InputMaybe<Scalars['Date']['input']>;
  dueDate2?: InputMaybe<Scalars['Date']['input']>;
  encounterId?: InputMaybe<Scalars['ID']['input']>;
  expiryDate?: InputMaybe<Scalars['Date']['input']>;
  lotNumber?: InputMaybe<Scalars['String']['input']>;
  manufacturer?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  providerId: Scalars['ID']['input'];
  rabiesTagNumber?: InputMaybe<Scalars['String']['input']>;
  route?: InputMaybe<RouteType>;
  site?: InputMaybe<Scalars['String']['input']>;
  technicianId?: InputMaybe<Scalars['ID']['input']>;
  type?: InputMaybe<ImmunizationType>;
};

export type ApproveCubexMedicationInput = {
  encounterId?: InputMaybe<Scalars['ID']['input']>;
  prescriberId: Scalars['ID']['input'];
};

export type ApproveCubexTreatmentInput = {
  encounterId?: InputMaybe<Scalars['ID']['input']>;
  providerId: Scalars['ID']['input'];
};

export type ApproveMedicationInput = {
  encounterId?: InputMaybe<Scalars['ID']['input']>;
  prescriberId: Scalars['ID']['input'];
};

export type ApptCountProviders = {
  __typename?: 'ApptCountProviders';
  count?: Maybe<Scalars['Int']['output']>;
  date?: Maybe<Scalars['String']['output']>;
  username?: Maybe<Scalars['String']['output']>;
};

export enum ArBreakdown {
  /** Breakdown by client/location */
  Client = 'CLIENT',
  /** Breakdown by order */
  Order = 'ORDER',
  /** Breakdown by organization */
  Org = 'ORG'
}

export type ArReconciliation = {
  __typename?: 'ArReconciliation';
  accountCreditCents: Scalars['Int']['output'];
  client: Client;
  clientId: Scalars['ID']['output'];
  deltaReportedArCents: Scalars['Int']['output'];
  dueInvoiceCents: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  locationId?: Maybe<Scalars['ID']['output']>;
  patientId?: Maybe<Scalars['ID']['output']>;
  reportedArCents: Scalars['Int']['output'];
};

export type AssignOrphanImmunizationTransactionInput = {
  /** The adjusted dose quantity for the immunization. If not provided, the transaction quantity will be used. */
  adjustedDoseQuantity?: InputMaybe<Scalars['Decimal']['input']>;
  date?: InputMaybe<Scalars['Date']['input']>;
  dueDate?: InputMaybe<Scalars['Date']['input']>;
  dueDate2?: InputMaybe<Scalars['Date']['input']>;
  encounterId?: InputMaybe<Scalars['ID']['input']>;
  expiryDate?: InputMaybe<Scalars['Date']['input']>;
  locationId: Scalars['ID']['input'];
  lotNumber?: InputMaybe<Scalars['String']['input']>;
  manufacturer?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  patientId: Scalars['ID']['input'];
  providerId: Scalars['ID']['input'];
  rabiesTagNumber?: InputMaybe<Scalars['String']['input']>;
  route?: InputMaybe<RouteType>;
  site?: InputMaybe<Scalars['String']['input']>;
  technicianId?: InputMaybe<Scalars['ID']['input']>;
  type?: InputMaybe<ImmunizationType>;
};

export type AssignOrphanImmunizationTransactionToNewEncounterInput = {
  /** The adjusted dose quantity for the immunization. If not provided, the transaction quantity will be used. */
  adjustedDoseQuantity?: InputMaybe<Scalars['Decimal']['input']>;
  date?: InputMaybe<Scalars['Date']['input']>;
  dueDate?: InputMaybe<Scalars['Date']['input']>;
  dueDate2?: InputMaybe<Scalars['Date']['input']>;
  encounterTypeId: Scalars['ID']['input'];
  expiryDate?: InputMaybe<Scalars['Date']['input']>;
  locationId: Scalars['ID']['input'];
  lotNumber?: InputMaybe<Scalars['String']['input']>;
  manufacturer?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  patientId: Scalars['ID']['input'];
  providerId: Scalars['ID']['input'];
  rabiesTagNumber?: InputMaybe<Scalars['String']['input']>;
  route?: InputMaybe<RouteType>;
  site?: InputMaybe<Scalars['String']['input']>;
  technicianId?: InputMaybe<Scalars['ID']['input']>;
  type?: InputMaybe<ImmunizationType>;
};

export type AssignOrphanTransactionInput = {
  /** The adjusted quantity for the clinical item. If not provided, the transaction quantity will be used. */
  adjustedItemQuantity?: InputMaybe<Scalars['Decimal']['input']>;
  encounterId?: InputMaybe<Scalars['ID']['input']>;
  locationId: Scalars['ID']['input'];
  patientId: Scalars['ID']['input'];
  providerId: Scalars['ID']['input'];
};

export type AssignOrphanTransactionToNewEncounterInput = {
  /** The adjusted quantity for the clinical item. If not provided, the transaction quantity will be used. */
  adjustedItemQuantity?: InputMaybe<Scalars['Decimal']['input']>;
  encounterTypeId: Scalars['ID']['input'];
  locationId: Scalars['ID']['input'];
  patientId: Scalars['ID']['input'];
  providerId: Scalars['ID']['input'];
};

export type AsyncMedicalRecord = {
  __typename?: 'AsyncMedicalRecord';
  id?: Maybe<Scalars['ID']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type Attachment = {
  __typename?: 'Attachment';
  id?: Maybe<Scalars['ID']['output']>;
  insertedAt?: Maybe<Scalars['NaiveDateTime']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  signedUrl?: Maybe<Scalars['String']['output']>;
};

export type AutoMessage = {
  __typename?: 'AutoMessage';
  /** @deprecated Please use `ageRestrictionLow` and `ageRestrictionHigh` instead */
  ageRestriction?: Maybe<Scalars['Numrange']['output']>;
  ageRestrictionHigh?: Maybe<Scalars['Int']['output']>;
  ageRestrictionLow?: Maybe<Scalars['Int']['output']>;
  ageUnit: Scalars['String']['output'];
  bodyContent?: Maybe<Scalars['String']['output']>;
  bodyHtml?: Maybe<Scalars['String']['output']>;
  bodyJson?: Maybe<Scalars['String']['output']>;
  breedRestrictions?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  clientMissingEmail?: Maybe<Scalars['Boolean']['output']>;
  clientMissingPhone?: Maybe<Scalars['Boolean']['output']>;
  hasAppointmentTypeIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  hasFutureAppointmentTypeIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  hasNoAppointmentTypeIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  hasNoFutureAppointmentTypeIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  id?: Maybe<Scalars['ID']['output']>;
  insertedAt?: Maybe<Scalars['NaiveDateTime']['output']>;
  limitSendWithinDays?: Maybe<Scalars['Int']['output']>;
  live?: Maybe<Scalars['Boolean']['output']>;
  locations?: Maybe<Array<Maybe<Location>>>;
  medium?: Maybe<ReminderType>;
  restrictToOnlyNonNeutered?: Maybe<Scalars['Boolean']['output']>;
  sendLimit?: Maybe<Scalars['Int']['output']>;
  speciesRestrictions?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  subject?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  triggerAfterDays?: Maybe<Scalars['Int']['output']>;
  triggerAppointmentTypes?: Maybe<Array<Maybe<AppointmentType>>>;
  triggerPlans?: Maybe<Array<Maybe<PreventionPlan>>>;
  triggerType?: Maybe<Scalars['String']['output']>;
  weightRestriction?: Maybe<Scalars['Numrange']['output']>;
};

export type AutoMessageInput = {
  ageRestriction?: InputMaybe<Scalars['Numrange']['input']>;
  ageRestrictionHigh?: InputMaybe<Scalars['Int']['input']>;
  ageRestrictionLow?: InputMaybe<Scalars['Int']['input']>;
  ageUnit?: InputMaybe<Scalars['String']['input']>;
  bodyContent?: InputMaybe<Scalars['String']['input']>;
  bodyHtml?: InputMaybe<Scalars['String']['input']>;
  bodyJson?: InputMaybe<Scalars['String']['input']>;
  breedRestrictions?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  clientMissingEmail?: InputMaybe<Scalars['Boolean']['input']>;
  clientMissingPhone?: InputMaybe<Scalars['Boolean']['input']>;
  hasAppointmentTypeIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  hasFutureAppointmentTypeIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  hasNoAppointmentTypeIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  hasNoFutureAppointmentTypeIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limitSendWithinDays?: InputMaybe<Scalars['Int']['input']>;
  live?: InputMaybe<Scalars['Boolean']['input']>;
  locationIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  medium?: InputMaybe<ReminderType>;
  restrictToOnlyNonNeutered?: InputMaybe<Scalars['Boolean']['input']>;
  sendLimit?: InputMaybe<Scalars['Int']['input']>;
  speciesRestrictions?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  subject?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  triggerAfterDays?: InputMaybe<Scalars['Int']['input']>;
  triggerAppointmentTypeIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  triggerPlanIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  triggerType?: InputMaybe<Scalars['String']['input']>;
  weightRestriction?: InputMaybe<Scalars['Numrange']['input']>;
};

export type AvailableTimeSlot = {
  __typename?: 'AvailableTimeSlot';
  date?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  provider?: Maybe<Provider>;
  providerId?: Maybe<Scalars['ID']['output']>;
  scheduleId?: Maybe<Scalars['ID']['output']>;
  time?: Maybe<Scalars['String']['output']>;
};

/** A bill is a pending order, posted invoice, or published estimate */
export type Bill = Estimate | Order;

export type BillingFrequencyOption = {
  __typename?: 'BillingFrequencyOption';
  key: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type BillingGroup = {
  __typename?: 'BillingGroup';
  agedBucketConfig?: Maybe<AgedBucketConfig>;
  autoSendStatements?: Maybe<Scalars['Boolean']['output']>;
  clientsCount: Scalars['Int']['output'];
  compounding?: Maybe<Scalars['Boolean']['output']>;
  createdBy?: Maybe<Provider>;
  createdById?: Maybe<Scalars['ID']['output']>;
  default?: Maybe<Scalars['Boolean']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  emailBody?: Maybe<Scalars['String']['output']>;
  emailSubject?: Maybe<Scalars['String']['output']>;
  feeCalculationMethod?: Maybe<FeeCalculationMethod>;
  feeIntervalDays?: Maybe<Scalars['Int']['output']>;
  feeStartDays?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  insertedAt: Scalars['NaiveDateTime']['output'];
  intervalConfig?: Maybe<IntervalConfig>;
  monthlyDueDate?: Maybe<Scalars['Int']['output']>;
  monthlyDueDateType?: Maybe<MonthlyDueDateType>;
  monthlyRunDate?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  orgId: Scalars['ID']['output'];
  updatedAt: Scalars['NaiveDateTime']['output'];
  updatedBy?: Maybe<Provider>;
  updatedById?: Maybe<Scalars['ID']['output']>;
};

export type BillingGroupConnection = {
  __typename?: 'BillingGroupConnection';
  edges?: Maybe<Array<Maybe<BillingGroupEdge>>>;
  pageInfo: PageInfo;
};

export type BillingGroupEdge = {
  __typename?: 'BillingGroupEdge';
  cursor?: Maybe<Scalars['String']['output']>;
  node?: Maybe<BillingGroup>;
};

export enum BillingGroupFeeType {
  /** Flat dollar amount fee */
  Flat = 'FLAT',
  /** Whichever is greater: flat amount or percentage */
  GreaterThan = 'GREATER_THAN',
  /** Percentage-based fee */
  Percent = 'PERCENT'
}

export type BillingGroupFilters = {
  description?: InputMaybe<Scalars['String']['input']>;
  historicalId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  insertedAtEnd?: InputMaybe<Scalars['NaiveDateTime']['input']>;
  insertedAtStart?: InputMaybe<Scalars['NaiveDateTime']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  orgId?: InputMaybe<Scalars['ID']['input']>;
  updatedAtEnd?: InputMaybe<Scalars['NaiveDateTime']['input']>;
  updatedAtStart?: InputMaybe<Scalars['NaiveDateTime']['input']>;
};

export type BillingGroupInput = {
  agedBucketConfig?: InputMaybe<AgedBucketConfigInput>;
  autoSendStatements?: InputMaybe<Scalars['Boolean']['input']>;
  compounding?: InputMaybe<Scalars['Boolean']['input']>;
  default?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  emailBody?: InputMaybe<Scalars['String']['input']>;
  emailSubject?: InputMaybe<Scalars['String']['input']>;
  feeCalculationMethod?: InputMaybe<FeeCalculationMethod>;
  feeIntervalDays?: InputMaybe<Scalars['Int']['input']>;
  feeStartDays?: InputMaybe<Scalars['Int']['input']>;
  intervalConfig?: InputMaybe<IntervalConfigInput>;
  monthlyDueDate?: InputMaybe<Scalars['Int']['input']>;
  monthlyDueDateType?: InputMaybe<MonthlyDueDateType>;
  monthlyRunDate?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
};

/** Minimal billing group info for dropdowns (no permission required) */
export type BillingGroupOption = {
  __typename?: 'BillingGroupOption';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type BillingGroupOrderBy = {
  id?: InputMaybe<OrderByDirection>;
  insertedAt?: InputMaybe<OrderByDirection>;
  name?: InputMaybe<OrderByDirection>;
  updatedAt?: InputMaybe<OrderByDirection>;
};

export type BillingNote = {
  __typename?: 'BillingNote';
  addedBy?: Maybe<Provider>;
  attachmentContentType?: Maybe<Scalars['String']['output']>;
  attachmentName?: Maybe<Scalars['String']['output']>;
  attachmentPath?: Maybe<Scalars['String']['output']>;
  datetime?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  insertedAt?: Maybe<Scalars['NaiveDateTime']['output']>;
  note?: Maybe<Scalars['String']['output']>;
};

export type BillingNoteInput = {
  attachmentContentType?: InputMaybe<Scalars['String']['input']>;
  attachmentPath?: InputMaybe<Scalars['String']['input']>;
  clientId?: InputMaybe<Scalars['ID']['input']>;
  datetime?: InputMaybe<Scalars['DateTime']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
};

export type BoardCell = {
  __typename?: 'BoardCell';
  comment?: Maybe<Scalars['String']['output']>;
  completed?: Maybe<Scalars['Boolean']['output']>;
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  completedBy?: Maybe<Provider>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  insertedAt?: Maybe<Scalars['NaiveDateTime']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
  quantity?: Maybe<Scalars['Decimal']['output']>;
  startedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type BoardCellInput = {
  boardRowId?: InputMaybe<Scalars['ID']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  productId?: InputMaybe<Scalars['ID']['input']>;
  quantity?: InputMaybe<Scalars['Decimal']['input']>;
};

export type BoardGroup = {
  __typename?: 'BoardGroup';
  defaultItems?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type BoardRow = {
  __typename?: 'BoardRow';
  boardGroupId?: Maybe<Scalars['ID']['output']>;
  cells?: Maybe<Array<Maybe<BoardCell>>>;
  estimateId?: Maybe<Scalars['ID']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  isActive?: Maybe<Scalars['Boolean']['output']>;
  patient?: Maybe<Patient>;
};

export type BoardRowInput = {
  boardGroupId?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BoardingBlockInput = {
  boardingCageId?: InputMaybe<Scalars['ID']['input']>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
  endTime?: InputMaybe<ReservationTime>;
  locationId?: InputMaybe<Scalars['ID']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
  startTime?: InputMaybe<ReservationTime>;
  status?: InputMaybe<ReservationStatus>;
};

export type BoardingCage = {
  __typename?: 'BoardingCage';
  boardingWard?: Maybe<BoardingWard>;
  boardingWardId?: Maybe<Scalars['ID']['output']>;
  hasReservations?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  maxWeight?: Maybe<Scalars['Decimal']['output']>;
  minWeight?: Maybe<Scalars['Decimal']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  position: Scalars['Int']['output'];
  species?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  wardId?: Maybe<Scalars['ID']['output']>;
};

export type BoardingCageInput = {
  boardingWardId?: InputMaybe<Scalars['ID']['input']>;
  maxWeight?: InputMaybe<Scalars['Decimal']['input']>;
  minWeight?: InputMaybe<Scalars['Decimal']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
  species?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type BoardingWard = {
  __typename?: 'BoardingWard';
  cages?: Maybe<Array<BoardingCage>>;
  hasReservations?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  locationId: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  position: Scalars['Int']['output'];
  showBoardingSchedule: Scalars['Boolean']['output'];
  showPatientLocations: Scalars['Boolean']['output'];
};

export type BoardingWardFilters = {
  showBoardingSchedule?: InputMaybe<Scalars['Boolean']['input']>;
  showPatientLocations?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BoardingWardInput = {
  locationId?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  showBoardingSchedule?: InputMaybe<Scalars['Boolean']['input']>;
  showPatientLocations?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Result of bolus calculation */
export type BolusCalculationResult = {
  __typename?: 'BolusCalculationResult';
  /** Volume per kg (ml/kg) */
  amount?: Maybe<Scalars['Decimal']['output']>;
  /** Patient weight in kg used for calculation */
  patientWeightKg?: Maybe<Scalars['Decimal']['output']>;
  /** Bolus rate (ml/hr) */
  rate?: Maybe<Scalars['Decimal']['output']>;
  /** Total volume (ml) */
  totalAmount?: Maybe<Scalars['Decimal']['output']>;
};

export type Cadence = {
  __typename?: 'Cadence';
  active?: Maybe<Scalars['Boolean']['output']>;
  body?: Maybe<Scalars['String']['output']>;
  contactMethod?: Maybe<CadenceContactMethods>;
  excludeSelectedLocationTags?: Maybe<Scalars['Boolean']['output']>;
  excludeSelectedLocations?: Maybe<Scalars['Boolean']['output']>;
  excludeSelectedProtocols?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  overdueOnly?: Maybe<Scalars['Boolean']['output']>;
  selectedLocationTags?: Maybe<Array<Maybe<LocationTag>>>;
  selectedLocations?: Maybe<Array<Maybe<Location>>>;
  selectedProtocols?: Maybe<Array<Maybe<Protocol>>>;
  subject?: Maybe<Scalars['String']['output']>;
  triggerOffsetDays?: Maybe<Scalars['Int']['output']>;
};

export enum CadenceContactMethods {
  Email = 'EMAIL',
  Postcard = 'POSTCARD',
  Sms = 'SMS'
}

export type CadenceInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  body?: InputMaybe<Scalars['String']['input']>;
  contactMethod?: InputMaybe<CadenceContactMethods>;
  excludeSelectedLocationTags?: InputMaybe<Scalars['Boolean']['input']>;
  excludeSelectedLocations?: InputMaybe<Scalars['Boolean']['input']>;
  excludeSelectedProtocols?: InputMaybe<Scalars['Boolean']['input']>;
  overdueOnly?: InputMaybe<Scalars['Boolean']['input']>;
  selectedLocationIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  selectedLocationTagIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  selectedProtocolIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  subject?: InputMaybe<Scalars['String']['input']>;
  triggerOffsetDays?: InputMaybe<Scalars['Int']['input']>;
};

export type Cage = {
  __typename?: 'Cage';
  id?: Maybe<Scalars['ID']['output']>;
  maxWeight?: Maybe<Scalars['Decimal']['output']>;
  minWeight?: Maybe<Scalars['Decimal']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  species?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type CageInput = {
  locationId?: InputMaybe<Scalars['ID']['input']>;
  maxWeight?: InputMaybe<Scalars['Decimal']['input']>;
  minWeight?: InputMaybe<Scalars['Decimal']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  species?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CallLog = {
  __typename?: 'CallLog';
  appointment?: Maybe<Appointment>;
  cameIn?: Maybe<Scalars['Boolean']['output']>;
  client?: Maybe<Client>;
  clientFirstName?: Maybe<Scalars['String']['output']>;
  clientLastName?: Maybe<Scalars['String']['output']>;
  clientReferralSource?: Maybe<ClientReferralSource>;
  clientReferralSourceId?: Maybe<Scalars['ID']['output']>;
  consultedByDoctor?: Maybe<Provider>;
  enteredBy?: Maybe<Provider>;
  fromPhoneNumber?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  insertedAt?: Maybe<Scalars['NaiveDateTime']['output']>;
  location?: Maybe<Location>;
  noVisitNeeded?: Maybe<Scalars['Boolean']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  outcome?: Maybe<CallLogOutcome>;
  patient?: Maybe<Patient>;
  patientName?: Maybe<Scalars['String']['output']>;
  rdvm?: Maybe<Rdvm>;
  rdvmName?: Maybe<Scalars['String']['output']>;
  sex?: Maybe<Scalars['String']['output']>;
  species?: Maybe<Scalars['String']['output']>;
  telephonySessionId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['NaiveDateTime']['output']>;
  voiceCall?: Maybe<VoiceCall>;
};

export type CallLogInput = {
  appointmentId?: InputMaybe<Scalars['ID']['input']>;
  cameIn?: InputMaybe<Scalars['Boolean']['input']>;
  clientFirstName?: InputMaybe<Scalars['String']['input']>;
  clientId?: InputMaybe<Scalars['ID']['input']>;
  clientLastName?: InputMaybe<Scalars['String']['input']>;
  clientReferralSourceId?: InputMaybe<Scalars['ID']['input']>;
  consultedByDoctorId?: InputMaybe<Scalars['ID']['input']>;
  enteredById?: InputMaybe<Scalars['ID']['input']>;
  fromPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  locationId?: InputMaybe<Scalars['ID']['input']>;
  noVisitNeeded?: InputMaybe<Scalars['Boolean']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  outcome?: InputMaybe<CallLogOutcome>;
  patientId?: InputMaybe<Scalars['ID']['input']>;
  patientName?: InputMaybe<Scalars['String']['input']>;
  rdvmId?: InputMaybe<Scalars['ID']['input']>;
  rdvmName?: InputMaybe<Scalars['String']['input']>;
  sex?: InputMaybe<Scalars['String']['input']>;
  species?: InputMaybe<Scalars['String']['input']>;
  telephonySessionId?: InputMaybe<Scalars['String']['input']>;
  voiceCallId?: InputMaybe<Scalars['ID']['input']>;
};

/** The outcome of the call */
export enum CallLogOutcome {
  /** Client scheduled an appointment */
  AppointmentScheduled = 'APPOINTMENT_SCHEDULED',
  /** Client changed vet */
  ChangedVet = 'CHANGED_VET',
  /** Client moved out of area */
  ClientMovedOutOfArea = 'CLIENT_MOVED_OUT_OF_AREA',
  /** Left message for client */
  LeftMessage = 'LEFT_MESSAGE',
  /** Client no longer has pet */
  NoLongerHavePet = 'NO_LONGER_HAVE_PET',
  /** Owner will call back */
  OwnerToCallBack = 'OWNER_TO_CALL_BACK',
  /** Patient deceased */
  PatientDeceased = 'PATIENT_DECEASED',
  /** Patient is up to date */
  PatientUpToDate = 'PATIENT_UP_TO_DATE',
  /** Client unavailable */
  Unavailable = 'UNAVAILABLE'
}

export type CardconnectCardInfo = {
  __typename?: 'CardconnectCardInfo';
  issuer?: Maybe<Scalars['String']['output']>;
  subtype?: Maybe<Scalars['String']['output']>;
};

export type CardconnectMerchantSurchargeStatus = {
  __typename?: 'CardconnectMerchantSurchargeStatus';
  surchargeEnabled: Scalars['Boolean']['output'];
  /** The surcharge rate ready to display, for example "3%". Null unless the status is ACTIVE. */
  surchargeRate?: Maybe<Scalars['String']['output']>;
  surchargeStatus: CardconnectSurchargeStatus;
};

/** How the merchant account's surcharge configuration reads to a client-facing screen */
export enum CardconnectSurchargeStatus {
  /** A surcharge rate is configured and usable */
  Active = 'ACTIVE',
  /** The merchant account does not surcharge */
  NotEnabled = 'NOT_ENABLED',
  /** Surcharging is on but the reported rate cannot be displayed */
  UnusableRate = 'UNUSABLE_RATE',
  /** Surcharging is on but the reported rate is zero */
  ZeroRate = 'ZERO_RATE'
}

export type CardconnectVerifyCredentialsResult = {
  __typename?: 'CardconnectVerifyCredentialsResult';
  reason?: Maybe<Scalars['String']['output']>;
  valid: Scalars['Boolean']['output'];
};

export enum CareCreditEntityType {
  Client = 'CLIENT',
  Estimate = 'ESTIMATE',
  Order = 'ORDER'
}

export enum CareCreditEventType {
  Apply = 'APPLY',
  ApplyLink = 'APPLY_LINK',
  PreviewQuickscreen = 'PREVIEW_QUICKSCREEN',
  Purchase = 'PURCHASE',
  PurchaseLink = 'PURCHASE_LINK',
  QuickScreen = 'QUICK_SCREEN',
  Refund = 'REFUND'
}

export enum CareCreditLandingPageType {
  Apply = 'APPLY',
  Home = 'HOME',
  Lookup = 'LOOKUP',
  PaymentEstimator = 'PAYMENT_ESTIMATOR',
  Purchase = 'PURCHASE',
  QuickScreen = 'QUICK_SCREEN'
}

export type CareCreditPrefillSession = {
  __typename?: 'CareCreditPrefillSession';
  referenceId?: Maybe<Scalars['String']['output']>;
  sessionId?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type CareTeamRole = {
  __typename?: 'CareTeamRole';
  id: Scalars['ID']['output'];
  insertedAt: Scalars['NaiveDateTime']['output'];
  locations?: Maybe<Array<Maybe<Location>>>;
  name?: Maybe<Scalars['String']['output']>;
  orgId: Scalars['ID']['output'];
  updatedAt: Scalars['NaiveDateTime']['output'];
};

export type Census = {
  __typename?: 'Census';
  enabled: Scalars['Boolean']['output'];
  kennel?: Maybe<CensusKennel>;
  kennels?: Maybe<CensusKennelConnection>;
  locationDetailLabels: Array<CensusLocationDetailLabel>;
  locationId: Scalars['ID']['output'];
  statusCounts: CensusStatusCounts;
  ward?: Maybe<CensusWard>;
  wards?: Maybe<CensusWardConnection>;
};


export type CensusKennelArgs = {
  id: Scalars['ID']['input'];
};


export type CensusKennelsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<CensusFilters>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type CensusWardArgs = {
  id: Scalars['ID']['input'];
};


export type CensusWardsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type CensusAppointmentAssignmentFilter = {
  assignedOnly?: InputMaybe<Scalars['Boolean']['input']>;
  assignmentStatus?: InputMaybe<CensusAssignmentStatus>;
};

export type CensusAssignment = CensusUpdateTarget & {
  __typename?: 'CensusAssignment';
  department?: Maybe<Department>;
  id: Scalars['ID']['output'];
  insertedAt?: Maybe<Scalars['NaiveDateTime']['output']>;
  patient?: Maybe<Patient>;
  provider?: Maybe<Provider>;
  source?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['NaiveDateTime']['output']>;
};

export enum CensusAssignmentStatus {
  Occupied = 'OCCUPIED',
  Reserved = 'RESERVED'
}

export type CensusFilters = {
  departmentIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  kennelIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  occupancy?: InputMaybe<CensusOccupancy>;
  patientAlerts?: InputMaybe<Array<Scalars['String']['input']>>;
  patientTagIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  providerIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  search?: InputMaybe<Scalars['String']['input']>;
  species?: InputMaybe<Array<Scalars['String']['input']>>;
  status?: InputMaybe<CensusStatus>;
  statuses?: InputMaybe<Array<CensusStatus>>;
  visitTypes?: InputMaybe<Array<VisitType>>;
  wardIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type CensusHistoryEvent = {
  __typename?: 'CensusHistoryEvent';
  appointment?: Maybe<Appointment>;
  assignment?: Maybe<CensusAssignment>;
  eventType: CensusHistoryEventType;
  id: Scalars['ID']['output'];
  kennel?: Maybe<CensusKennel>;
  occurredAt: Scalars['NaiveDateTime']['output'];
  patient?: Maybe<Patient>;
  provider?: Maybe<Provider>;
  ward?: Maybe<CensusWard>;
};

export type CensusHistoryEventConnection = {
  __typename?: 'CensusHistoryEventConnection';
  edges?: Maybe<Array<Maybe<CensusHistoryEventEdge>>>;
  pageInfo: PageInfo;
};

export type CensusHistoryEventEdge = {
  __typename?: 'CensusHistoryEventEdge';
  cursor?: Maybe<Scalars['String']['output']>;
  node?: Maybe<CensusHistoryEvent>;
};

export enum CensusHistoryEventType {
  AppointmentAssignment = 'APPOINTMENT_ASSIGNMENT',
  AssignmentCreated = 'ASSIGNMENT_CREATED',
  EncounterPlacement = 'ENCOUNTER_PLACEMENT',
  TreatmentSheetPlacement = 'TREATMENT_SHEET_PLACEMENT'
}

export type CensusKennel = CensusUpdateTarget & {
  __typename?: 'CensusKennel';
  /** Free text, max 500 characters. */
  additionalNotes?: Maybe<Scalars['String']['output']>;
  assignmentCount: Scalars['Int']['output'];
  assignmentStatus?: Maybe<CensusAssignmentStatus>;
  assignments: Array<CensusAssignment>;
  history?: Maybe<CensusHistoryEventConnection>;
  id: Scalars['ID']['output'];
  kennelStatus: CensusKennelStatus;
  locationDetail?: Maybe<CensusLocationDetailLabel>;
  maxWeight?: Maybe<Scalars['Decimal']['output']>;
  minWeight?: Maybe<Scalars['Decimal']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  position: Scalars['Int']['output'];
  species?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  wardId?: Maybe<Scalars['ID']['output']>;
};


export type CensusKennelHistoryArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  appointmentIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  before?: InputMaybe<Scalars['String']['input']>;
  eventTypes?: InputMaybe<Array<InputMaybe<CensusHistoryEventType>>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Scalars['NaiveDateTime']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  patientIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  providerIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  to?: InputMaybe<Scalars['NaiveDateTime']['input']>;
};

export type CensusKennelConnection = {
  __typename?: 'CensusKennelConnection';
  edges?: Maybe<Array<Maybe<CensusKennelEdge>>>;
  pageInfo: PageInfo;
};

export type CensusKennelEdge = {
  __typename?: 'CensusKennelEdge';
  cursor?: Maybe<Scalars['String']['output']>;
  node?: Maybe<CensusKennel>;
};

export enum CensusKennelStatus {
  Clean = 'CLEAN',
  Dirty = 'DIRTY',
  DoNotUse = 'DO_NOT_USE',
  Storage = 'STORAGE'
}

export type CensusLocationDetailLabel = {
  __typename?: 'CensusLocationDetailLabel';
  active: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type CensusLocationDetailLabelInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
};

export enum CensusOccupancy {
  Occupied = 'OCCUPIED',
  Unoccupied = 'UNOCCUPIED'
}

export enum CensusStatus {
  Clean = 'CLEAN',
  Dirty = 'DIRTY',
  DoNotUse = 'DO_NOT_USE',
  Occupied = 'OCCUPIED',
  Reserved = 'RESERVED',
  Storage = 'STORAGE',
  Unoccupied = 'UNOCCUPIED'
}

export type CensusStatusCounts = {
  __typename?: 'CensusStatusCounts';
  clean: Scalars['Int']['output'];
  dirty: Scalars['Int']['output'];
  doNotUse: Scalars['Int']['output'];
  occupied: Scalars['Int']['output'];
  reserved: Scalars['Int']['output'];
  storage: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
  unoccupied: Scalars['Int']['output'];
};

export type CensusUpdate = {
  __typename?: 'CensusUpdate';
  target: CensusUpdateTarget;
};

export type CensusUpdateTarget = {
  id: Scalars['ID']['output'];
};

export type CensusWard = CensusUpdateTarget & {
  __typename?: 'CensusWard';
  id: Scalars['ID']['output'];
  kennels?: Maybe<CensusKennelConnection>;
  locationId: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  position: Scalars['Int']['output'];
  showBoardingSchedule: Scalars['Boolean']['output'];
  showPatientLocations: Scalars['Boolean']['output'];
  statusCounts: CensusStatusCounts;
};


export type CensusWardKennelsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type CensusWardConnection = {
  __typename?: 'CensusWardConnection';
  edges?: Maybe<Array<Maybe<CensusWardEdge>>>;
  pageInfo: PageInfo;
};

export type CensusWardEdge = {
  __typename?: 'CensusWardEdge';
  cursor?: Maybe<Scalars['String']['output']>;
  node?: Maybe<CensusWard>;
};

export type Changelog = {
  __typename?: 'Changelog';
  action: ActionsEnum;
  afterState?: Maybe<Scalars['JSON']['output']>;
  beforeState?: Maybe<Scalars['JSON']['output']>;
  entity?: Maybe<ChangelogEntity>;
  entityId: Scalars['String']['output'];
  entitySource: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  insertedAt: Scalars['NaiveDateTime']['output'];
  provider?: Maybe<Provider>;
};

export type ChangelogConnection = {
  __typename?: 'ChangelogConnection';
  edges?: Maybe<Array<Maybe<ChangelogEdge>>>;
  pageInfo: PageInfo;
};

export type ChangelogEdge = {
  __typename?: 'ChangelogEdge';
  cursor?: Maybe<Scalars['String']['output']>;
  node?: Maybe<Changelog>;
};

export type ChangelogEntity = Conversation | Encounter | EncounterSection | EncounterSectionDatum | Immunization | LabOrder | LabResult | Medication | Message | Order | OrderItem | OrgLab | Patient | ProductPrice | ProviderTransfer | StockTransferItem | Task | TreatmentSheet | TreatmentSheetRow | Vitals;

export type ChangelogFilters = {
  action?: InputMaybe<ActionsEnum>;
  entityId?: InputMaybe<Scalars['String']['input']>;
  entitySource?: InputMaybe<Scalars['String']['input']>;
  insertedAtEnd?: InputMaybe<Scalars['NaiveDateTime']['input']>;
  insertedAtStart?: InputMaybe<Scalars['NaiveDateTime']['input']>;
  providerId?: InputMaybe<Scalars['ID']['input']>;
  providerIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

export type ChangelogOrderBy = {
  insertedAt?: InputMaybe<OrderByDirection>;
};

export type CheckboxDatum = Datum & {
  __typename?: 'CheckboxDatum';
  inline?: Maybe<Scalars['Truthy']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  options?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  required?: Maybe<Scalars['Truthy']['output']>;
  showTimestamp?: Maybe<Scalars['Truthy']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type ChecklistDatum = Datum & {
  __typename?: 'ChecklistDatum';
  inline?: Maybe<Scalars['Truthy']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  options?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  optionsDefault?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  required?: Maybe<Scalars['Truthy']['output']>;
  showTimestamp?: Maybe<Scalars['Truthy']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** A client who manages patient(s) */
export type Client = {
  __typename?: 'Client';
  accountCredit?: Maybe<Scalars['Decimal']['output']>;
  accountCreditHistoryCount: Scalars['Int']['output'];
  addresses?: Maybe<Array<Maybe<Address>>>;
  alerts?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  billingEmail?: Maybe<Scalars['String']['output']>;
  billingEmailVerifiedDate?: Maybe<Scalars['NaiveDateTime']['output']>;
  billingGroup?: Maybe<BillingGroup>;
  billingGroupId?: Maybe<Scalars['ID']['output']>;
  billingId?: Maybe<Scalars['String']['output']>;
  billingNotes?: Maybe<Array<Maybe<BillingNote>>>;
  businessName?: Maybe<Scalars['String']['output']>;
  cardconnectExpiry?: Maybe<Scalars['String']['output']>;
  cardconnectToken?: Maybe<Scalars['String']['output']>;
  cardconnectTokenLast4?: Maybe<Scalars['String']['output']>;
  careCreditApplication?: Maybe<ClientCareCreditApplication>;
  clientRdvms?: Maybe<Array<Maybe<ClientRdvm>>>;
  clientReferralSource?: Maybe<ClientReferralSource>;
  clientReferralSourceId?: Maybe<Scalars['ID']['output']>;
  coowners?: Maybe<Array<Maybe<Coowner>>>;
  coowns?: Maybe<Array<Coowner>>;
  creditMemos?: Maybe<Array<Maybe<CreditMemo>>>;
  customFields?: Maybe<Array<Maybe<CustomClientFieldValue>>>;
  customReferralSource?: Maybe<Scalars['String']['output']>;
  dateOfBirth?: Maybe<Scalars['Date']['output']>;
  declineBillingEmail?: Maybe<Scalars['Boolean']['output']>;
  declineEmail?: Maybe<Scalars['Boolean']['output']>;
  declinePhone?: Maybe<Scalars['Boolean']['output']>;
  declineRdvm?: Maybe<Scalars['Boolean']['output']>;
  declineSecondaryEmail?: Maybe<Scalars['Boolean']['output']>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  driversLicenseNumber?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  emailVerifiedDate?: Maybe<Scalars['NaiveDateTime']['output']>;
  exemptCareCreditQuickScreen?: Maybe<Scalars['Boolean']['output']>;
  externalCommPreferences?: Maybe<Array<Maybe<ClientExternalCommPreferencesValue>>>;
  familyName?: Maybe<Scalars['String']['output']>;
  givenName?: Maybe<Scalars['String']['output']>;
  historicalId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  identification?: Maybe<Scalars['String']['output']>;
  insertedAt?: Maybe<Scalars['NaiveDateTime']['output']>;
  isActive?: Maybe<Scalars['Boolean']['output']>;
  isBusiness?: Maybe<Scalars['Boolean']['output']>;
  isMerged?: Maybe<Scalars['Boolean']['output']>;
  isNewRdvmNeeded?: Maybe<Scalars['Boolean']['output']>;
  lastSyncedAt?: Maybe<Scalars['NaiveDateTime']['output']>;
  /** The most recent appointment for any of this client's patients */
  lastVisit?: Maybe<Appointment>;
  lifetimeValue: Scalars['Decimal']['output'];
  mergeIdentification?: Maybe<Scalars['String']['output']>;
  /** Returns number of missed (no show) appointments in the last N days */
  missedAppointments: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
  /** The earliest upcoming appointment for any of this client's patients */
  nextVisit?: Maybe<Appointment>;
  notes?: Maybe<Scalars['String']['output']>;
  orgId?: Maybe<Scalars['ID']['output']>;
  patients?: Maybe<Array<Patient>>;
  paymentCount: Scalars['Int']['output'];
  payments?: Maybe<Array<Maybe<Payment>>>;
  pdf?: Maybe<Scalars['String']['output']>;
  phoneNumbers?: Maybe<Array<Maybe<PhoneNumber>>>;
  preferredPhoneNumber?: Maybe<PhoneNumber>;
  primaryLocation?: Maybe<Location>;
  primaryLocationId?: Maybe<Scalars['ID']['output']>;
  privateNotes?: Maybe<Scalars['String']['output']>;
  pronouns?: Maybe<Pronouns>;
  pronounsOther?: Maybe<Scalars['String']['output']>;
  rdvms: Array<Rdvm>;
  secondaryEmail?: Maybe<Scalars['String']['output']>;
  secondaryEmailVerifiedDate?: Maybe<Scalars['NaiveDateTime']['output']>;
  sentBillingEmailVerificationDate?: Maybe<Scalars['NaiveDateTime']['output']>;
  sentEmailVerificationDate?: Maybe<Scalars['NaiveDateTime']['output']>;
  sentSecondaryEmailVerificationDate?: Maybe<Scalars['NaiveDateTime']['output']>;
  squareCardId?: Maybe<Scalars['String']['output']>;
  stopReminders?: Maybe<Scalars['Boolean']['output']>;
  stripeCustomerId?: Maybe<Scalars['String']['output']>;
  stripeInfo?: Maybe<PaymentSource>;
  tags: Array<ClientTag>;
  taxExempt?: Maybe<Scalars['Boolean']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  trailingYearValue: Scalars['Decimal']['output'];
  updatedAt?: Maybe<Scalars['NaiveDateTime']['output']>;
  verifiedAt?: Maybe<Scalars['DateTime']['output']>;
};


/** A client who manages patient(s) */
export type ClientAddressesArgs = {
  isPrimary?: InputMaybe<Scalars['Boolean']['input']>;
};


/** A client who manages patient(s) */
export type ClientCoownersArgs = {
  updatedAtEnd?: InputMaybe<Scalars['NaiveDateTime']['input']>;
  updatedAtStart?: InputMaybe<Scalars['NaiveDateTime']['input']>;
};


/** A client who manages patient(s) */
export type ClientMissedAppointmentsArgs = {
  numberOfDays?: InputMaybe<Scalars['Int']['input']>;
};


/** A client who manages patient(s) */
export type ClientPatientsArgs = {
  filters?: InputMaybe<PatientFilters>;
};


/** A client who manages patient(s) */
export type ClientPaymentCountArgs = {
  methodsToExclude?: InputMaybe<Array<InputMaybe<PaymentMethod>>>;
};


/** A client who manages patient(s) */
export type ClientPaymentsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<PaymentSort>;
};

export type ClientCareCreditApplication = {
  __typename?: 'ClientCareCreditApplication';
  cardholderAvailableCredit?: Maybe<Scalars['Decimal']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  status?: Maybe<ClientCareCreditStatus>;
};

export enum ClientCareCreditStatus {
  Cardholder = 'CARDHOLDER',
  Deferred = 'DEFERRED',
  PreApproved = 'PRE_APPROVED'
}

export type ClientConnection = {
  __typename?: 'ClientConnection';
  edges?: Maybe<Array<Maybe<ClientEdge>>>;
  pageInfo: PageInfo;
};

export type ClientConsent = {
  __typename?: 'ClientConsent';
  consent?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  insertedAt?: Maybe<Scalars['NaiveDateTime']['output']>;
  location?: Maybe<Location>;
  name?: Maybe<Scalars['String']['output']>;
  patient?: Maybe<Patient>;
  signature?: Maybe<Scalars['String']['output']>;
  signed?: Maybe<Scalars['Boolean']['output']>;
  signedDatetime?: Maybe<Scalars['DateTime']['output']>;
};

export type ClientEdge = {
  __typename?: 'ClientEdge';
  cursor?: Maybe<Scalars['String']['output']>;
  node?: Maybe<Client>;
};

export type ClientExternalCommPreferencesInput = {
  emailMarketing?: InputMaybe<Scalars['Boolean']['input']>;
  emailTransactional?: InputMaybe<Scalars['Boolean']['input']>;
  postcardMarketing?: InputMaybe<Scalars['Boolean']['input']>;
  postcardTransactional?: InputMaybe<Scalars['Boolean']['input']>;
  smsMarketing?: InputMaybe<Scalars['Boolean']['input']>;
  smsTransactional?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ClientExternalCommPreferencesValue = {
  __typename?: 'ClientExternalCommPreferencesValue';
  clientId?: Maybe<Scalars['ID']['output']>;
  emailMarketing?: Maybe<Scalars['Boolean']['output']>;
  emailTransactional?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  insertedAt?: Maybe<Scalars['NaiveDateTime']['output']>;
  orgId?: Maybe<Scalars['ID']['output']>;
  postcardMarketing?: Maybe<Scalars['Boolean']['output']>;
  postcardTransactional?: Maybe<Scalars['Boolean']['output']>;
  smsMarketing?: Maybe<Scalars['Boolean']['output']>;
  smsTransactional?: Maybe<Scalars['Boolean']['output']>;
  updatedAt?: Maybe<Scalars['NaiveDateTime']['output']>;
};

export type ClientFilters = {
  billingGroupId?: InputMaybe<Scalars['ID']['input']>;
  byProvider?: InputMaybe<Scalars['ID']['input']>;
  coownerEmail?: InputMaybe<Scalars['String']['input']>;
  coownerName?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  familyName?: InputMaybe<Scalars['String']['input']>;
  givenName?: InputMaybe<Scalars['String']['input']>;
  historicalId?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  insertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isMember?: InputMaybe<Scalars['Boolean']['input']>;
  locationId?: InputMaybe<Scalars['ID']['input']>;
  microchipNumber?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  patientBreed?: InputMaybe<Scalars['String']['input']>;
  patientIsDeceased?: InputMaybe<Scalars['Boolean']['input']>;
  patientIsMember?: InputMaybe<Scalars['Boolean']['input']>;
  patientLocationId?: InputMaybe<Scalars['ID']['input']>;
  patientName?: InputMaybe<Scalars['String']['input']>;
  patientOnlyActive?: InputMaybe<Scalars['Boolean']['input']>;
  patientProviderId?: InputMaybe<Scalars['ID']['input']>;
  patientSpecies?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  problem?: InputMaybe<Scalars['String']['input']>;
  rabiesTagNumber?: InputMaybe<Scalars['String']['input']>;
  tag?: InputMaybe<Scalars['String']['input']>;
};

export type ClientInput = {
  addresses?: InputMaybe<Array<InputMaybe<AddressInput>>>;
  billingEmail?: InputMaybe<Scalars['String']['input']>;
  billingEmailVerifiedDate?: InputMaybe<Scalars['NaiveDateTime']['input']>;
  billingGroupId?: InputMaybe<Scalars['ID']['input']>;
  billingId?: InputMaybe<Scalars['String']['input']>;
  businessName?: InputMaybe<Scalars['String']['input']>;
  cardconnectExpiry?: InputMaybe<Scalars['String']['input']>;
  cardconnectToken?: InputMaybe<Scalars['String']['input']>;
  clientReferralSourceId?: InputMaybe<Scalars['ID']['input']>;
  customReferralSource?: InputMaybe<Scalars['String']['input']>;
  dateOfBirth?: InputMaybe<Scalars['Date']['input']>;
  declineBillingEmail?: InputMaybe<Scalars['Boolean']['input']>;
  declineEmail?: InputMaybe<Scalars['Boolean']['input']>;
  declinePhone?: InputMaybe<Scalars['Boolean']['input']>;
  declineRdvm?: InputMaybe<Scalars['Boolean']['input']>;
  declineSecondaryEmail?: InputMaybe<Scalars['Boolean']['input']>;
  driversLicenseNumber?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  emailVerifiedDate?: InputMaybe<Scalars['NaiveDateTime']['input']>;
  exemptCareCreditQuickScreen?: InputMaybe<Scalars['Boolean']['input']>;
  familyName?: InputMaybe<Scalars['String']['input']>;
  givenName?: InputMaybe<Scalars['String']['input']>;
  historicalId?: InputMaybe<Scalars['String']['input']>;
  identification?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isBusiness?: InputMaybe<Scalars['Boolean']['input']>;
  lastSyncedAt?: InputMaybe<Scalars['NaiveDateTime']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  phoneNumbers?: InputMaybe<Array<InputMaybe<PhoneNumberInput>>>;
  preferredPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  primaryLocationId?: InputMaybe<Scalars['ID']['input']>;
  privateNotes?: InputMaybe<Scalars['String']['input']>;
  pronouns?: InputMaybe<Pronouns>;
  pronounsOther?: InputMaybe<Scalars['String']['input']>;
  rdvmIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  secondaryEmail?: InputMaybe<Scalars['String']['input']>;
  secondaryEmailVerifiedDate?: InputMaybe<Scalars['NaiveDateTime']['input']>;
  sentBillingEmailVerificationDate?: InputMaybe<Scalars['NaiveDateTime']['input']>;
  sentEmailVerificationDate?: InputMaybe<Scalars['NaiveDateTime']['input']>;
  sentSecondaryEmailVerificationDate?: InputMaybe<Scalars['NaiveDateTime']['input']>;
  stopReminders?: InputMaybe<Scalars['Boolean']['input']>;
  stripeCustomerId?: InputMaybe<Scalars['String']['input']>;
  stripeInfo?: InputMaybe<PaymentSourceInput>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  taxExempt?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updateNote?: InputMaybe<Scalars['String']['input']>;
  verifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ClientRdvm = {
  __typename?: 'ClientRdvm';
  clientRdvmContacts?: Maybe<Array<Maybe<RdvmContact>>>;
  id?: Maybe<Scalars['ID']['output']>;
  insertedAt?: Maybe<Scalars['NaiveDateTime']['output']>;
  isPreferred?: Maybe<Scalars['Boolean']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  rdvm?: Maybe<Rdvm>;
};

export type ClientRdvmInput = {
  clientId?: InputMaybe<Scalars['ID']['input']>;
  contactIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  isPreferred?: InputMaybe<Scalars['Boolean']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  rdvmId?: InputMaybe<Scalars['ID']['input']>;
};

export type ClientReferralSource = {
  __typename?: 'ClientReferralSource';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  position?: Maybe<Scalars['Int']['output']>;
};

export type ClientReferralSourceInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
};

/** A client search result */
export type ClientResult = {
  __typename?: 'ClientResult';
  accountCredit?: Maybe<Scalars['Decimal']['output']>;
  accountCreditHistoryCount: Scalars['Int']['output'];
  addresses?: Maybe<Array<Maybe<Address>>>;
  alerts?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  billingEmail?: Maybe<Scalars['String']['output']>;
  billingEmailVerifiedDate?: Maybe<Scalars['NaiveDateTime']['output']>;
  billingGroup?: Maybe<BillingGroup>;
  billingGroupId?: Maybe<Scalars['ID']['output']>;
  billingId?: Maybe<Scalars['String']['output']>;
  billingNotes?: Maybe<Array<Maybe<BillingNote>>>;
  businessName?: Maybe<Scalars['String']['output']>;
  cardconnectExpiry?: Maybe<Scalars['String']['output']>;
  cardconnectToken?: Maybe<Scalars['String']['output']>;
  cardconnectTokenLast4?: Maybe<Scalars['String']['output']>;
  careCreditApplication?: Maybe<ClientCareCreditApplication>;
  clientRdvms?: Maybe<Array<Maybe<ClientRdvm>>>;
  clientReferralSource?: Maybe<ClientReferralSource>;
  clientReferralSourceId?: Maybe<Scalars['ID']['output']>;
  coowners?: Maybe<Array<Maybe<Coowner>>>;
  coowns?: Maybe<Array<Coowner>>;
  creditMemos?: Maybe<Array<Maybe<CreditMemo>>>;
  customFields?: Maybe<Array<Maybe<CustomClientFieldValue>>>;
  customReferralSource?: Maybe<Scalars['String']['output']>;
  dateOfBirth?: Maybe<Scalars['Date']['output']>;
  declineBillingEmail?: Maybe<Scalars['Boolean']['output']>;
  declineEmail?: Maybe<Scalars['Boolean']['output']>;
  declinePhone?: Maybe<Scalars['Boolean']['output']>;
  declineRdvm?: Maybe<Scalars['Boolean']['output']>;
  declineSecondaryEmail?: Maybe<Scalars['Boolean']['output']>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  driversLicenseNumber?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  emailVerifiedDate?: Maybe<Scalars['NaiveDateTime']['output']>;
  exemptCareCreditQuickScreen?: Maybe<Scalars['Boolean']['output']>;
  externalCommPreferences?: Maybe<Array<Maybe<ClientExternalCommPreferencesValue>>>;
  familyName?: Maybe<Scalars['String']['output']>;
  givenName?: Maybe<Scalars['String']['output']>;
  hasExternalMatches?: Maybe<Scalars['Boolean']['output']>;
  historicalId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  identification?: Maybe<Scalars['String']['output']>;
  insertedAt?: Maybe<Scalars['NaiveDateTime']['output']>;
  isActive?: Maybe<Scalars['Boolean']['output']>;
  isBusiness?: Maybe<Scalars['Boolean']['output']>;
  isMerged?: Maybe<Scalars['Boolean']['output']>;
  isNewRdvmNeeded?: Maybe<Scalars['Boolean']['output']>;
  lastSyncedAt?: Maybe<Scalars['NaiveDateTime']['output']>;
  /** The most recent appointment for any of this client's patients */
  lastVisit?: Maybe<Appointment>;
  lifetimeValue: Scalars['Decimal']['output'];
  mergeIdentification?: Maybe<Scalars['String']['output']>;
  /** Returns number of missed (no show) appointments in the last N days */
  missedAppointments: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
  /** The earliest upcoming appointment for any of this client's patients */
  nextVisit?: Maybe<Appointment>;
  notes?: Maybe<Scalars['String']['output']>;
  orgId?: Maybe<Scalars['ID']['output']>;
  patientResults?: Maybe<Array<Maybe<Patient>>>;
  patients?: Maybe<Array<Patient>>;
  paymentCount: Scalars['Int']['output'];
  payments?: Maybe<Array<Maybe<Payment>>>;
  pdf?: Maybe<Scalars['String']['output']>;
  phoneNumbers?: Maybe<Array<Maybe<PhoneNumber>>>;
  preferredPhoneNumber?: Maybe<PhoneNumber>;
  primaryLocation?: Maybe<Location>;
  primaryLocationId?: Maybe<Scalars['ID']['output']>;
  privateNotes?: Maybe<Scalars['String']['output']>;
  pronouns?: Maybe<Pronouns>;
  pronounsOther?: Maybe<Scalars['String']['output']>;
  rdvms: Array<Rdvm>;
  secondaryEmail?: Maybe<Scalars['String']['output']>;
  secondaryEmailVerifiedDate?: Maybe<Scalars['NaiveDateTime']['output']>;
  sentBillingEmailVerificationDate?: Maybe<Scalars['NaiveDateTime']['output']>;
  sentEmailVerificationDate?: Maybe<Scalars['NaiveDateTime']['output']>;
  sentSecondaryEmailVerificationDate?: Maybe<Scalars['NaiveDateTime']['output']>;
  squareCardId?: Maybe<Scalars['String']['output']>;
  stopReminders?: Maybe<Scalars['Boolean']['output']>;
  stripeCustomerId?: Maybe<Scalars['String']['output']>;
  stripeInfo?: Maybe<PaymentSource>;
  tags: Array<ClientTag>;
  taxExempt?: Maybe<Scalars['Boolean']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  trailingYearValue: Scalars['Decimal']['output'];
  updatedAt?: Maybe<Scalars['NaiveDateTime']['output']>;
  verifiedAt?: Maybe<Scalars['DateTime']['output']>;
};


/** A client search result */
export type ClientResultAddressesArgs = {
  isPrimary?: InputMaybe<Scalars['Boolean']['input']>;
};


/** A client search result */
export type ClientResultCoownersArgs = {
  updatedAtEnd?: InputMaybe<Scalars['NaiveDateTime']['input']>;
  updatedAtStart?: InputMaybe<Scalars['NaiveDateTime']['input']>;
};


/** A client search result */
export type ClientResultMissedAppointmentsArgs = {
  numberOfDays?: InputMaybe<Scalars['Int']['input']>;
};


/** A client search result */
export type ClientResultPatientsArgs = {
  filters?: InputMaybe<PatientFilters>;
};


/** A client search result */
export type ClientResultPaymentCountArgs = {
  methodsToExclude?: InputMaybe<Array<InputMaybe<PaymentMethod>>>;
};


/** A client search result */
export type ClientResultPaymentsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<PaymentSort>;
};

export type ClientTag = {
  __typename?: 'ClientTag';
  coupons?: Maybe<Array<Maybe<Coupon>>>;
  discount?: Maybe<Scalars['Decimal']['output']>;
  discountType?: Maybe<DiscountType>;
  id: Scalars['ID']['output'];
  locations?: Maybe<Array<Maybe<Location>>>;
  name?: Maybe<Scalars['String']['output']>;
  priority?: Maybe<Scalars['Int']['output']>;
};

export type ClientTagInput = {
  couponIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  discount?: InputMaybe<Scalars['Decimal']['input']>;
  discountType?: InputMaybe<DiscountType>;
  locationIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  priority?: InputMaybe<Scalars['Int']['input']>;
};

export type ClinicalNote = {
  __typename?: 'ClinicalNote';
  datetime?: Maybe<Scalars['DateTime']['output']>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  fieldData?: Maybe<Scalars['JSON']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  location?: Maybe<Location>;
  provider?: Maybe<Provider>;
  text?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  visit?: Maybe<Visit>;
};

export type ClinicalNoteInput = {
  datetime?: InputMaybe<Scalars['DateTime']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  fieldData?: InputMaybe<Scalars['JSON']['input']>;
  locationId?: InputMaybe<Scalars['ID']['input']>;
  patientId?: InputMaybe<Scalars['ID']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  visitId?: InputMaybe<Scalars['ID']['input']>;
};

export type Comment = {
  __typename?: 'Comment';
  body?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  insertedAt?: Maybe<Scalars['NaiveDateTime']['output']>;
  provider?: Maybe<Provider>;
  updatedAt?: Maybe<Scalars['NaiveDateTime']['output']>;
};

export enum CommentableEntityType {
  Appointment = 'APPOINTMENT',
  LabResult = 'LAB_RESULT',
  RdvmVisit = 'RDVM_VISIT',
  Reservation = 'RESERVATION',
  Task = 'TASK',
  TreatmentSheet = 'TREATMENT_SHEET'
}

export enum Comparison {
  Eq = 'EQ',
  EqAtom = 'EQ_ATOM',
  Gt = 'GT',
  Gte = 'GTE',
  IdIn = 'ID_IN',
  In = 'IN',
  Lt = 'LT',
  Lte = 'LTE'
}

export type Complication = {
  __typename?: 'Complication';
  id: Scalars['ID']['output'];
  isMajor?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type ComplicationInput = {
  isMajor?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/**
 * A single condition that must be met for a conditional permission to be required.
 *
 * Each condition checks whether a field equals one of the expected values.
 * When multiple conditions are specified in a conditional_permission, ALL must be true (AND logic).
 *
 * ## Condition Types
 *
 * Use either `value` OR `exists`, not both:
 *
 * - **value**: Check if a field matches specific values (e.g., `value: ["true"]`)
 * - **exists**: Check if a value/entity exists or not (e.g., `exists: true`)
 *
 * ## Examples
 *
 * ```elixir
 * # Check field value
 * %{field: "is_controlled", value: ["true"]}
 *
 * # Check entity exists
 * %{entity_module: "Vetspire.Billing.Product", entity_id_path: "input.product_id", exists: true}
 *
 * # Check entity does NOT exist
 * %{entity_module: "Vetspire.Billing.Product", entity_id_path: "input.product_id", exists: false}
 *
 * # Check if a field on the entity has a value
 * %{field: "manufacturer_id", entity_module: "Vetspire.Billing.Product", entity_id_path: "id", exists: true}
 *
 * # Check if input field was provided (no entity lookup)
 * %{field: "input.prescriber_id", exists: true}
 * ```
 */
export type Condition = {
  /**
   * Dot-notation path to the entity ID in the GraphQL arguments (e.g., 'input.product_id', 'medication_id').
   * Used to fetch the related entity for conditional permission checking.
   * Required when entity_module is specified.
   */
  entityIdPath?: InputMaybe<Scalars['String']['input']>;
  /**
   * The Elixir module name for the entity to check (e.g., 'Vetspire.Clinical.Medication').
   *
   * When specified with entity_id_path:
   * - The system extracts the entity ID from GraphQL arguments using the path
   * - Fetches the entity from the database using this module
   * - Checks the field value on the fetched entity
   *
   * When not specified:
   * - The field value is checked directly on the input arguments
   * - Useful for permissions based on values provided in the GraphQL request
   */
  entityModule?: InputMaybe<Scalars['String']['input']>;
  /** Check if the value/entity exists (true) or does not exist (false). Cannot be used with `value`. */
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  /** The field name to check on the resource (e.g., 'is_controlled', 'status'). Required when using `value`, optional when using `exists` with an entity. */
  field?: InputMaybe<Scalars['String']['input']>;
  /** The expected field values that trigger this permission requirement (e.g., ['true'], ['active', 'pending']). Cannot be used with `exists`. */
  value?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type Conditional = {
  __typename?: 'Conditional';
  operator?: Maybe<ConditionalOperator>;
  productId?: Maybe<Scalars['Int']['output']>;
  quantity?: Maybe<Scalars['Int']['output']>;
};

export type ConditionalInput = {
  operator?: InputMaybe<ConditionalOperator>;
  productId?: InputMaybe<Scalars['Int']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
};

export enum ConditionalOperator {
  Equal = 'EQUAL',
  GreaterThanOrEqual = 'GREATER_THAN_OR_EQUAL',
  LessThanOrEqual = 'LESS_THAN_OR_EQUAL'
}

/**
 * Defines a permission that depends on runtime field values of a resource.
 *
 * Used for dynamic authorization where permission requirements change based on
 * the actual data being accessed. All conditions must be met (AND logic) for
 * the permission to be required.
 */
export type ConditionalPermission = {
  /**
   * List of conditions that must ALL be true for this permission to be required.
   * If all conditions are met and the user lacks the permission, access is denied.
   */
  conditions: Array<Condition>;
  /** The required permission string (e.g., 'medication.prescribe_controlled') */
  permission: Scalars['String']['input'];
};

export type ConsentForm = {
  __typename?: 'ConsentForm';
  body?: Maybe<Scalars['String']['output']>;
  enabled?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  position?: Maybe<Scalars['Int']['output']>;
};

export type ConsentFormInput = {
  body?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
};

export enum ContactType {
  AssociateVet = 'ASSOCIATE_VET',
  MedicalDirector = 'MEDICAL_DIRECTOR',
  Other = 'OTHER',
  Owner = 'OWNER',
  PracticeManager = 'PRACTICE_MANAGER',
  Receptionist = 'RECEPTIONIST',
  Technician = 'TECHNICIAN'
}

/** A conversation between a client, a client's rdvm or a client's coowner and their providers at an org */
export type Conversation = {
  __typename?: 'Conversation';
  client?: Maybe<Client>;
  closed?: Maybe<Scalars['Boolean']['output']>;
  closedAt?: Maybe<Scalars['DateTime']['output']>;
  coowner?: Maybe<Coowner>;
  id?: Maybe<Scalars['ID']['output']>;
  insertedAt?: Maybe<Scalars['NaiveDateTime']['output']>;
  isSelectedClientSecEmail?: Maybe<Scalars['Boolean']['output']>;
  latestMessage?: Maybe<Message>;
  location?: Maybe<Location>;
  medium?: Maybe<ConversationMedium>;
  messages?: Maybe<Array<Maybe<Message>>>;
  org?: Maybe<Org>;
  patient?: Maybe<Patient>;
  rdvm?: Maybe<Rdvm>;
  sharedEmails: Array<Scalars['String']['output']>;
  subject?: Maybe<Scalars['String']['output']>;
  visit?: Maybe<Visit>;
};


/** A conversation between a client, a client's rdvm or a client's coowner and their providers at an org */
export type ConversationMessagesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export type ConversationConnection = {
  __typename?: 'ConversationConnection';
  edges?: Maybe<Array<Maybe<ConversationEdge>>>;
  pageInfo: PageInfo;
};

export type ConversationEdge = {
  __typename?: 'ConversationEdge';
  cursor?: Maybe<Scalars['String']['output']>;
  node?: Maybe<Conversation>;
};

export type ConversationInput = {
  closed?: InputMaybe<Scalars['Boolean']['input']>;
  closedAt?: InputMaybe<Scalars['DateTime']['input']>;
  coownerId?: InputMaybe<Scalars['ID']['input']>;
  isSelectedClientSecEmail?: InputMaybe<Scalars['Boolean']['input']>;
  locationId?: InputMaybe<Scalars['ID']['input']>;
  medium?: InputMaybe<ConversationMedium>;
  rdvmId?: InputMaybe<Scalars['ID']['input']>;
  subject?: InputMaybe<Scalars['String']['input']>;
  visitId?: InputMaybe<Scalars['ID']['input']>;
};

export enum ConversationMedium {
  App = 'APP',
  Email = 'EMAIL',
  Facebook = 'FACEBOOK',
  Fax = 'FAX',
  Other = 'OTHER',
  Postcard = 'POSTCARD',
  Sms = 'SMS',
  WebsiteChat = 'WEBSITE_CHAT'
}

export type ConversationPage = {
  __typename?: 'ConversationPage';
  entries?: Maybe<Array<Conversation>>;
  metadata?: Maybe<Cursor>;
};

export type ConversationSetAttachment = {
  bucket?: InputMaybe<Scalars['String']['input']>;
  contentType?: InputMaybe<Scalars['String']['input']>;
  filename?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** A coowner (linked to a client) */
export type Coowner = {
  __typename?: 'Coowner';
  address?: Maybe<Scalars['String']['output']>;
  billingEmail?: Maybe<Scalars['String']['output']>;
  billingEmailVerifiedDate?: Maybe<Scalars['NaiveDateTime']['output']>;
  client?: Maybe<Client>;
  coownerClient?: Maybe<Client>;
  declineBillingEmail?: Maybe<Scalars['Boolean']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  insertedAt?: Maybe<Scalars['NaiveDateTime']['output']>;
  isActiveAssociate?: Maybe<Scalars['Boolean']['output']>;
  isPrimaryContact?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  patient?: Maybe<Patient>;
  percentageOwnership?: Maybe<Scalars['Decimal']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  relationship?: Maybe<Scalars['String']['output']>;
  relationshipId?: Maybe<Scalars['ID']['output']>;
  remind?: Maybe<Scalars['Boolean']['output']>;
  sentBillingEmailVerificationDate?: Maybe<Scalars['NaiveDateTime']['output']>;
  shareMedicalRecords?: Maybe<Scalars['Boolean']['output']>;
  updatedAt?: Maybe<Scalars['NaiveDateTime']['output']>;
};

export type CoownerBreakdown = {
  __typename?: 'CoownerBreakdown';
  client: Client;
  clientId: Scalars['ID']['output'];
  total: Scalars['Decimal']['output'];
  totalCents: Scalars['Int']['output'];
};

export type CoownerInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  billingEmail?: InputMaybe<Scalars['String']['input']>;
  billingEmailVerifiedDate?: InputMaybe<Scalars['NaiveDateTime']['input']>;
  coOwnerClientId?: InputMaybe<Scalars['ID']['input']>;
  declineBillingEmail?: InputMaybe<Scalars['Boolean']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  isActiveAssociate?: InputMaybe<Scalars['Boolean']['input']>;
  isPrimaryContact?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  patientId?: InputMaybe<Scalars['ID']['input']>;
  percentageOwnership?: InputMaybe<Scalars['Decimal']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  relationshipId?: InputMaybe<Scalars['ID']['input']>;
  remind?: InputMaybe<Scalars['Boolean']['input']>;
  sentBillingEmailVerificationDate?: InputMaybe<Scalars['NaiveDateTime']['input']>;
  shareMedicalRecords?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Coupon = {
  __typename?: 'Coupon';
  allowableClientRedemptions?: Maybe<Scalars['Int']['output']>;
  allowablePatientRedemptions?: Maybe<Scalars['Int']['output']>;
  appliedOrders?: Maybe<Array<Maybe<Order>>>;
  clientTags: Array<Maybe<ClientTag>>;
  code?: Maybe<Scalars['String']['output']>;
  conditionals?: Maybe<Array<Maybe<Conditional>>>;
  couponProducts?: Maybe<Array<Maybe<CouponProduct>>>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  discount?: Maybe<Scalars['Decimal']['output']>;
  discountType?: Maybe<DiscountType>;
  excludedClientTags: Array<Maybe<ClientTag>>;
  excludedPatientTags: Array<Maybe<PatientTag>>;
  expirationDate?: Maybe<Scalars['Date']['output']>;
  id: Scalars['ID']['output'];
  insertedAt?: Maybe<Scalars['NaiveDateTime']['output']>;
  locations?: Maybe<Array<Maybe<Location>>>;
  memberOnly?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  newClientOnly?: Maybe<Scalars['Boolean']['output']>;
  orders?: Maybe<Array<Maybe<Order>>>;
  packages?: Maybe<Array<Maybe<ProductPackage>>>;
  patientTags: Array<Maybe<PatientTag>>;
  productCategories?: Maybe<Array<Maybe<ProductCategory>>>;
  productTypes?: Maybe<Array<Maybe<ProductType>>>;
  products?: Maybe<Array<Maybe<Product>>>;
  redeemByCode?: Maybe<Scalars['Boolean']['output']>;
  revenueCenter?: Maybe<RevenueCenter>;
  revenueCenterId?: Maybe<Scalars['ID']['output']>;
  startDate?: Maybe<Scalars['Date']['output']>;
};


export type CouponAppliedOrdersArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  updatedAtEnd?: InputMaybe<Scalars['NaiveDateTime']['input']>;
  updatedAtStart?: InputMaybe<Scalars['NaiveDateTime']['input']>;
};

export type CouponInput = {
  allowableClientRedemptions?: InputMaybe<Scalars['Int']['input']>;
  allowablePatientRedemptions?: InputMaybe<Scalars['Int']['input']>;
  clientTagIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  code?: InputMaybe<Scalars['String']['input']>;
  conditionals?: InputMaybe<Array<InputMaybe<ConditionalInput>>>;
  couponProducts?: InputMaybe<Array<InputMaybe<CouponProductInput>>>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  discount?: InputMaybe<Scalars['Decimal']['input']>;
  discountType?: InputMaybe<DiscountType>;
  excludedClientTagIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  excludedPatientTagIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  expirationDate?: InputMaybe<Scalars['Date']['input']>;
  locationIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  memberOnly?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  newClientOnly?: InputMaybe<Scalars['Boolean']['input']>;
  packageIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  patientTagIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  productCategoryIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  productIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  productTypeIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  redeemByCode?: InputMaybe<Scalars['Boolean']['input']>;
  revenueCenterId?: InputMaybe<Scalars['ID']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
};

export type CouponProduct = {
  __typename?: 'CouponProduct';
  autoApply?: Maybe<Scalars['Boolean']['output']>;
  couponId?: Maybe<Scalars['ID']['output']>;
  productId?: Maybe<Scalars['ID']['output']>;
};

export type CouponProductInput = {
  autoApply?: InputMaybe<Scalars['Boolean']['input']>;
  productId: Scalars['ID']['input'];
};

export type CreateCareTeamRoleInput = {
  locationIds: Array<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Input for creating a lab order from Harvest (UPenn LIS) order submission. */
export type CreateHarvestLabOrderInput = {
  comments?: InputMaybe<Scalars['String']['input']>;
  dateOfRequest?: InputMaybe<Scalars['String']['input']>;
  eventType: IguanaLabOrderEventType;
  exams?: InputMaybe<Array<InputMaybe<HarvestExamInput>>>;
  locationId: Scalars['ID']['input'];
  patientId: Scalars['ID']['input'];
  providerId?: InputMaybe<Scalars['ID']['input']>;
  sampleId: Scalars['String']['input'];
};

/** Input for creating a lab result from Harvest (UPenn LIS) report ingestion. */
export type CreateHarvestLabResultInput = {
  approvedDateTime?: InputMaybe<Scalars['String']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  dateTime?: InputMaybe<Scalars['String']['input']>;
  eventType: IguanaLabOrderEventType;
  examResults?: InputMaybe<Array<InputMaybe<HarvestExamResultInput>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** Base64-encoded PDF report (optional) */
  resultBase64?: InputMaybe<Scalars['String']['input']>;
  /** Plain-text result summary (optional) */
  resultText?: InputMaybe<Scalars['String']['input']>;
  sampleId: Scalars['String']['input'];
};

/** Input for creating a lab order from Iguana/Penn RIS order submission. */
export type CreateIguanaLabOrderInput = {
  accessionNumber: Scalars['Int']['input'];
  dateOfRequest?: InputMaybe<Scalars['String']['input']>;
  eventType: IguanaLabOrderEventType;
  exams?: InputMaybe<Array<InputMaybe<IguanaExamInput>>>;
  history?: InputMaybe<Scalars['String']['input']>;
  locationId: Scalars['ID']['input'];
  modality: Scalars['String']['input'];
  patientId: Scalars['ID']['input'];
  providerId?: InputMaybe<Scalars['ID']['input']>;
  resource?: InputMaybe<Scalars['String']['input']>;
  scheduleDateTime?: InputMaybe<Scalars['String']['input']>;
  stat?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Input for creating a lab result from Iguana/Penn RIS report ingestion. */
export type CreateIguanaLabResultInput = {
  accessionNumber: Scalars['Int']['input'];
  datetime?: InputMaybe<Scalars['String']['input']>;
  eventType: IguanaLabOrderEventType;
  name?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  /** Base64-encoded PDF report (optional) */
  resultBase64?: InputMaybe<Scalars['String']['input']>;
  /** Plain-text result summary (optional) */
  resultText?: InputMaybe<Scalars['String']['input']>;
};

export type CreateManualArAdjustmentInput = {
  adjustmentDate: Scalars['Date']['input'];
  amountCents: Scalars['Int']['input'];
  clientId: Scalars['ID']['input'];
  creditAccount: Scalars['String']['input'];
  debitAccount: Scalars['String']['input'];
  locationId: Scalars['ID']['input'];
};

export type CreateProviderTransferInput = {
  departmentId?: InputMaybe<Scalars['ID']['input']>;
  locationId: Scalars['ID']['input'];
  providerId: Scalars['ID']['input'];
  startTime: Scalars['DateTime']['input'];
  treatmentSheetId: Scalars['ID']['input'];
};

export type CreateStockTransferFulfillmentItemInput = {
  expirationDate?: InputMaybe<Scalars['Date']['input']>;
  fulfillmentNote?: InputMaybe<Scalars['String']['input']>;
  lotNumber?: InputMaybe<Scalars['String']['input']>;
  quantityChangeReason?: InputMaybe<Scalars['String']['input']>;
  receivedQuantity?: InputMaybe<Scalars['Decimal']['input']>;
  status?: InputMaybe<StockTransferFulfillmentItemStatus>;
};

export type CreateStockTransferRequestInput = {
  collectionNotes?: InputMaybe<Scalars['String']['input']>;
  fromStockLocationId?: InputMaybe<Scalars['ID']['input']>;
  fulfillmentNotes?: InputMaybe<Scalars['String']['input']>;
  isPriority?: InputMaybe<Scalars['Boolean']['input']>;
  isReturn?: InputMaybe<Scalars['Boolean']['input']>;
  locationId: Scalars['ID']['input'];
  orderDate?: InputMaybe<Scalars['DateTime']['input']>;
  requestItems?: InputMaybe<Array<CreateStockTransferRequestItemInput>>;
  requestNotes?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<StockTransferRequestStatus>;
  toStockLocationId?: InputMaybe<Scalars['ID']['input']>;
  transferDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CreateStockTransferRequestItemInput = {
  productId: Scalars['ID']['input'];
  requestedQuantity?: InputMaybe<Scalars['Decimal']['input']>;
};

export type CreateStockTransferRequestItemsInput = {
  requestItems: Array<CreateStockTransferRequestItemInput>;
};

export type CreateStockTransferTemplateItemInput = {
  productId: Scalars['ID']['input'];
  requestedQuantity?: InputMaybe<Scalars['Decimal']['input']>;
};

export type CreateTreatmentSheetInput = {
  careTeamMembers?: InputMaybe<Array<InputMaybe<TreatmentSheetCareTeamMemberInput>>>;
  criticalCondition?: InputMaybe<Scalars['Boolean']['input']>;
  departmentId?: InputMaybe<Scalars['ID']['input']>;
  locationId?: InputMaybe<Scalars['ID']['input']>;
  patientId: Scalars['ID']['input'];
  patientLocation?: InputMaybe<PatientLocationInput>;
  providerId: Scalars['ID']['input'];
  start: Scalars['DateTime']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
  treatmentSheetTemplateId?: InputMaybe<Scalars['ID']['input']>;
  visitId?: InputMaybe<Scalars['ID']['input']>;
  visitProblemsList?: InputMaybe<Scalars['String']['input']>;
  visitType?: InputMaybe<VisitType>;
};

export type CreditMemo = {
  __typename?: 'CreditMemo';
  amount?: Maybe<Scalars['Decimal']['output']>;
  client?: Maybe<Client>;
  creditReason?: Maybe<CreditReason>;
  datetime?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  location?: Maybe<Location>;
  note?: Maybe<Scalars['String']['output']>;
  orderItem?: Maybe<OrderItem>;
  provider?: Maybe<Provider>;
  type?: Maybe<Scalars['String']['output']>;
};

export type CreditMemoInput = {
  amount?: InputMaybe<Scalars['Decimal']['input']>;
  creditReasonId?: InputMaybe<Scalars['ID']['input']>;
  locationId?: InputMaybe<Scalars['ID']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
};

export type CreditMemoTotals = {
  __typename?: 'CreditMemoTotals';
  cashDownDiscount?: Maybe<Scalars['Decimal']['output']>;
  cashDownDiscountCount?: Maybe<Scalars['Int']['output']>;
  count?: Maybe<Scalars['Int']['output']>;
  credit?: Maybe<Scalars['Decimal']['output']>;
  creditCount?: Maybe<Scalars['Int']['output']>;
  total?: Maybe<Scalars['Decimal']['output']>;
};

export type CreditReason = {
  __typename?: 'CreditReason';
  id?: Maybe<Scalars['ID']['output']>;
  isActive?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type CreditReasonInput = {
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type CreditReasonRelated = {
  __typename?: 'CreditReasonRelated';
  active?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type Cursor = {
  __typename?: 'Cursor';
  after?: Maybe<Scalars['String']['output']>;
  before?: Maybe<Scalars['String']['output']>;
  limit: Scalars['Int']['output'];
  totalCount: Scalars['Int']['output'];
  totalCountCapExceeded: Scalars['Boolean']['output'];
};

/** A custom appointment information field */
export type CustomAppointmentField = {
  __typename?: 'CustomAppointmentField';
  id?: Maybe<Scalars['ID']['output']>;
  includeOnAppointment?: Maybe<Scalars['Boolean']['output']>;
  insertedAt?: Maybe<Scalars['NaiveDateTime']['output']>;
  isActive?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  required?: Maybe<Scalars['Boolean']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type CustomAppointmentFieldInput = {
  includeOnAppointment?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

/** A custom appointment field value */
export type CustomAppointmentFieldValue = {
  __typename?: 'CustomAppointmentFieldValue';
  appointmentId?: Maybe<Scalars['ID']['output']>;
  customAppointmentField?: Maybe<CustomAppointmentField>;
  customAppointmentFieldId?: Maybe<Scalars['ID']['output']>;
  historicalId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  insertedAt?: Maybe<Scalars['NaiveDateTime']['output']>;
  updatedAt?: Maybe<Scalars['NaiveDateTime']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type CustomAppointmentFieldValueInput = {
  appointmentId?: InputMaybe<Scalars['ID']['input']>;
  customAppointmentFieldId?: InputMaybe<Scalars['ID']['input']>;
  historicalId?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** A custom client information field */
export type CustomClientField = {
  __typename?: 'CustomClientField';
  id?: Maybe<Scalars['ID']['output']>;
  insertedAt?: Maybe<Scalars['NaiveDateTime']['output']>;
  isActive?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type CustomClientFieldInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

/** A custom client field value */
export type CustomClientFieldValue = {
  __typename?: 'CustomClientFieldValue';
  clientId?: Maybe<Scalars['ID']['output']>;
  customClientField?: Maybe<CustomClientField>;
  customClientFieldId?: Maybe<Scalars['ID']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  insertedAt?: Maybe<Scalars['NaiveDateTime']['output']>;
  updatedAt?: Maybe<Scalars['NaiveDateTime']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type CustomClientFieldValueInput = {
  clientId?: InputMaybe<Scalars['ID']['input']>;
  customClientFieldId?: InputMaybe<Scalars['ID']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type CustomLocationAttribute = {
  __typename?: 'CustomLocationAttribute';
  id?: Maybe<Scalars['ID']['output']>;
  insertedAt?: Maybe<Scalars['NaiveDateTime']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type CustomLocationAttributeInput = {
  name?: InputMaybe<Scalars['String']['input']>;
};

/** A custom patient information field */
export type CustomPatientField = {
  __typename?: 'CustomPatientField';
  id?: Maybe<Scalars['ID']['output']>;
  includeOnAppointment?: Maybe<Scalars['Boolean']['output']>;
  insertedAt?: Maybe<Scalars['NaiveDateTime']['output']>;
  isActive?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type CustomPatientFieldInput = {
  includeOnAppointment?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

/** A custom patient field value */
export type CustomPatientFieldValue = {
  __typename?: 'CustomPatientFieldValue';
  appointment?: Maybe<Appointment>;
  appointmentId?: Maybe<Scalars['ID']['output']>;
  customPatientField?: Maybe<CustomPatientField>;
  customPatientFieldId?: Maybe<Scalars['ID']['output']>;
  historicalId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  insertedAt?: Maybe<Scalars['NaiveDateTime']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  patientId?: Maybe<Scalars['ID']['output']>;
  updatedAt?: Maybe<Scalars['NaiveDateTime']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type CustomPatientFieldValueInput = {
  appointmentId?: InputMaybe<Scalars['ID']['input']>;
  customPatientFieldId?: InputMaybe<Scalars['ID']['input']>;
  historicalId?: InputMaybe<Scalars['String']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  patientId?: InputMaybe<Scalars['ID']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type CustomPatientProtocol = {
  __typename?: 'CustomPatientProtocol';
  date?: Maybe<Scalars['Date']['output']>;
  dueDate?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  location?: Maybe<Location>;
  org?: Maybe<Org>;
  patient?: Maybe<Patient>;
  protocol?: Maybe<Protocol>;
  provider?: Maybe<Provider>;
  sourceDocument?: Maybe<PatientDocument>;
};

export type CustomPatientProtocolInput = {
  date?: InputMaybe<Scalars['Date']['input']>;
  dueDate?: InputMaybe<Scalars['Date']['input']>;
  isDeclined?: InputMaybe<Scalars['Boolean']['input']>;
  isDelete?: InputMaybe<Scalars['Boolean']['input']>;
  locationId?: InputMaybe<Scalars['ID']['input']>;
  orgId?: InputMaybe<Scalars['ID']['input']>;
  patientId?: InputMaybe<Scalars['ID']['input']>;
  protocolId?: InputMaybe<Scalars['ID']['input']>;
  providerId?: InputMaybe<Scalars['ID']['input']>;
  sourceDocumentId?: InputMaybe<Scalars['ID']['input']>;
};

export type CustomTreatmentSheetRowInput = {
  additives?: InputMaybe<Array<InputMaybe<TreatmentSheetRowAdditiveInput>>>;
  administration?: InputMaybe<Scalars['String']['input']>;
  boluses?: InputMaybe<Array<InputMaybe<TreatmentSheetRowBolusInput>>>;
  calculatedAmount?: InputMaybe<Scalars['Decimal']['input']>;
  discontinued?: InputMaybe<Scalars['Boolean']['input']>;
  dose?: InputMaybe<Scalars['Decimal']['input']>;
  doseUnit?: InputMaybe<Scalars['String']['input']>;
  extendedInstructions?: InputMaybe<Scalars['String']['input']>;
  fluid?: InputMaybe<TreatmentSheetRowFluidInput>;
  format?: InputMaybe<TreatmentSheetFormat>;
  /**
   * Minutes between administrations. The `-1` ("as needed") and `0` ("one time")
   * sentinels are translated to `scheduleType` while clients on a previous
   * release remain deployed, and rejected once that translation is retired —
   * send `scheduleType: PRN` or `ONCE` instead. `SCHEDULED` requires a positive
   * value; `ONCE`/`CONTINUOUS` require null. On an update, omitting this field
   * keeps the stored frequency.
   */
  frequency?: InputMaybe<Scalars['Int']['input']>;
  inactiveIntervals?: InputMaybe<Array<InputMaybe<TreatmentTimeIntervalInput>>>;
  instructions?: InputMaybe<Scalars['String']['input']>;
  isBillable?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Decimal']['input']>;
  /** How the row is scheduled. Omitting it on create stores `SCHEDULED`. */
  scheduleType?: InputMaybe<ScheduleType>;
  start?: InputMaybe<Scalars['DateTime']['input']>;
  totalDose?: InputMaybe<Scalars['Decimal']['input']>;
  type?: InputMaybe<TreatmentSheetType>;
  units?: InputMaybe<TreatmentSheetUnits>;
};

/** A custom vital */
export type CustomVital = {
  __typename?: 'CustomVital';
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type CustomVitalInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type DailyStockTransferReportItem = {
  __typename?: 'DailyStockTransferReportItem';
  expirationDate?: Maybe<Scalars['Date']['output']>;
  fromStockLocationId?: Maybe<Scalars['ID']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  insertedAt?: Maybe<Scalars['NaiveDateTime']['output']>;
  lotNumber?: Maybe<Scalars['String']['output']>;
  orderDate?: Maybe<Scalars['DateTime']['output']>;
  physicalLocation?: Maybe<Scalars['String']['output']>;
  productId?: Maybe<Scalars['ID']['output']>;
  productName?: Maybe<Scalars['String']['output']>;
  receivedQuantity?: Maybe<Scalars['Decimal']['output']>;
  requestedQuantity?: Maybe<Scalars['Decimal']['output']>;
  requesterName?: Maybe<Scalars['String']['output']>;
  toStockLocationId?: Maybe<Scalars['ID']['output']>;
  transferDate?: Maybe<Scalars['DateTime']['output']>;
  transferRequestId?: Maybe<Scalars['ID']['output']>;
  transferTo?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['NaiveDateTime']['output']>;
};

export type Dashboard = {
  __typename?: 'Dashboard';
  encounters?: Maybe<Array<Maybe<Encounter>>>;
};


export type DashboardEncountersArgs = {
  additionalProviderOnly?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  locationId?: InputMaybe<Scalars['ID']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  viewerOnly?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DatasyncLog = {
  __typename?: 'DatasyncLog';
  completed?: Maybe<Scalars['Boolean']['output']>;
  csvRequest?: Maybe<Scalars['Boolean']['output']>;
  downloadUrl?: Maybe<Scalars['String']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  insertedAt?: Maybe<Scalars['NaiveDateTime']['output']>;
  practiceId?: Maybe<Scalars['String']['output']>;
  recordsSynced?: Maybe<Array<Maybe<DatasyncRecords>>>;
  status?: Maybe<Scalars['String']['output']>;
  syncedAt?: Maybe<Scalars['DateTime']['output']>;
  table?: Maybe<Scalars['String']['output']>;
};

export type DatasyncRecords = {
  __typename?: 'DatasyncRecords';
  description?: Maybe<Scalars['String']['output']>;
  module?: Maybe<Scalars['String']['output']>;
  records?: Maybe<Scalars['Int']['output']>;
};

export type DateCount = {
  __typename?: 'DateCount';
  count?: Maybe<Scalars['Int']['output']>;
  date?: Maybe<Scalars['String']['output']>;
};

export type Datum = {
  type?: Maybe<Scalars['String']['output']>;
};

export enum DayOfWeek {
  /** Friday */
  Friday = 'FRIDAY',
  /** Monday */
  Monday = 'MONDAY',
  /** Saturday */
  Saturday = 'SATURDAY',
  /** Sunday */
  Sunday = 'SUNDAY',
  /** Thursday */
  Thursday = 'THURSDAY',
  /** Tuesday */
  Tuesday = 'TUESDAY',
  /** Wednesday */
  Wednesday = 'WEDNESDAY'
}

export type DeceasedPatientItem = {
  __typename?: 'DeceasedPatientItem';
  balance?: Maybe<Scalars['Decimal']['output']>;
  clientCredit?: Maybe<Scalars['Decimal']['output']>;
  clientId?: Maybe<Scalars['ID']['output']>;
  clientName?: Maybe<Scalars['String']['output']>;
  clientPhoneNumber?: Maybe<Scalars['String']['output']>;
  deceasedDate?: Maybe<Scalars['Date']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  patientId?: Maybe<Scalars['ID']['output']>;
  patientName?: Maybe<Scalars['String']['output']>;
  species?: Maybe<Scalars['String']['output']>;
};

export type DeceasedPatientItemConnection = {
  __typename?: 'DeceasedPatientItemConnection';
  edges?: Maybe<Array<Maybe<DeceasedPatientItemEdge>>>;
  pageInfo: PageInfo;
};

export type DeceasedPatientItemEdge = {
  __typename?: 'DeceasedPatientItemEdge';
  cursor?: Maybe<Scalars['String']['output']>;
  node?: Maybe<DeceasedPatientItem>;
};

export type DeclineReason = {
  __typename?: 'DeclineReason';
  id?: Maybe<Scalars['ID']['output']>;
  isActive?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type DeclineReasonInput = {
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type DeletionLog = {
  __typename?: 'DeletionLog';
  errorMessage?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  module?: Maybe<Scalars['String']['output']>;
  recordsDeleted?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type Department = {
  __typename?: 'Department';
  appointmentStatuses?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  appointmentTypeIds?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  color?: Maybe<Scalars['String']['output']>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  displayOnFlow?: Maybe<Scalars['Boolean']['output']>;
  displayOnOrder?: Maybe<Scalars['Boolean']['output']>;
  displayOnSchedule?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  isSurgery?: Maybe<Scalars['Boolean']['output']>;
  locationId?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  numberOfDepartment?: Maybe<Scalars['Int']['output']>;
  orgDepartmentId?: Maybe<Scalars['ID']['output']>;
  position?: Maybe<Scalars['Int']['output']>;
  providers?: Maybe<Array<Maybe<Provider>>>;
  reducesInventoryFromDefaultStockLocation?: Maybe<Scalars['Boolean']['output']>;
};

export type DepartmentInput = {
  appointmentStatuses?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  appointmentTypeIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  color?: InputMaybe<Scalars['String']['input']>;
  displayOnFlow?: InputMaybe<Scalars['Boolean']['input']>;
  displayOnOrder?: InputMaybe<Scalars['Boolean']['input']>;
  displayOnSchedule?: InputMaybe<Scalars['Boolean']['input']>;
  isSurgery?: InputMaybe<Scalars['Boolean']['input']>;
  locationId?: InputMaybe<Scalars['ID']['input']>;
  orgDepartmentId?: InputMaybe<Scalars['ID']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
  providerIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  reducesInventoryFromDefaultStockLocation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DetailedCreditItem = {
  __typename?: 'DetailedCreditItem';
  clientId?: Maybe<Scalars['ID']['output']>;
  clientName?: Maybe<Scalars['String']['output']>;
  date?: Maybe<Scalars['String']['output']>;
  datetime?: Maybe<Scalars['String']['output']>;
  hasVoidedId?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  locationId?: Maybe<Scalars['ID']['output']>;
  nonRevenue?: Maybe<Scalars['Boolean']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  orderId?: Maybe<Scalars['ID']['output']>;
  orderItemId?: Maybe<Scalars['ID']['output']>;
  pencilIcon?: Maybe<Scalars['Boolean']['output']>;
  productId?: Maybe<Scalars['ID']['output']>;
  productName?: Maybe<Scalars['String']['output']>;
  revenueCenter?: Maybe<Scalars['String']['output']>;
  subtotalCents?: Maybe<Scalars['Int']['output']>;
  totalAfterTaxCents?: Maybe<Scalars['Int']['output']>;
  totalBeforeTaxCents?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  voidedAt?: Maybe<Scalars['String']['output']>;
  voidedById?: Maybe<Scalars['ID']['output']>;
};

export type DetailedCreditItemConnection = {
  __typename?: 'DetailedCreditItemConnection';
  edges?: Maybe<Array<Maybe<DetailedCreditItemEdge>>>;
  pageInfo: PageInfo;
};

export type DetailedCreditItemEdge = {
  __typename?: 'DetailedCreditItemEdge';
  cursor?: Maybe<Scalars['String']['output']>;
  node?: Maybe<DetailedCreditItem>;
};

export type DetailedSalesRevenueItem = {
  __typename?: 'DetailedSalesRevenueItem';
  clientId?: Maybe<Scalars['ID']['output']>;
  clientName?: Maybe<Scalars['String']['output']>;
  declined?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  invoicedAtDate?: Maybe<Scalars['String']['output']>;
  locationId?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  nonRevenue?: Maybe<Scalars['Boolean']['output']>;
  notRendered?: Maybe<Scalars['Boolean']['output']>;
  orderId?: Maybe<Scalars['ID']['output']>;
  posted?: Maybe<Scalars['Boolean']['output']>;
  productId?: Maybe<Scalars['ID']['output']>;
  revenueCenter?: Maybe<Scalars['String']['output']>;
  subtotalCents?: Maybe<Scalars['Int']['output']>;
  totalAfterTaxCents?: Maybe<Scalars['Int']['output']>;
  totalBeforeTaxCents?: Maybe<Scalars['Int']['output']>;
  uncollectible?: Maybe<Scalars['Boolean']['output']>;
};

export type DetailedSalesRevenueItemConnection = {
  __typename?: 'DetailedSalesRevenueItemConnection';
  edges?: Maybe<Array<Maybe<DetailedSalesRevenueItemEdge>>>;
  pageInfo: PageInfo;
};

export type DetailedSalesRevenueItemEdge = {
  __typename?: 'DetailedSalesRevenueItemEdge';
  cursor?: Maybe<Scalars['String']['output']>;
  node?: Maybe<DetailedSalesRevenueItem>;
};

/** A diagnosis code */
export type Diagnosis = {
  __typename?: 'Diagnosis';
  id?: Maybe<Scalars['ID']['output']>;
  ontology?: Maybe<Scalars['String']['output']>;
  snomedConceptId?: Maybe<Scalars['String']['output']>;
  snomedModuleId?: Maybe<Scalars['String']['output']>;
  term?: Maybe<Scalars['String']['output']>;
};

export type Diagnostic = {
  __typename?: 'Diagnostic';
  declineReason?: Maybe<DeclineReason>;
  declined?: Maybe<Scalars['Boolean']['output']>;
  encounter?: Maybe<Encounter>;
  id?: Maybe<Scalars['ID']['output']>;
  insertedAt?: Maybe<Scalars['NaiveDateTime']['output']>;
  internal?: Maybe<Scalars['Boolean']['output']>;
  isIssuedViaCubex?: Maybe<Scalars['Boolean']['output']>;
  /** Returns the clinical pathology label PDF as a base64-encoded string */
  labelPdf?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  packageItem?: Maybe<ProductPackageItem>;
  product?: Maybe<Product>;
  productId?: Maybe<Scalars['ID']['output']>;
  provider?: Maybe<Provider>;
  providerId?: Maybe<Scalars['ID']['output']>;
  quantity?: Maybe<Scalars['Decimal']['output']>;
  results?: Maybe<Scalars['JSON']['output']>;
  status?: Maybe<DiagnosticStatus>;
  value?: Maybe<Scalars['String']['output']>;
  /** The amount wasted from Cubex */
  wasteQuantity?: Maybe<Scalars['Decimal']['output']>;
};


export type DiagnosticLabelPdfArgs = {
  collectedAt?: InputMaybe<Scalars['DateTime']['input']>;
  locationId: Scalars['ID']['input'];
};

export type DiagnosticConnection = {
  __typename?: 'DiagnosticConnection';
  edges?: Maybe<Array<Maybe<DiagnosticEdge>>>;
  pageInfo: PageInfo;
};

export type DiagnosticEdge = {
  __typename?: 'DiagnosticEdge';
  cursor?: Maybe<Scalars['String']['output']>;
  node?: Maybe<Diagnostic>;
};

export type DiagnosticInput = {
  declineReasonId?: InputMaybe<Scalars['ID']['input']>;
  declined?: InputMaybe<Scalars['Boolean']['input']>;
  encounterId?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  internal?: InputMaybe<Scalars['Boolean']['input']>;
  locationId?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  patientId?: InputMaybe<Scalars['ID']['input']>;
  productId?: InputMaybe<Scalars['ID']['input']>;
  providerId?: InputMaybe<Scalars['ID']['input']>;
  quantity?: InputMaybe<Scalars['Decimal']['input']>;
  results?: InputMaybe<Scalars['JSON']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export enum DiagnosticStatus {
  Active = 'ACTIVE',
  /** Indicates that a diagnostic order from a Cubex cabinet was declined. Should only be used when the Cubex Two-Way integration is enabled. */
  ApprovalDeclined = 'APPROVAL_DECLINED',
  /** Indicates a diagnostic ordered from a Cubex cabinet that was deleted. Should only be used when the Cubex Two-Way integration is enabled. */
  Deleted = 'DELETED',
  /** Indicates a diagnostic returned via Encounter which does not have statuses */
  Null = 'NULL',
  /** Indicates a diagnostic ordered from a Cubex cabinet that requires approval. Should only be used when the Cubex Two-Way integration is enabled. */
  PendingApproval = 'PENDING_APPROVAL',
  /** Indicates a diagnostic returned via a Cubex cabinet. Should only be used when the Cubex Two-Way integration is enabled. */
  Returned = 'RETURNED'
}

export type DialpadOffice = {
  __typename?: 'DialpadOffice';
  officeId?: Maybe<Scalars['String']['output']>;
  officeName?: Maybe<Scalars['String']['output']>;
};

export type DiscountReason = {
  __typename?: 'DiscountReason';
  id?: Maybe<Scalars['ID']['output']>;
  isActive?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type DiscountReasonInput = {
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export enum DiscountType {
  Fixed = 'FIXED',
  Flat = 'FLAT',
  Off = 'OFF',
  Percent = 'PERCENT'
}

export type DosageCalculationResult = {
  __typename?: 'DosageCalculationResult';
  calculatedAmount?: Maybe<Scalars['PlainDecimal']['output']>;
  dose?: Maybe<Scalars['PlainDecimal']['output']>;
  doseRangeStatus?: Maybe<DoseRangeStatus>;
  patientWeightKg?: Maybe<Scalars['PlainDecimal']['output']>;
  totalDose?: Maybe<Scalars['PlainDecimal']['output']>;
};

export type DosageConfigInput = {
  drugStrength: Scalars['Decimal']['input'];
  speciesDosageConfigs?: InputMaybe<Array<InputMaybe<SpeciesDosageConfigInput>>>;
  unit: Scalars['String']['input'];
};

export enum DosageInputType {
  CalculatedAmount = 'CALCULATED_AMOUNT',
  Dose = 'DOSE',
  TotalDose = 'TOTAL_DOSE'
}

export enum DosageTreatmentType {
  Cri = 'CRI',
  Medication = 'MEDICATION'
}

export enum DoseRangeStatus {
  Above = 'ABOVE',
  Below = 'BELOW',
  Within = 'WITHIN'
}

export enum DoubleBookingConstraint {
  Overlapping = 'OVERLAPPING',
  SameSlot = 'SAME_SLOT'
}

export type DropdownDatum = Datum & {
  __typename?: 'DropdownDatum';
  full?: Maybe<Scalars['Truthy']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  options?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  required?: Maybe<Scalars['Truthy']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type ElectronicSignature = {
  __typename?: 'ElectronicSignature';
  id?: Maybe<Scalars['ID']['output']>;
  signature?: Maybe<Scalars['String']['output']>;
};

/** This is the delivery status of the email. This infomation is obtained via SendGrid. */
export type EmailStatus = {
  __typename?: 'EmailStatus';
  email?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type EmailTemplate = {
  __typename?: 'EmailTemplate';
  htmlTemplate?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  updatedAt?: Maybe<Scalars['NaiveDateTime']['output']>;
};

export type EmailTemplateInput = {
  htmlTemplate?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

/** A clinical encounter */
export type Encounter = {
  __typename?: 'Encounter';
  additionalProviders?: Maybe<Array<Maybe<Provider>>>;
  appointment?: Maybe<Appointment>;
  careTeamMembers?: Maybe<Array<Maybe<EncounterCareTeamMember>>>;
  category?: Maybe<Scalars['String']['output']>;
  /** User who started encounter */
  checkedInBy?: Maybe<Provider>;
  clientConsents?: Maybe<Array<Maybe<ClientConsent>>>;
  /** The department this encounter belongs to */
  department?: Maybe<Department>;
  diagnostics?: Maybe<Array<Maybe<Diagnostic>>>;
  encounterProducts?: Maybe<Array<Maybe<EncounterProduct>>>;
  encounterType?: Maybe<EncounterType>;
  encounterVersions?: Maybe<Array<Maybe<EncounterVersion>>>;
  estimates?: Maybe<Array<Maybe<Estimate>>>;
  historicalId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  immunizations?: Maybe<Array<Maybe<Immunization>>>;
  insertedAt?: Maybe<Scalars['NaiveDateTime']['output']>;
  intake?: Maybe<Array<Maybe<Datum>>>;
  labOrders?: Maybe<Array<Maybe<LabOrder>>>;
  labResults?: Maybe<Array<Maybe<LabResult>>>;
  linkedClinicalNotes?: Maybe<Array<Maybe<LinkedClinicalNote>>>;
  linkedEncounters?: Maybe<Array<Maybe<LinkedEncounter>>>;
  location?: Maybe<Location>;
  medications?: Maybe<Array<Maybe<Medication>>>;
  metadata?: Maybe<Scalars['JSON']['output']>;
  /** A user-friendly name for this encounter, concatening its title and date */
  name?: Maybe<Scalars['String']['output']>;
  nextVisitDate?: Maybe<Scalars['Date']['output']>;
  nextVisitReason?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Order>;
  org?: Maybe<Org>;
  patient?: Maybe<Patient>;
  patientComplications?: Maybe<Array<Maybe<PatientComplication>>>;
  patientDocuments?: Maybe<Array<Maybe<PatientDocument>>>;
  /** Ward and kennel linked to this encounter, including after the encounter is signed. Null if no placement was recorded for this encounter. For where the patient is now, use Patient.lastKnownLocation. */
  patientLocation?: Maybe<PatientLocation>;
  patientLocations?: Maybe<Array<Maybe<PatientLocation>>>;
  problems?: Maybe<Array<Maybe<Problem>>>;
  productSuggestions?: Maybe<Array<Maybe<ProductSuggestion>>>;
  /** Attending/signing provider */
  provider?: Maybe<Provider>;
  requiredSectionsNotFilledOut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** User who scribed the encounter */
  scribedBy?: Maybe<Provider>;
  sections?: Maybe<Array<Maybe<EncounterSection>>>;
  sectionsJson?: Maybe<Scalars['String']['output']>;
  sharedAt?: Maybe<Scalars['NaiveDateTime']['output']>;
  signed?: Maybe<Scalars['Boolean']['output']>;
  signedDatetime?: Maybe<Scalars['DateTime']['output']>;
  signer?: Maybe<Provider>;
  start?: Maybe<Scalars['DateTime']['output']>;
  surveyLinkSent?: Maybe<Scalars['Boolean']['output']>;
  tasks?: Maybe<Array<Maybe<Task>>>;
  /** Technician */
  technician?: Maybe<Provider>;
  title?: Maybe<Scalars['String']['output']>;
  treatments?: Maybe<Array<Maybe<Treatment>>>;
  updatedAt?: Maybe<Scalars['NaiveDateTime']['output']>;
  visit?: Maybe<Visit>;
  visitType?: Maybe<VisitType>;
  vitals?: Maybe<Vitals>;
};


/** A clinical encounter */
export type EncounterDiagnosticsArgs = {
  hasProduct?: InputMaybe<Scalars['Boolean']['input']>;
  undeclined?: InputMaybe<Scalars['Boolean']['input']>;
};


/** A clinical encounter */
export type EncounterEncounterProductsArgs = {
  hasProduct?: InputMaybe<Scalars['Boolean']['input']>;
  undeclined?: InputMaybe<Scalars['Boolean']['input']>;
};


/** A clinical encounter */
export type EncounterImmunizationsArgs = {
  hasProduct?: InputMaybe<Scalars['Boolean']['input']>;
  notHistorical?: InputMaybe<Scalars['Boolean']['input']>;
  undeclined?: InputMaybe<Scalars['Boolean']['input']>;
};


/** A clinical encounter */
export type EncounterMedicationsArgs = {
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  hasProduct?: InputMaybe<Scalars['Boolean']['input']>;
  includeFullyWasted?: InputMaybe<Scalars['Boolean']['input']>;
  notHistorical?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<MedicationStatus>;
  undeclined?: InputMaybe<Scalars['Boolean']['input']>;
};


/** A clinical encounter */
export type EncounterTreatmentsArgs = {
  hasProduct?: InputMaybe<Scalars['Boolean']['input']>;
  undeclined?: InputMaybe<Scalars['Boolean']['input']>;
};

/** An encounter care team member association */
export type EncounterCareTeamMember = {
  __typename?: 'EncounterCareTeamMember';
  careTeamRoleId: Scalars['ID']['output'];
  encounter?: Maybe<Encounter>;
  encounterId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  orgId: Scalars['ID']['output'];
  providerId: Scalars['ID']['output'];
};

export type EncounterCareTeamMemberInput = {
  careTeamRoleId: Scalars['ID']['input'];
  providerId: Scalars['ID']['input'];
};

export type EncounterConnection = {
  __typename?: 'EncounterConnection';
  edges?: Maybe<Array<Maybe<EncounterEdge>>>;
  pageInfo: PageInfo;
};

export type EncounterEdge = {
  __typename?: 'EncounterEdge';
  cursor?: Maybe<Scalars['String']['output']>;
  node?: Maybe<Encounter>;
};

export type EncounterFilters = {
  additionalProviderOnly?: InputMaybe<Scalars['Boolean']['input']>;
  clientId?: InputMaybe<Scalars['ID']['input']>;
  historicalId?: InputMaybe<Scalars['String']['input']>;
  locationId?: InputMaybe<Scalars['ID']['input']>;
  patientId?: InputMaybe<Scalars['ID']['input']>;
  providerId?: InputMaybe<Scalars['ID']['input']>;
  signed?: InputMaybe<Scalars['Boolean']['input']>;
  startAfter?: InputMaybe<Scalars['NaiveDateTime']['input']>;
  startBefore?: InputMaybe<Scalars['NaiveDateTime']['input']>;
  updatedAtEnd?: InputMaybe<Scalars['NaiveDateTime']['input']>;
  updatedAtStart?: InputMaybe<Scalars['NaiveDateTime']['input']>;
  viewerOnly?: InputMaybe<Scalars['Boolean']['input']>;
};

export type EncounterInput = {
  additionalProviderIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  appointmentId?: InputMaybe<Scalars['ID']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  checkedInById?: InputMaybe<Scalars['ID']['input']>;
  departmentId?: InputMaybe<Scalars['ID']['input']>;
  historicalId?: InputMaybe<Scalars['String']['input']>;
  locationId?: InputMaybe<Scalars['ID']['input']>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  nextVisitDate?: InputMaybe<Scalars['Date']['input']>;
  nextVisitReason?: InputMaybe<Scalars['String']['input']>;
  orderId?: InputMaybe<Scalars['ID']['input']>;
  patientLocation?: InputMaybe<PatientLocationInput>;
  providerId?: InputMaybe<Scalars['ID']['input']>;
  scribedById?: InputMaybe<Scalars['ID']['input']>;
  sections?: InputMaybe<Array<InputMaybe<EncounterSectionInput>>>;
  signed?: InputMaybe<Scalars['Boolean']['input']>;
  start?: InputMaybe<Scalars['DateTime']['input']>;
  technicianId?: InputMaybe<Scalars['ID']['input']>;
  visitId?: InputMaybe<Scalars['ID']['input']>;
  visitType?: InputMaybe<VisitType>;
  vitals?: InputMaybe<VitalsInput>;
};

export type EncounterOrderBy = {
  id?: InputMaybe<OrderByDirection>;
  insertedAt?: InputMaybe<OrderByDirection>;
  start?: InputMaybe<OrderByDirection>;
  updatedAt?: InputMaybe<OrderByDirection>;
};

export enum EncounterPdfType {
  /** After Visit Summary or known as Discharge Summary */
  Avs = 'AVS',
  /** Full Summary */
  Encounter = 'ENCOUNTER'
}

export type EncounterProduct = {
  __typename?: 'EncounterProduct';
  declineReason?: Maybe<DeclineReason>;
  declined?: Maybe<Scalars['Boolean']['output']>;
  encounter?: Maybe<Encounter>;
  id?: Maybe<Scalars['ID']['output']>;
  insertedAt?: Maybe<Scalars['NaiveDateTime']['output']>;
  isIssuedViaCubex?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  packageItem?: Maybe<ProductPackageItem>;
  product?: Maybe<Product>;
  provider?: Maybe<Provider>;
  quantity?: Maybe<Scalars['Decimal']['output']>;
  status?: Maybe<EncounterProductStatus>;
  /** The amount wasted from Cubex */
  wasteQuantity?: Maybe<Scalars['Decimal']['output']>;
};

export type EncounterProductConnection = {
  __typename?: 'EncounterProductConnection';
  edges?: Maybe<Array<Maybe<EncounterProductEdge>>>;
  pageInfo: PageInfo;
};

export type EncounterProductEdge = {
  __typename?: 'EncounterProductEdge';
  cursor?: Maybe<Scalars['String']['output']>;
  node?: Maybe<EncounterProduct>;
};

export type EncounterProductInput = {
  declineReasonId?: InputMaybe<Scalars['ID']['input']>;
  declined?: InputMaybe<Scalars['Boolean']['input']>;
  encounterId?: InputMaybe<Scalars['ID']['input']>;
  locationId?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  patientId?: InputMaybe<Scalars['ID']['input']>;
  productId?: InputMaybe<Scalars['ID']['input']>;
  providerId?: InputMaybe<Scalars['ID']['input']>;
  quantity?: InputMaybe<Scalars['Decimal']['input']>;
};

export enum EncounterProductStatus {
  Active = 'ACTIVE',
  /** Indicates that an encounter product order from a Cubex cabinet was declined. Should only be used when the Cubex Two-Way integration is enabled. */
  ApprovalDeclined = 'APPROVAL_DECLINED',
  /** Indicates an encounter product ordered from a Cubex cabinet that was deleted. Should only be used when the Cubex Two-Way integration is enabled. */
  Deleted = 'DELETED',
  /** Indicates a encounter product returned via Encounter which does not have statuses */
  Null = 'NULL',
  /** Indicates an encounter product ordered from a Cubex cabinet that requires approval. Should only be used when the Cubex Two-Way integration is enabled. */
  PendingApproval = 'PENDING_APPROVAL',
  /** Indicates an encounter product returned via a Cubex cabinet. Should only be used when the Cubex Two-Way integration is enabled. */
  Returned = 'RETURNED'
}

export type EncounterSection = {
  __typename?: 'EncounterSection';
  addable?: Maybe<Scalars['Boolean']['output']>;
  aiInstructions?: Maybe<Scalars['String']['output']>;
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  completedBy?: Maybe<Provider>;
  completedById?: Maybe<Scalars['ID']['output']>;
  data?: Maybe<Array<Maybe<Datum>>>;
  educable?: Maybe<Scalars['Boolean']['output']>;
  encounter?: Maybe<Encounter>;
  immunable?: Maybe<Scalars['Boolean']['output']>;
  isAttachments?: Maybe<Scalars['Boolean']['output']>;
  isComplications?: Maybe<Scalars['Boolean']['output']>;
  isConsents?: Maybe<Scalars['Boolean']['output']>;
  isDiagnostics?: Maybe<Scalars['Boolean']['output']>;
  isDischarge?: Maybe<Scalars['Boolean']['output']>;
  isEmbedded?: Maybe<Scalars['Boolean']['output']>;
  isFollowup?: Maybe<Scalars['Boolean']['output']>;
  isImmunizations?: Maybe<Scalars['Boolean']['output']>;
  isIntake?: Maybe<Scalars['Boolean']['output']>;
  isLinkedEncounters?: Maybe<Scalars['Boolean']['output']>;
  isMedications?: Maybe<Scalars['Boolean']['output']>;
  isMonitoring?: Maybe<Scalars['Boolean']['output']>;
  isOrders?: Maybe<Scalars['Boolean']['output']>;
  isPrivate?: Maybe<Scalars['Boolean']['output']>;
  isProblems?: Maybe<Scalars['Boolean']['output']>;
  isRequired?: Maybe<Scalars['Boolean']['output']>;
  labable?: Maybe<Scalars['Boolean']['output']>;
  lastEditedAt?: Maybe<Scalars['DateTime']['output']>;
  lastEditedById?: Maybe<Scalars['ID']['output']>;
  lastEditedBySessionId?: Maybe<Scalars['String']['output']>;
  medicable?: Maybe<Scalars['Boolean']['output']>;
  metadata?: Maybe<Scalars['JSON']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  onReferral?: Maybe<Scalars['Boolean']['output']>;
  showCompletedBy?: Maybe<Scalars['Boolean']['output']>;
  treatable?: Maybe<Scalars['Boolean']['output']>;
  vitals?: Maybe<Scalars['Boolean']['output']>;
};

export type EncounterSectionDatum = {
  __typename?: 'EncounterSectionDatum';
  encounter?: Maybe<Encounter>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type EncounterSectionDatumReplaceInput = {
  datum: Scalars['JSON']['input'];
  datumIdx: Scalars['Int']['input'];
  sectionIdx: Scalars['Int']['input'];
};

export type EncounterSectionInput = {
  addable?: InputMaybe<Scalars['Boolean']['input']>;
  aiInstructions?: InputMaybe<Scalars['String']['input']>;
  data?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  educable?: InputMaybe<Scalars['Boolean']['input']>;
  immunable?: InputMaybe<Scalars['Boolean']['input']>;
  isAttachments?: InputMaybe<Scalars['Boolean']['input']>;
  isComplications?: InputMaybe<Scalars['Boolean']['input']>;
  isConsents?: InputMaybe<Scalars['Boolean']['input']>;
  isDiagnostics?: InputMaybe<Scalars['Boolean']['input']>;
  isDischarge?: InputMaybe<Scalars['Boolean']['input']>;
  isEmbedded?: InputMaybe<Scalars['Boolean']['input']>;
  isFollowup?: InputMaybe<Scalars['Boolean']['input']>;
  isImmunizations?: InputMaybe<Scalars['Boolean']['input']>;
  isIntake?: InputMaybe<Scalars['Boolean']['input']>;
  isLinkedEncounters?: InputMaybe<Scalars['Boolean']['input']>;
  isMedications?: InputMaybe<Scalars['Boolean']['input']>;
  isMonitoring?: InputMaybe<Scalars['Boolean']['input']>;
  isOrders?: InputMaybe<Scalars['Boolean']['input']>;
  isPrivate?: InputMaybe<Scalars['Boolean']['input']>;
  isProblems?: InputMaybe<Scalars['Boolean']['input']>;
  isRequired?: InputMaybe<Scalars['Boolean']['input']>;
  labable?: InputMaybe<Scalars['Boolean']['input']>;
  medicable?: InputMaybe<Scalars['Boolean']['input']>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  onReferral?: InputMaybe<Scalars['Boolean']['input']>;
  showCompletedBy?: InputMaybe<Scalars['Boolean']['input']>;
  treatable?: InputMaybe<Scalars['Boolean']['input']>;
  vitals?: InputMaybe<Scalars['Boolean']['input']>;
};

export type EncounterSectionLock = {
  __typename?: 'EncounterSectionLock';
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  completedById?: Maybe<Scalars['ID']['output']>;
  completedByName?: Maybe<Scalars['String']['output']>;
  data?: Maybe<Array<Maybe<Datum>>>;
  encounterId?: Maybe<Scalars['ID']['output']>;
  lastEditedAt?: Maybe<Scalars['DateTime']['output']>;
  lastEditedById?: Maybe<Scalars['ID']['output']>;
  lastEditedBySessionId?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  providerId?: Maybe<Scalars['ID']['output']>;
  sectionIdx?: Maybe<Scalars['Int']['output']>;
  sessionId?: Maybe<Scalars['String']['output']>;
};

export enum EncounterSummaryDocumentType {
  /** Discharge Instructions */
  DischargeInstructions = 'DISCHARGE_INSTRUCTIONS',
  /** Encounter Summary */
  EncounterSummary = 'ENCOUNTER_SUMMARY',
  /** Referral Letter */
  ReferralLetter = 'REFERRAL_LETTER'
}

export enum EncounterTemplateCategory {
  Consult = 'CONSULT',
  Discharge = 'DISCHARGE',
  Exam = 'EXAM',
  Surgery = 'SURGERY'
}

export type EncounterType = {
  __typename?: 'EncounterType';
  category?: Maybe<EncounterTemplateCategory>;
  default?: Maybe<Scalars['Boolean']['output']>;
  defaultExtras?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  enabledLocations?: Maybe<Array<Maybe<Location>>>;
  id?: Maybe<Scalars['String']['output']>;
  intake?: Maybe<Array<Maybe<Datum>>>;
  isDisabled?: Maybe<Scalars['Boolean']['output']>;
  isEmbeddable?: Maybe<Scalars['Boolean']['output']>;
  isSurgery?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  private?: Maybe<Scalars['Boolean']['output']>;
  sectionOverrides?: Maybe<Array<Maybe<EncounterTypeSectionOverride>>>;
  sections?: Maybe<Array<Maybe<EncounterSection>>>;
  sectionsJson?: Maybe<Scalars['JSON']['output']>;
  veterinarianRequired?: Maybe<Scalars['Boolean']['output']>;
};

export type EncounterTypeInput = {
  category?: InputMaybe<EncounterTemplateCategory>;
  default?: InputMaybe<Scalars['Boolean']['input']>;
  defaultExtras?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  enabledLocationIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  isDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  isEmbeddable?: InputMaybe<Scalars['Boolean']['input']>;
  isSurgery?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  private?: InputMaybe<Scalars['Boolean']['input']>;
  sectionsJson?: InputMaybe<Scalars['JSON']['input']>;
  veterinarianRequired?: InputMaybe<Scalars['Boolean']['input']>;
};

export type EncounterTypeSectionOverride = {
  __typename?: 'EncounterTypeSectionOverride';
  aiInstructions?: Maybe<Scalars['String']['output']>;
  encounterTypeId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  providerId: Scalars['ID']['output'];
  sectionName: Scalars['String']['output'];
};

export type EncounterTypeSectionOverrideItemInput = {
  aiInstructions?: InputMaybe<Scalars['String']['input']>;
  sectionName: Scalars['String']['input'];
};

export type EncounterVersion = {
  __typename?: 'EncounterVersion';
  datetime?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  path?: Maybe<Scalars['String']['output']>;
  signer?: Maybe<Provider>;
};

export type EntitiesTag = {
  __typename?: 'EntitiesTag';
  entityId?: Maybe<Scalars['ID']['output']>;
  entityTag?: Maybe<EntityTag>;
  entityTagId?: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
};

export type EntitiesTagInput = {
  entityId: Scalars['ID']['input'];
  entityTagId: Scalars['ID']['input'];
};

export type EntityTag = {
  __typename?: 'EntityTag';
  color?: Maybe<Scalars['String']['output']>;
  entityTagGroupId?: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  insertedAt?: Maybe<Scalars['NaiveDateTime']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  position?: Maybe<Scalars['Int']['output']>;
};

export type EntityTagGroup = {
  __typename?: 'EntityTagGroup';
  color?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  isHidden?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Array<EntityTag>>;
};

export type EntityTagGroupInput = {
  color?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  entityName?: InputMaybe<Scalars['String']['input']>;
  isHidden?: InputMaybe<Scalars['Boolean']['input']>;
  locationId?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type EntityTagInput = {
  color?: InputMaybe<Scalars['String']['input']>;
  entityTagGroupId?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
};

export type EntityValidation = {
  __typename?: 'EntityValidation';
  entity: Scalars['String']['output'];
  field: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  validation: Scalars['String']['output'];
};

export type EntityValidationInput = {
  entity: Scalars['String']['input'];
  field: Scalars['String']['input'];
  validation: Scalars['String']['input'];
};

export type Estimate = {
  __typename?: 'Estimate';
  appliedCoupons?: Maybe<Array<Maybe<Coupon>>>;
  boardRows?: Maybe<Array<Maybe<BoardRow>>>;
  cityTaxRate?: Maybe<Scalars['Decimal']['output']>;
  client?: Maybe<Client>;
  clientConsents?: Maybe<Array<Maybe<ClientConsent>>>;
  closed?: Maybe<Scalars['Boolean']['output']>;
  consentSignature?: Maybe<Scalars['String']['output']>;
  countyTaxRate?: Maybe<Scalars['Decimal']['output']>;
  datetime?: Maybe<Scalars['DateTime']['output']>;
  discount?: Maybe<Scalars['Decimal']['output']>;
  discountType?: Maybe<DiscountType>;
  encounter?: Maybe<Encounter>;
  estimateType?: Maybe<EstimateType>;
  highCityTaxCents?: Maybe<Scalars['Int']['output']>;
  highCountyTaxCents?: Maybe<Scalars['Int']['output']>;
  highOtherTaxCents?: Maybe<Scalars['Int']['output']>;
  highStateTaxCents?: Maybe<Scalars['Int']['output']>;
  highSubtotalCents?: Maybe<Scalars['Int']['output']>;
  highTotal?: Maybe<Scalars['Decimal']['output']>;
  highTotalAfterTaxCents?: Maybe<Scalars['Int']['output']>;
  highTotalDiscountCents?: Maybe<Scalars['Int']['output']>;
  highTotalTaxCents?: Maybe<Scalars['Int']['output']>;
  historicalId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  insertedAt?: Maybe<Scalars['NaiveDateTime']['output']>;
  items?: Maybe<Array<Maybe<EstimateItem>>>;
  location?: Maybe<Location>;
  lowCityTaxCents?: Maybe<Scalars['Int']['output']>;
  lowCountyTaxCents?: Maybe<Scalars['Int']['output']>;
  lowOtherTaxCents?: Maybe<Scalars['Int']['output']>;
  lowStateTaxCents?: Maybe<Scalars['Int']['output']>;
  lowSubtotalCents?: Maybe<Scalars['Int']['output']>;
  lowTotal?: Maybe<Scalars['Decimal']['output']>;
  lowTotalAfterTaxCents?: Maybe<Scalars['Int']['output']>;
  lowTotalDiscountCents?: Maybe<Scalars['Int']['output']>;
  lowTotalTaxCents?: Maybe<Scalars['Int']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Order>;
  ordered?: Maybe<Scalars['Boolean']['output']>;
  otherTaxRate?: Maybe<Scalars['Decimal']['output']>;
  patient?: Maybe<Patient>;
  patients?: Maybe<Array<Maybe<Patient>>>;
  payLink?: Maybe<Scalars['String']['output']>;
  payments?: Maybe<Array<Maybe<Payment>>>;
  provider?: Maybe<Provider>;
  stateTaxRate?: Maybe<Scalars['Decimal']['output']>;
  status?: Maybe<EstimateStatus>;
  strippedCouponNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /**
   * @deprecated This field is deprecated and will only ever return an estimates's `otherTaxRate`.
   * Estimates now have various tax rate fields you may want to read. Please update your queries
   * to pull from `otherTaxRate`, `cityTaxRate`, `stateTaxRate`, and `countyTaxRate`.
   *
   */
  taxRate?: Maybe<Scalars['Decimal']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  totalPaid?: Maybe<Scalars['Decimal']['output']>;
  updatedAt?: Maybe<Scalars['NaiveDateTime']['output']>;
};


export type EstimateItemsArgs = {
  sorted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type EstimateInput = {
  cityTaxRate?: InputMaybe<Scalars['Decimal']['input']>;
  clientId?: InputMaybe<Scalars['ID']['input']>;
  closed?: InputMaybe<Scalars['Boolean']['input']>;
  consentSignature?: InputMaybe<Scalars['String']['input']>;
  countyTaxRate?: InputMaybe<Scalars['Decimal']['input']>;
  datetime?: InputMaybe<Scalars['DateTime']['input']>;
  discount?: InputMaybe<Scalars['Decimal']['input']>;
  discountType?: InputMaybe<DiscountType>;
  encounterId?: InputMaybe<Scalars['ID']['input']>;
  estimateType?: InputMaybe<EstimateType>;
  locationId?: InputMaybe<Scalars['ID']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  ordered?: InputMaybe<Scalars['Boolean']['input']>;
  otherTaxRate?: InputMaybe<Scalars['Decimal']['input']>;
  patientId?: InputMaybe<Scalars['ID']['input']>;
  providerId?: InputMaybe<Scalars['ID']['input']>;
  stateTaxRate?: InputMaybe<Scalars['Decimal']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type EstimateItem = {
  __typename?: 'EstimateItem';
  declineReason?: Maybe<DeclineReason>;
  declined?: Maybe<Scalars['Boolean']['output']>;
  department?: Maybe<Department>;
  discounted?: Maybe<Scalars['Boolean']['output']>;
  dispenseFee?: Maybe<Scalars['Decimal']['output']>;
  estimate?: Maybe<Estimate>;
  hidden?: Maybe<Scalars['Boolean']['output']>;
  highPrice?: Maybe<Scalars['Decimal']['output']>;
  highQuantity?: Maybe<Scalars['Decimal']['output']>;
  highSubtotalCents?: Maybe<Scalars['Int']['output']>;
  highTotal?: Maybe<Scalars['Price']['output']>;
  highTotalBeforeTaxCents?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  inPackage?: Maybe<Scalars['Boolean']['output']>;
  insertedAt?: Maybe<Scalars['NaiveDateTime']['output']>;
  isPackage?: Maybe<Scalars['Boolean']['output']>;
  isSecretlyIncluded?: Maybe<Scalars['Boolean']['output']>;
  /**
   * @deprecated This field is deprecated and will only ever return an estimate item's `is_taxed_other`.
   * EstimateItems now have various tax rate fields you may want to read. Please update your queries
   * to pull from `isTaxedOther`, `isTaxedCity`, `isTaxedState`, and `isTaxedCounty`.
   *
   */
  isTaxed?: Maybe<Scalars['Boolean']['output']>;
  isTaxedCity?: Maybe<Scalars['Boolean']['output']>;
  isTaxedCounty?: Maybe<Scalars['Boolean']['output']>;
  isTaxedOther?: Maybe<Scalars['Boolean']['output']>;
  isTaxedState?: Maybe<Scalars['Boolean']['output']>;
  lineDiscount?: Maybe<Scalars['Decimal']['output']>;
  lineDiscountType?: Maybe<DiscountType>;
  lowPrice?: Maybe<Scalars['Decimal']['output']>;
  lowQuantity?: Maybe<Scalars['Decimal']['output']>;
  lowSubtotalCents?: Maybe<Scalars['Int']['output']>;
  lowTotal?: Maybe<Scalars['Price']['output']>;
  lowTotalBeforeTaxCents?: Maybe<Scalars['Int']['output']>;
  minimumPrice?: Maybe<Scalars['Decimal']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  package?: Maybe<ProductPackage>;
  patient?: Maybe<Patient>;
  percentDiscounted?: Maybe<Scalars['Decimal']['output']>;
  position?: Maybe<Scalars['Int']['output']>;
  priceIncluded?: Maybe<Scalars['Boolean']['output']>;
  product?: Maybe<Product>;
  productId?: Maybe<Scalars['ID']['output']>;
  provider?: Maybe<Provider>;
  sourceEstimateItemId?: Maybe<Scalars['ID']['output']>;
  undeletable?: Maybe<Scalars['Boolean']['output']>;
  unitPrice?: Maybe<Scalars['Decimal']['output']>;
  volumeTiers?: Maybe<Array<Maybe<PriceTier>>>;
};

export type EstimateItemInput = {
  declineReasonId?: InputMaybe<Scalars['ID']['input']>;
  declined?: InputMaybe<Scalars['Boolean']['input']>;
  departmentId?: InputMaybe<Scalars['ID']['input']>;
  discounted?: InputMaybe<Scalars['Boolean']['input']>;
  dispenseFee?: InputMaybe<Scalars['Decimal']['input']>;
  estimateId?: InputMaybe<Scalars['ID']['input']>;
  highQuantity?: InputMaybe<Scalars['Decimal']['input']>;
  inPackage?: InputMaybe<Scalars['Boolean']['input']>;
  isPackage?: InputMaybe<Scalars['Boolean']['input']>;
  isTaxed?: InputMaybe<Scalars['Boolean']['input']>;
  isTaxedCity?: InputMaybe<Scalars['Boolean']['input']>;
  isTaxedCounty?: InputMaybe<Scalars['Boolean']['input']>;
  isTaxedOther?: InputMaybe<Scalars['Boolean']['input']>;
  isTaxedState?: InputMaybe<Scalars['Boolean']['input']>;
  lineDiscount?: InputMaybe<Scalars['Decimal']['input']>;
  lineDiscountReason?: InputMaybe<Scalars['String']['input']>;
  lineDiscountType?: InputMaybe<DiscountType>;
  lowQuantity?: InputMaybe<Scalars['Decimal']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  packageId?: InputMaybe<Scalars['ID']['input']>;
  patientId?: InputMaybe<Scalars['ID']['input']>;
  percentDiscounted?: InputMaybe<Scalars['Decimal']['input']>;
  productId?: InputMaybe<Scalars['ID']['input']>;
  providerId?: InputMaybe<Scalars['ID']['input']>;
  unitPrice?: InputMaybe<Scalars['Decimal']['input']>;
};

export enum EstimateStatus {
  Closed = 'CLOSED',
  Due = 'DUE',
  Open = 'OPEN',
  Paid = 'PAID'
}

export enum EstimateType {
  Oncology = 'ONCOLOGY',
  Standard = 'STANDARD',
  Surgery = 'SURGERY'
}

export type EstimatesTotals = {
  __typename?: 'EstimatesTotals';
  closed?: Maybe<Scalars['Decimal']['output']>;
  closedCount?: Maybe<Scalars['Int']['output']>;
  count?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  invoiced?: Maybe<Scalars['Decimal']['output']>;
  invoicedCount?: Maybe<Scalars['Int']['output']>;
  open?: Maybe<Scalars['Decimal']['output']>;
  openCount?: Maybe<Scalars['Int']['output']>;
};

export type Event = {
  __typename?: 'Event';
  datetime?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  location?: Maybe<Location>;
  metadata?: Maybe<Scalars['JSON']['output']>;
  provider?: Maybe<Provider>;
  type?: Maybe<Scalars['String']['output']>;
};

export type EventConnection = {
  __typename?: 'EventConnection';
  edges?: Maybe<Array<Maybe<EventEdge>>>;
  pageInfo: PageInfo;
};

export type EventEdge = {
  __typename?: 'EventEdge';
  cursor?: Maybe<Scalars['String']['output']>;
  node?: Maybe<Event>;
};

export type EventMetadataFilter = {
  name?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type EventsOrderBy = {
  insertedAt?: InputMaybe<OrderByDirection>;
  type?: InputMaybe<OrderByDirection>;
};

export type ExternalSearchInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  familyName?: InputMaybe<Scalars['String']['input']>;
  givenName?: InputMaybe<Scalars['String']['input']>;
  petName?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
};

export type ExternalSearchResult = {
  __typename?: 'ExternalSearchResult';
  accountCredit?: Maybe<Scalars['Decimal']['output']>;
  accountCreditHistoryCount: Scalars['Int']['output'];
  addresses?: Maybe<Array<Maybe<Address>>>;
  alerts?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  billingEmail?: Maybe<Scalars['String']['output']>;
  billingEmailVerifiedDate?: Maybe<Scalars['NaiveDateTime']['output']>;
  billingGroup?: Maybe<BillingGroup>;
  billingGroupId?: Maybe<Scalars['ID']['output']>;
  billingId?: Maybe<Scalars['String']['output']>;
  billingNotes?: Maybe<Array<Maybe<BillingNote>>>;
  businessName?: Maybe<Scalars['String']['output']>;
  cardconnectExpiry?: Maybe<Scalars['String']['output']>;
  cardconnectToken?: Maybe<Scalars['String']['output']>;
  cardconnectTokenLast4?: Maybe<Scalars['String']['output']>;
  careCreditApplication?: Maybe<ClientCareCreditApplication>;
  clientRdvms?: Maybe<Array<Maybe<ClientRdvm>>>;
  clientReferralSource?: Maybe<ClientReferralSource>;
  clientReferralSourceId?: Maybe<Scalars['ID']['output']>;
  coowners?: Maybe<Array<Maybe<Coowner>>>;
  coowns?: Maybe<Array<Coowner>>;
  creditMemos?: Maybe<Array<Maybe<CreditMemo>>>;
  customFields?: Maybe<Array<Maybe<CustomClientFieldValue>>>;
  customReferralSource?: Maybe<Scalars['String']['output']>;
  dateOfBirth?: Maybe<Scalars['Date']['output']>;
  declineBillingEmail?: Maybe<Scalars['Boolean']['output']>;
  declineEmail?: Maybe<Scalars['Boolean']['output']>;
  declinePhone?: Maybe<Scalars['Boolean']['output']>;
  declineRdvm?: Maybe<Scalars['Boolean']['output']>;
  declineSecondaryEmail?: Maybe<Scalars['Boolean']['output']>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  driversLicenseNumber?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  emailVerifiedDate?: Maybe<Scalars['NaiveDateTime']['output']>;
  emails?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  exemptCareCreditQuickScreen?: Maybe<Scalars['Boolean']['output']>;
  externalCommPreferences?: Maybe<Array<Maybe<ClientExternalCommPreferencesValue>>>;
  familyName?: Maybe<Scalars['String']['output']>;
  givenName?: Maybe<Scalars['String']['output']>;
  historicalId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  identification?: Maybe<Scalars['String']['output']>;
  insertedAt?: Maybe<Scalars['NaiveDateTime']['output']>;
  isActive?: Maybe<Scalars['Boolean']['output']>;
  isBusiness?: Maybe<Scalars['Boolean']['output']>;
  isMerged?: Maybe<Scalars['Boolean']['output']>;
  isNewRdvmNeeded?: Maybe<Scalars['Boolean']['output']>;
  lastSyncedAt?: Maybe<Scalars['NaiveDateTime']['output']>;
  /** The most recent appointment for any of this client's patients */
  lastVisit?: Maybe<Appointment>;
  lifetimeValue: Scalars['Decimal']['output'];
  mergeIdentification?: Maybe<Scalars['String']['output']>;
  /** Returns number of missed (no show) appointments in the last N days */
  missedAppointments: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
  /** The earliest upcoming appointment for any of this client's patients */
  nextVisit?: Maybe<Appointment>;
  notes?: Maybe<Scalars['String']['output']>;
  orgId?: Maybe<Scalars['ID']['output']>;
  patientResults?: Maybe<Array<Maybe<Patient>>>;
  patients?: Maybe<Array<Patient>>;
  paymentCount: Scalars['Int']['output'];
  payments?: Maybe<Array<Maybe<Payment>>>;
  pdf?: Maybe<Scalars['String']['output']>;
  phoneNumbers?: Maybe<Array<Maybe<PhoneNumber>>>;
  preferredPhoneNumber?: Maybe<PhoneNumber>;
  primaryLocation?: Maybe<Location>;
  primaryLocationId?: Maybe<Scalars['ID']['output']>;
  privateNotes?: Maybe<Scalars['String']['output']>;
  pronouns?: Maybe<Pronouns>;
  pronounsOther?: Maybe<Scalars['String']['output']>;
  rdvms: Array<Rdvm>;
  secondaryEmail?: Maybe<Scalars['String']['output']>;
  secondaryEmailVerifiedDate?: Maybe<Scalars['NaiveDateTime']['output']>;
  sentBillingEmailVerificationDate?: Maybe<Scalars['NaiveDateTime']['output']>;
  sentEmailVerificationDate?: Maybe<Scalars['NaiveDateTime']['output']>;
  sentSecondaryEmailVerificationDate?: Maybe<Scalars['NaiveDateTime']['output']>;
  squareCardId?: Maybe<Scalars['String']['output']>;
  stopReminders?: Maybe<Scalars['Boolean']['output']>;
  stripeCustomerId?: Maybe<Scalars['String']['output']>;
  stripeInfo?: Maybe<PaymentSource>;
  tags: Array<ClientTag>;
  taxExempt?: Maybe<Scalars['Boolean']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  trailingYearValue: Scalars['Decimal']['output'];
  updatedAt?: Maybe<Scalars['NaiveDateTime']['output']>;
  verifiedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type ExternalSearchResultAddressesArgs = {
  isPrimary?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ExternalSearchResultCoownersArgs = {
  updatedAtEnd?: InputMaybe<Scalars['NaiveDateTime']['input']>;
  updatedAtStart?: InputMaybe<Scalars['NaiveDateTime']['input']>;
};


export type ExternalSearchResultMissedAppointmentsArgs = {
  numberOfDays?: InputMaybe<Scalars['Int']['input']>;
};


export type ExternalSearchResultPatientsArgs = {
  filters?: InputMaybe<PatientFilters>;
};


export type ExternalSearchResultPaymentCountArgs = {
  methodsToExclude?: InputMaybe<Array<InputMaybe<PaymentMethod>>>;
};


export type ExternalSearchResultPaymentsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<PaymentSort>;
};

export type ExtraField = {
  __typename?: 'ExtraField';
  label?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type ExtraFieldInput = {
  field?: InputMaybe<Scalars['String']['input']>;
  testCode?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export enum Eye {
  Od = 'OD',
  Os = 'OS',
  Ou = 'OU'
}

export type FeatureFlag = {
  __typename?: 'FeatureFlag';
  enabled: Scalars['Boolean']['output'];
  id?: Maybe<Scalars['ID']['output']>;
  name: FeatureFlagEnum;
};

export enum FeatureFlagEnum {
  /** Enable AI Data Dashboard */
  AiDataDashboard = 'AI_DATA_DASHBOARD',
  /** Enable AI Encounter Diagnostics */
  AiEncounterDiagnostics = 'AI_ENCOUNTER_DIAGNOSTICS',
  /** Enable AI Encounter Diagnostics Assistant */
  AiEncounterDiagnosticsAssistant = 'AI_ENCOUNTER_DIAGNOSTICS_ASSISTANT',
  /** Whether to show generated lab trends in the patient summary. */
  AiLabTrends = 'AI_LAB_TRENDS',
  /** Enable AI-suggested orders banner on encounters */
  AiOrderSuggestions = 'AI_ORDER_SUGGESTIONS',
  /** Enable the org-wide AI PDF extraction rules admin page */
  AiOrgPdfExtractionRules = 'AI_ORG_PDF_EXTRACTION_RULES',
  /** Whether to show the new patient summary AI features. */
  AiPatientSummary = 'AI_PATIENT_SUMMARY',
  /** Whether to show the new patient summary AI assistant. */
  AiPatientSummaryAssistant = 'AI_PATIENT_SUMMARY_ASSISTANT',
  /** Whether to show the plain-language overview at the top of the patient summary. */
  AiPatientSummaryOverview = 'AI_PATIENT_SUMMARY_OVERVIEW',
  /** Enable AI PDF Assistant */
  AiPdfAssistant = 'AI_PDF_ASSISTANT',
  /** Enable AI PDF Extraction */
  AiPdfExtraction = 'AI_PDF_EXTRACTION',
  /** Enable AI PDF Summary */
  AiPdfSummary = 'AI_PDF_SUMMARY',
  /** Switches the AI Scribe recorder to the v2 implementation */
  AiRecorderV2 = 'AI_RECORDER_V2',
  /** Enable AI Review Notes V2 */
  AiReviewNotesV2 = 'AI_REVIEW_NOTES_V2',
  /** Enable Admin AI Section Encounter Instructions */
  AiSectionEncounterInstructions = 'AI_SECTION_ENCOUNTER_INSTRUCTIONS',
  /** Enables the changes for reading persisted bill totals introduced by the CA epic. */
  ConsistentAccounting = 'CONSISTENT_ACCOUNTING',
  /** Enables marking a client as a business at creation time */
  ClinicalBusinessAccount = 'ClinicalBusinessAccount',
  /** Enables the new provider dashboard UI */
  ClinicalDashboard = 'ClinicalDashboard',
  /** Kill switch for the new provider dashboard UI. When enabled (globally or per org/location), forces everyone back to the old dashboard and hides the opt-in toggle, without clearing anyone's saved choice. */
  ClinicalDashboardDisabled = 'ClinicalDashboardDisabled',
  /** Enables the Section Audit checkbox feature in Encounters and Encounter Type templates */
  ClinicalEncounterCheckbox = 'ClinicalEncounterCheckbox',
  /** Enables the Clinical Encounter Details feature */
  ClinicalEncounterDetails = 'ClinicalEncounterDetails',
  /** Enables the Field Service Visit Address for Organization Preference */
  ClinicalFieldService = 'ClinicalFieldService',
  /** Show HISA checkbox and HISA ID in the New Patient form */
  ClinicalHisaPatientForm = 'ClinicalHISAPatientForm',
  /** Enables the Linked Appointments section in the New Appointment Modal */
  ClinicalLinkedAppts = 'ClinicalLinkedAppts',
  /** Enables the rewritten Monitoring component with TypeScript and best practices */
  ClinicalMonitoringRewrite = 'ClinicalMonitoringRewrite',
  /** New Appointment Modal for schedule */
  ClinicalNewApptModal = 'ClinicalNewApptModal',
  /** Enables enhanced patient associate controls (primary contact, active associate, share medical records) */
  ClinicalPatientAssociates = 'ClinicalPatientAssociates',
  /** Enables Visit Reasons for Petfolk */
  ClinicalPetfolkVisitReasons = 'ClinicalPetfolkVisitReasons',
  /** Enables the new rDVM display on patient charts with updated brand styles and preferred status support */
  ClinicalRdvm = 'ClinicalRdvm',
  /** Admin can make recurring provider schedules */
  ClinicalRecurringProviderSchedule = 'ClinicalRecurringProviderSchedule',
  /** Show the Registered Name field on the Patient Info page and Create Patient forms */
  ClinicalRegistered = 'ClinicalRegistered',
  /** Enables Travel Zones - org-scoped, color-coded zones that appointments can be assigned to for field/mobile scheduling */
  ClinicalTravelZones = 'ClinicalTravelZones',
  /** Enables the concept of a clinical visit */
  ClinicalVisit = 'ClinicalVisit',
  /** Whether to replace Reporting->Accounts Receivable report with Aged Accounts Receivable report */
  DiAgedAccountsReceivableReport = 'DIAgedAccountsReceivableReport',
  /** Enables the batched Accounts Receivable report generation with breakdown options */
  DiBatchedAr = 'DIBatchedAR',
  /** Enables the census route/pages */
  DiCensus = 'DICensus',
  /** Requires PIN entry for prescribing controlled substances to comply with DEA regulations */
  DiControlledDrugPinRequirement = 'DIControlledDrugPinRequirement',
  /** Disables prescribing medications not in draft, pending, or pending approval status */
  DiDisableDuplicationMedicationPrescription = 'DIDisableDuplicationMedicationPrescription',
  /** Disables Phoenix Presence in encounters and uses timestamp-based section locking instead */
  DiDisablePresenceInEncounters = 'DIDisablePresenceInEncounters',
  /** Enables the new Discounts Report feature */
  DiDiscountsReport = 'DIDiscountsReport',
  /** Enables GraphQL backend for encounter operations (replacing websockets) */
  DiEncountersGraphQlBackend = 'DIEncountersGraphQLBackend',
  /** Enables the Heart and Paw Financial Reports */
  DiHeartAndPawFinancialReports = 'DIHeartAndPawFinancialReports',
  /** Use specific medication labels for MSU */
  DimsuMedicationsLabel = 'DIMSUMedicationsLabel',
  /** Enables the Days Supply field for medication prescriptions */
  DiMedicationDaysSupply = 'DIMedicationDaysSupply',
  /** Enables the new medications order modal independently of the pharmacy whiteboard */
  DiMedicationsOrderModal = 'DIMedicationsOrderModal',
  /** Enables monthly automated AR report generation and email preferences */
  DiMonthlyArReport = 'DIMonthlyArReport',
  /** Enables the Net Balance Due total on the Client Billing page header */
  DiNetClientBalanceDue = 'DINetClientBalanceDue',
  /** Enables the New Billing Groups Statements feature */
  DiNewBillingGroupsStatements = 'DINewBillingGroupsStatements',
  /** Includes open invoices in inventory stock calculations for orgs that need in-stock inventory to reflect unfinalized usage */
  DiOpenInvoicesInventory = 'DIOpenInvoicesInventory',
  /** Enables display of Research ID on patient billing invoices */
  DiOrderResearchId = 'DIOrderResearchId',
  /** Enables pharmacy whiteboard workflow including approval-required medication ordering and approve & send to pharmacy features */
  DiPharmacyWhiteboard = 'DIPharmacyWhiteboard',
  /** Enables the new Request Stock Transfer feature */
  DiRequestStockTransfer = 'DIRequestStockTransfer',
  /** Disables API users access to utilize the API */
  DisableApiUsers = 'DISABLE_API_USERS',
  /** Disables Oban from processing new jobs */
  DisableOban = 'DISABLE_OBAN',
  /** Enables the Stock Locations Management feature */
  DiStockLocationsManagement = 'DIStockLocationsManagement',
  /** Whether to allow data sync export and import functionality */
  DataSyncExportImportData = 'DataSyncExportImportData',
  /** Whether or not we enable access to the Compliance Dashboard */
  EnableComplianceDashboard = 'ENABLE_COMPLIANCE_DASHBOARD',
  /** Whether or not to enable the new email templates feature */
  EnableNewEmailTemplates = 'ENABLE_NEW_EMAIL_TEMPLATES',
  /** Whether to show the NOVABoard and NOVASheets(Treatment Sheets) */
  EnableNova = 'ENABLE_NOVA',
  /** Enables access to new FMR pdf generator */
  FullMedicalRecordPdf = 'FULL_MEDICAL_RECORD_PDF',
  /** Enables the ability to have co-owners link to real clients instead of just a name. */
  LinkedCoowners = 'LINKED_COOWNERS',
  /** Enables the 'To Go Home' checkbox for medication prescriptions */
  MedicationToGoHome = 'MedicationToGoHome',
  /** new integrated workflow board (experimental) */
  NewBoard = 'NEW_BOARD',
  /** New Flow page */
  NewFlow = 'NEW_FLOW',
  /** Whether to use the new pricing calculations or not */
  NewPricing = 'NEW_PRICING',
  /** Enables Stripe's server side terminal integration */
  NewStripeTerminal = 'NEW_STRIPE_TERMINAL',
  /** Enables the filtering view on schedules */
  NewScheduleFiltersView = 'NewScheduleFiltersView',
  /** Enables the NOVABoard transfer filtering functionality */
  NovaBoardTransferFilter = 'NovaBoardTransferFilter',
  /** Enables Dosage Calculator feature */
  NovaCalculator = 'NovaCalculator',
  /** Enables the new day break navigation bar interface */
  NovaDayBreakNavBar = 'NovaDayBreakNavBar',
  /** Enables Nova permissions and access control features */
  NovaPermissions = 'NovaPermissions',
  NovaUniGl = 'NovaUniGL',
  /**
   * Legacy Nova weight flag kept as a no-op for backward compatibility
   * @deprecated Deprecated compatibility flag; do not use in new clients
   */
  NovaWeight = 'NovaWeight',
  /** plumb's workflows */
  Plumbs = 'PLUMBS',
  /** Enables the Bulk User Import feature */
  PlatformBulkUserImport = 'PlatformBulkUserImport',
  /** Enables the Platform Changelogs feature */
  PlatformChangelogs = 'PlatformChangelogs',
  /** Enables the Changelogs admin view */
  PlatformChangelogsWeb = 'PlatformChangelogsWeb',
  /** Enables the Antech V6 integration */
  PlatformIntegrationsAntechV6 = 'PlatformIntegrationsAntechV6',
  /** Enable CareCredit integration */
  PlatformIntegrationsCareCredit = 'PlatformIntegrationsCareCredit',
  /** Enable CareCredit integration BQS */
  PlatformIntegrationsCareCreditBqs = 'PlatformIntegrationsCareCreditBQS',
  /** Enables sending individual items within a package to Cubex when it is added to an encounter */
  PlatformIntegrationsCubexSendEncounterPackages = 'PlatformIntegrationsCubexSendEncounterPackages',
  /** Enables sending eligible items to Cubex when an encounter-linked estimate is converted to an invoice */
  PlatformIntegrationsCubexSendEstimateConversionItems = 'PlatformIntegrationsCubexSendEstimateConversionItems',
  /** Enables the sync to Cubex functionality for eligible items */
  PlatformIntegrationsCubexSync = 'PlatformIntegrationsCubexSync',
  /** Enables the Cubex two-way integration */
  PlatformIntegrationsCubexTwoWay = 'PlatformIntegrationsCubexTwoWay',
  /** Enables functionality for sending a product's parent id instead of the child id to Cubex */
  PlatformIntegrationsCubexUseProductParentIds = 'PlatformIntegrationsCubexUseProductParentIds',
  /** Enables the Fiserv surcharge feature */
  PlatformIntegrationsFiservSurcharge = 'PlatformIntegrationsFiservSurcharge',
  /** Enables the FujiRIS integration */
  PlatformIntegrationsFujiRis = 'PlatformIntegrationsFujiRIS',
  /** Enables the HFD (Healthcare Finance Direct) integration */
  PlatformIntegrationsHfd = 'PlatformIntegrationsHFD',
  /** Applies Vetspire's pricing hierarchy and tax logic to Idexx reference lab orders instead of the raw Idexx unit cost */
  PlatformIntegrationsIdexxPricingHierarchyFix = 'PlatformIntegrationsIdexxPricingHierarchyFix',
  /** Enables the Outlook integration */
  PlatformIntegrationsOutlook = 'PlatformIntegrationsOutlook',
  /** When enabled, shows and allows the Square Integration for orgs */
  PlatformIntegrationsSquare = 'PlatformIntegrationsSquare',
  /** When enabled, shows and allows the Stripe Integration for orgs */
  PlatformIntegrationsStripe = 'PlatformIntegrationsStripe',
  /** Enables the UPenn Lab integration */
  PlatformIntegrationsUPennLab = 'PlatformIntegrationsUPennLab',
  /** Enables the Vertex integration */
  PlatformIntegrationsVertex = 'PlatformIntegrationsVertex',
  /** Enables the Vetcalculator integration */
  PlatformIntegrationsVetcalculator = 'PlatformIntegrationsVetcalculator',
  /** Enable eUnity viewer integration for VitalPacs lab results */
  PlatformIntegrationseUnity = 'PlatformIntegrationseUnity',
  /** Enables the new patient chart lab orders UI */
  PlatformLabOrdersUi = 'PlatformLabOrdersUI',
  /** Kill switch for the new patient chart lab orders UI. When enabled (globally or per org/location), forces everyone back to the legacy UI and hides the opt-in toggle, without clearing anyone's saved choice. */
  PlatformLabOrdersUiDisabled = 'PlatformLabOrdersUIDisabled',
  /** Enables the new patient orders feature */
  PlatformPatientOrders = 'PlatformPatientOrders',
  /** Enables Stripe's server-side Terminal integration for Interac payments */
  PlatformPaymentStripeInterac = 'PlatformPaymentStripeInterac',
  /** Enables recording Stripe Interac refunds processed via SDK */
  PlatformStripeInteracRefundsBySdk = 'PlatformStripeInteracRefundsBySdk',
  /** Use simulated Stripe Terminal reader for testing (true) or real internet reader for production (false) */
  PlatformStripeInteracUseSimulatedReader = 'PlatformStripeInteracUseSimulatedReader',
  /** Whether the organization is in read-only mode */
  ReadOnlyMode = 'READ_ONLY_MODE',
  /** Show accounts receivable on client billing page. */
  ShowClientAccountsReceivable = 'SHOW_CLIENT_ACCOUNTS_RECEIVABLE',
  /** Whether or not to enable the Legacy Email Template link */
  ShowLegacyEmailTemplateLink = 'SHOW_LEGACY_EMAIL_TEMPLATE_LINK',
  /** Enable Multiple Encounter support for AI Scribe, allowing a single scribe session to be associated with multiple encounters for the same patient visit */
  ScribeMultipleEncounters = 'ScribeMultipleEncounters',
  /** Enables AI Scribe */
  ScribeWeb = 'ScribeWeb',
  /** Enables experimental AI Scribe features in the web application */
  ScribeWebBeta = 'ScribeWebBeta',
  /** Enables new encounter table schema with provider/session tracking */
  NewEncounterTables = 'new_encounter_tables'
}

export enum FeeCalculationMethod {
  /** Calculate fees based on aging buckets (30/60/90/121+ days) */
  AgedBuckets = 'AGED_BUCKETS',
  /** Calculate fees based on recurring intervals (every X days) */
  Interval = 'INTERVAL'
}

export type FieldDatum = Datum & {
  __typename?: 'FieldDatum';
  full?: Maybe<Scalars['Truthy']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  required?: Maybe<Scalars['Truthy']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type FieldDatumPart = {
  __typename?: 'FieldDatumPart';
  label?: Maybe<Scalars['String']['output']>;
  required?: Maybe<Scalars['Truthy']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/**
 * An address a field service team travels to in order to see a patient. Maintained on the Patient
 * Information page and used as the source of the visit location dropdown when booking an
 * appointment. Distinct from a client's addresses, which are used for mailing and billing.
 */
export type FieldServiceAddress = {
  __typename?: 'FieldServiceAddress';
  city?: Maybe<Scalars['String']['output']>;
  hasFutureAppointments: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  insertedAt?: Maybe<Scalars['NaiveDateTime']['output']>;
  /** Whether this is the patient's default field service visit address */
  isDefault?: Maybe<Scalars['Boolean']['output']>;
  /** Human readable name for the location, e.g. 'Smith Barn' */
  label?: Maybe<Scalars['String']['output']>;
  /** Free text notes or directions for reaching the location */
  notes?: Maybe<Scalars['String']['output']>;
  patient?: Maybe<Patient>;
  postalCode?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['NaiveDateTime']['output']>;
};

export type FieldServiceAddressInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  /** When true, unsets whichever address is currently the patient's default in the same operation */
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
};

export type File = {
  __typename?: 'File';
  name: Scalars['String']['output'];
};

export type FileResults = {
  __typename?: 'FileResults';
  files: Array<File>;
  nextPageToken?: Maybe<Scalars['String']['output']>;
};

export type Filter = {
  cmp?: InputMaybe<Comparison>;
  field?: InputMaybe<FilterField>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export enum FilterField {
  LocationId = 'LOCATION_ID',
  Name = 'NAME',
  Status = 'STATUS',
  Type = 'TYPE'
}

export type FormDatum = Datum & {
  __typename?: 'FormDatum';
  fields?: Maybe<Array<Maybe<FieldDatumPart>>>;
  full?: Maybe<Scalars['Truthy']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  required?: Maybe<Scalars['Truthy']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type FormulaDatum = Datum & {
  __typename?: 'FormulaDatum';
  a?: Maybe<Scalars['String']['output']>;
  aunit?: Maybe<Scalars['String']['output']>;
  b?: Maybe<Scalars['String']['output']>;
  bunit?: Maybe<Scalars['String']['output']>;
  inline?: Maybe<Scalars['Truthy']['output']>;
  operation?: Maybe<Scalars['String']['output']>;
  required?: Maybe<Scalars['Truthy']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  unit?: Maybe<Scalars['String']['output']>;
};

export type Frequency = {
  __typename?: 'Frequency';
  code: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  label?: Maybe<Scalars['String']['output']>;
  minutes: Scalars['Int']['output'];
  sortOrder?: Maybe<Scalars['Int']['output']>;
};

export type FujirisLabOrderDetail = {
  __typename?: 'FujirisLabOrderDetail';
  history?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  resource?: Maybe<Scalars['String']['output']>;
  scheduleDateTime?: Maybe<Scalars['DateTime']['output']>;
  stat?: Maybe<Scalars['Boolean']['output']>;
  testModifiers?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  testQuantities?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type FulfillmentSource = {
  __typename?: 'FulfillmentSource';
  id: Scalars['ID']['output'];
  isExternal?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type FulfillmentSourceInput = {
  isExternal?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Exam line on a Harvest (UPenn LIS) lab order. */
export type HarvestExamInput = {
  collectionDateTime?: InputMaybe<Scalars['String']['input']>;
  comments?: InputMaybe<Scalars['String']['input']>;
  examCode?: InputMaybe<Scalars['String']['input']>;
  examName?: InputMaybe<Scalars['String']['input']>;
  history?: InputMaybe<Scalars['String']['input']>;
  priority?: InputMaybe<Scalars['String']['input']>;
  specimenReceivedDateTime?: InputMaybe<Scalars['String']['input']>;
};

/** Structured exam result line from Harvest (UPenn LIS) report ingestion. */
export type HarvestExamResultInput = {
  examCode?: InputMaybe<Scalars['String']['input']>;
  interpretation?: InputMaybe<Scalars['String']['input']>;
  observationDateTime?: InputMaybe<Scalars['String']['input']>;
  observationIdentifier?: InputMaybe<Scalars['String']['input']>;
  observationValue?: InputMaybe<Scalars['String']['input']>;
  observationValueType?: InputMaybe<Scalars['String']['input']>;
  referenceRange?: InputMaybe<Scalars['String']['input']>;
  resultStatus?: InputMaybe<Scalars['String']['input']>;
  units?: InputMaybe<Scalars['String']['input']>;
};

export type HarvestLabOrderDetail = {
  __typename?: 'HarvestLabOrderDetail';
  id?: Maybe<Scalars['ID']['output']>;
};

export type HfdApplicantInput = {
  city: Scalars['String']['input'];
  country: Scalars['String']['input'];
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  phone: Scalars['String']['input'];
  postalCode: Scalars['String']['input'];
  state: Scalars['String']['input'];
  streetLine1: Scalars['String']['input'];
  streetLine2?: InputMaybe<Scalars['String']['input']>;
};

export type HfdApplicationResult = {
  __typename?: 'HfdApplicationResult';
  id: Scalars['ID']['output'];
  orderId: Scalars['ID']['output'];
  status: HfdApplicationStatus;
};

export enum HfdApplicationStatus {
  Approved = 'APPROVED',
  Declined = 'DECLINED',
  Expired = 'EXPIRED',
  Pending = 'PENDING',
  Unknown = 'UNKNOWN'
}

/** A datum highlight */
export type Highlight = {
  __typename?: 'Highlight';
  label?: Maybe<Scalars['String']['output']>;
  length?: Maybe<Scalars['Int']['output']>;
  start?: Maybe<Scalars['Int']['output']>;
};

export type Hospitalization = {
  __typename?: 'Hospitalization';
  cage?: Maybe<Cage>;
  department?: Maybe<Department>;
  id?: Maybe<Scalars['ID']['output']>;
  insertedAt?: Maybe<Scalars['NaiveDateTime']['output']>;
  intern?: Maybe<Provider>;
  isActive?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use Status instead of Level */
  level?: Maybe<Scalars['Int']['output']>;
  location?: Maybe<Location>;
  patient?: Maybe<Patient>;
  provider?: Maybe<Provider>;
  reason?: Maybe<Scalars['String']['output']>;
  resident?: Maybe<Provider>;
  start?: Maybe<Scalars['DateTime']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  tasks?: Maybe<Array<Maybe<HospitalizationTask>>>;
  technician?: Maybe<Provider>;
  treatmentSheets?: Maybe<Array<Maybe<TreatmentSheet>>>;
};

export type HospitalizationInput = {
  cageId?: InputMaybe<Scalars['ID']['input']>;
  departmentId?: InputMaybe<Scalars['ID']['input']>;
  internId?: InputMaybe<Scalars['ID']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  locationId?: InputMaybe<Scalars['ID']['input']>;
  patientId?: InputMaybe<Scalars['ID']['input']>;
  providerId?: InputMaybe<Scalars['ID']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
  residentId?: InputMaybe<Scalars['ID']['input']>;
  start?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  technicianId?: InputMaybe<Scalars['ID']['input']>;
};

export type HospitalizationTask = {
  __typename?: 'HospitalizationTask';
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  completedBy?: Maybe<Provider>;
  id?: Maybe<Scalars['ID']['output']>;
  insertedAt?: Maybe<Scalars['NaiveDateTime']['output']>;
  position?: Maybe<Scalars['Int']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type HospitalizationTaskInput = {
  completedAt?: InputMaybe<Scalars['DateTime']['input']>;
  completedById?: InputMaybe<Scalars['ID']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type IguanaExamInput = {
  examCode?: InputMaybe<Scalars['String']['input']>;
  examName?: InputMaybe<Scalars['String']['input']>;
  modifier?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
};

export enum IguanaLabOrderEventType {
  LisOrderCancelled = 'LIS_ORDER_CANCELLED',
  LisOrderSubmitted = 'LIS_ORDER_SUBMITTED',
  LisOrderUpdated = 'LIS_ORDER_UPDATED',
  LisReportReceived = 'LIS_REPORT_RECEIVED',
  RisOrderAccepted = 'RIS_ORDER_ACCEPTED',
  RisOrderCancelled = 'RIS_ORDER_CANCELLED',
  RisOrderSubmitted = 'RIS_ORDER_SUBMITTED',
  RisOrderUpdated = 'RIS_ORDER_UPDATED',
  RisReportReceived = 'RIS_REPORT_RECEIVED'
}

export enum IguanaRisOrderUpdateStatus {
  Completed = 'COMPLETED',
  Inprogress = 'INPROGRESS'
}

export type ImageDatum = Datum & {
  __typename?: 'ImageDatum';
  alt?: Maybe<Scalars['String']['output']>;
  image?: Maybe<Scalars['String']['output']>;
  inline?: Maybe<Scalars['Truthy']['output']>;
  required?: Maybe<Scalars['Truthy']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

/** An immunization */
export type Immunization = {
  __typename?: 'Immunization';
  administered?: Maybe<Scalars['Boolean']['output']>;
  date?: Maybe<Scalars['Date']['output']>;
  declineReason?: Maybe<DeclineReason>;
  declined?: Maybe<Scalars['Boolean']['output']>;
  doseQuantity?: Maybe<Scalars['String']['output']>;
  dueDate?: Maybe<Scalars['Date']['output']>;
  dueDate2?: Maybe<Scalars['Date']['output']>;
  encounter?: Maybe<Encounter>;
  /** @deprecated Please use due date for due date and expiry date for lot expiration. */
  expirationDate?: Maybe<Scalars['Date']['output']>;
  expiryDate?: Maybe<Scalars['Date']['output']>;
  historical?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  immunizationStatus?: Maybe<ImmunizationStatus>;
  insertedAt?: Maybe<Scalars['NaiveDateTime']['output']>;
  isDiscontinued?: Maybe<Scalars['Boolean']['output']>;
  isIssuedViaCubex?: Maybe<Scalars['Boolean']['output']>;
  isRabies?: Maybe<Scalars['Boolean']['output']>;
  location?: Maybe<Location>;
  lotNumber?: Maybe<Scalars['String']['output']>;
  manufacturer?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  packageItem?: Maybe<ProductPackageItem>;
  patient?: Maybe<Patient>;
  product?: Maybe<Product>;
  productSuggestion?: Maybe<ProductSuggestion>;
  provider?: Maybe<Provider>;
  rabiesTagNumber?: Maybe<Scalars['String']['output']>;
  route?: Maybe<RouteType>;
  site?: Maybe<Scalars['String']['output']>;
  sourceDocument?: Maybe<PatientDocument>;
  technician?: Maybe<Provider>;
  type?: Maybe<ImmunizationType>;
  updatedAt?: Maybe<Scalars['NaiveDateTime']['output']>;
  /** The amount wasted from Cubex */
  wasteQuantity?: Maybe<Scalars['Decimal']['output']>;
};

export type ImmunizationConnection = {
  __typename?: 'ImmunizationConnection';
  edges?: Maybe<Array<Maybe<ImmunizationEdge>>>;
  pageInfo: PageInfo;
};

export type ImmunizationDatum = Datum & {
  __typename?: 'ImmunizationDatum';
  administerDate?: Maybe<Scalars['String']['output']>;
  doseQuantity?: Maybe<Scalars['String']['output']>;
  dueDate2?: Maybe<Scalars['String']['output']>;
  lotNumber?: Maybe<Scalars['String']['output']>;
  manufacturer?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  nextDueDate?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  prescriber?: Maybe<Scalars['String']['output']>;
  prescriberId?: Maybe<Scalars['String']['output']>;
  productId?: Maybe<Scalars['String']['output']>;
  rabiesTagNumber?: Maybe<Scalars['String']['output']>;
  required?: Maybe<Scalars['Truthy']['output']>;
  shortcutDays?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  site?: Maybe<Scalars['String']['output']>;
  technicianId?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type ImmunizationEdge = {
  __typename?: 'ImmunizationEdge';
  cursor?: Maybe<Scalars['String']['output']>;
  node?: Maybe<Immunization>;
};

export type ImmunizationFilters = {
  clientId?: InputMaybe<Scalars['ID']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  isLatest?: InputMaybe<Scalars['Boolean']['input']>;
  isRabies?: InputMaybe<Scalars['Boolean']['input']>;
  locationId?: InputMaybe<Scalars['ID']['input']>;
  patientId?: InputMaybe<Scalars['ID']['input']>;
  updatedAtEnd?: InputMaybe<Scalars['NaiveDateTime']['input']>;
  updatedAtStart?: InputMaybe<Scalars['NaiveDateTime']['input']>;
};

export type ImmunizationInput = {
  administered?: InputMaybe<Scalars['Boolean']['input']>;
  date?: InputMaybe<Scalars['Date']['input']>;
  declineReasonId?: InputMaybe<Scalars['ID']['input']>;
  declined?: InputMaybe<Scalars['Boolean']['input']>;
  doseQuantity?: InputMaybe<Scalars['String']['input']>;
  dueDate?: InputMaybe<Scalars['Date']['input']>;
  dueDate2?: InputMaybe<Scalars['Date']['input']>;
  encounterId?: InputMaybe<Scalars['ID']['input']>;
  expiryDate?: InputMaybe<Scalars['Date']['input']>;
  historical?: InputMaybe<Scalars['Boolean']['input']>;
  immunizationStatus?: InputMaybe<ImmunizationStatus>;
  isDiscontinued?: InputMaybe<Scalars['Boolean']['input']>;
  isRabies?: InputMaybe<Scalars['Boolean']['input']>;
  locationId?: InputMaybe<Scalars['ID']['input']>;
  lotNumber?: InputMaybe<Scalars['String']['input']>;
  manufacturer?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  patientId?: InputMaybe<Scalars['ID']['input']>;
  productId?: InputMaybe<Scalars['ID']['input']>;
  productSuggestionId?: InputMaybe<Scalars['ID']['input']>;
  providerId?: InputMaybe<Scalars['ID']['input']>;
  rabiesTagNumber?: InputMaybe<Scalars['String']['input']>;
  route?: InputMaybe<RouteType>;
  site?: InputMaybe<Scalars['String']['input']>;
  sourceDocumentId?: InputMaybe<Scalars['ID']['input']>;
  technicianId?: InputMaybe<Scalars['ID']['input']>;
  type?: InputMaybe<ImmunizationType>;
};

export enum ImmunizationStatus {
  Active = 'ACTIVE',
  ApprovalDeclined = 'APPROVAL_DECLINED',
  Completed = 'COMPLETED',
  Declined = 'DECLINED',
  Deleted = 'DELETED',
  EnteredInError = 'ENTERED_IN_ERROR',
  Pending = 'PENDING',
  PendingApproval = 'PENDING_APPROVAL',
  Returned = 'RETURNED'
}

export enum ImmunizationType {
  Booster = 'BOOSTER',
  Initial = 'INITIAL'
}

/** Type of entity being imported from a patient document */
export enum ImportEntityType {
  /** Import an immunization */
  Immunization = 'IMMUNIZATION',
  /** Import a medication */
  Medication = 'MEDICATION',
  /** Import a patient protocol */
  PatientProtocol = 'PATIENT_PROTOCOL'
}

/** Unified input for importing entities from a patient document. The entity_type must match the provided data field. */
export type ImportFromDocumentInput = {
  customPatientProtocol?: InputMaybe<CustomPatientProtocolInput>;
  /** Type of entity being imported */
  entityType: ImportEntityType;
  immunization?: InputMaybe<ImmunizationInput>;
  medication?: InputMaybe<MedicationInput>;
  /** ID of the source patient document */
  sourceDocumentId: Scalars['ID']['input'];
  /** Index within ai_import_extract for matching source data */
  sourceIdx: Scalars['Int']['input'];
};

export type ImportedEntity = {
  __typename?: 'ImportedEntity';
  /** ID of the imported entity */
  entityId: Scalars['ID']['output'];
  /** Type of entity: 'medication', 'immunization', or 'custom_patient_protocol' */
  entityType: Scalars['String']['output'];
  /** Source index for imported entity */
  idx: Scalars['Int']['output'];
  /** Name of the imported entity */
  name: Scalars['String']['output'];
};

export enum InferredResultTypes {
  Abnormal = 'ABNORMAL',
  Negative = 'NEGATIVE',
  Normal = 'NORMAL',
  Positive = 'POSITIVE',
  Unknown = 'UNKNOWN'
}

export type IntervalConfig = {
  __typename?: 'IntervalConfig';
  amountCents?: Maybe<Scalars['Int']['output']>;
  percent?: Maybe<Scalars['Decimal']['output']>;
  statementNote?: Maybe<Scalars['String']['output']>;
  type: BillingGroupFeeType;
};

export type IntervalConfigInput = {
  amountCents?: InputMaybe<Scalars['Int']['input']>;
  percent?: InputMaybe<Scalars['Decimal']['input']>;
  statementNote?: InputMaybe<Scalars['String']['input']>;
  type: BillingGroupFeeType;
};

export type InventoryAdjustment = {
  __typename?: 'InventoryAdjustment';
  expirationDate?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  insertedAt?: Maybe<Scalars['NaiveDateTime']['output']>;
  isManual?: Maybe<Scalars['Boolean']['output']>;
  lotNumber?: Maybe<Scalars['String']['output']>;
  manufacturer?: Maybe<ProductManufacturer>;
  product?: Maybe<Product>;
  provider?: Maybe<Provider>;
  quantityChange?: Maybe<Scalars['Decimal']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
  wastageReason?: Maybe<WastageReason>;
};

export type InventoryAdjustmentInput = {
  expirationDate?: InputMaybe<Scalars['Date']['input']>;
  locationId?: InputMaybe<Scalars['ID']['input']>;
  lotNumber?: InputMaybe<Scalars['String']['input']>;
  manufacturerId?: InputMaybe<Scalars['ID']['input']>;
  newQuantity?: InputMaybe<Scalars['Decimal']['input']>;
  productId?: InputMaybe<Scalars['ID']['input']>;
  quantityChange?: InputMaybe<Scalars['Decimal']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
  wastageReason?: InputMaybe<WastageReason>;
};

export type InventoryLevel = {
  __typename?: 'InventoryLevel';
  awaiting?: Maybe<Scalars['Decimal']['output']>;
  locationId?: Maybe<Scalars['ID']['output']>;
  locationName?: Maybe<Scalars['String']['output']>;
  lotNumber?: Maybe<Scalars['String']['output']>;
  lowStockThreshold?: Maybe<Scalars['Int']['output']>;
  manufacturer?: Maybe<ProductManufacturer>;
  productId?: Maybe<Scalars['ID']['output']>;
  stock?: Maybe<Scalars['Decimal']['output']>;
};

export type InventoryLog = {
  __typename?: 'InventoryLog';
  changedAt?: Maybe<Scalars['NaiveDateTime']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  isManual?: Maybe<Scalars['Boolean']['output']>;
  lotNumber?: Maybe<Scalars['String']['output']>;
  orderItem?: Maybe<OrderItem>;
  provider?: Maybe<Provider>;
  quantityChange: Scalars['Decimal']['output'];
  reason?: Maybe<Scalars['String']['output']>;
  reversible?: Maybe<Scalars['Boolean']['output']>;
};

export type InvoiceLineItemReason = {
  __typename?: 'InvoiceLineItemReason';
  id?: Maybe<Scalars['ID']['output']>;
  isActive?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type InvoiceLineItemReasonInput = {
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export enum InvoiceSortFieldEnum {
  Datetime = 'DATETIME',
  Id = 'ID',
  InsertedAt = 'INSERTED_AT',
  UpdatedAt = 'UPDATED_AT'
}

export enum InvoiceStatus {
  Collections = 'COLLECTIONS',
  Deleted = 'DELETED',
  Due = 'DUE',
  Open = 'OPEN',
  Paid = 'PAID',
  Uncollectible = 'UNCOLLECTIBLE',
  Void = 'VOID'
}

export enum IsoCountry {
  Ca = 'CA',
  Us = 'US'
}

export type LabDevice = {
  __typename?: 'LabDevice';
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type LabModifier = {
  __typename?: 'LabModifier';
  code?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  insertedAt?: Maybe<Scalars['NaiveDateTime']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  orgId?: Maybe<Scalars['ID']['output']>;
};

export type LabModifierInput = {
  code: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type LabOrder = {
  __typename?: 'LabOrder';
  accessionId?: Maybe<Scalars['String']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  declined?: Maybe<Scalars['Boolean']['output']>;
  encounter?: Maybe<Encounter>;
  extUrl?: Maybe<Scalars['String']['output']>;
  externalId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  insertedAt?: Maybe<Scalars['NaiveDateTime']['output']>;
  labResults?: Maybe<Array<Maybe<LabResult>>>;
  /** Integration-specific details for a lab order, if any. */
  orderDetail?: Maybe<LabOrderDetail>;
  orgLab?: Maybe<OrgLab>;
  patient?: Maybe<Patient>;
  pdf?: Maybe<Scalars['String']['output']>;
  productSuggestion?: Maybe<ProductSuggestion>;
  provider?: Maybe<Provider>;
  scannedCodes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  status?: Maybe<Scalars['String']['output']>;
  testNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  tests?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['NaiveDateTime']['output']>;
  viewUrl?: Maybe<Scalars['String']['output']>;
  visit?: Maybe<Visit>;
};


export type LabOrderPdfArgs = {
  refetch?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Integration-specific details for a lab order. */
export type LabOrderDetail = FujirisLabOrderDetail | HarvestLabOrderDetail;

export type LabOrderInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  encounterId?: InputMaybe<Scalars['ID']['input']>;
  scannedCodes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  visitId?: InputMaybe<Scalars['ID']['input']>;
};

export type LabResult = {
  __typename?: 'LabResult';
  abnormals: Array<Scalars['String']['output']>;
  accessionId?: Maybe<Scalars['String']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  comments?: Maybe<Array<Comment>>;
  datetime?: Maybe<Scalars['DateTime']['output']>;
  diagnosticResultUrl?: Maybe<Scalars['String']['output']>;
  encounter?: Maybe<Encounter>;
  externalId?: Maybe<Scalars['String']['output']>;
  hasComments?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  images: Array<LabResultImage>;
  insertedAt?: Maybe<Scalars['NaiveDateTime']['output']>;
  labOrder?: Maybe<LabOrder>;
  labOrderId?: Maybe<Scalars['ID']['output']>;
  laboratory?: Maybe<Scalars['String']['output']>;
  location?: Maybe<Location>;
  name?: Maybe<Scalars['String']['output']>;
  normals: Array<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  orgLab?: Maybe<OrgLab>;
  orphanData?: Maybe<Scalars['JSON']['output']>;
  patientId?: Maybe<Scalars['ID']['output']>;
  provider?: Maybe<Provider>;
  resultPdf?: Maybe<Scalars['String']['output']>;
  resultText?: Maybe<Scalars['String']['output']>;
  resultUrl?: Maybe<Scalars['String']['output']>;
  /** List of reviewers who reviewed to lab results */
  reviewers?: Maybe<Array<Maybe<Provider>>>;
  testCount?: Maybe<Scalars['Int']['output']>;
  testResults?: Maybe<Array<Maybe<TestResult>>>;
  unknowns: Array<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['NaiveDateTime']['output']>;
  visit?: Maybe<Visit>;
};


export type LabResultTestResultsArgs = {
  onlyAbnormal?: InputMaybe<Scalars['Boolean']['input']>;
};

export type LabResultConnection = {
  __typename?: 'LabResultConnection';
  edges?: Maybe<Array<Maybe<LabResultEdge>>>;
  pageInfo: PageInfo;
};

export type LabResultEdge = {
  __typename?: 'LabResultEdge';
  cursor?: Maybe<Scalars['String']['output']>;
  node?: Maybe<LabResult>;
};

export type LabResultImage = {
  __typename?: 'LabResultImage';
  contentType?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  /** Short lived URL directly to the thumbnail. Access will expire 24hrs after retrieval. */
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
  /** Short lived URL directly to the image. Access will expire 24hrs after retrieval. */
  url?: Maybe<Scalars['String']['output']>;
};

export type LabResultInput = {
  encounterId?: InputMaybe<Scalars['ID']['input']>;
  patientId?: InputMaybe<Scalars['ID']['input']>;
  visitId?: InputMaybe<Scalars['ID']['input']>;
};

export type LabTest = {
  __typename?: 'LabTest';
  category?: Maybe<Scalars['String']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  extraFields?: Maybe<Array<Maybe<ExtraField>>>;
  name?: Maybe<Scalars['String']['output']>;
  species?: Maybe<Scalars['String']['output']>;
};

/**
 * One lab value's history. The engine merges the names a vendor gave it, so a
 * patient whose glucose arrived as both `GLU` and `Glucose` has one analyte,
 * while values sharing a name across kinds -- blood and urine white cells --
 * stay apart by units.
 */
export type LabTrendAnalyte = {
  __typename?: 'LabTrendAnalyte';
  /** What the vendor called it, so a caller can find what it asked for. */
  aliases?: Maybe<Array<Scalars['String']['output']>>;
  canonicalKey?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  /** The range the analyte is judged against, where the readings disagree. */
  referenceRange?: Maybe<LabTrendRange>;
  series?: Maybe<Array<LabTrendReading>>;
  units?: Maybe<Scalars['String']['output']>;
};

export type LabTrendInsights = {
  __typename?: 'LabTrendInsights';
  analytes?: Maybe<Array<LabTrendNarrative>>;
};

export type LabTrendNarrative = {
  __typename?: 'LabTrendNarrative';
  name?: Maybe<Scalars['String']['output']>;
  narrative?: Maybe<Scalars['String']['output']>;
};

export type LabTrendRange = {
  __typename?: 'LabTrendRange';
  max?: Maybe<Scalars['Float']['output']>;
  min?: Maybe<Scalars['Float']['output']>;
};

export type LabTrendReading = {
  __typename?: 'LabTrendReading';
  isNumeric?: Maybe<Scalars['Boolean']['output']>;
  labResultId?: Maybe<Scalars['ID']['output']>;
  /** The value as the lab wrote it, which keeps \"53.0\" and \"< 0.1\". */
  rawValue?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  timestamp?: Maybe<Scalars['DateTime']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

export type LabTrendRun = {
  __typename?: 'LabTrendRun';
  /** Empty until the run completes, and for a run that found nothing. */
  analytes?: Maybe<Array<LabTrendAnalyte>>;
  error?: Maybe<Scalars['String']['output']>;
  insights?: Maybe<LabTrendInsights>;
  /** The engine's id for this run, so a stuck or failed one can be looked up. */
  jobId?: Maybe<Scalars['String']['output']>;
  /**
   * Whether this is a trend whose refresh failed. It is the last one generated,
   * and still the best answer, but older than the reader would otherwise assume.
   */
  stale?: Maybe<Scalars['Boolean']['output']>;
  status: LabTrendStatus;
};

export enum LabTrendStatus {
  /** The result is on the job. */
  Completed = 'COMPLETED',
  /** The engine could not generate this patient's trends. */
  Failed = 'FAILED',
  /** Queued or running. */
  Pending = 'PENDING'
}

export enum LabelSize {
  Label54X70Mm = 'LABEL54X70MM',
  Label103X164Mm = 'LABEL103X164MM',
  Label889X508Mm = 'LABEL889X508MM'
}

/** A late payment fee applied to an order */
export type LateFee = {
  __typename?: 'LateFee';
  amountCents?: Maybe<Scalars['Int']['output']>;
  appliedAtDate?: Maybe<Scalars['Date']['output']>;
  bucket?: Maybe<Scalars['String']['output']>;
  client?: Maybe<Client>;
  configSnapshot?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  milestone?: Maybe<Scalars['Int']['output']>;
  order?: Maybe<Order>;
};

export type LedgerEntry = {
  __typename?: 'LedgerEntry';
  account?: Maybe<Scalars['String']['output']>;
  clientId?: Maybe<Scalars['ID']['output']>;
  creditCents?: Maybe<Scalars['Int']['output']>;
  datetime?: Maybe<Scalars['DateTime']['output']>;
  debitCents?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  locationDate?: Maybe<Scalars['Date']['output']>;
  locationId?: Maybe<Scalars['ID']['output']>;
  locationTime?: Maybe<Scalars['Time']['output']>;
  orderIds?: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
  subaccount?: Maybe<Scalars['String']['output']>;
  transactionId?: Maybe<Scalars['ID']['output']>;
  transactionType?: Maybe<Scalars['String']['output']>;
};

export type LedgerEntryTotals = {
  __typename?: 'LedgerEntryTotals';
  accountsReceivable?: Maybe<Scalars['Decimal']['output']>;
  accountsReceivableCount?: Maybe<Scalars['Int']['output']>;
  apaPayments?: Maybe<Scalars['Decimal']['output']>;
  apaPaymentsCount?: Maybe<Scalars['Int']['output']>;
  badDebt?: Maybe<Scalars['Decimal']['output']>;
  badDebtCount?: Maybe<Scalars['Int']['output']>;
  careCreditPayments?: Maybe<Scalars['Decimal']['output']>;
  careCreditPaymentsCount?: Maybe<Scalars['Int']['output']>;
  carePlanPayments?: Maybe<Scalars['Decimal']['output']>;
  carePlanPaymentsCount?: Maybe<Scalars['Int']['output']>;
  cashPayments?: Maybe<Scalars['Decimal']['output']>;
  cashPaymentsCount?: Maybe<Scalars['Int']['output']>;
  checkPayments?: Maybe<Scalars['Decimal']['output']>;
  checkPaymentsCount?: Maybe<Scalars['Int']['output']>;
  count?: Maybe<Scalars['Int']['output']>;
  creditCardPayments?: Maybe<Scalars['Decimal']['output']>;
  creditCardPaymentsCount?: Maybe<Scalars['Int']['output']>;
  creditDueCustomer?: Maybe<Scalars['Decimal']['output']>;
  creditDueCustomerCount?: Maybe<Scalars['Int']['output']>;
  deferredRevenue?: Maybe<Scalars['Decimal']['output']>;
  deferredRevenueCount?: Maybe<Scalars['Int']['output']>;
  discounts?: Maybe<Scalars['Decimal']['output']>;
  discountsCount?: Maybe<Scalars['Int']['output']>;
  donationPayments?: Maybe<Scalars['Decimal']['output']>;
  donationPaymentsCount?: Maybe<Scalars['Int']['output']>;
  donations?: Maybe<Scalars['Decimal']['output']>;
  donationsCount?: Maybe<Scalars['Int']['output']>;
  expirationRevenue?: Maybe<Scalars['Decimal']['output']>;
  expirationRevenueCount?: Maybe<Scalars['Int']['output']>;
  fortivaPayments?: Maybe<Scalars['Decimal']['output']>;
  fortivaPaymentsCount?: Maybe<Scalars['Int']['output']>;
  giftCardPayments?: Maybe<Scalars['Decimal']['output']>;
  giftCardPaymentsCount?: Maybe<Scalars['Int']['output']>;
  goodwillDiscounts?: Maybe<Scalars['Decimal']['output']>;
  goodwillDiscountsCount?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  paymentBancPayments?: Maybe<Scalars['Decimal']['output']>;
  paymentBancPaymentsCount?: Maybe<Scalars['Int']['output']>;
  plansAr?: Maybe<Scalars['Decimal']['output']>;
  plansArCount?: Maybe<Scalars['Int']['output']>;
  pumpkinPayments?: Maybe<Scalars['Decimal']['output']>;
  pumpkinPaymentsCount?: Maybe<Scalars['Int']['output']>;
  rectanglePayments?: Maybe<Scalars['Decimal']['output']>;
  rectanglePaymentsCount?: Maybe<Scalars['Int']['output']>;
  revenue?: Maybe<Scalars['Decimal']['output']>;
  revenueCount?: Maybe<Scalars['Int']['output']>;
  scratchPayPayments?: Maybe<Scalars['Decimal']['output']>;
  scratchPayPaymentsCount?: Maybe<Scalars['Int']['output']>;
  snapFinancePayments?: Maybe<Scalars['Decimal']['output']>;
  snapFinancePaymentsCount?: Maybe<Scalars['Int']['output']>;
  tax?: Maybe<Scalars['Decimal']['output']>;
  taxCount?: Maybe<Scalars['Int']['output']>;
  tips?: Maybe<Scalars['Decimal']['output']>;
  tipsCount?: Maybe<Scalars['Int']['output']>;
  total?: Maybe<Scalars['Decimal']['output']>;
  trupanionPayments?: Maybe<Scalars['Decimal']['output']>;
  trupanionPaymentsCount?: Maybe<Scalars['Int']['output']>;
  voucherPayments?: Maybe<Scalars['Decimal']['output']>;
  voucherPaymentsCount?: Maybe<Scalars['Int']['output']>;
};

export type LegalEntity = {
  __typename?: 'LegalEntity';
  id?: Maybe<Scalars['ID']['output']>;
  vertexCode?: Maybe<Scalars['String']['output']>;
};

export type License = {
  __typename?: 'License';
  comments?: Maybe<Scalars['String']['output']>;
  expirationDate?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  insertedAt?: Maybe<Scalars['NaiveDateTime']['output']>;
  isActive?: Maybe<Scalars['Boolean']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  type?: Maybe<LicenseType>;
  updatedAt?: Maybe<Scalars['NaiveDateTime']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type LicenseInput = {
  comments?: InputMaybe<Scalars['String']['input']>;
  expirationDate?: InputMaybe<Scalars['Date']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  providerId?: InputMaybe<Scalars['ID']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<LicenseType>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export enum LicenseType {
  Cds = 'CDS',
  CertifiedTech = 'CERTIFIED_TECH',
  Dea = 'DEA',
  Other = 'OTHER',
  State = 'STATE',
  StateControlledSubstance = 'STATE_CONTROLLED_SUBSTANCE',
  Usda = 'USDA'
}

export type LinkedClinicalNote = {
  __typename?: 'LinkedClinicalNote';
  clinicalNote?: Maybe<ClinicalNote>;
  encounter?: Maybe<Encounter>;
  id?: Maybe<Scalars['ID']['output']>;
  print?: Maybe<Scalars['Boolean']['output']>;
};

export type LinkedClinicalNoteInput = {
  print?: InputMaybe<Scalars['Boolean']['input']>;
};

export type LinkedEncounter = {
  __typename?: 'LinkedEncounter';
  childEncounter?: Maybe<Encounter>;
  encounter?: Maybe<Encounter>;
  id?: Maybe<Scalars['ID']['output']>;
  print?: Maybe<Scalars['Boolean']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type LinkedEncounterInput = {
  print?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** A healthcare-providing location */
export type Location = {
  __typename?: 'Location';
  abaxisPassword?: Maybe<Scalars['String']['output']>;
  /**
   * @deprecated The return value of this field will change to return a nested object of type 'address'.
   *
   * Please update your API usage to either select 'addressString', or use 'addressFields'
   * which will reflect the new return value of this field for the meantime.
   *
   * Please note that the latter will eventually be renamed to 'address'.
   *
   */
  address?: Maybe<Scalars['String']['output']>;
  addressFields?: Maybe<Address>;
  addressString?: Maybe<Scalars['String']['output']>;
  allowChangeRefillProvider?: Maybe<Scalars['Boolean']['output']>;
  appointmentSlotMinutes?: Maybe<Scalars['Int']['output']>;
  attributes?: Maybe<Array<Maybe<LocationAttribute>>>;
  availableSlots?: Maybe<Array<Maybe<AvailableTimeSlot>>>;
  boardingWards?: Maybe<Array<BoardingWard>>;
  budgetPercent?: Maybe<Scalars['Decimal']['output']>;
  cages?: Maybe<Array<Cage>>;
  cardconnectMerchantId?: Maybe<Scalars['String']['output']>;
  cardconnectPaymentPage?: Maybe<Scalars['String']['output']>;
  cardconnectTerminals?: Maybe<Scalars['JSON']['output']>;
  careCreditMerchantIdMasked?: Maybe<Scalars['String']['output']>;
  careCreditPaymentUrl?: Maybe<Scalars['String']['output']>;
  cashBankAmount?: Maybe<Scalars['Decimal']['output']>;
  censusEnabled?: Maybe<Scalars['Boolean']['output']>;
  cityTaxRate?: Maybe<Scalars['Decimal']['output']>;
  clinicImagePath?: Maybe<Scalars['String']['output']>;
  color?: Maybe<Scalars['String']['output']>;
  country?: Maybe<IsoCountry>;
  countyTaxRate?: Maybe<Scalars['Decimal']['output']>;
  covetrusContextKey?: Maybe<Scalars['String']['output']>;
  cubexActive?: Maybe<Scalars['Boolean']['output']>;
  cubexDbName?: Maybe<Scalars['String']['output']>;
  cubexPassword?: Maybe<Scalars['String']['output']>;
  cubexUsername?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  datasyncBitwerxLocationId?: Maybe<Scalars['String']['output']>;
  datasyncBitwerxPracticeId?: Maybe<Scalars['String']['output']>;
  datasyncConsolidateClientNotes?: Maybe<Scalars['Boolean']['output']>;
  datasyncForceUniqueEncounters?: Maybe<Scalars['Boolean']['output']>;
  datasyncImportBillingGroups?: Maybe<Scalars['Boolean']['output']>;
  datasyncImportBillingNotes?: Maybe<Scalars['Boolean']['output']>;
  datasyncImportCoowners?: Maybe<Scalars['Boolean']['output']>;
  datasyncImportDisplayIdAsIdentification?: Maybe<Scalars['Boolean']['output']>;
  datasyncImportFarmNameAsBusinessName?: Maybe<Scalars['Boolean']['output']>;
  datasyncImportFollowupsAsClinicalNotes?: Maybe<Scalars['Boolean']['output']>;
  datasyncImportInactiveClientDataStartingFrom?: Maybe<Scalars['Date']['output']>;
  datasyncImportMemosAsClinicalNotes?: Maybe<Scalars['Boolean']['output']>;
  datasyncImportRegisteredName?: Maybe<Scalars['Boolean']['output']>;
  datasyncImportRemindersAsImmunizations?: Maybe<Scalars['Boolean']['output']>;
  datasyncImportSecondaryPhoneNotes?: Maybe<Scalars['Boolean']['output']>;
  datasyncIncludeHistoricalAr?: Maybe<Scalars['Boolean']['output']>;
  datasyncOnlyImportNewRecords?: Maybe<Scalars['Boolean']['output']>;
  datasyncPrioritizeRoomOverProvider?: Maybe<Scalars['Boolean']['output']>;
  datasyncToken?: Maybe<Scalars['String']['output']>;
  daycareCapacity?: Maybe<Scalars['Int']['output']>;
  deaNumber?: Maybe<Scalars['String']['output']>;
  default?: Maybe<Scalars['Boolean']['output']>;
  defaultLabelPrinter?: Maybe<Scalars['String']['output']>;
  defaultWeightUnit?: Maybe<WeightUnit>;
  departments?: Maybe<Array<Maybe<Department>>>;
  dialpadOfficeId?: Maybe<Scalars['String']['output']>;
  differentiatedProducts?: Maybe<Array<Maybe<Product>>>;
  directPrint?: Maybe<Scalars['Boolean']['output']>;
  /** Disables the fixed positioning for daycare or queue columns in the Vetspire UI schedule. */
  disableFixedColumns?: Maybe<Scalars['Boolean']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  district?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  enableAbaxis?: Maybe<Scalars['Boolean']['output']>;
  enableBoarding?: Maybe<Scalars['Boolean']['output']>;
  enableCareCreditToggle?: Maybe<Scalars['Boolean']['output']>;
  enableCovetrus: Scalars['Boolean']['output'];
  enableCovetrusOrg?: Maybe<Scalars['Boolean']['output']>;
  enableCovetrusToggle?: Maybe<Scalars['Boolean']['output']>;
  enableCubex?: Maybe<Scalars['Boolean']['output']>;
  enableCubexTwoWay: Scalars['Boolean']['output'];
  enableDaycare?: Maybe<Scalars['Boolean']['output']>;
  enableDialpad?: Maybe<Scalars['Boolean']['output']>;
  enableDoubleBooking?: Maybe<Scalars['Boolean']['output']>;
  enableGcp?: Maybe<Scalars['Boolean']['output']>;
  enableHfd?: Maybe<Scalars['Boolean']['output']>;
  enableNova?: Maybe<Scalars['Boolean']['output']>;
  enableOnlineBooking?: Maybe<Scalars['Boolean']['output']>;
  enableProviderSchedules?: Maybe<Scalars['Boolean']['output']>;
  enableReadyForDischarge?: Maybe<Scalars['Boolean']['output']>;
  enableReminders?: Maybe<Scalars['Boolean']['output']>;
  enableRingCentral?: Maybe<Scalars['Boolean']['output']>;
  enableSameDayAppointmentsOnly?: Maybe<Scalars['Boolean']['output']>;
  enableStripe?: Maybe<Scalars['Boolean']['output']>;
  enableVetsourceIntegration?: Maybe<Scalars['Boolean']['output']>;
  enableWaitlist?: Maybe<Scalars['Boolean']['output']>;
  enforceControlledDrugLimits?: Maybe<Scalars['Boolean']['output']>;
  extension?: Maybe<Scalars['String']['output']>;
  facebookLink?: Maybe<Scalars['String']['output']>;
  faxNumber?: Maybe<Scalars['String']['output']>;
  flipLabel?: Maybe<Scalars['Boolean']['output']>;
  forwardInboundMessagesToEmail?: Maybe<Scalars['Boolean']['output']>;
  gcpAccessToken?: Maybe<Scalars['String']['output']>;
  googleLink?: Maybe<Scalars['String']['output']>;
  harmonizedSalesTaxNumber?: Maybe<Scalars['String']['output']>;
  hasMicrochipIntegration?: Maybe<Scalars['Boolean']['output']>;
  hfdProviderId?: Maybe<Scalars['String']['output']>;
  historicalId?: Maybe<Scalars['String']['output']>;
  hospitalizations?: Maybe<Array<Maybe<Hospitalization>>>;
  id: Scalars['ID']['output'];
  insertedAt?: Maybe<Scalars['NaiveDateTime']['output']>;
  intacctCashAccount?: Maybe<Scalars['String']['output']>;
  intacctEntityId?: Maybe<Scalars['String']['output']>;
  intacctLocationId?: Maybe<Scalars['String']['output']>;
  inventoryParentLocationId?: Maybe<Scalars['ID']['output']>;
  inventorySourceLocation?: Maybe<Location>;
  isActive?: Maybe<Scalars['Boolean']['output']>;
  isLegacyAddress?: Maybe<Scalars['Boolean']['output']>;
  isTest?: Maybe<Scalars['Boolean']['output']>;
  labelSize?: Maybe<LabelSize>;
  latitude?: Maybe<Scalars['String']['output']>;
  legalEntity?: Maybe<LegalEntity>;
  locationHours?: Maybe<LocationHours>;
  locationTags?: Maybe<Array<Maybe<LocationTag>>>;
  logoUri?: Maybe<Scalars['String']['output']>;
  longitude?: Maybe<Scalars['String']['output']>;
  marketingProviders?: Maybe<Array<Provider>>;
  name: Scalars['String']['output'];
  openDate?: Maybe<Scalars['Date']['output']>;
  otherTaxRate?: Maybe<Scalars['Decimal']['output']>;
  packageMarkupPercent?: Maybe<Scalars['Decimal']['output']>;
  payrollId?: Maybe<Scalars['String']['output']>;
  petlinkPassword?: Maybe<Scalars['String']['output']>;
  petlinkUsername?: Maybe<Scalars['String']['output']>;
  pharmacyPhoneNumber?: Maybe<Scalars['String']['output']>;
  pharmacyWhiteboardEnabled?: Maybe<Scalars['Boolean']['output']>;
  pharmacyWhiteboardStatuses?: Maybe<Array<Scalars['String']['output']>>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  priceMarkupPercent?: Maybe<Scalars['Decimal']['output']>;
  printQrCodePatientLabel?: Maybe<Scalars['Boolean']['output']>;
  printnodeComputers?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  printnodePaperSize?: Maybe<Scalars['String']['output']>;
  printnodePrinter?: Maybe<Scalars['Int']['output']>;
  productMarkupPercent?: Maybe<Scalars['Decimal']['output']>;
  productTypeMarkupPercent?: Maybe<Scalars['Decimal']['output']>;
  providerSchedules?: Maybe<Array<Maybe<LocationProviderSchedule>>>;
  providerSchedulesByDate?: Maybe<Array<Maybe<LocationProviderSchedule>>>;
  providers?: Maybe<Array<Provider>>;
  providersWithGlobals?: Maybe<Array<Provider>>;
  rabiesCertificateStateRequirement?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  schedules?: Maybe<Array<Maybe<LocationSchedule>>>;
  scratchpayId?: Maybe<Scalars['String']['output']>;
  showDoctorDeaNumber?: Maybe<Scalars['Boolean']['output']>;
  showUnscheduledProviders?: Maybe<Scalars['Boolean']['output']>;
  showVialNumber?: Maybe<Scalars['Boolean']['output']>;
  squareLocationId?: Maybe<Scalars['String']['output']>;
  stateTaxRate?: Maybe<Scalars['Decimal']['output']>;
  stripeAccessToken?: Maybe<Scalars['String']['output']>;
  stripeConnectToken?: Maybe<Scalars['String']['output']>;
  stripeCustomerId?: Maybe<Scalars['String']['output']>;
  stripeDashboardUrl?: Maybe<Scalars['String']['output']>;
  stripeLocationId?: Maybe<Scalars['String']['output']>;
  stripePublishableKey?: Maybe<Scalars['String']['output']>;
  stripeSetup?: Maybe<Scalars['Boolean']['output']>;
  stripeUserId?: Maybe<Scalars['String']['output']>;
  surgeryCapacity?: Maybe<Scalars['Int']['output']>;
  tags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /**
   * @deprecated This field is deprecated and will only ever return a location's `otherTaxRate`.
   * Locations now have various tax rate fields you may want to read. Please update your queries
   * to pull from `otherTaxRate`, `cityTaxRate`, `stateTaxRate`, and `countyTaxRate`.
   *
   */
  taxRate?: Maybe<Scalars['Decimal']['output']>;
  timezone?: Maybe<Scalars['String']['output']>;
  tollFreeNumber?: Maybe<Scalars['String']['output']>;
  twilioPhoneNumber?: Maybe<Scalars['String']['output']>;
  unreadLocationChatMessagesCount?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['NaiveDateTime']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  vetsourceId?: Maybe<Scalars['String']['output']>;
  waitlistReadyMessage?: Maybe<Scalars['String']['output']>;
  yelpLink?: Maybe<Scalars['String']['output']>;
};


/** A healthcare-providing location */
export type LocationAvailableSlotsArgs = {
  allowHistorical?: InputMaybe<Scalars['Boolean']['input']>;
  appointmentTypeId: Scalars['ID']['input'];
  date?: InputMaybe<Scalars['Date']['input']>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
  firstAvailable?: InputMaybe<Scalars['Boolean']['input']>;
  numberOfPets?: InputMaybe<Scalars['Int']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
};


/** A healthcare-providing location */
export type LocationDepartmentsArgs = {
  onFlow?: InputMaybe<Scalars['Boolean']['input']>;
};


/** A healthcare-providing location */
export type LocationPackageMarkupPercentArgs = {
  id: Scalars['ID']['input'];
};


/** A healthcare-providing location */
export type LocationProductMarkupPercentArgs = {
  id: Scalars['ID']['input'];
};


/** A healthcare-providing location */
export type LocationProductTypeMarkupPercentArgs = {
  id: Scalars['ID']['input'];
};


/** A healthcare-providing location */
export type LocationProviderSchedulesArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
};


/** A healthcare-providing location */
export type LocationProviderSchedulesByDateArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  date?: InputMaybe<Scalars['Date']['input']>;
  end?: InputMaybe<Scalars['DateTime']['input']>;
  scheduleRangeView?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['DateTime']['input']>;
};


/** A healthcare-providing location */
export type LocationProvidersArgs = {
  isVeterinarian?: InputMaybe<Scalars['Boolean']['input']>;
  onlyActive?: InputMaybe<Scalars['Boolean']['input']>;
};


/** A healthcare-providing location */
export type LocationProvidersWithGlobalsArgs = {
  isVeterinarian?: InputMaybe<Scalars['Boolean']['input']>;
  onlyActive?: InputMaybe<Scalars['Boolean']['input']>;
  verified?: InputMaybe<Scalars['Boolean']['input']>;
};

export type LocationAttribute = {
  __typename?: 'LocationAttribute';
  customAttribute?: Maybe<CustomLocationAttribute>;
  id?: Maybe<Scalars['ID']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type LocationAttributeInput = {
  customAttributeId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  locationId?: InputMaybe<Scalars['ID']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type LocationChatMessage = {
  __typename?: 'LocationChatMessage';
  body?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  insertedAt?: Maybe<Scalars['NaiveDateTime']['output']>;
  provider?: Maybe<Provider>;
};

export type LocationChatNotification = {
  __typename?: 'LocationChatNotification';
  datetime: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  originatorId: Scalars['ID']['output'];
  title?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
};

export type LocationClientAccountCredits = {
  __typename?: 'LocationClientAccountCredits';
  accountCreditCents: Scalars['Int']['output'];
  clientId: Scalars['ID']['output'];
  isTestLocation: Scalars['Boolean']['output'];
  locationId?: Maybe<Scalars['ID']['output']>;
  locationName?: Maybe<Scalars['String']['output']>;
};

export type LocationFilters = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  inventoryDepository?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type LocationHours = {
  __typename?: 'LocationHours';
  fridayRanges?: Maybe<Array<Maybe<Scalars['Numrange']['output']>>>;
  id?: Maybe<Scalars['ID']['output']>;
  mondayRanges?: Maybe<Array<Maybe<Scalars['Numrange']['output']>>>;
  saturdayRanges?: Maybe<Array<Maybe<Scalars['Numrange']['output']>>>;
  sundayRanges?: Maybe<Array<Maybe<Scalars['Numrange']['output']>>>;
  thursdayRanges?: Maybe<Array<Maybe<Scalars['Numrange']['output']>>>;
  tuesdayRanges?: Maybe<Array<Maybe<Scalars['Numrange']['output']>>>;
  wednesdayRanges?: Maybe<Array<Maybe<Scalars['Numrange']['output']>>>;
};

export type LocationHoursInput = {
  fridayRanges?: InputMaybe<Array<InputMaybe<Scalars['Numrange']['input']>>>;
  mondayRanges?: InputMaybe<Array<InputMaybe<Scalars['Numrange']['input']>>>;
  saturdayRanges?: InputMaybe<Array<InputMaybe<Scalars['Numrange']['input']>>>;
  sundayRanges?: InputMaybe<Array<InputMaybe<Scalars['Numrange']['input']>>>;
  thursdayRanges?: InputMaybe<Array<InputMaybe<Scalars['Numrange']['input']>>>;
  tuesdayRanges?: InputMaybe<Array<InputMaybe<Scalars['Numrange']['input']>>>;
  wednesdayRanges?: InputMaybe<Array<InputMaybe<Scalars['Numrange']['input']>>>;
};

/** Input object for a location */
export type LocationInput = {
  abaxisPassword?: InputMaybe<Scalars['String']['input']>;
  addressFields?: InputMaybe<AddressInput>;
  allowChangeRefillProvider?: InputMaybe<Scalars['Boolean']['input']>;
  appointmentSlotMinutes?: InputMaybe<Scalars['Int']['input']>;
  attributes?: InputMaybe<Array<InputMaybe<LocationAttributeInput>>>;
  budgetPercent?: InputMaybe<Scalars['Decimal']['input']>;
  cardconnectMerchantId?: InputMaybe<Scalars['String']['input']>;
  cardconnectPaymentPage?: InputMaybe<Scalars['String']['input']>;
  cardconnectTerminals?: InputMaybe<Scalars['JSON']['input']>;
  careCreditPaymentUrl?: InputMaybe<Scalars['String']['input']>;
  cashBankAmount?: InputMaybe<Scalars['Decimal']['input']>;
  censusEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  cityTaxRate?: InputMaybe<Scalars['Decimal']['input']>;
  color?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<IsoCountry>;
  countyTaxRate?: InputMaybe<Scalars['Decimal']['input']>;
  covetrusContextKey?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  datasyncBitwerxLocationId?: InputMaybe<Scalars['String']['input']>;
  datasyncBitwerxPracticeId?: InputMaybe<Scalars['String']['input']>;
  datasyncConsolidateClientNotes?: InputMaybe<Scalars['Boolean']['input']>;
  datasyncForceUniqueEncounters?: InputMaybe<Scalars['Boolean']['input']>;
  datasyncImportBillingGroups?: InputMaybe<Scalars['Boolean']['input']>;
  datasyncImportBillingNotes?: InputMaybe<Scalars['Boolean']['input']>;
  datasyncImportCoowners?: InputMaybe<Scalars['Boolean']['input']>;
  datasyncImportDisplayIdAsIdentification?: InputMaybe<Scalars['Boolean']['input']>;
  datasyncImportFarmNameAsBusinessName?: InputMaybe<Scalars['Boolean']['input']>;
  datasyncImportFollowupsAsClinicalNotes?: InputMaybe<Scalars['Boolean']['input']>;
  datasyncImportInactiveClientDataStartingFrom?: InputMaybe<Scalars['Date']['input']>;
  datasyncImportMemosAsClinicalNotes?: InputMaybe<Scalars['Boolean']['input']>;
  datasyncImportRegisteredName?: InputMaybe<Scalars['Boolean']['input']>;
  datasyncImportRemindersAsImmunizations?: InputMaybe<Scalars['Boolean']['input']>;
  datasyncImportSecondaryPhoneNotes?: InputMaybe<Scalars['Boolean']['input']>;
  datasyncIncludeHistoricalAr?: InputMaybe<Scalars['Boolean']['input']>;
  datasyncOnlyImportNewRecords?: InputMaybe<Scalars['Boolean']['input']>;
  datasyncPrioritizeRoomOverProvider?: InputMaybe<Scalars['Boolean']['input']>;
  daycareCapacity?: InputMaybe<Scalars['Int']['input']>;
  deaNumber?: InputMaybe<Scalars['String']['input']>;
  defaultLabelPrinter?: InputMaybe<Scalars['String']['input']>;
  defaultWeightUnit?: InputMaybe<WeightUnit>;
  dialpadOfficeId?: InputMaybe<Scalars['String']['input']>;
  directPrint?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disables the fixed positioning for daycare or queue columns in the Vetspire UI schedule. */
  disableFixedColumns?: InputMaybe<Scalars['Boolean']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  district?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  enableAbaxis?: InputMaybe<Scalars['Boolean']['input']>;
  enableBoarding?: InputMaybe<Scalars['Boolean']['input']>;
  enableCareCreditToggle?: InputMaybe<Scalars['Boolean']['input']>;
  enableCovetrus?: InputMaybe<Scalars['Boolean']['input']>;
  enableDaycare?: InputMaybe<Scalars['Boolean']['input']>;
  enableDialpad?: InputMaybe<Scalars['Boolean']['input']>;
  enableDoubleBooking?: InputMaybe<Scalars['Boolean']['input']>;
  enableGcp?: InputMaybe<Scalars['Boolean']['input']>;
  enableNova?: InputMaybe<Scalars['Boolean']['input']>;
  enableOnlineBooking?: InputMaybe<Scalars['Boolean']['input']>;
  enableProviderSchedules?: InputMaybe<Scalars['Boolean']['input']>;
  enableReadyForDischarge?: InputMaybe<Scalars['Boolean']['input']>;
  enableReminders?: InputMaybe<Scalars['Boolean']['input']>;
  enableRingCentral?: InputMaybe<Scalars['Boolean']['input']>;
  enableSameDayAppointmentsOnly?: InputMaybe<Scalars['Boolean']['input']>;
  enableStripe?: InputMaybe<Scalars['Boolean']['input']>;
  enableVetsourceIntegration?: InputMaybe<Scalars['Boolean']['input']>;
  enableWaitlist?: InputMaybe<Scalars['Boolean']['input']>;
  enforceControlledDrugLimits?: InputMaybe<Scalars['Boolean']['input']>;
  extension?: InputMaybe<Scalars['String']['input']>;
  facebookLink?: InputMaybe<Scalars['String']['input']>;
  flipLabel?: InputMaybe<Scalars['Boolean']['input']>;
  forwardInboundMessagesToEmail?: InputMaybe<Scalars['Boolean']['input']>;
  gcpAccessToken?: InputMaybe<Scalars['String']['input']>;
  gcpExpiresIn?: InputMaybe<Scalars['Int']['input']>;
  gcpPrinterid?: InputMaybe<Scalars['String']['input']>;
  gcpRefreshToken?: InputMaybe<Scalars['String']['input']>;
  googleLink?: InputMaybe<Scalars['String']['input']>;
  harmonizedSalesTaxNumber?: InputMaybe<Scalars['String']['input']>;
  historicalId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  intacctCashAccount?: InputMaybe<Scalars['String']['input']>;
  intacctEntityId?: InputMaybe<Scalars['String']['input']>;
  intacctLocationId?: InputMaybe<Scalars['String']['input']>;
  inventoryParentLocationId?: InputMaybe<Scalars['ID']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isTest?: InputMaybe<Scalars['Boolean']['input']>;
  labelSize?: InputMaybe<LabelSize>;
  latitude?: InputMaybe<Scalars['String']['input']>;
  legalEntityId?: InputMaybe<Scalars['ID']['input']>;
  longitude?: InputMaybe<Scalars['String']['input']>;
  marketingProviders?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  openDate?: InputMaybe<Scalars['Date']['input']>;
  otherTaxRate?: InputMaybe<Scalars['Decimal']['input']>;
  payrollId?: InputMaybe<Scalars['String']['input']>;
  petlinkPassword?: InputMaybe<Scalars['String']['input']>;
  petlinkUsername?: InputMaybe<Scalars['String']['input']>;
  pharmacyPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  pharmacyWhiteboardEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  pharmacyWhiteboardStatuses?: InputMaybe<Array<Scalars['String']['input']>>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  priceMarkupPercent?: InputMaybe<Scalars['Decimal']['input']>;
  printQrCodePatientLabel?: InputMaybe<Scalars['Boolean']['input']>;
  printnodeComputers?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  printnodePaperSize?: InputMaybe<Scalars['String']['input']>;
  printnodePrinter?: InputMaybe<Scalars['Int']['input']>;
  rabiesCertificateStateRequirement?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  scratchpayId?: InputMaybe<Scalars['String']['input']>;
  showDoctorDeaNumber?: InputMaybe<Scalars['Boolean']['input']>;
  showUnscheduledProviders?: InputMaybe<Scalars['Boolean']['input']>;
  showVialNumber?: InputMaybe<Scalars['Boolean']['input']>;
  squareLocationId?: InputMaybe<Scalars['String']['input']>;
  stateTaxRate?: InputMaybe<Scalars['Decimal']['input']>;
  stripeAccessToken?: InputMaybe<Scalars['String']['input']>;
  stripeCustomerId?: InputMaybe<Scalars['String']['input']>;
  stripeLocationId?: InputMaybe<Scalars['String']['input']>;
  stripePublishableKey?: InputMaybe<Scalars['String']['input']>;
  stripeRefreshToken?: InputMaybe<Scalars['String']['input']>;
  stripeUserId?: InputMaybe<Scalars['String']['input']>;
  surgeryCapacity?: InputMaybe<Scalars['Int']['input']>;
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  vetsourceId?: InputMaybe<Scalars['String']['input']>;
  waitlistReadyMessage?: InputMaybe<Scalars['String']['input']>;
  yelpLink?: InputMaybe<Scalars['String']['input']>;
};

/** Result of updating a location's integrations settings */
export type LocationIntegrations = {
  __typename?: 'LocationIntegrations';
  location: Location;
  message?: Maybe<Scalars['String']['output']>;
};

export type LocationIntegrationsInput = {
  cardconnectMerchantId?: InputMaybe<Scalars['String']['input']>;
  cardconnectPaymentPage?: InputMaybe<Scalars['String']['input']>;
  cardconnectTerminals?: InputMaybe<Scalars['JSON']['input']>;
  careCreditPaymentUrl?: InputMaybe<Scalars['String']['input']>;
  covetrusContextKey?: InputMaybe<Scalars['String']['input']>;
  cubexDbName?: InputMaybe<Scalars['String']['input']>;
  cubexPassword?: InputMaybe<Scalars['String']['input']>;
  cubexUsername?: InputMaybe<Scalars['String']['input']>;
  enableCareCreditToggle?: InputMaybe<Scalars['Boolean']['input']>;
  enableCovetrus?: InputMaybe<Scalars['Boolean']['input']>;
  enableCubex?: InputMaybe<Scalars['Boolean']['input']>;
  enableCubexTwoWay?: InputMaybe<Scalars['Boolean']['input']>;
  enableHfd?: InputMaybe<Scalars['Boolean']['input']>;
  enableStripe?: InputMaybe<Scalars['Boolean']['input']>;
  enableVetsourceIntegration?: InputMaybe<Scalars['Boolean']['input']>;
  hfdProviderId?: InputMaybe<Scalars['String']['input']>;
  intacctCashAccount?: InputMaybe<Scalars['String']['input']>;
  intacctEntityId?: InputMaybe<Scalars['String']['input']>;
  intacctLocationId?: InputMaybe<Scalars['String']['input']>;
  petlinkPassword?: InputMaybe<Scalars['String']['input']>;
  petlinkUsername?: InputMaybe<Scalars['String']['input']>;
  scratchpayId?: InputMaybe<Scalars['String']['input']>;
  squareLocationId?: InputMaybe<Scalars['String']['input']>;
  stripeAccessToken?: InputMaybe<Scalars['String']['input']>;
  stripeCustomerId?: InputMaybe<Scalars['String']['input']>;
  stripeLocationId?: InputMaybe<Scalars['String']['input']>;
  stripePublishableKey?: InputMaybe<Scalars['String']['input']>;
  stripeRefreshToken?: InputMaybe<Scalars['String']['input']>;
  stripeUserId?: InputMaybe<Scalars['String']['input']>;
  vetsourceId?: InputMaybe<Scalars['String']['input']>;
};

export type LocationKpi = {
  __typename?: 'LocationKpi';
  data?: Maybe<Scalars['JSON']['output']>;
  date?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type LocationOrLocationTag = Location | LocationTag;

export type LocationProviderSchedule = {
  __typename?: 'LocationProviderSchedule';
  end?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  isChanged?: Maybe<Scalars['Boolean']['output']>;
  locationSchedule?: Maybe<LocationSchedule>;
  provider?: Maybe<Provider>;
  providerId?: Maybe<Scalars['ID']['output']>;
  scheduleRecurrenceId?: Maybe<Scalars['ID']['output']>;
  scheduleTemplate?: Maybe<ScheduleTemplate>;
  start?: Maybe<Scalars['Date']['output']>;
};

export type LocationProviderScheduleInput = {
  end?: InputMaybe<Scalars['Date']['input']>;
  locationId?: InputMaybe<Scalars['ID']['input']>;
  locationScheduleId?: InputMaybe<Scalars['ID']['input']>;
  providerId?: InputMaybe<Scalars['ID']['input']>;
  scheduleTemplateId?: InputMaybe<Scalars['ID']['input']>;
  start?: InputMaybe<Scalars['Date']['input']>;
};

export type LocationSchedule = {
  __typename?: 'LocationSchedule';
  appointmentTypes?: Maybe<Array<Maybe<AppointmentType>>>;
  departmentId?: Maybe<Scalars['ID']['output']>;
  departments?: Maybe<Array<Maybe<Department>>>;
  id?: Maybe<Scalars['ID']['output']>;
  isQueue?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  position?: Maybe<Scalars['Int']['output']>;
};

export type LocationScheduleInput = {
  appointmentTypeIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  isQueue?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
};

export type LocationTag = {
  __typename?: 'LocationTag';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  packageMarkupPercent?: Maybe<Scalars['Decimal']['output']>;
  productMarkupPercent?: Maybe<Scalars['Decimal']['output']>;
  productTypeMarkupPercent?: Maybe<Scalars['Decimal']['output']>;
};


export type LocationTagPackageMarkupPercentArgs = {
  id: Scalars['ID']['input'];
};


export type LocationTagProductMarkupPercentArgs = {
  id: Scalars['ID']['input'];
};


export type LocationTagProductTypeMarkupPercentArgs = {
  id: Scalars['ID']['input'];
};

export type LocationTagInput = {
  name?: InputMaybe<Scalars['String']['input']>;
};

export type LowStockThreshold = {
  __typename?: 'LowStockThreshold';
  id?: Maybe<Scalars['ID']['output']>;
  locationId?: Maybe<Scalars['ID']['output']>;
  reorderQuantity?: Maybe<Scalars['Int']['output']>;
  threshold?: Maybe<Scalars['Int']['output']>;
};

export type LowStockThresholdInput = {
  locationId?: InputMaybe<Scalars['ID']['input']>;
  productId?: InputMaybe<Scalars['ID']['input']>;
  reorderQuantity?: InputMaybe<Scalars['Int']['input']>;
  threshold?: InputMaybe<Scalars['Int']['input']>;
};

export type Macro = {
  __typename?: 'Macro';
  id?: Maybe<Scalars['ID']['output']>;
  insertedAt?: Maybe<Scalars['NaiveDateTime']['output']>;
  isUniversal?: Maybe<Scalars['Boolean']['output']>;
  locations?: Maybe<Array<Maybe<Location>>>;
  name?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
};

export type MacroInput = {
  isUniversal?: InputMaybe<Scalars['Boolean']['input']>;
  locationIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
};

export type ManualArAdjustmentResult = {
  __typename?: 'ManualArAdjustmentResult';
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type MassUploadResult = {
  __typename?: 'MassUploadResult';
  adjustmentsInserted: Array<Maybe<Scalars['String']['output']>>;
  uploadErrors: Array<Maybe<RowUploadError>>;
};

export type MasterProduct = {
  __typename?: 'MasterProduct';
  date?: Maybe<Scalars['Date']['output']>;
  dueDate?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  patientId?: Maybe<Scalars['ID']['output']>;
  productId?: Maybe<Scalars['ID']['output']>;
};

/** A medication */
export type Medication = {
  __typename?: 'Medication';
  /** Provider who created the medication */
  creator?: Maybe<Provider>;
  /** Sum of quantities across non-deleted refill medications for refill cap validation, excluding this one and the initial/root fill */
  cumulativeSiblingQuantity?: Maybe<Scalars['Decimal']['output']>;
  /** Date the medication was filled/dispensed */
  dateFilled?: Maybe<Scalars['Date']['output']>;
  /** Number of days the medication is expected to last */
  daysSupply?: Maybe<Scalars['Int']['output']>;
  deaNumber?: Maybe<Scalars['String']['output']>;
  declineReason?: Maybe<DeclineReason>;
  declined?: Maybe<Scalars['Boolean']['output']>;
  /** Max total quantity allowed for non-root refill medications when refills are greater than 0 (pharmacy_snapshot.quantity × pharmacy_snapshot.refills); initial/root fills and 0/nil refills are uncapped */
  dispenseCap?: Maybe<Scalars['Decimal']['output']>;
  dispensed?: Maybe<Scalars['Decimal']['output']>;
  dose?: Maybe<Scalars['String']['output']>;
  /** (optional) Encounter the medication was prescribed during if applicable */
  encounter?: Maybe<Encounter>;
  frequency?: Maybe<Scalars['String']['output']>;
  fulfillmentSource?: Maybe<FulfillmentSource>;
  historical?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  insertedAt?: Maybe<Scalars['NaiveDateTime']['output']>;
  isExternal?: Maybe<Scalars['Boolean']['output']>;
  isIssuedViaCubex?: Maybe<Scalars['Boolean']['output']>;
  labelPdf?: Maybe<Scalars['String']['output']>;
  /** Returns the appropriate label PDF based on the DIMSUMedicationsLabel feature flag */
  labelPdfAuto?: Maybe<Scalars['String']['output']>;
  labelPdfModern?: Maybe<Scalars['String']['output']>;
  lastEditedAt?: Maybe<Scalars['DateTime']['output']>;
  lastEditedBy?: Maybe<Provider>;
  lastEditedById?: Maybe<Scalars['ID']['output']>;
  lastEditedBySessionId?: Maybe<Scalars['String']['output']>;
  location?: Maybe<Location>;
  locationId?: Maybe<Scalars['ID']['output']>;
  /** The prescription's lot number */
  lotNumber?: Maybe<Scalars['String']['output']>;
  medicationManufacturers?: Maybe<Array<Maybe<MedicationManufacturer>>>;
  method?: Maybe<ProductApplicationType>;
  /** Detailed name of the medication prescribed */
  name?: Maybe<Scalars['String']['output']>;
  /** Additional information about the prescription */
  note?: Maybe<Scalars['String']['output']>;
  orderItem?: Maybe<OrderItem>;
  packageItem?: Maybe<ProductPackageItem>;
  /** Patient whom is taking the medication */
  patient?: Maybe<Patient>;
  pdf?: Maybe<Scalars['String']['output']>;
  /** Timestamp when the prescription was approved */
  pharmacyApprovedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Provider who approved the prescription in the pharmacy */
  pharmacyApprovedBy?: Maybe<Provider>;
  /** Provider who collected/picked up the prescription */
  pharmacyCollectedBy?: Maybe<Provider>;
  /** Timestamp when the prescription entered the Fill In Progress pharmacy status */
  pharmacyFillInProgressAt?: Maybe<Scalars['DateTime']['output']>;
  /** Provider who moved the prescription into the Fill In Progress pharmacy status */
  pharmacyFillInProgressBy?: Maybe<Provider>;
  /** Timestamp when the prescription entered the Final Rx Check pharmacy status */
  pharmacyFillVerificationAt?: Maybe<Scalars['DateTime']['output']>;
  /** Provider who moved the prescription into the Final Rx Check pharmacy status */
  pharmacyFillVerificationBy?: Maybe<Provider>;
  /** Provider who filled the prescription in the pharmacy */
  pharmacyFilledBy?: Maybe<Provider>;
  /** Provider who placed the prescription on hold */
  pharmacyOnHoldBy?: Maybe<Provider>;
  /** Timestamp when the prescription entered the Rx Approved pharmacy status */
  pharmacyPrescriptionApprovedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Provider who moved the prescription into the Rx Approved pharmacy status */
  pharmacyPrescriptionApprovedBy?: Maybe<Provider>;
  /** Provider who rejected the prescription */
  pharmacyRejectedBy?: Maybe<Provider>;
  /** Reason for rejecting the prescription */
  pharmacyRejectionReason?: Maybe<PharmacyRejectionReason>;
  /** Immutable snapshot of the medication's original state when first sent to pharmacy */
  pharmacySnapshot?: Maybe<PharmacySnapshot>;
  pharmacyStatus?: Maybe<PharmacyStatus>;
  /** Timestamp when the prescription was verified */
  pharmacyVerifiedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Provider who verified the prescription */
  pharmacyVerifiedBy?: Maybe<Provider>;
  /** Provider who prescribed the medication */
  prescriber?: Maybe<Provider>;
  product?: Maybe<Product>;
  productId?: Maybe<Scalars['ID']['output']>;
  productSuggestion?: Maybe<ProductSuggestion>;
  /** The amount of the medication */
  quantity?: Maybe<Scalars['Decimal']['output']>;
  quantityUnit?: Maybe<Scalars['String']['output']>;
  /** Date the medication's refills are valid by */
  refillByDate?: Maybe<Scalars['Date']['output']>;
  refillParent?: Maybe<Medication>;
  /** Position in the refill chain (0 = original, 1 = first refill, etc.) */
  refillSequence?: Maybe<Scalars['Int']['output']>;
  /** Number of refills originally prescribed */
  refills?: Maybe<Scalars['Int']['output']>;
  /** number of refills used */
  refillsUsed?: Maybe<Scalars['Int']['output']>;
  /** Provider who originally requested this medication or requested approval for this medication order */
  requestedBy?: Maybe<Provider>;
  rootMedication?: Maybe<Medication>;
  /** ID of the original medication in a refill chain */
  rootMedicationId?: Maybe<Scalars['ID']['output']>;
  /** Label/instructions for the administration of the medication */
  sig?: Maybe<Scalars['String']['output']>;
  sourceDocument?: Maybe<PatientDocument>;
  /** Date the medication's administration started */
  start?: Maybe<Scalars['Date']['output']>;
  status?: Maybe<MedicationStatus>;
  /** Date the medication's administration should cease */
  stop?: Maybe<Scalars['Date']['output']>;
  /** Indicates whether this medication is intended for the client to take home */
  toGoHome?: Maybe<Scalars['Boolean']['output']>;
  updatedAt?: Maybe<Scalars['NaiveDateTime']['output']>;
  /** Whether this medication uses legacy per-fill RX numbering */
  usesLegacyRefills?: Maybe<Scalars['Boolean']['output']>;
  vetsourced?: Maybe<Scalars['Boolean']['output']>;
  /** The prescription's vial number */
  vialNumber?: Maybe<Scalars['String']['output']>;
  visit?: Maybe<Visit>;
  /** The amount wasted from Cubex */
  wasteQuantity?: Maybe<Scalars['Decimal']['output']>;
};


/** A medication */
export type MedicationLabelPdfArgs = {
  locationId: Scalars['ID']['input'];
};


/** A medication */
export type MedicationLabelPdfAutoArgs = {
  locationId: Scalars['ID']['input'];
};


/** A medication */
export type MedicationPdfArgs = {
  locationId: Scalars['ID']['input'];
};

export type MedicationConnection = {
  __typename?: 'MedicationConnection';
  edges?: Maybe<Array<Maybe<MedicationEdge>>>;
  pageInfo: PageInfo;
};

export type MedicationEdge = {
  __typename?: 'MedicationEdge';
  cursor?: Maybe<Scalars['String']['output']>;
  node?: Maybe<Medication>;
};

export type MedicationInput = {
  creatorId?: InputMaybe<Scalars['ID']['input']>;
  daysSupply?: InputMaybe<Scalars['Int']['input']>;
  declineReasonId?: InputMaybe<Scalars['ID']['input']>;
  declined?: InputMaybe<Scalars['Boolean']['input']>;
  dispensed?: InputMaybe<Scalars['Decimal']['input']>;
  dose?: InputMaybe<Scalars['String']['input']>;
  encounterId?: InputMaybe<Scalars['ID']['input']>;
  frequency?: InputMaybe<Scalars['String']['input']>;
  fulfillmentSourceId?: InputMaybe<Scalars['ID']['input']>;
  historical?: InputMaybe<Scalars['Boolean']['input']>;
  isExternal?: InputMaybe<Scalars['Boolean']['input']>;
  locationId?: InputMaybe<Scalars['ID']['input']>;
  lotNumber?: InputMaybe<Scalars['String']['input']>;
  medicationManufacturers?: InputMaybe<Array<InputMaybe<MedicationManufacturerInput>>>;
  method?: InputMaybe<ProductApplicationType>;
  name?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  patientId?: InputMaybe<Scalars['ID']['input']>;
  prescriberId?: InputMaybe<Scalars['ID']['input']>;
  productId?: InputMaybe<Scalars['ID']['input']>;
  productSuggestionId?: InputMaybe<Scalars['ID']['input']>;
  quantity?: InputMaybe<Scalars['Decimal']['input']>;
  quantityUnit?: InputMaybe<Scalars['String']['input']>;
  refillByDate?: InputMaybe<Scalars['Date']['input']>;
  refills?: InputMaybe<Scalars['Int']['input']>;
  sig?: InputMaybe<Scalars['String']['input']>;
  sourceDocumentId?: InputMaybe<Scalars['ID']['input']>;
  start?: InputMaybe<Scalars['Date']['input']>;
  status?: InputMaybe<MedicationStatus>;
  stop?: InputMaybe<Scalars['Date']['input']>;
  toGoHome?: InputMaybe<Scalars['Boolean']['input']>;
  /** The prescription's vial number */
  vialNumber?: InputMaybe<Scalars['String']['input']>;
  visitId?: InputMaybe<Scalars['ID']['input']>;
};

export type MedicationIntegrationTransaction = {
  __typename?: 'MedicationIntegrationTransaction';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deleted: Scalars['Boolean']['output'];
  id?: Maybe<Scalars['ID']['output']>;
  integrationName: Scalars['String']['output'];
  locationId: Scalars['ID']['output'];
  medicationId?: Maybe<Scalars['ID']['output']>;
  orgId: Scalars['ID']['output'];
  orphanData?: Maybe<Scalars['JSON']['output']>;
  productType?: Maybe<Scalars['String']['output']>;
  transactionType: Scalars['String']['output'];
  unitOfMeasure?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type MedicationIntegrationTransactionConnection = {
  __typename?: 'MedicationIntegrationTransactionConnection';
  edges?: Maybe<Array<Maybe<MedicationIntegrationTransactionEdge>>>;
  pageInfo: PageInfo;
};

export type MedicationIntegrationTransactionEdge = {
  __typename?: 'MedicationIntegrationTransactionEdge';
  cursor?: Maybe<Scalars['String']['output']>;
  node?: Maybe<MedicationIntegrationTransaction>;
};

/** Medication manufacturer tracking */
export type MedicationManufacturer = {
  __typename?: 'MedicationManufacturer';
  expiryDate?: Maybe<Scalars['Date']['output']>;
  historicalId?: Maybe<Scalars['ID']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  insertedAt?: Maybe<Scalars['NaiveDateTime']['output']>;
  lotNumber?: Maybe<Scalars['String']['output']>;
  manufacturer?: Maybe<ProductManufacturer>;
  manufacturerId?: Maybe<Scalars['ID']['output']>;
  manufacturerName?: Maybe<Scalars['String']['output']>;
  medication?: Maybe<Medication>;
  medicationId?: Maybe<Scalars['ID']['output']>;
  medicationName?: Maybe<Scalars['String']['output']>;
  org?: Maybe<Org>;
  orgId?: Maybe<Scalars['ID']['output']>;
  quantity?: Maybe<Scalars['Decimal']['output']>;
  updatedAt?: Maybe<Scalars['NaiveDateTime']['output']>;
  /** The prescription's vial number */
  vialNumber?: Maybe<Scalars['String']['output']>;
};

export type MedicationManufacturerInput = {
  expiryDate?: InputMaybe<Scalars['Date']['input']>;
  historicalId?: InputMaybe<Scalars['ID']['input']>;
  lotNumber?: InputMaybe<Scalars['String']['input']>;
  manufacturerId?: InputMaybe<Scalars['ID']['input']>;
  manufacturerName?: InputMaybe<Scalars['String']['input']>;
  medicationName?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Decimal']['input']>;
  /** The prescription's vial number */
  vialNumber?: InputMaybe<Scalars['String']['input']>;
};

export type MedicationPharmacyFieldsInput = {
  daysSupply?: InputMaybe<Scalars['Int']['input']>;
  dose?: InputMaybe<Scalars['String']['input']>;
  frequency?: InputMaybe<Scalars['String']['input']>;
  lotNumber?: InputMaybe<Scalars['String']['input']>;
  medicationManufacturers?: InputMaybe<Array<InputMaybe<MedicationManufacturerInput>>>;
  method?: InputMaybe<ProductApplicationType>;
  note?: InputMaybe<Scalars['String']['input']>;
  prescriberId?: InputMaybe<Scalars['ID']['input']>;
  quantity?: InputMaybe<Scalars['Decimal']['input']>;
  quantityUnit?: InputMaybe<Scalars['String']['input']>;
  refillByDate?: InputMaybe<Scalars['Date']['input']>;
  refills?: InputMaybe<Scalars['Int']['input']>;
  sessionId?: InputMaybe<Scalars['String']['input']>;
  sig?: InputMaybe<Scalars['String']['input']>;
  stop?: InputMaybe<Scalars['Date']['input']>;
  toGoHome?: InputMaybe<Scalars['Boolean']['input']>;
  /** The prescription's vial number */
  vialNumber?: InputMaybe<Scalars['String']['input']>;
};

export type MedicationPharmacyStatusInput = {
  creatorId?: InputMaybe<Scalars['ID']['input']>;
  daysSupply?: InputMaybe<Scalars['Int']['input']>;
  declined?: InputMaybe<Scalars['Boolean']['input']>;
  dispensed?: InputMaybe<Scalars['Decimal']['input']>;
  dose?: InputMaybe<Scalars['String']['input']>;
  encounterId?: InputMaybe<Scalars['ID']['input']>;
  frequency?: InputMaybe<Scalars['String']['input']>;
  fulfillmentSourceId?: InputMaybe<Scalars['ID']['input']>;
  historical?: InputMaybe<Scalars['Boolean']['input']>;
  isExternal?: InputMaybe<Scalars['Boolean']['input']>;
  locationId?: InputMaybe<Scalars['ID']['input']>;
  lotNumber?: InputMaybe<Scalars['String']['input']>;
  method?: InputMaybe<ProductApplicationType>;
  name?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  patientId?: InputMaybe<Scalars['ID']['input']>;
  pharmacyApprovedAt?: InputMaybe<Scalars['DateTime']['input']>;
  pharmacyApprovedById?: InputMaybe<Scalars['ID']['input']>;
  pharmacyCollectedById?: InputMaybe<Scalars['ID']['input']>;
  pharmacyFillInProgressById?: InputMaybe<Scalars['ID']['input']>;
  pharmacyFilledById?: InputMaybe<Scalars['ID']['input']>;
  pharmacyOnHoldById?: InputMaybe<Scalars['ID']['input']>;
  pharmacyPrescriptionApprovedById?: InputMaybe<Scalars['ID']['input']>;
  pharmacyRejectedById?: InputMaybe<Scalars['ID']['input']>;
  pharmacyRejectionReason?: InputMaybe<PharmacyRejectionReason>;
  pharmacyStatus: PharmacyStatus;
  pharmacyVerifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  pharmacyVerifiedById?: InputMaybe<Scalars['ID']['input']>;
  prescriberId?: InputMaybe<Scalars['ID']['input']>;
  productId?: InputMaybe<Scalars['ID']['input']>;
  quantity?: InputMaybe<Scalars['Decimal']['input']>;
  quantityUnit?: InputMaybe<Scalars['String']['input']>;
  refillByDate?: InputMaybe<Scalars['Date']['input']>;
  refills?: InputMaybe<Scalars['Int']['input']>;
  sessionId?: InputMaybe<Scalars['String']['input']>;
  sig?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['Date']['input']>;
  status?: InputMaybe<MedicationStatus>;
  stop?: InputMaybe<Scalars['Date']['input']>;
  toGoHome?: InputMaybe<Scalars['Boolean']['input']>;
  /** The prescription's vial number */
  vialNumber?: InputMaybe<Scalars['String']['input']>;
  visitId?: InputMaybe<Scalars['ID']['input']>;
};

export enum MedicationStatus {
  Active = 'ACTIVE',
  Any = 'ANY',
  /** Indicates that a medication order from a Cubex cabinet was declined. Should only be used when the Cubex Two-Way integration is enabled. */
  ApprovalDeclined = 'APPROVAL_DECLINED',
  Completed = 'COMPLETED',
  Declined = 'DECLINED',
  Deleted = 'DELETED',
  Draft = 'DRAFT',
  Pending = 'PENDING',
  /** Indicates a medication ordered from a Cubex cabinet that requires approval. Should only be used when the Cubex Two-Way integration is enabled. */
  PendingApproval = 'PENDING_APPROVAL',
  /** Indicates a medication order that requires approval from a licensed provider. Used for the medication approval workflow. */
  PharmacyApprovalPending = 'PHARMACY_APPROVAL_PENDING',
  Refilled = 'REFILLED',
  /** Indicates a medication returned via a Cubex cabinet. Should only be used when the Cubex Two-Way integration is enabled. */
  Returned = 'RETURNED',
  /** Indicates a medication has been sent to the Pharmacy Whiteboard for fulfillment. */
  SentToPharmacy = 'SENT_TO_PHARMACY',
  Stopped = 'STOPPED',
  /** Indicates a medication imported from an external system that requires manual verification before use. */
  VerificationNeeded = 'VERIFICATION_NEEDED'
}

/** Count of medications grouped by status */
export type MedicationStatusCount = {
  __typename?: 'MedicationStatusCount';
  /** Number of medications with this status */
  count: Scalars['Int']['output'];
  /** The pharmacy status */
  pharmacyStatus?: Maybe<PharmacyStatus>;
  /** The medication status */
  status: MedicationStatus;
};

export type MedicationsFilledReportItem = {
  __typename?: 'MedicationsFilledReportItem';
  clientId?: Maybe<Scalars['ID']['output']>;
  clientName?: Maybe<Scalars['String']['output']>;
  dateFilled?: Maybe<Scalars['Date']['output']>;
  datePrescribed?: Maybe<Scalars['Date']['output']>;
  daysSupply?: Maybe<Scalars['Int']['output']>;
  dose?: Maybe<Scalars['String']['output']>;
  doseUnit?: Maybe<Scalars['String']['output']>;
  frequency?: Maybe<Scalars['String']['output']>;
  locationId?: Maybe<Scalars['ID']['output']>;
  locationName?: Maybe<Scalars['String']['output']>;
  medicationId?: Maybe<Scalars['ID']['output']>;
  medicationName?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  patientAge?: Maybe<Scalars['String']['output']>;
  patientBreed?: Maybe<Scalars['String']['output']>;
  patientId?: Maybe<Scalars['ID']['output']>;
  patientName?: Maybe<Scalars['String']['output']>;
  patientSex?: Maybe<Scalars['String']['output']>;
  patientSpecies?: Maybe<Scalars['String']['output']>;
  patientWeight?: Maybe<Scalars['String']['output']>;
  pharmacyApprovedByName?: Maybe<Scalars['String']['output']>;
  pharmacyFilledByName?: Maybe<Scalars['String']['output']>;
  pharmacyStatus?: Maybe<PharmacyStatus>;
  prescriberId?: Maybe<Scalars['ID']['output']>;
  prescriberName?: Maybe<Scalars['String']['output']>;
  quantity?: Maybe<Scalars['String']['output']>;
  refills?: Maybe<Scalars['Int']['output']>;
  sig?: Maybe<Scalars['String']['output']>;
};

export type MedicationsFilledReportResult = {
  __typename?: 'MedicationsFilledReportResult';
  medications?: Maybe<Array<Maybe<MedicationsFilledReportItem>>>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type MedicationsReportItem = {
  __typename?: 'MedicationsReportItem';
  clientId?: Maybe<Scalars['ID']['output']>;
  clientName?: Maybe<Scalars['String']['output']>;
  dateAdministered?: Maybe<Scalars['Date']['output']>;
  dateExpiry?: Maybe<Scalars['Date']['output']>;
  daysSupply?: Maybe<Scalars['Int']['output']>;
  departmentId?: Maybe<Scalars['ID']['output']>;
  departmentName?: Maybe<Scalars['String']['output']>;
  dose?: Maybe<Scalars['String']['output']>;
  doseUnit?: Maybe<Scalars['String']['output']>;
  frequency?: Maybe<Scalars['String']['output']>;
  locationId?: Maybe<Scalars['ID']['output']>;
  locationName?: Maybe<Scalars['String']['output']>;
  medicationId?: Maybe<Scalars['ID']['output']>;
  medicationName?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  patientAge?: Maybe<Scalars['String']['output']>;
  patientBreed?: Maybe<Scalars['String']['output']>;
  patientId?: Maybe<Scalars['ID']['output']>;
  patientName?: Maybe<Scalars['String']['output']>;
  patientSex?: Maybe<Scalars['String']['output']>;
  patientSpecies?: Maybe<Scalars['String']['output']>;
  patientWeight?: Maybe<Scalars['String']['output']>;
  providerId?: Maybe<Scalars['ID']['output']>;
  providerName?: Maybe<Scalars['String']['output']>;
  quantity?: Maybe<Scalars['String']['output']>;
  refills?: Maybe<Scalars['Int']['output']>;
  sig?: Maybe<Scalars['String']['output']>;
  status?: Maybe<MedicationStatus>;
  visitEndDate?: Maybe<Scalars['Date']['output']>;
  visitEndTime?: Maybe<Scalars['String']['output']>;
};

export type MedicationsReportResult = {
  __typename?: 'MedicationsReportResult';
  medications?: Maybe<Array<Maybe<MedicationsReportItem>>>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A single message in a conversation */
export type Message = {
  __typename?: 'Message';
  attachments?: Maybe<Array<Maybe<Attachment>>>;
  body?: Maybe<Scalars['String']['output']>;
  conversation?: Maybe<Conversation>;
  deletedAt?: Maybe<Scalars['NaiveDateTime']['output']>;
  deliveryStatus?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  insertedAt?: Maybe<Scalars['NaiveDateTime']['output']>;
  isAutomatedMessage?: Maybe<Scalars['Boolean']['output']>;
  recipientAddress?: Maybe<Scalars['String']['output']>;
  sender?: Maybe<MessageSender>;
  senderAddress?: Maybe<Scalars['String']['output']>;
  /** @deprecated Please use `delivery_status` instead */
  status?: Maybe<Scalars['String']['output']>;
};

/** A sender of a message, either a provider, client, rdvm or an associate */
export type MessageSender = Client | Coowner | Provider | Rdvm;

export type Modality = {
  __typename?: 'Modality';
  code?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type MonitorDatum = Datum & {
  __typename?: 'MonitorDatum';
  inline?: Maybe<Scalars['Truthy']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  required?: Maybe<Scalars['Truthy']['output']>;
  text?: Maybe<Scalars['Truthy']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
  values?: Maybe<Scalars['JSON']['output']>;
};

export type Monograph = {
  __typename?: 'Monograph';
  aliases?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  clarification?: Maybe<Scalars['String']['output']>;
  commercialNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  consensusStatement?: Maybe<Scalars['String']['output']>;
  contentType?: Maybe<Scalars['String']['output']>;
  drugClass?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  guides?: Maybe<Array<Maybe<MonographGuide>>>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  plumbsCreatedAt?: Maybe<Scalars['DateTime']['output']>;
  plumbsId?: Maybe<Scalars['String']['output']>;
  plumbsUpdatedAt?: Maybe<Scalars['DateTime']['output']>;
  pronunciation?: Maybe<Scalars['String']['output']>;
  publicationDetails?: Maybe<Scalars['String']['output']>;
  sections?: Maybe<Array<Maybe<MonographSection>>>;
  species?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  title?: Maybe<Scalars['String']['output']>;
};

export type MonographGuide = {
  __typename?: 'MonographGuide';
  plumbsId?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type MonographSection = {
  __typename?: 'MonographSection';
  title?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export enum Month {
  /** April */
  April = 'APRIL',
  /** August */
  August = 'AUGUST',
  /** December */
  December = 'DECEMBER',
  /** February */
  February = 'FEBRUARY',
  /** January */
  January = 'JANUARY',
  /** July */
  July = 'JULY',
  /** June */
  June = 'JUNE',
  /** March */
  March = 'MARCH',
  /** May */
  May = 'MAY',
  /** November */
  November = 'NOVEMBER',
  /** October */
  October = 'OCTOBER',
  /** September */
  September = 'SEPTEMBER'
}

export enum MonthlyDueDateType {
  /** Due date is the end of the month */
  EndOfMonth = 'END_OF_MONTH',
  /** Due date is a specific day of the month */
  SpecificDay = 'SPECIFIC_DAY'
}

export type Newsletter = {
  __typename?: 'Newsletter';
  audience?: Maybe<Scalars['JSON']['output']>;
  body?: Maybe<Scalars['String']['output']>;
  from?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  insertedAt?: Maybe<Scalars['NaiveDateTime']['output']>;
  numberSent?: Maybe<Scalars['Int']['output']>;
  /** Estimated number of messages to be sent. */
  numberToBeSent?: Maybe<Scalars['Int']['output']>;
  sent?: Maybe<Scalars['Boolean']['output']>;
  sentAt?: Maybe<Scalars['DateTime']['output']>;
  subject?: Maybe<Scalars['String']['output']>;
};

export type NewsletterInput = {
  audience?: InputMaybe<Scalars['JSON']['input']>;
  body?: InputMaybe<Scalars['String']['input']>;
  from?: InputMaybe<Scalars['String']['input']>;
  subject?: InputMaybe<Scalars['String']['input']>;
};

export type NoteDatum = Datum & {
  __typename?: 'NoteDatum';
  full?: Maybe<Scalars['Truthy']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  required?: Maybe<Scalars['Truthy']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type Notification = {
  __typename?: 'Notification';
  id: Scalars['ID']['output'];
  insertedAt: Scalars['NaiveDateTime']['output'];
  message?: Maybe<Scalars['String']['output']>;
  metadata?: Maybe<NotificationMetadata>;
  patient?: Maybe<Patient>;
  read: Scalars['Boolean']['output'];
  title?: Maybe<Scalars['String']['output']>;
  type: NotificationType;
};

export type NotificationMetadata = {
  __typename?: 'NotificationMetadata';
  encounterId?: Maybe<Scalars['ID']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
};

export enum NotificationType {
  ApprovalRequiredMedication = 'APPROVAL_REQUIRED_MEDICATION',
  Lab = 'LAB',
  RdvmMarketing = 'RDVM_MARKETING',
  ScribeCompleted = 'SCRIBE_COMPLETED',
  TaskAssigned = 'TASK_ASSIGNED',
  TaskComment = 'TASK_COMMENT',
  TaskCompleted = 'TASK_COMPLETED',
  TextPaymentReceived = 'TEXT_PAYMENT_RECEIVED'
}

export type NovaBoardCell = {
  __typename?: 'NovaBoardCell';
  completedCount: Scalars['Int']['output'];
  discontinuedCount: Scalars['Int']['output'];
  incompleteCount: Scalars['Int']['output'];
  plannedCount: Scalars['Int']['output'];
  /**
   * How many as needed (PRN) slots fall on the hour, across all rows. Not part of
   * `plannedCount` or `incompleteCount` — a PRN slot is not a dose anybody owes.
   * A cell with a PRN slot and nothing owed has `status: PRN`; a cell with both
   * keeps the owed status and still reports this count.
   */
  prnCount: Scalars['Int']['output'];
  skippedCount: Scalars['Int']['output'];
  startTime: Scalars['DateTime']['output'];
  status: NovaBoardCellStatus;
  treatments: Array<TreatmentInfo>;
};

export enum NovaBoardCellStatus {
  Completed = 'COMPLETED',
  Due = 'DUE',
  Inactive = 'INACTIVE',
  Late = 'LATE',
  None = 'NONE',
  Planned = 'PLANNED',
  /**
   * The hour carries an as needed (PRN) slot and nothing that is owed. Excluded
   * from `plannedCount`, `completedCount`, `skippedCount` and `incompleteCount` —
   * see `prnCount` and `TreatmentInfo.prnTimes`.
   *
   * A new enum value, so a **breaking change** for a client generated against an
   * earlier schema. `PRN` only ever appears where `NONE` would have, never
   * displacing `DUE`, `LATE`, `PLANNED`, `COMPLETED`, `SKIPPED` or `INACTIVE`, so
   * an unaware client falls through to its default rendering rather than
   * mistaking a PRN slot for owed work.
   */
  Prn = 'PRN',
  Skipped = 'SKIPPED'
}

export type NovaBoardFilters = {
  careTeamIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  departmentIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  providerIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  visitTypes?: InputMaybe<Array<VisitType>>;
  wardIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** Cell statistics for a single NovaBoard sheet */
export type NovaBoardRowCells = {
  __typename?: 'NovaBoardRowCells';
  cells: Array<Maybe<NovaBoardCell>>;
  sheetId: Scalars['ID']['output'];
};

/** NovaBoard sheet */
export type NovaBoardSheet = {
  __typename?: 'NovaBoardSheet';
  careTeamMembers?: Maybe<Array<Maybe<TreatmentSheetCareTeamMember>>>;
  cells?: Maybe<Array<Maybe<NovaBoardCell>>>;
  department?: Maybe<Department>;
  departmentId?: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  patient?: Maybe<Patient>;
  /** Ward and kennel linked to this Nova sheet row's treatment sheet, including after the sheet is signed. For where the patient is now, use Patient.lastKnownLocation. */
  patientLocation?: Maybe<PatientLocation>;
  provider?: Maybe<Provider>;
  providerOnShift?: Maybe<Provider>;
  signed: Scalars['Boolean']['output'];
  start?: Maybe<Scalars['DateTime']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  visit?: Maybe<Visit>;
  visitAlerts?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  visitProblemsList?: Maybe<Scalars['String']['output']>;
  visitType?: Maybe<VisitType>;
};


/** NovaBoard sheet */
export type NovaBoardSheetCellsArgs = {
  hoursAfter?: InputMaybe<Scalars['Int']['input']>;
  hoursBefore?: InputMaybe<Scalars['Int']['input']>;
};

export type NovaBoardUpdatePayload = {
  __typename?: 'NovaBoardUpdatePayload';
  locationId: Scalars['ID']['output'];
  sheetId?: Maybe<Scalars['ID']['output']>;
  timestamp: Scalars['DateTime']['output'];
  updateType: NovaBoardUpdateType;
  visitId?: Maybe<Scalars['ID']['output']>;
};

export enum NovaBoardUpdateType {
  CellUpdated = 'CELL_UPDATED',
  ProviderTransfer = 'PROVIDER_TRANSFER',
  RowUpdated = 'ROW_UPDATED',
  SheetCreated = 'SHEET_CREATED',
  SheetDeleted = 'SHEET_DELETED',
  SheetSigned = 'SHEET_SIGNED',
  SheetUpdated = 'SHEET_UPDATED',
  VisitRfdStatusUpdated = 'VISIT_RFD_STATUS_UPDATED'
}

export type NovaSheetMergeInput = {
  rows: Array<NovaSheetRowInput>;
};

export type NovaSheetMergeableTemplate = {
  __typename?: 'NovaSheetMergeableTemplate';
  /** Length of `duplicates`. Convenience field for UIs that only need the count. */
  duplicateCount: Scalars['Int']['output'];
  /**
   * Template rows excluded from `rows` because a treatment with the same
   * (name, type) already exists on the sheet. Surfaced so the UI can show
   * which treatments were skipped or offer conflict resolution.
   */
  duplicates: Array<NovaSheetRowMergeableTemplate>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  /**
   * Template rows the user can merge: those whose (name, type) does not
   * match an existing row on the sheet.
   */
  rows: Array<NovaSheetRowMergeableTemplate>;
};

export type NovaSheetRowInput = {
  administration?: InputMaybe<Scalars['String']['input']>;
  end?: InputMaybe<Scalars['DateTime']['input']>;
  extendedInstructions?: InputMaybe<Scalars['String']['input']>;
  /** Minutes between administrations. See `ScheduleType`. */
  frequency?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['ID']['input'];
  instructions?: InputMaybe<Scalars['String']['input']>;
  isBillable: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  productId?: InputMaybe<Scalars['ID']['input']>;
  quantity?: InputMaybe<Scalars['Decimal']['input']>;
  /**
   * How the row is scheduled. Send it back unchanged on `NovaSheetRowInput` —
   * it is what carries "as needed" through the merge.
   */
  scheduleType?: InputMaybe<ScheduleType>;
  start: Scalars['DateTime']['input'];
  type: TreatmentSheetType;
  unitLabel?: InputMaybe<Scalars['String']['input']>;
  units?: InputMaybe<TreatmentSheetUnits>;
};

export type NovaSheetRowMergeableTemplate = {
  __typename?: 'NovaSheetRowMergeableTemplate';
  administration?: Maybe<Scalars['String']['output']>;
  end?: Maybe<Scalars['DateTime']['output']>;
  extendedInstructions?: Maybe<Scalars['String']['output']>;
  /** Minutes between administrations. See `ScheduleType`. */
  frequency?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  instructions?: Maybe<Scalars['String']['output']>;
  isBillable: Scalars['Boolean']['output'];
  /**
   * Derived from `scheduleType`. On input, `true` is translated to
   * `scheduleType: PRN` when `scheduleType` is absent (NV-934 transition).
   * @deprecated Read `scheduleType` instead.
   */
  isPrn?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  productId?: Maybe<Scalars['ID']['output']>;
  quantity?: Maybe<Scalars['Decimal']['output']>;
  /**
   * How the row is scheduled. Send it back unchanged on `NovaSheetRowInput` —
   * it is what carries "as needed" through the merge.
   */
  scheduleType?: Maybe<ScheduleType>;
  start: Scalars['DateTime']['output'];
  type: TreatmentSheetType;
  unitLabel?: Maybe<Scalars['String']['output']>;
  units?: Maybe<TreatmentSheetUnits>;
};

export type ObanJob = {
  __typename?: 'ObanJob';
  args?: Maybe<Scalars['JSON']['output']>;
  attempt?: Maybe<Scalars['Int']['output']>;
  attemptedAt?: Maybe<Scalars['NaiveDateTime']['output']>;
  completedAt?: Maybe<Scalars['NaiveDateTime']['output']>;
  discardedAt?: Maybe<Scalars['NaiveDateTime']['output']>;
  errors?: Maybe<Scalars['JSON']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  insertedAt?: Maybe<Scalars['NaiveDateTime']['output']>;
  maxAttempts?: Maybe<Scalars['Int']['output']>;
  meta?: Maybe<Scalars['JSON']['output']>;
  priority?: Maybe<Scalars['Int']['output']>;
  queue?: Maybe<Scalars['String']['output']>;
  scheduledAt?: Maybe<Scalars['NaiveDateTime']['output']>;
  state?: Maybe<ObanJobState>;
  worker?: Maybe<Scalars['String']['output']>;
};

export enum ObanJobState {
  Available = 'AVAILABLE',
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  Discarded = 'DISCARDED',
  Executing = 'EXECUTING',
  Retryable = 'RETRYABLE',
  Scheduled = 'SCHEDULED'
}

/** An order is an itemized list of products and/or services to bill a client for */
export type Order = {
  __typename?: 'Order';
  appliedCoupons?: Maybe<Array<Maybe<Coupon>>>;
  cityTaxCents?: Maybe<Scalars['Int']['output']>;
  cityTaxRate?: Maybe<Scalars['Decimal']['output']>;
  client?: Maybe<Client>;
  coownerBreakdown?: Maybe<Array<CoownerBreakdown>>;
  countyTaxCents?: Maybe<Scalars['Int']['output']>;
  countyTaxRate?: Maybe<Scalars['Decimal']['output']>;
  coupon?: Maybe<Coupon>;
  couponDiscountCents?: Maybe<Scalars['Int']['output']>;
  datetime?: Maybe<Scalars['DateTime']['output']>;
  discount?: Maybe<Scalars['Decimal']['output']>;
  discountReason?: Maybe<Scalars['String']['output']>;
  discountType?: Maybe<DiscountType>;
  encounters?: Maybe<Array<Maybe<Encounter>>>;
  estimate?: Maybe<Estimate>;
  flags?: Maybe<Array<Maybe<OrderFlag>>>;
  historicalId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  insertedAt?: Maybe<Scalars['NaiveDateTime']['output']>;
  invoiceReference?: Maybe<Scalars['String']['output']>;
  invoiced?: Maybe<Scalars['Boolean']['output']>;
  invoicedAt?: Maybe<Scalars['DateTime']['output']>;
  invoicedAtDate?: Maybe<Scalars['Date']['output']>;
  /** if this order is representing an account credit */
  isAccountCredit?: Maybe<Scalars['Boolean']['output']>;
  /** if this order is representing a credited order item */
  isCredit?: Maybe<Scalars['Boolean']['output']>;
  /** if this order is representing a not rendered order item */
  isNotRendered?: Maybe<Scalars['Boolean']['output']>;
  itemDiscountWithOrderDiscountCents?: Maybe<Scalars['Int']['output']>;
  itemDiscountWithoutOrderDiscountCents?: Maybe<Scalars['Int']['output']>;
  items?: Maybe<Array<Maybe<OrderItem>>>;
  lateFees?: Maybe<Array<Maybe<LateFee>>>;
  lineDiscountCents?: Maybe<Scalars['Int']['output']>;
  location?: Maybe<Location>;
  locationId?: Maybe<Scalars['ID']['output']>;
  memberDiscountCents?: Maybe<Scalars['Int']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  orderDiscountCents?: Maybe<Scalars['Int']['output']>;
  otherTaxCents?: Maybe<Scalars['Int']['output']>;
  otherTaxRate?: Maybe<Scalars['Decimal']['output']>;
  patient?: Maybe<Patient>;
  patients?: Maybe<Array<Maybe<Patient>>>;
  payLink?: Maybe<Scalars['String']['output']>;
  /** @deprecated Deprecated! Will be removed soon. Use 'total' - 'totalPaid' to calculate instead. */
  paymentDue?: Maybe<Scalars['Price']['output']>;
  paymentDueCents?: Maybe<Scalars['Int']['output']>;
  payments?: Maybe<Array<Maybe<Payment>>>;
  planDiscountCents?: Maybe<Scalars['Int']['output']>;
  posted?: Maybe<Scalars['Boolean']['output']>;
  provider?: Maybe<Provider>;
  stateTaxCents?: Maybe<Scalars['Int']['output']>;
  stateTaxRate?: Maybe<Scalars['Decimal']['output']>;
  status?: Maybe<InvoiceStatus>;
  statusChangeAt?: Maybe<Scalars['DateTime']['output']>;
  /** @deprecated Please use `subtotalCents` */
  subtotal?: Maybe<Scalars['Decimal']['output']>;
  subtotalCents?: Maybe<Scalars['Int']['output']>;
  /**
   * @deprecated This field is deprecated and will only ever return an order's `otherTaxRate`.
   * Orders now have various tax rate fields you may want to read. Please update your queries
   * to pull from `otherTaxRate`, `cityTaxRate`, `stateTaxRate`, and `countyTaxRate`.
   *
   */
  taxRate?: Maybe<Scalars['Decimal']['output']>;
  /** @deprecated Please use `totalAfterTaxCents` */
  total?: Maybe<Scalars['Price']['output']>;
  totalAfterTaxCents?: Maybe<Scalars['Int']['output']>;
  totalBeforeTaxCents?: Maybe<Scalars['Int']['output']>;
  /** @deprecated Please use `itemDiscountWithOrderDiscountCents` */
  totalCouponDiscount?: Maybe<Scalars['Decimal']['output']>;
  totalCreditedCents?: Maybe<Scalars['Int']['output']>;
  totalDiscountCents?: Maybe<Scalars['Int']['output']>;
  /** @deprecated Please use `totalDiscountCents` */
  totalDiscounted?: Maybe<Scalars['Decimal']['output']>;
  /** @deprecated Please use sum of `memberDiscountCents` and `planDiscountCents` */
  totalMemberDiscount?: Maybe<Scalars['Decimal']['output']>;
  /** @deprecated Please use `totalNotRenderedCents` */
  totalNotRendered?: Maybe<Scalars['Decimal']['output']>;
  totalNotRenderedCents?: Maybe<Scalars['Int']['output']>;
  totalPaid?: Maybe<Scalars['Decimal']['output']>;
  /** @deprecated Please use `totalTaxCents` */
  totalTax?: Maybe<Scalars['Decimal']['output']>;
  totalTaxCents?: Maybe<Scalars['Int']['output']>;
  totalTaxRate?: Maybe<Scalars['Decimal']['output']>;
  updatedAt?: Maybe<Scalars['NaiveDateTime']['output']>;
  updatedById?: Maybe<Scalars['ID']['output']>;
  verbiage?: Maybe<Scalars['String']['output']>;
  visit?: Maybe<Visit>;
};


/** An order is an itemized list of products and/or services to bill a client for */
export type OrderItemsArgs = {
  sorted?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum OrderByDirection {
  Asc = 'ASC',
  Desc = 'DESC'
}

export enum OrderByEnum {
  InsertedAt = 'INSERTED_AT',
  UpdatedAt = 'UPDATED_AT'
}

export type OrderFlag = {
  __typename?: 'OrderFlag';
  color?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type OrderFlagInput = {
  color?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type OrderInput = {
  clientId?: InputMaybe<Scalars['ID']['input']>;
  couponId?: InputMaybe<Scalars['ID']['input']>;
  datetime?: InputMaybe<Scalars['DateTime']['input']>;
  discount?: InputMaybe<Scalars['Decimal']['input']>;
  discountReason?: InputMaybe<Scalars['String']['input']>;
  discountType?: InputMaybe<DiscountType>;
  flags?: InputMaybe<Array<InputMaybe<OrderFlagInput>>>;
  historicalId?: InputMaybe<Scalars['String']['input']>;
  invoiced?: InputMaybe<Scalars['Boolean']['input']>;
  invoicedAt?: InputMaybe<Scalars['DateTime']['input']>;
  locationId?: InputMaybe<Scalars['ID']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  patientId?: InputMaybe<Scalars['ID']['input']>;
  posted?: InputMaybe<Scalars['Boolean']['input']>;
  providerId?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<InvoiceStatus>;
  visitId?: InputMaybe<Scalars['ID']['input']>;
};

/** An order item is a single line item of an order that registers the bill for a product */
export type OrderItem = {
  __typename?: 'OrderItem';
  cityTaxCents?: Maybe<Scalars['Int']['output']>;
  cityTaxRate?: Maybe<Scalars['Decimal']['output']>;
  countyTaxCents?: Maybe<Scalars['Int']['output']>;
  countyTaxRate?: Maybe<Scalars['Decimal']['output']>;
  /** @deprecated Please use `itemDiscountWithOrderDiscountCents` */
  couponDiscount?: Maybe<Scalars['Price']['output']>;
  credited?: Maybe<Scalars['Boolean']['output']>;
  creditedQuantity?: Maybe<Scalars['Decimal']['output']>;
  date?: Maybe<Scalars['Date']['output']>;
  declineReason?: Maybe<DeclineReason>;
  declined?: Maybe<Scalars['Boolean']['output']>;
  department?: Maybe<Department>;
  /** @deprecated Please use `totalDiscountCents` instead */
  discount?: Maybe<Scalars['Price']['output']>;
  discountAmount?: Maybe<Scalars['Decimal']['output']>;
  discounted?: Maybe<Scalars['Boolean']['output']>;
  dispenseFee?: Maybe<Scalars['Decimal']['output']>;
  fulfilledExternally?: Maybe<Scalars['Boolean']['output']>;
  hidden?: Maybe<Scalars['Boolean']['output']>;
  historicalId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  inPackage?: Maybe<Scalars['Boolean']['output']>;
  insertedAt?: Maybe<Scalars['NaiveDateTime']['output']>;
  invoiceLineItemReason?: Maybe<InvoiceLineItemReason>;
  isPackage?: Maybe<Scalars['Boolean']['output']>;
  isSecretlyIncluded?: Maybe<Scalars['Boolean']['output']>;
  /**
   * @deprecated This field is deprecated and will only ever return an order item's `is_taxed_other`.
   * OrderItems now have various tax rate fields you may want to read. Please update your queries
   * to pull from `isTaxedOther`, `isTaxedCity`, `isTaxedState`, and `isTaxedCounty`.
   *
   */
  isTaxed?: Maybe<Scalars['Boolean']['output']>;
  isTaxedCity?: Maybe<Scalars['Boolean']['output']>;
  isTaxedCounty?: Maybe<Scalars['Boolean']['output']>;
  isTaxedOther?: Maybe<Scalars['Boolean']['output']>;
  isTaxedState?: Maybe<Scalars['Boolean']['output']>;
  itemDiscountWithOrderDiscountCents?: Maybe<Scalars['Int']['output']>;
  itemDiscountWithoutOrderDiscountCents?: Maybe<Scalars['Int']['output']>;
  /** @deprecated Please use `itemDiscountWithoutOrderDiscountCents` */
  lineDiscount?: Maybe<Scalars['Decimal']['output']>;
  lineDiscountReason?: Maybe<Scalars['String']['output']>;
  lineDiscountType?: Maybe<DiscountType>;
  lotNumber?: Maybe<Scalars['String']['output']>;
  medication?: Maybe<Medication>;
  medicationId?: Maybe<Scalars['ID']['output']>;
  /** @deprecated Please sum `planDiscountCents` and `memberDiscountCents` */
  memberDiscount?: Maybe<Scalars['Price']['output']>;
  memberDiscountCents?: Maybe<Scalars['Int']['output']>;
  minimumPrice?: Maybe<Scalars['Decimal']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  notRendered?: Maybe<Scalars['Boolean']['output']>;
  order?: Maybe<Order>;
  orderDiscountCents?: Maybe<Scalars['Int']['output']>;
  otherTaxCents?: Maybe<Scalars['Int']['output']>;
  otherTaxRate?: Maybe<Scalars['Decimal']['output']>;
  package?: Maybe<ProductPackage>;
  patient?: Maybe<Patient>;
  percentDiscounted?: Maybe<Scalars['Decimal']['output']>;
  planDiscountCents?: Maybe<Scalars['Int']['output']>;
  position?: Maybe<Scalars['Int']['output']>;
  priceIncluded?: Maybe<Scalars['Boolean']['output']>;
  product?: Maybe<Product>;
  productId?: Maybe<Scalars['ID']['output']>;
  provider?: Maybe<Provider>;
  quantity?: Maybe<Scalars['Decimal']['output']>;
  quantityCredited?: Maybe<Scalars['Decimal']['output']>;
  quantityNotRendered?: Maybe<Scalars['Decimal']['output']>;
  quantityRemaining?: Maybe<Scalars['Decimal']['output']>;
  refunded?: Maybe<Scalars['Boolean']['output']>;
  refundedAt?: Maybe<Scalars['NaiveDateTime']['output']>;
  refundedQuantity?: Maybe<Scalars['Decimal']['output']>;
  returned?: Maybe<Scalars['Boolean']['output']>;
  returnedOrderItems?: Maybe<Array<Maybe<ReturnedOrderItem>>>;
  returnedQuantity?: Maybe<Scalars['Decimal']['output']>;
  sourceOrderItemId?: Maybe<Scalars['ID']['output']>;
  stateTaxCents?: Maybe<Scalars['Int']['output']>;
  stateTaxRate?: Maybe<Scalars['Decimal']['output']>;
  /** @deprecated Please use `subtotalCents` */
  subtotal?: Maybe<Scalars['Price']['output']>;
  subtotalCents?: Maybe<Scalars['Int']['output']>;
  /** @deprecated Please sum all `*TaxCents` */
  tax?: Maybe<Scalars['Price']['output']>;
  /** @deprecated Please use `totalBeforeTaxCents` */
  total?: Maybe<Scalars['Price']['output']>;
  totalAfterTaxCents?: Maybe<Scalars['Int']['output']>;
  totalBeforeTaxCents?: Maybe<Scalars['Int']['output']>;
  totalDiscountCents?: Maybe<Scalars['Int']['output']>;
  /** @deprecated Please use `totalBeforeTaxCents`, or for without discount use `subtotalCents` */
  totalPrice?: Maybe<Scalars['Decimal']['output']>;
  undeletable?: Maybe<Scalars['Boolean']['output']>;
  unitPrice?: Maybe<Scalars['Decimal']['output']>;
  updatedAt?: Maybe<Scalars['NaiveDateTime']['output']>;
  volumeTiers?: Maybe<Array<Maybe<PriceTier>>>;
};


/** An order item is a single line item of an order that registers the bill for a product */
export type OrderItemTotalPriceArgs = {
  withoutDiscount?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OrderItemConnection = {
  __typename?: 'OrderItemConnection';
  edges?: Maybe<Array<Maybe<OrderItemEdge>>>;
  pageInfo: PageInfo;
};

export type OrderItemEdge = {
  __typename?: 'OrderItemEdge';
  cursor?: Maybe<Scalars['String']['output']>;
  node?: Maybe<OrderItem>;
};

export type OrderItemInput = {
  date?: InputMaybe<Scalars['Date']['input']>;
  declineReasonId?: InputMaybe<Scalars['ID']['input']>;
  declined?: InputMaybe<Scalars['Boolean']['input']>;
  departmentId?: InputMaybe<Scalars['ID']['input']>;
  discounted?: InputMaybe<Scalars['Boolean']['input']>;
  dispenseFee?: InputMaybe<Scalars['Decimal']['input']>;
  invoiceLineItemReasonId?: InputMaybe<Scalars['ID']['input']>;
  isTaxed?: InputMaybe<Scalars['Boolean']['input']>;
  isTaxedCity?: InputMaybe<Scalars['Boolean']['input']>;
  isTaxedCounty?: InputMaybe<Scalars['Boolean']['input']>;
  isTaxedOther?: InputMaybe<Scalars['Boolean']['input']>;
  isTaxedState?: InputMaybe<Scalars['Boolean']['input']>;
  lineDiscount?: InputMaybe<Scalars['Decimal']['input']>;
  lineDiscountReason?: InputMaybe<Scalars['String']['input']>;
  lineDiscountType?: InputMaybe<DiscountType>;
  lotNumber?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  patientId?: InputMaybe<Scalars['ID']['input']>;
  percentDiscounted?: InputMaybe<Scalars['Boolean']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
  providerId?: InputMaybe<Scalars['ID']['input']>;
  quantity?: InputMaybe<Scalars['Decimal']['input']>;
  returned?: InputMaybe<Scalars['Boolean']['input']>;
  unitPrice?: InputMaybe<Scalars['Decimal']['input']>;
  volumeTiers?: InputMaybe<Array<InputMaybe<PriceTierInput>>>;
};

/** Derived line-item status as shown on the Line Items report */
export enum OrderItemReportStatus {
  Declined = 'DECLINED',
  Due = 'DUE',
  Open = 'OPEN',
  Posted = 'POSTED',
  Uncollectible = 'UNCOLLECTIBLE'
}

export type OrderItemsTotals = {
  __typename?: 'OrderItemsTotals';
  count?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type OrderLineItemsFilters = {
  categoryIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
  excludeHistorical?: InputMaybe<Scalars['Boolean']['input']>;
  invoiced?: InputMaybe<Scalars['Boolean']['input']>;
  locationId?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  notRendered?: InputMaybe<Scalars['Boolean']['input']>;
  patientId?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  posted?: InputMaybe<Scalars['Boolean']['input']>;
  productId?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  providerId?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  returned?: InputMaybe<Scalars['Boolean']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
  typeIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  updatedAtEnd?: InputMaybe<Scalars['NaiveDateTime']['input']>;
  updatedAtStart?: InputMaybe<Scalars['NaiveDateTime']['input']>;
};

export type OrderLineItemsOrderBy = {
  date?: InputMaybe<OrderByDirection>;
  id?: InputMaybe<OrderByDirection>;
  insertedAt?: InputMaybe<OrderByDirection>;
  updatedAt?: InputMaybe<OrderByDirection>;
};

export type OrderPaymentMismatch = {
  __typename?: 'OrderPaymentMismatch';
  clientId: Scalars['ID']['output'];
  invoicedAtDate?: Maybe<Scalars['Date']['output']>;
  isTestLocation: Scalars['Boolean']['output'];
  locationId?: Maybe<Scalars['ID']['output']>;
  locationName?: Maybe<Scalars['String']['output']>;
  orderId: Scalars['ID']['output'];
  patientId?: Maybe<Scalars['ID']['output']>;
  paymentCents: Scalars['Int']['output'];
  totalLessReturnsCents: Scalars['Int']['output'];
};

export type Orderable = Product | ProductPackage;

export type OrdersCounts = {
  __typename?: 'OrdersCounts';
  diagnostics?: Maybe<Scalars['Int']['output']>;
  encounterProducts?: Maybe<Scalars['Int']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
  treatments?: Maybe<Scalars['Int']['output']>;
};

export type OrdersTotals = {
  __typename?: 'OrdersTotals';
  accountCredits?: Maybe<Scalars['Decimal']['output']>;
  accountCreditsCount?: Maybe<Scalars['Int']['output']>;
  count?: Maybe<Scalars['Int']['output']>;
  credited?: Maybe<Scalars['Decimal']['output']>;
  creditedCount?: Maybe<Scalars['Int']['output']>;
  due?: Maybe<Scalars['Decimal']['output']>;
  dueCount?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  ninety?: Maybe<Scalars['Decimal']['output']>;
  ninetyCount?: Maybe<Scalars['Int']['output']>;
  ninetyplus?: Maybe<Scalars['Decimal']['output']>;
  ninetyplusCount?: Maybe<Scalars['Int']['output']>;
  notRendered?: Maybe<Scalars['Decimal']['output']>;
  notRenderedCount?: Maybe<Scalars['Int']['output']>;
  open?: Maybe<Scalars['Decimal']['output']>;
  openCount?: Maybe<Scalars['Int']['output']>;
  paid?: Maybe<Scalars['Decimal']['output']>;
  paidCount?: Maybe<Scalars['Int']['output']>;
  sixty?: Maybe<Scalars['Decimal']['output']>;
  sixtyCount?: Maybe<Scalars['Int']['output']>;
  thirty?: Maybe<Scalars['Decimal']['output']>;
  thirtyCount?: Maybe<Scalars['Int']['output']>;
  total?: Maybe<Scalars['Decimal']['output']>;
  uncollectible?: Maybe<Scalars['Decimal']['output']>;
  uncollectibleCount?: Maybe<Scalars['Int']['output']>;
};

/** A top-level org */
export type Org = {
  __typename?: 'Org';
  activeSubscription?: Maybe<Scalars['Boolean']['output']>;
  appointmentTypes?: Maybe<Array<Maybe<AppointmentType>>>;
  chargebeeAccountName?: Maybe<Scalars['String']['output']>;
  chargebeeApiToken?: Maybe<Scalars['String']['output']>;
  clientReferralSources: Array<ClientReferralSource>;
  clientTags?: Maybe<Array<Maybe<ClientTag>>>;
  customLocationAttributes?: Maybe<Array<Maybe<CustomLocationAttribute>>>;
  defaultEncounterType?: Maybe<EncounterType>;
  defaultWeightUnit?: Maybe<WeightUnit>;
  emailTemplate?: Maybe<EmailTemplate>;
  enableAutoconfirm?: Maybe<Scalars['Boolean']['output']>;
  enableChargebee?: Maybe<Scalars['Boolean']['output']>;
  enableDialpad?: Maybe<Scalars['Boolean']['output']>;
  enableRingCentral?: Maybe<Scalars['Boolean']['output']>;
  enableSquare?: Maybe<Scalars['Boolean']['output']>;
  enableStripe?: Maybe<Scalars['Boolean']['output']>;
  enableTimeTracking?: Maybe<Scalars['Boolean']['output']>;
  /** Does this org have a certain preference enabled? Returns true if so, false if otherwise. */
  hasPref?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  locations?: Maybe<Array<Maybe<Location>>>;
  locationsCount?: Maybe<Scalars['Int']['output']>;
  logoUri?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  onlineBookCheckin?: Maybe<Scalars['Boolean']['output']>;
  paymentSource?: Maybe<PaymentSource>;
  /** What is the value for a given preference for this org? Returns the set value, or `null` if the preference is not enabled */
  prefValue?: Maybe<Scalars['String']['output']>;
  preferences: Array<OrgPreference>;
  productManufacturers?: Maybe<Array<Maybe<ProductManufacturer>>>;
  providers?: Maybe<Array<Maybe<Provider>>>;
  providersCount?: Maybe<Scalars['Int']['output']>;
  ringCentralAccessToken?: Maybe<Scalars['String']['output']>;
  ringCentralAccessTokenExpiresIn?: Maybe<Scalars['Int']['output']>;
  ringCentralClientId?: Maybe<Scalars['String']['output']>;
  ringCentralClientSecret?: Maybe<Scalars['String']['output']>;
  ringCentralRefreshTokenExpiresIn?: Maybe<Scalars['Int']['output']>;
  ringCentralUrl?: Maybe<Scalars['String']['output']>;
  rosTypes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  slug?: Maybe<Scalars['String']['output']>;
  squareAccessToken?: Maybe<Scalars['String']['output']>;
  squareClientId?: Maybe<Scalars['String']['output']>;
  stripeAccessToken?: Maybe<Scalars['String']['output']>;
  stripeConnectToken?: Maybe<Scalars['String']['output']>;
  stripeDashboardUrl?: Maybe<Scalars['String']['output']>;
  stripePublishableKey?: Maybe<Scalars['String']['output']>;
  stripeSetup?: Maybe<Scalars['Boolean']['output']>;
  stripeUserId?: Maybe<Scalars['String']['output']>;
  timezone?: Maybe<Scalars['String']['output']>;
  useCustomEmailTemplate?: Maybe<Scalars['Boolean']['output']>;
  vitalsTemplate?: Maybe<Array<Maybe<VitalsTemplate>>>;
  yourvet?: Maybe<Scalars['Boolean']['output']>;
};


/** A top-level org */
export type OrgAppointmentTypesArgs = {
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  isExam?: InputMaybe<Scalars['Boolean']['input']>;
  locationId?: InputMaybe<Scalars['ID']['input']>;
  sortByPosition?: InputMaybe<Scalars['Boolean']['input']>;
};


/** A top-level org */
export type OrgHasPrefArgs = {
  pref: Scalars['String']['input'];
};


/** A top-level org */
export type OrgLocationsArgs = {
  viewerAssignedOnly?: InputMaybe<Scalars['Boolean']['input']>;
};


/** A top-level org */
export type OrgPrefValueArgs = {
  pref: Scalars['String']['input'];
};


/** A top-level org */
export type OrgPreferencesArgs = {
  fields: Array<InputMaybe<Scalars['String']['input']>>;
};


/** A top-level org */
export type OrgProvidersArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
  includeApiUsers?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  locationId?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  onlyActive?: InputMaybe<Scalars['Boolean']['input']>;
  onlyCallCenter?: InputMaybe<Scalars['Boolean']['input']>;
  providerRole?: InputMaybe<Scalars['String']['input']>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  updatedAtEnd?: InputMaybe<Scalars['NaiveDateTime']['input']>;
  updatedAtStart?: InputMaybe<Scalars['NaiveDateTime']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
  vetOnly?: InputMaybe<Scalars['Boolean']['input']>;
  vetsAllowedCharges?: InputMaybe<Scalars['Boolean']['input']>;
  withAnyPermission?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  withPermission?: InputMaybe<Scalars['String']['input']>;
};


/** A top-level org */
export type OrgProvidersCountArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
  includeApiUsers?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  onlyActive?: InputMaybe<Scalars['Boolean']['input']>;
  onlyCallCenter?: InputMaybe<Scalars['Boolean']['input']>;
  providerRole?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

export type OrgDepartment = {
  __typename?: 'OrgDepartment';
  countOfDepartments: Scalars['Int']['output'];
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type OrgDepartmentInput = {
  name?: InputMaybe<Scalars['String']['input']>;
};

export type OrgInput = {
  chargebeeAccountName?: InputMaybe<Scalars['String']['input']>;
  chargebeeApiToken?: InputMaybe<Scalars['String']['input']>;
  defaultWeightUnit?: InputMaybe<WeightUnit>;
  emailTemplate?: InputMaybe<EmailTemplateInput>;
  enableAutoconfirm?: InputMaybe<Scalars['Boolean']['input']>;
  enableRingCentral?: InputMaybe<Scalars['Boolean']['input']>;
  enableSquare?: InputMaybe<Scalars['Boolean']['input']>;
  enableStripe?: InputMaybe<Scalars['Boolean']['input']>;
  enableTimeTracking?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  onlineBookCheckin?: InputMaybe<Scalars['Boolean']['input']>;
  ringCentralAccessToken?: InputMaybe<Scalars['String']['input']>;
  ringCentralClientId?: InputMaybe<Scalars['String']['input']>;
  ringCentralClientSecret?: InputMaybe<Scalars['String']['input']>;
  ringCentralUrl?: InputMaybe<Scalars['String']['input']>;
  rosTypes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  squareAccessToken?: InputMaybe<Scalars['String']['input']>;
  squareClientId?: InputMaybe<Scalars['String']['input']>;
  stripeAccessToken?: InputMaybe<Scalars['String']['input']>;
  stripePublishableKey?: InputMaybe<Scalars['String']['input']>;
  stripeUserId?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  useCustomEmailTemplate?: InputMaybe<Scalars['Boolean']['input']>;
  vitalsTemplate?: InputMaybe<Array<InputMaybe<VitalsTemplateInput>>>;
  yourvet?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OrgLab = {
  __typename?: 'OrgLab';
  accountNumber?: Maybe<Scalars['String']['output']>;
  antechPoc?: Maybe<Scalars['Boolean']['output']>;
  apiKey?: Maybe<Scalars['String']['output']>;
  autoInvoice?: Maybe<Scalars['Boolean']['output']>;
  clinicId?: Maybe<Scalars['String']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  inactive?: Maybe<Scalars['Boolean']['output']>;
  insertedAt?: Maybe<Scalars['NaiveDateTime']['output']>;
  labDevices?: Maybe<Scalars['JSON']['output']>;
  location?: Maybe<Location>;
  locationId?: Maybe<Scalars['ID']['output']>;
  markupMultiple?: Maybe<Scalars['Decimal']['output']>;
  mwlStationAeTitle?: Maybe<Scalars['String']['output']>;
  mwlStationName?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  orgLabType?: Maybe<OrgLabTypeMetadata>;
  password?: Maybe<Scalars['String']['output']>;
  type?: Maybe<OrgLabType>;
  username?: Maybe<Scalars['String']['output']>;
};

export type OrgLabInput = {
  accountNumber?: InputMaybe<Scalars['String']['input']>;
  antechPoc?: InputMaybe<Scalars['Boolean']['input']>;
  autoInvoice?: InputMaybe<Scalars['Boolean']['input']>;
  clinicId?: InputMaybe<Scalars['String']['input']>;
  inactive?: InputMaybe<Scalars['Boolean']['input']>;
  labDevices?: InputMaybe<Scalars['JSON']['input']>;
  locationId?: InputMaybe<Scalars['ID']['input']>;
  markupMultiple?: InputMaybe<Scalars['Decimal']['input']>;
  mwlStationAeTitle?: InputMaybe<Scalars['String']['input']>;
  mwlStationName?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  orgLabTypeId?: InputMaybe<Scalars['ID']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<OrgLabType>;
  username?: InputMaybe<Scalars['String']['input']>;
};

export enum OrgLabType {
  Abaxis = 'ABAXIS',
  Antech = 'ANTECH',
  AntechV3 = 'ANTECH_V3',
  AntechV6 = 'ANTECH_V6',
  Ellie = 'ELLIE',
  Fujiris = 'FUJIRIS',
  Heska = 'HESKA',
  Idexx = 'IDEXX',
  IdexxWebpacs = 'IDEXX_WEBPACS',
  Petdx = 'PETDX',
  UpennLab = 'UPENN_LAB',
  Vetrocket = 'VETROCKET',
  VitalPacs = 'VITAL_PACS',
  ZoetisPoc = 'ZOETIS_POC',
  ZoetisRef = 'ZOETIS_REF'
}

export type OrgLabTypeMetadata = {
  __typename?: 'OrgLabTypeMetadata';
  disabled: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type OrgLabUpdateResult = {
  __typename?: 'OrgLabUpdateResult';
  /** Whether the given credentials verified successfully. Null if this integration type does not support credential verification. */
  authenticated?: Maybe<Scalars['Boolean']['output']>;
  /** Summary of the credential check result. Null if this integration type does not support credential verification. */
  message?: Maybe<Scalars['String']['output']>;
  orgLab?: Maybe<OrgLab>;
};

export type OrgPreference = {
  __typename?: 'OrgPreference';
  enabled?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type OrgPreferenceInput = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type OutlookSyncResult = {
  __typename?: 'OutlookSyncResult';
  appointmentId: Scalars['ID']['output'];
  message?: Maybe<Scalars['String']['output']>;
  operationType: Scalars['String']['output'];
  status: OutlookSyncStatus;
};

export enum OutlookSyncStatus {
  Failed = 'FAILED',
  Success = 'SUCCESS'
}

/**
 * Configuration for ownership bypass on mutations.
 *
 * The presence of this config indicates ownership bypass is enabled.
 * Users who own the resource being mutated can bypass permission checks.
 *
 * ## Configuration Patterns
 *
 * **Create Operations** (no existing entity):
 * - Omit `entity_module` and `entity_id_path`
 * - Set `field` to the argument name containing the owner's provider ID
 * - Example: `%{field: "provider_id"}`
 *
 * **Update/Delete Operations** (existing entity):
 * - Set `entity_module` to fetch the entity
 * - Set `entity_id_path` to the path of the entity ID in arguments
 * - Set `field` to the field on the entity containing the owner's provider ID
 * - Example: `%{field: "provider_id", entity_module: "Vetspire.Accounts.License", entity_id_path: "id"}`
 */
export type OwnershipBypassMutationConfig = {
  /**
   * Dot-notation path to the entity ID in the GraphQL arguments (e.g., 'id', 'input.license_id').
   * Used to fetch the entity for ownership checking.
   * Required when entity_module is specified.
   */
  entityIdPath?: InputMaybe<Scalars['String']['input']>;
  /**
   * The Elixir module name for the entity to fetch and check ownership (e.g., 'Vetspire.Accounts.License').
   *
   * When specified:
   * - The entity is fetched from the database using the ID from `entity_id_path`
   * - The `field` on the fetched entity is checked for ownership
   * - Use for update/delete operations
   *
   * When omitted:
   * - The `field` is read directly from arguments
   * - Use for create operations where no entity exists yet
   */
  entityModule?: InputMaybe<Scalars['String']['input']>;
  /** The field name to check on the resource to get the provider id (e.g., 'provider_id', 'id') */
  field: Scalars['String']['input'];
};

export type Pack = {
  __typename?: 'Pack';
  client?: Maybe<Client>;
  date?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  location?: Maybe<Location>;
  name?: Maybe<Scalars['String']['output']>;
  orderId?: Maybe<Scalars['ID']['output']>;
  quantity?: Maybe<Scalars['Int']['output']>;
  quantityUsed?: Maybe<Scalars['Int']['output']>;
  totalPaid?: Maybe<Scalars['Decimal']['output']>;
  totalUsed?: Maybe<Scalars['Decimal']['output']>;
};

export type PageInfo = {
  __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']['output']>;
};

/** A patient listed in Vetspire. This entity represents a pet */
export type Patient = {
  __typename?: 'Patient';
  age?: Maybe<Scalars['String']['output']>;
  alerts?: Maybe<Array<Scalars['String']['output']>>;
  allergies?: Maybe<Array<Maybe<Allergy>>>;
  birthDate?: Maybe<Scalars['Date']['output']>;
  birthDay?: Maybe<Scalars['Int']['output']>;
  birthMonth?: Maybe<Scalars['Int']['output']>;
  birthYear?: Maybe<Scalars['Int']['output']>;
  bloodType?: Maybe<Scalars['String']['output']>;
  boardComments?: Maybe<Array<Maybe<BoardCell>>>;
  breed?: Maybe<Scalars['String']['output']>;
  callLogs?: Maybe<Array<Maybe<CallLog>>>;
  /** Returns true if the patient has at least one appointment with status 'checked_in', `admitted` or `inprogress` */
  checkedIn?: Maybe<Scalars['Boolean']['output']>;
  client?: Maybe<Client>;
  clientId?: Maybe<Scalars['ID']['output']>;
  clinicalNotes?: Maybe<Array<Maybe<ClinicalNote>>>;
  color?: Maybe<Scalars['String']['output']>;
  contactDetails?: Maybe<PatientContactDetails>;
  countOfCoowners?: Maybe<Scalars['Int']['output']>;
  customFields?: Maybe<Array<Maybe<CustomPatientFieldValue>>>;
  deceasedDate?: Maybe<Scalars['Date']['output']>;
  documents?: Maybe<Array<Maybe<PatientDocument>>>;
  encounters?: Maybe<Array<Maybe<Encounter>>>;
  /** The patient's field service visit addresses, default first then alphabetical by label */
  fieldServiceAddresses?: Maybe<Array<Maybe<FieldServiceAddress>>>;
  firstHeatDate?: Maybe<Scalars['Date']['output']>;
  goalWeight?: Maybe<Scalars['Decimal']['output']>;
  /** The patient's HISA number */
  hisa?: Maybe<Scalars['String']['output']>;
  /** Whether the patient is HISA registered */
  hisaRegistered?: Maybe<Scalars['Boolean']['output']>;
  historicalId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  identification?: Maybe<Scalars['String']['output']>;
  immunizations?: Maybe<Array<Immunization>>;
  insertedAt?: Maybe<Scalars['NaiveDateTime']['output']>;
  isActive?: Maybe<Scalars['Boolean']['output']>;
  isCritical?: Maybe<Scalars['Boolean']['output']>;
  isDeceased?: Maybe<Scalars['Boolean']['output']>;
  isDnr?: Maybe<Scalars['Boolean']['output']>;
  isEstimatedAge?: Maybe<Scalars['Boolean']['output']>;
  isEstimatedWeight?: Maybe<Scalars['Boolean']['output']>;
  isMerged?: Maybe<Scalars['Boolean']['output']>;
  isMixed?: Maybe<Scalars['Boolean']['output']>;
  labOrders?: Maybe<Array<Maybe<LabOrder>>>;
  labResults?: Maybe<Array<Maybe<LabResult>>>;
  /** Where the patient is now: the latest PatientLocation linked through at least one open encounter or open treatment sheet. Null when all linked encounters and sheets are closed. For placement on a specific encounter, sheet, or visit, use that record's patientLocation field instead. */
  lastKnownLocation?: Maybe<PatientLocation>;
  lastSyncedAt?: Maybe<Scalars['NaiveDateTime']['output']>;
  lastVisit?: Maybe<Appointment>;
  latestRabies?: Maybe<Immunization>;
  latestWeight?: Maybe<Weight>;
  medications?: Maybe<Array<Maybe<Medication>>>;
  mergeIdentification?: Maybe<Scalars['String']['output']>;
  microchip?: Maybe<Scalars['String']['output']>;
  microchipRegistered?: Maybe<Scalars['Boolean']['output']>;
  /** The patient's name */
  name?: Maybe<Scalars['String']['output']>;
  neuterDate?: Maybe<Scalars['Date']['output']>;
  neutered?: Maybe<Scalars['Boolean']['output']>;
  nextVisit?: Maybe<Appointment>;
  notes?: Maybe<Scalars['String']['output']>;
  openTreatmentSheet?: Maybe<TreatmentSheet>;
  patientDiagnoses?: Maybe<Array<Maybe<PatientDiagnosis>>>;
  patientLocations?: Maybe<Array<Maybe<PatientLocation>>>;
  /** Patient's rDVM assignments with patient-specific fields (notes, referring_doctors, etc) */
  patientRdvms?: Maybe<Array<Maybe<PatientRdvm>>>;
  percentageOwnership?: Maybe<Scalars['Decimal']['output']>;
  preferredRdvm?: Maybe<Rdvm>;
  preferredWeightUnit?: Maybe<Scalars['String']['output']>;
  /** For notes that will not display on the patient chart. */
  privateNotes?: Maybe<Scalars['String']['output']>;
  problems?: Maybe<Array<Maybe<Problem>>>;
  profileImageUrl?: Maybe<Scalars['String']['output']>;
  protocols?: Maybe<Array<PatientProtocol>>;
  rdvms?: Maybe<Array<Maybe<Rdvm>>>;
  /** The patient's registered name */
  registeredName?: Maybe<Scalars['String']['output']>;
  reminderSilences?: Maybe<Array<Maybe<ReminderSilence>>>;
  /**
   * The basic sex of the patient, without consideration of neutered status or age. When a more
   *   medically accurate description of the patient's sex is needed, we recommend using the `sexTerm`
   *   field instead.
   */
  sex?: Maybe<Sex>;
  /**
   * Species-specific descriptive term, which takes into account the patient's sex, neutered status, and
   * for certain species, age. For example, the sexTerm for an intact adult male horse's will
   * be `Stallion`. An altered female dog will be `Female (Spayed)`. Currently only equines
   * have age-specific sex terms, but we plan to add specific sex terms for other species in the future.
   * If the patient's sex or neutered status is missing, it will be listed as `Unknown`,
   * i.e. `Female (Unknown neutered status)`, `Unknown Sex (Intact)`, or `Unknown Sex (Unknown neutered status)`.
   */
  sexTerm?: Maybe<Scalars['String']['output']>;
  species?: Maybe<Scalars['String']['output']>;
  subscriptions?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  tags?: Maybe<Array<Maybe<PatientTag>>>;
  tasks?: Maybe<Array<Maybe<Task>>>;
  treatmentSheets?: Maybe<Array<TreatmentSheet>>;
  updatedAt?: Maybe<Scalars['NaiveDateTime']['output']>;
  verifiedAt?: Maybe<Scalars['DateTime']['output']>;
  visits?: Maybe<Array<Maybe<Visit>>>;
};


/** A patient listed in Vetspire. This entity represents a pet */
export type PatientImmunizationsArgs = {
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isLatest?: InputMaybe<Scalars['Boolean']['input']>;
};


/** A patient listed in Vetspire. This entity represents a pet */
export type PatientLabResultsArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  includeAiResults?: InputMaybe<Scalars['Boolean']['input']>;
};


/** A patient listed in Vetspire. This entity represents a pet */
export type PatientMedicationsArgs = {
  status?: InputMaybe<MedicationStatus>;
};


/** A patient listed in Vetspire. This entity represents a pet */
export type PatientPatientDiagnosesArgs = {
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
};


/** A patient listed in Vetspire. This entity represents a pet */
export type PatientProblemsArgs = {
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  rootLevel?: InputMaybe<Scalars['Boolean']['input']>;
};


/** A patient listed in Vetspire. This entity represents a pet */
export type PatientProtocolsArgs = {
  endDate?: InputMaybe<Scalars['Date']['input']>;
  endDueDate?: InputMaybe<Scalars['Date']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
  startDueDate?: InputMaybe<Scalars['Date']['input']>;
};


/** A patient listed in Vetspire. This entity represents a pet */
export type PatientTreatmentSheetsArgs = {
  isOpen?: InputMaybe<Scalars['Boolean']['input']>;
  isSigned?: InputMaybe<Scalars['Boolean']['input']>;
};


/** A patient listed in Vetspire. This entity represents a pet */
export type PatientVisitsArgs = {
  isCurrent?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PatientClinicalItemsPendingApprovalCounts = {
  __typename?: 'PatientClinicalItemsPendingApprovalCounts';
  diagnostics?: Maybe<Scalars['Int']['output']>;
  encounterProducts?: Maybe<Scalars['Int']['output']>;
  immunizations?: Maybe<Scalars['Int']['output']>;
  medications?: Maybe<Scalars['Int']['output']>;
  treatments?: Maybe<Scalars['Int']['output']>;
};

export type PatientCompliance = {
  __typename?: 'PatientCompliance';
  csvUrl?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  patient?: Maybe<Patient>;
  patientId?: Maybe<Scalars['ID']['output']>;
  productProtocols?: Maybe<Array<Maybe<PatientProtocol>>>;
  /** @deprecated Use `protocolRemindersByProtocol` instead */
  protocolReminders?: Maybe<Array<Maybe<ProtocolReminder>>>;
  protocolRemindersByProtocol?: Maybe<Array<Maybe<ProtocolReminderByProtocol>>>;
};

export type PatientComplication = {
  __typename?: 'PatientComplication';
  complication?: Maybe<Complication>;
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  severity?: Maybe<Severity>;
};

export type PatientComplicationInput = {
  complicationId?: InputMaybe<Scalars['ID']['input']>;
  datetime?: InputMaybe<Scalars['DateTime']['input']>;
  encounterId?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  patientId?: InputMaybe<Scalars['ID']['input']>;
  severity?: InputMaybe<Severity>;
};

export type PatientContactDetails = {
  __typename?: 'PatientContactDetails';
  client?: Maybe<Client>;
  id?: Maybe<Scalars['ID']['output']>;
  insertedAt?: Maybe<Scalars['NaiveDateTime']['output']>;
  isPrimaryContact?: Maybe<Scalars['Boolean']['output']>;
  patient?: Maybe<Patient>;
  relationship?: Maybe<Scalars['String']['output']>;
  relationshipId?: Maybe<Scalars['ID']['output']>;
  shareMedicalRecords?: Maybe<Scalars['Boolean']['output']>;
  updatedAt?: Maybe<Scalars['NaiveDateTime']['output']>;
};

export type PatientContactDetailsInput = {
  isPrimaryContact?: InputMaybe<Scalars['Boolean']['input']>;
  relationshipId: Scalars['ID']['input'];
  shareMedicalRecords?: InputMaybe<Scalars['Boolean']['input']>;
};

/** A diagnosis entry in a patient's diagnosis list */
export type PatientDiagnosis = {
  __typename?: 'PatientDiagnosis';
  comment?: Maybe<Scalars['String']['output']>;
  diagnosis?: Maybe<Diagnosis>;
  id?: Maybe<Scalars['ID']['output']>;
  insertedAt?: Maybe<Scalars['NaiveDateTime']['output']>;
  isActive?: Maybe<Scalars['Boolean']['output']>;
  /** optional name if not linked to a diagnosis code */
  name?: Maybe<Scalars['String']['output']>;
  patient?: Maybe<Patient>;
  provider?: Maybe<Provider>;
  treatments?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  updatedAt?: Maybe<Scalars['NaiveDateTime']['output']>;
};

export type PatientDiagnosisInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  diagnosisId?: InputMaybe<Scalars['ID']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  treatments?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type PatientDocument = {
  __typename?: 'PatientDocument';
  aiCategory?: Maybe<Scalars['String']['output']>;
  aiSummary?: Maybe<Scalars['String']['output']>;
  category?: Maybe<Scalars['String']['output']>;
  contentType?: Maybe<Scalars['String']['output']>;
  datetime?: Maybe<Scalars['NaiveDateTime']['output']>;
  encounterSectionName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  importedEntities?: Maybe<Array<Maybe<ImportedEntity>>>;
  insertedAt?: Maybe<Scalars['NaiveDateTime']['output']>;
  location?: Maybe<Location>;
  media?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  path?: Maybe<Scalars['String']['output']>;
  patient?: Maybe<Patient>;
  patientId?: Maybe<Scalars['ID']['output']>;
  uploader?: Maybe<Provider>;
  visit?: Maybe<Visit>;
};

export type PatientDocumentConnection = {
  __typename?: 'PatientDocumentConnection';
  edges?: Maybe<Array<Maybe<PatientDocumentEdge>>>;
  pageInfo: PageInfo;
};

export type PatientDocumentEdge = {
  __typename?: 'PatientDocumentEdge';
  cursor?: Maybe<Scalars['String']['output']>;
  node?: Maybe<PatientDocument>;
};

export type PatientDocumentFilters = {
  encounterId?: InputMaybe<Scalars['ID']['input']>;
  insertedAtEnd?: InputMaybe<Scalars['NaiveDateTime']['input']>;
  insertedAtStart?: InputMaybe<Scalars['NaiveDateTime']['input']>;
  locationId?: InputMaybe<Scalars['ID']['input']>;
  patientId?: InputMaybe<Scalars['ID']['input']>;
  updatedAtEnd?: InputMaybe<Scalars['NaiveDateTime']['input']>;
  updatedAtStart?: InputMaybe<Scalars['NaiveDateTime']['input']>;
  withoutEncounter?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PatientDocumentInput = {
  category?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  visitId?: InputMaybe<Scalars['ID']['input']>;
};

export type PatientDocumentOrderBy = {
  datetime?: InputMaybe<OrderByDirection>;
  id?: InputMaybe<OrderByDirection>;
  insertedAt?: InputMaybe<OrderByDirection>;
  updatedAt?: InputMaybe<OrderByDirection>;
};

export type PatientFilters = {
  breed?: InputMaybe<Scalars['String']['input']>;
  clientId?: InputMaybe<Scalars['ID']['input']>;
  excludeHistorical?: InputMaybe<Scalars['Boolean']['input']>;
  historicalId?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  insertedAt?: InputMaybe<Scalars['DateTime']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isDeceased?: InputMaybe<Scalars['Boolean']['input']>;
  isMember?: InputMaybe<Scalars['Boolean']['input']>;
  locationId?: InputMaybe<Scalars['ID']['input']>;
  microchipNumber?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  onlyActive?: InputMaybe<Scalars['Boolean']['input']>;
  problem?: InputMaybe<Scalars['String']['input']>;
  providerId?: InputMaybe<Scalars['ID']['input']>;
  rabiesTagNumber?: InputMaybe<Scalars['String']['input']>;
  species?: InputMaybe<Scalars['String']['input']>;
  subscriptions?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type PatientInput = {
  age?: InputMaybe<Scalars['String']['input']>;
  alerts?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  birthDate?: InputMaybe<Scalars['Date']['input']>;
  birthDay?: InputMaybe<Scalars['Int']['input']>;
  birthMonth?: InputMaybe<Scalars['Int']['input']>;
  birthYear?: InputMaybe<Scalars['Int']['input']>;
  bloodType?: InputMaybe<Scalars['String']['input']>;
  breed?: InputMaybe<Scalars['String']['input']>;
  color?: InputMaybe<Scalars['String']['input']>;
  deceasedDate?: InputMaybe<Scalars['Date']['input']>;
  firstHeatDate?: InputMaybe<Scalars['Date']['input']>;
  goalWeight?: InputMaybe<Scalars['Decimal']['input']>;
  hisa?: InputMaybe<Scalars['String']['input']>;
  hisaRegistered?: InputMaybe<Scalars['Boolean']['input']>;
  historicalId?: InputMaybe<Scalars['String']['input']>;
  identification?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isDeceased?: InputMaybe<Scalars['Boolean']['input']>;
  isDnr?: InputMaybe<Scalars['Boolean']['input']>;
  isEstimatedAge?: InputMaybe<Scalars['Boolean']['input']>;
  isEstimatedWeight?: InputMaybe<Scalars['Boolean']['input']>;
  isMixed?: InputMaybe<Scalars['Boolean']['input']>;
  lastSyncedAt?: InputMaybe<Scalars['NaiveDateTime']['input']>;
  microchip?: InputMaybe<Scalars['String']['input']>;
  microchipRegistered?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  neuterDate?: InputMaybe<Scalars['Date']['input']>;
  neutered?: InputMaybe<Scalars['Boolean']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  preferredWeightUnit?: InputMaybe<Scalars['String']['input']>;
  privateNotes?: InputMaybe<Scalars['String']['input']>;
  registeredName?: InputMaybe<Scalars['String']['input']>;
  sex?: InputMaybe<Sex>;
  species?: InputMaybe<Scalars['String']['input']>;
  subscriptions?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  verifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  vitals?: InputMaybe<Array<InputMaybe<VitalsInput>>>;
};

/**
 * A snapshot of a patient's physical ward + kennel at a point in time. Created
 * whenever a patient's location changes; encounters and treatment sheets
 * reference the snapshot in effect at the time of their creation/update.
 */
export type PatientLocation = {
  __typename?: 'PatientLocation';
  id: Scalars['ID']['output'];
  insertedAt?: Maybe<Scalars['NaiveDateTime']['output']>;
  kennel?: Maybe<BoardingCage>;
  patient?: Maybe<Patient>;
  updatedAt?: Maybe<Scalars['NaiveDateTime']['output']>;
  ward?: Maybe<BoardingWard>;
};

export type PatientLocationInput = {
  kennelId?: InputMaybe<Scalars['ID']['input']>;
  wardId?: InputMaybe<Scalars['ID']['input']>;
};

export enum PatientOrderByEnum {
  Id = 'ID',
  Name = 'NAME'
}

export type PatientPlan = {
  __typename?: 'PatientPlan';
  /** amount of plan payments invoiced including enrollment fee */
  amountCharged?: Maybe<Scalars['Decimal']['output']>;
  autoRenew?: Maybe<Scalars['Boolean']['output']>;
  cancelled?: Maybe<Scalars['Boolean']['output']>;
  cancelledAtDate?: Maybe<Scalars['Date']['output']>;
  charges?: Maybe<Array<Maybe<PatientPlanCharge>>>;
  deferred?: Maybe<Scalars['Boolean']['output']>;
  /** remaining deferred revenue */
  deferredRevenue?: Maybe<Scalars['Decimal']['output']>;
  endDate?: Maybe<Scalars['Date']['output']>;
  hasCharges?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  insertedAt?: Maybe<Scalars['NaiveDateTime']['output']>;
  items?: Maybe<Array<Maybe<PatientPlanItem>>>;
  location?: Maybe<Location>;
  patient?: Maybe<Patient>;
  paymentDate?: Maybe<Scalars['Date']['output']>;
  planDiscountPercent?: Maybe<Scalars['Decimal']['output']>;
  planInterval?: Maybe<PlanInterval>;
  preventionPlan?: Maybe<PreventionPlan>;
  renewalFailureReason?: Maybe<Scalars['String']['output']>;
  renewalPlan?: Maybe<PreventionPlan>;
  /** amount of plan payments that should have been invoiced */
  shouldHaveCharged?: Maybe<Scalars['Decimal']['output']>;
  startDate?: Maybe<Scalars['Date']['output']>;
  /** total cost of plan - may include a discount or markup over value of items in plan */
  total?: Maybe<Scalars['Decimal']['output']>;
  updatedAt?: Maybe<Scalars['NaiveDateTime']['output']>;
  /** previous deferred revenue now recognised as revenue */
  usedRevenue?: Maybe<Scalars['Decimal']['output']>;
  /** value of items in plan before discount or markup */
  value?: Maybe<Scalars['Decimal']['output']>;
};


export type PatientPlanDeferredRevenueArgs = {
  asOfDate?: InputMaybe<Scalars['Date']['input']>;
};


export type PatientPlanItemsArgs = {
  updatedAtEnd?: InputMaybe<Scalars['NaiveDateTime']['input']>;
  updatedAtStart?: InputMaybe<Scalars['NaiveDateTime']['input']>;
};


export type PatientPlanUsedRevenueArgs = {
  asOfDate?: InputMaybe<Scalars['Date']['input']>;
};

export type PatientPlanCharge = {
  __typename?: 'PatientPlanCharge';
  id: Scalars['ID']['output'];
  isCancelled: Scalars['Boolean']['output'];
  isEnrollmentFee: Scalars['Boolean']['output'];
  matchingOrderItem?: Maybe<OrderItem>;
  order?: Maybe<Order>;
  orderItem?: Maybe<OrderItem>;
  planInterval: PlanInterval;
  scheduledAmountCents: Scalars['Int']['output'];
  scheduledDate: Scalars['Date']['output'];
};

export type PatientPlanFilters = {
  /** Plan end date is after this date */
  endAfter?: InputMaybe<Scalars['Date']['input']>;
  /** Plan end date is before this date */
  endBefore?: InputMaybe<Scalars['Date']['input']>;
  excludeCancelled?: InputMaybe<Scalars['Boolean']['input']>;
  excludeEmployees?: InputMaybe<Scalars['Boolean']['input']>;
  excludeExpired?: InputMaybe<Scalars['Boolean']['input']>;
  locationIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  patientId?: InputMaybe<Scalars['ID']['input']>;
  providerId?: InputMaybe<Scalars['ID']['input']>;
  /** Plan start date is after this date */
  startAfter?: InputMaybe<Scalars['Date']['input']>;
  /** Plan start date is before this date */
  startBefore?: InputMaybe<Scalars['Date']['input']>;
  updatedAtEnd?: InputMaybe<Scalars['NaiveDateTime']['input']>;
  updatedAtStart?: InputMaybe<Scalars['NaiveDateTime']['input']>;
};

export type PatientPlanInput = {
  amountCharged?: InputMaybe<Scalars['Decimal']['input']>;
  autoRenew?: InputMaybe<Scalars['Boolean']['input']>;
  deferred?: InputMaybe<Scalars['Boolean']['input']>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
  includedProductIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  paymentDate?: InputMaybe<Scalars['Date']['input']>;
  planDiscountPercent?: InputMaybe<Scalars['Decimal']['input']>;
  planInterval?: InputMaybe<PlanInterval>;
  renewPlanId?: InputMaybe<Scalars['ID']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
  total?: InputMaybe<Scalars['Decimal']['input']>;
  value?: InputMaybe<Scalars['Decimal']['input']>;
};

export type PatientPlanItem = {
  __typename?: 'PatientPlanItem';
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  package?: Maybe<ProductPackage>;
  product?: Maybe<Product>;
  productIds?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  quantity?: Maybe<Scalars['Decimal']['output']>;
  quantityUsed?: Maybe<Scalars['Decimal']['output']>;
  unitTotal?: Maybe<Scalars['Decimal']['output']>;
};

export type PatientPlanItemInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  packageId?: InputMaybe<Scalars['ID']['input']>;
  productId?: InputMaybe<Scalars['ID']['input']>;
  productIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  quantity?: InputMaybe<Scalars['Decimal']['input']>;
  unitTotal?: InputMaybe<Scalars['Decimal']['input']>;
};

export type PatientProtocol = {
  __typename?: 'PatientProtocol';
  date?: Maybe<Scalars['Date']['output']>;
  dueDate?: Maybe<Scalars['Date']['output']>;
  historicalId?: Maybe<Scalars['ID']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  immunization?: Maybe<Immunization>;
  isDeclined?: Maybe<Scalars['Boolean']['output']>;
  isDelete?: Maybe<Scalars['Boolean']['output']>;
  isLegacy?: Maybe<Scalars['Boolean']['output']>;
  isPreemptive?: Maybe<Scalars['Boolean']['output']>;
  isStale?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  orderItem?: Maybe<OrderItem>;
  patient?: Maybe<Patient>;
  patientId?: Maybe<Scalars['ID']['output']>;
  protocol?: Maybe<Protocol>;
};

export type PatientProtocolConnection = {
  __typename?: 'PatientProtocolConnection';
  edges?: Maybe<Array<Maybe<PatientProtocolEdge>>>;
  pageInfo: PageInfo;
};

export type PatientProtocolEdge = {
  __typename?: 'PatientProtocolEdge';
  cursor?: Maybe<Scalars['String']['output']>;
  node?: Maybe<PatientProtocol>;
};

export type PatientProtocolFilters = {
  endDate?: InputMaybe<Scalars['Date']['input']>;
  endDueDate?: InputMaybe<Scalars['Date']['input']>;
  locationId?: InputMaybe<Scalars['ID']['input']>;
  locationIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  patientId?: InputMaybe<Scalars['ID']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
  startDueDate?: InputMaybe<Scalars['Date']['input']>;
  updatedAtEnd?: InputMaybe<Scalars['NaiveDateTime']['input']>;
  updatedAtStart?: InputMaybe<Scalars['NaiveDateTime']['input']>;
};

export type PatientProtocolOrderBy = {
  dueDate?: InputMaybe<OrderByDirection>;
  insertedAt?: InputMaybe<OrderByDirection>;
  updatedAt?: InputMaybe<OrderByDirection>;
};

/** A patient's RDVM assignment with patient-specific fields */
export type PatientRdvm = {
  __typename?: 'PatientRdvm';
  insertedAt?: Maybe<Scalars['NaiveDateTime']['output']>;
  isPreferred?: Maybe<Scalars['Boolean']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  rdvm?: Maybe<Rdvm>;
  referringDoctors?: Maybe<Scalars['String']['output']>;
};

export type PatientRegistration = {
  locationId?: InputMaybe<Scalars['ID']['input']>;
  patientId?: InputMaybe<Scalars['ID']['input']>;
};

export type PatientTag = {
  __typename?: 'PatientTag';
  color?: Maybe<Scalars['String']['output']>;
  coupons: Array<Coupon>;
  id: Scalars['ID']['output'];
  locations: Array<Location>;
  name?: Maybe<Scalars['String']['output']>;
  priority?: Maybe<Scalars['Int']['output']>;
};

export type PatientTagInput = {
  color?: InputMaybe<Scalars['String']['input']>;
  couponIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  locationIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  priority?: InputMaybe<Scalars['Int']['input']>;
};

export type Payment = {
  __typename?: 'Payment';
  amount?: Maybe<Scalars['Decimal']['output']>;
  canVoidPayment?: Maybe<Scalars['Boolean']['output']>;
  client?: Maybe<Client>;
  creditReason?: Maybe<CreditReasonRelated>;
  date?: Maybe<Scalars['Date']['output']>;
  datetime?: Maybe<Scalars['NaiveDateTime']['output']>;
  donation?: Maybe<Scalars['Decimal']['output']>;
  estimates?: Maybe<Array<Maybe<Estimate>>>;
  hasCreditAlteredByPayment?: Maybe<Scalars['Boolean']['output']>;
  hasVoidPayment?: Maybe<Scalars['Boolean']['output']>;
  hasVoidedPayment?: Maybe<Scalars['Boolean']['output']>;
  historicalId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  insertedAt?: Maybe<Scalars['NaiveDateTime']['output']>;
  isMarkAsRefundedRecord?: Maybe<Scalars['Boolean']['output']>;
  location?: Maybe<Location>;
  method?: Maybe<PaymentMethod>;
  methodType?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  orders: Array<Order>;
  paymentReason?: Maybe<PaymentReason>;
  provider?: Maybe<Provider>;
  reference?: Maybe<Scalars['String']['output']>;
  refundedAmount?: Maybe<Scalars['Decimal']['output']>;
  surcharge?: Maybe<Scalars['Decimal']['output']>;
  tip?: Maybe<Scalars['Decimal']['output']>;
  updatedAt?: Maybe<Scalars['NaiveDateTime']['output']>;
  /** @deprecated Please use `hasVoidPayment` instead */
  voided?: Maybe<Scalars['Boolean']['output']>;
};

export type PaymentInput = {
  locationId?: InputMaybe<Scalars['ID']['input']>;
  method?: InputMaybe<PaymentMethod>;
  methodType?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  reference?: InputMaybe<Scalars['String']['input']>;
};

export enum PaymentMethod {
  AccountCredit = 'ACCOUNT_CREDIT',
  Ach = 'ACH',
  Allegro = 'ALLEGRO',
  AllPetCard = 'ALL_PET_CARD',
  Apa = 'APA',
  ApClientRefundCheck = 'AP_CLIENT_REFUND_CHECK',
  Aspca = 'ASPCA',
  BadDebt = 'BAD_DEBT',
  CardconnectCapture = 'CARDCONNECT_CAPTURE',
  CardconnectChargeOnFile = 'CARDCONNECT_CHARGE_ON_FILE',
  CardconnectHostedPayment = 'CARDCONNECT_HOSTED_PAYMENT',
  CardconnectPay = 'CARDCONNECT_PAY',
  CareCredit = 'CARE_CREDIT',
  CarePlan = 'CARE_PLAN',
  Cash = 'CASH',
  Chargebee = 'CHARGEBEE',
  Check = 'CHECK',
  ClinicalTrial = 'CLINICAL_TRIAL',
  Clover = 'CLOVER',
  Credit = 'CREDIT',
  Deferred = 'DEFERRED',
  Donations = 'DONATIONS',
  ElectronicCheck = 'ELECTRONIC_CHECK',
  Fortiva = 'FORTIVA',
  GiftCard = 'GIFT_CARD',
  Groupon = 'GROUPON',
  Internal = 'INTERNAL',
  Intracompany = 'INTRACOMPANY',
  Membership = 'MEMBERSHIP',
  Migration = 'MIGRATION',
  PaymentBanc = 'PAYMENT_BANC',
  Pumpkin = 'PUMPKIN',
  Rectangle = 'RECTANGLE',
  Refund = 'REFUND',
  ScratchpayLoan = 'SCRATCHPAY_LOAN',
  ScratchPay = 'SCRATCH_PAY',
  SnapFinance = 'SNAP_FINANCE',
  Snout = 'SNOUT',
  Square = 'SQUARE',
  SquareConnect = 'SQUARE_CONNECT',
  SquarePay = 'SQUARE_PAY',
  Stripe = 'STRIPE',
  StripeInterac = 'STRIPE_INTERAC',
  StripePay = 'STRIPE_PAY',
  StripeTerminal = 'STRIPE_TERMINAL',
  Trupanion = 'TRUPANION',
  Voucher = 'VOUCHER'
}

export type PaymentReason = {
  __typename?: 'PaymentReason';
  id?: Maybe<Scalars['ID']['output']>;
  isActive?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type PaymentReasonInput = {
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export enum PaymentSort {
  /** Least recent payments first */
  Asc = 'ASC',
  /** Most recent payments first */
  Desc = 'DESC'
}

export type PaymentSource = {
  __typename?: 'PaymentSource';
  addressZip?: Maybe<Scalars['String']['output']>;
  brand?: Maybe<Scalars['String']['output']>;
  expMonth?: Maybe<Scalars['Int']['output']>;
  expYear?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  last4?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  stripeCardId?: Maybe<Scalars['String']['output']>;
  stripeTokenId?: Maybe<Scalars['String']['output']>;
};

export type PaymentSourceInput = {
  addressZip?: InputMaybe<Scalars['String']['input']>;
  brand?: InputMaybe<Scalars['String']['input']>;
  expMonth?: InputMaybe<Scalars['Int']['input']>;
  expYear?: InputMaybe<Scalars['Int']['input']>;
  last4?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  stripeCardId?: InputMaybe<Scalars['String']['input']>;
  stripeTokenId?: InputMaybe<Scalars['String']['input']>;
};

export type PaymentsTotals = {
  __typename?: 'PaymentsTotals';
  accountCredit?: Maybe<Scalars['Decimal']['output']>;
  accountCreditCount?: Maybe<Scalars['Int']['output']>;
  ach?: Maybe<Scalars['Decimal']['output']>;
  achCount?: Maybe<Scalars['Int']['output']>;
  allPetCard?: Maybe<Scalars['Decimal']['output']>;
  allPetCardCount?: Maybe<Scalars['Int']['output']>;
  allegro?: Maybe<Scalars['Decimal']['output']>;
  allegroCount?: Maybe<Scalars['Int']['output']>;
  apClientRefundCheck?: Maybe<Scalars['Decimal']['output']>;
  apClientRefundCheckCount?: Maybe<Scalars['Int']['output']>;
  apa?: Maybe<Scalars['Decimal']['output']>;
  apaCount?: Maybe<Scalars['Int']['output']>;
  aspca?: Maybe<Scalars['Decimal']['output']>;
  aspcaCount?: Maybe<Scalars['Int']['output']>;
  badDebt?: Maybe<Scalars['Decimal']['output']>;
  badDebtCount?: Maybe<Scalars['Int']['output']>;
  cardconnectCapture?: Maybe<Scalars['Decimal']['output']>;
  cardconnectCaptureCount?: Maybe<Scalars['Int']['output']>;
  cardconnectChargeOnFile?: Maybe<Scalars['Decimal']['output']>;
  cardconnectChargeOnFileCount?: Maybe<Scalars['Int']['output']>;
  cardconnectHostedPayment?: Maybe<Scalars['Decimal']['output']>;
  cardconnectHostedPaymentCount?: Maybe<Scalars['Int']['output']>;
  cardconnectPay?: Maybe<Scalars['Decimal']['output']>;
  cardconnectPayCount?: Maybe<Scalars['Int']['output']>;
  careCredit?: Maybe<Scalars['Decimal']['output']>;
  careCreditCount?: Maybe<Scalars['Int']['output']>;
  carePlan?: Maybe<Scalars['Decimal']['output']>;
  carePlanCount?: Maybe<Scalars['Int']['output']>;
  cash?: Maybe<Scalars['Decimal']['output']>;
  cashCount?: Maybe<Scalars['Int']['output']>;
  check?: Maybe<Scalars['Decimal']['output']>;
  checkCount?: Maybe<Scalars['Int']['output']>;
  clinicalTrial?: Maybe<Scalars['Decimal']['output']>;
  clinicalTrialCount?: Maybe<Scalars['Int']['output']>;
  clover?: Maybe<Scalars['Decimal']['output']>;
  cloverCount?: Maybe<Scalars['Int']['output']>;
  count?: Maybe<Scalars['Int']['output']>;
  credit?: Maybe<Scalars['Decimal']['output']>;
  creditCount?: Maybe<Scalars['Int']['output']>;
  donations?: Maybe<Scalars['Decimal']['output']>;
  donationsCount?: Maybe<Scalars['Int']['output']>;
  electronicCheck?: Maybe<Scalars['Decimal']['output']>;
  electronicCheckCount?: Maybe<Scalars['Int']['output']>;
  fortiva?: Maybe<Scalars['Decimal']['output']>;
  fortivaCount?: Maybe<Scalars['Int']['output']>;
  giftCard?: Maybe<Scalars['Decimal']['output']>;
  giftCardCount?: Maybe<Scalars['Int']['output']>;
  groupon?: Maybe<Scalars['Decimal']['output']>;
  grouponCount?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  internal?: Maybe<Scalars['Decimal']['output']>;
  internalCount?: Maybe<Scalars['Int']['output']>;
  intracompany?: Maybe<Scalars['Decimal']['output']>;
  intracompanyCount?: Maybe<Scalars['Int']['output']>;
  membership?: Maybe<Scalars['Decimal']['output']>;
  membershipCount?: Maybe<Scalars['Int']['output']>;
  paymentBanc?: Maybe<Scalars['Decimal']['output']>;
  paymentBancCount?: Maybe<Scalars['Int']['output']>;
  pumpkin?: Maybe<Scalars['Decimal']['output']>;
  pumpkinCount?: Maybe<Scalars['Int']['output']>;
  rectangle?: Maybe<Scalars['Decimal']['output']>;
  rectangleCount?: Maybe<Scalars['Int']['output']>;
  refund?: Maybe<Scalars['Decimal']['output']>;
  refundCount?: Maybe<Scalars['Int']['output']>;
  scratchPay?: Maybe<Scalars['Decimal']['output']>;
  scratchPayCount?: Maybe<Scalars['Int']['output']>;
  scratchpayLoan?: Maybe<Scalars['Decimal']['output']>;
  scratchpayLoanCount?: Maybe<Scalars['Int']['output']>;
  snapFinance?: Maybe<Scalars['Decimal']['output']>;
  snapFinanceCount?: Maybe<Scalars['Int']['output']>;
  square?: Maybe<Scalars['Decimal']['output']>;
  squareConnect?: Maybe<Scalars['Decimal']['output']>;
  squareConnectCount?: Maybe<Scalars['Int']['output']>;
  squareCount?: Maybe<Scalars['Int']['output']>;
  squarePay?: Maybe<Scalars['Decimal']['output']>;
  squarePayCount?: Maybe<Scalars['Int']['output']>;
  stripe?: Maybe<Scalars['Decimal']['output']>;
  stripeCount?: Maybe<Scalars['Int']['output']>;
  stripeTerminal?: Maybe<Scalars['Decimal']['output']>;
  stripeTerminalCount?: Maybe<Scalars['Int']['output']>;
  total?: Maybe<Scalars['Decimal']['output']>;
  trupanion?: Maybe<Scalars['Decimal']['output']>;
  trupanionCount?: Maybe<Scalars['Int']['output']>;
  voucher?: Maybe<Scalars['Decimal']['output']>;
  voucherCount?: Maybe<Scalars['Int']['output']>;
};

/** An org-scoped set of custom instructions for refining AI PDF extraction. */
export type PdfExtractionRule = {
  __typename?: 'PdfExtractionRule';
  active: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  immunizationInstructions?: Maybe<Scalars['String']['output']>;
  jobId?: Maybe<Scalars['String']['output']>;
  /** Base64-encoded bytes of the uploaded test PDF, for previewing a saved rule. Null when no upload is stored. Fetch lazily — it downloads the whole file. */
  media?: Maybe<Scalars['String']['output']>;
  medicationInstructions?: Maybe<Scalars['String']['output']>;
  patientInstructions?: Maybe<Scalars['String']['output']>;
  reminderInstructions?: Maybe<Scalars['String']['output']>;
  uploadBucket?: Maybe<Scalars['String']['output']>;
  uploadFilename?: Maybe<Scalars['String']['output']>;
  uploadPath?: Maybe<Scalars['String']['output']>;
};

export type PdfExtractionRuleInput = {
  /** Whether the rule is applied to the org's PDF imports. Omit to leave it unchanged. */
  active?: InputMaybe<Scalars['Boolean']['input']>;
  immunizationInstructions?: InputMaybe<Scalars['String']['input']>;
  jobId?: InputMaybe<Scalars['String']['input']>;
  medicationInstructions?: InputMaybe<Scalars['String']['input']>;
  patientInstructions?: InputMaybe<Scalars['String']['input']>;
  reminderInstructions?: InputMaybe<Scalars['String']['input']>;
  uploadBucket?: InputMaybe<Scalars['String']['input']>;
  uploadFilename?: InputMaybe<Scalars['String']['input']>;
  uploadPath?: InputMaybe<Scalars['String']['input']>;
};

/** Result of starting a 'Test Prompt' run: the submitted AI job id (which the client polls via the AI jobs endpoints) and the GCS reference to the uploaded PDF. */
export type PdfExtractionTestResult = {
  __typename?: 'PdfExtractionTestResult';
  jobId?: Maybe<Scalars['String']['output']>;
  uploadBucket?: Maybe<Scalars['String']['output']>;
  uploadFilename?: Maybe<Scalars['String']['output']>;
  uploadPath?: Maybe<Scalars['String']['output']>;
};

export type PendingImmunizationDatum = Datum & {
  __typename?: 'PendingImmunizationDatum';
  administerDate?: Maybe<Scalars['String']['output']>;
  doseQuantity?: Maybe<Scalars['String']['output']>;
  dueDate2?: Maybe<Scalars['String']['output']>;
  lotNumber?: Maybe<Scalars['String']['output']>;
  manufacturer?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  nextDueDate?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  prescriber?: Maybe<Scalars['String']['output']>;
  prescriberId?: Maybe<Scalars['String']['output']>;
  productId?: Maybe<Scalars['String']['output']>;
  rabiesTagNumber?: Maybe<Scalars['String']['output']>;
  required?: Maybe<Scalars['Truthy']['output']>;
  shortcutDays?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  site?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type PendingPackageDatum = Datum & {
  __typename?: 'PendingPackageDatum';
  name?: Maybe<Scalars['String']['output']>;
  required?: Maybe<Scalars['Truthy']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type PendingRxDatum = Datum & {
  __typename?: 'PendingRxDatum';
  applicationType?: Maybe<Scalars['String']['output']>;
  dispensed?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  prescriber?: Maybe<Scalars['String']['output']>;
  prescriberId?: Maybe<Scalars['String']['output']>;
  productId?: Maybe<Scalars['String']['output']>;
  quantity?: Maybe<Scalars['String']['output']>;
  refills?: Maybe<Scalars['String']['output']>;
  required?: Maybe<Scalars['Truthy']['output']>;
  sig?: Maybe<Scalars['String']['output']>;
  sigForQuantity?: Maybe<Scalars['String']['output']>;
  sigForUnit?: Maybe<Scalars['String']['output']>;
  sigFrequency?: Maybe<Scalars['String']['output']>;
  sigInstruction?: Maybe<Scalars['String']['output']>;
  sigLocation?: Maybe<Scalars['String']['output']>;
  sigNote?: Maybe<Scalars['String']['output']>;
  sigQuantity?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  units?: Maybe<Scalars['String']['output']>;
};

export type Permission = {
  __typename?: 'Permission';
  action: Scalars['String']['output'];
  adminTag?: Maybe<AdminTag>;
  context: Scalars['String']['output'];
  /** Parent permissions this permission depends on. At least one must be enabled for this permission to function. */
  requiredPermissions?: Maybe<Array<Permission>>;
  resource: Scalars['String']['output'];
  tooltip?: Maybe<Scalars['String']['output']>;
  value: Scalars['String']['output'];
};

export type PharmacyMedicationLock = {
  __typename?: 'PharmacyMedicationLock';
  lastEditedAt?: Maybe<Scalars['DateTime']['output']>;
  lastEditedById?: Maybe<Scalars['ID']['output']>;
  lastEditedBySessionId?: Maybe<Scalars['String']['output']>;
  medicationId?: Maybe<Scalars['ID']['output']>;
  providerName?: Maybe<Scalars['String']['output']>;
};

export type PharmacyMedicationsOrderBy = {
  id?: InputMaybe<OrderByDirection>;
  insertedAt?: InputMaybe<OrderByDirection>;
  name?: InputMaybe<OrderByDirection>;
  status?: InputMaybe<OrderByDirection>;
  updatedAt?: InputMaybe<OrderByDirection>;
};

export enum PharmacyRejectionReason {
  /** Rejection due to the medication being canceled by the doctor */
  CanceledByDoctor = 'CANCELED_BY_DOCTOR',
  /** Rejection due to client declining the medication */
  ClientDeclined = 'CLIENT_DECLINED',
  /** Rejection due to dosage clarification needed */
  DosageClarification = 'DOSAGE_CLARIFICATION',
  /** Rejection due to drug interaction */
  DrugInteraction = 'DRUG_INTERACTION',
  /** Rejection due to improper directions */
  ImproperDirections = 'IMPROPER_DIRECTIONS',
  /** Rejection due to incorrect route of administration */
  IncorrectRouteOfAdministration = 'INCORRECT_ROUTE_OF_ADMINISTRATION',
  /** Rejection due to manufacturer back order */
  ManufacturerBackOrder = 'MANUFACTURER_BACK_ORDER',
  /** Rejection due to medication being out of stock */
  OutOfStock = 'OUT_OF_STOCK'
}

/** Immutable snapshot of the medication's original state when first sent to pharmacy */
export type PharmacySnapshot = {
  __typename?: 'PharmacySnapshot';
  daysSupply?: Maybe<Scalars['Int']['output']>;
  deaNumber?: Maybe<Scalars['String']['output']>;
  dose?: Maybe<Scalars['String']['output']>;
  expiryDate?: Maybe<Scalars['Date']['output']>;
  frequency?: Maybe<Scalars['String']['output']>;
  fulfillmentSourceId?: Maybe<Scalars['Int']['output']>;
  fulfillmentSourceName?: Maybe<Scalars['String']['output']>;
  insertedAt?: Maybe<Scalars['NaiveDateTime']['output']>;
  lotNumber?: Maybe<Scalars['String']['output']>;
  manufacturerId?: Maybe<Scalars['Int']['output']>;
  manufacturerName?: Maybe<Scalars['String']['output']>;
  method?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  prescriberId?: Maybe<Scalars['Int']['output']>;
  prescriberName?: Maybe<Scalars['String']['output']>;
  productId?: Maybe<Scalars['Int']['output']>;
  quantity?: Maybe<Scalars['Decimal']['output']>;
  quantityUnit?: Maybe<Scalars['String']['output']>;
  refillByDate?: Maybe<Scalars['Date']['output']>;
  refills?: Maybe<Scalars['Int']['output']>;
  requestedById?: Maybe<Scalars['Int']['output']>;
  requestedByName?: Maybe<Scalars['String']['output']>;
  sig?: Maybe<Scalars['String']['output']>;
  start?: Maybe<Scalars['Date']['output']>;
  stop?: Maybe<Scalars['Date']['output']>;
  toGoHome?: Maybe<Scalars['Boolean']['output']>;
  /** The prescription's vial number */
  vialNumber?: Maybe<Scalars['String']['output']>;
};

export enum PharmacyStatus {
  /** Indicates a medication order that has been completed by the pharmacy. Used for the pharmacy whiteboard workflow. */
  Completed = 'COMPLETED',
  /** Indicates a medication order that is being physically filled by a pharmacy tech. Used for the granular pharmacy workflow. */
  FillInProgress = 'FILL_IN_PROGRESS',
  /** Indicates a medication order undergoing the Final Rx Check step. Used for the granular pharmacy workflow. */
  FillVerification = 'FILL_VERIFICATION',
  /** Indicates a medication order being actively processed by the pharmacy. Used for the pharmacy whiteboard workflow. */
  InProgress = 'IN_PROGRESS',
  /** Indicates a medication order that is on hold at the pharmacy. Used for the pharmacy whiteboard workflow. */
  OnHold = 'ON_HOLD',
  /** Indicates a medication order that has been approved and sent to the pharmacy whiteboard. Used for the Send to Pharmacy workflow. */
  Pending = 'PENDING',
  /** Indicates a medication order whose prescription has been approved by a pharmacist. Used for the granular pharmacy workflow. */
  PrescriptionApproved = 'PRESCRIPTION_APPROVED',
  /** Indicates a medication order undergoing prescription verification by a pharmacy tech. Used for the granular pharmacy workflow. */
  PrescriptionVerification = 'PRESCRIPTION_VERIFICATION',
  /** Indicates a medication order that is ready for pickup from the pharmacy. Used for the pharmacy whiteboard workflow. */
  Ready = 'READY',
  /** Indicates a medication order that was rejected by the pharmacy. Used for the pharmacy whiteboard workflow. */
  Rejected = 'REJECTED'
}

export type PhoneNumber = {
  __typename?: 'PhoneNumber';
  client?: Maybe<Client>;
  historicalId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  insertedAt?: Maybe<Scalars['NaiveDateTime']['output']>;
  /** Whether the phone number is a landline number versus a valid smartphone number that can accept SMS text messages */
  isLandline?: Maybe<Scalars['Boolean']['output']>;
  /** Name of the phone (e.g. Home, Mobile, or Office) */
  name?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  /** If this number is the preferred mode of contact. This is the number that will receive all text communications */
  preferred?: Maybe<Scalars['Boolean']['output']>;
  /** If automatic reminders should be sent to this phone number */
  reminders?: Maybe<Scalars['Boolean']['output']>;
  updatedAt?: Maybe<Scalars['NaiveDateTime']['output']>;
  /** The digits that compose the phone number (e.g. '+1 555 244 1356') */
  value?: Maybe<Scalars['String']['output']>;
};

export type PhoneNumberInput = {
  historicalId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  preferred?: InputMaybe<Scalars['Boolean']['input']>;
  reminders?: InputMaybe<Scalars['Boolean']['input']>;
  /** The digits that compose the phone number (e.g. '+1 555 244 1356') */
  value?: InputMaybe<Scalars['String']['input']>;
};

export enum PlanInterval {
  Monthly = 'MONTHLY',
  Quarterly = 'QUARTERLY',
  Yearly = 'YEARLY'
}

export type PlanOption = {
  __typename?: 'PlanOption';
  excludeRenewal?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  notNeutered?: Maybe<Scalars['Boolean']['output']>;
  package?: Maybe<ProductPackage>;
  packageId?: Maybe<Scalars['String']['output']>;
  product?: Maybe<Product>;
  productId?: Maybe<Scalars['String']['output']>;
  productIds?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  products?: Maybe<Array<Maybe<Product>>>;
  quantities?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  quantity?: Maybe<Scalars['Int']['output']>;
  required?: Maybe<Scalars['Boolean']['output']>;
  selected?: Maybe<Scalars['Boolean']['output']>;
  sex?: Maybe<Scalars['String']['output']>;
  species?: Maybe<Scalars['String']['output']>;
};

export type PlanOptionInput = {
  excludeRenewal?: InputMaybe<Scalars['Boolean']['input']>;
  /** optionally provide a fixed unit total */
  fixedUnitTotal?: InputMaybe<Scalars['Decimal']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notNeutered?: InputMaybe<Scalars['Boolean']['input']>;
  packageId?: InputMaybe<Scalars['ID']['input']>;
  productId?: InputMaybe<Scalars['ID']['input']>;
  productIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  quantities?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  selected?: InputMaybe<Scalars['Boolean']['input']>;
  sex?: InputMaybe<Scalars['String']['input']>;
  species?: InputMaybe<Scalars['String']['input']>;
};

export type PlayPackDeferredRevenueItem = {
  __typename?: 'PlayPackDeferredRevenueItem';
  clientId?: Maybe<Scalars['ID']['output']>;
  clientName?: Maybe<Scalars['String']['output']>;
  invoiced?: Maybe<Scalars['Boolean']['output']>;
  locationId?: Maybe<Scalars['ID']['output']>;
  orderId?: Maybe<Scalars['ID']['output']>;
  orderItemId?: Maybe<Scalars['ID']['output']>;
  packName?: Maybe<Scalars['String']['output']>;
  quantity?: Maybe<Scalars['Int']['output']>;
  quantityRemaining?: Maybe<Scalars['Int']['output']>;
  quantityUsed?: Maybe<Scalars['Int']['output']>;
  totalDeferred?: Maybe<Scalars['Decimal']['output']>;
  totalPaid?: Maybe<Scalars['Decimal']['output']>;
  totalUsed?: Maybe<Scalars['Decimal']['output']>;
};

export type PlayPackDeferredRevenueItemConnection = {
  __typename?: 'PlayPackDeferredRevenueItemConnection';
  edges?: Maybe<Array<Maybe<PlayPackDeferredRevenueItemEdge>>>;
  pageInfo: PageInfo;
};

export type PlayPackDeferredRevenueItemEdge = {
  __typename?: 'PlayPackDeferredRevenueItemEdge';
  cursor?: Maybe<Scalars['String']['output']>;
  node?: Maybe<PlayPackDeferredRevenueItem>;
};

export type PlumbsHandout = {
  __typename?: 'PlumbsHandout';
  contentType?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  plumbsId?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type PreventionPlan = {
  __typename?: 'PreventionPlan';
  autoRenewable?: Maybe<Scalars['Boolean']['output']>;
  dynamicPrice?: Maybe<Scalars['Boolean']['output']>;
  enrollable: Scalars['Boolean']['output'];
  enrollmentFee?: Maybe<Scalars['Decimal']['output']>;
  excludedProductIds?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  excludedProductTypeIds?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  id?: Maybe<Scalars['ID']['output']>;
  includedProductIds?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  insertedAt?: Maybe<Scalars['NaiveDateTime']['output']>;
  isActive?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  options?: Maybe<Array<Maybe<PlanOption>>>;
  percentDiscount?: Maybe<Scalars['Decimal']['output']>;
  planDiscountPercent?: Maybe<Scalars['Decimal']['output']>;
  previouslyPaidProductId?: Maybe<Scalars['Int']['output']>;
  sendAutoRenewNotices?: Maybe<Scalars['Boolean']['output']>;
  terms?: Maybe<Scalars['String']['output']>;
  totalValue?: Maybe<Scalars['Decimal']['output']>;
};

export type PreventionPlanInput = {
  autoRenewable?: InputMaybe<Scalars['Boolean']['input']>;
  dynamicPrice?: InputMaybe<Scalars['Boolean']['input']>;
  enrollable: Scalars['Boolean']['input'];
  enrollmentFee?: InputMaybe<Scalars['Decimal']['input']>;
  excludedProductIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  excludedProductTypeIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  includedProductIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  insertedAt?: InputMaybe<Scalars['NaiveDateTime']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  options?: InputMaybe<Array<InputMaybe<PlanOptionInput>>>;
  percentDiscount?: InputMaybe<Scalars['Decimal']['input']>;
  planDiscountPercent?: InputMaybe<Scalars['Decimal']['input']>;
  previouslyPaidProductId?: InputMaybe<Scalars['Int']['input']>;
  sendAutoRenewNotices?: InputMaybe<Scalars['Boolean']['input']>;
  terms?: InputMaybe<Scalars['String']['input']>;
  totalValue?: InputMaybe<Scalars['Decimal']['input']>;
};

/** A single price change */
export type PriceChange = {
  __typename?: 'PriceChange';
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  deletedById?: Maybe<Scalars['ID']['output']>;
  description: Scalars['String']['output'];
  downloadUrl?: Maybe<Scalars['String']['output']>;
  filters: Array<PriceChangeFilter>;
  id: Scalars['ID']['output'];
  insertedAt?: Maybe<Scalars['NaiveDateTime']['output']>;
  name: Scalars['String']['output'];
  priceChangeType: PriceChangeType;
  priceChangeValue: Scalars['Decimal']['output'];
  pricingType: PricingType;
  provider?: Maybe<Provider>;
  status: PriceChangeStatus;
};

export type PriceChangeFilter = {
  __typename?: 'PriceChangeFilter';
  allSelected: Scalars['Boolean']['output'];
  excludeSelected: Scalars['Boolean']['output'];
  ids?: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
  type: PriceChangeFilterType;
  values?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type PriceChangeFilterInput = {
  allSelected: Scalars['Boolean']['input'];
  excludeSelected: Scalars['Boolean']['input'];
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  type: PriceChangeFilterType;
  values?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export enum PriceChangeFilterType {
  DepartmentIds = 'DEPARTMENT_IDS',
  Districts = 'DISTRICTS',
  LocationIds = 'LOCATION_IDS',
  LocationTagIds = 'LOCATION_TAG_IDS',
  ManufacturerIds = 'MANUFACTURER_IDS',
  Products = 'PRODUCTS',
  ProductCategoryIds = 'PRODUCT_CATEGORY_IDS',
  ProductCodeIds = 'PRODUCT_CODE_IDS',
  ProductNameIds = 'PRODUCT_NAME_IDS',
  ProductTypeIds = 'PRODUCT_TYPE_IDS',
  Regions = 'REGIONS',
  States = 'STATES'
}

export type PriceChangeInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Array<InputMaybe<PriceChangeFilterInput>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  priceChangeType?: InputMaybe<PriceChangeType>;
  priceChangeValue?: InputMaybe<Scalars['Decimal']['input']>;
  pricingType?: InputMaybe<PricingType>;
};

export enum PriceChangeStatus {
  Completed = 'COMPLETED',
  Pending = 'PENDING'
}

export enum PriceChangeType {
  Flat = 'FLAT',
  Percent = 'PERCENT'
}

export type PriceTier = {
  __typename?: 'PriceTier';
  tier?: Maybe<Scalars['Int']['output']>;
  unitFee?: Maybe<Scalars['String']['output']>;
};

export type PriceTierInput = {
  tier?: InputMaybe<Scalars['Int']['input']>;
  unitFee?: InputMaybe<Scalars['Decimal']['input']>;
};

export enum PriceType {
  DefaultMarkup = 'DEFAULT_MARKUP',
  Fixed = 'FIXED',
  Markup = 'MARKUP',
  Volume = 'VOLUME'
}

export enum PricingType {
  Dispense = 'DISPENSE',
  Fixed = 'FIXED',
  Markup = 'MARKUP',
  Unit = 'UNIT',
  Volume = 'VOLUME'
}

export type PrintLabelResult = {
  __typename?: 'PrintLabelResult';
  status?: Maybe<Scalars['String']['output']>;
};

export type PrinterInput = {
  copies: Scalars['Int']['input'];
  locationId: Scalars['ID']['input'];
  printerid: Scalars['String']['input'];
};

export type PrintnodeComputersField = {
  __typename?: 'PrintnodeComputersField';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  state?: Maybe<Scalars['String']['output']>;
};

export type PrintnodePrintersField = {
  __typename?: 'PrintnodePrintersField';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  paperSizes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  status: Scalars['String']['output'];
};

/** A problem in a patient's problem list */
export type Problem = {
  __typename?: 'Problem';
  childProblems?: Maybe<Array<Maybe<Problem>>>;
  comment?: Maybe<Scalars['String']['output']>;
  diagnosis?: Maybe<Diagnosis>;
  enteredBy?: Maybe<Provider>;
  eye?: Maybe<Eye>;
  firstEncounter?: Maybe<Array<Maybe<Scalars['DateTime']['output']>>>;
  id?: Maybe<Scalars['ID']['output']>;
  insertedAt?: Maybe<Scalars['NaiveDateTime']['output']>;
  isActive?: Maybe<Scalars['Boolean']['output']>;
  /** optional name if not linked to a diagnosis code */
  name?: Maybe<Scalars['String']['output']>;
  numberOfEncounters?: Maybe<Scalars['Int']['output']>;
  onsetDate?: Maybe<Scalars['Date']['output']>;
  patient?: Maybe<Patient>;
  resolvedBy?: Maybe<Provider>;
  resolvedDate?: Maybe<Scalars['Date']['output']>;
  treatments?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  type?: Maybe<ProblemType>;
};

export type ProblemInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  diagnosisId?: InputMaybe<Scalars['ID']['input']>;
  encounterId?: InputMaybe<Scalars['ID']['input']>;
  eye?: InputMaybe<Eye>;
  id?: InputMaybe<Scalars['ID']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  onsetDate?: InputMaybe<Scalars['Date']['input']>;
  resolvedDate?: InputMaybe<Scalars['Date']['input']>;
  treatments?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type?: InputMaybe<ProblemType>;
};

export enum ProblemType {
  Acute = 'ACUTE',
  Chronic = 'CHRONIC'
}

export type ProcessorPayment = {
  __typename?: 'ProcessorPayment';
  amount?: Maybe<Scalars['Decimal']['output']>;
  datetime?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

/**
 * A product is a single line item of something tangible that the org can
 *   sell to the client and/or patient.
 */
export type Product = {
  __typename?: 'Product';
  ageRestriction?: Maybe<Scalars['Numrange']['output']>;
  alternativeName?: Maybe<Scalars['String']['output']>;
  applicationType?: Maybe<ProductApplicationType>;
  buyingQuantity?: Maybe<Scalars['Int']['output']>;
  cityTaxedLocations?: Maybe<Array<Maybe<Location>>>;
  /** Organization-defined product code */
  code?: Maybe<Scalars['String']['output']>;
  coerceIntegerQuantity?: Maybe<Scalars['Boolean']['output']>;
  controlledDrugSchedule?: Maybe<ScheduledDrugType>;
  countyTaxedLocations?: Maybe<Array<Maybe<Location>>>;
  createdBy?: Maybe<Provider>;
  cubexEnabledAt?: Maybe<Scalars['Boolean']['output']>;
  cubexEnabledLocations?: Maybe<Array<Maybe<Location>>>;
  defaultRoute?: Maybe<RouteType>;
  defaultSig?: Maybe<Scalars['String']['output']>;
  defaultSite?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  diagnosticCode?: Maybe<Scalars['String']['output']>;
  diagnosticCodeOrgLabType?: Maybe<OrgLabType>;
  diagnosticCodeOrgLabTypeMetadata?: Maybe<OrgLabTypeMetadata>;
  disabled?: Maybe<Scalars['Boolean']['output']>;
  disabledLocations?: Maybe<Array<Maybe<Location>>>;
  dischargeInstructions?: Maybe<Scalars['String']['output']>;
  /** Dispense fee added to the product independent of units given */
  dispenseFee?: Maybe<Scalars['Decimal']['output']>;
  enabledAt?: Maybe<Scalars['Boolean']['output']>;
  enabledLocationTags?: Maybe<Array<Maybe<LocationTag>>>;
  enabledLocations?: Maybe<Array<Maybe<Location>>>;
  /** If the sale price should be calculated by the unit fixed price or by the markup percentage */
  fixed?: Maybe<Scalars['Boolean']['output']>;
  fulfillmentSources?: Maybe<Array<Maybe<FulfillmentSource>>>;
  historicalId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  inStock?: Maybe<Scalars['Decimal']['output']>;
  insertedAt?: Maybe<Scalars['NaiveDateTime']['output']>;
  inventoryLevels?: Maybe<Array<Maybe<InventoryLevel>>>;
  inventoryStockLocation?: Maybe<Scalars['String']['output']>;
  invoiceBlurb?: Maybe<Scalars['String']['output']>;
  invoiceOnOrderCreation?: Maybe<Scalars['Boolean']['output']>;
  isControlledDrug?: Maybe<Scalars['Boolean']['output']>;
  isEuthanasia?: Maybe<Scalars['Boolean']['output']>;
  isNeuter?: Maybe<Scalars['Boolean']['output']>;
  isNonCompensated?: Maybe<Scalars['Boolean']['output']>;
  lastUsedDate?: Maybe<Scalars['NaiveDateTime']['output']>;
  linkedProducts?: Maybe<Array<Maybe<Product>>>;
  locationMarkup?: Maybe<Scalars['Decimal']['output']>;
  lotNumbers?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  lowStockThresholds?: Maybe<Array<Maybe<LowStockThreshold>>>;
  manufacturer?: Maybe<ProductManufacturer>;
  masterProducts?: Maybe<Array<Maybe<MasterProduct>>>;
  /** Maximum number of times this product can be added to an invoice by linking a day */
  maxDailyLinks?: Maybe<Scalars['Int']['output']>;
  maxOrderLimit?: Maybe<Scalars['Int']['output']>;
  metadataFields?: Maybe<Array<Maybe<ProductMetadataField>>>;
  minimumPrice?: Maybe<Scalars['Decimal']['output']>;
  /** Minimum price the product should be sold at (overrides all other considerations if the calculated price is less than this value if set) */
  minimumUnitPrice?: Maybe<Scalars['Decimal']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  ndc?: Maybe<Scalars['String']['output']>;
  /** Private note attached to this product */
  note?: Maybe<Scalars['String']['output']>;
  onlyInventory?: Maybe<Scalars['Boolean']['output']>;
  orderItems?: Maybe<Array<Maybe<OrderItem>>>;
  packageOnly?: Maybe<Scalars['Boolean']['output']>;
  packageOnlyLocations?: Maybe<Array<Maybe<Location>>>;
  parentProduct?: Maybe<Product>;
  parentProductId?: Maybe<Scalars['ID']['output']>;
  price?: Maybe<ProductPrice>;
  priceLocked?: Maybe<Scalars['Boolean']['output']>;
  prices?: Maybe<Array<Maybe<ProductPrice>>>;
  productCategories?: Maybe<Array<Maybe<ProductCategory>>>;
  productConfig?: Maybe<ProductConfig>;
  productManufacturers?: Maybe<Array<Maybe<ProductManufacturer>>>;
  productType?: Maybe<ProductType>;
  productTypeId?: Maybe<Scalars['ID']['output']>;
  promptsTip?: Maybe<Scalars['Boolean']['output']>;
  quantitySold?: Maybe<Scalars['Decimal']['output']>;
  /** Contract true cost of one unit, if different than unit cost */
  realUnitCost?: Maybe<Scalars['Decimal']['output']>;
  requiresHistory?: Maybe<Scalars['Boolean']['output']>;
  restrictToOnlyNonNeutered?: Maybe<Scalars['Boolean']['output']>;
  revenueCenter?: Maybe<RevenueCenter>;
  sellingQuantity?: Maybe<Scalars['Int']['output']>;
  sku?: Maybe<Scalars['String']['output']>;
  speciesRestrictions?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  stateTaxedLocations?: Maybe<Array<Maybe<Location>>>;
  stockLocationSource?: Maybe<Scalars['String']['output']>;
  suggestedProducts?: Maybe<Array<Maybe<Product>>>;
  taxedLocations?: Maybe<Array<Maybe<Location>>>;
  trackInventory?: Maybe<Scalars['Boolean']['output']>;
  undeletable?: Maybe<Scalars['Boolean']['output']>;
  /** Cost of one unit of the product */
  unitCost?: Maybe<Scalars['Decimal']['output']>;
  unitDurationDays?: Maybe<Scalars['String']['output']>;
  /** If fixed is true, then the sale price will be fixed to this value */
  unitFixedPrice?: Maybe<Scalars['Decimal']['output']>;
  /** Decimal representation [0-1] of the percentage that the product should be marked up to calculate sale price */
  unitMarkupPercent?: Maybe<Scalars['Decimal']['output']>;
  /** The calculated sale price of a unit of the product */
  unitPrice?: Maybe<Scalars['Decimal']['output']>;
  units?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['NaiveDateTime']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  /** If the default markup should be used */
  useDefault?: Maybe<Scalars['Boolean']['output']>;
  vetsourceId?: Maybe<Scalars['String']['output']>;
  weightRestriction?: Maybe<Scalars['Numrange']['output']>;
};


/**
 * A product is a single line item of something tangible that the org can
 *   sell to the client and/or patient.
 */
export type ProductCubexEnabledAtArgs = {
  locationId: Scalars['ID']['input'];
};


/**
 * A product is a single line item of something tangible that the org can
 *   sell to the client and/or patient.
 */
export type ProductEnabledAtArgs = {
  locationId: Scalars['ID']['input'];
};


/**
 * A product is a single line item of something tangible that the org can
 *   sell to the client and/or patient.
 */
export type ProductInStockArgs = {
  insertedAt?: InputMaybe<Scalars['NaiveDateTime']['input']>;
  locationId: Scalars['ID']['input'];
};


/**
 * A product is a single line item of something tangible that the org can
 *   sell to the client and/or patient.
 */
export type ProductInventoryLevelsArgs = {
  locationId?: InputMaybe<Scalars['ID']['input']>;
};


/**
 * A product is a single line item of something tangible that the org can
 *   sell to the client and/or patient.
 */
export type ProductLocationMarkupArgs = {
  locationId: Scalars['ID']['input'];
};


/**
 * A product is a single line item of something tangible that the org can
 *   sell to the client and/or patient.
 */
export type ProductLotNumbersArgs = {
  locationId?: InputMaybe<Scalars['ID']['input']>;
  onlyAvailable?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * A product is a single line item of something tangible that the org can
 *   sell to the client and/or patient.
 */
export type ProductLowStockThresholdsArgs = {
  locationId?: InputMaybe<Scalars['ID']['input']>;
};


/**
 * A product is a single line item of something tangible that the org can
 *   sell to the client and/or patient.
 */
export type ProductPriceArgs = {
  locationId?: InputMaybe<Scalars['ID']['input']>;
};


/**
 * A product is a single line item of something tangible that the org can
 *   sell to the client and/or patient.
 */
export type ProductPricesArgs = {
  onlyViewer?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * A product is a single line item of something tangible that the org can
 *   sell to the client and/or patient.
 */
export type ProductQuantitySoldArgs = {
  endDate?: InputMaybe<Scalars['Date']['input']>;
  insertedAtEnd?: InputMaybe<Scalars['NaiveDateTime']['input']>;
  insertedAtStart?: InputMaybe<Scalars['NaiveDateTime']['input']>;
  locationId: Scalars['ID']['input'];
  startDate?: InputMaybe<Scalars['Date']['input']>;
};


/**
 * A product is a single line item of something tangible that the org can
 *   sell to the client and/or patient.
 */
export type ProductUnitPriceArgs = {
  includeDispenseFee?: InputMaybe<Scalars['Boolean']['input']>;
  locationId?: InputMaybe<Scalars['ID']['input']>;
  quantity?: InputMaybe<Scalars['Decimal']['input']>;
  quickPriceCheck?: InputMaybe<Scalars['Boolean']['input']>;
  useMinimum?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum ProductApplicationType {
  Drops = 'DROPS',
  Ear = 'EAR',
  Eye = 'EYE',
  Im = 'IM',
  Injectable = 'INJECTABLE',
  Intramuscular = 'INTRAMUSCULAR',
  Intranasal = 'INTRANASAL',
  Iv = 'IV',
  NgTube = 'NG_TUBE',
  Ointment = 'OINTMENT',
  Oral = 'ORAL',
  PegTube = 'PEG_TUBE',
  Rectal = 'RECTAL',
  Spl = 'SPL',
  Subcutaneous = 'SUBCUTANEOUS',
  SubQ = 'SUB_Q',
  Tm = 'TM',
  Topical = 'TOPICAL',
  Transdermal = 'TRANSDERMAL'
}

export type ProductCategory = {
  __typename?: 'ProductCategory';
  amountSold?: Maybe<Scalars['Decimal']['output']>;
  cityTaxedLocations: Array<Location>;
  countyTaxedLocations: Array<Location>;
  historicalId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  stateTaxedLocations: Array<Location>;
  taxedLocations: Array<Location>;
};


export type ProductCategoryAmountSoldArgs = {
  endDate?: InputMaybe<Scalars['Date']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
};

export type ProductCategoryInput = {
  cityTaxedLocationIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  countyTaxedLocationIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  historicalId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  stateTaxedLocationIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  taxedLocationIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

export type ProductConfig = {
  __typename?: 'ProductConfig';
  defaultNotes?: Maybe<Scalars['String']['output']>;
  dosageConfig?: Maybe<ProductDosageConfig>;
  id: Scalars['ID']['output'];
};

export type ProductConfigInput = {
  defaultNotes?: InputMaybe<Scalars['String']['input']>;
  dosageConfig?: InputMaybe<DosageConfigInput>;
};

export type ProductDosageConfig = {
  __typename?: 'ProductDosageConfig';
  drugStrength: Scalars['Decimal']['output'];
  id: Scalars['ID']['output'];
  insertedAt?: Maybe<Scalars['NaiveDateTime']['output']>;
  productConfig?: Maybe<ProductConfig>;
  productConfigId: Scalars['ID']['output'];
  speciesDosageConfigs?: Maybe<Array<Maybe<ProductSpeciesDosageConfig>>>;
  unit: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['NaiveDateTime']['output']>;
};

export type ProductInput = {
  ageRestriction?: InputMaybe<Scalars['Numrange']['input']>;
  alternativeName?: InputMaybe<Scalars['String']['input']>;
  applicationType?: InputMaybe<ProductApplicationType>;
  buyingQuantity?: InputMaybe<Scalars['Int']['input']>;
  cityTaxedLocationIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  code?: InputMaybe<Scalars['String']['input']>;
  coerceIntegerQuantity?: InputMaybe<Scalars['Boolean']['input']>;
  controlledDrugSchedule?: InputMaybe<ScheduledDrugType>;
  countyTaxedLocationIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  cubexEnabledLocationIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  defaultRoute?: InputMaybe<RouteType>;
  defaultSig?: InputMaybe<Scalars['String']['input']>;
  defaultSite?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  diagnosticCode?: InputMaybe<Scalars['String']['input']>;
  diagnosticCodeOrgLabType?: InputMaybe<OrgLabType>;
  diagnosticCodeOrgLabTypeId?: InputMaybe<Scalars['ID']['input']>;
  disabled?: InputMaybe<Scalars['Boolean']['input']>;
  disabledLocations?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  dischargeInstructions?: InputMaybe<Scalars['String']['input']>;
  dispenseFee?: InputMaybe<Scalars['Decimal']['input']>;
  enabledLocationIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  enabledLocationTagIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  fixed?: InputMaybe<Scalars['Boolean']['input']>;
  fulfillmentSources?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  historicalId?: InputMaybe<Scalars['String']['input']>;
  inventoryStockLocation?: InputMaybe<Scalars['String']['input']>;
  invoiceBlurb?: InputMaybe<Scalars['String']['input']>;
  invoiceOnOrderCreation?: InputMaybe<Scalars['Boolean']['input']>;
  isControlledDrug?: InputMaybe<Scalars['Boolean']['input']>;
  isEuthanasia?: InputMaybe<Scalars['Boolean']['input']>;
  isNeuter?: InputMaybe<Scalars['Boolean']['input']>;
  isNonCompensated?: InputMaybe<Scalars['Boolean']['input']>;
  linkedProductIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  lowStockThresholds?: InputMaybe<Array<InputMaybe<LowStockThresholdInput>>>;
  manufacturerId?: InputMaybe<Scalars['ID']['input']>;
  masterProductIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  maxDailyLinks?: InputMaybe<Scalars['Int']['input']>;
  maxOrderLimit?: InputMaybe<Scalars['Int']['input']>;
  metadataFields?: InputMaybe<Array<InputMaybe<ProductMetadataFieldInput>>>;
  minimumPrice?: InputMaybe<Scalars['Decimal']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  ndc?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  onlyInventory?: InputMaybe<Scalars['Boolean']['input']>;
  packageOnly?: InputMaybe<Scalars['Boolean']['input']>;
  packageOnlyLocationIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  parentProductId?: InputMaybe<Scalars['ID']['input']>;
  priceLocked?: InputMaybe<Scalars['Boolean']['input']>;
  productCategories?: InputMaybe<Array<InputMaybe<ProductCategoryInput>>>;
  productCategoryIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  productConfig?: InputMaybe<ProductConfigInput>;
  productManufacturerIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  productTypeId?: InputMaybe<Scalars['ID']['input']>;
  promptsTip?: InputMaybe<Scalars['Boolean']['input']>;
  realUnitCost?: InputMaybe<Scalars['Decimal']['input']>;
  requiresHistory?: InputMaybe<Scalars['Boolean']['input']>;
  restrictToOnlyNonNeutered?: InputMaybe<Scalars['Boolean']['input']>;
  revenueCenterId?: InputMaybe<Scalars['ID']['input']>;
  sellingQuantity?: InputMaybe<Scalars['Int']['input']>;
  sku?: InputMaybe<Scalars['String']['input']>;
  speciesRestrictions?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  stateTaxedLocationIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  stockLocationSource?: InputMaybe<Scalars['String']['input']>;
  suggestedProductIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  taxedLocationIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  trackInventory?: InputMaybe<Scalars['Boolean']['input']>;
  undeletable?: InputMaybe<Scalars['Boolean']['input']>;
  unitCost?: InputMaybe<Scalars['Decimal']['input']>;
  unitDurationDays?: InputMaybe<Scalars['String']['input']>;
  unitFixedPrice?: InputMaybe<Scalars['Decimal']['input']>;
  unitMarkupPercent?: InputMaybe<Scalars['Decimal']['input']>;
  units?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  useDefault?: InputMaybe<Scalars['Boolean']['input']>;
  vetsourceId?: InputMaybe<Scalars['String']['input']>;
  weightRestriction?: InputMaybe<Scalars['Numrange']['input']>;
};

export type ProductManufacturer = {
  __typename?: 'ProductManufacturer';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  productId?: Maybe<Scalars['ID']['output']>;
};

export type ProductManufacturerInput = {
  name?: InputMaybe<Scalars['String']['input']>;
};

export type ProductManufacturerPage = {
  __typename?: 'ProductManufacturerPage';
  entries?: Maybe<Array<ProductManufacturer>>;
  metadata: Cursor;
};

export type ProductMetadataField = {
  __typename?: 'ProductMetadataField';
  name?: Maybe<Scalars['String']['output']>;
};

export type ProductMetadataFieldInput = {
  name?: InputMaybe<Scalars['String']['input']>;
};

export type ProductPackage = {
  __typename?: 'ProductPackage';
  ageRestriction?: Maybe<Scalars['Numrange']['output']>;
  cityTaxedLocationTags?: Maybe<Array<Maybe<LocationTag>>>;
  cityTaxedLocations?: Maybe<Array<Maybe<Location>>>;
  countyTaxedLocationTags?: Maybe<Array<Maybe<LocationTag>>>;
  countyTaxedLocations?: Maybe<Array<Maybe<Location>>>;
  discountPercent?: Maybe<Scalars['Decimal']['output']>;
  enabledLocationTags?: Maybe<Array<Maybe<LocationTag>>>;
  enabledLocations?: Maybe<Array<Maybe<Location>>>;
  fixedPrice?: Maybe<Scalars['Decimal']['output']>;
  hasMedicationProducts: Scalars['Boolean']['output'];
  id?: Maybe<Scalars['ID']['output']>;
  includedPackages?: Maybe<Array<Maybe<ProductPackage>>>;
  insertedAt?: Maybe<Scalars['NaiveDateTime']['output']>;
  isDisabled?: Maybe<Scalars['Boolean']['output']>;
  isLocked?: Maybe<Scalars['Boolean']['output']>;
  isPicklist?: Maybe<Scalars['Boolean']['output']>;
  /**
   * @deprecated This field is deprecated and will only ever return an product packages's `is_taxed_other`.
   * ProductPackages now have various tax rate fields you may want to read. Please update your queries
   * to pull from `isTaxedOther`, `isTaxedCity`, `isTaxedState`, and `isTaxedCounty`.
   *
   */
  isTaxed?: Maybe<Scalars['Boolean']['output']>;
  isTaxedCity?: Maybe<Scalars['Boolean']['output']>;
  isTaxedCounty?: Maybe<Scalars['Boolean']['output']>;
  isTaxedOther?: Maybe<Scalars['Boolean']['output']>;
  isTaxedState?: Maybe<Scalars['Boolean']['output']>;
  items?: Maybe<Array<Maybe<ProductPackageItem>>>;
  name?: Maybe<Scalars['String']['output']>;
  priceType?: Maybe<PriceType>;
  restrictToOnlyNonNeutered?: Maybe<Scalars['Boolean']['output']>;
  revenueCenter?: Maybe<RevenueCenter>;
  revenueCenterId?: Maybe<Scalars['ID']['output']>;
  speciesRestrictions?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  stateTaxedLocationTags?: Maybe<Array<Maybe<LocationTag>>>;
  stateTaxedLocations?: Maybe<Array<Maybe<Location>>>;
  taxedLocationTags?: Maybe<Array<Maybe<LocationTag>>>;
  taxedLocations?: Maybe<Array<Maybe<Location>>>;
  weightRestriction?: Maybe<Scalars['Numrange']['output']>;
};


export type ProductPackageFixedPriceArgs = {
  locationId?: InputMaybe<Scalars['ID']['input']>;
};


export type ProductPackageItemsArgs = {
  locationId?: InputMaybe<Scalars['ID']['input']>;
  patientId?: InputMaybe<Scalars['ID']['input']>;
  sorted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProductPackageInput = {
  ageRestriction?: InputMaybe<Scalars['Numrange']['input']>;
  cityTaxedLocationIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  cityTaxedLocationTagIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  countyTaxedLocationIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  countyTaxedLocationTagIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  discountPercent?: InputMaybe<Scalars['Decimal']['input']>;
  enabledLocationIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  enabledLocationTagIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  fixedPrice?: InputMaybe<Scalars['Decimal']['input']>;
  isDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  isLocked?: InputMaybe<Scalars['Boolean']['input']>;
  isPicklist?: InputMaybe<Scalars['Boolean']['input']>;
  isTaxed?: InputMaybe<Scalars['Boolean']['input']>;
  isTaxedCity?: InputMaybe<Scalars['Boolean']['input']>;
  isTaxedCounty?: InputMaybe<Scalars['Boolean']['input']>;
  isTaxedOther?: InputMaybe<Scalars['Boolean']['input']>;
  isTaxedState?: InputMaybe<Scalars['Boolean']['input']>;
  items?: InputMaybe<Array<InputMaybe<ProductPackageItemInput>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  priceType?: InputMaybe<PriceType>;
  restrictToOnlyNonNeutered?: InputMaybe<Scalars['Boolean']['input']>;
  revenueCenterId?: InputMaybe<Scalars['ID']['input']>;
  speciesRestrictions?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  stateTaxedLocationIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  stateTaxedLocationTagIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  taxedLocationIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  taxedLocationTagIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  weightRestriction?: InputMaybe<Scalars['Numrange']['input']>;
};

export type ProductPackageItem = {
  __typename?: 'ProductPackageItem';
  deleted?: Maybe<Scalars['Boolean']['output']>;
  fixedPrice?: Maybe<Scalars['Decimal']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  isHidden?: Maybe<Scalars['Boolean']['output']>;
  isIncluded?: Maybe<Scalars['Boolean']['output']>;
  isRequired?: Maybe<Scalars['Boolean']['output']>;
  overridePrice?: Maybe<Scalars['Boolean']['output']>;
  position?: Maybe<Scalars['Int']['output']>;
  product?: Maybe<Product>;
  productPackage?: Maybe<ProductPackage>;
  quantity?: Maybe<Scalars['Decimal']['output']>;
};

export type ProductPackageItemInput = {
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  fixedPrice?: InputMaybe<Scalars['Decimal']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  isHidden?: InputMaybe<Scalars['Boolean']['input']>;
  isIncluded?: InputMaybe<Scalars['Boolean']['input']>;
  isRequired?: InputMaybe<Scalars['Boolean']['input']>;
  overridePrice?: InputMaybe<Scalars['Boolean']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
  productId?: InputMaybe<Scalars['ID']['input']>;
  productPackageId?: InputMaybe<Scalars['ID']['input']>;
  quantity?: InputMaybe<Scalars['Decimal']['input']>;
};

export type ProductPrice = {
  __typename?: 'ProductPrice';
  department?: Maybe<Department>;
  dispenseFee?: Maybe<Scalars['Decimal']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  insertedAt?: Maybe<Scalars['NaiveDateTime']['output']>;
  location?: Maybe<Location>;
  locationTag?: Maybe<LocationTag>;
  minimumPrice?: Maybe<Scalars['Decimal']['output']>;
  product?: Maybe<Product>;
  type?: Maybe<PriceType>;
  unitFixedPrice?: Maybe<Scalars['Decimal']['output']>;
  unitMarkupPercent?: Maybe<Scalars['Decimal']['output']>;
  updatedAt?: Maybe<Scalars['NaiveDateTime']['output']>;
  volumeTiers?: Maybe<Array<Maybe<PriceTier>>>;
};

export type ProductPriceInput = {
  departmentId?: InputMaybe<Scalars['ID']['input']>;
  dispenseFee?: InputMaybe<Scalars['Decimal']['input']>;
  locationId?: InputMaybe<Scalars['ID']['input']>;
  locationTagId?: InputMaybe<Scalars['ID']['input']>;
  minimumPrice?: InputMaybe<Scalars['Decimal']['input']>;
  productId?: InputMaybe<Scalars['ID']['input']>;
  type?: InputMaybe<PriceType>;
  unitFixedPrice?: InputMaybe<Scalars['Decimal']['input']>;
  unitMarkupPercent?: InputMaybe<Scalars['Decimal']['input']>;
  volumeTiers?: InputMaybe<Array<InputMaybe<PriceTierInput>>>;
};

export type ProductSpeciesDosageConfig = {
  __typename?: 'ProductSpeciesDosageConfig';
  doseUnit?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  insertedAt?: Maybe<Scalars['NaiveDateTime']['output']>;
  maxDose: Scalars['Decimal']['output'];
  minDose: Scalars['Decimal']['output'];
  productDosageConfigId: Scalars['ID']['output'];
  sortOrder: Scalars['Int']['output'];
  species?: Maybe<Species>;
  speciesId: Scalars['ID']['output'];
  treatmentType: DosageTreatmentType;
  updatedAt?: Maybe<Scalars['NaiveDateTime']['output']>;
};

export type ProductSuggestion = {
  __typename?: 'ProductSuggestion';
  citation?: Maybe<Scalars['String']['output']>;
  encounter?: Maybe<Encounter>;
  id: Scalars['ID']['output'];
  insertedAt?: Maybe<Scalars['NaiveDateTime']['output']>;
  jobId: Scalars['String']['output'];
  productType: ProductSuggestionType;
  suggestedName: Scalars['String']['output'];
  suggestedProduct?: Maybe<Product>;
  updatedAt?: Maybe<Scalars['NaiveDateTime']['output']>;
};

export enum ProductSuggestionType {
  Diagnostic = 'DIAGNOSTIC',
  Immunization = 'IMMUNIZATION',
  Medication = 'MEDICATION',
  Treatment = 'TREATMENT'
}

export type ProductType = {
  __typename?: 'ProductType';
  amountSold?: Maybe<Scalars['Decimal']['output']>;
  cityTaxedLocationTags?: Maybe<Array<Maybe<LocationTag>>>;
  cityTaxedLocations?: Maybe<Array<Maybe<Location>>>;
  coerceIntegerQuantity?: Maybe<Scalars['Boolean']['output']>;
  commissions?: Maybe<Array<Maybe<ProviderCommission>>>;
  countyTaxedLocationTags?: Maybe<Array<Maybe<LocationTag>>>;
  countyTaxedLocations?: Maybe<Array<Maybe<Location>>>;
  defaultResource?: Maybe<Scalars['String']['output']>;
  dispenseFee?: Maybe<Scalars['Decimal']['output']>;
  hasLotNumber?: Maybe<Scalars['Boolean']['output']>;
  historicalId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  insertedAt?: Maybe<Scalars['NaiveDateTime']['output']>;
  invoiceBlurb?: Maybe<Scalars['String']['output']>;
  isBoarding?: Maybe<Scalars['Boolean']['output']>;
  isBoardingAddon?: Maybe<Scalars['Boolean']['output']>;
  isDefault?: Maybe<Scalars['Boolean']['output']>;
  isExam?: Maybe<Scalars['Boolean']['output']>;
  isFluid?: Maybe<Scalars['Boolean']['output']>;
  isFood?: Maybe<Scalars['Boolean']['output']>;
  isImaging?: Maybe<Scalars['Boolean']['output']>;
  isImmunization?: Maybe<Scalars['Boolean']['output']>;
  isInhouseDiagnostic?: Maybe<Scalars['Boolean']['output']>;
  isInjectable?: Maybe<Scalars['Boolean']['output']>;
  isMedication?: Maybe<Scalars['Boolean']['output']>;
  isRefDiagnostic?: Maybe<Scalars['Boolean']['output']>;
  isService?: Maybe<Scalars['Boolean']['output']>;
  isTaxedCity?: Maybe<Scalars['Boolean']['output']>;
  isTaxedCounty?: Maybe<Scalars['Boolean']['output']>;
  isTaxedOther?: Maybe<Scalars['Boolean']['output']>;
  isTaxedState?: Maybe<Scalars['Boolean']['output']>;
  isTreatment?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  numberOfDeletedProducts?: Maybe<Scalars['Int']['output']>;
  numberOfProducts?: Maybe<Scalars['Int']['output']>;
  onlyInventory?: Maybe<Scalars['Boolean']['output']>;
  revenueCenter?: Maybe<RevenueCenter>;
  revenueCenterId?: Maybe<Scalars['ID']['output']>;
  stateTaxedLocationTags?: Maybe<Array<Maybe<LocationTag>>>;
  stateTaxedLocations?: Maybe<Array<Maybe<Location>>>;
  taxPriority?: Maybe<Scalars['Int']['output']>;
  taxedLocationTags?: Maybe<Array<Maybe<LocationTag>>>;
  taxedLocations?: Maybe<Array<Maybe<Location>>>;
  trackInventory?: Maybe<Scalars['Boolean']['output']>;
  unitMarkupPercent?: Maybe<Scalars['Decimal']['output']>;
  updatedAt?: Maybe<Scalars['NaiveDateTime']['output']>;
};


export type ProductTypeAmountSoldArgs = {
  endDate: Scalars['Date']['input'];
  startDate: Scalars['Date']['input'];
};


export type ProductTypeCommissionsArgs = {
  providerId?: InputMaybe<Scalars['ID']['input']>;
};

export type ProductTypeFlags = {
  isBoarding?: InputMaybe<Scalars['Boolean']['input']>;
  isBoardingAddon?: InputMaybe<Scalars['Boolean']['input']>;
  isExam?: InputMaybe<Scalars['Boolean']['input']>;
  isImmunization?: InputMaybe<Scalars['Boolean']['input']>;
  isInhouseDiagnostic?: InputMaybe<Scalars['Boolean']['input']>;
  isInjectable?: InputMaybe<Scalars['Boolean']['input']>;
  isMedication?: InputMaybe<Scalars['Boolean']['input']>;
  isService?: InputMaybe<Scalars['Boolean']['input']>;
  isTreatment?: InputMaybe<Scalars['Boolean']['input']>;
  trackInventory?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProductTypeInput = {
  cityTaxedLocationTags?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  cityTaxedLocations?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  coerceIntegerQuantity?: InputMaybe<Scalars['Boolean']['input']>;
  countyTaxedLocationTags?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  countyTaxedLocations?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  defaultResource?: InputMaybe<Scalars['String']['input']>;
  dispenseFee?: InputMaybe<Scalars['Decimal']['input']>;
  hasLotNumber?: InputMaybe<Scalars['Boolean']['input']>;
  historicalId?: InputMaybe<Scalars['String']['input']>;
  invoiceBlurb?: InputMaybe<Scalars['String']['input']>;
  isBoarding?: InputMaybe<Scalars['Boolean']['input']>;
  isBoardingAddon?: InputMaybe<Scalars['Boolean']['input']>;
  isExam?: InputMaybe<Scalars['Boolean']['input']>;
  isFluid?: InputMaybe<Scalars['Boolean']['input']>;
  isFood?: InputMaybe<Scalars['Boolean']['input']>;
  isImaging?: InputMaybe<Scalars['Boolean']['input']>;
  isImmunization?: InputMaybe<Scalars['Boolean']['input']>;
  isInhouseDiagnostic?: InputMaybe<Scalars['Boolean']['input']>;
  isInjectable?: InputMaybe<Scalars['Boolean']['input']>;
  isMedication?: InputMaybe<Scalars['Boolean']['input']>;
  isRefDiagnostic?: InputMaybe<Scalars['Boolean']['input']>;
  isService?: InputMaybe<Scalars['Boolean']['input']>;
  isTaxedCity?: InputMaybe<Scalars['Boolean']['input']>;
  isTaxedCounty?: InputMaybe<Scalars['Boolean']['input']>;
  isTaxedOther?: InputMaybe<Scalars['Boolean']['input']>;
  isTaxedState?: InputMaybe<Scalars['Boolean']['input']>;
  isTreatment?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  onlyInventory?: InputMaybe<Scalars['Boolean']['input']>;
  revenueCenterId?: InputMaybe<Scalars['ID']['input']>;
  stateTaxedLocationTags?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  stateTaxedLocations?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  taxPriority?: InputMaybe<Scalars['Int']['input']>;
  taxedLocationTags?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  taxedLocations?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  trackInventory?: InputMaybe<Scalars['Boolean']['input']>;
  unitMarkupPercent?: InputMaybe<Scalars['Decimal']['input']>;
};

/** Pronouns */
export enum Pronouns {
  He = 'HE',
  Other = 'OTHER',
  She = 'SHE',
  They = 'THEY',
  Ze = 'ZE'
}

export type Protocol = {
  __typename?: 'Protocol';
  ageHighDays?: Maybe<Scalars['Int']['output']>;
  ageLowDays?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  durationDays?: Maybe<Scalars['Int']['output']>;
  excludedAppointmentTypeTags?: Maybe<Array<Maybe<AppointmentTypeTag>>>;
  excludedAppointmentTypes?: Maybe<Array<Maybe<AppointmentType>>>;
  excludedLocations?: Maybe<Array<Maybe<Location>>>;
  exclusionaryTimeFrame?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  isActive?: Maybe<Scalars['Boolean']['output']>;
  isPreemptive?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  products?: Maybe<Array<Maybe<Product>>>;
  species?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type ProtocolInput = {
  ageHighDays?: InputMaybe<Scalars['Int']['input']>;
  ageLowDays?: InputMaybe<Scalars['Int']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  durationDays?: InputMaybe<Scalars['Int']['input']>;
  excludedAppointmentTypeIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  excludedAppointmentTypeTagIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  excludedLocationIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  exclusionaryTimeFrame?: InputMaybe<Scalars['Int']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isPreemptive?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  productIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  species?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ProtocolReminder = {
  __typename?: 'ProtocolReminder';
  body?: Maybe<Scalars['String']['output']>;
  cadence?: Maybe<Cadence>;
  client?: Maybe<Client>;
  conversation?: Maybe<Conversation>;
  customPatientProtocols?: Maybe<Array<Maybe<PatientProtocol>>>;
  id?: Maybe<Scalars['ID']['output']>;
  immunizations?: Maybe<Array<Maybe<Immunization>>>;
  insertedAt?: Maybe<Scalars['NaiveDateTime']['output']>;
  isPreemptive?: Maybe<Scalars['Boolean']['output']>;
  location?: Maybe<Location>;
  message?: Maybe<Message>;
  obanJob?: Maybe<ObanJob>;
  orderItems?: Maybe<Array<Maybe<OrderItem>>>;
  patient?: Maybe<Patient>;
  patientProtocols?: Maybe<Array<Maybe<PatientProtocol>>>;
  protocols?: Maybe<Array<Maybe<Protocol>>>;
  sent?: Maybe<Scalars['Boolean']['output']>;
  subject?: Maybe<Scalars['String']['output']>;
  unsendable?: Maybe<Scalars['Boolean']['output']>;
  unsendableReason?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['NaiveDateTime']['output']>;
};

export type ProtocolReminderByProtocol = {
  __typename?: 'ProtocolReminderByProtocol';
  id?: Maybe<Scalars['ID']['output']>;
  protocol?: Maybe<Protocol>;
  protocolReminder?: Maybe<ProtocolReminder>;
};

export type ProtocolReminderInput = {
  sent?: InputMaybe<Scalars['Boolean']['input']>;
  unsendable?: InputMaybe<Scalars['Boolean']['input']>;
  unsendableReason?: InputMaybe<Scalars['String']['input']>;
};

/** All users are listed in Vetspire as a provider */
export type Provider = {
  __typename?: 'Provider';
  bridgeUserId?: Maybe<Scalars['ID']['output']>;
  chatLastReadAt?: Maybe<Scalars['DateTime']['output']>;
  commissions?: Maybe<Array<Maybe<ProviderCommission>>>;
  controlledDrugsPin?: Maybe<Scalars['String']['output']>;
  dailySurgeryLimit?: Maybe<Scalars['Int']['output']>;
  defaultLocationId?: Maybe<Scalars['ID']['output']>;
  departments?: Maybe<Array<Maybe<Department>>>;
  electronicSignature?: Maybe<ElectronicSignature>;
  email?: Maybe<Scalars['String']['output']>;
  familyName?: Maybe<Scalars['String']['output']>;
  givenName?: Maybe<Scalars['String']['output']>;
  historicalId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  insertedAt?: Maybe<Scalars['NaiveDateTime']['output']>;
  isActive?: Maybe<Scalars['Boolean']['output']>;
  isCallCenter?: Maybe<Scalars['Boolean']['output']>;
  isGroomer?: Maybe<Scalars['Boolean']['output']>;
  isOrgAdmin?: Maybe<Scalars['Boolean']['output']>;
  isRelief?: Maybe<Scalars['Boolean']['output']>;
  isSsoEnabled?: Maybe<Scalars['Boolean']['output']>;
  isVeterinarian?: Maybe<Scalars['Boolean']['output']>;
  lastLoginAt?: Maybe<Scalars['NaiveDateTime']['output']>;
  /** @deprecated Please use the field licenses instead. */
  licenseNumber?: Maybe<Scalars['String']['output']>;
  licenses?: Maybe<Array<Maybe<License>>>;
  locations?: Maybe<Array<Maybe<Location>>>;
  missingVetLicense?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  openPunches?: Maybe<Array<Maybe<ProviderPunch>>>;
  org?: Maybe<Org>;
  orgId?: Maybe<Scalars['ID']['output']>;
  outlookEmail?: Maybe<Scalars['String']['output']>;
  outlookVerifiedDate?: Maybe<Scalars['NaiveDateTime']['output']>;
  payrollId?: Maybe<Scalars['String']['output']>;
  position?: Maybe<Scalars['Int']['output']>;
  preferences?: Maybe<ProviderPreferences>;
  profileImageUrl?: Maybe<Scalars['String']['output']>;
  providerRole?: Maybe<ProviderRole>;
  providerRoleId?: Maybe<Scalars['ID']['output']>;
  punches?: Maybe<Array<Maybe<ProviderPunch>>>;
  scheduleTemplate?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  sentOutlookVerificationDate?: Maybe<Scalars['NaiveDateTime']['output']>;
  shortBio?: Maybe<Scalars['String']['output']>;
  suffix?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['NaiveDateTime']['output']>;
  username?: Maybe<Scalars['String']['output']>;
  verified?: Maybe<Scalars['Boolean']['output']>;
  vetsourcePin?: Maybe<Scalars['String']['output']>;
};


/** All users are listed in Vetspire as a provider */
export type ProviderLicenseNumberArgs = {
  field?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};


/** All users are listed in Vetspire as a provider */
export type ProviderPunchesArgs = {
  end: Scalars['DateTime']['input'];
  start: Scalars['DateTime']['input'];
};

export type ProviderAppointmentTypeLimit = {
  __typename?: 'ProviderAppointmentTypeLimit';
  appointmentTypeId?: Maybe<Scalars['ID']['output']>;
  enabled?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  limit?: Maybe<Scalars['Int']['output']>;
};

export type ProviderAppointmentTypeLimitInput = {
  appointmentTypeId?: InputMaybe<Scalars['ID']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  providerId?: InputMaybe<Scalars['ID']['input']>;
};

export type ProviderCommission = {
  __typename?: 'ProviderCommission';
  id?: Maybe<Scalars['ID']['output']>;
  percent?: Maybe<Scalars['Decimal']['output']>;
  productType?: Maybe<ProductType>;
};

export type ProviderCommissionInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  percent?: InputMaybe<Scalars['Decimal']['input']>;
  productTypeId?: InputMaybe<Scalars['ID']['input']>;
  providerId?: InputMaybe<Scalars['ID']['input']>;
};

export type ProviderConnection = {
  __typename?: 'ProviderConnection';
  edges?: Maybe<Array<Maybe<ProviderEdge>>>;
  pageInfo: PageInfo;
};

export type ProviderEdge = {
  __typename?: 'ProviderEdge';
  cursor?: Maybe<Scalars['String']['output']>;
  node?: Maybe<Provider>;
};

/** A feature flag resolved for the current provider, distinguishing an admin (org/location/global) force-on from the provider's own opt-in */
export type ProviderFeatureFlag = {
  __typename?: 'ProviderFeatureFlag';
  /** The effective value for this provider: an admin force-on OR the provider's own opt-in. Defaults to false. */
  enabled: Scalars['Boolean']['output'];
  /** Whether an admin has force-enabled the flag at the org/location/global level, which overrides the provider's own choice. When true the provider is locked on and the toggle is hidden. */
  forcedOn: Scalars['Boolean']['output'];
  id?: Maybe<Scalars['ID']['output']>;
  name: FeatureFlagEnum;
};

export type ProviderInput = {
  chatLastReadAt?: InputMaybe<Scalars['DateTime']['input']>;
  controlledDrugsPin?: InputMaybe<Scalars['String']['input']>;
  dailySurgeryLimit?: InputMaybe<Scalars['Int']['input']>;
  defaultLocationId?: InputMaybe<Scalars['ID']['input']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  email?: InputMaybe<Scalars['String']['input']>;
  familyName?: InputMaybe<Scalars['String']['input']>;
  freshchatRestoreId?: InputMaybe<Scalars['String']['input']>;
  givenName?: InputMaybe<Scalars['String']['input']>;
  historicalId?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isCallCenter?: InputMaybe<Scalars['Boolean']['input']>;
  isGroomer?: InputMaybe<Scalars['Boolean']['input']>;
  isOrgAdmin?: InputMaybe<Scalars['Boolean']['input']>;
  isRelief?: InputMaybe<Scalars['Boolean']['input']>;
  isVeterinarian?: InputMaybe<Scalars['Boolean']['input']>;
  locations?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  missingVetLicense?: InputMaybe<Scalars['Boolean']['input']>;
  outlookEmail?: InputMaybe<Scalars['String']['input']>;
  outlookVerifiedDate?: InputMaybe<Scalars['NaiveDateTime']['input']>;
  payrollId?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
  providerRoleId?: InputMaybe<Scalars['ID']['input']>;
  scheduleTemplate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sentOutlookVerificationDate?: InputMaybe<Scalars['NaiveDateTime']['input']>;
  shortBio?: InputMaybe<Scalars['String']['input']>;
  suffix?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
  verified?: InputMaybe<Scalars['Boolean']['input']>;
  vetsourcePin?: InputMaybe<Scalars['String']['input']>;
};

export type ProviderPreferences = {
  __typename?: 'ProviderPreferences';
  isAddedToLicenseTasks?: Maybe<Scalars['Boolean']['output']>;
  isInHouseLabNotificationsEmailed?: Maybe<Scalars['Boolean']['output']>;
  isInboundMessageEmailed?: Maybe<Scalars['Boolean']['output']>;
  isInboxNotificationEnabled?: Maybe<Scalars['Boolean']['output']>;
  isMarketingNotificationsEmailed?: Maybe<Scalars['Boolean']['output']>;
  isReferenceLabNotificationsEmailed?: Maybe<Scalars['Boolean']['output']>;
  isScribeNotificationsEnabled?: Maybe<Scalars['Boolean']['output']>;
  isTaskEmailed?: Maybe<Scalars['Boolean']['output']>;
};

export type ProviderPreferencesInput = {
  isAddedToLicenseTasks?: InputMaybe<Scalars['Boolean']['input']>;
  isInHouseLabNotificationsEmailed?: InputMaybe<Scalars['Boolean']['input']>;
  isInboundMessageEmailed?: InputMaybe<Scalars['Boolean']['input']>;
  isInboxNotificationEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isMarketingNotificationsEmailed?: InputMaybe<Scalars['Boolean']['input']>;
  isReferenceLabNotificationsEmailed?: InputMaybe<Scalars['Boolean']['input']>;
  isScribeNotificationsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isTaskEmailed?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProviderPunch = {
  __typename?: 'ProviderPunch';
  clockIn?: Maybe<Scalars['DateTime']['output']>;
  clockOut?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type ProviderPunchInput = {
  clockIn?: InputMaybe<Scalars['DateTime']['input']>;
  clockOut?: InputMaybe<Scalars['DateTime']['input']>;
  providerId?: InputMaybe<Scalars['ID']['input']>;
};

export type ProviderRole = {
  __typename?: 'ProviderRole';
  id: Scalars['ID']['output'];
  isDefault?: Maybe<Scalars['Boolean']['output']>;
  /** A list of job codes that a role maps to. */
  jobCodes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  name?: Maybe<Scalars['String']['output']>;
  numberOfUsers: Scalars['Int']['output'];
  permissions?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type ProviderRoleInput = {
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  /** A list of job codes that a role maps to. */
  jobCodes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  permissions?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ProviderTransfer = {
  __typename?: 'ProviderTransfer';
  department?: Maybe<Department>;
  departmentId?: Maybe<Scalars['ID']['output']>;
  endTime?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  insertedAt: Scalars['NaiveDateTime']['output'];
  orgId: Scalars['ID']['output'];
  provider?: Maybe<Provider>;
  providerId: Scalars['ID']['output'];
  startTime: Scalars['DateTime']['output'];
  treatmentSheet?: Maybe<TreatmentSheet>;
  treatmentSheetId: Scalars['ID']['output'];
  updatedAt: Scalars['NaiveDateTime']['output'];
};

export type ProviderViewerInput = {
  chatLastReadAt?: InputMaybe<Scalars['DateTime']['input']>;
  defaultLocationId?: InputMaybe<Scalars['ID']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  familyName?: InputMaybe<Scalars['String']['input']>;
  freshchatRestoreId?: InputMaybe<Scalars['String']['input']>;
  givenName?: InputMaybe<Scalars['String']['input']>;
  outlookEmail?: InputMaybe<Scalars['String']['input']>;
  outlookVerifiedDate?: InputMaybe<Scalars['NaiveDateTime']['input']>;
  sentOutlookVerificationDate?: InputMaybe<Scalars['NaiveDateTime']['input']>;
  shortBio?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

export type ProvidersFilters = {
  email?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  locationId?: InputMaybe<Scalars['ID']['input']>;
  locationIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  onlyActive?: InputMaybe<Scalars['Boolean']['input']>;
  onlyCallCenter?: InputMaybe<Scalars['Boolean']['input']>;
  orderByActivity?: InputMaybe<Scalars['Boolean']['input']>;
  providerRole?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
  vetOnly?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProvidersOrderBy = {
  email?: InputMaybe<OrderByDirection>;
  familyName?: InputMaybe<OrderByDirection>;
  givenName?: InputMaybe<OrderByDirection>;
  insertedAt?: InputMaybe<OrderByDirection>;
};

export type PurchaseOrder = {
  __typename?: 'PurchaseOrder';
  budget?: Maybe<Scalars['Decimal']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  insertedAt?: Maybe<Scalars['NaiveDateTime']['output']>;
  items?: Maybe<Array<Maybe<PurchaseOrderItem>>>;
  location?: Maybe<Location>;
  name?: Maybe<Scalars['String']['output']>;
  orderDate?: Maybe<Scalars['Date']['output']>;
  orderNumber?: Maybe<Scalars['String']['output']>;
  purchaser?: Maybe<Provider>;
  receivedDate?: Maybe<Scalars['Date']['output']>;
  status?: Maybe<PurchaseOrderStatus>;
  vendor?: Maybe<Vendor>;
  vendorId?: Maybe<Scalars['ID']['output']>;
  wasEdited?: Maybe<Scalars['Boolean']['output']>;
};

export type PurchaseOrderInput = {
  items?: InputMaybe<Array<InputMaybe<PurchaseOrderItemInput>>>;
  locationId?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  orderDate?: InputMaybe<Scalars['Date']['input']>;
  orderNumber?: InputMaybe<Scalars['String']['input']>;
  purchaserId?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<PurchaseOrderStatus>;
  vendorId?: InputMaybe<Scalars['ID']['input']>;
};

export type PurchaseOrderItem = {
  __typename?: 'PurchaseOrderItem';
  expirationDate?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  insertedAt?: Maybe<Scalars['DateTime']['output']>;
  lotNumber?: Maybe<Scalars['String']['output']>;
  product?: Maybe<Product>;
  quantity?: Maybe<Scalars['Decimal']['output']>;
  receivedQuantity?: Maybe<Scalars['Decimal']['output']>;
  unitCost?: Maybe<Scalars['Decimal']['output']>;
};

export type PurchaseOrderItemInput = {
  expirationDate?: InputMaybe<Scalars['Date']['input']>;
  lotNumber?: InputMaybe<Scalars['String']['input']>;
  /** For creating new products */
  product?: InputMaybe<ProductInput>;
  productId?: InputMaybe<Scalars['ID']['input']>;
  quantity?: InputMaybe<Scalars['Decimal']['input']>;
  receivedQuantity?: InputMaybe<Scalars['Decimal']['input']>;
  unitCost?: InputMaybe<Scalars['Decimal']['input']>;
};

export enum PurchaseOrderSortField {
  Id = 'ID',
  Location = 'LOCATION',
  Name = 'NAME',
  OrderDate = 'ORDER_DATE',
  OrderNumber = 'ORDER_NUMBER',
  ReceivedDate = 'RECEIVED_DATE',
  Status = 'STATUS'
}

export enum PurchaseOrderStatus {
  Cancelled = 'CANCELLED',
  Draft = 'DRAFT',
  Ordered = 'ORDERED',
  Partial = 'PARTIAL',
  Received = 'RECEIVED'
}

export type Rdvm = {
  __typename?: 'Rdvm';
  addressLine1?: Maybe<Scalars['String']['output']>;
  addressLine2?: Maybe<Scalars['String']['output']>;
  afterHoursTransferRdvmContact?: Maybe<RdvmContact>;
  callForwardedReferral?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  contacts?: Maybe<Array<Maybe<RdvmContact>>>;
  country?: Maybe<Scalars['String']['output']>;
  documents?: Maybe<Array<Maybe<RdvmDocument>>>;
  email?: Maybe<Scalars['String']['output']>;
  faxNumber?: Maybe<Scalars['String']['output']>;
  hasCallForwarding?: Maybe<Scalars['Boolean']['output']>;
  hasWebsiteReferral?: Maybe<Scalars['Boolean']['output']>;
  hoursOfOperation?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  insertedAt?: Maybe<Scalars['NaiveDateTime']['output']>;
  isActive?: Maybe<Scalars['Boolean']['output']>;
  lastVisitDate?: Maybe<Scalars['DateTime']['output']>;
  locations?: Maybe<Array<Maybe<Location>>>;
  marketingNotes?: Maybe<Scalars['String']['output']>;
  milesAway?: Maybe<Scalars['Decimal']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  /** Returns the number of trailing year patients for an rDVM's primary location.  If no primary location then no value is returned. */
  numberOfTrailingYearPatients?: Maybe<Scalars['Int']['output']>;
  numberOfVets?: Maybe<Scalars['Int']['output']>;
  numberOfVisitsLastNinetyDays?: Maybe<Scalars['Int']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
  primaryLocation?: Maybe<Location>;
  /** Returns the number of trailing year patients for an rDVM's primary location.  If no primary location then no value is returned. */
  primaryLocationTrailingYearPatients?: Maybe<Scalars['Int']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Array<Maybe<EntityTag>>>;
  transferContactMethod?: Maybe<Scalars['String']['output']>;
  transferNeededSurgeries?: Maybe<Scalars['Boolean']['output']>;
  transferOxygenDependent?: Maybe<Scalars['Boolean']['output']>;
  transferPostOpSurgeries?: Maybe<Scalars['Boolean']['output']>;
  transferUnstableCases?: Maybe<Scalars['Boolean']['output']>;
  updatedAt?: Maybe<Scalars['NaiveDateTime']['output']>;
  visits?: Maybe<Array<Maybe<RdvmVisit>>>;
  website?: Maybe<Scalars['String']['output']>;
  websiteReferral?: Maybe<Scalars['String']['output']>;
};

export type RdvmContact = {
  __typename?: 'RdvmContact';
  active?: Maybe<Scalars['Boolean']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isDecisionMaker?: Maybe<Scalars['Boolean']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  preferredUpdateMethod?: Maybe<Scalars['String']['output']>;
  rdvmId?: Maybe<Scalars['ID']['output']>;
  type?: Maybe<ContactType>;
};

export type RdvmContactInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  isDecisionMaker?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  preferredUpdateMethod?: InputMaybe<Scalars['String']['input']>;
  rdvmId?: InputMaybe<Scalars['ID']['input']>;
  type?: InputMaybe<ContactType>;
};

export type RdvmDocument = {
  __typename?: 'RdvmDocument';
  contentType?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  insertedAt?: Maybe<Scalars['NaiveDateTime']['output']>;
  media?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  path?: Maybe<Scalars['String']['output']>;
  uploader?: Maybe<Provider>;
};

export type RdvmInput = {
  addressLine1?: InputMaybe<Scalars['String']['input']>;
  addressLine2?: InputMaybe<Scalars['String']['input']>;
  afterHoursTransferRdvmContactId?: InputMaybe<Scalars['ID']['input']>;
  callForwardedReferral?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  faxNumber?: InputMaybe<Scalars['String']['input']>;
  hasCallForwarding?: InputMaybe<Scalars['Boolean']['input']>;
  hasWebsiteReferral?: InputMaybe<Scalars['Boolean']['input']>;
  hoursOfOperation?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  locationIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  marketingNotes?: InputMaybe<Scalars['String']['input']>;
  milesAway?: InputMaybe<Scalars['Decimal']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  numberOfVets?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  primaryLocationId?: InputMaybe<Scalars['ID']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  transferContactMethod?: InputMaybe<Scalars['String']['input']>;
  transferNeededSurgeries?: InputMaybe<Scalars['Boolean']['input']>;
  transferOxygenDependent?: InputMaybe<Scalars['Boolean']['input']>;
  transferPostOpSurgeries?: InputMaybe<Scalars['Boolean']['input']>;
  transferUnstableCases?: InputMaybe<Scalars['Boolean']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
  websiteReferral?: InputMaybe<Scalars['String']['input']>;
};

export type RdvmRecentPatients = {
  __typename?: 'RdvmRecentPatients';
  clientId?: Maybe<Scalars['ID']['output']>;
  clientName?: Maybe<Scalars['String']['output']>;
  lastSeenDate?: Maybe<Scalars['NaiveDateTime']['output']>;
  patientDeceased?: Maybe<Scalars['Boolean']['output']>;
  patientId?: Maybe<Scalars['ID']['output']>;
  patientName?: Maybe<Scalars['String']['output']>;
};

export type RdvmVisit = {
  __typename?: 'RdvmVisit';
  comments?: Maybe<Array<Comment>>;
  createdBy?: Maybe<Provider>;
  id: Scalars['ID']['output'];
  insertedAt?: Maybe<Scalars['NaiveDateTime']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  provider?: Maybe<Provider>;
  rdvmContact?: Maybe<RdvmContact>;
  rdvmId?: Maybe<Scalars['ID']['output']>;
  updatedAt?: Maybe<Scalars['NaiveDateTime']['output']>;
  visitDate?: Maybe<Scalars['DateTime']['output']>;
  visitRating?: Maybe<Scalars['Int']['output']>;
  visitType?: Maybe<Scalars['String']['output']>;
};

export type RdvmVisitInput = {
  notes?: InputMaybe<Scalars['String']['input']>;
  providerId?: InputMaybe<Scalars['ID']['input']>;
  rdvmContactId?: InputMaybe<Scalars['ID']['input']>;
  rdvmId?: InputMaybe<Scalars['ID']['input']>;
  visitDate?: InputMaybe<Scalars['DateTime']['input']>;
  visitRating?: InputMaybe<Scalars['Int']['input']>;
  visitType?: InputMaybe<Scalars['String']['input']>;
};

export type ReconciliationNote = {
  __typename?: 'ReconciliationNote';
  cashBank?: Maybe<Scalars['Decimal']['output']>;
  cashDeposited?: Maybe<Scalars['Decimal']['output']>;
  date?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  insertedAt?: Maybe<Scalars['NaiveDateTime']['output']>;
  location?: Maybe<Location>;
  notes?: Maybe<Scalars['String']['output']>;
  provider?: Maybe<Provider>;
  undone?: Maybe<Scalars['Boolean']['output']>;
  undoneBy?: Maybe<Provider>;
};

export type ReconciliationNoteInput = {
  cashBank?: InputMaybe<Scalars['Decimal']['input']>;
  cashDeposited?: InputMaybe<Scalars['Decimal']['input']>;
  date?: InputMaybe<Scalars['Date']['input']>;
  insertedAt?: InputMaybe<Scalars['NaiveDateTime']['input']>;
  locationId?: InputMaybe<Scalars['ID']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  undone?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Recurrence = {
  __typename?: 'Recurrence';
  id?: Maybe<Scalars['ID']['output']>;
  occurrences?: Maybe<Scalars['Int']['output']>;
  repeatDay?: Maybe<Scalars['Int']['output']>;
  repeatInterval: Scalars['Int']['output'];
  repeatMonth?: Maybe<Month>;
  repeatType: RepeatType;
  repeatUntil?: Maybe<Scalars['Date']['output']>;
  repeatWeekDays?: Maybe<Array<Maybe<DayOfWeek>>>;
  start?: Maybe<Scalars['DateTime']['output']>;
  weekOfMonth?: Maybe<WeekOfMonth>;
};

export enum RecurrenceDeleteScope {
  /** Delete this and all future appointments in the series. */
  AllOccurrences = 'ALL_OCCURRENCES',
  /** Delete this single appointment occurrence only. */
  ThisOccurrence = 'THIS_OCCURRENCE'
}

export enum RecurrenceEditScope {
  /** Update this and all future appointments in the series. */
  AllOccurrences = 'ALL_OCCURRENCES',
  /** Update this single appointment occurrence only. */
  ThisOccurrence = 'THIS_OCCURRENCE'
}

export type RecurrenceInput = {
  /** ID of the recurrence. */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** The number of times the event should occur. Only sent when 'Ends After' is selected. */
  occurrences?: InputMaybe<Scalars['Int']['input']>;
  /** The specific day of the month (1–31) the event should repeat on. Used when selecting 'On day 18' in monthly recurrence. */
  repeatDay?: InputMaybe<Scalars['Int']['input']>;
  /** The interval between each recurrence. For example, every 1 week or every 2 months. */
  repeatInterval: Scalars['Int']['input'];
  /** The month in which the yearly recurrence happens. Example: "June". Used for yearly patterns. */
  repeatMonth?: InputMaybe<Month>;
  /** The recurrence pattern type. Valid values: "daily", "weekly", "monthly", or "yearly". */
  repeatType: RepeatType;
  /** The end date of the recurrence. Only sent when 'Ends On' is selected. */
  repeatUntil?: InputMaybe<Scalars['Date']['input']>;
  /** A list of weekdays the event occurs on. Example: ["Monday", "Wednesday"]. Used for weekly, monthly, or yearly patterns. */
  repeatWeekDays?: InputMaybe<Array<InputMaybe<DayOfWeek>>>;
  /** The start date and time of the recurrence. */
  start?: InputMaybe<Scalars['DateTime']['input']>;
  /** Specifies which week in the month the recurrence should happen. Valid values: "first", "second", "third", "forth", "last". Used for monthly and yearly patterns. */
  weekOfMonth?: InputMaybe<WeekOfMonth>;
};

/** A relationship type used by coowners */
export type Relationship = {
  __typename?: 'Relationship';
  countOfCoowners: Scalars['Int']['output'];
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type RelationshipInput = {
  name?: InputMaybe<Scalars['String']['input']>;
};

export type Reminder = {
  __typename?: 'Reminder';
  appointmentTypeIds?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  body?: Maybe<Scalars['String']['output']>;
  event?: Maybe<ReminderEvent>;
  hoursAfter?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  on?: Maybe<Scalars['Boolean']['output']>;
  sentReminders?: Maybe<Array<Maybe<SentReminder>>>;
  subject?: Maybe<Scalars['String']['output']>;
  type?: Maybe<ReminderType>;
};

export enum ReminderEvent {
  AnnualWellness = 'ANNUAL_WELLNESS',
  Appointment = 'APPOINTMENT',
  AppointmentConfirmation = 'APPOINTMENT_CONFIRMATION',
  Birthday = 'BIRTHDAY',
  ImmunizationDue = 'IMMUNIZATION_DUE',
  NextVisit = 'NEXT_VISIT'
}

export type ReminderInput = {
  appointmentTypeIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  body?: InputMaybe<Scalars['String']['input']>;
  event?: InputMaybe<ReminderEvent>;
  hoursAfter?: InputMaybe<Scalars['Int']['input']>;
  on?: InputMaybe<Scalars['Boolean']['input']>;
  subject?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<ReminderType>;
};

export type ReminderSilence = {
  __typename?: 'ReminderSilence';
  datetime?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  patientId?: Maybe<Scalars['ID']['output']>;
  provider?: Maybe<Provider>;
  until?: Maybe<Scalars['DateTime']['output']>;
};

export type ReminderSilenceInput = {
  datetime?: InputMaybe<Scalars['DateTime']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  patientId?: InputMaybe<Scalars['ID']['input']>;
  until?: InputMaybe<Scalars['DateTime']['input']>;
};

export enum ReminderType {
  Email = 'EMAIL',
  Postcard = 'POSTCARD',
  Sms = 'SMS'
}

export enum RepeatType {
  /** Daily */
  Daily = 'DAILY',
  /** Monthly */
  Monthly = 'MONTHLY',
  /** Weekly */
  Weekly = 'WEEKLY',
  /** Yearly */
  Yearly = 'YEARLY'
}

export type RepeatingEvent = {
  __typename?: 'RepeatingEvent';
  appointment?: Maybe<Appointment>;
  id?: Maybe<Scalars['ID']['output']>;
  repeatInterval?: Maybe<Scalars['Int']['output']>;
};

export type RepeatingEventInput = {
  repeatInterval?: InputMaybe<Scalars['Int']['input']>;
};

export enum ReportBreakdown {
  AppointmentTime = 'APPOINTMENT_TIME',
  AppointmentTypeId = 'APPOINTMENT_TYPE_ID',
  AppointmentTypeRevenueCenterId = 'APPOINTMENT_TYPE_REVENUE_CENTER_ID',
  BookingMethod = 'BOOKING_METHOD',
  BookingPlace = 'BOOKING_PLACE',
  Cadence = 'CADENCE',
  CameIn = 'CAME_IN',
  ChargedTimes = 'CHARGED_TIMES',
  ClientId = 'CLIENT_ID',
  ClientName = 'CLIENT_NAME',
  ClientPhoneNumber = 'CLIENT_PHONE_NUMBER',
  ConsultedByDoctorId = 'CONSULTED_BY_DOCTOR_ID',
  ContactMethod = 'CONTACT_METHOD',
  ContainsLegacyReminders = 'CONTAINS_LEGACY_REMINDERS',
  Conversions = 'CONVERSIONS',
  DepartmentId = 'DEPARTMENT_ID',
  DuplicateCount = 'DUPLICATE_COUNT',
  IntacctEntityId = 'INTACCT_ENTITY_ID',
  IsMember = 'IS_MEMBER',
  IsNewClient = 'IS_NEW_CLIENT',
  IsNewOfTypeClient = 'IS_NEW_OF_TYPE_CLIENT',
  LocationId = 'LOCATION_ID',
  Method = 'METHOD',
  MonthsActive = 'MONTHS_ACTIVE',
  PatientId = 'PATIENT_ID',
  PatientName = 'PATIENT_NAME',
  PaymentReasonName = 'PAYMENT_REASON_NAME',
  PayrollId = 'PAYROLL_ID',
  PrimaryLocationId = 'PRIMARY_LOCATION_ID',
  ProductCategoryId = 'PRODUCT_CATEGORY_ID',
  ProductId = 'PRODUCT_ID',
  ProductTypeId = 'PRODUCT_TYPE_ID',
  ProtocolId = 'PROTOCOL_ID',
  ProviderId = 'PROVIDER_ID',
  ProviderOnRecordId = 'PROVIDER_ON_RECORD_ID',
  RdvmId = 'RDVM_ID',
  RecipientAddress = 'RECIPIENT_ADDRESS',
  RevenueCenterId = 'REVENUE_CENTER_ID',
  Sent = 'SENT',
  Status = 'STATUS',
  TaxBreakdown = 'TAX_BREAKDOWN',
  TippedProviderId = 'TIPPED_PROVIDER_ID',
  UnsendableReason = 'UNSENDABLE_REASON',
  VisitType = 'VISIT_TYPE'
}

export type ReportRow = {
  __typename?: 'ReportRow';
  clientId?: Maybe<Scalars['Int']['output']>;
  date?: Maybe<Scalars['String']['output']>;
  departmentId?: Maybe<Scalars['Int']['output']>;
  locationId?: Maybe<Scalars['Int']['output']>;
  payrollId?: Maybe<Scalars['Int']['output']>;
  productCategoryId?: Maybe<Scalars['Int']['output']>;
  productId?: Maybe<Scalars['Int']['output']>;
  productTypeId?: Maybe<Scalars['Int']['output']>;
  providerId?: Maybe<Scalars['Int']['output']>;
  rdvmId?: Maybe<Scalars['Int']['output']>;
  revenueCenterId?: Maybe<Scalars['Int']['output']>;
  tippedProviderId?: Maybe<Scalars['Int']['output']>;
  total?: Maybe<Scalars['Float']['output']>;
};

export enum ReportSegment {
  Day = 'DAY',
  Month = 'MONTH',
  Quarter = 'QUARTER',
  Week = 'WEEK',
  Year = 'YEAR'
}

export type Reservation = {
  __typename?: 'Reservation';
  addonProducts?: Maybe<Array<Maybe<Product>>>;
  boardingCage?: Maybe<BoardingCage>;
  boardingCageId?: Maybe<Scalars['ID']['output']>;
  category?: Maybe<ReservationCategory>;
  checkedIn?: Maybe<Scalars['Boolean']['output']>;
  checkedInAt?: Maybe<Scalars['DateTime']['output']>;
  checkedOut?: Maybe<Scalars['Boolean']['output']>;
  checkedOutAt?: Maybe<Scalars['DateTime']['output']>;
  comments?: Maybe<Array<Comment>>;
  createdBy?: Maybe<Provider>;
  endDate?: Maybe<Scalars['Date']['output']>;
  endTime?: Maybe<ReservationTime>;
  estimateId?: Maybe<Scalars['ID']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  nightsReserved?: Maybe<Scalars['Int']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  orders?: Maybe<Array<Maybe<Order>>>;
  patients?: Maybe<Array<Patient>>;
  product?: Maybe<Product>;
  startDate?: Maybe<Scalars['Date']['output']>;
  startTime?: Maybe<ReservationTime>;
  status?: Maybe<ReservationStatus>;
};

export enum ReservationCategory {
  Block = 'BLOCK',
  Reservation = 'RESERVATION'
}

export type ReservationFilters = {
  boardingCageId?: InputMaybe<Scalars['ID']['input']>;
  category?: InputMaybe<ReservationCategory>;
  endDate: Scalars['Date']['input'];
  locationId: Scalars['ID']['input'];
  orgId?: InputMaybe<Scalars['ID']['input']>;
  patientId?: InputMaybe<Scalars['ID']['input']>;
  productId?: InputMaybe<Scalars['ID']['input']>;
  startDate: Scalars['Date']['input'];
  status?: InputMaybe<Array<ReservationStatusFilter>>;
};

export type ReservationInput = {
  addonProductIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  boardingCageId?: InputMaybe<Scalars['ID']['input']>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
  endTime?: InputMaybe<ReservationTime>;
  locationId?: InputMaybe<Scalars['ID']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  patientIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  productId?: InputMaybe<Scalars['ID']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
  startTime?: InputMaybe<ReservationTime>;
  status?: InputMaybe<ReservationStatus>;
};

export enum ReservationStatus {
  CheckedIn = 'CHECKED_IN',
  CheckedOut = 'CHECKED_OUT',
  Planned = 'PLANNED'
}

export enum ReservationStatusFilter {
  Arriving = 'ARRIVING',
  Available = 'AVAILABLE',
  CheckedIn = 'CHECKED_IN',
  CheckedOut = 'CHECKED_OUT',
  Departing = 'DEPARTING'
}

export enum ReservationTime {
  Am = 'AM',
  Pm = 'PM'
}

/** A returned order item is a single line item of a returned quantity of an order item */
export type ReturnedOrderItem = {
  __typename?: 'ReturnedOrderItem';
  id?: Maybe<Scalars['ID']['output']>;
  location?: Maybe<Location>;
  order?: Maybe<Order>;
  orderItem?: Maybe<OrderItem>;
  org?: Maybe<Org>;
  quantity?: Maybe<Scalars['Decimal']['output']>;
  returnedAt?: Maybe<Scalars['DateTime']['output']>;
  returnedToStock?: Maybe<Scalars['Boolean']['output']>;
  subtotalCents?: Maybe<Scalars['Int']['output']>;
  totalAfterTaxCents?: Maybe<Scalars['Int']['output']>;
  totalBeforeTaxCents?: Maybe<Scalars['Int']['output']>;
  totalDiscountCents?: Maybe<Scalars['Int']['output']>;
  totalTaxCents?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<ReturnedOrderItemType>;
};

export enum ReturnedOrderItemType {
  Credited = 'CREDITED',
  NotRendered = 'NOT_RENDERED'
}

export type RevenueCenter = {
  __typename?: 'RevenueCenter';
  accountNumber?: Maybe<Scalars['String']['output']>;
  class?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type RevenueCenterBudget = {
  __typename?: 'RevenueCenterBudget';
  appointments?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  location?: Maybe<Location>;
  month?: Maybe<Scalars['Int']['output']>;
  revenue?: Maybe<Scalars['Decimal']['output']>;
  revenuePerAppointment?: Maybe<Scalars['Decimal']['output']>;
  year?: Maybe<Scalars['Int']['output']>;
};

export type RevenueCenterBudgetInput = {
  appointments?: InputMaybe<Scalars['Int']['input']>;
  locationId?: InputMaybe<Scalars['ID']['input']>;
  month?: InputMaybe<Scalars['Int']['input']>;
  revenue?: InputMaybe<Scalars['Decimal']['input']>;
  revenueCenterId?: InputMaybe<Scalars['ID']['input']>;
  revenuePerAppointment?: InputMaybe<Scalars['Decimal']['input']>;
  year?: InputMaybe<Scalars['Int']['input']>;
};

export type RevenueCenterInput = {
  accountNumber?: InputMaybe<Scalars['String']['input']>;
  class?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type RootMutationType = {
  __typename?: 'RootMutationType';
  acquireEncounterSectionLock?: Maybe<EncounterSectionLock>;
  acquireFaxNumber?: Maybe<Location>;
  acquirePharmacyMedicationLock?: Maybe<PharmacyMedicationLock>;
  acquireTollFreeNumber?: Maybe<Location>;
  acquireTwilioPhoneNumber?: Maybe<Location>;
  /** Add an address to a client */
  addClientAddress?: Maybe<Client>;
  addClientStripeInfo?: Maybe<Client>;
  /** Add a coowner to a client */
  addCoowner?: Maybe<Coowner>;
  addCreditMemo?: Maybe<CreditMemo>;
  addCustomTreatmentSheetRow?: Maybe<TreatmentSheetRow>;
  addEstimateItem?: Maybe<Array<Maybe<EstimateItem>>>;
  addItemsToVisit?: Maybe<Visit>;
  addLinkedClinicalNote?: Maybe<LinkedClinicalNote>;
  addLinkedEncounter?: Maybe<LinkedEncounter>;
  addLinkedProduct?: Maybe<Product>;
  addOrderItem?: Maybe<Array<Maybe<OrderItem>>>;
  addOrderItemToEncounter?: Maybe<OrderItem>;
  addPackageToEncounter?: Maybe<Encounter>;
  addPackageToEstimate?: Maybe<Estimate>;
  addPackageToOrder?: Maybe<Order>;
  addPackageToPackage?: Maybe<ProductPackage>;
  addPatientPlanItem?: Maybe<PatientPlanItem>;
  addPatientRdvm?: Maybe<Patient>;
  addPatientToBoard?: Maybe<BoardRow>;
  addPurchaseOrderItem?: Maybe<PurchaseOrderItem>;
  /** Adds a reviewer to a lab result */
  addReviewerToLabResult?: Maybe<LabResult>;
  /** @deprecated Please see the request/request-item/fulfillment-item stock transfer APIs instead. This API will be removed soon. */
  addStockTransferItem?: Maybe<StockTransferItem>;
  addTestsToLabOrder?: Maybe<LabOrder>;
  addTreatment?: Maybe<Treatment>;
  addTreatmentSheetCellComment?: Maybe<TreatmentSheetCell>;
  addTreatmentSheetRow?: Maybe<TreatmentSheetRow>;
  applyAccountCredit?: Maybe<Order>;
  applyCoupon?: Maybe<Order>;
  applyEstimateCoupon?: Maybe<Estimate>;
  /** Applies a price change */
  applyPriceChange?: Maybe<Scalars['String']['output']>;
  applyStockTransferTemplate?: Maybe<StockTransferRequest>;
  /** Approve a medication and send it to the pharmacy whiteboard */
  approveAndSendToPharmacy?: Maybe<Medication>;
  /** Approve a cubex-related diagnostic with a pending approval status. Should only be used when the Cubex Two-Way integration is enabled. */
  approveCubexDiagnostic: Diagnostic;
  /** Approve a cubex-related encounter product with a pending approval status. Should only be used when the Cubex Two-Way integration is enabled. */
  approveCubexEncounterProduct: EncounterProduct;
  /** Approve a cubex-related immunization with a pending approval status. Should only be used when the Cubex Two-Way integration is enabled. */
  approveCubexImmunization: Immunization;
  /** Approve a cubex-related medication with a pending approval status. Should only be used when the Cubex Two-Way integration is enabled. */
  approveCubexMedication: Medication;
  /** Approve a cubex-related treatment with a pending approval status. Should only be used when the Cubex Two-Way integration is enabled. */
  approveCubexTreatment: Treatment;
  /** Approves a medication. */
  approveMedication: Medication;
  /** Links an orphan immunization transaction to a patient and an existing encounter. Should only be used when the Cubex Two-Way integration is enabled */
  assignOrphanImmunizationTransaction: MedicationIntegrationTransaction;
  /** Links an orphan immunization transaction to a patient and a new encounter. Should only be used when the Cubex Two-Way integration is enabled */
  assignOrphanImmunizationTransactionToNewEncounter: MedicationIntegrationTransaction;
  /** Links an orphan transaction to a patient and an existing encounter. Should only be used when the Cubex Two-Way integration is enabled */
  assignOrphanTransaction: MedicationIntegrationTransaction;
  /** Links an orphan transaction to a patient and a new encounter. Should only be used when the Cubex Two-Way integration is enabled */
  assignOrphanTransactionToNewEncounter: MedicationIntegrationTransaction;
  /** Assign a problem in the patient's problem list to the encounter */
  assignProblemToEncounter?: Maybe<Problem>;
  /** Assigns a provider to a location */
  assignProviderToLocation?: Maybe<Provider>;
  /** Assigns a provider to a task */
  assignProviderToTask?: Maybe<Task>;
  autoApplyCoupons?: Maybe<Order>;
  autoApplyEstimateCoupons?: Maybe<Estimate>;
  autoApplyProductCoupons?: Maybe<Order>;
  /**
   * Atomically replaces multiple encounter section datums in a single transaction.
   *
   * All replacements are validated and executed atomically - if any datum doesn't exist, the entire operation rolls back.
   */
  batchReplaceEncounterSectionDatums?: Maybe<Encounter>;
  /** Batch create or update multiple org preferences in a single operation */
  batchUpsertOrgPreferences?: Maybe<Array<Maybe<OrgPreference>>>;
  billingHistory?: Maybe<Scalars['String']['output']>;
  billingStatement?: Maybe<Scalars['String']['output']>;
  bulkMarkRemindersAsSent?: Maybe<Scalars['Boolean']['output']>;
  bulkUpdateEncounterTypeSectionOverrides?: Maybe<EncounterType>;
  cancelDatasync?: Maybe<DatasyncLog>;
  cancelLabOrder?: Maybe<LabOrder>;
  cancelPlan?: Maybe<PatientPlan>;
  captureClientConsent?: Maybe<Scalars['String']['output']>;
  chargeClient?: Maybe<Payment>;
  chargeEstimate?: Maybe<Estimate>;
  chargeOrder?: Maybe<Order>;
  checkInReservation: Reservation;
  checkOutReservation: Reservation;
  clientConsentLink?: Maybe<Scalars['String']['output']>;
  clockIn?: Maybe<ProviderPunch>;
  clockOut?: Maybe<ProviderPunch>;
  comment?: Maybe<Comment>;
  completeBoardCell?: Maybe<BoardRow>;
  convertCallLogToAppointment?: Maybe<Appointment>;
  convertEstimateToOrder?: Maybe<Estimate>;
  copyFromPreviousEncounter?: Maybe<Encounter>;
  copyMedicationsToEncounter?: Maybe<Encounter>;
  copyPackage?: Maybe<ProductPackage>;
  createAlert?: Maybe<Alert>;
  createAllergy?: Maybe<Allergy>;
  createApiKey?: Maybe<ApiKey>;
  /** Create an appointment */
  createAppointment?: Maybe<Appointment>;
  createAppointmentReasonCategory?: Maybe<AppointmentReasonCategory>;
  createAppointmentReminder: AppointmentReminder;
  createAppointmentType: AppointmentType;
  createAppointmentTypeTag: AppointmentTypeTag;
  createApptVitals?: Maybe<Appointment>;
  createAutoMessage: AutoMessage;
  createBillingGroup?: Maybe<BillingGroup>;
  createBillingNote: BillingNote;
  createBoardCell: BoardCell;
  createBoardingBlock: Reservation;
  createBoardingCage: BoardingCage;
  createBoardingWard: BoardingWard;
  createBridgeUser?: Maybe<Provider>;
  createCadence?: Maybe<Cadence>;
  createCage: Cage;
  createCallLog: CallLog;
  createCareTeamRole?: Maybe<CareTeamRole>;
  createClient: Client;
  createClientRdvm: ClientRdvm;
  createClientReferralSource: ClientReferralSource;
  createClientTag?: Maybe<ClientTag>;
  createClinicalNote: ClinicalNote;
  createComplication: Complication;
  createConsentForm: ConsentForm;
  createConversation?: Maybe<Conversation>;
  createCoupon: Coupon;
  createCreditReason?: Maybe<CreditReason>;
  /** Creates a custom appointment field */
  createCustomAppointmentField?: Maybe<CustomAppointmentField>;
  /** Creates a custom appointment field value */
  createCustomAppointmentFieldValue?: Maybe<CustomAppointmentFieldValue>;
  /** Creates a custom client field */
  createCustomClientField?: Maybe<CustomClientField>;
  /** Creates a custom client field value */
  createCustomClientFieldValue?: Maybe<CustomClientFieldValue>;
  createCustomLocationAttribute?: Maybe<CustomLocationAttribute>;
  /** Creates a custom patient field */
  createCustomPatientField?: Maybe<CustomPatientField>;
  /** Creates a custom patient field value */
  createCustomPatientFieldValue?: Maybe<CustomPatientFieldValue>;
  createCustomPatientProtocol?: Maybe<CustomPatientProtocol>;
  createDeclineReason?: Maybe<DeclineReason>;
  createDepartment: Department;
  createDiagnostic: Diagnostic;
  createDiscountReason?: Maybe<DiscountReason>;
  createEncounterOrder?: Maybe<Encounter>;
  createEncounterProduct: EncounterProduct;
  /** Inserts a new section for the given `encounter_id`'s sections at the `section_idx`th position */
  createEncounterSection?: Maybe<Encounter>;
  /** Inserts the given datum for the given encounter's `section_idx` at the `datum_idx`th position */
  createEncounterSectionDatum?: Maybe<Encounter>;
  createEncounterType?: Maybe<EncounterType>;
  createEntitiesTag: EntitiesTag;
  createEntityTag: EntityTag;
  createEntityTagGroup: EntityTagGroup;
  createEntityValidation: EntityValidation;
  createEstimate?: Maybe<Estimate>;
  createEstimateItem: EstimateItem;
  /** Adds a field service visit address to a patient */
  createFieldServiceAddress?: Maybe<FieldServiceAddress>;
  createFulfillmentSource: FulfillmentSource;
  createHarvestLabOrder?: Maybe<LabOrder>;
  createHarvestLabResult?: Maybe<LabResult>;
  createHospitalization: Hospitalization;
  createHospitalizationTask?: Maybe<HospitalizationTask>;
  createIguanaLabOrder?: Maybe<LabOrder>;
  createIguanaLabResult?: Maybe<LabResult>;
  /** Create an immunization */
  createImmunization?: Maybe<Immunization>;
  createInventoryAdjustment?: Maybe<InventoryAdjustment>;
  createInvoiceLineItemReason?: Maybe<InvoiceLineItemReason>;
  createLabModifier?: Maybe<LabModifier>;
  createLicense?: Maybe<License>;
  createLocation?: Maybe<Location>;
  createLocationAttribute: LocationAttribute;
  createLocationProviderSchedule: LocationProviderSchedule;
  /** Add a location schedule */
  createLocationSchedule?: Maybe<LocationSchedule>;
  createLocationTag: LocationTag;
  createMacro: Macro;
  /** Create manual AR adjustment for prior periods */
  createManualArAdjustment: ManualArAdjustmentResult;
  createNewsletter?: Maybe<Newsletter>;
  createOrder?: Maybe<Order>;
  createOrderFlag: OrderFlag;
  createOrgDepartment: OrgDepartment;
  /** @deprecated Please use `createOrgLabWithCheck` instead. */
  createOrgLab: OrgLab;
  /** Creates a lab integration for a location. If the integration supports it, checks the given credentials and reports whether they authenticated successfully. */
  createOrgLabWithCheck?: Maybe<OrgLabUpdateResult>;
  createOrgPreference: OrgPreference;
  createOutlookOrgPreference?: Maybe<OrgPreference>;
  createParentProblem?: Maybe<Problem>;
  createPatient: Patient;
  createPatientComplication: PatientComplication;
  /** Create a new patient diagnosis entry */
  createPatientDiagnosis?: Maybe<PatientDiagnosis>;
  createPatientTag: PatientTag;
  createPaymentReason?: Maybe<PaymentReason>;
  createPreventionPlan: PreventionPlan;
  /** Creates a price change */
  createPriceChange?: Maybe<PriceChange>;
  /** Create a new problem */
  createProblem?: Maybe<Problem>;
  createProduct?: Maybe<Product>;
  createProductCategory: ProductCategory;
  createProductManufacturer?: Maybe<ProductManufacturer>;
  createProductPackage?: Maybe<ProductPackage>;
  createProductPackageItem: ProductPackageItem;
  createProductPrice?: Maybe<ProductPrice>;
  createProductType: ProductType;
  createProtocol: Protocol;
  createProvider?: Maybe<Provider>;
  createProviderPin?: Maybe<Provider>;
  createProviderPunch: ProviderPunch;
  createProviderRole: ProviderRole;
  createProviderTransfer?: Maybe<ProviderTransfer>;
  createPurchaseOrder?: Maybe<PurchaseOrder>;
  createRdvm?: Maybe<Rdvm>;
  /** Add a contact to rDVM */
  createRdvmContact?: Maybe<RdvmContact>;
  /** Add a vist to rDVM */
  createRdvmVisit?: Maybe<RdvmVisit>;
  createReconciliationNote: ReconciliationNote;
  createRelationship: Relationship;
  createReminder: Reminder;
  createReminderSilence: ReminderSilence;
  createReservation: Reservation;
  createReservationEstimate: Reservation;
  createRevenueCenter: RevenueCenter;
  createRevenueCenterBudget: RevenueCenterBudget;
  createScheduleRecurrence?: Maybe<ScheduleRecurrence>;
  createScheduleTemplate: ScheduleTemplate;
  createStockLocation?: Maybe<StockLocation>;
  /** @deprecated Please see the request/request-item/fulfillment-item stock transfer APIs instead. This API will be removed soon. */
  createStockTransfer?: Maybe<StockTransfer>;
  createStockTransferFulfillmentItem?: Maybe<StockTransferFulfillmentItem>;
  createStockTransferReportRecipient?: Maybe<StockTransferReportRecipient>;
  createStockTransferRequest?: Maybe<StockTransferRequest>;
  createStockTransferRequestItem?: Maybe<StockTransferRequestItem>;
  createStockTransferRequestItems?: Maybe<Array<Maybe<StockTransferRequestItem>>>;
  createStockTransferTemplate?: Maybe<StockTransferTemplate>;
  createStockTransferTemplateItem?: Maybe<StockTransferTemplateItem>;
  createStripePaymentIntent?: Maybe<Scalars['String']['output']>;
  createTask?: Maybe<Task>;
  createTaskCategory?: Maybe<TaskCategory>;
  createTaskGroup: TaskGroup;
  createTeletailsSession?: Maybe<TeletailsSession>;
  createTravelZone: TravelZone;
  createTreatmentSheet?: Maybe<TreatmentSheet>;
  createTreatmentSheetCell?: Maybe<TreatmentSheetCell>;
  createTreatmentSheetTemplate?: Maybe<TreatmentSheetTemplate>;
  createTrigger?: Maybe<Trigger>;
  createUserTask?: Maybe<Task>;
  createVitals?: Maybe<Vitals>;
  createVoiceCallLog?: Maybe<VoiceCall>;
  creditMemoPdf?: Maybe<Scalars['String']['output']>;
  /** Decline a cubex-related diagnostic with a pending approval status. Should only be used when the Cubex Two-Way integration is enabled. */
  declineCubexDiagnostic: Diagnostic;
  /** Decline a cubex-related encounter product with a pending approval status. Should only be used when the Cubex Two-Way integration is enabled. */
  declineCubexEncounterProduct: EncounterProduct;
  /** Decline a cubex-related immunization with a pending approval status. Should only be used when the Cubex Two-Way integration is enabled. */
  declineCubexImmunization: Immunization;
  /** Decline a cubex-related medication with a pending approval status. Should only be used when the Cubex Two-Way integration is enabled. */
  declineCubexMedication: Medication;
  /** Decline a cubex-related treatment with a pending approval status. Should only be used when the Cubex Two-Way integration is enabled. */
  declineCubexTreatment: Treatment;
  declinePackage?: Maybe<EstimateItem>;
  /** Deletes an address under the client's info */
  deleteAddress?: Maybe<Address>;
  deleteAlert: Alert;
  deleteAllergy: Allergy;
  /** Deletes an API key and associated API user */
  deleteApiKey?: Maybe<ApiKey>;
  deleteAppliedCoupon?: Maybe<Order>;
  deleteAppliedEstimateCoupon?: Maybe<Estimate>;
  deleteAppointment?: Maybe<Appointment>;
  deleteAppointmentReasonCategory?: Maybe<AppointmentReasonCategory>;
  deleteAppointmentReminder: AppointmentReminder;
  deleteAppointmentType: AppointmentType;
  deleteAppointmentTypeTag: AppointmentTypeTag;
  deleteAutoMessage: AutoMessage;
  deleteBillingGroup?: Maybe<BillingGroup>;
  deleteBoardCell: BoardCell;
  deleteBoardingBlock: Reservation;
  deleteBoardingCage: BoardingCage;
  deleteBoardingWard: BoardingWard;
  deleteCadence?: Maybe<Cadence>;
  deleteCage?: Maybe<Cage>;
  deleteCallLog: CallLog;
  deleteClientConsent?: Maybe<ClientConsent>;
  deleteClientRdvm: ClientRdvm;
  deleteClientReferralSource: ClientReferralSource;
  deleteClientTag?: Maybe<ClientTag>;
  deleteComplication: Complication;
  deleteConsentForm: ConsentForm;
  /** Deletes an associate */
  deleteCoowner?: Maybe<Coowner>;
  deleteCoupon: Coupon;
  /** Deletes a custom appointment field */
  deleteCustomAppointmentField?: Maybe<CustomAppointmentField>;
  /** Deletes a custom appointment field value */
  deleteCustomAppointmentFieldValue?: Maybe<CustomAppointmentFieldValue>;
  /** Deletes a custom client field */
  deleteCustomClientField?: Maybe<CustomClientField>;
  /** Deletes a custom client field value */
  deleteCustomClientFieldValue?: Maybe<CustomClientFieldValue>;
  deleteCustomLocationAttribute?: Maybe<CustomLocationAttribute>;
  deleteCustomLocationProviderSchedule?: Maybe<LocationProviderSchedule>;
  /** Deletes a custom patient field */
  deleteCustomPatientField?: Maybe<CustomPatientField>;
  /** Deletes a custom patient field value */
  deleteCustomPatientFieldValue?: Maybe<CustomPatientFieldValue>;
  deleteDepartment: Department;
  deleteDiagnostic: Diagnostic;
  deleteEncounter?: Maybe<Encounter>;
  deleteEncounterProduct: EncounterProduct;
  /** Deletes the corresponding section for the given `encounter_id`'s sections at the `section_idx`th position */
  deleteEncounterSection?: Maybe<Encounter>;
  /** Deletes the `datum_idx`th datum for the given encounter's `section_idx` */
  deleteEncounterSectionDatum?: Maybe<Encounter>;
  deleteEncounterType: EncounterType;
  deleteEncounterTypeSectionOverrides?: Maybe<EncounterType>;
  deleteEntitiesTag?: Maybe<EntitiesTag>;
  deleteEntityTag: EntityTag;
  deleteEntityTagGroup: EntityTagGroup;
  deleteEntityValidation: EntityValidation;
  deleteEstimate?: Maybe<Estimate>;
  deleteEstimateItem?: Maybe<EstimateItem>;
  /**
   * Deletes one of a patient's field service visit addresses, returning the deleted address.
   *
   * Appointments already booked against the address keep their booking and lose their visit
   * location, so deleting an address referenced by future appointments is safe.
   */
  deleteFieldServiceAddress?: Maybe<FieldServiceAddress>;
  deleteFulfillmentSource: FulfillmentSource;
  deleteImmunization: Immunization;
  deleteImportedData?: Maybe<DeletionLog>;
  /** Delete an existing image from the specified lab result. */
  deleteLabImage?: Maybe<LabResult>;
  deleteLabModifier?: Maybe<LabModifier>;
  deleteLabOrder?: Maybe<LabOrder>;
  deleteLabResult: LabResult;
  deleteLicense?: Maybe<License>;
  deleteLinkedClinicalNote?: Maybe<ClinicalNote>;
  deleteLinkedEncounter?: Maybe<Encounter>;
  deleteLinkedProduct?: Maybe<Product>;
  deleteLocation?: Maybe<Location>;
  deleteLocationProviderSchedule: LocationProviderSchedule;
  /** Deletes a location's schedule */
  deleteLocationSchedule?: Maybe<LocationSchedule>;
  deleteLocationTag: LocationTag;
  deleteMacro: Macro;
  deleteMedication?: Maybe<Medication>;
  deleteMessage?: Maybe<Message>;
  deleteNotification: Notification;
  deleteOrder?: Maybe<Order>;
  deleteOrderFlag: OrderFlag;
  deleteOrderItem?: Maybe<OrderItem>;
  deleteOrgDepartment: OrgDepartment;
  deleteOrgLab?: Maybe<OrgLab>;
  /** Deletes an orphan transaction. Should only be used when the Cubex Two-Way integration is enabled */
  deleteOrphanTransaction: MedicationIntegrationTransaction;
  deletePackagePackage?: Maybe<ProductPackage>;
  deletePatientComplication: PatientComplication;
  /** Delete a patient diagnosis entry */
  deletePatientDiagnosis?: Maybe<PatientDiagnosis>;
  deletePatientDocument?: Maybe<PatientDocument>;
  deletePatientTag: PatientTag;
  /** Deletes a price change */
  deletePriceChange?: Maybe<PriceChange>;
  deleteProblem: Problem;
  deleteProduct?: Maybe<Product>;
  deleteProductCategory: ProductCategory;
  deleteProductManufacturer?: Maybe<ProductManufacturer>;
  deleteProductPackage?: Maybe<ProductPackage>;
  deleteProductPackageItem: ProductPackageItem;
  deleteProductPrice: ProductPrice;
  deleteProductType: ProductType;
  deleteProtocol: Protocol;
  deleteProviderPunch: ProviderPunch;
  deleteProviderRole: ProviderRole;
  deletePurchaseOrder?: Maybe<PurchaseOrder>;
  deletePurchaseOrderItem?: Maybe<PurchaseOrderItem>;
  deleteRdvm?: Maybe<Rdvm>;
  deleteRdvmDocument?: Maybe<RdvmDocument>;
  deleteRdvmVisit: RdvmVisit;
  deleteRelationship: Relationship;
  deleteReminder: Reminder;
  deleteReservation: Reservation;
  deleteRevenueCenter: RevenueCenter;
  deleteScheduleTemplate: ScheduleTemplate;
  /** @deprecated Please see `deleteStockTransferRequest` instead. This API will be removed soon. */
  deleteStockTransfer?: Maybe<StockTransfer>;
  deleteStockTransferFulfillmentItem?: Maybe<StockTransferFulfillmentItem>;
  /** @deprecated Please see `deleteStockTransferRequestItem` / `deleteStockTransferFulfillmentItem` instead. This API will be removed soon. */
  deleteStockTransferItem?: Maybe<StockTransferItem>;
  deleteStockTransferReportRecipient?: Maybe<StockTransferReportRecipient>;
  deleteStockTransferRequest?: Maybe<StockTransferRequest>;
  deleteStockTransferRequestItem?: Maybe<StockTransferRequestItem>;
  deleteStockTransferTemplate?: Maybe<StockTransferTemplate>;
  deleteStockTransferTemplateItem?: Maybe<StockTransferTemplateItem>;
  deleteTaskCategory?: Maybe<TaskCategory>;
  deleteTaskGroup: TaskGroup;
  deleteTravelZone: TravelZone;
  deleteTreatment: Treatment;
  deleteTreatmentSheet?: Maybe<TreatmentSheet>;
  deleteTreatmentSheetRow?: Maybe<TreatmentSheetRow>;
  deleteTreatmentSheetRowAdditiveEntry?: Maybe<TreatmentSheetRowAdditiveEntry>;
  deleteTreatmentSheetTemplate?: Maybe<TreatmentSheetTemplate>;
  deleteTrigger?: Maybe<Trigger>;
  deleteVitals: Vitals;
  disableCreditReason?: Maybe<CreditReason>;
  disableDeclineReason?: Maybe<DeclineReason>;
  disableDiscountReason?: Maybe<DiscountReason>;
  disableInvoiceLineItemReason?: Maybe<InvoiceLineItemReason>;
  disablePaymentReason?: Maybe<PaymentReason>;
  /** Dismiss voice calls for a location */
  dismissVoiceCalls?: Maybe<Scalars['String']['output']>;
  /**
   * Downloads billing statements for all clients in the specified billing group as a combined PDF.
   * Returns a base64-encoded PDF file.
   */
  downloadBillingGroupStatements?: Maybe<Scalars['String']['output']>;
  downloadProtocolsMigrationCsv?: Maybe<Scalars['String']['output']>;
  downloadUsageReport?: Maybe<Scalars['String']['output']>;
  editPatientRdvm?: Maybe<Patient>;
  /**
   * Emails billing statements to all clients in the specified billing groups.
   * Each client with a billing email on file will receive their own billing statement.
   * When `emailAll` is true, emails all billing groups in the org.
   */
  emailBillingGroupStatements?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Either zips & emails all billing statements at the given location to the list of provided
   * emails, or if no emails are provided, emails each client their billing statement
   * if they have one.
   */
  emailBillingStatements?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Superseded by `emailBillingStatements`. */
  emailClientBillingStatement?: Maybe<Scalars['String']['output']>;
  emailClientPaymentReceipt?: Maybe<Scalars['String']['output']>;
  emailClientsAddresses?: Maybe<Scalars['String']['output']>;
  emailCreditMemoToClient?: Maybe<Array<Maybe<EmailStatus>>>;
  emailEncounter?: Maybe<Array<Maybe<EmailStatus>>>;
  /** @deprecated You can use email_encounter_record */
  emailEncounterPdf?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  emailEncounterRecord?: Maybe<Array<Maybe<EmailStatus>>>;
  emailEncounterRecordToCustom?: Maybe<Array<Maybe<EmailStatus>>>;
  emailEncounterRecordToRdvms?: Maybe<Array<Maybe<EmailStatus>>>;
  emailEstimateToClient?: Maybe<Array<Maybe<EmailStatus>>>;
  emailFilteredProducts?: Maybe<Scalars['String']['output']>;
  emailHospitalizationNoticeToRdvms?: Maybe<Array<Maybe<EmailStatus>>>;
  emailImmunizationsRecord?: Maybe<Scalars['String']['output']>;
  emailInventoryCsv?: Maybe<Scalars['String']['output']>;
  emailInvoiceToClient?: Maybe<Array<Maybe<EmailStatus>>>;
  emailLabResult?: Maybe<Array<Maybe<EmailStatus>>>;
  emailMedicalRecordsSummary?: Maybe<Scalars['String']['output']>;
  emailPatientCompliancesReport?: Maybe<Scalars['String']['output']>;
  emailProductsCsv?: Maybe<Scalars['String']['output']>;
  emailRabiesCertificate?: Maybe<Scalars['String']['output']>;
  emailRdvmsCsv?: Maybe<Scalars['String']['output']>;
  emailRemindersCsv?: Maybe<Scalars['String']['output']>;
  emailSelectedRabiesCertificates?: Maybe<Scalars['String']['output']>;
  emailTreatmentSheetSummary?: Maybe<Scalars['String']['output']>;
  emailUsageReport?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated You can use encounter_summary */
  encounterPdf?: Maybe<Scalars['String']['output']>;
  endOfDayReport?: Maybe<Scalars['String']['output']>;
  endVideoCall?: Maybe<Scalars['String']['output']>;
  endVisit?: Maybe<Visit>;
  enrollPlan?: Maybe<PatientPlan>;
  fetchVetrocketImages?: Maybe<LabResult>;
  fileDownloadLink: Scalars['String']['output'];
  finishLabOrder?: Maybe<LabOrder>;
  genVetsourceUrl?: Maybe<Scalars['String']['output']>;
  /** Generate aged accounts receivable report */
  generateAgedArReport: AgedArReportGeneration;
  generateClientAuthToken?: Maybe<Scalars['String']['output']>;
  generateInventoryReport?: Maybe<Scalars['String']['output']>;
  generateInvoice?: Maybe<Order>;
  /**
   * Start generating trends for the analytes named.
   *
   * One job covers the set, and the engine writes a single narrative over it, so
   * ask for analytes that belong together -- the summary drawer asks for the
   * results it flagged abnormal.
   *
   * The set is also the run's identity: the same analytes asked for again inside
   * fifteen minutes are the run already in flight, and a different set replaces
   * it.
   *
   * Answers with the analytes it started, and with nothing when the run was
   * already there. Where it gets to is `labTrends` to say, since the engine's
   * webhook is what finishes a job.
   */
  generateLabTrends?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  generatePlumbsPdfUrl?: Maybe<Scalars['String']['output']>;
  generatePlumbsUrl?: Maybe<Scalars['String']['output']>;
  generateUsageSummaryReport?: Maybe<Scalars['String']['output']>;
  /** Generates an authenticated VetCalculator iframe URL for the current user */
  generateVetcalculatorIframeUrl?: Maybe<Scalars['String']['output']>;
  groupOrderItemsByPatient?: Maybe<Order>;
  /** Import an entity from a patient document. Exactly one of medication, immunization, or patient_protocol must be provided. */
  importFromDocument?: Maybe<ImportedEntity>;
  initiateCareCreditPrefill?: Maybe<CareCreditPrefillSession>;
  initiateCareCreditPrefillRefund?: Maybe<CareCreditPrefillSession>;
  insertNewTemplate?: Maybe<Encounter>;
  invoiceBarcodesPdf?: Maybe<Scalars['String']['output']>;
  invoiceBoardRow?: Maybe<Order>;
  issueCreditDiscount?: Maybe<Scalars['String']['output']>;
  linkAppointments?: Maybe<Array<Maybe<Appointment>>>;
  linkCall?: Maybe<VoiceCall>;
  /** Links a lab result to a patient */
  linkOrphanLabResultToPatient: LabResult;
  linkPatientPlanChargeToOrderItem?: Maybe<PatientPlanCharge>;
  makeAppointmentTypeDefault?: Maybe<AppointmentType>;
  markAllNormalEncounter?: Maybe<Encounter>;
  /** Mark a cubex-related diagnostic as pending approval. Should only be used when the Cubex Two-Way integration is enabled. */
  markCubexDiagnosticAsPendingApproval: Diagnostic;
  /** Mark a cubex-related encounter product as pending approval. Should only be used when the Cubex Two-Way integration is enabled. */
  markCubexEncounterProductAsPendingApproval: EncounterProduct;
  /** Mark a cubex-related immunization as pending approval. Should only be used when the Cubex Two-Way integration is enabled. */
  markCubexImmunizationAsPendingApproval: Immunization;
  /** Mark a cubex-related medication as pending approval. Should only be used when the Cubex Two-Way integration is enabled. */
  markCubexMedicationAsPendingApproval: Medication;
  /** Mark a cubex-related treatment as pending approval. Should only be used when the Cubex Two-Way integration is enabled. */
  markCubexTreatmentAsPendingApproval: Treatment;
  markOrderPaidIfFullyPaid?: Maybe<Order>;
  markOrderUncollectible?: Maybe<Order>;
  markPaymentAsRefunded?: Maybe<Payment>;
  markPostcardProtocolReminderAsSent?: Maybe<ProtocolReminder>;
  markVisitReadyForDischarge?: Maybe<Visit>;
  massMicrochipRegister?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  mergeClientReferralSources?: Maybe<Array<Maybe<ClientReferralSource>>>;
  mergeClients?: Maybe<Client>;
  mergeNovaTemplateRows: TreatmentSheet;
  mergePatients?: Maybe<Patient>;
  mergeRdvms: Rdvm;
  movePatientToClient?: Maybe<Patient>;
  /** Create a new encounter for a patient at a location */
  newEncounter?: Maybe<Encounter>;
  newVendor?: Maybe<Vendor>;
  onboardPetdxLab?: Maybe<OrgLab>;
  orderLab?: Maybe<LabOrder>;
  paymentReceiptPdf?: Maybe<Scalars['String']['output']>;
  performDatasync?: Maybe<DatasyncLog>;
  /** Prescribe a medication */
  prescribeMedication?: Maybe<Medication>;
  /** Previews a price change */
  previewPriceChange?: Maybe<Scalars['String']['output']>;
  printLabelPrintnode?: Maybe<PrintLabelResult>;
  promoteEstimateToBoard?: Maybe<BoardRow>;
  /** Pushes a diagnostic to Cubex. Can be used when the Cubex Sync feature is enabled */
  pushDiagnosticToCubex?: Maybe<Scalars['String']['output']>;
  /** Pushes an encounter product to Cubex. Can be used when the Cubex Sync feature is enabled */
  pushEncounterProductToCubex?: Maybe<Scalars['String']['output']>;
  pushImmunizationToCubex?: Maybe<Scalars['String']['output']>;
  pushMedicationToCubex?: Maybe<Scalars['String']['output']>;
  pushToCubex?: Maybe<Scalars['String']['output']>;
  pushTreatmentToCubex?: Maybe<Scalars['String']['output']>;
  readAllNotifications?: Maybe<Scalars['Int']['output']>;
  readNotification?: Maybe<Notification>;
  reassignProductType?: Maybe<ProductType>;
  recordPatientWeight?: Maybe<Vitals>;
  recordStripeSdkRefund?: Maybe<Payment>;
  refillAndSendToPharmacy?: Maybe<Medication>;
  refillMedication?: Maybe<Medication>;
  refreshLabResult?: Maybe<LabResult>;
  refreshPreventionPlan?: Maybe<Array<Maybe<PatientPlan>>>;
  /**
   * @deprecated Please *do not* use this mutation any longer.
   *
   * Refunding order items now no longer respects the `returned`, `credit`, or `not rendered` args,
   * nor will it always mark the given order as `returned`/`credited`/`not_rendered`, as these
   * states are no longer going to be used.
   *
   * Please update your code to use `returnOrderItem` instead.
   *
   */
  refundOrderItem?: Maybe<OrderItem>;
  refundPayment?: Maybe<Payment>;
  registerPatientMicrochip?: Maybe<Patient>;
  removeClientStripeInfo?: Maybe<Scalars['String']['output']>;
  removeItemsFromVisit?: Maybe<Visit>;
  removePatientPlanItem?: Maybe<PatientPlanItem>;
  removePatientRdvm?: Maybe<Patient>;
  /** Removes a provider from a lab result */
  removeReviewerFromLabResult?: Maybe<LabResult>;
  reopenEncounter?: Maybe<Encounter>;
  reopenOrder?: Maybe<Order>;
  reopenVisit?: Maybe<Visit>;
  reorderAlerts?: Maybe<Array<Maybe<Alert>>>;
  reorderBoardingCages: BoardingCage;
  reorderBoardingWards: BoardingWard;
  reorderClientReferralSources?: Maybe<Array<Maybe<ClientReferralSource>>>;
  reorderEntityTags?: Maybe<Array<Maybe<EntityTag>>>;
  reorderEstimateItems?: Maybe<Estimate>;
  reorderOrderItems?: Maybe<Order>;
  /**
   * Replaces a given datum by (section_idx x datum_idx) with provided JSON.
   *
   * Note that no validity checking of the datum input is performed.
   * If you wish to simply update a given datum, you can more safetly use `replace_encounter_section_datum` instead.
   */
  replaceEncounterSectionDatum?: Maybe<Encounter>;
  /** Update a draft medication to request approval from a veterinarian */
  requestMedicationApproval?: Maybe<Medication>;
  requestSourceDataDownloadUrl?: Maybe<DatasyncLog>;
  resendVerification?: Maybe<Scalars['String']['output']>;
  resetProviderPin?: Maybe<Provider>;
  retryJob?: Maybe<ObanJob>;
  retryLabOrderPlacement?: Maybe<LabOrder>;
  returnOrderItem?: Maybe<Array<Maybe<ReturnedOrderItem>>>;
  reviewArReconciliation: ArReconciliation;
  runAdHocAutoMessage: AutoMessage;
  runArReconciliation: ArReconciliation;
  saveCensusLocationDetailLabels: Array<CensusLocationDetailLabel>;
  saveEstimate?: Maybe<Estimate>;
  saveMicrochip?: Maybe<Patient>;
  /** Create or update the current org's AI PDF extraction rule. Only the given fields change, so saving a test run leaves the rule's active flag alone. */
  savePdfExtractionRule: PdfExtractionRule;
  saveProviderElectronicSignature?: Maybe<ElectronicSignature>;
  saveTreatmentSheetCellOrderItem?: Maybe<TreatmentSheetCell>;
  saveTreatmentSheetRowAdditiveEntry?: Maybe<TreatmentSheetRowAdditiveEntry>;
  sendApptConfirmation?: Maybe<Appointment>;
  sendCardConnectHostedPaymentRequest?: Maybe<Scalars['String']['output']>;
  sendCareCreditPaymentUrl?: Maybe<Scalars['String']['output']>;
  sendClientCheckinLink?: Maybe<Scalars['String']['output']>;
  sendEmailVerification?: Maybe<Client>;
  sendEstimateConsentDepositLink?: Maybe<Scalars['String']['output']>;
  sendInvoiceToHfd?: Maybe<HfdApplicationResult>;
  sendLocationChatMessage?: Maybe<LocationChatMessage>;
  sendMessage?: Maybe<Message>;
  sendNewsletter?: Maybe<Newsletter>;
  sendNewsletterTest?: Maybe<Scalars['String']['output']>;
  sendOutlookEmailVerification?: Maybe<Provider>;
  sendPaymentRequest?: Maybe<Scalars['String']['output']>;
  sendReminder?: Maybe<ProtocolReminder>;
  sendSurveyLink?: Maybe<Scalars['String']['output']>;
  sendTestEmail?: Maybe<Scalars['String']['output']>;
  setApptPickupTime?: Maybe<Appointment>;
  setCensusKennelAdditionalNotes: CensusKennel;
  setCensusKennelLocationDetail: CensusKennel;
  setCensusKennelPhysicalStatus: CensusKennel;
  setChatLastReadAt?: Maybe<Scalars['String']['output']>;
  setDaycareOpen?: Maybe<Scalars['Boolean']['output']>;
  setFeatureFlag?: Maybe<Scalars['Boolean']['output']>;
  setProviderFeatureFlag?: Maybe<ProviderFeatureFlag>;
  /** Sign an encounter with the current user */
  signEncounter?: Maybe<Encounter>;
  signTreatmentSheet?: Maybe<TreatmentSheet>;
  startAsyncMedicalRecord?: Maybe<AsyncMedicalRecord>;
  startConversation?: Maybe<Conversation>;
  /** Start a test extraction using the given per-type instructions. Upload a PDF, or omit it to re-run against the one already stored on the org's rule. */
  startPdfExtractionTestRun: PdfExtractionTestResult;
  startVisit?: Maybe<Visit>;
  stripeAttachPaymentMethodToCustomer?: Maybe<StripePaymentMethod>;
  stripeCancelReaderAction?: Maybe<StripeReader>;
  stripeUpsertCustomer?: Maybe<StripeCustomer>;
  surgeryLogPdf?: Maybe<Scalars['String']['output']>;
  /** @deprecated Please see the request/request-item/fulfillment-item stock transfer APIs instead. This API will be removed soon. */
  switchStockTransfer?: Maybe<StockTransfer>;
  syncClient?: Maybe<SyncClientResult>;
  testMicrosoftCalendarIntegration?: Maybe<Scalars['String']['output']>;
  testScribeInstructions?: Maybe<ScribeTestResult>;
  textApptReady?: Maybe<Appointment>;
  /** Toggle the completed by status of an encounter section */
  toggleEncounterSectionCompletedBy?: Maybe<EncounterSection>;
  transferPatient?: Maybe<Patient>;
  triggerPrescription?: Maybe<Medication>;
  /** Assign a problem in the patient's problem list to the encounter */
  unassignProblemFromEncounter?: Maybe<Problem>;
  /** Removes a provider from a location */
  unassignProviderFromLocation?: Maybe<Provider>;
  /** Removes a provider from a task */
  unassignProviderFromTask?: Maybe<Task>;
  uncompleteBoardCell?: Maybe<BoardCell>;
  undoManualAdjustment?: Maybe<InventoryAdjustment>;
  /** @deprecated Please see `undoManualAdjustment` instead. This field will be removed soon. */
  undoWastageAdjustment?: Maybe<InventoryAdjustment>;
  unlinkAppointment?: Maybe<Appointment>;
  unlinkCall?: Maybe<VoiceCall>;
  /** Updates an address under the client's info */
  updateAddress?: Maybe<Address>;
  updateAlert?: Maybe<Alert>;
  updateAllergy?: Maybe<Allergy>;
  updateAppointment?: Maybe<Appointment>;
  updateAppointmentIntake?: Maybe<AppointmentIntakeData>;
  /** Update appointment positions in the queue. Used for drag-and-drop reordering. */
  updateAppointmentPositions?: Maybe<UpdateAppointmentPositionsResult>;
  updateAppointmentReasonCategory?: Maybe<AppointmentReasonCategory>;
  updateAppointmentType: AppointmentType;
  updateAppointmentTypeTag: AppointmentTypeTag;
  updateAutoMessage: AutoMessage;
  updateBillingGroup?: Maybe<BillingGroup>;
  updateBoardCell?: Maybe<BoardCell>;
  updateBoardRow?: Maybe<BoardRow>;
  updateBoardingBlock: Reservation;
  updateBoardingCage: BoardingCage;
  updateBoardingWard: BoardingWard;
  updateCadence?: Maybe<Cadence>;
  updateCage?: Maybe<Cage>;
  updateCallLog?: Maybe<CallLog>;
  updateCareCreditMerchantId?: Maybe<Location>;
  updateCareTeamRole?: Maybe<CareTeamRole>;
  /** Mutate a client if authorized */
  updateClient?: Maybe<Client>;
  updateClientExternalCommPreferences?: Maybe<ClientExternalCommPreferencesValue>;
  updateClientRdvm?: Maybe<ClientRdvm>;
  updateClientReferralSource?: Maybe<ClientReferralSource>;
  updateClientTag?: Maybe<ClientTag>;
  updateClinicalNote?: Maybe<ClinicalNote>;
  updateComment?: Maybe<Comment>;
  updateComplication: Complication;
  updateConsentForm?: Maybe<ConsentForm>;
  updateConversation?: Maybe<Conversation>;
  /** Updates an associate */
  updateCoowner?: Maybe<Coowner>;
  updateCoupon: Coupon;
  updateCreditReason?: Maybe<CreditReason>;
  /** Updates a custom appointment field (only includeOnAppointment can be modified) */
  updateCustomAppointmentField?: Maybe<CustomAppointmentField>;
  /** Updates a custom appointment field value */
  updateCustomAppointmentFieldValue?: Maybe<CustomAppointmentFieldValue>;
  /** Updates a custom client field value */
  updateCustomClientFieldValue?: Maybe<CustomClientFieldValue>;
  updateCustomLocationAttribute?: Maybe<CustomLocationAttribute>;
  /** Updates a custom patient field (only includeOnAppointment can be modified) */
  updateCustomPatientField?: Maybe<CustomPatientField>;
  /** Updates a custom patient field value */
  updateCustomPatientFieldValue?: Maybe<CustomPatientFieldValue>;
  updateCustomPatientProtocol?: Maybe<CustomPatientProtocol>;
  updateCustomTreatmentSheetRow?: Maybe<TreatmentSheetRow>;
  updateDeclineReason?: Maybe<DeclineReason>;
  updateDepartment: Department;
  updateDiagnostic?: Maybe<Diagnostic>;
  /** create or delete a subscription to dial pad call events */
  updateDialpadSubscription?: Maybe<Org>;
  updateDiscountReason?: Maybe<DiscountReason>;
  /** Update a live encounter */
  updateEncounter?: Maybe<Encounter>;
  /** Update encounter care team members */
  updateEncounterCareTeamMembers?: Maybe<Array<Maybe<EncounterCareTeamMember>>>;
  updateEncounterProduct?: Maybe<EncounterProduct>;
  /** Updates the section corresponding to the given `section_idx` for the given `encounter_id` */
  updateEncounterSection?: Maybe<Encounter>;
  /** Updates a given datum by (section_idx x datum_idx) with provided changeset */
  updateEncounterSectionDatum?: Maybe<Encounter>;
  updateEncounterType?: Maybe<EncounterType>;
  updateEntityTag?: Maybe<EntityTag>;
  updateEntityTagGroup?: Maybe<EntityTagGroup>;
  updateEstimate?: Maybe<Estimate>;
  updateEstimateItem?: Maybe<EstimateItem>;
  updateEstimateItems?: Maybe<Estimate>;
  /** Updates one of a patient's field service visit addresses */
  updateFieldServiceAddress?: Maybe<FieldServiceAddress>;
  updateFulfillmentSource?: Maybe<FulfillmentSource>;
  updateHarvestLabOrder?: Maybe<LabOrder>;
  updateHospitalization?: Maybe<Hospitalization>;
  updateHospitalizationTask?: Maybe<HospitalizationTask>;
  updateIguanaLabOrder?: Maybe<LabOrder>;
  updateImmunization?: Maybe<Immunization>;
  updateInvoiceLineItemReason?: Maybe<InvoiceLineItemReason>;
  updateLabModifier?: Maybe<LabModifier>;
  updateLabOrder?: Maybe<LabOrder>;
  updateLabResult?: Maybe<LabResult>;
  updateLicense?: Maybe<License>;
  /** Update a linked clinical note */
  updateLinkedClinicalNote?: Maybe<LinkedClinicalNote>;
  /** Update a linked encounter */
  updateLinkedEncounter?: Maybe<LinkedEncounter>;
  /** Updates a location. Use updateLocationIntegrations for Cubex and other integration updates requiring credential validation. */
  updateLocation?: Maybe<Location>;
  updateLocationAttribute?: Maybe<LocationAttribute>;
  updateLocationHours?: Maybe<LocationHours>;
  /** Updates a location's integrations settings and validates Cubex credentials when provided */
  updateLocationIntegrations?: Maybe<LocationIntegrations>;
  updateLocationProviderSchedule?: Maybe<LocationProviderSchedule>;
  /** Update a location schedule */
  updateLocationSchedule?: Maybe<LocationSchedule>;
  updateLocationTag: LocationTag;
  updateMacro: Macro;
  /** Update a medication */
  updateMedication: Medication;
  /** Update pharmacy-specific fields in a medication */
  updateMedicationPharmacyFields: Medication;
  /** Update a medication with pharmacy status support */
  updateMedicationWithPharmacyStatus: Medication;
  updateNewsletter?: Maybe<Newsletter>;
  updateOrder?: Maybe<Order>;
  updateOrderFlag?: Maybe<OrderFlag>;
  updateOrderItem?: Maybe<OrderItem>;
  updateOrderItems?: Maybe<Order>;
  /** Update the viewer's org */
  updateOrg?: Maybe<Org>;
  updateOrgDepartment: OrgDepartment;
  updateOrgLab: OrgLab;
  /** Updates a lab integration for a location. If the integration supports it, checks the given credentials and reports whether they authenticated successfully. */
  updateOrgLabWithCheck: OrgLabUpdateResult;
  updateOrgPreference?: Maybe<OrgPreference>;
  updateOutlookOrgPreference?: Maybe<OrgPreference>;
  updatePatient?: Maybe<Patient>;
  updatePatientComplication?: Maybe<PatientComplication>;
  /** Update an existing patient diagnosis entry */
  updatePatientDiagnosis?: Maybe<PatientDiagnosis>;
  updatePatientDocument?: Maybe<PatientDocument>;
  updatePatientPlan: PatientPlan;
  updatePatientPlanItem?: Maybe<PatientPlanItem>;
  updatePatientTag: PatientTag;
  updatePayment?: Maybe<Payment>;
  updatePaymentReason?: Maybe<PaymentReason>;
  /** Mutate a phone number */
  updatePhoneNumber?: Maybe<PhoneNumber>;
  updatePreventionPlan?: Maybe<PreventionPlan>;
  /** Updates a price change */
  updatePriceChange?: Maybe<PriceChange>;
  updateProblem?: Maybe<Problem>;
  /** Update a product */
  updateProduct?: Maybe<Product>;
  updateProductCategory: ProductCategory;
  /** Controls whether a product is synced to Cubex at the specified location. Requires the Cubex Sync feature to be enabled. */
  updateProductCubexEnabled?: Maybe<Product>;
  updateProductEnabled?: Maybe<Product>;
  updateProductManufacturer?: Maybe<ProductManufacturer>;
  updateProductPackage?: Maybe<ProductPackage>;
  updateProductPackageItem?: Maybe<ProductPackageItem>;
  updateProductPrice?: Maybe<ProductPrice>;
  updateProductProductCategory?: Maybe<Product>;
  updateProductType: ProductType;
  updateProtocol?: Maybe<Protocol>;
  updateProtocolReminder?: Maybe<ProtocolReminder>;
  updateProvider?: Maybe<Provider>;
  updateProviderPunch: ProviderPunch;
  updateProviderRole: ProviderRole;
  updateProviderTransfer?: Maybe<ProviderTransfer>;
  updatePurchaseOrder?: Maybe<PurchaseOrder>;
  updatePurchaseOrderItem?: Maybe<PurchaseOrderItem>;
  /** @deprecated Please see the request/request-item/fulfillment-item stock transfer APIs instead. This API will be removed soon. */
  updateQuantityStockTransferItem?: Maybe<StockTransferItem>;
  updateRdvm?: Maybe<Rdvm>;
  updateRdvmContact?: Maybe<RdvmContact>;
  updateRdvmVisit?: Maybe<RdvmVisit>;
  updateReconciliationNote: ReconciliationNote;
  updateRelationship: Relationship;
  updateReminder?: Maybe<Reminder>;
  updateReminderSilence?: Maybe<ReminderSilence>;
  updateReservation: Reservation;
  updateRevenueCenter?: Maybe<RevenueCenter>;
  updateRevenueCenterBudget: RevenueCenterBudget;
  updateScheduleTemplate?: Maybe<ScheduleTemplate>;
  updateStockLocation?: Maybe<StockLocation>;
  /** @deprecated Please see the request/request-item/fulfillment-item stock transfer APIs instead. This API will be removed soon. */
  updateStockTransfer?: Maybe<StockTransfer>;
  updateStockTransferFulfillmentItem?: Maybe<StockTransferFulfillmentItem>;
  /** @deprecated Please see the request/request-item/fulfillment-item stock transfer APIs instead. This API will be removed soon. */
  updateStockTransferItem?: Maybe<StockTransferItem>;
  /** @deprecated Please see the request/request-item/fulfillment-item stock transfer APIs instead. This API will be removed soon. */
  updateStockTransferNotes?: Maybe<StockTransferNote>;
  updateStockTransferReportRecipient?: Maybe<StockTransferReportRecipient>;
  updateStockTransferRequest?: Maybe<StockTransferRequest>;
  updateStockTransferRequestItem?: Maybe<StockTransferRequestItem>;
  updateStockTransferTemplate?: Maybe<StockTransferTemplate>;
  updateStockTransferTemplateItem?: Maybe<StockTransferTemplateItem>;
  updateTask?: Maybe<Task>;
  updateTaskCategory?: Maybe<TaskCategory>;
  updateTaskGroup: TaskGroup;
  updateTravelZone: TravelZone;
  updateTreatment?: Maybe<Treatment>;
  updateTreatmentSheet?: Maybe<TreatmentSheet>;
  updateTreatmentSheetCell?: Maybe<TreatmentSheetCell>;
  updateTreatmentSheetRow?: Maybe<TreatmentSheetRow>;
  updateTreatmentSheetRowInactiveIntervals?: Maybe<TreatmentSheetRow>;
  updateTreatmentSheetStart?: Maybe<TreatmentSheet>;
  updateTreatmentSheetTemplate?: Maybe<TreatmentSheetTemplate>;
  updateTreatmentSheetTimeSlots?: Maybe<TreatmentSheet>;
  updateTrigger?: Maybe<Trigger>;
  updateVendor?: Maybe<Vendor>;
  updateViewer?: Maybe<Provider>;
  updateViewerPassword?: Maybe<Provider>;
  updateVisitHeaderConfig?: Maybe<VisitHeaderConfig>;
  updateVitals?: Maybe<Vitals>;
  updateVoiceCall?: Maybe<VoiceCall>;
  uploadClinicImage?: Maybe<Location>;
  uploadEmailTemplateImage?: Maybe<Scalars['String']['output']>;
  uploadEncounterTypeAsset?: Maybe<Scalars['String']['output']>;
  /** Create a new image for the specified lab result. */
  uploadLabImage?: Maybe<LabResult>;
  uploadLocationLogo?: Maybe<Org>;
  uploadMassInventory?: Maybe<MassUploadResult>;
  uploadMassProducts?: Maybe<Scalars['String']['output']>;
  uploadMassRdvms?: Maybe<Scalars['String']['output']>;
  uploadOrgLogo?: Maybe<Org>;
  uploadPatientDocument?: Maybe<PatientDocument>;
  uploadPatientImage?: Maybe<Patient>;
  uploadProtocolsMigrationCsv?: Maybe<Scalars['String']['output']>;
  uploadProviderElectronicSignature?: Maybe<ElectronicSignature>;
  uploadProviderProfileImage?: Maybe<Provider>;
  uploadRdvmDocument?: Maybe<RdvmDocument>;
  upsertLowStockThreshold?: Maybe<LowStockThreshold>;
  upsertPackageLocationMarkup?: Maybe<LocationOrLocationTag>;
  upsertPatientContactDetails?: Maybe<PatientContactDetails>;
  upsertProductConfig?: Maybe<ProductConfig>;
  upsertProductLocationMarkup?: Maybe<LocationOrLocationTag>;
  upsertProductTypeLocationMarkup?: Maybe<Location>;
  upsertProviderAppointmentTypeLimit?: Maybe<ProviderAppointmentTypeLimit>;
  upsertProviderCommissions?: Maybe<Array<Maybe<ProviderCommission>>>;
  upsertProviderPreferences?: Maybe<ProviderPreferences>;
  validateControlledDrugPin?: Maybe<Scalars['Boolean']['output']>;
  valuesetLabel?: Maybe<Scalars['String']['output']>;
  voidPayment?: Maybe<Payment>;
};


export type RootMutationTypeAcquireEncounterSectionLockArgs = {
  encounterId: Scalars['ID']['input'];
  sectionIdx: Scalars['Int']['input'];
  sessionId?: InputMaybe<Scalars['String']['input']>;
};


export type RootMutationTypeAcquireFaxNumberArgs = {
  locationId: Scalars['ID']['input'];
};


export type RootMutationTypeAcquirePharmacyMedicationLockArgs = {
  medicationId: Scalars['ID']['input'];
  sessionId: Scalars['String']['input'];
};


export type RootMutationTypeAcquireTollFreeNumberArgs = {
  locationId: Scalars['ID']['input'];
};


export type RootMutationTypeAcquireTwilioPhoneNumberArgs = {
  areaCode?: InputMaybe<Scalars['String']['input']>;
  locationId: Scalars['ID']['input'];
};


export type RootMutationTypeAddClientAddressArgs = {
  clientId: Scalars['ID']['input'];
  input?: InputMaybe<AddressInput>;
};


export type RootMutationTypeAddClientStripeInfoArgs = {
  id: Scalars['ID']['input'];
  input: PaymentSourceInput;
};


export type RootMutationTypeAddCoownerArgs = {
  clientId: Scalars['ID']['input'];
  input: CoownerInput;
};


export type RootMutationTypeAddCreditMemoArgs = {
  clientId: Scalars['ID']['input'];
  input: CreditMemoInput;
};


export type RootMutationTypeAddCustomTreatmentSheetRowArgs = {
  input: CustomTreatmentSheetRowInput;
  treatmentSheetId: Scalars['ID']['input'];
};


export type RootMutationTypeAddEstimateItemArgs = {
  input: EstimateItemInput;
};


export type RootMutationTypeAddItemsToVisitArgs = {
  items: Array<VisitItemInput>;
  visitId: Scalars['ID']['input'];
};


export type RootMutationTypeAddLinkedClinicalNoteArgs = {
  clinicalNoteId: Scalars['ID']['input'];
  encounterId: Scalars['ID']['input'];
};


export type RootMutationTypeAddLinkedEncounterArgs = {
  encounterId: Scalars['ID']['input'];
  linkedEncounterId: Scalars['ID']['input'];
  title: Scalars['String']['input'];
};


export type RootMutationTypeAddLinkedProductArgs = {
  linkedProductId: Scalars['ID']['input'];
  productId: Scalars['ID']['input'];
};


export type RootMutationTypeAddOrderItemArgs = {
  departmentId?: InputMaybe<Scalars['ID']['input']>;
  encounterId?: InputMaybe<Scalars['ID']['input']>;
  input?: InputMaybe<OrderItemInput>;
  orderId: Scalars['ID']['input'];
  productId?: InputMaybe<Scalars['ID']['input']>;
};


export type RootMutationTypeAddOrderItemToEncounterArgs = {
  encounterId?: InputMaybe<Scalars['ID']['input']>;
  productId?: InputMaybe<Scalars['ID']['input']>;
  quantity?: InputMaybe<Scalars['Decimal']['input']>;
};


export type RootMutationTypeAddPackageToEncounterArgs = {
  encounterId: Scalars['ID']['input'];
  packageId: Scalars['ID']['input'];
  selectedItemIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};


export type RootMutationTypeAddPackageToEstimateArgs = {
  estimateId: Scalars['ID']['input'];
  packageId: Scalars['ID']['input'];
  patientId?: InputMaybe<Scalars['ID']['input']>;
  selectedItemIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};


export type RootMutationTypeAddPackageToOrderArgs = {
  orderId: Scalars['ID']['input'];
  packageId: Scalars['ID']['input'];
  patientId?: InputMaybe<Scalars['ID']['input']>;
  selectedItemIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};


export type RootMutationTypeAddPackageToPackageArgs = {
  id: Scalars['ID']['input'];
  packageId: Scalars['ID']['input'];
};


export type RootMutationTypeAddPatientPlanItemArgs = {
  input: PatientPlanItemInput;
  patientPlanId: Scalars['ID']['input'];
};


export type RootMutationTypeAddPatientRdvmArgs = {
  id: Scalars['ID']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  preferred?: InputMaybe<Scalars['Boolean']['input']>;
  rdvmId: Scalars['ID']['input'];
  referringDoctors?: InputMaybe<Scalars['String']['input']>;
};


export type RootMutationTypeAddPatientToBoardArgs = {
  boardGroupId?: InputMaybe<Scalars['ID']['input']>;
  locationId: Scalars['ID']['input'];
  patientId: Scalars['ID']['input'];
};


export type RootMutationTypeAddPurchaseOrderItemArgs = {
  orderId: Scalars['ID']['input'];
  productId: Scalars['ID']['input'];
};


export type RootMutationTypeAddReviewerToLabResultArgs = {
  labResultId: Scalars['ID']['input'];
  providerId: Scalars['ID']['input'];
};


export type RootMutationTypeAddStockTransferItemArgs = {
  productId: Scalars['ID']['input'];
  transferId: Scalars['ID']['input'];
};


export type RootMutationTypeAddTestsToLabOrderArgs = {
  comment?: InputMaybe<Scalars['String']['input']>;
  orderId: Scalars['ID']['input'];
  tests: Array<InputMaybe<Scalars['String']['input']>>;
};


export type RootMutationTypeAddTreatmentArgs = {
  input: TreatmentInput;
};


export type RootMutationTypeAddTreatmentSheetCellCommentArgs = {
  text?: InputMaybe<Scalars['String']['input']>;
  treatmentSheetCellId: Scalars['ID']['input'];
};


export type RootMutationTypeAddTreatmentSheetRowArgs = {
  input: TreatmentSheetRowInput;
  treatmentSheetId: Scalars['ID']['input'];
};


export type RootMutationTypeApplyAccountCreditArgs = {
  orderId: Scalars['ID']['input'];
};


export type RootMutationTypeApplyCouponArgs = {
  couponId: Scalars['ID']['input'];
  orderId?: InputMaybe<Scalars['ID']['input']>;
};


export type RootMutationTypeApplyEstimateCouponArgs = {
  couponId: Scalars['ID']['input'];
  estimateId?: InputMaybe<Scalars['ID']['input']>;
};


export type RootMutationTypeApplyPriceChangeArgs = {
  id: Scalars['ID']['input'];
};


export type RootMutationTypeApplyStockTransferTemplateArgs = {
  templateId: Scalars['ID']['input'];
};


export type RootMutationTypeApproveAndSendToPharmacyArgs = {
  input: MedicationInput;
  medicationId: Scalars['ID']['input'];
};


export type RootMutationTypeApproveCubexDiagnosticArgs = {
  id: Scalars['ID']['input'];
  input: ApproveCubexDiagnosticInput;
};


export type RootMutationTypeApproveCubexEncounterProductArgs = {
  id: Scalars['ID']['input'];
  input: ApproveCubexEncounterProductInput;
};


export type RootMutationTypeApproveCubexImmunizationArgs = {
  id: Scalars['ID']['input'];
  input: ApproveCubexImmunizationInput;
};


export type RootMutationTypeApproveCubexMedicationArgs = {
  id: Scalars['ID']['input'];
  input: ApproveCubexMedicationInput;
};


export type RootMutationTypeApproveCubexTreatmentArgs = {
  id: Scalars['ID']['input'];
  input: ApproveCubexTreatmentInput;
};


export type RootMutationTypeApproveMedicationArgs = {
  id: Scalars['ID']['input'];
  input: ApproveMedicationInput;
};


export type RootMutationTypeAssignOrphanImmunizationTransactionArgs = {
  id: Scalars['ID']['input'];
  input: AssignOrphanImmunizationTransactionInput;
};


export type RootMutationTypeAssignOrphanImmunizationTransactionToNewEncounterArgs = {
  id: Scalars['ID']['input'];
  input: AssignOrphanImmunizationTransactionToNewEncounterInput;
};


export type RootMutationTypeAssignOrphanTransactionArgs = {
  id: Scalars['ID']['input'];
  input: AssignOrphanTransactionInput;
};


export type RootMutationTypeAssignOrphanTransactionToNewEncounterArgs = {
  id: Scalars['ID']['input'];
  input: AssignOrphanTransactionToNewEncounterInput;
};


export type RootMutationTypeAssignProblemToEncounterArgs = {
  encounterId: Scalars['ID']['input'];
  problemId: Scalars['ID']['input'];
};


export type RootMutationTypeAssignProviderToLocationArgs = {
  locationId: Scalars['ID']['input'];
  providerId: Scalars['ID']['input'];
};


export type RootMutationTypeAssignProviderToTaskArgs = {
  providerId: Scalars['ID']['input'];
  taskId: Scalars['ID']['input'];
};


export type RootMutationTypeAutoApplyCouponsArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type RootMutationTypeAutoApplyEstimateCouponsArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type RootMutationTypeAutoApplyProductCouponsArgs = {
  orderId: Scalars['ID']['input'];
};


export type RootMutationTypeBatchReplaceEncounterSectionDatumsArgs = {
  encounterId: Scalars['ID']['input'];
  inputs: Array<EncounterSectionDatumReplaceInput>;
  sessionId?: InputMaybe<Scalars['String']['input']>;
};


export type RootMutationTypeBatchUpsertOrgPreferencesArgs = {
  preferences: Array<OrgPreferenceInput>;
};


export type RootMutationTypeBillingHistoryArgs = {
  clientId: Scalars['ID']['input'];
};


export type RootMutationTypeBillingStatementArgs = {
  clientId: Scalars['ID']['input'];
  locationId: Scalars['ID']['input'];
};


export type RootMutationTypeBulkMarkRemindersAsSentArgs = {
  file: Scalars['Upload']['input'];
};


export type RootMutationTypeBulkUpdateEncounterTypeSectionOverridesArgs = {
  encounterTypeId: Scalars['ID']['input'];
  overrides: Array<EncounterTypeSectionOverrideItemInput>;
};


export type RootMutationTypeCancelDatasyncArgs = {
  locationId: Scalars['ID']['input'];
  logId: Scalars['ID']['input'];
  practiceId: Scalars['String']['input'];
};


export type RootMutationTypeCancelLabOrderArgs = {
  id: Scalars['ID']['input'];
};


export type RootMutationTypeCancelPlanArgs = {
  discount?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
};


export type RootMutationTypeCaptureClientConsentArgs = {
  clientConsentId?: InputMaybe<Scalars['ID']['input']>;
  clientId?: InputMaybe<Scalars['ID']['input']>;
  consent: Scalars['String']['input'];
  consentFormId?: InputMaybe<Scalars['ID']['input']>;
  encounterId?: InputMaybe<Scalars['ID']['input']>;
  estimateId?: InputMaybe<Scalars['ID']['input']>;
  locationId?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  patientId?: InputMaybe<Scalars['ID']['input']>;
  signature: Scalars['String']['input'];
};


export type RootMutationTypeChargeClientArgs = {
  amount?: InputMaybe<Scalars['Decimal']['input']>;
  clientId: Scalars['ID']['input'];
  donation?: InputMaybe<Scalars['Decimal']['input']>;
  locationId?: InputMaybe<Scalars['ID']['input']>;
  method: PaymentMethod;
  methodType?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  paymentReasonId?: InputMaybe<Scalars['ID']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  reference?: InputMaybe<Scalars['String']['input']>;
  tip?: InputMaybe<Scalars['Decimal']['input']>;
  tokenize?: InputMaybe<Scalars['Boolean']['input']>;
};


export type RootMutationTypeChargeEstimateArgs = {
  amount: Scalars['Decimal']['input'];
  donation?: InputMaybe<Scalars['Decimal']['input']>;
  estimateId: Scalars['ID']['input'];
  locationId?: InputMaybe<Scalars['ID']['input']>;
  method: PaymentMethod;
  methodType?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  reference?: InputMaybe<Scalars['String']['input']>;
  tip?: InputMaybe<Scalars['Decimal']['input']>;
  tokenize?: InputMaybe<Scalars['Boolean']['input']>;
};


export type RootMutationTypeChargeOrderArgs = {
  amount?: InputMaybe<Scalars['Decimal']['input']>;
  donation?: InputMaybe<Scalars['Decimal']['input']>;
  method: PaymentMethod;
  methodType?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  orderId: Scalars['ID']['input'];
  payingClientId?: InputMaybe<Scalars['ID']['input']>;
  paymentReasonId?: InputMaybe<Scalars['ID']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  reference?: InputMaybe<Scalars['String']['input']>;
  tip?: InputMaybe<Scalars['Decimal']['input']>;
  tokenize?: InputMaybe<Scalars['Boolean']['input']>;
};


export type RootMutationTypeCheckInReservationArgs = {
  id: Scalars['ID']['input'];
};


export type RootMutationTypeCheckOutReservationArgs = {
  id: Scalars['ID']['input'];
};


export type RootMutationTypeClientConsentLinkArgs = {
  clientId?: InputMaybe<Scalars['ID']['input']>;
  consent?: InputMaybe<Scalars['String']['input']>;
  consentFormId?: InputMaybe<Scalars['ID']['input']>;
  encounterId?: InputMaybe<Scalars['ID']['input']>;
  estimateId?: InputMaybe<Scalars['ID']['input']>;
  locationId?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  patientId?: InputMaybe<Scalars['ID']['input']>;
};


export type RootMutationTypeClockInArgs = {
  clockIn: Scalars['DateTime']['input'];
};


export type RootMutationTypeClockOutArgs = {
  clockOut: Scalars['DateTime']['input'];
  id: Scalars['ID']['input'];
};


export type RootMutationTypeCommentArgs = {
  body: Scalars['String']['input'];
  entityType: CommentableEntityType;
  entityTypeId: Scalars['ID']['input'];
};


export type RootMutationTypeCompleteBoardCellArgs = {
  id: Scalars['ID']['input'];
};


export type RootMutationTypeConvertCallLogToAppointmentArgs = {
  callLogId: Scalars['ID']['input'];
  handledByRemote?: InputMaybe<Scalars['Boolean']['input']>;
};


export type RootMutationTypeConvertEstimateToOrderArgs = {
  id: Scalars['ID']['input'];
};


export type RootMutationTypeCopyFromPreviousEncounterArgs = {
  encounterId: Scalars['ID']['input'];
  sectionName: Scalars['String']['input'];
};


export type RootMutationTypeCopyMedicationsToEncounterArgs = {
  encounterId: Scalars['ID']['input'];
  sectionIdx?: InputMaybe<Scalars['Int']['input']>;
  sectionName?: InputMaybe<Scalars['String']['input']>;
};


export type RootMutationTypeCopyPackageArgs = {
  id: Scalars['ID']['input'];
};


export type RootMutationTypeCreateAlertArgs = {
  input: AlertInput;
};


export type RootMutationTypeCreateAllergyArgs = {
  patientId: Scalars['ID']['input'];
};


export type RootMutationTypeCreateApiKeyArgs = {
  providerRoleId: Scalars['ID']['input'];
  title: Scalars['String']['input'];
};


export type RootMutationTypeCreateAppointmentArgs = {
  input: AppointmentInput;
};


export type RootMutationTypeCreateAppointmentReasonCategoryArgs = {
  reason: Scalars['String']['input'];
};


export type RootMutationTypeCreateAppointmentReminderArgs = {
  input?: InputMaybe<AppointmentReminderInput>;
};


export type RootMutationTypeCreateAppointmentTypeArgs = {
  input?: InputMaybe<AppointmentTypeInput>;
};


export type RootMutationTypeCreateAppointmentTypeTagArgs = {
  input?: InputMaybe<AppointmentTypeTagInput>;
};


export type RootMutationTypeCreateApptVitalsArgs = {
  appointmentId: Scalars['ID']['input'];
};


export type RootMutationTypeCreateAutoMessageArgs = {
  input?: InputMaybe<AutoMessageInput>;
};


export type RootMutationTypeCreateBillingGroupArgs = {
  input: BillingGroupInput;
};


export type RootMutationTypeCreateBillingNoteArgs = {
  input?: InputMaybe<BillingNoteInput>;
};


export type RootMutationTypeCreateBoardCellArgs = {
  input?: InputMaybe<BoardCellInput>;
};


export type RootMutationTypeCreateBoardingBlockArgs = {
  input: BoardingBlockInput;
};


export type RootMutationTypeCreateBoardingCageArgs = {
  input?: InputMaybe<BoardingCageInput>;
};


export type RootMutationTypeCreateBoardingWardArgs = {
  input: BoardingWardInput;
};


export type RootMutationTypeCreateBridgeUserArgs = {
  id: Scalars['ID']['input'];
};


export type RootMutationTypeCreateCadenceArgs = {
  input: CadenceInput;
};


export type RootMutationTypeCreateCageArgs = {
  input?: InputMaybe<CageInput>;
};


export type RootMutationTypeCreateCallLogArgs = {
  input?: InputMaybe<CallLogInput>;
};


export type RootMutationTypeCreateCareTeamRoleArgs = {
  input: CreateCareTeamRoleInput;
};


export type RootMutationTypeCreateClientArgs = {
  input?: InputMaybe<ClientInput>;
};


export type RootMutationTypeCreateClientRdvmArgs = {
  input?: InputMaybe<ClientRdvmInput>;
};


export type RootMutationTypeCreateClientReferralSourceArgs = {
  input?: InputMaybe<ClientReferralSourceInput>;
};


export type RootMutationTypeCreateClientTagArgs = {
  input: ClientTagInput;
};


export type RootMutationTypeCreateClinicalNoteArgs = {
  input?: InputMaybe<ClinicalNoteInput>;
};


export type RootMutationTypeCreateComplicationArgs = {
  input?: InputMaybe<ComplicationInput>;
};


export type RootMutationTypeCreateConsentFormArgs = {
  input?: InputMaybe<ConsentFormInput>;
};


export type RootMutationTypeCreateConversationArgs = {
  clientId: Scalars['ID']['input'];
  input?: InputMaybe<ConversationInput>;
  patientId?: InputMaybe<Scalars['ID']['input']>;
  subject?: InputMaybe<Scalars['String']['input']>;
};


export type RootMutationTypeCreateCouponArgs = {
  input: CouponInput;
};


export type RootMutationTypeCreateCreditReasonArgs = {
  input: CreditReasonInput;
};


export type RootMutationTypeCreateCustomAppointmentFieldArgs = {
  input?: InputMaybe<CustomAppointmentFieldInput>;
};


export type RootMutationTypeCreateCustomAppointmentFieldValueArgs = {
  input: CustomAppointmentFieldValueInput;
};


export type RootMutationTypeCreateCustomClientFieldArgs = {
  input?: InputMaybe<CustomClientFieldInput>;
};


export type RootMutationTypeCreateCustomClientFieldValueArgs = {
  clientId?: InputMaybe<Scalars['ID']['input']>;
  customClientFieldId?: InputMaybe<Scalars['ID']['input']>;
  input?: InputMaybe<CustomClientFieldValueInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};


export type RootMutationTypeCreateCustomLocationAttributeArgs = {
  input: CustomLocationAttributeInput;
};


export type RootMutationTypeCreateCustomPatientFieldArgs = {
  input?: InputMaybe<CustomPatientFieldInput>;
};


export type RootMutationTypeCreateCustomPatientFieldValueArgs = {
  appointmentId?: InputMaybe<Scalars['ID']['input']>;
  customPatientFieldId?: InputMaybe<Scalars['ID']['input']>;
  input?: InputMaybe<CustomPatientFieldValueInput>;
  patientId?: InputMaybe<Scalars['ID']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};


export type RootMutationTypeCreateCustomPatientProtocolArgs = {
  input?: InputMaybe<CustomPatientProtocolInput>;
};


export type RootMutationTypeCreateDeclineReasonArgs = {
  input: DeclineReasonInput;
};


export type RootMutationTypeCreateDepartmentArgs = {
  input?: InputMaybe<DepartmentInput>;
};


export type RootMutationTypeCreateDiagnosticArgs = {
  input?: InputMaybe<DiagnosticInput>;
};


export type RootMutationTypeCreateDiscountReasonArgs = {
  input: DiscountReasonInput;
};


export type RootMutationTypeCreateEncounterOrderArgs = {
  encounterId: Scalars['ID']['input'];
};


export type RootMutationTypeCreateEncounterProductArgs = {
  input?: InputMaybe<EncounterProductInput>;
};


export type RootMutationTypeCreateEncounterSectionArgs = {
  encounterId: Scalars['ID']['input'];
  input: EncounterSectionInput;
  sectionIdx: Scalars['Int']['input'];
};


export type RootMutationTypeCreateEncounterSectionDatumArgs = {
  datum: Scalars['JSON']['input'];
  datumIdx: Scalars['Int']['input'];
  encounterId: Scalars['ID']['input'];
  sectionIdx: Scalars['Int']['input'];
  sessionId?: InputMaybe<Scalars['String']['input']>;
};


export type RootMutationTypeCreateEncounterTypeArgs = {
  input?: InputMaybe<EncounterTypeInput>;
};


export type RootMutationTypeCreateEntitiesTagArgs = {
  input?: InputMaybe<EntitiesTagInput>;
};


export type RootMutationTypeCreateEntityTagArgs = {
  input?: InputMaybe<EntityTagInput>;
};


export type RootMutationTypeCreateEntityTagGroupArgs = {
  input?: InputMaybe<EntityTagGroupInput>;
};


export type RootMutationTypeCreateEntityValidationArgs = {
  input?: InputMaybe<EntityValidationInput>;
};


export type RootMutationTypeCreateEstimateArgs = {
  input: EstimateInput;
};


export type RootMutationTypeCreateEstimateItemArgs = {
  input?: InputMaybe<EstimateItemInput>;
};


export type RootMutationTypeCreateFieldServiceAddressArgs = {
  input: FieldServiceAddressInput;
  patientId: Scalars['ID']['input'];
};


export type RootMutationTypeCreateFulfillmentSourceArgs = {
  input?: InputMaybe<FulfillmentSourceInput>;
};


export type RootMutationTypeCreateHarvestLabOrderArgs = {
  input: CreateHarvestLabOrderInput;
};


export type RootMutationTypeCreateHarvestLabResultArgs = {
  input: CreateHarvestLabResultInput;
};


export type RootMutationTypeCreateHospitalizationArgs = {
  input?: InputMaybe<HospitalizationInput>;
};


export type RootMutationTypeCreateHospitalizationTaskArgs = {
  hospitalizationId: Scalars['ID']['input'];
  input?: InputMaybe<HospitalizationTaskInput>;
};


export type RootMutationTypeCreateIguanaLabOrderArgs = {
  input: CreateIguanaLabOrderInput;
};


export type RootMutationTypeCreateIguanaLabResultArgs = {
  input: CreateIguanaLabResultInput;
};


export type RootMutationTypeCreateImmunizationArgs = {
  input: ImmunizationInput;
};


export type RootMutationTypeCreateInventoryAdjustmentArgs = {
  input?: InputMaybe<InventoryAdjustmentInput>;
};


export type RootMutationTypeCreateInvoiceLineItemReasonArgs = {
  input: InvoiceLineItemReasonInput;
};


export type RootMutationTypeCreateLabModifierArgs = {
  input: LabModifierInput;
};


export type RootMutationTypeCreateLicenseArgs = {
  input: LicenseInput;
};


export type RootMutationTypeCreateLocationAttributeArgs = {
  input?: InputMaybe<LocationAttributeInput>;
};


export type RootMutationTypeCreateLocationProviderScheduleArgs = {
  input?: InputMaybe<LocationProviderScheduleInput>;
};


export type RootMutationTypeCreateLocationScheduleArgs = {
  input: LocationScheduleInput;
  locationId: Scalars['ID']['input'];
};


export type RootMutationTypeCreateLocationTagArgs = {
  input?: InputMaybe<LocationTagInput>;
};


export type RootMutationTypeCreateMacroArgs = {
  input: MacroInput;
};


export type RootMutationTypeCreateManualArAdjustmentArgs = {
  input: CreateManualArAdjustmentInput;
};


export type RootMutationTypeCreateOrderArgs = {
  input: OrderInput;
};


export type RootMutationTypeCreateOrderFlagArgs = {
  input?: InputMaybe<OrderFlagInput>;
};


export type RootMutationTypeCreateOrgDepartmentArgs = {
  input?: InputMaybe<OrgDepartmentInput>;
};


export type RootMutationTypeCreateOrgLabArgs = {
  input?: InputMaybe<OrgLabInput>;
};


export type RootMutationTypeCreateOrgLabWithCheckArgs = {
  input: OrgLabInput;
};


export type RootMutationTypeCreateOrgPreferenceArgs = {
  input?: InputMaybe<OrgPreferenceInput>;
};


export type RootMutationTypeCreateOutlookOrgPreferenceArgs = {
  input?: InputMaybe<OrgPreferenceInput>;
};


export type RootMutationTypeCreateParentProblemArgs = {
  id: Scalars['ID']['input'];
};


export type RootMutationTypeCreatePatientArgs = {
  clientId: Scalars['ID']['input'];
  input?: InputMaybe<PatientInput>;
};


export type RootMutationTypeCreatePatientComplicationArgs = {
  input?: InputMaybe<PatientComplicationInput>;
};


export type RootMutationTypeCreatePatientDiagnosisArgs = {
  input?: InputMaybe<PatientDiagnosisInput>;
  patientId: Scalars['ID']['input'];
};


export type RootMutationTypeCreatePatientTagArgs = {
  input?: InputMaybe<PatientTagInput>;
};


export type RootMutationTypeCreatePaymentReasonArgs = {
  input: PaymentReasonInput;
};


export type RootMutationTypeCreatePreventionPlanArgs = {
  input?: InputMaybe<PreventionPlanInput>;
};


export type RootMutationTypeCreatePriceChangeArgs = {
  input: PriceChangeInput;
};


export type RootMutationTypeCreateProblemArgs = {
  input?: InputMaybe<ProblemInput>;
  patientId: Scalars['ID']['input'];
};


export type RootMutationTypeCreateProductCategoryArgs = {
  input?: InputMaybe<ProductCategoryInput>;
};


export type RootMutationTypeCreateProductManufacturerArgs = {
  input: ProductManufacturerInput;
};


export type RootMutationTypeCreateProductPackageArgs = {
  input?: InputMaybe<ProductPackageInput>;
};


export type RootMutationTypeCreateProductPackageItemArgs = {
  input?: InputMaybe<ProductPackageItemInput>;
};


export type RootMutationTypeCreateProductPriceArgs = {
  input: ProductPriceInput;
};


export type RootMutationTypeCreateProductTypeArgs = {
  input: ProductTypeInput;
};


export type RootMutationTypeCreateProtocolArgs = {
  input?: InputMaybe<ProtocolInput>;
};


export type RootMutationTypeCreateProviderArgs = {
  input: ProviderInput;
};


export type RootMutationTypeCreateProviderPinArgs = {
  currentPassword: Scalars['String']['input'];
  pin: Scalars['String']['input'];
  pinConfirmation: Scalars['String']['input'];
};


export type RootMutationTypeCreateProviderPunchArgs = {
  input: ProviderPunchInput;
};


export type RootMutationTypeCreateProviderRoleArgs = {
  input?: InputMaybe<ProviderRoleInput>;
};


export type RootMutationTypeCreateProviderTransferArgs = {
  input: CreateProviderTransferInput;
};


export type RootMutationTypeCreatePurchaseOrderArgs = {
  input?: InputMaybe<PurchaseOrderInput>;
};


export type RootMutationTypeCreateRdvmArgs = {
  input: RdvmInput;
};


export type RootMutationTypeCreateRdvmContactArgs = {
  input: RdvmContactInput;
};


export type RootMutationTypeCreateRdvmVisitArgs = {
  input: RdvmVisitInput;
};


export type RootMutationTypeCreateReconciliationNoteArgs = {
  input: ReconciliationNoteInput;
};


export type RootMutationTypeCreateRelationshipArgs = {
  input?: InputMaybe<RelationshipInput>;
};


export type RootMutationTypeCreateReminderArgs = {
  input?: InputMaybe<ReminderInput>;
};


export type RootMutationTypeCreateReminderSilenceArgs = {
  input?: InputMaybe<ReminderSilenceInput>;
};


export type RootMutationTypeCreateReservationArgs = {
  input: ReservationInput;
};


export type RootMutationTypeCreateReservationEstimateArgs = {
  id: Scalars['ID']['input'];
};


export type RootMutationTypeCreateRevenueCenterArgs = {
  input: RevenueCenterInput;
};


export type RootMutationTypeCreateRevenueCenterBudgetArgs = {
  input: RevenueCenterBudgetInput;
};


export type RootMutationTypeCreateScheduleRecurrenceArgs = {
  input: ScheduleRecurrenceInput;
};


export type RootMutationTypeCreateScheduleTemplateArgs = {
  input?: InputMaybe<ScheduleTemplateInput>;
};


export type RootMutationTypeCreateStockLocationArgs = {
  input?: InputMaybe<StockLocationInput>;
};


export type RootMutationTypeCreateStockTransferArgs = {
  input?: InputMaybe<StockTransferInput>;
};


export type RootMutationTypeCreateStockTransferFulfillmentItemArgs = {
  input: CreateStockTransferFulfillmentItemInput;
  requestItemId: Scalars['ID']['input'];
};


export type RootMutationTypeCreateStockTransferReportRecipientArgs = {
  input: StockTransferReportRecipientInput;
};


export type RootMutationTypeCreateStockTransferRequestArgs = {
  input: CreateStockTransferRequestInput;
};


export type RootMutationTypeCreateStockTransferRequestItemArgs = {
  input: CreateStockTransferRequestItemInput;
  requestId: Scalars['ID']['input'];
};


export type RootMutationTypeCreateStockTransferRequestItemsArgs = {
  input: CreateStockTransferRequestItemsInput;
  requestId: Scalars['ID']['input'];
};


export type RootMutationTypeCreateStockTransferTemplateArgs = {
  input: StockTransferTemplateInput;
};


export type RootMutationTypeCreateStockTransferTemplateItemArgs = {
  input: CreateStockTransferTemplateItemInput;
  templateId: Scalars['ID']['input'];
};


export type RootMutationTypeCreateStripePaymentIntentArgs = {
  amount: Scalars['Decimal']['input'];
  locationId: Scalars['ID']['input'];
};


export type RootMutationTypeCreateTaskArgs = {
  input?: InputMaybe<TaskInput>;
  patientId?: InputMaybe<Scalars['ID']['input']>;
};


export type RootMutationTypeCreateTaskCategoryArgs = {
  input: TaskCategoryInput;
};


export type RootMutationTypeCreateTaskGroupArgs = {
  input: TaskGroupInput;
};


export type RootMutationTypeCreateTeletailsSessionArgs = {
  input?: InputMaybe<TeletailsSessionInput>;
};


export type RootMutationTypeCreateTravelZoneArgs = {
  input: TravelZoneInput;
};


export type RootMutationTypeCreateTreatmentSheetArgs = {
  input: CreateTreatmentSheetInput;
};


export type RootMutationTypeCreateTreatmentSheetCellArgs = {
  input?: InputMaybe<TreatmentSheetCellInput>;
  treatmentSheetRowId?: InputMaybe<Scalars['ID']['input']>;
};


export type RootMutationTypeCreateTreatmentSheetTemplateArgs = {
  input: TreatmentSheetTemplateInput;
};


export type RootMutationTypeCreateUserTaskArgs = {
  input?: InputMaybe<TaskInput>;
  locationId?: InputMaybe<Scalars['ID']['input']>;
  providerIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  roleId?: InputMaybe<Scalars['ID']['input']>;
  taskGroupIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};


export type RootMutationTypeCreateVitalsArgs = {
  input?: InputMaybe<VitalsInput>;
};


export type RootMutationTypeCreateVoiceCallLogArgs = {
  input: CallLogInput;
  voiceCallId: Scalars['ID']['input'];
};


export type RootMutationTypeCreditMemoPdfArgs = {
  id: Scalars['ID']['input'];
};


export type RootMutationTypeDeclineCubexDiagnosticArgs = {
  id: Scalars['ID']['input'];
};


export type RootMutationTypeDeclineCubexEncounterProductArgs = {
  id: Scalars['ID']['input'];
};


export type RootMutationTypeDeclineCubexImmunizationArgs = {
  id: Scalars['ID']['input'];
};


export type RootMutationTypeDeclineCubexMedicationArgs = {
  id: Scalars['ID']['input'];
};


export type RootMutationTypeDeclineCubexTreatmentArgs = {
  id: Scalars['ID']['input'];
};


export type RootMutationTypeDeclinePackageArgs = {
  declined: Scalars['Boolean']['input'];
  id: Scalars['ID']['input'];
};


export type RootMutationTypeDeleteAddressArgs = {
  id: Scalars['ID']['input'];
};


export type RootMutationTypeDeleteAlertArgs = {
  id: Scalars['ID']['input'];
};


export type RootMutationTypeDeleteAllergyArgs = {
  id: Scalars['ID']['input'];
};


export type RootMutationTypeDeleteApiKeyArgs = {
  id: Scalars['ID']['input'];
};


export type RootMutationTypeDeleteAppliedCouponArgs = {
  couponId: Scalars['ID']['input'];
  orderId?: InputMaybe<Scalars['ID']['input']>;
};


export type RootMutationTypeDeleteAppliedEstimateCouponArgs = {
  couponId: Scalars['ID']['input'];
  estimateId?: InputMaybe<Scalars['ID']['input']>;
};


export type RootMutationTypeDeleteAppointmentArgs = {
  id: Scalars['ID']['input'];
  recurrenceDeleteScope?: InputMaybe<RecurrenceDeleteScope>;
};


export type RootMutationTypeDeleteAppointmentReasonCategoryArgs = {
  id: Scalars['ID']['input'];
};


export type RootMutationTypeDeleteAppointmentReminderArgs = {
  id: Scalars['ID']['input'];
};


export type RootMutationTypeDeleteAppointmentTypeArgs = {
  id: Scalars['ID']['input'];
};


export type RootMutationTypeDeleteAppointmentTypeTagArgs = {
  id: Scalars['ID']['input'];
};


export type RootMutationTypeDeleteAutoMessageArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type RootMutationTypeDeleteBillingGroupArgs = {
  id: Scalars['ID']['input'];
};


export type RootMutationTypeDeleteBoardCellArgs = {
  id: Scalars['ID']['input'];
};


export type RootMutationTypeDeleteBoardingBlockArgs = {
  id: Scalars['ID']['input'];
};


export type RootMutationTypeDeleteBoardingCageArgs = {
  id: Scalars['ID']['input'];
};


export type RootMutationTypeDeleteBoardingWardArgs = {
  id: Scalars['ID']['input'];
};


export type RootMutationTypeDeleteCadenceArgs = {
  id: Scalars['ID']['input'];
};


export type RootMutationTypeDeleteCageArgs = {
  id: Scalars['ID']['input'];
};


export type RootMutationTypeDeleteCallLogArgs = {
  id: Scalars['ID']['input'];
};


export type RootMutationTypeDeleteClientConsentArgs = {
  id: Scalars['ID']['input'];
};


export type RootMutationTypeDeleteClientRdvmArgs = {
  id: Scalars['ID']['input'];
};


export type RootMutationTypeDeleteClientReferralSourceArgs = {
  id: Scalars['ID']['input'];
};


export type RootMutationTypeDeleteClientTagArgs = {
  id: Scalars['ID']['input'];
};


export type RootMutationTypeDeleteComplicationArgs = {
  id: Scalars['ID']['input'];
};


export type RootMutationTypeDeleteConsentFormArgs = {
  id: Scalars['ID']['input'];
};


export type RootMutationTypeDeleteCoownerArgs = {
  id: Scalars['ID']['input'];
};


export type RootMutationTypeDeleteCouponArgs = {
  id: Scalars['ID']['input'];
};


export type RootMutationTypeDeleteCustomAppointmentFieldArgs = {
  id: Scalars['ID']['input'];
};


export type RootMutationTypeDeleteCustomAppointmentFieldValueArgs = {
  id: Scalars['ID']['input'];
};


export type RootMutationTypeDeleteCustomClientFieldArgs = {
  id: Scalars['ID']['input'];
};


export type RootMutationTypeDeleteCustomClientFieldValueArgs = {
  id: Scalars['ID']['input'];
};


export type RootMutationTypeDeleteCustomLocationAttributeArgs = {
  id: Scalars['ID']['input'];
};


export type RootMutationTypeDeleteCustomLocationProviderScheduleArgs = {
  id: Scalars['ID']['input'];
};


export type RootMutationTypeDeleteCustomPatientFieldArgs = {
  id: Scalars['ID']['input'];
};


export type RootMutationTypeDeleteCustomPatientFieldValueArgs = {
  id: Scalars['ID']['input'];
};


export type RootMutationTypeDeleteDepartmentArgs = {
  id: Scalars['ID']['input'];
};


export type RootMutationTypeDeleteDiagnosticArgs = {
  id: Scalars['ID']['input'];
};


export type RootMutationTypeDeleteEncounterArgs = {
  id: Scalars['ID']['input'];
};


export type RootMutationTypeDeleteEncounterProductArgs = {
  id: Scalars['ID']['input'];
};


export type RootMutationTypeDeleteEncounterSectionArgs = {
  encounterId: Scalars['ID']['input'];
  sectionIdx: Scalars['Int']['input'];
};


export type RootMutationTypeDeleteEncounterSectionDatumArgs = {
  datumIdx: Scalars['Int']['input'];
  encounterId: Scalars['ID']['input'];
  sectionIdx: Scalars['Int']['input'];
  sessionId?: InputMaybe<Scalars['String']['input']>;
};


export type RootMutationTypeDeleteEncounterTypeArgs = {
  id: Scalars['ID']['input'];
};


export type RootMutationTypeDeleteEncounterTypeSectionOverridesArgs = {
  encounterTypeId: Scalars['ID']['input'];
};


export type RootMutationTypeDeleteEntitiesTagArgs = {
  entityId: Scalars['ID']['input'];
  entityTagId: Scalars['ID']['input'];
};


export type RootMutationTypeDeleteEntityTagArgs = {
  id: Scalars['ID']['input'];
};


export type RootMutationTypeDeleteEntityTagGroupArgs = {
  id: Scalars['ID']['input'];
};


export type RootMutationTypeDeleteEntityValidationArgs = {
  id: Scalars['ID']['input'];
};


export type RootMutationTypeDeleteEstimateArgs = {
  id: Scalars['ID']['input'];
};


export type RootMutationTypeDeleteEstimateItemArgs = {
  id: Scalars['ID']['input'];
};


export type RootMutationTypeDeleteFieldServiceAddressArgs = {
  id: Scalars['ID']['input'];
  newDefaultId?: InputMaybe<Scalars['ID']['input']>;
};


export type RootMutationTypeDeleteFulfillmentSourceArgs = {
  id: Scalars['ID']['input'];
};


export type RootMutationTypeDeleteImmunizationArgs = {
  id: Scalars['ID']['input'];
};


export type RootMutationTypeDeleteImportedDataArgs = {
  entity: Scalars['String']['input'];
  force?: InputMaybe<Scalars['Boolean']['input']>;
  includeAttachments?: InputMaybe<Scalars['Boolean']['input']>;
  locationId: Scalars['ID']['input'];
  token: Scalars['String']['input'];
};


export type RootMutationTypeDeleteLabImageArgs = {
  imageId: Scalars['String']['input'];
  labResultId: Scalars['ID']['input'];
};


export type RootMutationTypeDeleteLabModifierArgs = {
  id: Scalars['ID']['input'];
};


export type RootMutationTypeDeleteLabOrderArgs = {
  id: Scalars['ID']['input'];
};


export type RootMutationTypeDeleteLabResultArgs = {
  id: Scalars['ID']['input'];
};


export type RootMutationTypeDeleteLicenseArgs = {
  id: Scalars['ID']['input'];
};


export type RootMutationTypeDeleteLinkedClinicalNoteArgs = {
  clinicalNoteId: Scalars['ID']['input'];
  encounterId: Scalars['ID']['input'];
};


export type RootMutationTypeDeleteLinkedEncounterArgs = {
  encounterId: Scalars['ID']['input'];
  linkedEncounterId: Scalars['ID']['input'];
};


export type RootMutationTypeDeleteLinkedProductArgs = {
  linkedProductId: Scalars['ID']['input'];
  productId: Scalars['ID']['input'];
};


export type RootMutationTypeDeleteLocationArgs = {
  id: Scalars['ID']['input'];
};


export type RootMutationTypeDeleteLocationProviderScheduleArgs = {
  id: Scalars['ID']['input'];
};


export type RootMutationTypeDeleteLocationScheduleArgs = {
  id: Scalars['ID']['input'];
};


export type RootMutationTypeDeleteLocationTagArgs = {
  id: Scalars['ID']['input'];
};


export type RootMutationTypeDeleteMacroArgs = {
  id: Scalars['ID']['input'];
};


export type RootMutationTypeDeleteMedicationArgs = {
  id: Scalars['ID']['input'];
};


export type RootMutationTypeDeleteMessageArgs = {
  id: Scalars['ID']['input'];
};


export type RootMutationTypeDeleteNotificationArgs = {
  id: Scalars['ID']['input'];
};


export type RootMutationTypeDeleteOrderArgs = {
  id: Scalars['ID']['input'];
};


export type RootMutationTypeDeleteOrderFlagArgs = {
  id: Scalars['ID']['input'];
};


export type RootMutationTypeDeleteOrderItemArgs = {
  id: Scalars['ID']['input'];
};


export type RootMutationTypeDeleteOrgDepartmentArgs = {
  destinationOrgDepartmentId?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
};


export type RootMutationTypeDeleteOrgLabArgs = {
  id: Scalars['ID']['input'];
};


export type RootMutationTypeDeleteOrphanTransactionArgs = {
  id: Scalars['ID']['input'];
  locationId: Scalars['ID']['input'];
};


export type RootMutationTypeDeletePackagePackageArgs = {
  includedPackageId: Scalars['ID']['input'];
  packageId: Scalars['ID']['input'];
};


export type RootMutationTypeDeletePatientComplicationArgs = {
  id: Scalars['ID']['input'];
};


export type RootMutationTypeDeletePatientDiagnosisArgs = {
  id: Scalars['ID']['input'];
};


export type RootMutationTypeDeletePatientDocumentArgs = {
  id: Scalars['ID']['input'];
};


export type RootMutationTypeDeletePatientTagArgs = {
  id: Scalars['ID']['input'];
};


export type RootMutationTypeDeletePriceChangeArgs = {
  id: Scalars['ID']['input'];
};


export type RootMutationTypeDeleteProblemArgs = {
  id: Scalars['ID']['input'];
};


export type RootMutationTypeDeleteProductArgs = {
  id: Scalars['ID']['input'];
};


export type RootMutationTypeDeleteProductCategoryArgs = {
  id: Scalars['ID']['input'];
};


export type RootMutationTypeDeleteProductManufacturerArgs = {
  id: Scalars['ID']['input'];
};


export type RootMutationTypeDeleteProductPackageArgs = {
  id: Scalars['ID']['input'];
};


export type RootMutationTypeDeleteProductPackageItemArgs = {
  id: Scalars['ID']['input'];
};


export type RootMutationTypeDeleteProductPriceArgs = {
  id: Scalars['ID']['input'];
};


export type RootMutationTypeDeleteProductTypeArgs = {
  id: Scalars['ID']['input'];
};


export type RootMutationTypeDeleteProtocolArgs = {
  id: Scalars['ID']['input'];
};


export type RootMutationTypeDeleteProviderPunchArgs = {
  id: Scalars['ID']['input'];
};


export type RootMutationTypeDeleteProviderRoleArgs = {
  id: Scalars['ID']['input'];
};


export type RootMutationTypeDeletePurchaseOrderArgs = {
  id: Scalars['ID']['input'];
};


export type RootMutationTypeDeletePurchaseOrderItemArgs = {
  id: Scalars['ID']['input'];
};


export type RootMutationTypeDeleteRdvmArgs = {
  id: Scalars['ID']['input'];
};


export type RootMutationTypeDeleteRdvmDocumentArgs = {
  id: Scalars['ID']['input'];
};


export type RootMutationTypeDeleteRdvmVisitArgs = {
  id: Scalars['ID']['input'];
};


export type RootMutationTypeDeleteRelationshipArgs = {
  destinationRelationshipId?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
};


export type RootMutationTypeDeleteReminderArgs = {
  id: Scalars['ID']['input'];
};


export type RootMutationTypeDeleteReservationArgs = {
  id: Scalars['ID']['input'];
};


export type RootMutationTypeDeleteRevenueCenterArgs = {
  id: Scalars['ID']['input'];
};


export type RootMutationTypeDeleteScheduleTemplateArgs = {
  id: Scalars['ID']['input'];
};


export type RootMutationTypeDeleteStockTransferArgs = {
  id: Scalars['ID']['input'];
};


export type RootMutationTypeDeleteStockTransferFulfillmentItemArgs = {
  id: Scalars['ID']['input'];
};


export type RootMutationTypeDeleteStockTransferItemArgs = {
  id: Scalars['ID']['input'];
};


export type RootMutationTypeDeleteStockTransferReportRecipientArgs = {
  id: Scalars['ID']['input'];
};


export type RootMutationTypeDeleteStockTransferRequestArgs = {
  id: Scalars['ID']['input'];
};


export type RootMutationTypeDeleteStockTransferRequestItemArgs = {
  id: Scalars['ID']['input'];
};


export type RootMutationTypeDeleteStockTransferTemplateArgs = {
  id: Scalars['ID']['input'];
};


export type RootMutationTypeDeleteStockTransferTemplateItemArgs = {
  id: Scalars['ID']['input'];
};


export type RootMutationTypeDeleteTaskCategoryArgs = {
  id: Scalars['ID']['input'];
};


export type RootMutationTypeDeleteTaskGroupArgs = {
  id: Scalars['ID']['input'];
};


export type RootMutationTypeDeleteTravelZoneArgs = {
  id: Scalars['ID']['input'];
};


export type RootMutationTypeDeleteTreatmentArgs = {
  id: Scalars['ID']['input'];
};


export type RootMutationTypeDeleteTreatmentSheetArgs = {
  id: Scalars['ID']['input'];
};


export type RootMutationTypeDeleteTreatmentSheetRowArgs = {
  id: Scalars['ID']['input'];
};


export type RootMutationTypeDeleteTreatmentSheetRowAdditiveEntryArgs = {
  id: Scalars['ID']['input'];
};


export type RootMutationTypeDeleteTreatmentSheetTemplateArgs = {
  id: Scalars['ID']['input'];
};


export type RootMutationTypeDeleteTriggerArgs = {
  id: Scalars['ID']['input'];
};


export type RootMutationTypeDeleteVitalsArgs = {
  id: Scalars['ID']['input'];
};


export type RootMutationTypeDisableCreditReasonArgs = {
  id: Scalars['ID']['input'];
};


export type RootMutationTypeDisableDeclineReasonArgs = {
  id: Scalars['ID']['input'];
};


export type RootMutationTypeDisableDiscountReasonArgs = {
  id: Scalars['ID']['input'];
};


export type RootMutationTypeDisableInvoiceLineItemReasonArgs = {
  id: Scalars['ID']['input'];
};


export type RootMutationTypeDisablePaymentReasonArgs = {
  id: Scalars['ID']['input'];
};


export type RootMutationTypeDismissVoiceCallsArgs = {
  locationId: Scalars['ID']['input'];
};


export type RootMutationTypeDownloadBillingGroupStatementsArgs = {
  billingGroupId: Scalars['ID']['input'];
  endDate?: InputMaybe<Scalars['Date']['input']>;
  locationId: Scalars['ID']['input'];
  startDate?: InputMaybe<Scalars['Date']['input']>;
};


export type RootMutationTypeDownloadProtocolsMigrationCsvArgs = {
  emails?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  locationId: Scalars['ID']['input'];
};


export type RootMutationTypeDownloadUsageReportArgs = {
  breakdownByProvider?: InputMaybe<Scalars['Boolean']['input']>;
  categoryIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  endDate: Scalars['Date']['input'];
  locationIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  packageIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  productIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  startDate: Scalars['Date']['input'];
  typeIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};


export type RootMutationTypeEditPatientRdvmArgs = {
  id: Scalars['ID']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  preferred?: InputMaybe<Scalars['Boolean']['input']>;
  rdvmId: Scalars['ID']['input'];
  referringDoctors?: InputMaybe<Scalars['String']['input']>;
};


export type RootMutationTypeEmailBillingGroupStatementsArgs = {
  billingGroupIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  emailAll?: InputMaybe<Scalars['Boolean']['input']>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
  locationId: Scalars['ID']['input'];
  startDate?: InputMaybe<Scalars['Date']['input']>;
};


export type RootMutationTypeEmailBillingStatementsArgs = {
  clientId?: InputMaybe<Scalars['ID']['input']>;
  emails?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
  locationId: Scalars['ID']['input'];
  startDate?: InputMaybe<Scalars['Date']['input']>;
};


export type RootMutationTypeEmailClientBillingStatementArgs = {
  clientId: Scalars['ID']['input'];
  locationId: Scalars['ID']['input'];
};


export type RootMutationTypeEmailClientPaymentReceiptArgs = {
  paymentId: Scalars['ID']['input'];
};


export type RootMutationTypeEmailClientsAddressesArgs = {
  insertedAtEnd?: InputMaybe<Scalars['NaiveDateTime']['input']>;
  insertedAtStart?: InputMaybe<Scalars['NaiveDateTime']['input']>;
  locationIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};


export type RootMutationTypeEmailCreditMemoToClientArgs = {
  creditMemoId: Scalars['ID']['input'];
};


export type RootMutationTypeEmailEncounterArgs = {
  attachmentIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  body?: InputMaybe<Scalars['String']['input']>;
  documentType?: InputMaybe<EncounterSummaryDocumentType>;
  encounterId: Scalars['ID']['input'];
  extras?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  onlySections?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  recipientEmails?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type?: InputMaybe<Scalars['String']['input']>;
  unnamedSectionIdxs?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};


export type RootMutationTypeEmailEncounterPdfArgs = {
  encounterId: Scalars['ID']['input'];
  type?: InputMaybe<EncounterPdfType>;
};


export type RootMutationTypeEmailEncounterRecordArgs = {
  encounterId: Scalars['ID']['input'];
  only?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  patientId: Scalars['ID']['input'];
};


export type RootMutationTypeEmailEncounterRecordToCustomArgs = {
  email: Scalars['String']['input'];
  encounterId: Scalars['ID']['input'];
  only?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  patientId: Scalars['ID']['input'];
};


export type RootMutationTypeEmailEncounterRecordToRdvmsArgs = {
  encounterId: Scalars['ID']['input'];
  patientId: Scalars['ID']['input'];
};


export type RootMutationTypeEmailEstimateToClientArgs = {
  estimateId: Scalars['ID']['input'];
};


export type RootMutationTypeEmailFilteredProductsArgs = {
  categoryIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  code?: InputMaybe<Scalars['String']['input']>;
  diagnosticCode?: InputMaybe<Scalars['String']['input']>;
  diagnosticCodeOrgLabType?: InputMaybe<OrgLabType>;
  excludeChildren?: InputMaybe<Scalars['Boolean']['input']>;
  hasDiagnosticCode?: InputMaybe<Scalars['Boolean']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  isControlledDrug?: InputMaybe<Scalars['Boolean']['input']>;
  isNonCompensated?: InputMaybe<Scalars['Boolean']['input']>;
  locationId: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  onlyBelowThreshold?: InputMaybe<Scalars['ID']['input']>;
  onlyEnabledAt?: InputMaybe<Scalars['ID']['input']>;
  onlyTrackInventory?: InputMaybe<Scalars['Boolean']['input']>;
  partialProductId?: InputMaybe<Scalars['String']['input']>;
  recipients: Array<InputMaybe<Scalars['String']['input']>>;
  revenueCenterIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  sku?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<SortProductOptions>;
  typeIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  updatedAtEnd?: InputMaybe<Scalars['NaiveDateTime']['input']>;
  updatedAtStart?: InputMaybe<Scalars['NaiveDateTime']['input']>;
};


export type RootMutationTypeEmailHospitalizationNoticeToRdvmsArgs = {
  encounterId: Scalars['ID']['input'];
  patientId: Scalars['ID']['input'];
};


export type RootMutationTypeEmailImmunizationsRecordArgs = {
  emails?: InputMaybe<Array<Scalars['String']['input']>>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  isLatest?: InputMaybe<Scalars['Boolean']['input']>;
  locationId?: InputMaybe<Scalars['ID']['input']>;
  patientId: Scalars['ID']['input'];
};


export type RootMutationTypeEmailInventoryCsvArgs = {
  locationId: Scalars['ID']['input'];
  recipients: Array<InputMaybe<Scalars['String']['input']>>;
};


export type RootMutationTypeEmailInvoiceToClientArgs = {
  coownerClientId?: InputMaybe<Scalars['ID']['input']>;
  invoiceId: Scalars['ID']['input'];
};


export type RootMutationTypeEmailLabResultArgs = {
  body?: InputMaybe<Scalars['String']['input']>;
  emails?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  labResultId: Scalars['ID']['input'];
  subject?: InputMaybe<Scalars['String']['input']>;
};


export type RootMutationTypeEmailMedicalRecordsSummaryArgs = {
  body?: InputMaybe<Scalars['String']['input']>;
  emailTo: Scalars['String']['input'];
  end?: InputMaybe<Scalars['NaiveDateTime']['input']>;
  includeCommunications?: InputMaybe<Scalars['Boolean']['input']>;
  includeDocuments?: InputMaybe<Scalars['Boolean']['input']>;
  includeExams?: InputMaybe<Scalars['Boolean']['input']>;
  includeImmunizations?: InputMaybe<Scalars['Boolean']['input']>;
  includeLabResults?: InputMaybe<Scalars['Boolean']['input']>;
  includeMedications?: InputMaybe<Scalars['Boolean']['input']>;
  includeNotes?: InputMaybe<Scalars['Boolean']['input']>;
  includePrivate?: InputMaybe<Scalars['Boolean']['input']>;
  includeTasks?: InputMaybe<Scalars['Boolean']['input']>;
  includeTreatmentSheets?: InputMaybe<Scalars['Boolean']['input']>;
  isShareMode?: InputMaybe<Scalars['Boolean']['input']>;
  locationId?: InputMaybe<Scalars['ID']['input']>;
  onlyIncludeItems?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  onlySigned?: InputMaybe<Scalars['Boolean']['input']>;
  patientId: Scalars['ID']['input'];
  selectedItems?: InputMaybe<SelectedItemsInput>;
  start?: InputMaybe<Scalars['NaiveDateTime']['input']>;
  subject?: InputMaybe<Scalars['String']['input']>;
  visitId?: InputMaybe<Scalars['ID']['input']>;
};


export type RootMutationTypeEmailPatientCompliancesReportArgs = {
  end?: InputMaybe<Scalars['DateTime']['input']>;
  locationIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  patientId?: InputMaybe<Scalars['ID']['input']>;
  patientName?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  protocolName?: InputMaybe<Scalars['String']['input']>;
  recipients: Array<InputMaybe<Scalars['String']['input']>>;
  showOldReminders?: InputMaybe<Scalars['Boolean']['input']>;
  showSilenced?: InputMaybe<Scalars['Boolean']['input']>;
  start?: InputMaybe<Scalars['DateTime']['input']>;
};


export type RootMutationTypeEmailProductsCsvArgs = {
  locationIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  recipients: Array<InputMaybe<Scalars['String']['input']>>;
};


export type RootMutationTypeEmailRabiesCertificateArgs = {
  ignoreHistorical?: InputMaybe<Scalars['Boolean']['input']>;
  locationId?: InputMaybe<Scalars['ID']['input']>;
  patientId: Scalars['ID']['input'];
};


export type RootMutationTypeEmailRdvmsCsvArgs = {
  includeLocationsUnassigned?: InputMaybe<Scalars['Boolean']['input']>;
  locationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  recipients: Array<InputMaybe<Scalars['String']['input']>>;
};


export type RootMutationTypeEmailRemindersCsvArgs = {
  recipients: Array<InputMaybe<Scalars['String']['input']>>;
};


export type RootMutationTypeEmailSelectedRabiesCertificatesArgs = {
  emails?: InputMaybe<Array<Scalars['String']['input']>>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  locationId?: InputMaybe<Scalars['ID']['input']>;
  patientId: Scalars['ID']['input'];
};


export type RootMutationTypeEmailTreatmentSheetSummaryArgs = {
  emailBody?: InputMaybe<Scalars['String']['input']>;
  emailTo?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  includeIncompleteTreatments?: InputMaybe<Scalars['Boolean']['input']>;
  locationId?: InputMaybe<Scalars['ID']['input']>;
  treatmentSheetId: Scalars['ID']['input'];
};


export type RootMutationTypeEmailUsageReportArgs = {
  breakdownByProvider?: InputMaybe<Scalars['Boolean']['input']>;
  categoryIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  emails: Array<InputMaybe<Scalars['String']['input']>>;
  endDate: Scalars['Date']['input'];
  locationIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  packageIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  productIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  startDate: Scalars['Date']['input'];
  typeIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};


export type RootMutationTypeEncounterPdfArgs = {
  encounterId: Scalars['ID']['input'];
  type?: InputMaybe<EncounterPdfType>;
};


export type RootMutationTypeEndOfDayReportArgs = {
  end?: InputMaybe<Scalars['DateTime']['input']>;
  locationId: Scalars['ID']['input'];
  start: Scalars['DateTime']['input'];
};


export type RootMutationTypeEndVideoCallArgs = {
  appointmentId: Scalars['ID']['input'];
};


export type RootMutationTypeEndVisitArgs = {
  stop?: InputMaybe<Scalars['NaiveDateTime']['input']>;
  visitId: Scalars['ID']['input'];
};


export type RootMutationTypeEnrollPlanArgs = {
  autoRenew?: InputMaybe<Scalars['Boolean']['input']>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
  hsn: Scalars['String']['input'];
  locationId: Scalars['ID']['input'];
  options?: InputMaybe<Array<InputMaybe<PlanOptionInput>>>;
  patientId: Scalars['ID']['input'];
  planId: Scalars['ID']['input'];
  planInterval: PlanInterval;
  renewPlanId?: InputMaybe<Scalars['ID']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
};


export type RootMutationTypeFetchVetrocketImagesArgs = {
  id: Scalars['ID']['input'];
};


export type RootMutationTypeFileDownloadLinkArgs = {
  path: Scalars['String']['input'];
};


export type RootMutationTypeFinishLabOrderArgs = {
  orderId: Scalars['ID']['input'];
};


export type RootMutationTypeGenVetsourceUrlArgs = {
  locationId?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  patientId?: InputMaybe<Scalars['ID']['input']>;
};


export type RootMutationTypeGenerateAgedArReportArgs = {
  asAt: Scalars['Date']['input'];
  breakdown: ArBreakdown;
  locationIds: Array<Scalars['ID']['input']>;
};


export type RootMutationTypeGenerateClientAuthTokenArgs = {
  clientId: Scalars['ID']['input'];
};


export type RootMutationTypeGenerateInventoryReportArgs = {
  categoryIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  code?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  excludeChildren?: InputMaybe<Scalars['Boolean']['input']>;
  locationId?: InputMaybe<Scalars['ID']['input']>;
  minimumThreshold?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  onlyBelowThreshold?: InputMaybe<Scalars['ID']['input']>;
  onlyTrackInventory?: InputMaybe<Scalars['Boolean']['input']>;
  partialProductId?: InputMaybe<Scalars['String']['input']>;
  realUnitCost?: InputMaybe<Scalars['Decimal']['input']>;
  scheduledDrugTypes?: InputMaybe<Array<InputMaybe<ScheduledDrugType>>>;
  sortBy?: InputMaybe<SortProductOptions>;
  sortDirection?: InputMaybe<Scalars['String']['input']>;
  sortField?: InputMaybe<Scalars['String']['input']>;
  typeIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  unitCost?: InputMaybe<Scalars['Decimal']['input']>;
};


export type RootMutationTypeGenerateInvoiceArgs = {
  id: Scalars['ID']['input'];
};


export type RootMutationTypeGenerateLabTrendsArgs = {
  analytes: Array<Scalars['String']['input']>;
  locationId: Scalars['ID']['input'];
  patientId: Scalars['ID']['input'];
};


export type RootMutationTypeGeneratePlumbsPdfUrlArgs = {
  id: Scalars['String']['input'];
};


export type RootMutationTypeGenerateUsageSummaryReportArgs = {
  categoryIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  code?: InputMaybe<Scalars['String']['input']>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  email?: InputMaybe<Scalars['String']['input']>;
  insertedAtEnd?: InputMaybe<Scalars['NaiveDateTime']['input']>;
  insertedAtStart?: InputMaybe<Scalars['NaiveDateTime']['input']>;
  locationId?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  onlyEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  partialProductId?: InputMaybe<Scalars['ID']['input']>;
  typeIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};


export type RootMutationTypeGenerateVetcalculatorIframeUrlArgs = {
  locationId: Scalars['ID']['input'];
};


export type RootMutationTypeGroupOrderItemsByPatientArgs = {
  orderId: Scalars['ID']['input'];
};


export type RootMutationTypeImportFromDocumentArgs = {
  input: ImportFromDocumentInput;
};


export type RootMutationTypeInitiateCareCreditPrefillArgs = {
  amount?: InputMaybe<Scalars['Decimal']['input']>;
  entityId: Scalars['ID']['input'];
  entityType: CareCreditEntityType;
  event: CareCreditEventType;
  landingPage?: InputMaybe<CareCreditLandingPageType>;
  locationId: Scalars['ID']['input'];
};


export type RootMutationTypeInitiateCareCreditPrefillRefundArgs = {
  amount: Scalars['Decimal']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  paymentId: Scalars['ID']['input'];
};


export type RootMutationTypeInsertNewTemplateArgs = {
  encounterId: Scalars['ID']['input'];
  encounterTypeId: Scalars['ID']['input'];
  sectionIdx: Scalars['Int']['input'];
};


export type RootMutationTypeInvoiceBarcodesPdfArgs = {
  orderId: Scalars['ID']['input'];
};


export type RootMutationTypeInvoiceBoardRowArgs = {
  boardRowId: Scalars['ID']['input'];
};


export type RootMutationTypeIssueCreditDiscountArgs = {
  discountAmount: Scalars['Decimal']['input'];
  discountType: DiscountType;
  note?: InputMaybe<Scalars['String']['input']>;
  orderId: Scalars['ID']['input'];
};


export type RootMutationTypeLinkAppointmentsArgs = {
  appointmentIds: Array<Scalars['ID']['input']>;
  groupId?: InputMaybe<Scalars['ID']['input']>;
};


export type RootMutationTypeLinkCallArgs = {
  callLogId: Scalars['ID']['input'];
  clientId?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
  patientId?: InputMaybe<Scalars['ID']['input']>;
};


export type RootMutationTypeLinkOrphanLabResultToPatientArgs = {
  id: Scalars['ID']['input'];
  patientId: Scalars['ID']['input'];
};


export type RootMutationTypeLinkPatientPlanChargeToOrderItemArgs = {
  orderItemId: Scalars['ID']['input'];
  patientPlanChargeId: Scalars['ID']['input'];
};


export type RootMutationTypeMakeAppointmentTypeDefaultArgs = {
  id: Scalars['ID']['input'];
};


export type RootMutationTypeMarkAllNormalEncounterArgs = {
  encounterId: Scalars['ID']['input'];
  sectionName: Scalars['String']['input'];
  value?: InputMaybe<Scalars['String']['input']>;
};


export type RootMutationTypeMarkCubexDiagnosticAsPendingApprovalArgs = {
  id: Scalars['ID']['input'];
};


export type RootMutationTypeMarkCubexEncounterProductAsPendingApprovalArgs = {
  id: Scalars['ID']['input'];
};


export type RootMutationTypeMarkCubexImmunizationAsPendingApprovalArgs = {
  id: Scalars['ID']['input'];
};


export type RootMutationTypeMarkCubexMedicationAsPendingApprovalArgs = {
  id: Scalars['ID']['input'];
};


export type RootMutationTypeMarkCubexTreatmentAsPendingApprovalArgs = {
  id: Scalars['ID']['input'];
};


export type RootMutationTypeMarkOrderPaidIfFullyPaidArgs = {
  id: Scalars['ID']['input'];
};


export type RootMutationTypeMarkOrderUncollectibleArgs = {
  orderId: Scalars['ID']['input'];
};


export type RootMutationTypeMarkPaymentAsRefundedArgs = {
  paymentId: Scalars['ID']['input'];
};


export type RootMutationTypeMarkPostcardProtocolReminderAsSentArgs = {
  protocolReminderId: Scalars['ID']['input'];
};


export type RootMutationTypeMarkVisitReadyForDischargeArgs = {
  readyForDischarge?: InputMaybe<Scalars['Boolean']['input']>;
  visitId: Scalars['ID']['input'];
};


export type RootMutationTypeMassMicrochipRegisterArgs = {
  patientRegistrations?: InputMaybe<Array<InputMaybe<PatientRegistration>>>;
};


export type RootMutationTypeMergeClientReferralSourcesArgs = {
  fromId: Scalars['ID']['input'];
  toId: Scalars['ID']['input'];
};


export type RootMutationTypeMergeClientsArgs = {
  fromId: Scalars['ID']['input'];
  toId: Scalars['ID']['input'];
};


export type RootMutationTypeMergeNovaTemplateRowsArgs = {
  input: NovaSheetMergeInput;
  sheetId: Scalars['ID']['input'];
};


export type RootMutationTypeMergePatientsArgs = {
  fromPatientId: Scalars['ID']['input'];
  toPatientId: Scalars['ID']['input'];
};


export type RootMutationTypeMergeRdvmsArgs = {
  fromId: Scalars['ID']['input'];
  toId: Scalars['ID']['input'];
};


export type RootMutationTypeMovePatientToClientArgs = {
  clientId: Scalars['ID']['input'];
  patientId: Scalars['ID']['input'];
};


export type RootMutationTypeNewEncounterArgs = {
  input?: InputMaybe<EncounterInput>;
  patientId: Scalars['ID']['input'];
  typeId?: InputMaybe<Scalars['ID']['input']>;
};


export type RootMutationTypeNewVendorArgs = {
  input: VendorInput;
};


export type RootMutationTypeOnboardPetdxLabArgs = {
  id: Scalars['ID']['input'];
};


export type RootMutationTypeOrderLabArgs = {
  collectionDateTimes?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  comment?: InputMaybe<Scalars['String']['input']>;
  drawTime?: InputMaybe<Scalars['Int']['input']>;
  encounterId?: InputMaybe<Scalars['ID']['input']>;
  extraFields?: InputMaybe<Array<ExtraFieldInput>>;
  history?: InputMaybe<Scalars['String']['input']>;
  historyOfCancer?: InputMaybe<Scalars['Boolean']['input']>;
  modality?: InputMaybe<Scalars['String']['input']>;
  orgLabId: Scalars['ID']['input'];
  patientId: Scalars['ID']['input'];
  productIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  productSuggestionId?: InputMaybe<Scalars['ID']['input']>;
  providerId?: InputMaybe<Scalars['ID']['input']>;
  scannedCodes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  scheduleDateTime?: InputMaybe<Scalars['DateTime']['input']>;
  serialNumber?: InputMaybe<Scalars['String']['input']>;
  specimenReceivedDateTimes?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  stat?: InputMaybe<Scalars['Boolean']['input']>;
  suspicious?: InputMaybe<Scalars['Boolean']['input']>;
  symptoms?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  testHistories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  testModifiers?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  testPriorities?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  testQuantities?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tests?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type?: InputMaybe<Scalars['String']['input']>;
  visitId?: InputMaybe<Scalars['ID']['input']>;
};


export type RootMutationTypePaymentReceiptPdfArgs = {
  paymentId: Scalars['ID']['input'];
};


export type RootMutationTypePerformDatasyncArgs = {
  entity?: InputMaybe<Scalars['String']['input']>;
  locationId: Scalars['ID']['input'];
  practiceId: Scalars['String']['input'];
};


export type RootMutationTypePrescribeMedicationArgs = {
  input: MedicationInput;
};


export type RootMutationTypePreviewPriceChangeArgs = {
  id: Scalars['ID']['input'];
};


export type RootMutationTypePrintLabelPrintnodeArgs = {
  clientId?: InputMaybe<Scalars['ID']['input']>;
  diagnosticId?: InputMaybe<Scalars['ID']['input']>;
  input?: InputMaybe<PrinterInput>;
  medicationId?: InputMaybe<Scalars['ID']['input']>;
  patientId?: InputMaybe<Scalars['ID']['input']>;
};


export type RootMutationTypePromoteEstimateToBoardArgs = {
  estimateId: Scalars['ID']['input'];
};


export type RootMutationTypePushDiagnosticToCubexArgs = {
  id: Scalars['ID']['input'];
  locationId?: InputMaybe<Scalars['ID']['input']>;
};


export type RootMutationTypePushEncounterProductToCubexArgs = {
  id: Scalars['ID']['input'];
  locationId?: InputMaybe<Scalars['ID']['input']>;
};


export type RootMutationTypePushImmunizationToCubexArgs = {
  id: Scalars['ID']['input'];
  locationId?: InputMaybe<Scalars['ID']['input']>;
};


export type RootMutationTypePushMedicationToCubexArgs = {
  id: Scalars['ID']['input'];
  locationId?: InputMaybe<Scalars['ID']['input']>;
};


export type RootMutationTypePushToCubexArgs = {
  locationId: Scalars['ID']['input'];
  patientId: Scalars['ID']['input'];
};


export type RootMutationTypePushTreatmentToCubexArgs = {
  id: Scalars['ID']['input'];
  locationId?: InputMaybe<Scalars['ID']['input']>;
};


export type RootMutationTypeReadNotificationArgs = {
  id: Scalars['ID']['input'];
};


export type RootMutationTypeReassignProductTypeArgs = {
  newProductTypeId?: InputMaybe<Scalars['ID']['input']>;
  productTypeId?: InputMaybe<Scalars['ID']['input']>;
};


export type RootMutationTypeRecordPatientWeightArgs = {
  datetime?: InputMaybe<Scalars['NaiveDateTime']['input']>;
  patientId: Scalars['ID']['input'];
  weight: Scalars['Decimal']['input'];
  weightUnit: WeightUnit;
};


export type RootMutationTypeRecordStripeSdkRefundArgs = {
  amount: Scalars['Decimal']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  paymentId: Scalars['ID']['input'];
  stripeRefundId: Scalars['String']['input'];
};


export type RootMutationTypeRefillAndSendToPharmacyArgs = {
  id: Scalars['ID']['input'];
  locationId?: InputMaybe<Scalars['ID']['input']>;
  lotNumber?: InputMaybe<Scalars['String']['input']>;
  prescriberId?: InputMaybe<Scalars['ID']['input']>;
  start?: InputMaybe<Scalars['Date']['input']>;
  stop?: InputMaybe<Scalars['Date']['input']>;
};


export type RootMutationTypeRefillMedicationArgs = {
  id: Scalars['ID']['input'];
  locationId?: InputMaybe<Scalars['ID']['input']>;
  lotNumber?: InputMaybe<Scalars['String']['input']>;
  prescriberId?: InputMaybe<Scalars['ID']['input']>;
  start?: InputMaybe<Scalars['Date']['input']>;
  stop?: InputMaybe<Scalars['Date']['input']>;
};


export type RootMutationTypeRefreshLabResultArgs = {
  id: Scalars['ID']['input'];
};


export type RootMutationTypeRefreshPreventionPlanArgs = {
  id: Scalars['ID']['input'];
};


export type RootMutationTypeRefundOrderItemArgs = {
  credit?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  notRendered?: InputMaybe<Scalars['Boolean']['input']>;
  returned?: InputMaybe<Scalars['Boolean']['input']>;
};


export type RootMutationTypeRefundPaymentArgs = {
  amount: Scalars['Decimal']['input'];
  noCharge?: InputMaybe<Scalars['Boolean']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  paymentId: Scalars['ID']['input'];
  readerId?: InputMaybe<Scalars['String']['input']>;
};


export type RootMutationTypeRegisterPatientMicrochipArgs = {
  locationId: Scalars['ID']['input'];
  patientId: Scalars['ID']['input'];
};


export type RootMutationTypeRemoveClientStripeInfoArgs = {
  id: Scalars['ID']['input'];
};


export type RootMutationTypeRemoveItemsFromVisitArgs = {
  items: Array<VisitItemInput>;
  visitId: Scalars['ID']['input'];
};


export type RootMutationTypeRemovePatientPlanItemArgs = {
  id: Scalars['ID']['input'];
};


export type RootMutationTypeRemovePatientRdvmArgs = {
  id: Scalars['ID']['input'];
  rdvmId: Scalars['ID']['input'];
};


export type RootMutationTypeRemoveReviewerFromLabResultArgs = {
  labResultId: Scalars['ID']['input'];
  providerId: Scalars['ID']['input'];
};


export type RootMutationTypeReopenEncounterArgs = {
  id: Scalars['ID']['input'];
};


export type RootMutationTypeReopenOrderArgs = {
  id: Scalars['ID']['input'];
};


export type RootMutationTypeReopenVisitArgs = {
  visitId: Scalars['ID']['input'];
};


export type RootMutationTypeReorderAlertsArgs = {
  fromId: Scalars['ID']['input'];
  toId: Scalars['ID']['input'];
};


export type RootMutationTypeReorderBoardingCagesArgs = {
  fromId: Scalars['ID']['input'];
  toId: Scalars['ID']['input'];
};


export type RootMutationTypeReorderBoardingWardsArgs = {
  fromId: Scalars['ID']['input'];
  toId: Scalars['ID']['input'];
};


export type RootMutationTypeReorderClientReferralSourcesArgs = {
  fromId: Scalars['ID']['input'];
  toId: Scalars['ID']['input'];
};


export type RootMutationTypeReorderEntityTagsArgs = {
  fromId: Scalars['ID']['input'];
  toId: Scalars['ID']['input'];
};


export type RootMutationTypeReorderEstimateItemsArgs = {
  fromId: Scalars['ID']['input'];
  toId: Scalars['ID']['input'];
};


export type RootMutationTypeReorderOrderItemsArgs = {
  fromId: Scalars['ID']['input'];
  toId: Scalars['ID']['input'];
};


export type RootMutationTypeReplaceEncounterSectionDatumArgs = {
  datum: Scalars['JSON']['input'];
  datumIdx: Scalars['Int']['input'];
  encounterId: Scalars['ID']['input'];
  sectionIdx: Scalars['Int']['input'];
  sessionId?: InputMaybe<Scalars['String']['input']>;
};


export type RootMutationTypeRequestMedicationApprovalArgs = {
  input: MedicationInput;
  medicationId: Scalars['ID']['input'];
};


export type RootMutationTypeRequestSourceDataDownloadUrlArgs = {
  entity: Scalars['String']['input'];
  locationId: Scalars['ID']['input'];
  practiceId: Scalars['String']['input'];
};


export type RootMutationTypeResendVerificationArgs = {
  id: Scalars['ID']['input'];
};


export type RootMutationTypeResetProviderPinArgs = {
  currentPassword: Scalars['String']['input'];
  pin: Scalars['String']['input'];
  pinConfirmation: Scalars['String']['input'];
};


export type RootMutationTypeRetryJobArgs = {
  id: Scalars['ID']['input'];
};


export type RootMutationTypeRetryLabOrderPlacementArgs = {
  id: Scalars['ID']['input'];
};


export type RootMutationTypeReturnOrderItemArgs = {
  creditReasonId?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
  quantity?: InputMaybe<Scalars['Decimal']['input']>;
  returnedToStock?: InputMaybe<Scalars['Boolean']['input']>;
};


export type RootMutationTypeReviewArReconciliationArgs = {
  id: Scalars['ID']['input'];
};


export type RootMutationTypeRunAdHocAutoMessageArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type RootMutationTypeRunArReconciliationArgs = {
  clientId: Scalars['ID']['input'];
};


export type RootMutationTypeSaveCensusLocationDetailLabelsArgs = {
  labels: Array<CensusLocationDetailLabelInput>;
  locationId: Scalars['ID']['input'];
};


export type RootMutationTypeSaveEstimateArgs = {
  id: Scalars['ID']['input'];
};


export type RootMutationTypeSaveMicrochipArgs = {
  patientId: Scalars['ID']['input'];
};


export type RootMutationTypeSavePdfExtractionRuleArgs = {
  input: PdfExtractionRuleInput;
};


export type RootMutationTypeSaveProviderElectronicSignatureArgs = {
  providerId: Scalars['ID']['input'];
  signature: Scalars['String']['input'];
};


export type RootMutationTypeSaveTreatmentSheetCellOrderItemArgs = {
  id: Scalars['ID']['input'];
  input?: InputMaybe<SaveTreatmentSheetCellOrderItemInput>;
};


export type RootMutationTypeSaveTreatmentSheetRowAdditiveEntryArgs = {
  additiveId?: InputMaybe<Scalars['ID']['input']>;
  input?: InputMaybe<TreatmentSheetRowAdditiveEntryInput>;
};


export type RootMutationTypeSendApptConfirmationArgs = {
  id: Scalars['ID']['input'];
};


export type RootMutationTypeSendCardConnectHostedPaymentRequestArgs = {
  amount?: InputMaybe<Scalars['Decimal']['input']>;
  clientId: Scalars['ID']['input'];
  locationId?: InputMaybe<Scalars['ID']['input']>;
  medium?: InputMaybe<Scalars['String']['input']>;
  orderId?: InputMaybe<Scalars['ID']['input']>;
  orderType?: InputMaybe<Scalars['String']['input']>;
};


export type RootMutationTypeSendCareCreditPaymentUrlArgs = {
  amount?: InputMaybe<Scalars['Decimal']['input']>;
  clientId: Scalars['ID']['input'];
  locationId?: InputMaybe<Scalars['ID']['input']>;
  medium?: InputMaybe<Scalars['String']['input']>;
  orderId?: InputMaybe<Scalars['ID']['input']>;
  orderType?: InputMaybe<Scalars['String']['input']>;
};


export type RootMutationTypeSendClientCheckinLinkArgs = {
  apptId: Scalars['ID']['input'];
  clientId?: InputMaybe<Scalars['ID']['input']>;
  locationId?: InputMaybe<Scalars['ID']['input']>;
  method?: InputMaybe<Scalars['String']['input']>;
};


export type RootMutationTypeSendEmailVerificationArgs = {
  clientId?: InputMaybe<Scalars['ID']['input']>;
  isBillingEmail?: InputMaybe<Scalars['Boolean']['input']>;
  isSecondaryEmail?: InputMaybe<Scalars['Boolean']['input']>;
};


export type RootMutationTypeSendEstimateConsentDepositLinkArgs = {
  consent: Scalars['String']['input'];
  estimateId: Scalars['ID']['input'];
  medium: ConversationMedium;
};


export type RootMutationTypeSendInvoiceToHfdArgs = {
  amountCents: Scalars['Int']['input'];
  applicant: HfdApplicantInput;
  orderId: Scalars['ID']['input'];
  programCode: Scalars['String']['input'];
};


export type RootMutationTypeSendLocationChatMessageArgs = {
  body?: InputMaybe<Scalars['String']['input']>;
  locationId: Scalars['ID']['input'];
};


export type RootMutationTypeSendMessageArgs = {
  attachments?: InputMaybe<Array<InputMaybe<Scalars['Upload']['input']>>>;
  body: Scalars['String']['input'];
  close?: InputMaybe<Scalars['Boolean']['input']>;
  conversationId: Scalars['ID']['input'];
  messageId?: InputMaybe<Scalars['ID']['input']>;
};


export type RootMutationTypeSendNewsletterArgs = {
  id: Scalars['ID']['input'];
};


export type RootMutationTypeSendNewsletterTestArgs = {
  id: Scalars['ID']['input'];
  to: Scalars['String']['input'];
};


export type RootMutationTypeSendPaymentRequestArgs = {
  amount?: InputMaybe<Scalars['Decimal']['input']>;
  clientId: Scalars['ID']['input'];
  donation?: InputMaybe<Scalars['Decimal']['input']>;
  locationId?: InputMaybe<Scalars['ID']['input']>;
  medium?: InputMaybe<ConversationMedium>;
  method?: InputMaybe<PaymentMethod>;
  orderId?: InputMaybe<Scalars['ID']['input']>;
  orderType?: InputMaybe<Scalars['String']['input']>;
  tip?: InputMaybe<Scalars['Decimal']['input']>;
};


export type RootMutationTypeSendReminderArgs = {
  reminderId: Scalars['ID']['input'];
};


export type RootMutationTypeSendSurveyLinkArgs = {
  encounterId: Scalars['ID']['input'];
};


export type RootMutationTypeSendTestEmailArgs = {
  emails?: InputMaybe<Array<Scalars['String']['input']>>;
  locationId: Scalars['ID']['input'];
  template: Scalars['String']['input'];
};


export type RootMutationTypeSetApptPickupTimeArgs = {
  id: Scalars['ID']['input'];
  pickupTime: Scalars['DateTime']['input'];
  text?: InputMaybe<Scalars['Boolean']['input']>;
};


export type RootMutationTypeSetCensusKennelAdditionalNotesArgs = {
  additionalNotes?: InputMaybe<Scalars['String']['input']>;
  kennelId: Scalars['ID']['input'];
  locationId: Scalars['ID']['input'];
};


export type RootMutationTypeSetCensusKennelLocationDetailArgs = {
  kennelId: Scalars['ID']['input'];
  locationDetailLabelId?: InputMaybe<Scalars['ID']['input']>;
  locationId: Scalars['ID']['input'];
};


export type RootMutationTypeSetCensusKennelPhysicalStatusArgs = {
  kennelId: Scalars['ID']['input'];
  locationId: Scalars['ID']['input'];
  status: CensusKennelStatus;
};


export type RootMutationTypeSetChatLastReadAtArgs = {
  locationId: Scalars['ID']['input'];
};


export type RootMutationTypeSetDaycareOpenArgs = {
  date: Scalars['Date']['input'];
  locationId: Scalars['ID']['input'];
  value: Scalars['Boolean']['input'];
};


export type RootMutationTypeSetFeatureFlagArgs = {
  locationId?: InputMaybe<Scalars['ID']['input']>;
  name: FeatureFlagEnum;
  orgId?: InputMaybe<Scalars['ID']['input']>;
  providerId?: InputMaybe<Scalars['ID']['input']>;
  value: Scalars['Boolean']['input'];
};


export type RootMutationTypeSetProviderFeatureFlagArgs = {
  name: FeatureFlagEnum;
  value: Scalars['Boolean']['input'];
};


export type RootMutationTypeSignEncounterArgs = {
  id: Scalars['ID']['input'];
};


export type RootMutationTypeSignTreatmentSheetArgs = {
  id: Scalars['ID']['input'];
  signed?: InputMaybe<Scalars['Boolean']['input']>;
};


export type RootMutationTypeStartAsyncMedicalRecordArgs = {
  end?: InputMaybe<Scalars['NaiveDateTime']['input']>;
  includeCommunications?: InputMaybe<Scalars['Boolean']['input']>;
  includeDocuments?: InputMaybe<Scalars['Boolean']['input']>;
  includeExams?: InputMaybe<Scalars['Boolean']['input']>;
  includeImmunizations?: InputMaybe<Scalars['Boolean']['input']>;
  includeLabResults?: InputMaybe<Scalars['Boolean']['input']>;
  includeMedications?: InputMaybe<Scalars['Boolean']['input']>;
  includeNotes?: InputMaybe<Scalars['Boolean']['input']>;
  includePrivate?: InputMaybe<Scalars['Boolean']['input']>;
  includeTasks?: InputMaybe<Scalars['Boolean']['input']>;
  includeTreatmentSheets?: InputMaybe<Scalars['Boolean']['input']>;
  locationId?: InputMaybe<Scalars['ID']['input']>;
  onlyIncludeItems?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  onlySigned?: InputMaybe<Scalars['Boolean']['input']>;
  patientId: Scalars['ID']['input'];
  selectedItems?: InputMaybe<SelectedItemsInput>;
  start?: InputMaybe<Scalars['NaiveDateTime']['input']>;
  visitId?: InputMaybe<Scalars['ID']['input']>;
};


export type RootMutationTypeStartConversationArgs = {
  attachments?: InputMaybe<Array<InputMaybe<ConversationSetAttachment>>>;
  body: Scalars['String']['input'];
  clientId: Scalars['ID']['input'];
  input: ConversationInput;
};


export type RootMutationTypeStartPdfExtractionTestRunArgs = {
  file?: InputMaybe<Scalars['Upload']['input']>;
  immunizationInstructions?: InputMaybe<Scalars['String']['input']>;
  medicationInstructions?: InputMaybe<Scalars['String']['input']>;
  patientInstructions?: InputMaybe<Scalars['String']['input']>;
  reminderInstructions?: InputMaybe<Scalars['String']['input']>;
};


export type RootMutationTypeStartVisitArgs = {
  locationId: Scalars['ID']['input'];
  patientId: Scalars['ID']['input'];
};


export type RootMutationTypeStripeAttachPaymentMethodToCustomerArgs = {
  paymentMethodId: Scalars['String']['input'];
};


export type RootMutationTypeStripeCancelReaderActionArgs = {
  locationId?: InputMaybe<Scalars['ID']['input']>;
  readerId: Scalars['String']['input'];
};


export type RootMutationTypeStripeUpsertCustomerArgs = {
  email: Scalars['String']['input'];
};


export type RootMutationTypeSurgeryLogPdfArgs = {
  locationId: Scalars['ID']['input'];
};


export type RootMutationTypeSwitchStockTransferArgs = {
  id: Scalars['ID']['input'];
  isReturn: Scalars['Boolean']['input'];
};


export type RootMutationTypeSyncClientArgs = {
  input: SyncClientInput;
};


export type RootMutationTypeTestScribeInstructionsArgs = {
  encounterTypeId: Scalars['ID']['input'];
  encounterTypeName?: InputMaybe<Scalars['String']['input']>;
  locationId?: InputMaybe<Scalars['ID']['input']>;
  patientId?: InputMaybe<Scalars['String']['input']>;
  referenceRecordingId?: InputMaybe<Scalars['String']['input']>;
  sections: Array<Scalars['JSON']['input']>;
  source: Scalars['String']['input'];
  transcript?: InputMaybe<Scalars['String']['input']>;
};


export type RootMutationTypeTextApptReadyArgs = {
  appointmentId: Scalars['ID']['input'];
};


export type RootMutationTypeToggleEncounterSectionCompletedByArgs = {
  encounterId: Scalars['ID']['input'];
  sectionIdx: Scalars['Int']['input'];
};


export type RootMutationTypeTransferPatientArgs = {
  patientId: Scalars['ID']['input'];
  toClientId: Scalars['ID']['input'];
};


export type RootMutationTypeTriggerPrescriptionArgs = {
  medicationId: Scalars['ID']['input'];
};


export type RootMutationTypeUnassignProblemFromEncounterArgs = {
  encounterId: Scalars['ID']['input'];
  problemId: Scalars['ID']['input'];
};


export type RootMutationTypeUnassignProviderFromLocationArgs = {
  locationId: Scalars['ID']['input'];
  providerId: Scalars['ID']['input'];
};


export type RootMutationTypeUnassignProviderFromTaskArgs = {
  providerId: Scalars['ID']['input'];
  taskId: Scalars['ID']['input'];
};


export type RootMutationTypeUncompleteBoardCellArgs = {
  id: Scalars['ID']['input'];
};


export type RootMutationTypeUndoManualAdjustmentArgs = {
  id: Scalars['ID']['input'];
};


export type RootMutationTypeUndoWastageAdjustmentArgs = {
  id: Scalars['ID']['input'];
};


export type RootMutationTypeUnlinkAppointmentArgs = {
  appointmentId: Scalars['ID']['input'];
};


export type RootMutationTypeUnlinkCallArgs = {
  callLogId?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
};


export type RootMutationTypeUpdateAddressArgs = {
  id: Scalars['ID']['input'];
  input: AddressInput;
};


export type RootMutationTypeUpdateAlertArgs = {
  id: Scalars['ID']['input'];
  input: AlertInput;
};


export type RootMutationTypeUpdateAllergyArgs = {
  id: Scalars['ID']['input'];
  input: AllergyInput;
};


export type RootMutationTypeUpdateAppointmentArgs = {
  id: Scalars['ID']['input'];
  input: AppointmentInput;
};


export type RootMutationTypeUpdateAppointmentIntakeArgs = {
  appointmentId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  value?: InputMaybe<Scalars['String']['input']>;
};


export type RootMutationTypeUpdateAppointmentPositionsArgs = {
  appointmentPositions: Array<AppointmentPositionInput>;
};


export type RootMutationTypeUpdateAppointmentReasonCategoryArgs = {
  id: Scalars['ID']['input'];
  reason: Scalars['String']['input'];
};


export type RootMutationTypeUpdateAppointmentTypeArgs = {
  id: Scalars['ID']['input'];
  input: AppointmentTypeInput;
};


export type RootMutationTypeUpdateAppointmentTypeTagArgs = {
  id: Scalars['ID']['input'];
  input: AppointmentTypeTagInput;
};


export type RootMutationTypeUpdateAutoMessageArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  input?: InputMaybe<AutoMessageInput>;
};


export type RootMutationTypeUpdateBillingGroupArgs = {
  id: Scalars['ID']['input'];
  input: BillingGroupInput;
};


export type RootMutationTypeUpdateBoardCellArgs = {
  id: Scalars['ID']['input'];
  input: BoardCellInput;
};


export type RootMutationTypeUpdateBoardRowArgs = {
  id: Scalars['ID']['input'];
  input: BoardRowInput;
};


export type RootMutationTypeUpdateBoardingBlockArgs = {
  id: Scalars['ID']['input'];
  input: BoardingBlockInput;
};


export type RootMutationTypeUpdateBoardingCageArgs = {
  id: Scalars['ID']['input'];
  input?: InputMaybe<BoardingCageInput>;
};


export type RootMutationTypeUpdateBoardingWardArgs = {
  id: Scalars['ID']['input'];
  input: BoardingWardInput;
};


export type RootMutationTypeUpdateCadenceArgs = {
  id: Scalars['ID']['input'];
  input: CadenceInput;
};


export type RootMutationTypeUpdateCageArgs = {
  id: Scalars['ID']['input'];
  input: CageInput;
};


export type RootMutationTypeUpdateCallLogArgs = {
  id: Scalars['ID']['input'];
  input: CallLogInput;
};


export type RootMutationTypeUpdateCareCreditMerchantIdArgs = {
  locationId: Scalars['ID']['input'];
  merchantId?: InputMaybe<Scalars['String']['input']>;
};


export type RootMutationTypeUpdateCareTeamRoleArgs = {
  careTeamRoleId: Scalars['ID']['input'];
  input: UpdateCareTeamRoleInput;
};


export type RootMutationTypeUpdateClientArgs = {
  id: Scalars['ID']['input'];
  input: ClientInput;
};


export type RootMutationTypeUpdateClientExternalCommPreferencesArgs = {
  clientId: Scalars['ID']['input'];
  input: ClientExternalCommPreferencesInput;
};


export type RootMutationTypeUpdateClientRdvmArgs = {
  fromRdvmId?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
  input: ClientRdvmInput;
  migratePatientIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type RootMutationTypeUpdateClientReferralSourceArgs = {
  id: Scalars['ID']['input'];
  input: ClientReferralSourceInput;
};


export type RootMutationTypeUpdateClientTagArgs = {
  id: Scalars['ID']['input'];
  input: ClientTagInput;
};


export type RootMutationTypeUpdateClinicalNoteArgs = {
  id: Scalars['ID']['input'];
  input: ClinicalNoteInput;
};


export type RootMutationTypeUpdateCommentArgs = {
  body: Scalars['String']['input'];
  id: Scalars['ID']['input'];
};


export type RootMutationTypeUpdateComplicationArgs = {
  id: Scalars['ID']['input'];
  input: ComplicationInput;
};


export type RootMutationTypeUpdateConsentFormArgs = {
  id: Scalars['ID']['input'];
  input: ConsentFormInput;
};


export type RootMutationTypeUpdateConversationArgs = {
  id: Scalars['ID']['input'];
  input: ConversationInput;
};


export type RootMutationTypeUpdateCoownerArgs = {
  id: Scalars['ID']['input'];
  input: CoownerInput;
};


export type RootMutationTypeUpdateCouponArgs = {
  id: Scalars['ID']['input'];
  input: CouponInput;
};


export type RootMutationTypeUpdateCreditReasonArgs = {
  id: Scalars['ID']['input'];
  input: CreditReasonInput;
};


export type RootMutationTypeUpdateCustomAppointmentFieldArgs = {
  id: Scalars['ID']['input'];
  input: CustomAppointmentFieldInput;
};


export type RootMutationTypeUpdateCustomAppointmentFieldValueArgs = {
  id: Scalars['ID']['input'];
  input: CustomAppointmentFieldValueInput;
};


export type RootMutationTypeUpdateCustomClientFieldValueArgs = {
  id: Scalars['ID']['input'];
  input?: InputMaybe<CustomClientFieldValueInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};


export type RootMutationTypeUpdateCustomLocationAttributeArgs = {
  id: Scalars['ID']['input'];
  input: CustomLocationAttributeInput;
};


export type RootMutationTypeUpdateCustomPatientFieldArgs = {
  id: Scalars['ID']['input'];
  input: CustomPatientFieldInput;
};


export type RootMutationTypeUpdateCustomPatientFieldValueArgs = {
  appointmentId?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
  input?: InputMaybe<CustomPatientFieldValueInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};


export type RootMutationTypeUpdateCustomPatientProtocolArgs = {
  id: Scalars['ID']['input'];
  input?: InputMaybe<CustomPatientProtocolInput>;
};


export type RootMutationTypeUpdateCustomTreatmentSheetRowArgs = {
  id: Scalars['ID']['input'];
  input: CustomTreatmentSheetRowInput;
};


export type RootMutationTypeUpdateDeclineReasonArgs = {
  id: Scalars['ID']['input'];
  input: DeclineReasonInput;
};


export type RootMutationTypeUpdateDepartmentArgs = {
  id: Scalars['ID']['input'];
  input: DepartmentInput;
};


export type RootMutationTypeUpdateDiagnosticArgs = {
  id: Scalars['ID']['input'];
  input: DiagnosticInput;
};


export type RootMutationTypeUpdateDialpadSubscriptionArgs = {
  enableDialpad: Scalars['Boolean']['input'];
};


export type RootMutationTypeUpdateDiscountReasonArgs = {
  id: Scalars['ID']['input'];
  input: DiscountReasonInput;
};


export type RootMutationTypeUpdateEncounterArgs = {
  id: Scalars['ID']['input'];
  input?: InputMaybe<EncounterInput>;
};


export type RootMutationTypeUpdateEncounterCareTeamMembersArgs = {
  careTeamMembers: Array<EncounterCareTeamMemberInput>;
  encounterId: Scalars['ID']['input'];
};


export type RootMutationTypeUpdateEncounterProductArgs = {
  id: Scalars['ID']['input'];
  input: EncounterProductInput;
};


export type RootMutationTypeUpdateEncounterSectionArgs = {
  encounterId: Scalars['ID']['input'];
  input: EncounterSectionInput;
  sectionIdx: Scalars['Int']['input'];
};


export type RootMutationTypeUpdateEncounterSectionDatumArgs = {
  datumIdx: Scalars['Int']['input'];
  encounterId: Scalars['ID']['input'];
  sectionIdx: Scalars['Int']['input'];
  sessionId?: InputMaybe<Scalars['String']['input']>;
  updates: Scalars['JSON']['input'];
};


export type RootMutationTypeUpdateEncounterTypeArgs = {
  id: Scalars['ID']['input'];
  input?: InputMaybe<EncounterTypeInput>;
};


export type RootMutationTypeUpdateEntityTagArgs = {
  id: Scalars['ID']['input'];
  input: EntityTagInput;
};


export type RootMutationTypeUpdateEntityTagGroupArgs = {
  id: Scalars['ID']['input'];
  input: EntityTagGroupInput;
};


export type RootMutationTypeUpdateEstimateArgs = {
  id: Scalars['ID']['input'];
  input: EstimateInput;
};


export type RootMutationTypeUpdateEstimateItemArgs = {
  id: Scalars['ID']['input'];
  input: EstimateItemInput;
};


export type RootMutationTypeUpdateEstimateItemsArgs = {
  id: Scalars['ID']['input'];
  input: EstimateItemInput;
};


export type RootMutationTypeUpdateFieldServiceAddressArgs = {
  id: Scalars['ID']['input'];
  input: FieldServiceAddressInput;
};


export type RootMutationTypeUpdateFulfillmentSourceArgs = {
  id: Scalars['ID']['input'];
  input: FulfillmentSourceInput;
};


export type RootMutationTypeUpdateHarvestLabOrderArgs = {
  input: UpdateHarvestLabOrderInput;
};


export type RootMutationTypeUpdateHospitalizationArgs = {
  id: Scalars['ID']['input'];
  input: HospitalizationInput;
};


export type RootMutationTypeUpdateHospitalizationTaskArgs = {
  id: Scalars['ID']['input'];
  input: HospitalizationTaskInput;
};


export type RootMutationTypeUpdateIguanaLabOrderArgs = {
  input: UpdateIguanaLabOrderInput;
};


export type RootMutationTypeUpdateImmunizationArgs = {
  id: Scalars['ID']['input'];
  input: ImmunizationInput;
};


export type RootMutationTypeUpdateInvoiceLineItemReasonArgs = {
  id: Scalars['ID']['input'];
  input: InvoiceLineItemReasonInput;
};


export type RootMutationTypeUpdateLabModifierArgs = {
  id: Scalars['ID']['input'];
  input: LabModifierInput;
};


export type RootMutationTypeUpdateLabOrderArgs = {
  id: Scalars['ID']['input'];
  input: LabOrderInput;
};


export type RootMutationTypeUpdateLabResultArgs = {
  id: Scalars['ID']['input'];
  input: LabResultInput;
};


export type RootMutationTypeUpdateLicenseArgs = {
  id: Scalars['ID']['input'];
  input: LicenseInput;
};


export type RootMutationTypeUpdateLinkedClinicalNoteArgs = {
  id: Scalars['ID']['input'];
  input?: InputMaybe<LinkedClinicalNoteInput>;
};


export type RootMutationTypeUpdateLinkedEncounterArgs = {
  id: Scalars['ID']['input'];
  input?: InputMaybe<LinkedEncounterInput>;
};


export type RootMutationTypeUpdateLocationArgs = {
  id: Scalars['ID']['input'];
  input?: InputMaybe<LocationInput>;
};


export type RootMutationTypeUpdateLocationAttributeArgs = {
  id: Scalars['ID']['input'];
  input: LocationAttributeInput;
};


export type RootMutationTypeUpdateLocationHoursArgs = {
  id: Scalars['ID']['input'];
  input: LocationHoursInput;
};


export type RootMutationTypeUpdateLocationIntegrationsArgs = {
  id: Scalars['ID']['input'];
  input?: InputMaybe<LocationIntegrationsInput>;
};


export type RootMutationTypeUpdateLocationProviderScheduleArgs = {
  id: Scalars['ID']['input'];
  input: LocationProviderScheduleInput;
};


export type RootMutationTypeUpdateLocationScheduleArgs = {
  id: Scalars['ID']['input'];
  input: LocationScheduleInput;
};


export type RootMutationTypeUpdateLocationTagArgs = {
  id: Scalars['ID']['input'];
  input: LocationTagInput;
};


export type RootMutationTypeUpdateMacroArgs = {
  id: Scalars['ID']['input'];
  input: MacroInput;
};


export type RootMutationTypeUpdateMedicationArgs = {
  id: Scalars['ID']['input'];
  input: MedicationInput;
};


export type RootMutationTypeUpdateMedicationPharmacyFieldsArgs = {
  id: Scalars['ID']['input'];
  input: MedicationPharmacyFieldsInput;
};


export type RootMutationTypeUpdateMedicationWithPharmacyStatusArgs = {
  id: Scalars['ID']['input'];
  input: MedicationPharmacyStatusInput;
};


export type RootMutationTypeUpdateNewsletterArgs = {
  id: Scalars['ID']['input'];
  input: NewsletterInput;
};


export type RootMutationTypeUpdateOrderArgs = {
  id: Scalars['ID']['input'];
  input: OrderInput;
};


export type RootMutationTypeUpdateOrderFlagArgs = {
  id: Scalars['ID']['input'];
  input: OrderFlagInput;
};


export type RootMutationTypeUpdateOrderItemArgs = {
  id: Scalars['ID']['input'];
  input: OrderItemInput;
};


export type RootMutationTypeUpdateOrderItemsArgs = {
  id: Scalars['ID']['input'];
  input: OrderItemInput;
};


export type RootMutationTypeUpdateOrgArgs = {
  input?: InputMaybe<OrgInput>;
};


export type RootMutationTypeUpdateOrgDepartmentArgs = {
  id: Scalars['ID']['input'];
  input: OrgDepartmentInput;
};


export type RootMutationTypeUpdateOrgLabArgs = {
  id: Scalars['ID']['input'];
  input: OrgLabInput;
};


export type RootMutationTypeUpdateOrgLabWithCheckArgs = {
  id: Scalars['ID']['input'];
  input: OrgLabInput;
};


export type RootMutationTypeUpdateOrgPreferenceArgs = {
  id: Scalars['ID']['input'];
  input: OrgPreferenceInput;
};


export type RootMutationTypeUpdateOutlookOrgPreferenceArgs = {
  id: Scalars['ID']['input'];
  input?: InputMaybe<OrgPreferenceInput>;
};


export type RootMutationTypeUpdatePatientArgs = {
  id: Scalars['ID']['input'];
  input: PatientInput;
};


export type RootMutationTypeUpdatePatientComplicationArgs = {
  id: Scalars['ID']['input'];
  input: PatientComplicationInput;
};


export type RootMutationTypeUpdatePatientDiagnosisArgs = {
  id: Scalars['ID']['input'];
  input?: InputMaybe<PatientDiagnosisInput>;
};


export type RootMutationTypeUpdatePatientDocumentArgs = {
  id: Scalars['ID']['input'];
  input: PatientDocumentInput;
};


export type RootMutationTypeUpdatePatientPlanArgs = {
  id: Scalars['ID']['input'];
  input: PatientPlanInput;
};


export type RootMutationTypeUpdatePatientPlanItemArgs = {
  id: Scalars['ID']['input'];
  input: PatientPlanItemInput;
};


export type RootMutationTypeUpdatePatientTagArgs = {
  id: Scalars['ID']['input'];
  input: PatientTagInput;
};


export type RootMutationTypeUpdatePaymentArgs = {
  id: Scalars['ID']['input'];
  input: PaymentInput;
};


export type RootMutationTypeUpdatePaymentReasonArgs = {
  id: Scalars['ID']['input'];
  input: PaymentReasonInput;
};


export type RootMutationTypeUpdatePhoneNumberArgs = {
  id: Scalars['ID']['input'];
  input: PhoneNumberInput;
};


export type RootMutationTypeUpdatePreventionPlanArgs = {
  id: Scalars['ID']['input'];
  input: PreventionPlanInput;
};


export type RootMutationTypeUpdatePriceChangeArgs = {
  id: Scalars['ID']['input'];
  input: PriceChangeInput;
};


export type RootMutationTypeUpdateProblemArgs = {
  id: Scalars['ID']['input'];
  input: ProblemInput;
};


export type RootMutationTypeUpdateProductArgs = {
  id: Scalars['ID']['input'];
  input: ProductInput;
  locationId?: InputMaybe<Scalars['ID']['input']>;
};


export type RootMutationTypeUpdateProductCategoryArgs = {
  id: Scalars['ID']['input'];
  input: ProductCategoryInput;
};


export type RootMutationTypeUpdateProductCubexEnabledArgs = {
  enable: Scalars['Boolean']['input'];
  locationId: Scalars['ID']['input'];
  productId: Scalars['ID']['input'];
};


export type RootMutationTypeUpdateProductEnabledArgs = {
  enable: Scalars['Boolean']['input'];
  locationId: Scalars['ID']['input'];
  productId: Scalars['ID']['input'];
};


export type RootMutationTypeUpdateProductManufacturerArgs = {
  id: Scalars['ID']['input'];
  input: ProductManufacturerInput;
};


export type RootMutationTypeUpdateProductPackageArgs = {
  id: Scalars['ID']['input'];
  input: ProductPackageInput;
};


export type RootMutationTypeUpdateProductPackageItemArgs = {
  id: Scalars['ID']['input'];
  input: ProductPackageItemInput;
};


export type RootMutationTypeUpdateProductPriceArgs = {
  id: Scalars['ID']['input'];
  input: ProductPriceInput;
};


export type RootMutationTypeUpdateProductProductCategoryArgs = {
  productCategoryId: Scalars['ID']['input'];
  productId: Scalars['ID']['input'];
};


export type RootMutationTypeUpdateProductTypeArgs = {
  id: Scalars['ID']['input'];
  input: ProductTypeInput;
};


export type RootMutationTypeUpdateProtocolArgs = {
  id: Scalars['ID']['input'];
  input: ProtocolInput;
};


export type RootMutationTypeUpdateProtocolReminderArgs = {
  id: Scalars['ID']['input'];
  input: ProtocolReminderInput;
};


export type RootMutationTypeUpdateProviderArgs = {
  id: Scalars['ID']['input'];
  input: ProviderInput;
};


export type RootMutationTypeUpdateProviderPunchArgs = {
  id: Scalars['ID']['input'];
  input: ProviderPunchInput;
};


export type RootMutationTypeUpdateProviderRoleArgs = {
  id: Scalars['ID']['input'];
  input?: InputMaybe<ProviderRoleInput>;
};


export type RootMutationTypeUpdateProviderTransferArgs = {
  input: UpdateProviderTransferInput;
  providerTransferId: Scalars['ID']['input'];
};


export type RootMutationTypeUpdatePurchaseOrderArgs = {
  id: Scalars['ID']['input'];
  input: PurchaseOrderInput;
};


export type RootMutationTypeUpdatePurchaseOrderItemArgs = {
  id: Scalars['ID']['input'];
  input: PurchaseOrderItemInput;
};


export type RootMutationTypeUpdateQuantityStockTransferItemArgs = {
  id: Scalars['ID']['input'];
  quantity?: InputMaybe<Scalars['Decimal']['input']>;
};


export type RootMutationTypeUpdateRdvmArgs = {
  id: Scalars['ID']['input'];
  input: RdvmInput;
};


export type RootMutationTypeUpdateRdvmContactArgs = {
  id: Scalars['ID']['input'];
  input: RdvmContactInput;
};


export type RootMutationTypeUpdateRdvmVisitArgs = {
  id: Scalars['ID']['input'];
  input: RdvmVisitInput;
};


export type RootMutationTypeUpdateReconciliationNoteArgs = {
  id: Scalars['ID']['input'];
  input: ReconciliationNoteInput;
};


export type RootMutationTypeUpdateRelationshipArgs = {
  id: Scalars['ID']['input'];
  input: RelationshipInput;
};


export type RootMutationTypeUpdateReminderArgs = {
  id: Scalars['ID']['input'];
  input: ReminderInput;
};


export type RootMutationTypeUpdateReminderSilenceArgs = {
  id: Scalars['ID']['input'];
  input: ReminderSilenceInput;
};


export type RootMutationTypeUpdateReservationArgs = {
  id: Scalars['ID']['input'];
  input: ReservationInput;
};


export type RootMutationTypeUpdateRevenueCenterArgs = {
  id: Scalars['ID']['input'];
  input: RevenueCenterInput;
};


export type RootMutationTypeUpdateRevenueCenterBudgetArgs = {
  id: Scalars['ID']['input'];
  input: RevenueCenterBudgetInput;
};


export type RootMutationTypeUpdateScheduleTemplateArgs = {
  id: Scalars['ID']['input'];
  input: ScheduleTemplateInput;
};


export type RootMutationTypeUpdateStockLocationArgs = {
  input?: InputMaybe<StockLocationUpdate>;
};


export type RootMutationTypeUpdateStockTransferArgs = {
  id: Scalars['ID']['input'];
  input?: InputMaybe<StockTransferInput>;
};


export type RootMutationTypeUpdateStockTransferFulfillmentItemArgs = {
  id: Scalars['ID']['input'];
  input: UpdateStockTransferFulfillmentItemInput;
};


export type RootMutationTypeUpdateStockTransferItemArgs = {
  id: Scalars['ID']['input'];
  input?: InputMaybe<StockTransferItemInput>;
};


export type RootMutationTypeUpdateStockTransferNotesArgs = {
  input?: InputMaybe<StockTransferNoteInput>;
  transferId: Scalars['ID']['input'];
};


export type RootMutationTypeUpdateStockTransferReportRecipientArgs = {
  id: Scalars['ID']['input'];
  input: UpdateStockTransferReportRecipientInput;
};


export type RootMutationTypeUpdateStockTransferRequestArgs = {
  id: Scalars['ID']['input'];
  input: UpdateStockTransferRequestInput;
};


export type RootMutationTypeUpdateStockTransferRequestItemArgs = {
  id: Scalars['ID']['input'];
  input: UpdateStockTransferRequestItemInput;
};


export type RootMutationTypeUpdateStockTransferTemplateArgs = {
  id: Scalars['ID']['input'];
  input: UpdateStockTransferTemplateInput;
};


export type RootMutationTypeUpdateStockTransferTemplateItemArgs = {
  id: Scalars['ID']['input'];
  input: UpdateStockTransferTemplateItemInput;
};


export type RootMutationTypeUpdateTaskArgs = {
  id: Scalars['ID']['input'];
  input: TaskInput;
};


export type RootMutationTypeUpdateTaskCategoryArgs = {
  id: Scalars['ID']['input'];
  input: TaskCategoryInput;
};


export type RootMutationTypeUpdateTaskGroupArgs = {
  id: Scalars['ID']['input'];
  input: TaskGroupInput;
};


export type RootMutationTypeUpdateTravelZoneArgs = {
  id: Scalars['ID']['input'];
  input: TravelZoneInput;
};


export type RootMutationTypeUpdateTreatmentArgs = {
  id: Scalars['ID']['input'];
  input: TreatmentInput;
};


export type RootMutationTypeUpdateTreatmentSheetArgs = {
  id: Scalars['ID']['input'];
  input: TreatmentSheetInput;
};


export type RootMutationTypeUpdateTreatmentSheetCellArgs = {
  id: Scalars['ID']['input'];
  input: TreatmentSheetCellInput;
};


export type RootMutationTypeUpdateTreatmentSheetRowArgs = {
  id: Scalars['ID']['input'];
  input: TreatmentSheetRowInput;
};


export type RootMutationTypeUpdateTreatmentSheetRowInactiveIntervalsArgs = {
  id: Scalars['ID']['input'];
  inactiveIntervals: Array<TreatmentTimeIntervalInput>;
};


export type RootMutationTypeUpdateTreatmentSheetStartArgs = {
  id: Scalars['ID']['input'];
  start: Scalars['DateTime']['input'];
};


export type RootMutationTypeUpdateTreatmentSheetTemplateArgs = {
  id: Scalars['ID']['input'];
  input: TreatmentSheetTemplateInput;
};


export type RootMutationTypeUpdateTreatmentSheetTimeSlotsArgs = {
  id: Scalars['ID']['input'];
  timeSlots: Array<InputMaybe<Scalars['DateTime']['input']>>;
};


export type RootMutationTypeUpdateTriggerArgs = {
  id: Scalars['ID']['input'];
  input: TriggerInput;
};


export type RootMutationTypeUpdateVendorArgs = {
  id: Scalars['ID']['input'];
  input: VendorInput;
};


export type RootMutationTypeUpdateViewerArgs = {
  input: ProviderViewerInput;
};


export type RootMutationTypeUpdateViewerPasswordArgs = {
  oldPassword: Scalars['String']['input'];
  password: Scalars['String']['input'];
  passwordConfirmation: Scalars['String']['input'];
};


export type RootMutationTypeUpdateVisitHeaderConfigArgs = {
  diagnosisIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  rdvmIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  showDiagnosis?: InputMaybe<Scalars['Boolean']['input']>;
  showPrimaryContact?: InputMaybe<Scalars['Boolean']['input']>;
  showRdvm?: InputMaybe<Scalars['Boolean']['input']>;
  visitId: Scalars['ID']['input'];
};


export type RootMutationTypeUpdateVitalsArgs = {
  id: Scalars['ID']['input'];
  input?: InputMaybe<VitalsInput>;
};


export type RootMutationTypeUpdateVoiceCallArgs = {
  id: Scalars['ID']['input'];
  input: VoiceCallInput;
};


export type RootMutationTypeUploadClinicImageArgs = {
  clinicImage: Scalars['Upload']['input'];
  locationId: Scalars['ID']['input'];
};


export type RootMutationTypeUploadEmailTemplateImageArgs = {
  emailTemplateImage: Scalars['Upload']['input'];
  locationId: Scalars['ID']['input'];
};


export type RootMutationTypeUploadEncounterTypeAssetArgs = {
  asset: Scalars['Upload']['input'];
};


export type RootMutationTypeUploadLabImageArgs = {
  image: Scalars['Upload']['input'];
  labResultId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};


export type RootMutationTypeUploadLocationLogoArgs = {
  id: Scalars['ID']['input'];
  logo: Scalars['Upload']['input'];
};


export type RootMutationTypeUploadMassInventoryArgs = {
  file: Scalars['Upload']['input'];
  locationId: Scalars['ID']['input'];
};


export type RootMutationTypeUploadMassProductsArgs = {
  file: Scalars['Upload']['input'];
};


export type RootMutationTypeUploadMassRdvmsArgs = {
  file: Scalars['Upload']['input'];
};


export type RootMutationTypeUploadOrgLogoArgs = {
  logo: Scalars['Upload']['input'];
};


export type RootMutationTypeUploadPatientDocumentArgs = {
  category?: InputMaybe<Scalars['String']['input']>;
  document: Scalars['Upload']['input'];
  encounterId?: InputMaybe<Scalars['ID']['input']>;
  encounterSectionName?: InputMaybe<Scalars['String']['input']>;
  locationId?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  patientId: Scalars['ID']['input'];
  visitId?: InputMaybe<Scalars['ID']['input']>;
};


export type RootMutationTypeUploadPatientImageArgs = {
  document: Scalars['Upload']['input'];
  patientId: Scalars['ID']['input'];
};


export type RootMutationTypeUploadProtocolsMigrationCsvArgs = {
  file: Scalars['Upload']['input'];
  locationId: Scalars['ID']['input'];
};


export type RootMutationTypeUploadProviderElectronicSignatureArgs = {
  providerId: Scalars['ID']['input'];
  signature: Scalars['Upload']['input'];
};


export type RootMutationTypeUploadProviderProfileImageArgs = {
  document: Scalars['Upload']['input'];
  providerId: Scalars['ID']['input'];
};


export type RootMutationTypeUploadRdvmDocumentArgs = {
  document: Scalars['Upload']['input'];
  name: Scalars['String']['input'];
  rdvmId: Scalars['ID']['input'];
};


export type RootMutationTypeUpsertLowStockThresholdArgs = {
  input: LowStockThresholdInput;
};


export type RootMutationTypeUpsertPackageLocationMarkupArgs = {
  locationId?: InputMaybe<Scalars['ID']['input']>;
  locationTagId?: InputMaybe<Scalars['ID']['input']>;
  markupPercent?: InputMaybe<Scalars['Decimal']['input']>;
  packageId: Scalars['ID']['input'];
};


export type RootMutationTypeUpsertPatientContactDetailsArgs = {
  input: PatientContactDetailsInput;
  patientId: Scalars['ID']['input'];
};


export type RootMutationTypeUpsertProductConfigArgs = {
  input: UpsertProductConfigInput;
  productId: Scalars['ID']['input'];
};


export type RootMutationTypeUpsertProductLocationMarkupArgs = {
  locationId?: InputMaybe<Scalars['ID']['input']>;
  locationTagId?: InputMaybe<Scalars['ID']['input']>;
  markupPercent?: InputMaybe<Scalars['Decimal']['input']>;
  productId: Scalars['ID']['input'];
};


export type RootMutationTypeUpsertProductTypeLocationMarkupArgs = {
  locationId?: InputMaybe<Scalars['ID']['input']>;
  locationTagId?: InputMaybe<Scalars['ID']['input']>;
  markupPercent?: InputMaybe<Scalars['Decimal']['input']>;
  productTypeId: Scalars['ID']['input'];
};


export type RootMutationTypeUpsertProviderAppointmentTypeLimitArgs = {
  input?: InputMaybe<ProviderAppointmentTypeLimitInput>;
};


export type RootMutationTypeUpsertProviderCommissionsArgs = {
  inputs: Array<ProviderCommissionInput>;
};


export type RootMutationTypeUpsertProviderPreferencesArgs = {
  input?: InputMaybe<ProviderPreferencesInput>;
};


export type RootMutationTypeValidateControlledDrugPinArgs = {
  action: Scalars['String']['input'];
  locationId?: InputMaybe<Scalars['ID']['input']>;
  pin: Scalars['String']['input'];
  providerId?: InputMaybe<Scalars['ID']['input']>;
};


export type RootMutationTypeValuesetLabelArgs = {
  encounterId: Scalars['ID']['input'];
  sectionName: Scalars['String']['input'];
};


export type RootMutationTypeVoidPaymentArgs = {
  paymentId: Scalars['ID']['input'];
};

export type RootQueryType = {
  __typename?: 'RootQueryType';
  accountCreditHistory?: Maybe<AccountCreditHistoryResponse>;
  /** Lists account credits voided without corresponding payment voided */
  accountCreditsVoidedWithoutPaymentVoided: Array<Payment>;
  accounts?: Maybe<ClientConnection>;
  /** Returns a client's accounts receivable balance. */
  accountsReceivableBalance?: Maybe<AccountsReceivableBalance>;
  activeBoardRows?: Maybe<Array<Maybe<BoardRow>>>;
  activeSubscriptionForOrg?: Maybe<VetspireSubscription>;
  /** Search for active calls filtering by location phone number */
  activeVoiceCalls?: Maybe<Array<Maybe<VoiceCall>>>;
  addresses?: Maybe<Array<Maybe<Address>>>;
  administrationRoutes: Array<AdministrationRoute>;
  /** Lists aged accounts receivable records */
  agedAccountsReceivable?: Maybe<Array<Maybe<AgedAccountsReceivable>>>;
  /** Returns aged accounts receivable totals */
  agedAccountsReceivableTotals?: Maybe<AgedAccountsReceivableTotals>;
  alert?: Maybe<Alert>;
  alerts: Array<Alert>;
  /** @deprecated Only use 'allergies' when querying inside of 'patient'. Field will be removed soon. */
  allergies?: Maybe<Array<Maybe<Allergy>>>;
  analytics?: Maybe<Array<Maybe<AnalyticsData>>>;
  /** Lookup API keys for your org */
  apiKeys: Array<ApiKey>;
  appointment?: Maybe<Appointment>;
  appointmentReasonCategories: Array<AppointmentReasonCategory>;
  appointmentReminders?: Maybe<Array<Maybe<AppointmentReminder>>>;
  appointmentTypeTag: AppointmentTypeTag;
  appointmentTypeTags: Array<AppointmentTypeTag>;
  appointmentTypes: Array<AppointmentType>;
  /** Get a list of appointments either by location id or provider id */
  appointments?: Maybe<Array<Maybe<Appointment>>>;
  /**
   * Runs the appointments report and returns results inline.
   *
   * This report supports the following breakdowns:
   *  - LOCATION_ID
   *  - PROVIDER_ID
   *  - APPOINTMENT_TYPE_ID
   *  - IS_NEW_CLIENT
   *  - IS_NEW_OF_TYPE_CLIENT
   *  - IS_MEMBER
   *  - BOOKING_METHOD
   *  - BOOKING_PLACE
   *  - STATUS
   *  - APPOINTMENT_TYPE_REVENUE_CENTER_ID
   *  - CLIENT_ID
   *  - CLIENT_PHONE_NUMBER
   *  - PATIENT_ID
   *  - PATIENT_NAME
   *  - APPOINTMENT_TIME
   *
   * If results time out, please fetch smaller date ranges, otherwise please use the alternative
   * `emailAppointmentsReport` query.
   */
  appointmentsReport?: Maybe<Scalars['JSON']['output']>;
  /** Lists logged client AR reconciliation issues */
  arReconciliationIssues: Array<ArReconciliation>;
  asyncMedicalRecord?: Maybe<AsyncMedicalRecord>;
  autoMessage: AutoMessage;
  autoMessages: Array<AutoMessage>;
  availableCages: Array<BoardingCage>;
  availableOrgLabTypes: Array<OrgLabTypeMetadata>;
  availableTimes?: Maybe<Array<Maybe<AvailableTimeSlot>>>;
  /** Get NOVA billing frequency options for dropdown */
  billingFrequencyOptions: Array<BillingFrequencyOption>;
  billingGroup?: Maybe<BillingGroup>;
  /** Get billing groups for dropdown (no permission required) */
  billingGroupOptions: Array<BillingGroupOption>;
  billingGroups?: Maybe<BillingGroupConnection>;
  billingGroupsCount?: Maybe<Scalars['Int']['output']>;
  bills?: Maybe<Array<Maybe<Bill>>>;
  boardCell?: Maybe<BoardCell>;
  boardGroups?: Maybe<Array<Maybe<BoardGroup>>>;
  boardRow?: Maybe<BoardRow>;
  boardingCages: Array<BoardingCage>;
  boardingWards: Array<BoardingWard>;
  bookedDays?: Maybe<Array<Scalars['Date']['output']>>;
  cadence?: Maybe<Cadence>;
  cadences?: Maybe<Array<Maybe<Cadence>>>;
  cages?: Maybe<Array<Maybe<Cage>>>;
  /**
   * Calculates bolus values using patient weight.
   *
   * Provide either `amount` (ml/kg) OR `totalAmount` (ml):
   * - If `amount` is provided: calculates totalAmount = amount × patientWeight
   * - If `totalAmount` is provided: calculates amount = totalAmount ÷ patientWeight
   *
   * Always calculates: rate = totalAmount × 60 ÷ overPeriod
   */
  calculateBolusValues?: Maybe<BolusCalculationResult>;
  calculateDosage?: Maybe<DosageCalculationResult>;
  callLog?: Maybe<CallLog>;
  /** Get a list of call logs */
  callLogs?: Maybe<Array<Maybe<CallLog>>>;
  callLogsCount?: Maybe<Scalars['Int']['output']>;
  /**
   * Runs the callLogs report and returns results inline.
   *
   * This report supports the following breakdowns:
   *  - LOCATION_ID
   *  - CAME_IN
   *  - CONSULTED_BY_DOCTOR_ID
   *
   * If results time out, please fetch smaller date ranges, otherwise please use the alternative
   * `emailCalllogsReport` query.
   */
  callLogsReport?: Maybe<Scalars['JSON']['output']>;
  /**
   * Runs the calls report and returns results inline.
   *
   * This report supports the following breakdowns:
   *  - LOCATION_ID
   *
   * If results time out, please fetch smaller date ranges, otherwise please use the alternative
   * `emailCallsReport` query.
   */
  callsReport?: Maybe<Scalars['JSON']['output']>;
  cardconnectVerifyCredentials?: Maybe<CardconnectVerifyCredentialsResult>;
  careCreditAccessToken?: Maybe<Scalars['String']['output']>;
  careTeamRoles?: Maybe<Array<Maybe<CareTeamRole>>>;
  ccTerminals?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  census?: Maybe<Census>;
  changelogs?: Maybe<ChangelogConnection>;
  changelogsCount: Scalars['Int']['output'];
  changelogsEntitySources: Array<Scalars['String']['output']>;
  checkDuplicatePhoneNumber?: Maybe<Scalars['Boolean']['output']>;
  /** Lookup a specific client by id */
  client?: Maybe<Client>;
  /** Lists sum of client account credits by location */
  clientAccountCreditsByLocation: Array<LocationClientAccountCredits>;
  clientConsent?: Maybe<ClientConsent>;
  clientReferralSource: ClientReferralSource;
  clientReferralSources: Array<ClientReferralSource>;
  clientTag?: Maybe<ClientTag>;
  clientTags?: Maybe<Array<Maybe<ClientTag>>>;
  /** Get a list of clients within your organization's database. Depending on how many providers your organization has, you may need to page through your data with filters. */
  clients?: Maybe<Array<Maybe<Client>>>;
  clientsCount?: Maybe<Scalars['Int']['output']>;
  complications: Array<Complication>;
  /**
   * The `should_convert_urls_to_a_tags` is a boolean flag that determines whether URLs
   *   should be converted into clickable links by adding an <a> tag with the CSS class `vespire-consent-form-link`.
   */
  consentForm?: Maybe<ConsentForm>;
  consentForms?: Maybe<Array<Maybe<ConsentForm>>>;
  /** Lookup an rdvms contacts */
  contacts: Array<RdvmContact>;
  conversation?: Maybe<Conversation>;
  conversations?: Maybe<Array<Maybe<Conversation>>>;
  conversationsPaginated: ConversationPage;
  coowners?: Maybe<Array<Maybe<Coowner>>>;
  count?: Maybe<Array<Maybe<AnalyticsDataRow>>>;
  /**
   * Count the number of appointments in a range from start to end
   * segmented into days, weeks, months, years.
   */
  countAppointmentProviders?: Maybe<Array<Maybe<ApptCountProviders>>>;
  /**
   * Count the number of appointments in a range from start to end
   * segmented into days, weeks, months, years.
   */
  countAppointments?: Maybe<Array<Maybe<DateCount>>>;
  /** Count new clients based on filters between a range and segment */
  countNewClients?: Maybe<Array<Maybe<DateCount>>>;
  /** Count the number of appointments by a certain provider id */
  countViewerAppointments?: Maybe<Array<Maybe<DateCount>>>;
  coupon?: Maybe<Coupon>;
  /**
   * Runs the couponDiscounts report and returns results inline.
   *
   * This report supports the following breakdowns:
   *  - LOCATION_ID
   *  - REVENUE_CENTER_ID
   *  - PROVIDER_ID
   *  - PRODUCT_ID
   *
   * If results time out, please fetch smaller date ranges, otherwise please use the alternative
   * `emailCoupondiscountsReport` query.
   */
  couponDiscountsReport?: Maybe<Array<Maybe<ReportRow>>>;
  coupons?: Maybe<Array<Maybe<Coupon>>>;
  creditMemos?: Maybe<Array<Maybe<CreditMemo>>>;
  creditMemosTotals?: Maybe<CreditMemoTotals>;
  /** Lists credit migrations voided */
  creditMigrationsVoided: Array<Payment>;
  creditReasons?: Maybe<Array<Maybe<CreditReason>>>;
  /** Get custom appointment field values */
  customAppointmentFieldValues?: Maybe<Array<Maybe<CustomAppointmentFieldValue>>>;
  /** Get all custom appointment fields at the viewer's org */
  customAppointmentFields?: Maybe<Array<Maybe<CustomAppointmentField>>>;
  /** Get custom client field values */
  customClientFieldValues?: Maybe<Array<Maybe<CustomClientFieldValue>>>;
  /** Get all custom client fields at the viewer's org */
  customClientFields?: Maybe<Array<Maybe<CustomClientField>>>;
  /** Get custom patient field values */
  customPatientFieldValues?: Maybe<Array<Maybe<CustomPatientFieldValue>>>;
  /** Get all custom patient fields at the viewer's org */
  customPatientFields?: Maybe<Array<Maybe<CustomPatientField>>>;
  dailyStockTransferReport?: Maybe<Array<Maybe<DailyStockTransferReportItem>>>;
  dashboard?: Maybe<Dashboard>;
  deceasedPatientsCount?: Maybe<Scalars['Int']['output']>;
  deceasedPatientsReport?: Maybe<DeceasedPatientItemConnection>;
  declineReasons?: Maybe<Array<Maybe<DeclineReason>>>;
  departments?: Maybe<Array<Maybe<Department>>>;
  detailedCreditsCount?: Maybe<Scalars['Int']['output']>;
  detailedCreditsReport?: Maybe<DetailedCreditItemConnection>;
  detailedSalesRevenueCount?: Maybe<Scalars['Int']['output']>;
  detailedSalesRevenueReport?: Maybe<DetailedSalesRevenueItemConnection>;
  detectStripePaymentType?: Maybe<StripePaymentTypeResult>;
  diagnostic?: Maybe<Diagnostic>;
  diagnostics?: Maybe<Array<Maybe<Diagnostic>>>;
  dialpadOffices?: Maybe<Array<Maybe<DialpadOffice>>>;
  discountReasons?: Maybe<Array<Maybe<DiscountReason>>>;
  /**
   * Runs the appointments report and emails the results as an excel file to the given
   * email address.
   *
   * This report supports the following breakdowns:
   *  - LOCATION_ID
   *  - PROVIDER_ID
   *  - APPOINTMENT_TYPE_ID
   *  - IS_NEW_CLIENT
   *  - IS_NEW_OF_TYPE_CLIENT
   *  - IS_MEMBER
   *  - BOOKING_METHOD
   *  - BOOKING_PLACE
   *  - STATUS
   *  - APPOINTMENT_TYPE_REVENUE_CENTER_ID
   *  - CLIENT_ID
   *  - CLIENT_PHONE_NUMBER
   *  - PATIENT_ID
   *  - PATIENT_NAME
   *  - APPOINTMENT_TIME
   *
   * If results are requested inline, please use the provided `appointmentsReport` query.
   */
  emailAppointmentsReport?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Runs the callLogs report and emails the results as an excel file to the given
   * email address.
   *
   * This report supports the following breakdowns:
   *  - LOCATION_ID
   *  - CAME_IN
   *  - CONSULTED_BY_DOCTOR_ID
   *
   * If results are requested inline, please use the provided `callLogsReport` query.
   */
  emailCallLogsReport?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Runs the calls report and emails the results as an excel file to the given
   * email address.
   *
   * This report supports the following breakdowns:
   *  - LOCATION_ID
   *
   * If results are requested inline, please use the provided `callsReport` query.
   */
  emailCallsReport?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Runs the couponDiscounts report and emails the results as an excel file to the given
   * email address.
   *
   * This report supports the following breakdowns:
   *  - LOCATION_ID
   *  - REVENUE_CENTER_ID
   *  - PROVIDER_ID
   *  - PRODUCT_ID
   *
   * If results are requested inline, please use the provided `couponDiscountsReport` query.
   */
  emailCouponDiscountsReport?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Runs the grossSales report and emails the results as an excel file to the given
   * email address.
   *
   * This report supports the following breakdowns:
   *  - LOCATION_ID
   *  - REVENUE_CENTER_ID
   *  - PROVIDER_ID
   *  - PRODUCT_ID
   *  - PRODUCT_TYPE_ID
   *  - PRODUCT_CATEGORY_ID
   *  - CLIENT_ID
   *
   * If results are requested inline, please use the provided `grossSalesReport` query.
   */
  emailGrossSalesReport?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Runs the paidSales report and emails the results as an excel file to the given
   * email address.
   *
   * This report supports the following breakdowns:
   *  - LOCATION_ID
   *  - REVENUE_CENTER_ID
   *  - PROVIDER_ID
   *  - PRODUCT_ID
   *  - PRODUCT_TYPE_ID
   *  - PRODUCT_CATEGORY_ID
   *  - CLIENT_ID
   *  - PAYROLL_ID
   *
   * If results are requested inline, please use the provided `paidSalesReport` query.
   */
  emailPaidSalesReport?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Runs the protocolReminders report and emails the results as an excel file to the given
   * email address.
   *
   * This report supports the following breakdowns:
   *  - LOCATION_ID
   *  - UNSENDABLE_REASON
   *  - DUPLICATE_COUNT
   *  - SENT
   *  - CADENCE
   *  - CONTACT_METHOD
   *  - CONVERSIONS
   *  - CLIENT_ID
   *  - CLIENT_NAME
   *  - PATIENT_ID
   *  - PATIENT_NAME
   *  - CONTAINS_LEGACY_REMINDERS
   *  - RECIPIENT_ADDRESS
   *  - PROTOCOL_ID
   *
   * If results are requested inline, please use the provided `protocolRemindersReport` query.
   */
  emailProtocolRemindersReport?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Runs the sales report and emails the results as an excel file to the given
   * email address.
   *
   * This report supports the following breakdowns:
   *  - LOCATION_ID
   *  - PROVIDER_ID
   *  - REVENUE_CENTER_ID
   *  - PRODUCT_TYPE_ID
   *  - PRODUCT_CATEGORY_ID
   *  - PRODUCT_ID
   *  - DEPARTMENT_ID
   *  - CLIENT_ID
   *  - PAYROLL_ID
   *  - RDVM_ID
   *
   * If results are requested inline, please use the provided `salesReport` query.
   */
  emailSalesReport?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Runs the tips report and emails the results as an excel file to the given
   * email address.
   *
   * This report supports the following breakdowns:
   *  - LOCATION_ID
   *  - TIPPED_PROVIDER_ID
   *  - CLIENT_ID
   *
   * If results are requested inline, please use the provided `tipsReport` query.
   */
  emailTipsReport?: Maybe<Scalars['Boolean']['output']>;
  encounter?: Maybe<Encounter>;
  /** Get encounter care team members */
  encounterCareTeamMembers?: Maybe<Array<Maybe<EncounterCareTeamMember>>>;
  encounterProducts?: Maybe<Array<Maybe<EncounterProduct>>>;
  encounterSummary?: Maybe<Scalars['String']['output']>;
  encounterType: EncounterType;
  encounterTypes?: Maybe<Array<Maybe<EncounterType>>>;
  /** Search for encounters by patient id, org id, and status */
  encounters?: Maybe<Array<Maybe<Encounter>>>;
  /** Poll for a list of encounters updated since a specific datetime */
  encountersUpdatedSince?: Maybe<Array<Maybe<Encounter>>>;
  entitiesTag?: Maybe<EntitiesTag>;
  entityTag?: Maybe<EntityTag>;
  entityValidations: Array<EntityValidation>;
  estimate?: Maybe<Estimate>;
  estimateItems?: Maybe<Array<Maybe<EstimateItem>>>;
  estimatePdf?: Maybe<Scalars['String']['output']>;
  estimates?: Maybe<Array<Maybe<Estimate>>>;
  estimatesTotals?: Maybe<EstimatesTotals>;
  events?: Maybe<Array<Event>>;
  eventsPaginated?: Maybe<EventConnection>;
  externalCommPreferences?: Maybe<ClientExternalCommPreferencesValue>;
  externalSearch?: Maybe<Array<Maybe<ExternalSearchResult>>>;
  featureFlag?: Maybe<FeatureFlag>;
  featureFlags?: Maybe<Array<Maybe<FeatureFlag>>>;
  fileFolders: Array<Scalars['String']['output']>;
  files: FileResults;
  frequencies?: Maybe<Array<Frequency>>;
  fulfillmentSource?: Maybe<FulfillmentSource>;
  fulfillmentSources: Array<FulfillmentSource>;
  getCardconnectBaseUrlBySlug: Scalars['String']['output'];
  getCardconnectCardInfo: CardconnectCardInfo;
  getCardconnectMerchantSurchargeStatus: CardconnectMerchantSurchargeStatus;
  getInhouseDevices?: Maybe<Array<Maybe<LabDevice>>>;
  getLatestLocationKpis?: Maybe<Array<Maybe<LocationKpi>>>;
  getPatientDocuments?: Maybe<PatientDocumentConnection>;
  getRdvmRecentPatients: Array<RdvmRecentPatients>;
  /**
   * Runs the grossSales report and returns results inline.
   *
   * This report supports the following breakdowns:
   *  - LOCATION_ID
   *  - REVENUE_CENTER_ID
   *  - PROVIDER_ID
   *  - PRODUCT_ID
   *  - PRODUCT_TYPE_ID
   *  - PRODUCT_CATEGORY_ID
   *  - CLIENT_ID
   *
   * If results time out, please fetch smaller date ranges, otherwise please use the alternative
   * `emailGrosssalesReport` query.
   */
  grossSalesReport?: Maybe<Array<Maybe<ReportRow>>>;
  /** if the client has due, collections, or uncollectible invoices */
  hasAppointmentBillingAlert?: Maybe<Scalars['Boolean']['output']>;
  /** if the client has an open, due balance */
  hasBalanceDue?: Maybe<Scalars['Boolean']['output']>;
  hospitalizations?: Maybe<Array<Maybe<Hospitalization>>>;
  immunization?: Maybe<Immunization>;
  /** Get immunizations PDF */
  immunizationPdf?: Maybe<Scalars['String']['output']>;
  /** Get immunizations */
  immunizations?: Maybe<Array<Maybe<Immunization>>>;
  immunizationsDue?: Maybe<Array<Maybe<Immunization>>>;
  inCollections?: Maybe<Scalars['Boolean']['output']>;
  inventoryAdjustment?: Maybe<InventoryAdjustment>;
  inventoryAdjustments?: Maybe<Array<Maybe<InventoryAdjustment>>>;
  invoiceLineItemReasons?: Maybe<Array<Maybe<InvoiceLineItemReason>>>;
  invoicePdf?: Maybe<Scalars['String']['output']>;
  isDaycareOpen?: Maybe<Scalars['Boolean']['output']>;
  /** List lab modifiers for the current provider's org */
  labModifiers?: Maybe<Array<Maybe<LabModifier>>>;
  labOrder?: Maybe<LabOrder>;
  labOrders?: Maybe<Array<Maybe<LabOrder>>>;
  labResult?: Maybe<LabResult>;
  labResults?: Maybe<Array<Maybe<LabResult>>>;
  labTests: Array<LabTest>;
  /**
   * Where the patient's run has got to, or null if nothing has asked for one.
   *
   * Answers with every analyte the run covers. The engine merges the vendor's
   * names, so it decides what an analyte is called and the caller matches on the
   * name and aliases it reports.
   *
   * Reads only: `generateLabTrends` is what starts a run, so this is safe to
   * poll.
   */
  labTrends?: Maybe<LabTrendRun>;
  lapsingPatients?: Maybe<Array<Maybe<Patient>>>;
  latestDatasyncLogs?: Maybe<Array<Maybe<DatasyncLog>>>;
  latestDeletionLogs?: Maybe<Array<Maybe<DeletionLog>>>;
  ledgerEntries?: Maybe<Array<Maybe<LedgerEntry>>>;
  ledgerEntryTotals?: Maybe<LedgerEntryTotals>;
  legalEntities?: Maybe<Array<Maybe<LegalEntity>>>;
  listEncounters?: Maybe<EncounterConnection>;
  listEncountersCount?: Maybe<Scalars['Int']['output']>;
  listImmunizations?: Maybe<ImmunizationConnection>;
  listPatientProtocols?: Maybe<PatientProtocolConnection>;
  listProviders?: Maybe<ProviderConnection>;
  /** @deprecated Please see `stockTransferTemplates` instead. This API will be removed soon. */
  listStockTransferTemplates?: Maybe<Array<Maybe<StockTransferTemplate>>>;
  listTasks?: Maybe<TaskConnection>;
  /** Lookup a location by id (defaults to latest added) */
  location?: Maybe<Location>;
  /** Get a list of appointments types which are either enabled globally, or enabled for the given location */
  locationAppointmentTypes?: Maybe<Array<Maybe<AppointmentType>>>;
  locationChatMessages?: Maybe<Array<Maybe<LocationChatMessage>>>;
  locationSchedules?: Maybe<Array<Maybe<LocationSchedule>>>;
  locationTag: LocationTag;
  locationTags: Array<LocationTag>;
  locations?: Maybe<Array<Location>>;
  locationsDepartments?: Maybe<Array<Maybe<Department>>>;
  macro: Macro;
  macros: Array<Maybe<Macro>>;
  macrosCount?: Maybe<Scalars['Int']['output']>;
  mandatoryConsentForms?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  masterProducts?: Maybe<Array<Maybe<MasterProduct>>>;
  medicalRecordsSummary?: Maybe<Scalars['String']['output']>;
  medication?: Maybe<Medication>;
  /** Lookup a patient's medication by status */
  medications?: Maybe<Array<Maybe<Medication>>>;
  medicationsFilledReport?: Maybe<MedicationsFilledReportResult>;
  medicationsReport?: Maybe<MedicationsReportResult>;
  modalities?: Maybe<Array<Maybe<Modality>>>;
  monograph?: Maybe<Monograph>;
  monographs?: Maybe<Array<Monograph>>;
  newsletter: Newsletter;
  newsletters: Array<Newsletter>;
  notifications?: Maybe<Array<Maybe<Notification>>>;
  /** Get NovaBoard sheets for a location */
  novaBoard?: Maybe<Array<NovaBoardSheet>>;
  /**
   * Get cell statistics for a single NovaBoard sheet
   * @deprecated Use novaBoard { cells(hoursBefore, hoursAfter) } or novaBoardSheet { cells(hoursBefore, hoursAfter) }
   */
  novaBoardRowCells?: Maybe<NovaBoardRowCells>;
  /** Get a single NovaBoard sheet by ID */
  novaBoardSheet?: Maybe<NovaBoardSheet>;
  /** Get time slots for NovaBoard */
  novaBoardSlots?: Maybe<Array<TimeSlot>>;
  novaSheet: TreatmentSheet;
  openConversationsCount?: Maybe<Scalars['Int']['output']>;
  /** Gets an order by id */
  order?: Maybe<Order>;
  orderFlag?: Maybe<OrderFlag>;
  orderFlags: Array<OrderFlag>;
  orderItems?: Maybe<Array<Maybe<OrderItem>>>;
  orderItemsTotals?: Maybe<OrderItemsTotals>;
  orderLineItems?: Maybe<OrderItemConnection>;
  /** Lists order payment mismatches for client */
  orderPaymentMismatches: Array<OrderPaymentMismatch>;
  /** Lists all orders based on the query */
  orders?: Maybe<Array<Maybe<Order>>>;
  /** @deprecated Please use `patientClinicalItemsPendingApprovalCounts` instead */
  ordersPendingApprovalCounts?: Maybe<OrdersCounts>;
  /** Returns a count of all orders based on a query, excludes datasync imported orders. */
  ordersTotals?: Maybe<OrdersTotals>;
  /** Lookup an org (defaults to viewer's) */
  org?: Maybe<Org>;
  orgDepartments?: Maybe<Array<Maybe<OrgDepartment>>>;
  orgLab?: Maybe<OrgLab>;
  orgLabOrders: Array<LabOrder>;
  orgLabResults: Array<LabResult>;
  orgLabs: Array<OrgLab>;
  /** Returns a list of orphan transactions. Should only be used when the Cubex Two-Way integration is enabled */
  orphanTransactions?: Maybe<MedicationIntegrationTransactionConnection>;
  /** Returns the count of orphan transactions for a location */
  orphanTransactionsCount?: Maybe<Scalars['Int']['output']>;
  orphanedLabs: Array<LabResult>;
  orphanedLabsCount?: Maybe<Scalars['Int']['output']>;
  orphanedLabsPaginated?: Maybe<LabResultConnection>;
  overdueTasksCount?: Maybe<Scalars['Int']['output']>;
  packs?: Maybe<Array<Maybe<Pack>>>;
  /**
   * Runs the paidSales report and returns results inline.
   *
   * This report supports the following breakdowns:
   *  - LOCATION_ID
   *  - REVENUE_CENTER_ID
   *  - PROVIDER_ID
   *  - PRODUCT_ID
   *  - PRODUCT_TYPE_ID
   *  - PRODUCT_CATEGORY_ID
   *  - CLIENT_ID
   *  - PAYROLL_ID
   *
   * If results time out, please fetch smaller date ranges, otherwise please use the alternative
   * `emailPaidsalesReport` query.
   */
  paidSalesReport?: Maybe<Array<Maybe<ReportRow>>>;
  patient?: Maybe<Patient>;
  /** Retrieve a patient's pending approval counts for clinical items. Should only be used when both the Cubex Two-Way integration and the patient orders feature are enabled; otherwise some fields may be unauthorized or null. */
  patientClinicalItemsPendingApprovalCounts?: Maybe<PatientClinicalItemsPendingApprovalCounts>;
  patientCompliances?: Maybe<Array<Maybe<PatientCompliance>>>;
  patientCompliancesCount?: Maybe<Scalars['Int']['output']>;
  patientCompliancesCsvUrl?: Maybe<Scalars['String']['output']>;
  patientComplication?: Maybe<PatientComplication>;
  patientConsentForms?: Maybe<Array<Maybe<ClientConsent>>>;
  /** Get the diagnosis list for a patient */
  patientDiagnoses?: Maybe<Array<Maybe<PatientDiagnosis>>>;
  /** Get diagnostics for a specific patient. Should only be used when the patient orders feature is enabled. */
  patientDiagnostics?: Maybe<DiagnosticConnection>;
  patientDocument?: Maybe<PatientDocument>;
  patientDocuments?: Maybe<PatientDocumentConnection>;
  /** Get encounter products for a specific patient. Should only be used when the patient orders feature is enabled. */
  patientEncounterProducts?: Maybe<EncounterProductConnection>;
  patientLabel?: Maybe<Scalars['String']['output']>;
  patientPlan: PatientPlan;
  /** Retrieve a list of prevention plans at your org */
  patientPlans?: Maybe<Array<Maybe<PatientPlan>>>;
  /** Count prevention plans at your org */
  patientPlansCount?: Maybe<Scalars['Int']['output']>;
  patientProtocols?: Maybe<Array<Maybe<PatientProtocol>>>;
  patientQrCode?: Maybe<Scalars['String']['output']>;
  patientTag?: Maybe<PatientTag>;
  patientTags: Array<PatientTag>;
  /** Get treatments for a specific patient. Should only be used when the patient orders feature is enabled. */
  patientTreatments?: Maybe<TreatmentConnection>;
  /** Retrieve a list of all patients at your org */
  patients: Array<Patient>;
  payment?: Maybe<Payment>;
  paymentProviders?: Maybe<Array<Maybe<Provider>>>;
  paymentReasons?: Maybe<Array<Maybe<PaymentReason>>>;
  payments?: Maybe<Array<Maybe<Payment>>>;
  paymentsTotals?: Maybe<PaymentsTotals>;
  /** Lists payments voided without corresponding account credit voided */
  paymentsVoidedWithoutAccountCreditVoided: Array<Payment>;
  /** The current org's AI PDF extraction rule, if it has one. */
  pdfExtractionRule?: Maybe<PdfExtractionRule>;
  permissions: Array<Permission>;
  /** Retrieve paginated medications with pharmacy statuses */
  pharmacyMedications?: Maybe<MedicationConnection>;
  /** Get count of medications grouped by pharmacy status */
  pharmacyMedicationsCount: Array<Maybe<MedicationStatusCount>>;
  phoneNumbers?: Maybe<Array<Maybe<PhoneNumber>>>;
  plan?: Maybe<PreventionPlan>;
  playPackDeferredRevenueCount?: Maybe<Scalars['Int']['output']>;
  playPackDeferredRevenueReport?: Maybe<PlayPackDeferredRevenueItemConnection>;
  plumbsHandouts?: Maybe<Array<Maybe<PlumbsHandout>>>;
  preventionPlan: PreventionPlan;
  preventionPlans: Array<PreventionPlan>;
  previewCadence?: Maybe<Cadence>;
  /** Gets a price change by id */
  priceChange?: Maybe<PriceChange>;
  /** Lists price changes */
  priceChanges?: Maybe<Array<Maybe<PriceChange>>>;
  problems?: Maybe<Array<Maybe<Problem>>>;
  processorPayments?: Maybe<Array<Maybe<ProcessorPayment>>>;
  product?: Maybe<Product>;
  productCategories: Array<ProductCategory>;
  productCategory?: Maybe<ProductCategory>;
  productHistory?: Maybe<Array<Maybe<InventoryLog>>>;
  productManufacturer?: Maybe<ProductManufacturer>;
  productManufacturers: Array<Maybe<ProductManufacturer>>;
  productManufacturersPaginated: ProductManufacturerPage;
  productPackage?: Maybe<ProductPackage>;
  productPackages?: Maybe<Array<Maybe<ProductPackage>>>;
  productType?: Maybe<ProductType>;
  productTypes: Array<ProductType>;
  products?: Maybe<Array<Maybe<Product>>>;
  productsCount?: Maybe<Scalars['Int']['output']>;
  productsInStockCount?: Maybe<Scalars['Decimal']['output']>;
  protocol: Protocol;
  protocolReminders?: Maybe<Array<Maybe<ProtocolReminder>>>;
  protocolRemindersCount?: Maybe<Scalars['Int']['output']>;
  /**
   * Runs the protocolReminders report and returns results inline.
   *
   * This report supports the following breakdowns:
   *  - LOCATION_ID
   *  - UNSENDABLE_REASON
   *  - DUPLICATE_COUNT
   *  - SENT
   *  - CADENCE
   *  - CONTACT_METHOD
   *  - CONVERSIONS
   *  - CLIENT_ID
   *  - CLIENT_NAME
   *  - PATIENT_ID
   *  - PATIENT_NAME
   *  - CONTAINS_LEGACY_REMINDERS
   *  - RECIPIENT_ADDRESS
   *  - PROTOCOL_ID
   *
   * If results time out, please fetch smaller date ranges, otherwise please use the alternative
   * `emailProtocolremindersReport` query.
   */
  protocolRemindersReport?: Maybe<Scalars['JSON']['output']>;
  protocols: Array<Protocol>;
  /** Lookup a specific provider by id. All users in Vetspire are listed as a provider and have an id. */
  provider?: Maybe<Provider>;
  providerAuthToken?: Maybe<Scalars['String']['output']>;
  providerDepartments?: Maybe<Array<Maybe<Department>>>;
  providerFeatureFlag?: Maybe<ProviderFeatureFlag>;
  providerRole?: Maybe<ProviderRole>;
  providerRoles: Array<ProviderRole>;
  providers?: Maybe<Array<Maybe<Provider>>>;
  purchaseOrder?: Maybe<PurchaseOrder>;
  purchaseOrders?: Maybe<Array<Maybe<PurchaseOrder>>>;
  rabiesCertificate?: Maybe<Scalars['String']['output']>;
  rabiesCertificates?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  rdvm?: Maybe<Rdvm>;
  rdvmContact?: Maybe<RdvmContact>;
  rdvmDocument?: Maybe<RdvmDocument>;
  rdvms: Array<Rdvm>;
  rdvmsCount?: Maybe<Scalars['Int']['output']>;
  /** The current provider's org's most recent successful scribe recordings that have a transcript (newest first, capped). Backs the AI Scribe test reference-encounter picker. Pass `mineOnly: true` to scope to the current provider's own recordings (the Profile picker). Pass `encounterTypeId` to scope to recordings of a single template. */
  recentScribeRecordings?: Maybe<Array<Maybe<ScribeRecording>>>;
  /** Search for recent calls filtering by location phone number */
  recentVoiceCalls?: Maybe<Array<Maybe<VoiceCall>>>;
  recentVoiceCallsCount?: Maybe<Scalars['Int']['output']>;
  reconciliationNotes: Array<ReconciliationNote>;
  refundedOrderItems?: Maybe<Array<Maybe<OrderItem>>>;
  regeneratePatientProtocols?: Maybe<Array<Maybe<PatientProtocol>>>;
  relationships?: Maybe<Array<Maybe<Relationship>>>;
  reminders?: Maybe<Array<Maybe<Reminder>>>;
  reservation: Reservation;
  reservationKennelPdf: Scalars['String']['output'];
  reservations?: Maybe<Array<Reservation>>;
  returnedOrderItems?: Maybe<Array<Maybe<ReturnedOrderItem>>>;
  revenueCenter?: Maybe<RevenueCenter>;
  revenueCenterBudgets?: Maybe<Array<Maybe<RevenueCenterBudget>>>;
  revenueCenters: Array<RevenueCenter>;
  /**
   * Runs the sales report and returns results inline.
   *
   * This report supports the following breakdowns:
   *  - LOCATION_ID
   *  - PROVIDER_ID
   *  - REVENUE_CENTER_ID
   *  - PRODUCT_TYPE_ID
   *  - PRODUCT_CATEGORY_ID
   *  - PRODUCT_ID
   *  - DEPARTMENT_ID
   *  - CLIENT_ID
   *  - PAYROLL_ID
   *  - RDVM_ID
   *
   * If results time out, please fetch smaller date ranges, otherwise please use the alternative
   * `emailSalesReport` query.
   */
  salesReport?: Maybe<Scalars['JSON']['output']>;
  /**
   * Runs the sales report and returns results inline.
   *
   * This report supports the following breakdowns:
   *  - LOCATION_ID
   *  - PROVIDER_ID
   *  - REVENUE_CENTER_ID
   *  - PRODUCT_TYPE_ID
   *  - PRODUCT_CATEGORY_ID
   *  - PRODUCT_ID
   *  - DEPARTMENT_ID
   *  - CLIENT_ID
   *  - PAYROLL_ID
   *  - RDVM_ID
   *
   * If results time out, please fetch smaller date ranges, otherwise please use the alternative
   * `emailSalesReport` query.
   */
  salesTypedReport?: Maybe<Array<Maybe<ReportRow>>>;
  scheduleTemplate?: Maybe<ScheduleTemplate>;
  scheduleTemplates?: Maybe<Array<ScheduleTemplate>>;
  scribeInstructionPreferences?: Maybe<Array<Maybe<EncounterType>>>;
  /** Full-text search for clients or patients at a org */
  searchAccounts?: Maybe<Array<Maybe<ClientResult>>>;
  /** Search diagnoses by term */
  searchDiagnoses?: Maybe<Array<Maybe<Diagnosis>>>;
  searchLocationTags?: Maybe<Array<Maybe<LocationTag>>>;
  searchMacros?: Maybe<Array<Maybe<Macro>>>;
  searchPackages?: Maybe<Array<Maybe<ProductPackage>>>;
  /** Search for the computers associated with PrintNode account */
  searchPrintnodeComputers?: Maybe<Array<Maybe<PrintnodeComputersField>>>;
  /** Search for the printers associated with PrintNode account */
  searchPrintnodePrinters?: Maybe<Array<PrintnodePrintersField>>;
  searchProductCategories?: Maybe<Array<Maybe<ProductCategory>>>;
  searchProductTypes?: Maybe<Array<Maybe<ProductType>>>;
  /** Search orderable products and, when `search_packages` is enabled, product packages. By default excludes products/product_types with `only_inventory: true`; pass `include_only_inventory: true` to include them (e.g. Purchase Orders). */
  searchProductables?: Maybe<Array<Maybe<Orderable>>>;
  /** Search products. By default excludes products with `only_inventory: true` and products whose product_type has `only_inventory: true`. Pass `include_only_inventory: true` to include them (e.g. Purchase Orders). */
  searchProducts?: Maybe<Array<Maybe<Product>>>;
  searchRdvms: Array<Rdvm>;
  searchTagGroups?: Maybe<Array<EntityTagGroup>>;
  selfCheckInLink?: Maybe<Scalars['String']['output']>;
  sentAutoMessages: Array<SentAutoMessage>;
  sentReminders?: Maybe<Array<Maybe<SentReminder>>>;
  species?: Maybe<Array<Maybe<Species>>>;
  stockLocation?: Maybe<StockLocation>;
  stockLocations?: Maybe<Array<Maybe<StockLocation>>>;
  /** @deprecated Please see `stockTransferRequest` / `stockTransferRequests` instead. This API will be removed soon. */
  stockTransfer?: Maybe<StockTransfer>;
  stockTransferLocationReport?: Maybe<Array<Maybe<StockTransferLocationItem>>>;
  stockTransferReportRecipients?: Maybe<Array<Maybe<StockTransferReportRecipient>>>;
  stockTransferRequest?: Maybe<StockTransferRequest>;
  stockTransferRequestStatusCounts?: Maybe<StockTransferRequestStatusCounts>;
  stockTransferRequests?: Maybe<StockTransferRequestConnection>;
  stockTransferTemplate?: Maybe<StockTransferTemplate>;
  stockTransferTemplates?: Maybe<StockTransferTemplateConnection>;
  stockTransferTemplatesCount?: Maybe<Scalars['Int']['output']>;
  /** @deprecated Please see `stockTransferRequest` / `stockTransferRequests` instead. This API will be removed soon. */
  stockTransfers?: Maybe<Array<Maybe<StockTransfer>>>;
  storedLabTests?: Maybe<Array<Maybe<LabTest>>>;
  stripeConnectionToken?: Maybe<Scalars['String']['output']>;
  stripeGetClientSecret: StripeClientSecret;
  stripeGetCustomer?: Maybe<StripeCustomer>;
  stripePaymentIntent?: Maybe<StripePaymentIntent>;
  stripePublishableKey?: Maybe<Scalars['String']['output']>;
  stripeReader?: Maybe<StripeReader>;
  stripeReaders?: Maybe<Array<Maybe<StripeReader>>>;
  task?: Maybe<Task>;
  taskCategories?: Maybe<Array<Maybe<TaskCategory>>>;
  taskGroups?: Maybe<Array<Maybe<TaskGroup>>>;
  /** Query for a list of tasks */
  tasks?: Maybe<Array<Maybe<Task>>>;
  tasksCount?: Maybe<Scalars['Int']['output']>;
  /**
   * Runs the tips report and returns results inline.
   *
   * This report supports the following breakdowns:
   *  - LOCATION_ID
   *  - TIPPED_PROVIDER_ID
   *  - CLIENT_ID
   *
   * If results time out, please fetch smaller date ranges, otherwise please use the alternative
   * `emailTipsReport` query.
   */
  tipsReport?: Maybe<Array<Maybe<ReportRow>>>;
  totalClients?: Maybe<Scalars['Int']['output']>;
  totalPatients?: Maybe<Scalars['Int']['output']>;
  /** Get the active travel zones configured for the current provider's org */
  travelZones: Array<TravelZone>;
  treatment?: Maybe<Treatment>;
  treatmentSheet?: Maybe<TreatmentSheet>;
  treatmentSheetProviderTransfers?: Maybe<Array<Maybe<ProviderTransfer>>>;
  treatmentSheetRow?: Maybe<TreatmentSheetRow>;
  treatmentSheetTemplate: TreatmentSheetTemplate;
  treatmentSheetTemplates?: Maybe<Array<Maybe<TreatmentSheetTemplate>>>;
  treatmentSheets: Array<TreatmentSheet>;
  treatmentSummary?: Maybe<Scalars['String']['output']>;
  treatments?: Maybe<Array<Maybe<Treatment>>>;
  trigger?: Maybe<Trigger>;
  triggers?: Maybe<Array<Maybe<Trigger>>>;
  unreadConversations?: Maybe<Array<Maybe<Conversation>>>;
  unreadConversationsCount?: Maybe<Scalars['Int']['output']>;
  unreadConversationsPaginated?: Maybe<ConversationConnection>;
  unreadNotificationsCount?: Maybe<Scalars['Int']['output']>;
  upennLabTests?: Maybe<Array<Maybe<Product>>>;
  usageReport?: Maybe<UsageReport>;
  vendor?: Maybe<Vendor>;
  vendors?: Maybe<Array<Maybe<Vendor>>>;
  videoRoomToken?: Maybe<Scalars['String']['output']>;
  /** Lookup the viewer */
  viewer?: Maybe<Viewer>;
  /** Lookup the viewer */
  viewerSubscription?: Maybe<Viewer>;
  visit?: Maybe<Visit>;
  visits: Array<RdvmVisit>;
  /** Counts total visits for this rDVM */
  visitsCount?: Maybe<Scalars['Int']['output']>;
  visitsReport?: Maybe<VisitsReportItemConnection>;
  visitsReportCount?: Maybe<Scalars['Int']['output']>;
  /** Historical vitals */
  vitals?: Maybe<Array<Maybe<Vitals>>>;
  /** Format for vitals */
  vitalsTemplate?: Maybe<Array<Maybe<VitalDatum>>>;
  voidablePaymentMethods?: Maybe<Array<Maybe<PaymentMethod>>>;
};


export type RootQueryTypeAccountCreditHistoryArgs = {
  clientId: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<InputMaybe<AccountCreditHistoryOrderBy>>>;
};


export type RootQueryTypeAccountCreditsVoidedWithoutPaymentVoidedArgs = {
  clientId: Scalars['ID']['input'];
};


export type RootQueryTypeAccountsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<AccountsFilters>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<InputMaybe<AccountsOrderBy>>>;
};


export type RootQueryTypeAccountsReceivableBalanceArgs = {
  clientId?: InputMaybe<Scalars['ID']['input']>;
};


export type RootQueryTypeActiveBoardRowsArgs = {
  locationId: Scalars['ID']['input'];
};


export type RootQueryTypeActiveVoiceCallsArgs = {
  locationId: Scalars['ID']['input'];
};


export type RootQueryTypeAddressesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  updatedAtEnd?: InputMaybe<Scalars['NaiveDateTime']['input']>;
  updatedAtStart?: InputMaybe<Scalars['NaiveDateTime']['input']>;
};


export type RootQueryTypeAgedAccountsReceivableArgs = {
  asAt: Scalars['Date']['input'];
  breakdown: ArBreakdown;
  bucketFilter?: InputMaybe<Scalars['String']['input']>;
  clientId?: InputMaybe<Scalars['ID']['input']>;
  clientTagIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  locationIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type RootQueryTypeAgedAccountsReceivableTotalsArgs = {
  asAt: Scalars['Date']['input'];
  breakdown: ArBreakdown;
  bucketFilter?: InputMaybe<Scalars['String']['input']>;
  clientId?: InputMaybe<Scalars['ID']['input']>;
  clientTagIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  locationIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};


export type RootQueryTypeAlertArgs = {
  id: Scalars['ID']['input'];
};


export type RootQueryTypeAlertsArgs = {
  updatedAtEnd?: InputMaybe<Scalars['NaiveDateTime']['input']>;
  updatedAtStart?: InputMaybe<Scalars['NaiveDateTime']['input']>;
};


export type RootQueryTypeAllergiesArgs = {
  patientId: Scalars['ID']['input'];
};


export type RootQueryTypeAnalyticsArgs = {
  endDate?: InputMaybe<Scalars['Date']['input']>;
  fields?: InputMaybe<Array<InputMaybe<AnalyticsField>>>;
  modifiers?: InputMaybe<Array<InputMaybe<AnalyticsFieldModifier>>>;
  segment?: InputMaybe<AnalyticsSegment>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
};


export type RootQueryTypeAppointmentArgs = {
  id: Scalars['ID']['input'];
};


export type RootQueryTypeAppointmentRemindersArgs = {
  patientId: Scalars['ID']['input'];
  start?: InputMaybe<Scalars['DateTime']['input']>;
};


export type RootQueryTypeAppointmentTypeTagArgs = {
  id: Scalars['ID']['input'];
};


export type RootQueryTypeAppointmentTypeTagsArgs = {
  locationId?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};


export type RootQueryTypeAppointmentTypesArgs = {
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  sortByPosition?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAtEnd?: InputMaybe<Scalars['NaiveDateTime']['input']>;
  updatedAtStart?: InputMaybe<Scalars['NaiveDateTime']['input']>;
};


export type RootQueryTypeAppointmentsArgs = {
  appointmentTypeIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  apptOnly?: InputMaybe<Scalars['Boolean']['input']>;
  censusAssignment?: InputMaybe<CensusAppointmentAssignmentFilter>;
  clientId?: InputMaybe<Scalars['ID']['input']>;
  daycareOnly?: InputMaybe<Scalars['Boolean']['input']>;
  end?: InputMaybe<Scalars['DateTime']['input']>;
  historicalId?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  includeCompleted?: InputMaybe<Scalars['Boolean']['input']>;
  includeDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  isLive?: InputMaybe<Scalars['Boolean']['input']>;
  isOngoing?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  locationId?: InputMaybe<Scalars['ID']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  onlyDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  onlyToday?: InputMaybe<Scalars['Boolean']['input']>;
  patientId?: InputMaybe<Scalars['ID']['input']>;
  patientIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  providerId?: InputMaybe<Scalars['ID']['input']>;
  start?: InputMaybe<Scalars['DateTime']['input']>;
  statuses?: InputMaybe<Array<InputMaybe<AppointmentStatus>>>;
  updatedAtEnd?: InputMaybe<Scalars['NaiveDateTime']['input']>;
  updatedAtStart?: InputMaybe<Scalars['NaiveDateTime']['input']>;
  visitTypes?: InputMaybe<Array<VisitType>>;
};


export type RootQueryTypeAppointmentsReportArgs = {
  breakdowns?: InputMaybe<Array<InputMaybe<ReportBreakdown>>>;
  clientTagIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  endDate: Scalars['Date']['input'];
  localTimezone?: InputMaybe<Scalars['String']['input']>;
  locationIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  segment?: InputMaybe<ReportSegment>;
  startDate: Scalars['Date']['input'];
};


export type RootQueryTypeArReconciliationIssuesArgs = {
  includeReviewed: Scalars['Boolean']['input'];
};


export type RootQueryTypeAsyncMedicalRecordArgs = {
  id: Scalars['String']['input'];
};


export type RootQueryTypeAutoMessageArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type RootQueryTypeAutoMessagesArgs = {
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  updatedAtEnd?: InputMaybe<Scalars['NaiveDateTime']['input']>;
  updatedAtStart?: InputMaybe<Scalars['NaiveDateTime']['input']>;
};


export type RootQueryTypeAvailableCagesArgs = {
  endDate: Scalars['Date']['input'];
  locationId: Scalars['ID']['input'];
  patientId?: InputMaybe<Scalars['ID']['input']>;
  startDate: Scalars['Date']['input'];
};


export type RootQueryTypeAvailableOrgLabTypesArgs = {
  locationId?: InputMaybe<Scalars['ID']['input']>;
};


export type RootQueryTypeAvailableTimesArgs = {
  appointmentTypeId: Scalars['ID']['input'];
  date: Scalars['Date']['input'];
  firstAvailable?: InputMaybe<Scalars['Boolean']['input']>;
  locationId: Scalars['ID']['input'];
  numberOfPets?: InputMaybe<Scalars['Int']['input']>;
};


export type RootQueryTypeBillingGroupArgs = {
  id: Scalars['ID']['input'];
};


export type RootQueryTypeBillingGroupsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<BillingGroupFilters>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<InputMaybe<BillingGroupOrderBy>>>;
};


export type RootQueryTypeBillingGroupsCountArgs = {
  filters?: InputMaybe<BillingGroupFilters>;
};


export type RootQueryTypeBillsArgs = {
  clientId: Scalars['ID']['input'];
};


export type RootQueryTypeBoardCellArgs = {
  id: Scalars['ID']['input'];
};


export type RootQueryTypeBoardGroupsArgs = {
  category?: InputMaybe<Scalars['String']['input']>;
};


export type RootQueryTypeBoardRowArgs = {
  id: Scalars['ID']['input'];
};


export type RootQueryTypeBoardingCagesArgs = {
  locationId: Scalars['ID']['input'];
};


export type RootQueryTypeBoardingWardsArgs = {
  filters?: InputMaybe<BoardingWardFilters>;
  locationId: Scalars['ID']['input'];
};


export type RootQueryTypeBookedDaysArgs = {
  endDate: Scalars['Date']['input'];
  locationId: Scalars['ID']['input'];
  startDate: Scalars['Date']['input'];
};


export type RootQueryTypeCadenceArgs = {
  id: Scalars['ID']['input'];
};


export type RootQueryTypeCadencesArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
};


export type RootQueryTypeCagesArgs = {
  locationId?: InputMaybe<Scalars['ID']['input']>;
  patientId?: InputMaybe<Scalars['ID']['input']>;
};


export type RootQueryTypeCalculateBolusValuesArgs = {
  amount?: InputMaybe<Scalars['Decimal']['input']>;
  overPeriod: Scalars['Int']['input'];
  patientId: Scalars['ID']['input'];
  totalAmount?: InputMaybe<Scalars['Decimal']['input']>;
};


export type RootQueryTypeCalculateDosageArgs = {
  doseUnit?: InputMaybe<Scalars['String']['input']>;
  inputType?: InputMaybe<DosageInputType>;
  inputValue: Scalars['Decimal']['input'];
  patientId: Scalars['ID']['input'];
  productConfigId: Scalars['ID']['input'];
  treatmentType?: InputMaybe<DosageTreatmentType>;
};


export type RootQueryTypeCallLogArgs = {
  id: Scalars['ID']['input'];
};


export type RootQueryTypeCallLogsArgs = {
  insertedAtEnd?: InputMaybe<Scalars['NaiveDateTime']['input']>;
  insertedAtStart?: InputMaybe<Scalars['NaiveDateTime']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  locationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  patientId?: InputMaybe<Scalars['ID']['input']>;
};


export type RootQueryTypeCallLogsCountArgs = {
  insertedAtEnd?: InputMaybe<Scalars['NaiveDateTime']['input']>;
  insertedAtStart?: InputMaybe<Scalars['NaiveDateTime']['input']>;
  locationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type RootQueryTypeCallLogsReportArgs = {
  breakdowns?: InputMaybe<Array<InputMaybe<ReportBreakdown>>>;
  clientTagIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  endDate: Scalars['Date']['input'];
  localTimezone?: InputMaybe<Scalars['String']['input']>;
  locationIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  segment?: InputMaybe<ReportSegment>;
  startDate: Scalars['Date']['input'];
};


export type RootQueryTypeCallsReportArgs = {
  breakdowns?: InputMaybe<Array<InputMaybe<ReportBreakdown>>>;
  clientTagIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  endDate: Scalars['Date']['input'];
  localTimezone?: InputMaybe<Scalars['String']['input']>;
  locationIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  segment?: InputMaybe<ReportSegment>;
  startDate: Scalars['Date']['input'];
};


export type RootQueryTypeCardconnectVerifyCredentialsArgs = {
  boltApiKey: Scalars['String']['input'];
  boltApiKeyRequired: Scalars['Boolean']['input'];
  merchantId: Scalars['String']['input'];
  password: Scalars['String']['input'];
  username: Scalars['String']['input'];
};


export type RootQueryTypeCareCreditAccessTokenArgs = {
  locationId: Scalars['ID']['input'];
};


export type RootQueryTypeCareTeamRolesArgs = {
  locationId?: InputMaybe<Scalars['ID']['input']>;
};


export type RootQueryTypeCcTerminalsArgs = {
  locationId: Scalars['ID']['input'];
};


export type RootQueryTypeCensusArgs = {
  filters?: InputMaybe<CensusFilters>;
  locationId: Scalars['ID']['input'];
};


export type RootQueryTypeChangelogsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters: ChangelogFilters;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<InputMaybe<ChangelogOrderBy>>>;
};


export type RootQueryTypeChangelogsCountArgs = {
  filters: ChangelogFilters;
};


export type RootQueryTypeChangelogsEntitySourcesArgs = {
  insertedAtEnd: Scalars['NaiveDateTime']['input'];
  insertedAtStart: Scalars['NaiveDateTime']['input'];
};


export type RootQueryTypeCheckDuplicatePhoneNumberArgs = {
  input: PhoneNumberInput;
};


export type RootQueryTypeClientArgs = {
  id: Scalars['ID']['input'];
};


export type RootQueryTypeClientAccountCreditsByLocationArgs = {
  clientId: Scalars['ID']['input'];
};


export type RootQueryTypeClientConsentArgs = {
  id: Scalars['ID']['input'];
};


export type RootQueryTypeClientReferralSourceArgs = {
  id: Scalars['ID']['input'];
};


export type RootQueryTypeClientReferralSourcesArgs = {
  updatedAtEnd?: InputMaybe<Scalars['NaiveDateTime']['input']>;
  updatedAtStart?: InputMaybe<Scalars['NaiveDateTime']['input']>;
};


export type RootQueryTypeClientTagArgs = {
  id: Scalars['ID']['input'];
};


export type RootQueryTypeClientsArgs = {
  filters?: InputMaybe<ClientFilters>;
  insertedAtEnd?: InputMaybe<Scalars['NaiveDateTime']['input']>;
  insertedAtStart?: InputMaybe<Scalars['NaiveDateTime']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<SortOptions>;
  updatedAtEnd?: InputMaybe<Scalars['NaiveDateTime']['input']>;
  updatedAtStart?: InputMaybe<Scalars['NaiveDateTime']['input']>;
};


export type RootQueryTypeClientsCountArgs = {
  filters?: InputMaybe<ClientFilters>;
  insertedAtEnd?: InputMaybe<Scalars['NaiveDateTime']['input']>;
  insertedAtStart?: InputMaybe<Scalars['NaiveDateTime']['input']>;
  sortBy?: InputMaybe<SortOptions>;
};


export type RootQueryTypeComplicationsArgs = {
  updatedAtEnd?: InputMaybe<Scalars['NaiveDateTime']['input']>;
  updatedAtStart?: InputMaybe<Scalars['NaiveDateTime']['input']>;
};


export type RootQueryTypeConsentFormArgs = {
  id: Scalars['ID']['input'];
  shouldConvertUrlsToATags?: InputMaybe<Scalars['Boolean']['input']>;
};


export type RootQueryTypeConsentFormsArgs = {
  onlyEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};


export type RootQueryTypeContactsArgs = {
  rdvmId?: InputMaybe<Scalars['ID']['input']>;
};


export type RootQueryTypeConversationArgs = {
  id: Scalars['ID']['input'];
};


export type RootQueryTypeConversationsArgs = {
  clientId?: InputMaybe<Scalars['ID']['input']>;
  closed?: InputMaybe<Scalars['Boolean']['input']>;
  excludeEmpty?: InputMaybe<Scalars['Boolean']['input']>;
  excludeProtocols?: InputMaybe<Scalars['Boolean']['input']>;
  locationId?: InputMaybe<Scalars['ID']['input']>;
  onlyViewer?: InputMaybe<Scalars['Boolean']['input']>;
  patientId?: InputMaybe<Scalars['ID']['input']>;
  start?: InputMaybe<Scalars['DateTime']['input']>;
};


export type RootQueryTypeConversationsPaginatedArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  clientId?: InputMaybe<Scalars['ID']['input']>;
  closed?: InputMaybe<Scalars['Boolean']['input']>;
  excludeEmpty?: InputMaybe<Scalars['Boolean']['input']>;
  excludeProtocols?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  locationId?: InputMaybe<Scalars['ID']['input']>;
  onlyViewer?: InputMaybe<Scalars['Boolean']['input']>;
  patientId?: InputMaybe<Scalars['ID']['input']>;
  start?: InputMaybe<Scalars['DateTime']['input']>;
};


export type RootQueryTypeCoownersArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  updatedAtEnd?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAtStart?: InputMaybe<Scalars['DateTime']['input']>;
};


export type RootQueryTypeCountArgs = {
  breakdowns?: InputMaybe<Array<InputMaybe<AnalyticsBreakdown>>>;
  endDate: Scalars['Date']['input'];
  field: AnalyticsField;
  filters?: InputMaybe<Array<InputMaybe<Filter>>>;
  segment?: InputMaybe<AnalyticsSegment>;
  startDate: Scalars['Date']['input'];
};


export type RootQueryTypeCountAppointmentProvidersArgs = {
  end?: InputMaybe<Scalars['DateTime']['input']>;
  segment: TimeSegment;
  start?: InputMaybe<Scalars['DateTime']['input']>;
};


export type RootQueryTypeCountAppointmentsArgs = {
  end?: InputMaybe<Scalars['DateTime']['input']>;
  segment: TimeSegment;
  start?: InputMaybe<Scalars['DateTime']['input']>;
};


export type RootQueryTypeCountNewClientsArgs = {
  end?: InputMaybe<Scalars['DateTime']['input']>;
  segment: TimeSegment;
  start?: InputMaybe<Scalars['DateTime']['input']>;
};


export type RootQueryTypeCountViewerAppointmentsArgs = {
  end?: InputMaybe<Scalars['DateTime']['input']>;
  segment: TimeSegment;
  start?: InputMaybe<Scalars['DateTime']['input']>;
};


export type RootQueryTypeCouponArgs = {
  id: Scalars['ID']['input'];
};


export type RootQueryTypeCouponDiscountsReportArgs = {
  breakdowns?: InputMaybe<Array<InputMaybe<ReportBreakdown>>>;
  clientTagIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  endDate: Scalars['Date']['input'];
  localTimezone?: InputMaybe<Scalars['String']['input']>;
  locationIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  segment?: InputMaybe<ReportSegment>;
  startDate: Scalars['Date']['input'];
};


export type RootQueryTypeCouponsArgs = {
  clientId?: InputMaybe<Scalars['ID']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  locationId?: InputMaybe<Scalars['ID']['input']>;
  patientId?: InputMaybe<Scalars['ID']['input']>;
};


export type RootQueryTypeCreditMemosArgs = {
  alertIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  clientTagIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  end: Scalars['DateTime']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  locationIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  patientTagIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  start: Scalars['DateTime']['input'];
  updatedAtEnd?: InputMaybe<Scalars['NaiveDateTime']['input']>;
  updatedAtStart?: InputMaybe<Scalars['NaiveDateTime']['input']>;
};


export type RootQueryTypeCreditMemosTotalsArgs = {
  alertIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  clientTagIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  end?: InputMaybe<Scalars['DateTime']['input']>;
  locationIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  patientTagIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  start?: InputMaybe<Scalars['DateTime']['input']>;
};


export type RootQueryTypeCreditMigrationsVoidedArgs = {
  clientId: Scalars['ID']['input'];
};


export type RootQueryTypeCustomAppointmentFieldValuesArgs = {
  appointmentId?: InputMaybe<Scalars['ID']['input']>;
  customAppointmentFieldId?: InputMaybe<Scalars['ID']['input']>;
};


export type RootQueryTypeCustomAppointmentFieldsArgs = {
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
};


export type RootQueryTypeCustomClientFieldValuesArgs = {
  clientId?: InputMaybe<Scalars['ID']['input']>;
  customClientFieldId?: InputMaybe<Scalars['ID']['input']>;
};


export type RootQueryTypeCustomClientFieldsArgs = {
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
};


export type RootQueryTypeCustomPatientFieldValuesArgs = {
  appointmentId?: InputMaybe<Scalars['ID']['input']>;
  customPatientFieldId?: InputMaybe<Scalars['ID']['input']>;
  patientId?: InputMaybe<Scalars['ID']['input']>;
};


export type RootQueryTypeCustomPatientFieldsArgs = {
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
};


export type RootQueryTypeDailyStockTransferReportArgs = {
  locationId: Scalars['ID']['input'];
  productIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  stockLocationIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type RootQueryTypeDeceasedPatientsCountArgs = {
  endDate?: InputMaybe<Scalars['Date']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
};


export type RootQueryTypeDeceasedPatientsReportArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
};


export type RootQueryTypeDepartmentsArgs = {
  locationId: Scalars['ID']['input'];
};


export type RootQueryTypeDetailedCreditsCountArgs = {
  alertIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  clientTagIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
  locationIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  patientTagIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  providerIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
};


export type RootQueryTypeDetailedCreditsReportArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  alertIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  before?: InputMaybe<Scalars['String']['input']>;
  clientTagIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locationIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  patientTagIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  providerIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
};


export type RootQueryTypeDetailedSalesRevenueCountArgs = {
  alertIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  clientTagIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  endDate: Scalars['Date']['input'];
  locationIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  patientTagIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  providerIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  startDate: Scalars['Date']['input'];
};


export type RootQueryTypeDetailedSalesRevenueReportArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  alertIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  before?: InputMaybe<Scalars['String']['input']>;
  clientTagIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  endDate: Scalars['Date']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locationIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  patientTagIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  providerIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  startDate: Scalars['Date']['input'];
};


export type RootQueryTypeDetectStripePaymentTypeArgs = {
  locationId?: InputMaybe<Scalars['ID']['input']>;
  paymentIntentId: Scalars['String']['input'];
};


export type RootQueryTypeDiagnosticArgs = {
  id: Scalars['ID']['input'];
};


export type RootQueryTypeDiagnosticsArgs = {
  clientId?: InputMaybe<Scalars['ID']['input']>;
  patientId?: InputMaybe<Scalars['ID']['input']>;
  updatedAtEnd?: InputMaybe<Scalars['NaiveDateTime']['input']>;
  updatedAtStart?: InputMaybe<Scalars['NaiveDateTime']['input']>;
};


export type RootQueryTypeEmailAppointmentsReportArgs = {
  breakdowns?: InputMaybe<Array<InputMaybe<ReportBreakdown>>>;
  clientTagIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  emailAddresses: Array<Scalars['String']['input']>;
  endDate: Scalars['Date']['input'];
  localTimezone?: InputMaybe<Scalars['String']['input']>;
  locationIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  segment?: InputMaybe<ReportSegment>;
  startDate: Scalars['Date']['input'];
};


export type RootQueryTypeEmailCallLogsReportArgs = {
  breakdowns?: InputMaybe<Array<InputMaybe<ReportBreakdown>>>;
  clientTagIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  emailAddresses: Array<Scalars['String']['input']>;
  endDate: Scalars['Date']['input'];
  localTimezone?: InputMaybe<Scalars['String']['input']>;
  locationIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  segment?: InputMaybe<ReportSegment>;
  startDate: Scalars['Date']['input'];
};


export type RootQueryTypeEmailCallsReportArgs = {
  breakdowns?: InputMaybe<Array<InputMaybe<ReportBreakdown>>>;
  clientTagIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  emailAddresses: Array<Scalars['String']['input']>;
  endDate: Scalars['Date']['input'];
  localTimezone?: InputMaybe<Scalars['String']['input']>;
  locationIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  segment?: InputMaybe<ReportSegment>;
  startDate: Scalars['Date']['input'];
};


export type RootQueryTypeEmailCouponDiscountsReportArgs = {
  breakdowns?: InputMaybe<Array<InputMaybe<ReportBreakdown>>>;
  clientTagIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  emailAddresses: Array<Scalars['String']['input']>;
  endDate: Scalars['Date']['input'];
  localTimezone?: InputMaybe<Scalars['String']['input']>;
  locationIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  segment?: InputMaybe<ReportSegment>;
  startDate: Scalars['Date']['input'];
};


export type RootQueryTypeEmailGrossSalesReportArgs = {
  breakdowns?: InputMaybe<Array<InputMaybe<ReportBreakdown>>>;
  clientTagIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  emailAddresses: Array<Scalars['String']['input']>;
  endDate: Scalars['Date']['input'];
  localTimezone?: InputMaybe<Scalars['String']['input']>;
  locationIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  segment?: InputMaybe<ReportSegment>;
  startDate: Scalars['Date']['input'];
};


export type RootQueryTypeEmailPaidSalesReportArgs = {
  breakdowns?: InputMaybe<Array<InputMaybe<ReportBreakdown>>>;
  clientTagIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  emailAddresses: Array<Scalars['String']['input']>;
  endDate: Scalars['Date']['input'];
  localTimezone?: InputMaybe<Scalars['String']['input']>;
  locationIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  segment?: InputMaybe<ReportSegment>;
  startDate: Scalars['Date']['input'];
};


export type RootQueryTypeEmailProtocolRemindersReportArgs = {
  breakdowns?: InputMaybe<Array<InputMaybe<ReportBreakdown>>>;
  clientTagIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  emailAddresses: Array<Scalars['String']['input']>;
  endDate: Scalars['Date']['input'];
  localTimezone?: InputMaybe<Scalars['String']['input']>;
  locationIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  segment?: InputMaybe<ReportSegment>;
  startDate: Scalars['Date']['input'];
};


export type RootQueryTypeEmailSalesReportArgs = {
  breakdowns?: InputMaybe<Array<InputMaybe<ReportBreakdown>>>;
  clientTagIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  emailAddresses: Array<Scalars['String']['input']>;
  endDate: Scalars['Date']['input'];
  localTimezone?: InputMaybe<Scalars['String']['input']>;
  locationIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  segment?: InputMaybe<ReportSegment>;
  startDate: Scalars['Date']['input'];
};


export type RootQueryTypeEmailTipsReportArgs = {
  breakdowns?: InputMaybe<Array<InputMaybe<ReportBreakdown>>>;
  clientTagIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  emailAddresses: Array<Scalars['String']['input']>;
  endDate: Scalars['Date']['input'];
  localTimezone?: InputMaybe<Scalars['String']['input']>;
  locationIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  segment?: InputMaybe<ReportSegment>;
  startDate: Scalars['Date']['input'];
};


export type RootQueryTypeEncounterArgs = {
  id: Scalars['ID']['input'];
};


export type RootQueryTypeEncounterCareTeamMembersArgs = {
  encounterId: Scalars['ID']['input'];
};


export type RootQueryTypeEncounterProductsArgs = {
  clientId?: InputMaybe<Scalars['ID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  locationId?: InputMaybe<Scalars['ID']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  patientId?: InputMaybe<Scalars['ID']['input']>;
  providerId?: InputMaybe<Scalars['ID']['input']>;
  updatedAtEnd?: InputMaybe<Scalars['NaiveDateTime']['input']>;
  updatedAtStart?: InputMaybe<Scalars['NaiveDateTime']['input']>;
};


export type RootQueryTypeEncounterSummaryArgs = {
  attachmentIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  documentType?: InputMaybe<EncounterSummaryDocumentType>;
  encounterId: Scalars['ID']['input'];
  extras?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  locationId?: InputMaybe<Scalars['ID']['input']>;
  only?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  onlySections?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  unnamedSectionIdxs?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};


export type RootQueryTypeEncounterTypeArgs = {
  id: Scalars['ID']['input'];
};


export type RootQueryTypeEncounterTypesArgs = {
  isEmbeddable?: InputMaybe<Scalars['Boolean']['input']>;
  locationId?: InputMaybe<Scalars['ID']['input']>;
  onlyEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};


export type RootQueryTypeEncountersArgs = {
  additionalProviderOnly?: InputMaybe<Scalars['Boolean']['input']>;
  clientId?: InputMaybe<Scalars['ID']['input']>;
  historicalId?: InputMaybe<Scalars['String']['input']>;
  includeCoowned?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  locationId?: InputMaybe<Scalars['ID']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  patientId?: InputMaybe<Scalars['ID']['input']>;
  providerId?: InputMaybe<Scalars['ID']['input']>;
  signed?: InputMaybe<Scalars['Boolean']['input']>;
  startAfter?: InputMaybe<Scalars['NaiveDateTime']['input']>;
  startBefore?: InputMaybe<Scalars['NaiveDateTime']['input']>;
  updatedAtEnd?: InputMaybe<Scalars['NaiveDateTime']['input']>;
  updatedAtStart?: InputMaybe<Scalars['NaiveDateTime']['input']>;
  viewerOnly?: InputMaybe<Scalars['Boolean']['input']>;
};


export type RootQueryTypeEncountersUpdatedSinceArgs = {
  updatedAt: Scalars['DateTime']['input'];
};


export type RootQueryTypeEntitiesTagArgs = {
  id: Scalars['ID']['input'];
};


export type RootQueryTypeEntityTagArgs = {
  id: Scalars['ID']['input'];
};


export type RootQueryTypeEntityValidationsArgs = {
  updatedAtEnd?: InputMaybe<Scalars['NaiveDateTime']['input']>;
  updatedAtStart?: InputMaybe<Scalars['NaiveDateTime']['input']>;
};


export type RootQueryTypeEstimateArgs = {
  id: Scalars['ID']['input'];
};


export type RootQueryTypeEstimateItemsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  updatedAtEnd?: InputMaybe<Scalars['NaiveDateTime']['input']>;
  updatedAtStart?: InputMaybe<Scalars['NaiveDateTime']['input']>;
};


export type RootQueryTypeEstimatePdfArgs = {
  id: Scalars['ID']['input'];
};


export type RootQueryTypeEstimatesArgs = {
  alertIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  clientId?: InputMaybe<Scalars['ID']['input']>;
  clientTagIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  closed?: InputMaybe<Scalars['Boolean']['input']>;
  end?: InputMaybe<Scalars['DateTime']['input']>;
  invoiced?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  locationId?: InputMaybe<Scalars['ID']['input']>;
  locationIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  patientTagIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  providerId?: InputMaybe<Scalars['ID']['input']>;
  start?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAtEnd?: InputMaybe<Scalars['NaiveDateTime']['input']>;
  updatedAtStart?: InputMaybe<Scalars['NaiveDateTime']['input']>;
};


export type RootQueryTypeEstimatesTotalsArgs = {
  alertIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  clientId?: InputMaybe<Scalars['ID']['input']>;
  clientTagIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  closed?: InputMaybe<Scalars['Boolean']['input']>;
  end?: InputMaybe<Scalars['DateTime']['input']>;
  invoiced?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  locationIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  patientTagIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  providerId?: InputMaybe<Scalars['ID']['input']>;
  start?: InputMaybe<Scalars['DateTime']['input']>;
};


export type RootQueryTypeEventsArgs = {
  locationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  metadata?: InputMaybe<Array<EventMetadataFilter>>;
  since?: InputMaybe<Scalars['NaiveDateTime']['input']>;
  types: Array<Scalars['String']['input']>;
  until?: InputMaybe<Scalars['NaiveDateTime']['input']>;
};


export type RootQueryTypeEventsPaginatedArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  metadata?: InputMaybe<Array<EventMetadataFilter>>;
  orderBy?: InputMaybe<Array<InputMaybe<EventsOrderBy>>>;
  since?: InputMaybe<Scalars['NaiveDateTime']['input']>;
  types: Array<Scalars['String']['input']>;
  until?: InputMaybe<Scalars['NaiveDateTime']['input']>;
};


export type RootQueryTypeExternalCommPreferencesArgs = {
  clientId: Scalars['ID']['input'];
};


export type RootQueryTypeExternalSearchArgs = {
  input?: InputMaybe<ExternalSearchInput>;
};


export type RootQueryTypeFeatureFlagArgs = {
  locationId?: InputMaybe<Scalars['ID']['input']>;
  name: FeatureFlagEnum;
};


export type RootQueryTypeFeatureFlagsArgs = {
  locationId?: InputMaybe<Scalars['ID']['input']>;
  names: Array<InputMaybe<FeatureFlagEnum>>;
};


export type RootQueryTypeFilesArgs = {
  pageToken?: InputMaybe<Scalars['String']['input']>;
  path: Scalars['String']['input'];
};


export type RootQueryTypeFrequenciesArgs = {
  forNovasheet?: InputMaybe<Scalars['Boolean']['input']>;
};


export type RootQueryTypeFulfillmentSourceArgs = {
  id: Scalars['ID']['input'];
};


export type RootQueryTypeFulfillmentSourcesArgs = {
  updatedAtEnd?: InputMaybe<Scalars['NaiveDateTime']['input']>;
  updatedAtStart?: InputMaybe<Scalars['NaiveDateTime']['input']>;
};


export type RootQueryTypeGetCardconnectBaseUrlBySlugArgs = {
  slug: Scalars['String']['input'];
};


export type RootQueryTypeGetCardconnectCardInfoArgs = {
  clientId: Scalars['ID']['input'];
  locationId: Scalars['ID']['input'];
};


export type RootQueryTypeGetCardconnectMerchantSurchargeStatusArgs = {
  locationId: Scalars['ID']['input'];
};


export type RootQueryTypeGetInhouseDevicesArgs = {
  orgLabId: Scalars['ID']['input'];
};


export type RootQueryTypeGetLatestLocationKpisArgs = {
  locationId?: InputMaybe<Scalars['ID']['input']>;
};


export type RootQueryTypeGetPatientDocumentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  excludeMedia?: InputMaybe<Scalars['Boolean']['input']>;
  filters?: InputMaybe<PatientDocumentFilters>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<InputMaybe<PatientDocumentOrderBy>>>;
};


export type RootQueryTypeGetRdvmRecentPatientsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  rdvmId: Scalars['ID']['input'];
};


export type RootQueryTypeGrossSalesReportArgs = {
  breakdowns?: InputMaybe<Array<InputMaybe<ReportBreakdown>>>;
  clientTagIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  endDate: Scalars['Date']['input'];
  localTimezone?: InputMaybe<Scalars['String']['input']>;
  locationIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  segment?: InputMaybe<ReportSegment>;
  startDate: Scalars['Date']['input'];
};


export type RootQueryTypeHasAppointmentBillingAlertArgs = {
  clientId: Scalars['ID']['input'];
};


export type RootQueryTypeHasBalanceDueArgs = {
  clientId: Scalars['ID']['input'];
};


export type RootQueryTypeHospitalizationsArgs = {
  careTeamId?: InputMaybe<Scalars['ID']['input']>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  locationId?: InputMaybe<Scalars['ID']['input']>;
};


export type RootQueryTypeImmunizationArgs = {
  id: Scalars['ID']['input'];
};


export type RootQueryTypeImmunizationPdfArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  isLatest?: InputMaybe<Scalars['Boolean']['input']>;
  locationId: Scalars['ID']['input'];
  patientId: Scalars['ID']['input'];
};


export type RootQueryTypeImmunizationsArgs = {
  clientId?: InputMaybe<Scalars['ID']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  ignoreHistorical?: InputMaybe<Scalars['Boolean']['input']>;
  isLatest?: InputMaybe<Scalars['Boolean']['input']>;
  isRabies?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  locationId?: InputMaybe<Scalars['ID']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  patientId?: InputMaybe<Scalars['ID']['input']>;
  updatedAtEnd?: InputMaybe<Scalars['NaiveDateTime']['input']>;
  updatedAtStart?: InputMaybe<Scalars['NaiveDateTime']['input']>;
};


export type RootQueryTypeImmunizationsDueArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locationId: Scalars['ID']['input'];
  offset?: InputMaybe<Scalars['Int']['input']>;
  showSilenced?: InputMaybe<Scalars['Boolean']['input']>;
  withinDays?: InputMaybe<Scalars['Int']['input']>;
};


export type RootQueryTypeInCollectionsArgs = {
  clientId: Scalars['ID']['input'];
};


export type RootQueryTypeInventoryAdjustmentArgs = {
  locationId: Scalars['ID']['input'];
  lotNumber: Scalars['String']['input'];
  productId?: InputMaybe<Scalars['ID']['input']>;
};


export type RootQueryTypeInventoryAdjustmentsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locationId: Scalars['ID']['input'];
  offset?: InputMaybe<Scalars['Int']['input']>;
  productId?: InputMaybe<Scalars['ID']['input']>;
};


export type RootQueryTypeInvoicePdfArgs = {
  coownerClientId?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
};


export type RootQueryTypeIsDaycareOpenArgs = {
  date: Scalars['Date']['input'];
  locationId: Scalars['ID']['input'];
};


export type RootQueryTypeLabOrderArgs = {
  id: Scalars['ID']['input'];
};


export type RootQueryTypeLabOrdersArgs = {
  patientId: Scalars['ID']['input'];
};


export type RootQueryTypeLabResultArgs = {
  id: Scalars['ID']['input'];
};


export type RootQueryTypeLabResultsArgs = {
  includeAiResults?: InputMaybe<Scalars['Boolean']['input']>;
  patientId: Scalars['ID']['input'];
};


export type RootQueryTypeLabTestsArgs = {
  id: Scalars['ID']['input'];
  locationId?: InputMaybe<Scalars['ID']['input']>;
  modality?: InputMaybe<Scalars['String']['input']>;
};


export type RootQueryTypeLabTrendsArgs = {
  patientId: Scalars['ID']['input'];
};


export type RootQueryTypeLapsingPatientsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locationId: Scalars['ID']['input'];
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type RootQueryTypeLatestDatasyncLogsArgs = {
  locationId: Scalars['ID']['input'];
};


export type RootQueryTypeLatestDeletionLogsArgs = {
  locationId: Scalars['ID']['input'];
};


export type RootQueryTypeLedgerEntriesArgs = {
  account?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
  locationIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
};


export type RootQueryTypeLedgerEntryTotalsArgs = {
  account?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
  locationIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
};


export type RootQueryTypeListEncountersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<EncounterFilters>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<InputMaybe<EncounterOrderBy>>>;
};


export type RootQueryTypeListEncountersCountArgs = {
  filters?: InputMaybe<EncounterFilters>;
};


export type RootQueryTypeListImmunizationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<ImmunizationFilters>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type RootQueryTypeListPatientProtocolsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<PatientProtocolFilters>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<InputMaybe<PatientProtocolOrderBy>>>;
};


export type RootQueryTypeListProvidersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters: ProvidersFilters;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<InputMaybe<ProvidersOrderBy>>>;
};


export type RootQueryTypeListStockTransferTemplatesArgs = {
  stockLocationId: Scalars['ID']['input'];
};


export type RootQueryTypeListTasksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<TasksFilters>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<InputMaybe<TasksOrderBy>>>;
};


export type RootQueryTypeLocationArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type RootQueryTypeLocationAppointmentTypesArgs = {
  includeDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  locationId: Scalars['ID']['input'];
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type RootQueryTypeLocationChatMessagesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locationId: Scalars['ID']['input'];
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type RootQueryTypeLocationSchedulesArgs = {
  locationId?: InputMaybe<Scalars['ID']['input']>;
  patientId?: InputMaybe<Scalars['ID']['input']>;
};


export type RootQueryTypeLocationTagArgs = {
  id: Scalars['ID']['input'];
};


export type RootQueryTypeLocationsArgs = {
  filters?: InputMaybe<LocationFilters>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  viewerAssignedOnly?: InputMaybe<Scalars['Boolean']['input']>;
};


export type RootQueryTypeLocationsDepartmentsArgs = {
  locationIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};


export type RootQueryTypeMacroArgs = {
  id: Scalars['ID']['input'];
};


export type RootQueryTypeMacrosArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locationIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  updatedAtEnd?: InputMaybe<Scalars['NaiveDateTime']['input']>;
  updatedAtStart?: InputMaybe<Scalars['NaiveDateTime']['input']>;
};


export type RootQueryTypeMacrosCountArgs = {
  locationIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
};


export type RootQueryTypeMandatoryConsentFormsArgs = {
  encounterId: Scalars['ID']['input'];
};


export type RootQueryTypeMedicalRecordsSummaryArgs = {
  abortOnProbableTimeout?: InputMaybe<Scalars['Boolean']['input']>;
  end?: InputMaybe<Scalars['NaiveDateTime']['input']>;
  includeCommunications?: InputMaybe<Scalars['Boolean']['input']>;
  includeDocuments?: InputMaybe<Scalars['Boolean']['input']>;
  includeExams?: InputMaybe<Scalars['Boolean']['input']>;
  includeImmunizations?: InputMaybe<Scalars['Boolean']['input']>;
  includeLabResults?: InputMaybe<Scalars['Boolean']['input']>;
  includeMedications?: InputMaybe<Scalars['Boolean']['input']>;
  includeNotes?: InputMaybe<Scalars['Boolean']['input']>;
  includePrivate?: InputMaybe<Scalars['Boolean']['input']>;
  includeTasks?: InputMaybe<Scalars['Boolean']['input']>;
  includeTreatmentSheets?: InputMaybe<Scalars['Boolean']['input']>;
  locationId?: InputMaybe<Scalars['ID']['input']>;
  onlyIncludeItems?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  onlySigned?: InputMaybe<Scalars['Boolean']['input']>;
  patientId: Scalars['ID']['input'];
  selectedItems?: InputMaybe<SelectedItemsInput>;
  start?: InputMaybe<Scalars['NaiveDateTime']['input']>;
  visitId?: InputMaybe<Scalars['ID']['input']>;
};


export type RootQueryTypeMedicationArgs = {
  id: Scalars['ID']['input'];
};


export type RootQueryTypeMedicationsArgs = {
  clientId?: InputMaybe<Scalars['ID']['input']>;
  hasRefills?: InputMaybe<Scalars['Boolean']['input']>;
  includeFullyWasted?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  locationId?: InputMaybe<Scalars['ID']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  patientId?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<MedicationStatus>;
  updatedAtEnd?: InputMaybe<Scalars['NaiveDateTime']['input']>;
  updatedAtStart?: InputMaybe<Scalars['NaiveDateTime']['input']>;
};


export type RootQueryTypeMedicationsFilledReportArgs = {
  alertIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  clientTagIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  dateFilledEnd: Scalars['Date']['input'];
  dateFilledStart: Scalars['Date']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  locationIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  onlyControlledDrugs?: InputMaybe<Scalars['Boolean']['input']>;
  patientName?: InputMaybe<Scalars['String']['input']>;
  patientTagIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  pharmacyStatus?: InputMaybe<Array<InputMaybe<PharmacyStatus>>>;
  providerIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};


export type RootQueryTypeMedicationsReportArgs = {
  alertIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  clientTagIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  endDate: Scalars['Date']['input'];
  excludeHistorical?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  locationIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  patientName?: InputMaybe<Scalars['String']['input']>;
  patientTagIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  providerIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  startDate: Scalars['Date']['input'];
  status?: InputMaybe<Array<InputMaybe<MedicationStatus>>>;
  visitEndDateEnd?: InputMaybe<Scalars['Date']['input']>;
  visitEndDateStart?: InputMaybe<Scalars['Date']['input']>;
};


export type RootQueryTypeModalitiesArgs = {
  orgLabId: Scalars['ID']['input'];
};


export type RootQueryTypeMonographArgs = {
  category?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  productId?: InputMaybe<Scalars['ID']['input']>;
};


export type RootQueryTypeNewsletterArgs = {
  id: Scalars['ID']['input'];
};


export type RootQueryTypeNewslettersArgs = {
  updatedAtEnd?: InputMaybe<Scalars['NaiveDateTime']['input']>;
  updatedAtStart?: InputMaybe<Scalars['NaiveDateTime']['input']>;
};


export type RootQueryTypeNotificationsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type RootQueryTypeNovaBoardArgs = {
  filters?: InputMaybe<NovaBoardFilters>;
  locationId: Scalars['ID']['input'];
};


export type RootQueryTypeNovaBoardRowCellsArgs = {
  hoursAfter?: InputMaybe<Scalars['Int']['input']>;
  hoursBefore?: InputMaybe<Scalars['Int']['input']>;
  locationId: Scalars['ID']['input'];
  sheetId: Scalars['ID']['input'];
};


export type RootQueryTypeNovaBoardSheetArgs = {
  locationId: Scalars['ID']['input'];
  sheetId: Scalars['ID']['input'];
};


export type RootQueryTypeNovaBoardSlotsArgs = {
  hoursAfter?: InputMaybe<Scalars['Int']['input']>;
  hoursBefore?: InputMaybe<Scalars['Int']['input']>;
  locationId: Scalars['ID']['input'];
};


export type RootQueryTypeNovaSheetArgs = {
  id: Scalars['ID']['input'];
};


export type RootQueryTypeOpenConversationsCountArgs = {
  locationId: Scalars['ID']['input'];
};


export type RootQueryTypeOrderArgs = {
  id: Scalars['ID']['input'];
};


export type RootQueryTypeOrderFlagArgs = {
  id: Scalars['ID']['input'];
};


export type RootQueryTypeOrderFlagsArgs = {
  updatedAtEnd?: InputMaybe<Scalars['NaiveDateTime']['input']>;
  updatedAtStart?: InputMaybe<Scalars['NaiveDateTime']['input']>;
};


export type RootQueryTypeOrderItemsArgs = {
  alertIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  byInvoiceDate?: InputMaybe<Scalars['Boolean']['input']>;
  categoryIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  clientTagIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  dateFilledEnd?: InputMaybe<Scalars['Date']['input']>;
  dateFilledStart?: InputMaybe<Scalars['Date']['input']>;
  declineReasonIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
  excludeHistorical?: InputMaybe<Scalars['Boolean']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  includeDeclined?: InputMaybe<Scalars['Boolean']['input']>;
  isReturned?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  locationIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  names?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  notRendered?: InputMaybe<Scalars['Boolean']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  onlyControlledDrugs?: InputMaybe<Scalars['Boolean']['input']>;
  onlyInventory?: InputMaybe<Scalars['Boolean']['input']>;
  onlyInvoiced?: InputMaybe<Scalars['Boolean']['input']>;
  onlyPosted?: InputMaybe<Scalars['Boolean']['input']>;
  orderFlagIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  packageIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  patientIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  patientTagIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  productIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  providerId?: InputMaybe<Scalars['ID']['input']>;
  providerIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  scheduledDrugTypes?: InputMaybe<Array<InputMaybe<ScheduledDrugType>>>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
  statuses?: InputMaybe<Array<InputMaybe<OrderItemReportStatus>>>;
  typeIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  updatedAtEnd?: InputMaybe<Scalars['NaiveDateTime']['input']>;
  updatedAtStart?: InputMaybe<Scalars['NaiveDateTime']['input']>;
};


export type RootQueryTypeOrderItemsTotalsArgs = {
  alertIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  byInvoiceDate?: InputMaybe<Scalars['Boolean']['input']>;
  clientTagIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  declineReasonIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  end?: InputMaybe<Scalars['Date']['input']>;
  includeDeclined?: InputMaybe<Scalars['Boolean']['input']>;
  isReturned?: InputMaybe<Scalars['Boolean']['input']>;
  locationIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  onlyControlledDrugs?: InputMaybe<Scalars['Boolean']['input']>;
  onlyInvoiced?: InputMaybe<Scalars['Boolean']['input']>;
  orderFlagIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  patientTagIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  providerId?: InputMaybe<Scalars['ID']['input']>;
  providerIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  scheduledDrugTypes?: InputMaybe<Array<InputMaybe<ScheduledDrugType>>>;
  start?: InputMaybe<Scalars['Date']['input']>;
  statuses?: InputMaybe<Array<InputMaybe<OrderItemReportStatus>>>;
};


export type RootQueryTypeOrderLineItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<OrderLineItemsFilters>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<InputMaybe<OrderLineItemsOrderBy>>>;
};


export type RootQueryTypeOrderPaymentMismatchesArgs = {
  clientId: Scalars['ID']['input'];
};


export type RootQueryTypeOrdersArgs = {
  alertIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  clientId?: InputMaybe<Scalars['ID']['input']>;
  clientTagIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  end?: InputMaybe<Scalars['DateTime']['input']>;
  excludeHistorical?: InputMaybe<Scalars['Boolean']['input']>;
  hideSubscriptions?: InputMaybe<Scalars['Boolean']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  includeAccountCredits?: InputMaybe<Scalars['Boolean']['input']>;
  includeNegatives?: InputMaybe<Scalars['Boolean']['input']>;
  invoiced?: InputMaybe<Scalars['Boolean']['input']>;
  invoicedBy?: InputMaybe<Scalars['DateTime']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  localTimezone?: InputMaybe<Scalars['String']['input']>;
  locationId?: InputMaybe<Scalars['ID']['input']>;
  locationIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  mismatched?: InputMaybe<Scalars['Boolean']['input']>;
  notUncollectible?: InputMaybe<Scalars['Boolean']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  onlyDiscounted?: InputMaybe<Scalars['Boolean']['input']>;
  onlySubscriptions?: InputMaybe<Scalars['Boolean']['input']>;
  orderBy?: InputMaybe<InvoiceSortFieldEnum>;
  orderFlagIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  patientTagIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  posted?: InputMaybe<Scalars['Boolean']['input']>;
  providerId?: InputMaybe<Scalars['ID']['input']>;
  start?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAtEnd?: InputMaybe<Scalars['NaiveDateTime']['input']>;
  updatedAtStart?: InputMaybe<Scalars['NaiveDateTime']['input']>;
};


export type RootQueryTypeOrdersPendingApprovalCountsArgs = {
  locationId: Scalars['ID']['input'];
  patientId: Scalars['ID']['input'];
};


export type RootQueryTypeOrdersTotalsArgs = {
  agingBuckets?: InputMaybe<Scalars['Boolean']['input']>;
  alertIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  clientId?: InputMaybe<Scalars['ID']['input']>;
  clientTagIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  end?: InputMaybe<Scalars['DateTime']['input']>;
  excludeHistorical?: InputMaybe<Scalars['Boolean']['input']>;
  excludeHistoricalTotals?: InputMaybe<Scalars['Boolean']['input']>;
  hideSubscriptions?: InputMaybe<Scalars['Boolean']['input']>;
  includeAccountCredits?: InputMaybe<Scalars['Boolean']['input']>;
  includeNegatives?: InputMaybe<Scalars['Boolean']['input']>;
  invoiced?: InputMaybe<Scalars['Boolean']['input']>;
  localTimezone?: InputMaybe<Scalars['String']['input']>;
  locationIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  mismatched?: InputMaybe<Scalars['Boolean']['input']>;
  notUncollectible?: InputMaybe<Scalars['Boolean']['input']>;
  onlySubscriptions?: InputMaybe<Scalars['Boolean']['input']>;
  orderFlagIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  patientTagIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  posted?: InputMaybe<Scalars['Boolean']['input']>;
  providerId?: InputMaybe<Scalars['ID']['input']>;
  start?: InputMaybe<Scalars['DateTime']['input']>;
};


export type RootQueryTypeOrgLabArgs = {
  id: Scalars['ID']['input'];
};


export type RootQueryTypeOrgLabOrdersArgs = {
  updatedAtEnd?: InputMaybe<Scalars['NaiveDateTime']['input']>;
  updatedAtStart?: InputMaybe<Scalars['NaiveDateTime']['input']>;
};


export type RootQueryTypeOrgLabResultsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  updatedAtEnd?: InputMaybe<Scalars['NaiveDateTime']['input']>;
  updatedAtStart?: InputMaybe<Scalars['NaiveDateTime']['input']>;
};


export type RootQueryTypeOrgLabsArgs = {
  locationId?: InputMaybe<Scalars['ID']['input']>;
};


export type RootQueryTypeOrphanTransactionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locationId: Scalars['ID']['input'];
};


export type RootQueryTypeOrphanTransactionsCountArgs = {
  locationId: Scalars['ID']['input'];
};


export type RootQueryTypeOrphanedLabsArgs = {
  locationId: Scalars['ID']['input'];
};


export type RootQueryTypeOrphanedLabsCountArgs = {
  locationId: Scalars['ID']['input'];
};


export type RootQueryTypeOrphanedLabsPaginatedArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locationId: Scalars['ID']['input'];
};


export type RootQueryTypePacksArgs = {
  alertIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  clientId?: InputMaybe<Scalars['ID']['input']>;
  clientTagIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  locationIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};


export type RootQueryTypePaidSalesReportArgs = {
  breakdowns?: InputMaybe<Array<InputMaybe<ReportBreakdown>>>;
  clientTagIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  endDate: Scalars['Date']['input'];
  localTimezone?: InputMaybe<Scalars['String']['input']>;
  locationIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  segment?: InputMaybe<ReportSegment>;
  startDate: Scalars['Date']['input'];
};


export type RootQueryTypePatientArgs = {
  id: Scalars['ID']['input'];
};


export type RootQueryTypePatientClinicalItemsPendingApprovalCountsArgs = {
  locationId: Scalars['ID']['input'];
  patientId: Scalars['ID']['input'];
};


export type RootQueryTypePatientCompliancesArgs = {
  end?: InputMaybe<Scalars['DateTime']['input']>;
  limit?: Scalars['Int']['input'];
  locationIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  offset?: Scalars['Int']['input'];
  patientId?: InputMaybe<Scalars['ID']['input']>;
  patientName?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  protocolName?: InputMaybe<Scalars['String']['input']>;
  showOldReminders?: InputMaybe<Scalars['Boolean']['input']>;
  showSilenced?: InputMaybe<Scalars['Boolean']['input']>;
  start?: InputMaybe<Scalars['DateTime']['input']>;
};


export type RootQueryTypePatientCompliancesCountArgs = {
  end?: InputMaybe<Scalars['DateTime']['input']>;
  locationIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  patientId?: InputMaybe<Scalars['ID']['input']>;
  patientName?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  protocolName?: InputMaybe<Scalars['String']['input']>;
  showOldReminders?: InputMaybe<Scalars['Boolean']['input']>;
  showSilenced?: InputMaybe<Scalars['Boolean']['input']>;
  start?: InputMaybe<Scalars['DateTime']['input']>;
};


export type RootQueryTypePatientCompliancesCsvUrlArgs = {
  end?: InputMaybe<Scalars['DateTime']['input']>;
  locationIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  patientId?: InputMaybe<Scalars['ID']['input']>;
  patientName?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  protocolName?: InputMaybe<Scalars['String']['input']>;
  showOldReminders?: InputMaybe<Scalars['Boolean']['input']>;
  showSilenced?: InputMaybe<Scalars['Boolean']['input']>;
  start?: InputMaybe<Scalars['DateTime']['input']>;
};


export type RootQueryTypePatientComplicationArgs = {
  id: Scalars['ID']['input'];
};


export type RootQueryTypePatientConsentFormsArgs = {
  clientId?: InputMaybe<Scalars['ID']['input']>;
  patientId?: InputMaybe<Scalars['ID']['input']>;
  updatedAtEnd?: InputMaybe<Scalars['NaiveDateTime']['input']>;
  updatedAtStart?: InputMaybe<Scalars['NaiveDateTime']['input']>;
};


export type RootQueryTypePatientDiagnosesArgs = {
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  patientId: Scalars['ID']['input'];
};


export type RootQueryTypePatientDiagnosticsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locationStatusFilter: Scalars['ID']['input'];
  patientId: Scalars['ID']['input'];
  status?: InputMaybe<Array<InputMaybe<DiagnosticStatus>>>;
};


export type RootQueryTypePatientDocumentArgs = {
  id: Scalars['ID']['input'];
};


export type RootQueryTypePatientDocumentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<PatientDocumentFilters>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<InputMaybe<PatientDocumentOrderBy>>>;
};


export type RootQueryTypePatientEncounterProductsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locationStatusFilter: Scalars['ID']['input'];
  patientId: Scalars['ID']['input'];
  status?: InputMaybe<Array<InputMaybe<EncounterProductStatus>>>;
};


export type RootQueryTypePatientLabelArgs = {
  id: Scalars['ID']['input'];
  locationId: Scalars['ID']['input'];
  type?: InputMaybe<Scalars['String']['input']>;
};


export type RootQueryTypePatientPlanArgs = {
  id: Scalars['ID']['input'];
};


export type RootQueryTypePatientPlansArgs = {
  filters?: InputMaybe<PatientPlanFilters>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type RootQueryTypePatientPlansCountArgs = {
  filters?: InputMaybe<PatientPlanFilters>;
};


export type RootQueryTypePatientProtocolsArgs = {
  endDate?: InputMaybe<Scalars['Date']['input']>;
  endDueDate?: InputMaybe<Scalars['Date']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  locationIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<TriggeredProtocolsSortFieldEnum>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
  startDueDate?: InputMaybe<Scalars['Date']['input']>;
  updatedAtEnd?: InputMaybe<Scalars['NaiveDateTime']['input']>;
  updatedAtStart?: InputMaybe<Scalars['NaiveDateTime']['input']>;
};


export type RootQueryTypePatientQrCodeArgs = {
  id: Scalars['ID']['input'];
};


export type RootQueryTypePatientTagArgs = {
  id: Scalars['ID']['input'];
};


export type RootQueryTypePatientTagsArgs = {
  updatedAtEnd?: InputMaybe<Scalars['NaiveDateTime']['input']>;
  updatedAtStart?: InputMaybe<Scalars['NaiveDateTime']['input']>;
};


export type RootQueryTypePatientTreatmentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locationStatusFilter: Scalars['ID']['input'];
  patientId: Scalars['ID']['input'];
  status?: InputMaybe<Array<InputMaybe<TreatmentStatus>>>;
};


export type RootQueryTypePatientsArgs = {
  filters?: InputMaybe<PatientFilters>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<PatientOrderByEnum>;
  updatedAtEnd?: InputMaybe<Scalars['NaiveDateTime']['input']>;
  updatedAtStart?: InputMaybe<Scalars['NaiveDateTime']['input']>;
};


export type RootQueryTypePaymentArgs = {
  id: Scalars['ID']['input'];
};


export type RootQueryTypePaymentProvidersArgs = {
  alertIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  end?: InputMaybe<Scalars['DateTime']['input']>;
  excludeHistorical?: InputMaybe<Scalars['Boolean']['input']>;
  hideAccountCredit?: InputMaybe<Scalars['Boolean']['input']>;
  locationIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  methods?: InputMaybe<Array<InputMaybe<PaymentMethod>>>;
  start?: InputMaybe<Scalars['DateTime']['input']>;
};


export type RootQueryTypePaymentsArgs = {
  alertIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  clientId?: InputMaybe<Scalars['ID']['input']>;
  clientTagIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  end?: InputMaybe<Scalars['DateTime']['input']>;
  excludeHistorical?: InputMaybe<Scalars['Boolean']['input']>;
  hideAccountCredit?: InputMaybe<Scalars['Boolean']['input']>;
  hideNegativeAccountCredits?: InputMaybe<Scalars['Boolean']['input']>;
  hideVoided?: InputMaybe<Scalars['Boolean']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  locationId?: InputMaybe<Scalars['ID']['input']>;
  locationIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  method?: InputMaybe<PaymentMethod>;
  methods?: InputMaybe<Array<InputMaybe<PaymentMethod>>>;
  methodsToExclude?: InputMaybe<Array<InputMaybe<PaymentMethod>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  onlyPositive?: InputMaybe<Scalars['Boolean']['input']>;
  patientTagIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  providerIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  sort?: InputMaybe<PaymentSort>;
  start?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAtEnd?: InputMaybe<Scalars['NaiveDateTime']['input']>;
  updatedAtStart?: InputMaybe<Scalars['NaiveDateTime']['input']>;
};


export type RootQueryTypePaymentsTotalsArgs = {
  alertIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  clientTagIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  end?: InputMaybe<Scalars['DateTime']['input']>;
  excludeHistorical?: InputMaybe<Scalars['Boolean']['input']>;
  hideAccountCredit?: InputMaybe<Scalars['Boolean']['input']>;
  locationIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  method?: InputMaybe<PaymentMethod>;
  patientTagIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  start?: InputMaybe<Scalars['DateTime']['input']>;
};


export type RootQueryTypePaymentsVoidedWithoutAccountCreditVoidedArgs = {
  clientId: Scalars['ID']['input'];
};


export type RootQueryTypePermissionsArgs = {
  locationId: Scalars['ID']['input'];
};


export type RootQueryTypePharmacyMedicationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  insertedAtEnd?: InputMaybe<Scalars['NaiveDateTime']['input']>;
  insertedAtStart?: InputMaybe<Scalars['NaiveDateTime']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locationId: Scalars['ID']['input'];
  orderBy?: InputMaybe<Array<InputMaybe<PharmacyMedicationsOrderBy>>>;
  pharmacyStatus?: InputMaybe<Array<InputMaybe<PharmacyStatus>>>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Array<InputMaybe<MedicationStatus>>>;
};


export type RootQueryTypePharmacyMedicationsCountArgs = {
  locationId: Scalars['ID']['input'];
};


export type RootQueryTypePhoneNumbersArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  updatedAtEnd?: InputMaybe<Scalars['NaiveDateTime']['input']>;
  updatedAtStart?: InputMaybe<Scalars['NaiveDateTime']['input']>;
};


export type RootQueryTypePlayPackDeferredRevenueCountArgs = {
  alertIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  asAtDate: Scalars['Date']['input'];
  clientTagIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  locationIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  patientTagIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  providerIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};


export type RootQueryTypePlayPackDeferredRevenueReportArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  alertIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  asAtDate: Scalars['Date']['input'];
  before?: InputMaybe<Scalars['String']['input']>;
  clientTagIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locationIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  patientTagIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  providerIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};


export type RootQueryTypePlumbsHandoutsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  term?: InputMaybe<Scalars['String']['input']>;
};


export type RootQueryTypePreventionPlanArgs = {
  id: Scalars['ID']['input'];
};


export type RootQueryTypePreventionPlansArgs = {
  updatedAtEnd?: InputMaybe<Scalars['NaiveDateTime']['input']>;
  updatedAtStart?: InputMaybe<Scalars['NaiveDateTime']['input']>;
};


export type RootQueryTypePreviewCadenceArgs = {
  body: Scalars['String']['input'];
  contactMethod?: InputMaybe<Scalars['String']['input']>;
  subject?: InputMaybe<Scalars['String']['input']>;
};


export type RootQueryTypePriceChangeArgs = {
  id: Scalars['ID']['input'];
};


export type RootQueryTypeProblemsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  updatedAtEnd?: InputMaybe<Scalars['NaiveDateTime']['input']>;
  updatedAtStart?: InputMaybe<Scalars['NaiveDateTime']['input']>;
};


export type RootQueryTypeProcessorPaymentsArgs = {
  end: Scalars['DateTime']['input'];
  locationId: Scalars['ID']['input'];
  start: Scalars['DateTime']['input'];
};


export type RootQueryTypeProductArgs = {
  id: Scalars['ID']['input'];
};


export type RootQueryTypeProductCategoriesArgs = {
  updatedAtEnd?: InputMaybe<Scalars['NaiveDateTime']['input']>;
  updatedAtStart?: InputMaybe<Scalars['NaiveDateTime']['input']>;
};


export type RootQueryTypeProductCategoryArgs = {
  id: Scalars['ID']['input'];
};


export type RootQueryTypeProductHistoryArgs = {
  locationId: Scalars['ID']['input'];
  productId?: InputMaybe<Scalars['ID']['input']>;
};


export type RootQueryTypeProductManufacturerArgs = {
  id: Scalars['ID']['input'];
};


export type RootQueryTypeProductManufacturersArgs = {
  name?: InputMaybe<Scalars['String']['input']>;
};


export type RootQueryTypeProductManufacturersPaginatedArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};


export type RootQueryTypeProductPackageArgs = {
  id: Scalars['ID']['input'];
};


export type RootQueryTypeProductPackagesArgs = {
  locationId?: InputMaybe<Scalars['ID']['input']>;
  updatedAtEnd?: InputMaybe<Scalars['NaiveDateTime']['input']>;
  updatedAtStart?: InputMaybe<Scalars['NaiveDateTime']['input']>;
};


export type RootQueryTypeProductTypeArgs = {
  id: Scalars['ID']['input'];
};


export type RootQueryTypeProductTypesArgs = {
  updatedAtEnd?: InputMaybe<Scalars['NaiveDateTime']['input']>;
  updatedAtStart?: InputMaybe<Scalars['NaiveDateTime']['input']>;
};


export type RootQueryTypeProductsArgs = {
  categoryIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  code?: InputMaybe<Scalars['String']['input']>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  diagnosticCode?: InputMaybe<Scalars['String']['input']>;
  diagnosticCodeOrgLabType?: InputMaybe<OrgLabType>;
  excludeChildren?: InputMaybe<Scalars['Boolean']['input']>;
  excludeDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  excludeOnlyInventory?: InputMaybe<Scalars['Boolean']['input']>;
  hasDiagnosticCode?: InputMaybe<Scalars['Boolean']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  isControlledDrug?: InputMaybe<Scalars['Boolean']['input']>;
  isNonCompensated?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  minimumThreshold?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  onlyBelowThreshold?: InputMaybe<Scalars['ID']['input']>;
  onlyEnabledAt?: InputMaybe<Scalars['ID']['input']>;
  onlyImaging?: InputMaybe<Scalars['Boolean']['input']>;
  onlyTrackInventory?: InputMaybe<Scalars['Boolean']['input']>;
  partialProductId?: InputMaybe<Scalars['String']['input']>;
  realUnitCost?: InputMaybe<Scalars['Decimal']['input']>;
  revenueCenterIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  scheduledDrugTypes?: InputMaybe<Array<InputMaybe<ScheduledDrugType>>>;
  sku?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<SortProductOptions>;
  sortDirection?: InputMaybe<Scalars['String']['input']>;
  sortField?: InputMaybe<Scalars['String']['input']>;
  typeIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  unitCost?: InputMaybe<Scalars['Decimal']['input']>;
  updatedAtEnd?: InputMaybe<Scalars['NaiveDateTime']['input']>;
  updatedAtStart?: InputMaybe<Scalars['NaiveDateTime']['input']>;
};


export type RootQueryTypeProductsCountArgs = {
  categoryIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  code?: InputMaybe<Scalars['String']['input']>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  diagnosticCode?: InputMaybe<Scalars['String']['input']>;
  excludeChildren?: InputMaybe<Scalars['Boolean']['input']>;
  minimumThreshold?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  onlyBelowThreshold?: InputMaybe<Scalars['ID']['input']>;
  onlyEnabledAt?: InputMaybe<Scalars['ID']['input']>;
  onlyTrackInventory?: InputMaybe<Scalars['Boolean']['input']>;
  partialProductId?: InputMaybe<Scalars['String']['input']>;
  realUnitCost?: InputMaybe<Scalars['Decimal']['input']>;
  revenueCenterIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  scheduledDrugTypes?: InputMaybe<Array<InputMaybe<ScheduledDrugType>>>;
  sku?: InputMaybe<Scalars['String']['input']>;
  typeIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  unitCost?: InputMaybe<Scalars['Decimal']['input']>;
};


export type RootQueryTypeProductsInStockCountArgs = {
  insertedAt?: InputMaybe<Scalars['NaiveDateTime']['input']>;
  locationId: Scalars['ID']['input'];
};


export type RootQueryTypeProtocolArgs = {
  id: Scalars['ID']['input'];
};


export type RootQueryTypeProtocolRemindersArgs = {
  cadenceId?: InputMaybe<Scalars['ID']['input']>;
  clientId?: InputMaybe<Scalars['ID']['input']>;
  contactMethod?: InputMaybe<CadenceContactMethods>;
  insertedAtEnd?: InputMaybe<Scalars['DateTime']['input']>;
  insertedAtStart?: InputMaybe<Scalars['DateTime']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  locationId?: InputMaybe<Scalars['ID']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<SortFieldEnum>;
  patientId?: InputMaybe<Scalars['ID']['input']>;
  protocolId?: InputMaybe<Scalars['ID']['input']>;
  sent?: InputMaybe<Scalars['Boolean']['input']>;
  unsendable?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAtEnd?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAtStart?: InputMaybe<Scalars['DateTime']['input']>;
};


export type RootQueryTypeProtocolRemindersReportArgs = {
  breakdowns?: InputMaybe<Array<InputMaybe<ReportBreakdown>>>;
  clientTagIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  endDate: Scalars['Date']['input'];
  localTimezone?: InputMaybe<Scalars['String']['input']>;
  locationIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  segment?: InputMaybe<ReportSegment>;
  startDate: Scalars['Date']['input'];
};


export type RootQueryTypeProtocolsArgs = {
  updatedAtEnd?: InputMaybe<Scalars['NaiveDateTime']['input']>;
  updatedAtStart?: InputMaybe<Scalars['NaiveDateTime']['input']>;
};


export type RootQueryTypeProviderArgs = {
  id: Scalars['ID']['input'];
};


export type RootQueryTypeProviderAuthTokenArgs = {
  providerId: Scalars['ID']['input'];
};


export type RootQueryTypeProviderDepartmentsArgs = {
  locationIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  providerId: Scalars['ID']['input'];
};


export type RootQueryTypeProviderFeatureFlagArgs = {
  locationId?: InputMaybe<Scalars['ID']['input']>;
  name: FeatureFlagEnum;
};


export type RootQueryTypeProviderRoleArgs = {
  id: Scalars['ID']['input'];
};


export type RootQueryTypeProviderRolesArgs = {
  updatedAtEnd?: InputMaybe<Scalars['NaiveDateTime']['input']>;
  updatedAtStart?: InputMaybe<Scalars['NaiveDateTime']['input']>;
};


export type RootQueryTypeProvidersArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  locationId?: InputMaybe<Scalars['ID']['input']>;
  onlyActive?: InputMaybe<Scalars['Boolean']['input']>;
  vetOnly?: InputMaybe<Scalars['Boolean']['input']>;
};


export type RootQueryTypePurchaseOrderArgs = {
  id: Scalars['ID']['input'];
};


export type RootQueryTypePurchaseOrdersArgs = {
  editedOnly?: InputMaybe<Scalars['Boolean']['input']>;
  locationIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  orderedSince?: InputMaybe<Scalars['Date']['input']>;
  sortDirection?: InputMaybe<SortDirection>;
  sortField?: InputMaybe<PurchaseOrderSortField>;
};


export type RootQueryTypeRabiesCertificateArgs = {
  ignoreHistorical?: InputMaybe<Scalars['Boolean']['input']>;
  locationId?: InputMaybe<Scalars['ID']['input']>;
  patientId: Scalars['ID']['input'];
};


export type RootQueryTypeRabiesCertificatesArgs = {
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  locationId?: InputMaybe<Scalars['ID']['input']>;
  patientId: Scalars['ID']['input'];
};


export type RootQueryTypeRdvmArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type RootQueryTypeRdvmContactArgs = {
  id: Scalars['ID']['input'];
};


export type RootQueryTypeRdvmDocumentArgs = {
  id: Scalars['ID']['input'];
};


export type RootQueryTypeRdvmsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  updatedAtEnd?: InputMaybe<Scalars['NaiveDateTime']['input']>;
  updatedAtStart?: InputMaybe<Scalars['NaiveDateTime']['input']>;
};


export type RootQueryTypeRdvmsCountArgs = {
  includeLocationsUnassigned?: InputMaybe<Scalars['Boolean']['input']>;
  locationIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  primaryLocationId?: InputMaybe<Scalars['ID']['input']>;
  term?: InputMaybe<Scalars['String']['input']>;
};


export type RootQueryTypeRecentScribeRecordingsArgs = {
  encounterTypeId?: InputMaybe<Scalars['ID']['input']>;
  mineOnly?: InputMaybe<Scalars['Boolean']['input']>;
};


export type RootQueryTypeRecentVoiceCallsArgs = {
  insertedAtEnd?: InputMaybe<Scalars['NaiveDateTime']['input']>;
  insertedAtStart?: InputMaybe<Scalars['NaiveDateTime']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  locationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type RootQueryTypeRecentVoiceCallsCountArgs = {
  insertedAtEnd?: InputMaybe<Scalars['NaiveDateTime']['input']>;
  insertedAtStart?: InputMaybe<Scalars['NaiveDateTime']['input']>;
  locationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type RootQueryTypeReconciliationNotesArgs = {
  endDate: Scalars['Date']['input'];
  locationId?: InputMaybe<Scalars['ID']['input']>;
  startDate: Scalars['Date']['input'];
};


export type RootQueryTypeRefundedOrderItemsArgs = {
  end?: InputMaybe<Scalars['DateTime']['input']>;
  locationIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  providerId?: InputMaybe<Scalars['ID']['input']>;
  providerIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  start?: InputMaybe<Scalars['DateTime']['input']>;
};


export type RootQueryTypeRegeneratePatientProtocolsArgs = {
  patientId: Scalars['ID']['input'];
};


export type RootQueryTypeRemindersArgs = {
  insertedAtEnd?: InputMaybe<Scalars['NaiveDateTime']['input']>;
  insertedAtStart?: InputMaybe<Scalars['NaiveDateTime']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  on?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAtEnd?: InputMaybe<Scalars['NaiveDateTime']['input']>;
  updatedAtStart?: InputMaybe<Scalars['NaiveDateTime']['input']>;
};


export type RootQueryTypeReservationArgs = {
  id: Scalars['ID']['input'];
};


export type RootQueryTypeReservationKennelPdfArgs = {
  id: Scalars['ID']['input'];
};


export type RootQueryTypeReservationsArgs = {
  filters?: InputMaybe<ReservationFilters>;
};


export type RootQueryTypeReturnedOrderItemsArgs = {
  alertIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  end?: InputMaybe<Scalars['DateTime']['input']>;
  locationIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  orderFlagIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  providerId?: InputMaybe<Scalars['ID']['input']>;
  providerIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  start?: InputMaybe<Scalars['DateTime']['input']>;
};


export type RootQueryTypeRevenueCenterArgs = {
  id: Scalars['ID']['input'];
};


export type RootQueryTypeRevenueCenterBudgetsArgs = {
  locationId: Scalars['ID']['input'];
  revenueCenterId: Scalars['ID']['input'];
  year: Scalars['Int']['input'];
};


export type RootQueryTypeSalesReportArgs = {
  breakdowns?: InputMaybe<Array<InputMaybe<ReportBreakdown>>>;
  clientTagIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  endDate: Scalars['Date']['input'];
  localTimezone?: InputMaybe<Scalars['String']['input']>;
  locationIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  segment?: InputMaybe<ReportSegment>;
  startDate: Scalars['Date']['input'];
};


export type RootQueryTypeSalesTypedReportArgs = {
  breakdowns?: InputMaybe<Array<InputMaybe<ReportBreakdown>>>;
  clientTagIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  endDate: Scalars['Date']['input'];
  localTimezone?: InputMaybe<Scalars['String']['input']>;
  locationIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  segment?: InputMaybe<ReportSegment>;
  startDate: Scalars['Date']['input'];
};


export type RootQueryTypeScheduleTemplateArgs = {
  id: Scalars['ID']['input'];
};


export type RootQueryTypeScheduleTemplatesArgs = {
  locationId?: InputMaybe<Scalars['ID']['input']>;
  updatedAtEnd?: InputMaybe<Scalars['NaiveDateTime']['input']>;
  updatedAtStart?: InputMaybe<Scalars['NaiveDateTime']['input']>;
};


export type RootQueryTypeSearchAccountsArgs = {
  clientId?: InputMaybe<Scalars['ID']['input']>;
  includeDeceased?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  locationId?: InputMaybe<Scalars['ID']['input']>;
  orgId?: InputMaybe<Scalars['ID']['input']>;
  patientOnlyActive?: InputMaybe<Scalars['Boolean']['input']>;
  query: Scalars['String']['input'];
};


export type RootQueryTypeSearchDiagnosesArgs = {
  limit: Scalars['Int']['input'];
  ontology?: InputMaybe<Scalars['String']['input']>;
  term: Scalars['String']['input'];
};


export type RootQueryTypeSearchLocationTagsArgs = {
  name: Scalars['String']['input'];
};


export type RootQueryTypeSearchMacrosArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locationId?: InputMaybe<Scalars['ID']['input']>;
  term: Scalars['String']['input'];
};


export type RootQueryTypeSearchPackagesArgs = {
  query: Scalars['String']['input'];
};


export type RootQueryTypeSearchPrintnodePrintersArgs = {
  locationId: Scalars['ID']['input'];
};


export type RootQueryTypeSearchProductCategoriesArgs = {
  name: Scalars['String']['input'];
};


export type RootQueryTypeSearchProductTypesArgs = {
  name: Scalars['String']['input'];
};


export type RootQueryTypeSearchProductablesArgs = {
  includeOnlyInventory?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  locationId?: InputMaybe<Scalars['ID']['input']>;
  patientId?: InputMaybe<Scalars['ID']['input']>;
  searchPackages?: InputMaybe<Scalars['Boolean']['input']>;
  term: Scalars['String']['input'];
  typeFlags?: InputMaybe<ProductTypeFlags>;
};


export type RootQueryTypeSearchProductsArgs = {
  includeOnlyInventory?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  locationId?: InputMaybe<Scalars['ID']['input']>;
  term: Scalars['String']['input'];
  typeFlags?: InputMaybe<ProductTypeFlags>;
};


export type RootQueryTypeSearchRdvmsArgs = {
  includeLocationsUnassigned?: InputMaybe<Scalars['Boolean']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  locationIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  primaryLocationId?: InputMaybe<Scalars['ID']['input']>;
  term?: InputMaybe<Scalars['String']['input']>;
};


export type RootQueryTypeSearchTagGroupsArgs = {
  entityName: Scalars['String']['input'];
  locationId: Scalars['ID']['input'];
};


export type RootQueryTypeSelfCheckInLinkArgs = {
  appointmentId: Scalars['ID']['input'];
};


export type RootQueryTypeSentAutoMessagesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  updatedAtEnd?: InputMaybe<Scalars['NaiveDateTime']['input']>;
  updatedAtStart?: InputMaybe<Scalars['NaiveDateTime']['input']>;
};


export type RootQueryTypeSentRemindersArgs = {
  clientId?: InputMaybe<Scalars['ID']['input']>;
  insertedAtEnd?: InputMaybe<Scalars['NaiveDateTime']['input']>;
  insertedAtStart?: InputMaybe<Scalars['NaiveDateTime']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderByEnum>;
  patientId?: InputMaybe<Scalars['ID']['input']>;
  updatedAtEnd?: InputMaybe<Scalars['NaiveDateTime']['input']>;
  updatedAtStart?: InputMaybe<Scalars['NaiveDateTime']['input']>;
};


export type RootQueryTypeSpeciesArgs = {
  activeOnly?: InputMaybe<Scalars['Boolean']['input']>;
};


export type RootQueryTypeStockLocationArgs = {
  id: Scalars['ID']['input'];
  locationId: Scalars['ID']['input'];
};


export type RootQueryTypeStockLocationsArgs = {
  locationId: Scalars['ID']['input'];
};


export type RootQueryTypeStockTransferArgs = {
  id: Scalars['ID']['input'];
};


export type RootQueryTypeStockTransferLocationReportArgs = {
  endDate?: InputMaybe<Scalars['Date']['input']>;
  locationId: Scalars['ID']['input'];
  productCategoryIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  productIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
  toStockLocationIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};


export type RootQueryTypeStockTransferReportRecipientsArgs = {
  locationId: Scalars['ID']['input'];
};


export type RootQueryTypeStockTransferRequestArgs = {
  id: Scalars['ID']['input'];
};


export type RootQueryTypeStockTransferRequestStatusCountsArgs = {
  filters?: InputMaybe<StockTransferRequestFilters>;
  locationId?: InputMaybe<Scalars['ID']['input']>;
};


export type RootQueryTypeStockTransferRequestsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<StockTransferRequestFilters>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locationId?: InputMaybe<Scalars['ID']['input']>;
};


export type RootQueryTypeStockTransferTemplateArgs = {
  id: Scalars['ID']['input'];
};


export type RootQueryTypeStockTransferTemplatesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locationId?: InputMaybe<Scalars['ID']['input']>;
  stockLocationId?: InputMaybe<Scalars['ID']['input']>;
};


export type RootQueryTypeStockTransferTemplatesCountArgs = {
  locationId?: InputMaybe<Scalars['ID']['input']>;
  stockLocationId?: InputMaybe<Scalars['ID']['input']>;
};


export type RootQueryTypeStockTransfersArgs = {
  locationId?: InputMaybe<Scalars['ID']['input']>;
};


export type RootQueryTypeStoredLabTestsArgs = {
  id: Scalars['ID']['input'];
};


export type RootQueryTypeStripeConnectionTokenArgs = {
  locationId: Scalars['ID']['input'];
};


export type RootQueryTypeStripePaymentIntentArgs = {
  locationId?: InputMaybe<Scalars['ID']['input']>;
  paymentIntentId: Scalars['String']['input'];
};


export type RootQueryTypeStripePublishableKeyArgs = {
  locationId?: InputMaybe<Scalars['ID']['input']>;
};


export type RootQueryTypeStripeReaderArgs = {
  locationId?: InputMaybe<Scalars['ID']['input']>;
  readerId: Scalars['String']['input'];
};


export type RootQueryTypeStripeReadersArgs = {
  locationId?: InputMaybe<Scalars['ID']['input']>;
};


export type RootQueryTypeTaskArgs = {
  id: Scalars['ID']['input'];
};


export type RootQueryTypeTaskGroupsArgs = {
  locationId: Scalars['ID']['input'];
};


export type RootQueryTypeTasksArgs = {
  done?: InputMaybe<Scalars['Boolean']['input']>;
  end?: InputMaybe<Scalars['Date']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  locationId?: InputMaybe<Scalars['ID']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  overdue?: InputMaybe<Scalars['Boolean']['input']>;
  patientId?: InputMaybe<Scalars['ID']['input']>;
  start?: InputMaybe<Scalars['Date']['input']>;
  viewerAssigned?: InputMaybe<Scalars['Boolean']['input']>;
};


export type RootQueryTypeTasksCountArgs = {
  done?: InputMaybe<Scalars['Boolean']['input']>;
  end?: InputMaybe<Scalars['Date']['input']>;
  locationId?: InputMaybe<Scalars['ID']['input']>;
  patientId?: InputMaybe<Scalars['ID']['input']>;
  start?: InputMaybe<Scalars['Date']['input']>;
  viewerAssigned?: InputMaybe<Scalars['Boolean']['input']>;
};


export type RootQueryTypeTipsReportArgs = {
  breakdowns?: InputMaybe<Array<InputMaybe<ReportBreakdown>>>;
  clientTagIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  endDate: Scalars['Date']['input'];
  localTimezone?: InputMaybe<Scalars['String']['input']>;
  locationIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  segment?: InputMaybe<ReportSegment>;
  startDate: Scalars['Date']['input'];
};


export type RootQueryTypeTreatmentArgs = {
  id: Scalars['ID']['input'];
};


export type RootQueryTypeTreatmentSheetArgs = {
  id: Scalars['ID']['input'];
};


export type RootQueryTypeTreatmentSheetProviderTransfersArgs = {
  locationId: Scalars['ID']['input'];
  order?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
  treatmentSheetId: Scalars['ID']['input'];
};


export type RootQueryTypeTreatmentSheetRowArgs = {
  id: Scalars['ID']['input'];
};


export type RootQueryTypeTreatmentSheetTemplateArgs = {
  id: Scalars['ID']['input'];
};


export type RootQueryTypeTreatmentSheetTemplatesArgs = {
  locationId?: InputMaybe<Scalars['ID']['input']>;
  onlyEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};


export type RootQueryTypeTreatmentSheetsArgs = {
  isOpen?: InputMaybe<Scalars['Boolean']['input']>;
  isSigned?: InputMaybe<Scalars['Boolean']['input']>;
  locationId?: InputMaybe<Scalars['ID']['input']>;
  patientId?: InputMaybe<Scalars['ID']['input']>;
};


export type RootQueryTypeTreatmentSummaryArgs = {
  includeIncompleteTreatments?: InputMaybe<Scalars['Boolean']['input']>;
  locationId?: InputMaybe<Scalars['ID']['input']>;
  summaryType?: InputMaybe<TreatmentSheetSummaryType>;
  treatmentSheetId: Scalars['ID']['input'];
};


export type RootQueryTypeTreatmentsArgs = {
  clientId?: InputMaybe<Scalars['ID']['input']>;
  updatedAtEnd?: InputMaybe<Scalars['NaiveDateTime']['input']>;
  updatedAtStart?: InputMaybe<Scalars['NaiveDateTime']['input']>;
};


export type RootQueryTypeTriggerArgs = {
  id: Scalars['ID']['input'];
};


export type RootQueryTypeUnreadConversationsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type RootQueryTypeUnreadConversationsPaginatedArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type RootQueryTypeUpennLabTestsArgs = {
  locationId: Scalars['ID']['input'];
  modality: Scalars['String']['input'];
};


export type RootQueryTypeUsageReportArgs = {
  breakdownByProvider?: InputMaybe<Scalars['Boolean']['input']>;
  categoryIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  endDate: Scalars['Date']['input'];
  isReturned?: InputMaybe<Scalars['Boolean']['input']>;
  locationIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  packageIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  productIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  startDate: Scalars['Date']['input'];
  typeIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};


export type RootQueryTypeVendorArgs = {
  id: Scalars['ID']['input'];
};


export type RootQueryTypeVideoRoomTokenArgs = {
  appointmentId: Scalars['ID']['input'];
};


export type RootQueryTypeVisitArgs = {
  id: Scalars['ID']['input'];
};


export type RootQueryTypeVisitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  rdvmId?: InputMaybe<Scalars['ID']['input']>;
};


export type RootQueryTypeVisitsCountArgs = {
  rdvmId?: InputMaybe<Scalars['ID']['input']>;
};


export type RootQueryTypeVisitsReportArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  clientId?: InputMaybe<Scalars['String']['input']>;
  clientName?: InputMaybe<Scalars['String']['input']>;
  encounterSigned?: InputMaybe<Scalars['Boolean']['input']>;
  endDate: Scalars['Date']['input'];
  endTime?: InputMaybe<Scalars['Time']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locationId?: InputMaybe<Scalars['ID']['input']>;
  locationIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  patientId?: InputMaybe<Scalars['String']['input']>;
  patientName?: InputMaybe<Scalars['String']['input']>;
  providerIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  species?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startDate: Scalars['Date']['input'];
  startTime?: InputMaybe<Scalars['Time']['input']>;
  visitTypes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type RootQueryTypeVisitsReportCountArgs = {
  clientId?: InputMaybe<Scalars['String']['input']>;
  clientName?: InputMaybe<Scalars['String']['input']>;
  encounterSigned?: InputMaybe<Scalars['Boolean']['input']>;
  endDate: Scalars['Date']['input'];
  endTime?: InputMaybe<Scalars['Time']['input']>;
  locationId?: InputMaybe<Scalars['ID']['input']>;
  locationIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  patientId?: InputMaybe<Scalars['String']['input']>;
  patientName?: InputMaybe<Scalars['String']['input']>;
  providerIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  species?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startDate: Scalars['Date']['input'];
  startTime?: InputMaybe<Scalars['Time']['input']>;
  visitTypes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type RootQueryTypeVitalsArgs = {
  appointmentId?: InputMaybe<Scalars['ID']['input']>;
  encounterId?: InputMaybe<Scalars['ID']['input']>;
  from?: InputMaybe<Scalars['DateTime']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  patientId?: InputMaybe<Scalars['ID']['input']>;
  updatedAtEnd?: InputMaybe<Scalars['NaiveDateTime']['input']>;
  updatedAtStart?: InputMaybe<Scalars['NaiveDateTime']['input']>;
};


export type RootQueryTypeVitalsTemplateArgs = {
  appointmentId?: InputMaybe<Scalars['ID']['input']>;
};

export type RootSubscriptionType = {
  __typename?: 'RootSubscriptionType';
  agedArReportCompleted?: Maybe<AgedArReportStatus>;
  appointmentUpdated?: Maybe<Appointment>;
  censusUpdated?: Maybe<CensusUpdate>;
  encounterDocuments?: Maybe<Encounter>;
  encounterLinkedEncounters?: Maybe<Encounter>;
  encounterOrders?: Maybe<Encounter>;
  encounterPatientComplications?: Maybe<Encounter>;
  encounterSectionUpdated?: Maybe<EncounterSectionLock>;
  encounterUpdated?: Maybe<Encounter>;
  encounterVitals?: Maybe<Encounter>;
  estimateTaxUpdateStarted?: Maybe<Estimate>;
  estimateTaxUpdated?: Maybe<Estimate>;
  estimateUpdated?: Maybe<Estimate>;
  locationChatMessageAdded?: Maybe<LocationChatMessage>;
  locationChatNotification?: Maybe<LocationChatNotification>;
  notificationCreated?: Maybe<Notification>;
  novaBoardUpdated?: Maybe<NovaBoardUpdatePayload>;
  orderCreated?: Maybe<Order>;
  orderFinalInvoiceTaxFinished?: Maybe<Order>;
  orderFinalInvoiceTaxStarted?: Maybe<Order>;
  orderTaxUpdateStarted?: Maybe<Order>;
  orderTaxUpdated?: Maybe<Order>;
  orderUpdated?: Maybe<Order>;
  /** Subscription for outlook sync completion events */
  outlookSyncCompleted?: Maybe<OutlookSyncResult>;
  patientAlerts?: Maybe<Patient>;
  patientDiagnoses?: Maybe<Patient>;
  patientProblems?: Maybe<Patient>;
  pharmacyMedicationLockUpdated?: Maybe<PharmacyMedicationLock>;
  pharmacyMedicationUpdated?: Maybe<Medication>;
  protocolsRegenerated?: Maybe<Array<Maybe<PatientProtocol>>>;
  reservationCreated?: Maybe<Reservation>;
  reservationDeleted?: Maybe<Reservation>;
  reservationUpdated?: Maybe<Reservation>;
  stockTransferRequestCreated?: Maybe<StockTransferRequest>;
  stockTransferRequestDeleted?: Maybe<StockTransferRequest>;
  stockTransferRequestUpdated?: Maybe<StockTransferRequest>;
  unreadConversationsLatest?: Maybe<Conversation>;
  visitHeaderConfigUpdated?: Maybe<VisitHeaderConfig>;
  voiceCallCreated?: Maybe<VoiceCall>;
};


export type RootSubscriptionTypeAgedArReportCompletedArgs = {
  asAt: Scalars['Date']['input'];
  orgId: Scalars['ID']['input'];
  topic: Scalars['String']['input'];
};


export type RootSubscriptionTypeAppointmentUpdatedArgs = {
  end?: InputMaybe<Scalars['DateTime']['input']>;
  locationId: Scalars['ID']['input'];
  start?: InputMaybe<Scalars['DateTime']['input']>;
};


export type RootSubscriptionTypeCensusUpdatedArgs = {
  locationId: Scalars['ID']['input'];
};


export type RootSubscriptionTypeEncounterDocumentsArgs = {
  encounterId: Scalars['ID']['input'];
};


export type RootSubscriptionTypeEncounterLinkedEncountersArgs = {
  encounterId: Scalars['ID']['input'];
};


export type RootSubscriptionTypeEncounterOrdersArgs = {
  encounterId: Scalars['ID']['input'];
};


export type RootSubscriptionTypeEncounterPatientComplicationsArgs = {
  encounterId: Scalars['ID']['input'];
};


export type RootSubscriptionTypeEncounterSectionUpdatedArgs = {
  encounterId: Scalars['ID']['input'];
};


export type RootSubscriptionTypeEncounterUpdatedArgs = {
  encounterId: Scalars['ID']['input'];
};


export type RootSubscriptionTypeEncounterVitalsArgs = {
  encounterId: Scalars['ID']['input'];
};


export type RootSubscriptionTypeEstimateTaxUpdateStartedArgs = {
  estimateId: Scalars['ID']['input'];
};


export type RootSubscriptionTypeEstimateTaxUpdatedArgs = {
  estimateId: Scalars['ID']['input'];
};


export type RootSubscriptionTypeEstimateUpdatedArgs = {
  estimateId: Scalars['ID']['input'];
};


export type RootSubscriptionTypeLocationChatMessageAddedArgs = {
  locationId: Scalars['ID']['input'];
};


export type RootSubscriptionTypeLocationChatNotificationArgs = {
  locationId: Scalars['ID']['input'];
};


export type RootSubscriptionTypeNovaBoardUpdatedArgs = {
  locationId: Scalars['ID']['input'];
};


export type RootSubscriptionTypeOrderCreatedArgs = {
  clientId: Scalars['ID']['input'];
};


export type RootSubscriptionTypeOrderFinalInvoiceTaxFinishedArgs = {
  orderId: Scalars['ID']['input'];
};


export type RootSubscriptionTypeOrderFinalInvoiceTaxStartedArgs = {
  orderId: Scalars['ID']['input'];
};


export type RootSubscriptionTypeOrderTaxUpdateStartedArgs = {
  orderId: Scalars['ID']['input'];
};


export type RootSubscriptionTypeOrderTaxUpdatedArgs = {
  orderId: Scalars['ID']['input'];
};


export type RootSubscriptionTypeOrderUpdatedArgs = {
  clientId: Scalars['ID']['input'];
};


export type RootSubscriptionTypeOutlookSyncCompletedArgs = {
  appointmentId: Scalars['ID']['input'];
};


export type RootSubscriptionTypePatientAlertsArgs = {
  patientId: Scalars['ID']['input'];
};


export type RootSubscriptionTypePatientDiagnosesArgs = {
  patientId: Scalars['ID']['input'];
};


export type RootSubscriptionTypePatientProblemsArgs = {
  patientId: Scalars['ID']['input'];
};


export type RootSubscriptionTypePharmacyMedicationLockUpdatedArgs = {
  medicationId: Scalars['ID']['input'];
};


export type RootSubscriptionTypePharmacyMedicationUpdatedArgs = {
  locationId: Scalars['ID']['input'];
  patientId?: InputMaybe<Scalars['ID']['input']>;
};


export type RootSubscriptionTypeProtocolsRegeneratedArgs = {
  patientId: Scalars['ID']['input'];
};


export type RootSubscriptionTypeReservationCreatedArgs = {
  locationId: Scalars['ID']['input'];
};


export type RootSubscriptionTypeReservationDeletedArgs = {
  locationId: Scalars['ID']['input'];
};


export type RootSubscriptionTypeReservationUpdatedArgs = {
  locationId: Scalars['ID']['input'];
};


export type RootSubscriptionTypeStockTransferRequestCreatedArgs = {
  locationId: Scalars['ID']['input'];
};


export type RootSubscriptionTypeStockTransferRequestDeletedArgs = {
  locationId: Scalars['ID']['input'];
};


export type RootSubscriptionTypeStockTransferRequestUpdatedArgs = {
  locationId: Scalars['ID']['input'];
};


export type RootSubscriptionTypeVisitHeaderConfigUpdatedArgs = {
  visitId: Scalars['ID']['input'];
};


export type RootSubscriptionTypeVoiceCallCreatedArgs = {
  locationId: Scalars['ID']['input'];
};

export enum RouteType {
  Drops = 'DROPS',
  Injectable = 'INJECTABLE',
  Intramuscular = 'INTRAMUSCULAR',
  Intranasal = 'INTRANASAL',
  Intravenously = 'INTRAVENOUSLY',
  Ointment = 'OINTMENT',
  Oral = 'ORAL',
  Subcutaneous = 'SUBCUTANEOUS',
  Topical = 'TOPICAL',
  Transdermal = 'TRANSDERMAL'
}

export type RowUploadError = {
  __typename?: 'RowUploadError';
  row: Scalars['String']['output'];
};

export type RxDatum = Datum & {
  __typename?: 'RxDatum';
  dispensed?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  prescriber?: Maybe<Scalars['String']['output']>;
  productId?: Maybe<Scalars['ID']['output']>;
  quantity?: Maybe<Scalars['String']['output']>;
  refills?: Maybe<Scalars['String']['output']>;
  refused?: Maybe<Scalars['Boolean']['output']>;
  required?: Maybe<Scalars['Truthy']['output']>;
  sig?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  units?: Maybe<Scalars['String']['output']>;
};

export type SaveTreatmentSheetCellOrderItemInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  quantity?: InputMaybe<Scalars['Decimal']['input']>;
};

export type ScheduleRecurrence = {
  __typename?: 'ScheduleRecurrence';
  end?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  provider?: Maybe<Provider>;
  providerId?: Maybe<Scalars['ID']['output']>;
  repeatDays?: Maybe<Array<Maybe<DayOfWeek>>>;
  scheduleTemplate?: Maybe<ScheduleTemplate>;
  start?: Maybe<Scalars['Date']['output']>;
};

export type ScheduleRecurrenceInput = {
  end: Scalars['Date']['input'];
  locationId: Scalars['ID']['input'];
  providerId: Scalars['ID']['input'];
  repeatDays: Array<DayOfWeek>;
  scheduleTemplateId?: InputMaybe<Scalars['ID']['input']>;
  start: Scalars['Date']['input'];
};

export type ScheduleTemplate = {
  __typename?: 'ScheduleTemplate';
  id?: Maybe<Scalars['ID']['output']>;
  locations?: Maybe<Array<Maybe<Location>>>;
  name?: Maybe<Scalars['String']['output']>;
  ranges?: Maybe<Array<Maybe<ScheduleTemplateRange>>>;
};

export type ScheduleTemplateInput = {
  locations: Array<InputMaybe<Scalars['ID']['input']>>;
  name: Scalars['String']['input'];
  ranges: Array<InputMaybe<ScheduleTemplateRangeInput>>;
};

export type ScheduleTemplateRange = {
  __typename?: 'ScheduleTemplateRange';
  appointmentType?: Maybe<AppointmentType>;
  appointmentTypeId?: Maybe<Scalars['ID']['output']>;
  range?: Maybe<Scalars['Numrange']['output']>;
};

export type ScheduleTemplateRangeInput = {
  appointmentTypeId?: InputMaybe<Scalars['ID']['input']>;
  range?: InputMaybe<Scalars['Numrange']['input']>;
};

/**
 * How a treatment row is scheduled. This, not `frequency`, decides whether a row
 * puts slots on a board or a PDF. `frequency` means one thing — an interval in
 * minutes — and is null whenever there is no interval to state.
 *
 * Clients must read a null or unrecognised value as `SCHEDULED`, and must treat a
 * null or non-positive `frequency` as "no recurrence" whatever the kind says.
 */
export enum ScheduleType {
  /**
   * Reserved: one unbroken administration, nothing discrete to place. Valid to
   * receive so the enum never has to widen, but nothing produces it yet.
   */
  Continuous = 'CONTINUOUS',
  /** A single administration at `start`. `frequency` is always null. */
  Once = 'ONCE',
  /**
   * Administered as needed. Never resolves to due or late. A PRN `frequency` is a
   * **minimum interval** — "no more often than q4h" — and is display only today.
   */
  Prn = 'PRN',
  /** Recurs every `frequency` minutes from `start`. Counts toward overdue. */
  Scheduled = 'SCHEDULED'
}

export enum ScheduledDrugType {
  Schedule1 = 'SCHEDULE1',
  Schedule2 = 'SCHEDULE2',
  Schedule3 = 'SCHEDULE3',
  Schedule4 = 'SCHEDULE4',
  Schedule5 = 'SCHEDULE5'
}

export type ScribeRecording = {
  __typename?: 'ScribeRecording';
  encounter?: Maybe<Encounter>;
  endedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  scribedEncounter?: Maybe<Scalars['JSON']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  transcript?: Maybe<Scalars['JSON']['output']>;
};

export type ScribeTestResult = {
  __typename?: 'ScribeTestResult';
  jobId?: Maybe<Scalars['String']['output']>;
  original?: Maybe<Scalars['JSON']['output']>;
};

export type SelectedItemsInput = {
  selectedAll?: InputMaybe<Scalars['Boolean']['input']>;
  selectedCategories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  selectedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type SentAutoMessage = {
  __typename?: 'SentAutoMessage';
  autoMessage?: Maybe<AutoMessage>;
  id?: Maybe<Scalars['ID']['output']>;
  insertedAt?: Maybe<Scalars['NaiveDateTime']['output']>;
  location?: Maybe<Location>;
  patient?: Maybe<Patient>;
  sentDatetime?: Maybe<Scalars['DateTime']['output']>;
  updatedAt?: Maybe<Scalars['NaiveDateTime']['output']>;
};

export type SentReminder = {
  __typename?: 'SentReminder';
  event?: Maybe<ReminderEvent>;
  eventId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  insertedAt?: Maybe<Scalars['NaiveDateTime']['output']>;
  patient?: Maybe<Patient>;
  reminder?: Maybe<Reminder>;
  reminderType?: Maybe<ReminderType>;
};

export enum Severity {
  Mild = 'MILD',
  Moderate = 'MODERATE',
  Severe = 'SEVERE'
}

/** The sex of the patient is listed as Sex */
export enum Sex {
  Female = 'FEMALE',
  Male = 'MALE',
  Unknown = 'UNKNOWN'
}

export type SketchDatum = Datum & {
  __typename?: 'SketchDatum';
  image?: Maybe<Scalars['String']['output']>;
  inline?: Maybe<Scalars['Truthy']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  required?: Maybe<Scalars['Truthy']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export enum SortDirection {
  Asc = 'ASC',
  Desc = 'DESC'
}

export enum SortFieldEnum {
  InsertedAt = 'INSERTED_AT',
  UpdatedAt = 'UPDATED_AT'
}

export enum SortOptions {
  Alphabetical = 'ALPHABETICAL',
  InsertedAt = 'INSERTED_AT',
  MostRecent = 'MOST_RECENT'
}

export enum SortProductOptions {
  Alphabetical = 'ALPHABETICAL',
  InsertedAt = 'INSERTED_AT',
  LastUsedDate = 'LAST_USED_DATE',
  MostRecent = 'MOST_RECENT'
}

export type Species = {
  __typename?: 'Species';
  code: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  insertedAt?: Maybe<Scalars['NaiveDateTime']['output']>;
  isActive: Scalars['Boolean']['output'];
  label: Scalars['String']['output'];
  sortOrder?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['NaiveDateTime']['output']>;
};

export type SpeciesDosageConfigInput = {
  maxDose: Scalars['Decimal']['input'];
  minDose: Scalars['Decimal']['input'];
  speciesIds: Array<Scalars['ID']['input']>;
  treatmentType?: InputMaybe<DosageTreatmentType>;
};

export type StockLocation = {
  __typename?: 'StockLocation';
  createdBy?: Maybe<Provider>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isDefault: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
};

export type StockLocationInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  locationId: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

export type StockLocationUpdate = {
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  locationId: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

export type StockTransfer = {
  __typename?: 'StockTransfer';
  collectionNotes?: Maybe<Scalars['String']['output']>;
  /** @deprecated Please see request notes, fulfillment item notes, and events on the stock transfer request APIs instead. This field will be removed soon. */
  fulfillmentNotes?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  insertedAt?: Maybe<Scalars['NaiveDateTime']['output']>;
  isReturn?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Please see `stockTransferRequest.requestItems.fulfillmentItems` instead. This field will be removed soon. */
  items?: Maybe<Array<Maybe<StockTransferItem>>>;
  location?: Maybe<Location>;
  /** @deprecated Please see request notes, fulfillment notes, and collection notes instead. This field will be removed soon. */
  notes?: Maybe<Scalars['String']['output']>;
  orderDate?: Maybe<Scalars['DateTime']['output']>;
  outOfStock?: Maybe<Scalars['Boolean']['output']>;
  requestNotes?: Maybe<Scalars['String']['output']>;
  requester?: Maybe<Provider>;
  status?: Maybe<StockTransferStatus>;
  stockLocationFrom?: Maybe<StockLocation>;
  stockLocationTo?: Maybe<StockLocation>;
  transferDate?: Maybe<Scalars['DateTime']['output']>;
  /** @deprecated Please see request notes, fulfillment item notes, and events on the stock transfer request APIs instead. This field will be removed soon. */
  transferNotes?: Maybe<Array<Maybe<StockTransferNote>>>;
  updatedAt?: Maybe<Scalars['NaiveDateTime']['output']>;
};

export type StockTransferFulfillmentItem = {
  __typename?: 'StockTransferFulfillmentItem';
  collectedAt?: Maybe<Scalars['DateTime']['output']>;
  collectedBy?: Maybe<Provider>;
  expirationDate?: Maybe<Scalars['Date']['output']>;
  fulfillmentNote?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  insertedAt?: Maybe<Scalars['NaiveDateTime']['output']>;
  inventoryAdjustment?: Maybe<InventoryAdjustment>;
  lotNumber?: Maybe<Scalars['String']['output']>;
  product?: Maybe<Product>;
  provider?: Maybe<Provider>;
  quantityChangeReason?: Maybe<Scalars['String']['output']>;
  readyAt?: Maybe<Scalars['DateTime']['output']>;
  readyBy?: Maybe<Provider>;
  receivedQuantity?: Maybe<Scalars['Decimal']['output']>;
  status?: Maybe<StockTransferFulfillmentItemStatus>;
  updatedAt?: Maybe<Scalars['NaiveDateTime']['output']>;
};

export enum StockTransferFulfillmentItemStatus {
  Collected = 'COLLECTED',
  Draft = 'DRAFT',
  Ready = 'READY'
}

export type StockTransferInput = {
  locationId?: InputMaybe<Scalars['ID']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  orderDate?: InputMaybe<Scalars['DateTime']['input']>;
  requesterId?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<StockTransferStatus>;
  stockLocationFromId?: InputMaybe<Scalars['ID']['input']>;
  stockLocationToId?: InputMaybe<Scalars['ID']['input']>;
  transferDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type StockTransferItem = {
  __typename?: 'StockTransferItem';
  expirationDate?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  insertedAt?: Maybe<Scalars['NaiveDateTime']['output']>;
  inventoryAdjustment?: Maybe<InventoryAdjustment>;
  lotNumber?: Maybe<Scalars['String']['output']>;
  product?: Maybe<Product>;
  quantity?: Maybe<Scalars['Decimal']['output']>;
  quantityAtLocation?: Maybe<Scalars['Decimal']['output']>;
  quantityChangeReason?: Maybe<Scalars['String']['output']>;
  quantityInRealTime?: Maybe<Scalars['Decimal']['output']>;
  receivedQuantity?: Maybe<Scalars['Decimal']['output']>;
  stockTransfer?: Maybe<StockTransfer>;
  unitCost?: Maybe<Scalars['Decimal']['output']>;
  updatedAt?: Maybe<Scalars['NaiveDateTime']['output']>;
};

export type StockTransferItemInput = {
  expirationDate?: InputMaybe<Scalars['Date']['input']>;
  lotNumber?: InputMaybe<Scalars['String']['input']>;
  quantityChangeReason?: InputMaybe<Scalars['String']['input']>;
  receivedQuantity?: InputMaybe<Scalars['Decimal']['input']>;
};

export type StockTransferLocationItem = {
  __typename?: 'StockTransferLocationItem';
  collectedAt?: Maybe<Scalars['DateTime']['output']>;
  expirationDate?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  lotNumber?: Maybe<Scalars['String']['output']>;
  orderDate?: Maybe<Scalars['DateTime']['output']>;
  product?: Maybe<Product>;
  productId?: Maybe<Scalars['ID']['output']>;
  productName?: Maybe<Scalars['String']['output']>;
  quantityChangeReason?: Maybe<Scalars['String']['output']>;
  receivedQuantity?: Maybe<Scalars['Decimal']['output']>;
  requestedQuantity?: Maybe<Scalars['Decimal']['output']>;
  requesterName?: Maybe<Scalars['String']['output']>;
  status?: Maybe<StockTransferRequestStatus>;
  totalTransferCost?: Maybe<Scalars['Decimal']['output']>;
  transferDate?: Maybe<Scalars['DateTime']['output']>;
  transferFrom?: Maybe<Scalars['String']['output']>;
  transferRequestId?: Maybe<Scalars['ID']['output']>;
  transferTo?: Maybe<Scalars['String']['output']>;
  unitCost?: Maybe<Scalars['Decimal']['output']>;
};

export type StockTransferNote = {
  __typename?: 'StockTransferNote';
  id?: Maybe<Scalars['ID']['output']>;
  insertedAt?: Maybe<Scalars['NaiveDateTime']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  status?: Maybe<StockTransferStatus>;
  stockTransfer?: Maybe<StockTransfer>;
  stockTransferId?: Maybe<Scalars['ID']['output']>;
};

export type StockTransferNoteInput = {
  note?: InputMaybe<Scalars['String']['input']>;
};

export type StockTransferReportRecipient = {
  __typename?: 'StockTransferReportRecipient';
  email?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  locationId?: Maybe<Scalars['ID']['output']>;
  orgId?: Maybe<Scalars['ID']['output']>;
};

export type StockTransferReportRecipientInput = {
  email: Scalars['String']['input'];
  locationId: Scalars['ID']['input'];
};

export type StockTransferRequest = {
  __typename?: 'StockTransferRequest';
  afterHours?: Maybe<Scalars['Boolean']['output']>;
  collectionNotes?: Maybe<Scalars['String']['output']>;
  fromStockLocation?: Maybe<StockLocation>;
  fulfilledItemCount?: Maybe<Scalars['Int']['output']>;
  fulfillmentItems?: Maybe<Array<Maybe<StockTransferFulfillmentItem>>>;
  fulfillmentNotes?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  insertedAt?: Maybe<Scalars['NaiveDateTime']['output']>;
  isPriority?: Maybe<Scalars['Boolean']['output']>;
  isReturn?: Maybe<Scalars['Boolean']['output']>;
  location?: Maybe<Location>;
  orderDate?: Maybe<Scalars['DateTime']['output']>;
  outOfStock?: Maybe<Scalars['Boolean']['output']>;
  partial?: Maybe<Scalars['Boolean']['output']>;
  requestItems?: Maybe<Array<Maybe<StockTransferRequestItem>>>;
  requestNotes?: Maybe<Scalars['String']['output']>;
  requestedItemCount?: Maybe<Scalars['Int']['output']>;
  requester?: Maybe<Provider>;
  status?: Maybe<StockTransferRequestStatus>;
  /** @deprecated Please see `fromStockLocation` instead. This field will be removed soon. */
  stockLocationFrom?: Maybe<StockLocation>;
  /** @deprecated Please see `toStockLocation` instead. This field will be removed soon. */
  stockLocationTo?: Maybe<StockLocation>;
  toStockLocation?: Maybe<StockLocation>;
  transferDate?: Maybe<Scalars['DateTime']['output']>;
  updatedAt?: Maybe<Scalars['NaiveDateTime']['output']>;
};

export type StockTransferRequestConnection = {
  __typename?: 'StockTransferRequestConnection';
  edges?: Maybe<Array<Maybe<StockTransferRequestEdge>>>;
  pageInfo: PageInfo;
};

export type StockTransferRequestEdge = {
  __typename?: 'StockTransferRequestEdge';
  cursor?: Maybe<Scalars['String']['output']>;
  node?: Maybe<StockTransferRequest>;
};

export type StockTransferRequestFilters = {
  afterHours?: InputMaybe<Scalars['Boolean']['input']>;
  fromStockLocationIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  isPriority?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<StockTransferRequestStatus>;
  stockLocationIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  toStockLocationIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type StockTransferRequestItem = {
  __typename?: 'StockTransferRequestItem';
  fulfilledQuantity?: Maybe<Scalars['Decimal']['output']>;
  fulfillmentItems?: Maybe<Array<Maybe<StockTransferFulfillmentItem>>>;
  fulfillmentStatus?: Maybe<StockTransferRequestItemFulfillmentStatus>;
  id?: Maybe<Scalars['ID']['output']>;
  insertedAt?: Maybe<Scalars['NaiveDateTime']['output']>;
  product?: Maybe<Product>;
  remainingQuantity?: Maybe<Scalars['Decimal']['output']>;
  requestedQuantity?: Maybe<Scalars['Decimal']['output']>;
  stockOnHand?: Maybe<Scalars['Decimal']['output']>;
  unitCost?: Maybe<Scalars['Decimal']['output']>;
  updatedAt?: Maybe<Scalars['NaiveDateTime']['output']>;
};

export enum StockTransferRequestItemFulfillmentStatus {
  Collected = 'COLLECTED',
  Draft = 'DRAFT',
  Partial = 'PARTIAL',
  Ready = 'READY'
}

export enum StockTransferRequestStatus {
  Completed = 'COMPLETED',
  Draft = 'DRAFT',
  Requested = 'REQUESTED'
}

export type StockTransferRequestStatusCounts = {
  __typename?: 'StockTransferRequestStatusCounts';
  completed?: Maybe<Scalars['Int']['output']>;
  draft?: Maybe<Scalars['Int']['output']>;
  requested?: Maybe<Scalars['Int']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

export enum StockTransferStatus {
  Collected = 'COLLECTED',
  Draft = 'DRAFT',
  Ready = 'READY',
  Requested = 'REQUESTED'
}

export type StockTransferTemplate = {
  __typename?: 'StockTransferTemplate';
  id?: Maybe<Scalars['ID']['output']>;
  insertedAt?: Maybe<Scalars['NaiveDateTime']['output']>;
  isPriority?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Please see `templateItems` instead. This field will be removed soon. */
  items?: Maybe<Array<Maybe<StockTransferTemplateItem>>>;
  lastUpdatedBy?: Maybe<Provider>;
  location?: Maybe<Location>;
  name?: Maybe<Scalars['String']['output']>;
  /** @deprecated Please see `toStockLocation` instead. This field will be removed soon. */
  stockLocationTo?: Maybe<StockLocation>;
  templateItems?: Maybe<Array<Maybe<StockTransferTemplateItem>>>;
  toStockLocation?: Maybe<StockLocation>;
  updatedAt?: Maybe<Scalars['NaiveDateTime']['output']>;
};

export type StockTransferTemplateConnection = {
  __typename?: 'StockTransferTemplateConnection';
  edges?: Maybe<Array<Maybe<StockTransferTemplateEdge>>>;
  pageInfo: PageInfo;
};

export type StockTransferTemplateEdge = {
  __typename?: 'StockTransferTemplateEdge';
  cursor?: Maybe<Scalars['String']['output']>;
  node?: Maybe<StockTransferTemplate>;
};

export type StockTransferTemplateInput = {
  isPriority?: InputMaybe<Scalars['Boolean']['input']>;
  locationId?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  stockLocationToId?: InputMaybe<Scalars['ID']['input']>;
  templateItems?: InputMaybe<Array<CreateStockTransferTemplateItemInput>>;
  toStockLocationId?: InputMaybe<Scalars['ID']['input']>;
};

export type StockTransferTemplateItem = {
  __typename?: 'StockTransferTemplateItem';
  id?: Maybe<Scalars['ID']['output']>;
  insertedAt?: Maybe<Scalars['NaiveDateTime']['output']>;
  product?: Maybe<Product>;
  /** @deprecated Please see `requestedQuantity` instead. This field will be removed soon. */
  quantity?: Maybe<Scalars['Decimal']['output']>;
  requestedQuantity?: Maybe<Scalars['Decimal']['output']>;
  updatedAt?: Maybe<Scalars['NaiveDateTime']['output']>;
};

export type StripeAddress = {
  __typename?: 'StripeAddress';
  city: Scalars['String']['output'];
  country: Scalars['String']['output'];
  line1: Scalars['String']['output'];
  line2?: Maybe<Scalars['String']['output']>;
  postalCode: Scalars['String']['output'];
  state: Scalars['String']['output'];
};

export type StripeBillingDetails = {
  __typename?: 'StripeBillingDetails';
  address: StripeAddress;
  email?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  phone?: Maybe<Scalars['String']['output']>;
};

export type StripeCard = {
  __typename?: 'StripeCard';
  brand: Scalars['String']['output'];
  expMonth: Scalars['String']['output'];
  expYear: Scalars['String']['output'];
  last4: Scalars['String']['output'];
};

export type StripeClientSecret = {
  __typename?: 'StripeClientSecret';
  clientSecret: Scalars['String']['output'];
  id: Scalars['String']['output'];
};

export type StripeCustomer = {
  __typename?: 'StripeCustomer';
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  invoiceSettings?: Maybe<StripeInvoiceSettings>;
};

export type StripeInvoiceSettings = {
  __typename?: 'StripeInvoiceSettings';
  defaultPaymentMethod?: Maybe<StripePaymentMethod>;
};

/** Payment Intent data returned by Stripe's server side integration. */
export type StripePaymentIntent = {
  __typename?: 'StripePaymentIntent';
  allowedSourceTypes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  amount?: Maybe<Scalars['String']['output']>;
  amountCapturable?: Maybe<Scalars['String']['output']>;
  amountDetails?: Maybe<Scalars['JSON']['output']>;
  amountReceived?: Maybe<Scalars['String']['output']>;
  application?: Maybe<Scalars['String']['output']>;
  applicationFeeAmount?: Maybe<Scalars['String']['output']>;
  automaticPaymentMethods?: Maybe<Scalars['String']['output']>;
  canceledAt?: Maybe<Scalars['String']['output']>;
  cancellationReason?: Maybe<Scalars['String']['output']>;
  captureMethod?: Maybe<Scalars['String']['output']>;
  charges?: Maybe<Scalars['JSON']['output']>;
  clientSecret?: Maybe<Scalars['String']['output']>;
  confirmationMethod?: Maybe<Scalars['String']['output']>;
  created?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  customer?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  invoice?: Maybe<Scalars['String']['output']>;
  lastPaymentError?: Maybe<Scalars['String']['output']>;
  latestCharge?: Maybe<Scalars['String']['output']>;
  livemode?: Maybe<Scalars['String']['output']>;
  metadata?: Maybe<Scalars['JSON']['output']>;
  nextAction?: Maybe<Scalars['String']['output']>;
  nextSourceAction?: Maybe<Scalars['String']['output']>;
  object?: Maybe<Scalars['String']['output']>;
  onBehalfOf?: Maybe<Scalars['String']['output']>;
  paymentMethod?: Maybe<Scalars['String']['output']>;
  paymentMethodOptions?: Maybe<Scalars['JSON']['output']>;
  paymentMethodTypes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  processing?: Maybe<Scalars['String']['output']>;
  receiptEmail?: Maybe<Scalars['String']['output']>;
  review?: Maybe<Scalars['String']['output']>;
  setupFutureUsage?: Maybe<Scalars['String']['output']>;
  shipping?: Maybe<Scalars['String']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  statementDescriptor?: Maybe<Scalars['String']['output']>;
  statementDescriptorSuffix?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  transferData?: Maybe<Scalars['String']['output']>;
  transferGroup?: Maybe<Scalars['String']['output']>;
};

export type StripePaymentMethod = {
  __typename?: 'StripePaymentMethod';
  billingDetails: StripeBillingDetails;
  card?: Maybe<StripeCard>;
  id?: Maybe<Scalars['String']['output']>;
  usBankAccount?: Maybe<StripeUsBankAccount>;
};

export enum StripePaymentType {
  /** Payment was processed via Stripe Terminal (card tap) */
  CardPresent = 'CARD_PRESENT',
  /** Payment was processed via Stripe Interac (Interac debit) */
  InteracPresent = 'INTERAC_PRESENT',
  /** Payment type could not be determined */
  Unknown = 'UNKNOWN'
}

export type StripePaymentTypeResult = {
  __typename?: 'StripePaymentTypeResult';
  paymentIntentId: Scalars['String']['output'];
  type: StripePaymentType;
};

/** Reader data returned by Stripe's server side integration. */
export type StripeReader = {
  __typename?: 'StripeReader';
  action?: Maybe<Scalars['JSON']['output']>;
  deviceSwVersion?: Maybe<Scalars['String']['output']>;
  deviceType?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  ipAddress?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  livemode?: Maybe<Scalars['Boolean']['output']>;
  location?: Maybe<Scalars['String']['output']>;
  metadata?: Maybe<Scalars['JSON']['output']>;
  object?: Maybe<Scalars['String']['output']>;
  serialNumber?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type StripeUsBankAccount = {
  __typename?: 'StripeUsBankAccount';
  bankName: Scalars['String']['output'];
  last4: Scalars['String']['output'];
  routingNumber: Scalars['String']['output'];
};

/** Available subscription models. */
export enum SubscriptionModel {
  Location = 'LOCATION',
  Provider = 'PROVIDER'
}

export type SyncClientInput = {
  identification?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
};

export type SyncClientResult = {
  __typename?: 'SyncClientResult';
  clientId?: Maybe<Scalars['ID']['output']>;
};

/** A task to do assigned to a patient performed at a specific location */
export type Task = {
  __typename?: 'Task';
  /** List of providers who are assigned to complete this task and will be backup */
  assignees?: Maybe<Array<Maybe<Provider>>>;
  comments?: Maybe<Array<Maybe<Comment>>>;
  completedBy?: Maybe<Provider>;
  /** Creator of the task if the task was created by a provider (null if computer-generated) */
  creator?: Maybe<Provider>;
  /** If the task has been deleted */
  deleted?: Maybe<Scalars['Boolean']['output']>;
  /** Description of the task */
  description?: Maybe<Scalars['String']['output']>;
  /** If the task has been done */
  done?: Maybe<Scalars['Boolean']['output']>;
  /** Due date for the task (will alert all assignees when it comes) */
  dueDate?: Maybe<Scalars['Date']['output']>;
  /** Linked encounter */
  encounter?: Maybe<Encounter>;
  id?: Maybe<Scalars['ID']['output']>;
  insertedAt?: Maybe<Scalars['NaiveDateTime']['output']>;
  location?: Maybe<Location>;
  patient?: Maybe<Patient>;
  priority?: Maybe<Scalars['Int']['output']>;
  rdvm?: Maybe<Rdvm>;
  snoozeUntilDueDate?: Maybe<Scalars['Boolean']['output']>;
  taskCategory?: Maybe<TaskCategory>;
  taskGroups?: Maybe<Array<Maybe<TaskGroup>>>;
  /** Title of the task */
  text?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['NaiveDateTime']['output']>;
  visit?: Maybe<Visit>;
};

export type TaskCategory = {
  __typename?: 'TaskCategory';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type TaskCategoryInput = {
  name?: InputMaybe<Scalars['String']['input']>;
};

export type TaskConnection = {
  __typename?: 'TaskConnection';
  edges?: Maybe<Array<Maybe<TaskEdge>>>;
  pageInfo: PageInfo;
};

export type TaskEdge = {
  __typename?: 'TaskEdge';
  cursor?: Maybe<Scalars['String']['output']>;
  node?: Maybe<Task>;
};

export type TaskGroup = {
  __typename?: 'TaskGroup';
  id: Scalars['ID']['output'];
  location?: Maybe<Location>;
  name?: Maybe<Scalars['String']['output']>;
  providers?: Maybe<Array<Maybe<Provider>>>;
};

export type TaskGroupInput = {
  locationId?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  providerIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

export type TaskInput = {
  assigneeIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  done?: InputMaybe<Scalars['Boolean']['input']>;
  dueDate?: InputMaybe<Scalars['Date']['input']>;
  encounterId?: InputMaybe<Scalars['ID']['input']>;
  locationId?: InputMaybe<Scalars['ID']['input']>;
  priority?: InputMaybe<Scalars['Int']['input']>;
  rdvmId?: InputMaybe<Scalars['ID']['input']>;
  /** Due date for the task will send notification on day it is due */
  snoozeUntilDueDate?: InputMaybe<Scalars['Boolean']['input']>;
  taskCategoryId?: InputMaybe<Scalars['ID']['input']>;
  taskGroupIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  text?: InputMaybe<Scalars['String']['input']>;
  visitId?: InputMaybe<Scalars['ID']['input']>;
};

export type TasksFilters = {
  done?: InputMaybe<Scalars['Boolean']['input']>;
  end?: InputMaybe<Scalars['Date']['input']>;
  locationId?: InputMaybe<Scalars['ID']['input']>;
  /** Only show overdue due tasks */
  overdue?: InputMaybe<Scalars['Boolean']['input']>;
  patientId?: InputMaybe<Scalars['ID']['input']>;
  start?: InputMaybe<Scalars['Date']['input']>;
  /** If we should only show tasks assigned to the viewer */
  viewerAssigned?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TasksOrderBy = {
  dueDate?: InputMaybe<OrderByDirection>;
  id?: InputMaybe<OrderByDirection>;
  priority?: InputMaybe<OrderByDirection>;
  updatedAt?: InputMaybe<OrderByDirection>;
};

export type TeletailsSession = {
  __typename?: 'TeletailsSession';
  result?: Maybe<Scalars['String']['output']>;
};

export type TeletailsSessionInput = {
  appointmentId?: InputMaybe<Scalars['ID']['input']>;
  familyName?: InputMaybe<Scalars['String']['input']>;
  givenName?: InputMaybe<Scalars['String']['input']>;
  locationId?: InputMaybe<Scalars['ID']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};

export type TestResult = {
  __typename?: 'TestResult';
  abnormal?: Maybe<Scalars['String']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  inferredResult?: Maybe<InferredResultTypes>;
  name?: Maybe<Scalars['String']['output']>;
  normalMax?: Maybe<Scalars['String']['output']>;
  normalMin?: Maybe<Scalars['String']['output']>;
  rangeMax?: Maybe<Scalars['String']['output']>;
  rangeMin?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  units?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type TextDatum = Datum & {
  __typename?: 'TextDatum';
  highlights?: Maybe<Array<Maybe<Highlight>>>;
  inline?: Maybe<Scalars['Truthy']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  required?: Maybe<Scalars['Truthy']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** Segment a time-range counter by day, week, month, or year */
export enum TimeSegment {
  Day = 'DAY',
  Month = 'MONTH',
  Week = 'WEEK',
  Year = 'YEAR'
}

export type TimeSlot = {
  __typename?: 'TimeSlot';
  displayValue: Scalars['String']['output'];
  hour: Scalars['Int']['output'];
  isDue: Scalars['Boolean']['output'];
  startTime: Scalars['DateTime']['output'];
};

export type TravelZone = {
  __typename?: 'TravelZone';
  color: Scalars['String']['output'];
  futureAppointmentCount: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  insertedAt?: Maybe<Scalars['NaiveDateTime']['output']>;
  name: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['NaiveDateTime']['output']>;
};

export type TravelZoneInput = {
  color?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type Treatment = {
  __typename?: 'Treatment';
  declineReason?: Maybe<DeclineReason>;
  declined?: Maybe<Scalars['Boolean']['output']>;
  encounter?: Maybe<Encounter>;
  id?: Maybe<Scalars['ID']['output']>;
  insertedAt?: Maybe<Scalars['NaiveDateTime']['output']>;
  isIssuedViaCubex?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  packageItem?: Maybe<ProductPackageItem>;
  patient?: Maybe<Patient>;
  product?: Maybe<Product>;
  productId?: Maybe<Scalars['ID']['output']>;
  productSuggestion?: Maybe<ProductSuggestion>;
  provider?: Maybe<Provider>;
  providerId?: Maybe<Scalars['ID']['output']>;
  quantity?: Maybe<Scalars['Decimal']['output']>;
  status?: Maybe<TreatmentStatus>;
  updatedAt?: Maybe<Scalars['NaiveDateTime']['output']>;
  /** The amount wasted from Cubex */
  wasteQuantity?: Maybe<Scalars['Decimal']['output']>;
};

export type TreatmentConnection = {
  __typename?: 'TreatmentConnection';
  edges?: Maybe<Array<Maybe<TreatmentEdge>>>;
  pageInfo: PageInfo;
};

export type TreatmentDatum = Datum & {
  __typename?: 'TreatmentDatum';
  name?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  productId?: Maybe<Scalars['ID']['output']>;
  quantity?: Maybe<Scalars['String']['output']>;
  required?: Maybe<Scalars['Truthy']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type TreatmentEdge = {
  __typename?: 'TreatmentEdge';
  cursor?: Maybe<Scalars['String']['output']>;
  node?: Maybe<Treatment>;
};

export type TreatmentInfo = {
  __typename?: 'TreatmentInfo';
  completedTimes: Array<Scalars['DateTime']['output']>;
  discontinued: Scalars['Boolean']['output'];
  /**
   * Minutes between administrations. It is `scheduleType`, not this, that says
   * whether the row occupies slots.
   */
  frequency?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  /**
   * Owed doses in the hour that were neither given nor skipped. Always empty on a
   * `PRN` or `CONTINUOUS` row: an as-needed dose that was not given is not
   * outstanding work.
   */
  incompleteTimes: Array<Scalars['DateTime']['output']>;
  isBillable: Scalars['Boolean']['output'];
  /**
   * Derived from `scheduleType`. A PRN treatment owes no doses: it contributes to
   * no count, never resolves to `DUE` or `LATE`, and its slots arrive as
   * `prnTimes`.
   * @deprecated Read `scheduleType` instead.
   */
  isPrn: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  /**
   * The times in the hour where a `PRN` row's minimum interval falls — render
   * these as the PRN state, never as owed doses. Non-empty only for a `PRN` row
   * that carries an interval, and absent from every count except `prnCount`.
   */
  prnTimes: Array<Scalars['DateTime']['output']>;
  /** How the row is scheduled. Never null: an unset kind reads as `SCHEDULED`. */
  scheduleType: ScheduleType;
  /**
   * The times this row **owes** a dose at in the hour: its generated occurrences
   * on a `SCHEDULED` or `ONCE` row. On a `PRN` or `CONTINUOUS` row nothing is
   * owed, so what was charted stands in — the completed and skipped times. A PRN
   * row's generated slots are `prnTimes`, never these.
   */
  scheduledTimes: Array<Scalars['DateTime']['output']>;
  skippedTimes: Array<Scalars['DateTime']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  units?: Maybe<TreatmentSheetUnits>;
};

export type TreatmentInput = {
  declineReasonId?: InputMaybe<Scalars['ID']['input']>;
  declined?: InputMaybe<Scalars['Boolean']['input']>;
  encounterId?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  locationId?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  patientId?: InputMaybe<Scalars['ID']['input']>;
  productId?: InputMaybe<Scalars['ID']['input']>;
  productSuggestionId?: InputMaybe<Scalars['ID']['input']>;
  providerId?: InputMaybe<Scalars['ID']['input']>;
  quantity?: InputMaybe<Scalars['Decimal']['input']>;
};

export type TreatmentSheet = {
  __typename?: 'TreatmentSheet';
  careTeamMembers?: Maybe<Array<Maybe<TreatmentSheetCareTeamMember>>>;
  comments?: Maybe<Array<Comment>>;
  department?: Maybe<Department>;
  id: Scalars['ID']['output'];
  insertedAt: Scalars['NaiveDateTime']['output'];
  location?: Maybe<Location>;
  locationId?: Maybe<Scalars['ID']['output']>;
  mergeableTemplate: NovaSheetMergeableTemplate;
  mergeableTemplates: Array<NovaSheetMergeableTemplate>;
  order?: Maybe<Order>;
  patient?: Maybe<Patient>;
  /** Ward and kennel linked to this treatment sheet, including after the sheet is signed or stopped. Null if no placement was recorded for this sheet. For where the patient is now, use Patient.lastKnownLocation. */
  patientLocation?: Maybe<PatientLocation>;
  patientLocations?: Maybe<Array<Maybe<PatientLocation>>>;
  provider?: Maybe<Provider>;
  providerOnShift?: Maybe<Provider>;
  providerTransfers?: Maybe<Array<Maybe<ProviderTransfer>>>;
  rows?: Maybe<Array<Maybe<TreatmentSheetRow>>>;
  signed?: Maybe<Scalars['Boolean']['output']>;
  signedBy?: Maybe<Provider>;
  start?: Maybe<Scalars['DateTime']['output']>;
  stop?: Maybe<Scalars['DateTime']['output']>;
  timeSlots?: Maybe<Array<Maybe<Scalars['DateTime']['output']>>>;
  title?: Maybe<Scalars['String']['output']>;
  visit?: Maybe<Visit>;
  visitAlerts?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  visitProblemsList?: Maybe<Scalars['String']['output']>;
  visitType?: Maybe<Scalars['String']['output']>;
};


export type TreatmentSheetMergeableTemplateArgs = {
  templateId: Scalars['ID']['input'];
};

export type TreatmentSheetCareTeamMember = {
  __typename?: 'TreatmentSheetCareTeamMember';
  careTeamRole?: Maybe<CareTeamRole>;
  careTeamRoleId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  insertedAt?: Maybe<Scalars['NaiveDateTime']['output']>;
  position?: Maybe<Scalars['Int']['output']>;
  provider?: Maybe<Provider>;
  providerId: Scalars['ID']['output'];
  treatmentSheetId: Scalars['ID']['output'];
  updatedAt?: Maybe<Scalars['NaiveDateTime']['output']>;
};

export type TreatmentSheetCareTeamMemberInput = {
  careTeamRoleId: Scalars['ID']['input'];
  providerId: Scalars['ID']['input'];
};

export type TreatmentSheetCell = {
  __typename?: 'TreatmentSheetCell';
  backgroundColor?: Maybe<Scalars['String']['output']>;
  comments?: Maybe<Array<Maybe<TreatmentSheetCellComment>>>;
  id?: Maybe<Scalars['ID']['output']>;
  orderItem?: Maybe<OrderItem>;
  orderItemId?: Maybe<Scalars['ID']['output']>;
  patient?: Maybe<Patient>;
  provider?: Maybe<Provider>;
  skipped?: Maybe<Scalars['Boolean']['output']>;
  start?: Maybe<Scalars['DateTime']['output']>;
  treatmentSheetRowId?: Maybe<Scalars['ID']['output']>;
  unit?: Maybe<TreatmentSheetUnits>;
  value?: Maybe<Scalars['String']['output']>;
};

export type TreatmentSheetCellComment = {
  __typename?: 'TreatmentSheetCellComment';
  datetime?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  provider?: Maybe<Provider>;
  text?: Maybe<Scalars['String']['output']>;
};

export type TreatmentSheetCellInput = {
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  skipped?: InputMaybe<Scalars['Boolean']['input']>;
  start?: InputMaybe<Scalars['DateTime']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export enum TreatmentSheetFormat {
  Decimal = 'DECIMAL',
  Text = 'TEXT'
}

export type TreatmentSheetInput = {
  careTeamMembers?: InputMaybe<Array<InputMaybe<TreatmentSheetCareTeamMemberInput>>>;
  criticalCondition?: InputMaybe<Scalars['Boolean']['input']>;
  patientLocation?: InputMaybe<PatientLocationInput>;
  start?: InputMaybe<Scalars['DateTime']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  visitAlerts?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  visitId?: InputMaybe<Scalars['ID']['input']>;
  visitProblemsList?: InputMaybe<Scalars['String']['input']>;
  visitType?: InputMaybe<VisitType>;
};

export type TreatmentSheetRow = {
  __typename?: 'TreatmentSheetRow';
  additives?: Maybe<Array<Maybe<TreatmentSheetRowAdditive>>>;
  administration?: Maybe<Scalars['String']['output']>;
  boluses?: Maybe<Array<Maybe<TreatmentSheetRowBolus>>>;
  calculatedAmount?: Maybe<Scalars['PlainDecimal']['output']>;
  cells?: Maybe<Array<Maybe<TreatmentSheetCell>>>;
  discontinued?: Maybe<Scalars['Boolean']['output']>;
  dose?: Maybe<Scalars['PlainDecimal']['output']>;
  doseUnit?: Maybe<Scalars['String']['output']>;
  extendedInstructions?: Maybe<Scalars['String']['output']>;
  fluid?: Maybe<TreatmentSheetRowFluid>;
  format?: Maybe<TreatmentSheetFormat>;
  /**
   * Minutes between administrations. Treat null or non-positive as "no
   * recurrence" — do not infer a schedule from it.
   */
  frequency?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  inactiveIntervals?: Maybe<Array<Maybe<TreatmentTimeInterval>>>;
  instructions?: Maybe<Scalars['String']['output']>;
  isBillable?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Derived from `scheduleType` — true exactly when it is `PRN`.
   * @deprecated Read `scheduleType` instead.
   */
  isPrn?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  orderItem?: Maybe<OrderItem>;
  product?: Maybe<Product>;
  productId?: Maybe<Scalars['ID']['output']>;
  quantity?: Maybe<Scalars['PlainDecimal']['output']>;
  /** How the row is scheduled. Never null: an unset kind reads as `SCHEDULED`. */
  scheduleType: ScheduleType;
  start?: Maybe<Scalars['DateTime']['output']>;
  totalDose?: Maybe<Scalars['PlainDecimal']['output']>;
  treatmentSheet?: Maybe<TreatmentSheet>;
  treatmentSheetId?: Maybe<Scalars['ID']['output']>;
  type?: Maybe<TreatmentSheetType>;
  units?: Maybe<TreatmentSheetUnits>;
};

export type TreatmentSheetRowAdditive = {
  __typename?: 'TreatmentSheetRowAdditive';
  amount?: Maybe<Scalars['Decimal']['output']>;
  concentration?: Maybe<Scalars['Decimal']['output']>;
  concentrationUnits?: Maybe<Scalars['String']['output']>;
  entries?: Maybe<Array<Maybe<TreatmentSheetRowAdditiveEntry>>>;
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  product?: Maybe<Product>;
  productId?: Maybe<Scalars['ID']['output']>;
  start?: Maybe<Scalars['DateTime']['output']>;
  treatmentSheetRowId?: Maybe<Scalars['ID']['output']>;
};

export type TreatmentSheetRowAdditiveEntry = {
  __typename?: 'TreatmentSheetRowAdditiveEntry';
  additive?: Maybe<TreatmentSheetRowAdditive>;
  additiveId?: Maybe<Scalars['ID']['output']>;
  enteredAt?: Maybe<Scalars['DateTime']['output']>;
  enteredBy?: Maybe<Provider>;
  enteredById?: Maybe<Scalars['ID']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  isBillable?: Maybe<Scalars['Boolean']['output']>;
  orderItemId?: Maybe<Scalars['ID']['output']>;
  quantity?: Maybe<Scalars['Decimal']['output']>;
};

export type TreatmentSheetRowAdditiveEntryInput = {
  additiveId?: InputMaybe<Scalars['ID']['input']>;
  enteredAt?: InputMaybe<Scalars['DateTime']['input']>;
  enteredById?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  isBillable?: InputMaybe<Scalars['Boolean']['input']>;
  orderItemId?: InputMaybe<Scalars['ID']['input']>;
  quantity?: InputMaybe<Scalars['Decimal']['input']>;
};

export type TreatmentSheetRowAdditiveInput = {
  amount?: InputMaybe<Scalars['Decimal']['input']>;
  concentration?: InputMaybe<Scalars['Decimal']['input']>;
  concentrationUnits?: InputMaybe<Scalars['String']['input']>;
  entries?: InputMaybe<Array<InputMaybe<TreatmentSheetRowAdditiveEntryInput>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  productId?: InputMaybe<Scalars['ID']['input']>;
  start?: InputMaybe<Scalars['DateTime']['input']>;
};

export type TreatmentSheetRowBolus = {
  __typename?: 'TreatmentSheetRowBolus';
  amount?: Maybe<Scalars['Decimal']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  overPeriod?: Maybe<Scalars['Int']['output']>;
  rate?: Maybe<Scalars['Decimal']['output']>;
  start?: Maybe<Scalars['DateTime']['output']>;
  totalAmount?: Maybe<Scalars['Decimal']['output']>;
  treatmentSheetRowId?: Maybe<Scalars['ID']['output']>;
};

export type TreatmentSheetRowBolusInput = {
  amount?: InputMaybe<Scalars['Decimal']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  overPeriod?: InputMaybe<Scalars['Int']['input']>;
  rate?: InputMaybe<Scalars['Decimal']['input']>;
  start?: InputMaybe<Scalars['DateTime']['input']>;
  totalAmount?: InputMaybe<Scalars['Decimal']['input']>;
};

export type TreatmentSheetRowFluid = {
  __typename?: 'TreatmentSheetRowFluid';
  criDeliveryUnits?: Maybe<Scalars['String']['output']>;
  criDilutedConcentration?: Maybe<Scalars['Decimal']['output']>;
  criDilutionInstructions?: Maybe<Scalars['String']['output']>;
  criOriginalConcentration?: Maybe<Scalars['Decimal']['output']>;
  dehydrationDeficit?: Maybe<Scalars['Decimal']['output']>;
  dehydrationPercent?: Maybe<Scalars['Decimal']['output']>;
  dehydrationRestorationMinutes?: Maybe<Scalars['Int']['output']>;
  fluidType?: Maybe<TreatmentSheetRowFluidType>;
  hourlyAmount?: Maybe<Scalars['Decimal']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  maintenanceAmount?: Maybe<Scalars['Decimal']['output']>;
  transfusionDonorBloodType?: Maybe<Scalars['String']['output']>;
  transfusionDonorNumber?: Maybe<Scalars['String']['output']>;
  treatmentSheetRowId?: Maybe<Scalars['ID']['output']>;
};

export type TreatmentSheetRowFluidInput = {
  criDeliveryUnits?: InputMaybe<Scalars['String']['input']>;
  criDilutedConcentration?: InputMaybe<Scalars['Decimal']['input']>;
  criDilutionInstructions?: InputMaybe<Scalars['String']['input']>;
  criOriginalConcentration?: InputMaybe<Scalars['Decimal']['input']>;
  dehydrationDeficit?: InputMaybe<Scalars['Decimal']['input']>;
  dehydrationPercent?: InputMaybe<Scalars['Decimal']['input']>;
  dehydrationRestorationMinutes?: InputMaybe<Scalars['Int']['input']>;
  fluidType?: InputMaybe<Scalars['String']['input']>;
  hourlyAmount?: InputMaybe<Scalars['Decimal']['input']>;
  maintenanceAmount?: InputMaybe<Scalars['Decimal']['input']>;
  transfusionDonorBloodType?: InputMaybe<Scalars['String']['input']>;
  transfusionDonorNumber?: InputMaybe<Scalars['String']['input']>;
};

export enum TreatmentSheetRowFluidType {
  BloodTransfusion = 'BLOOD_TRANSFUSION',
  Cri = 'CRI',
  PlasmaTransfusion = 'PLASMA_TRANSFUSION',
  Standard = 'STANDARD'
}

export type TreatmentSheetRowInput = {
  additives?: InputMaybe<Array<InputMaybe<TreatmentSheetRowAdditiveInput>>>;
  administration?: InputMaybe<Scalars['String']['input']>;
  boluses?: InputMaybe<Array<InputMaybe<TreatmentSheetRowBolusInput>>>;
  calculatedAmount?: InputMaybe<Scalars['Decimal']['input']>;
  discontinued?: InputMaybe<Scalars['Boolean']['input']>;
  dose?: InputMaybe<Scalars['Decimal']['input']>;
  doseUnit?: InputMaybe<Scalars['String']['input']>;
  extendedInstructions?: InputMaybe<Scalars['String']['input']>;
  fluid?: InputMaybe<TreatmentSheetRowFluidInput>;
  format?: InputMaybe<TreatmentSheetFormat>;
  /**
   * Minutes between administrations. The `-1` ("as needed") and `0` ("one time")
   * sentinels are translated to `scheduleType` while clients on a previous
   * release remain deployed, and rejected once that translation is retired —
   * send `scheduleType: PRN` or `ONCE` instead. `SCHEDULED` requires a positive
   * value; `ONCE`/`CONTINUOUS` require null. On an update, omitting this field
   * keeps the stored frequency.
   */
  frequency?: InputMaybe<Scalars['Int']['input']>;
  inactiveIntervals?: InputMaybe<Array<InputMaybe<TreatmentTimeIntervalInput>>>;
  instructions?: InputMaybe<Scalars['String']['input']>;
  isBillable?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  productId: Scalars['ID']['input'];
  quantity?: InputMaybe<Scalars['Decimal']['input']>;
  /** How the row is scheduled. Omitting it on create stores `SCHEDULED`. */
  scheduleType?: InputMaybe<ScheduleType>;
  start?: InputMaybe<Scalars['DateTime']['input']>;
  totalDose?: InputMaybe<Scalars['Decimal']['input']>;
  type?: InputMaybe<TreatmentSheetType>;
  units?: InputMaybe<TreatmentSheetUnits>;
};

export enum TreatmentSheetSummaryType {
  ProgressNotes = 'PROGRESS_NOTES',
  Summary = 'SUMMARY'
}

export type TreatmentSheetTemplate = {
  __typename?: 'TreatmentSheetTemplate';
  default?: Maybe<Scalars['Boolean']['output']>;
  enabledLocations?: Maybe<Array<Maybe<Location>>>;
  id?: Maybe<Scalars['ID']['output']>;
  isDisabled?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  rows?: Maybe<Scalars['JSON']['output']>;
};

export type TreatmentSheetTemplateInput = {
  default?: InputMaybe<Scalars['Boolean']['input']>;
  enabledLocationIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  isDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  rows?: InputMaybe<Array<InputMaybe<TreatmentTemplateSection>>>;
};

export enum TreatmentSheetType {
  Catheter = 'CATHETER',
  Cri = 'CRI',
  Diagnostic = 'DIAGNOSTIC',
  Fluid = 'FLUID',
  Medication = 'MEDICATION',
  Monitoring = 'MONITORING',
  Nutrition = 'NUTRITION',
  Other = 'OTHER',
  PatientCare = 'PATIENT_CARE',
  Procedure = 'PROCEDURE',
  Task = 'TASK',
  Transfusion = 'TRANSFUSION',
  Vital = 'VITAL'
}

export enum TreatmentSheetUnits {
  Bpm = 'BPM',
  Celsius = 'CELSIUS',
  Drops = 'DROPS',
  Fahrenheit = 'FAHRENHEIT',
  Gm = 'GM',
  Kg = 'KG',
  L = 'L',
  Lbs = 'LBS',
  Mg = 'MG',
  Ml = 'ML',
  Percent = 'PERCENT',
  Tablets = 'TABLETS',
  Units = 'UNITS'
}

export enum TreatmentStatus {
  Active = 'ACTIVE',
  /** Indicates that a treatment order from a Cubex cabinet was declined. Should only be used when the Cubex Two-Way integration is enabled. */
  ApprovalDeclined = 'APPROVAL_DECLINED',
  /** Indicates a treatment ordered from a Cubex cabinet that was deleted. Should only be used when the Cubex Two-Way integration is enabled. */
  Deleted = 'DELETED',
  /** Indicates a treatment returned via Encounter which does not have statuses */
  Null = 'NULL',
  /** Indicates a treatment ordered from a Cubex cabinet that requires approval. Should only be used when the Cubex Two-Way integration is enabled. */
  PendingApproval = 'PENDING_APPROVAL',
  /** Indicates a treatment returned via a Cubex cabinet. Should only be used when the Cubex Two-Way integration is enabled. */
  Returned = 'RETURNED'
}

export type TreatmentTemplateSection = {
  format: Scalars['String']['input'];
  /**
   * Minutes between administrations. `SCHEDULED` requires a positive value and
   * `ONCE`/`CONTINUOUS` require null. The legacy `-1` and `0` sentinels are
   * translated to `schedule_type` `PRN`/`ONCE` while older clients remain
   * deployed (NV-934); they will be rejected once that translation is retired.
   */
  frequency?: InputMaybe<Scalars['Int']['input']>;
  /**
   * Deprecated: send `scheduleType: PRN` instead. Honored for clients on a
   * previous release — `true` is translated to `scheduleType: PRN` when
   * `scheduleType` is absent.
   */
  isPrn?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  productId?: InputMaybe<Scalars['ID']['input']>;
  /**
   * How the row is scheduled; omitting it stores `SCHEDULED` unless a legacy
   * encoding (`isPrn`, sentinel `frequency`) is present to translate.
   */
  scheduleType?: InputMaybe<ScheduleType>;
  type: Scalars['String']['input'];
  units?: InputMaybe<Scalars['String']['input']>;
};

export type TreatmentTimeInterval = {
  __typename?: 'TreatmentTimeInterval';
  begin?: Maybe<Scalars['DateTime']['output']>;
  end?: Maybe<Scalars['DateTime']['output']>;
};

export type TreatmentTimeIntervalInput = {
  begin?: InputMaybe<Scalars['DateTime']['input']>;
  end?: InputMaybe<Scalars['DateTime']['input']>;
};

export type Trigger = {
  __typename?: 'Trigger';
  autoDisabled?: Maybe<Scalars['Boolean']['output']>;
  disabledReason?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  if?: Maybe<TriggerIf>;
  lastCompletedAt?: Maybe<Scalars['DateTime']['output']>;
  on?: Maybe<Scalars['Boolean']['output']>;
  options?: Maybe<TriggerOptions>;
  then?: Maybe<TriggerThen>;
};

export type TriggerAddOrderItemOptions = TriggerOptions & {
  __typename?: 'TriggerAddOrderItemOptions';
  ignoreProviders?: Maybe<Array<Maybe<TriggerIgnoreProvider>>>;
  productId?: Maybe<Scalars['ID']['output']>;
  productTypeIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  products?: Maybe<Array<Maybe<TriggerProduct>>>;
  providerIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  quantity?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type TriggerCreateTaskOptions = TriggerOptions & {
  __typename?: 'TriggerCreateTaskOptions';
  assignees?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  due?: Maybe<Scalars['String']['output']>;
  ignoreProviders?: Maybe<Array<Maybe<TriggerIgnoreProvider>>>;
  productTypeIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  products?: Maybe<Array<Maybe<TriggerProduct>>>;
  providerIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  taskGroupIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type TriggerDefaultOptions = TriggerOptions & {
  __typename?: 'TriggerDefaultOptions';
  ignoreProviders?: Maybe<Array<Maybe<TriggerIgnoreProvider>>>;
  productTypeIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  products?: Maybe<Array<Maybe<TriggerProduct>>>;
  providerIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  type?: Maybe<Scalars['String']['output']>;
};

export enum TriggerIf {
  AppointmentCancelled = 'APPOINTMENT_CANCELLED',
  AppointmentCheckIn = 'APPOINTMENT_CHECK_IN',
  AppointmentReminder = 'APPOINTMENT_REMINDER',
  AppointmentUpdate = 'APPOINTMENT_UPDATE',
  CreatePatient = 'CREATE_PATIENT',
  EventBlockUpdate = 'EVENT_BLOCK_UPDATE',
  InvoiceCharged = 'INVOICE_CHARGED',
  InvoicePaid = 'INVOICE_PAID',
  MicrochipSaved = 'MICROCHIP_SAVED',
  NewAppointment = 'NEW_APPOINTMENT',
  NewEncounter = 'NEW_ENCOUNTER',
  NewEventBlock = 'NEW_EVENT_BLOCK',
  NewImmunization = 'NEW_IMMUNIZATION',
  NewInvoiceGenerated = 'NEW_INVOICE_GENERATED',
  NewPrescription = 'NEW_PRESCRIPTION',
  PatientDocumentUploaded = 'PATIENT_DOCUMENT_UPLOADED',
  PrescriptionDeleted = 'PRESCRIPTION_DELETED',
  ProductsInvoiced = 'PRODUCTS_INVOICED',
  ProductTypesInvoiced = 'PRODUCT_TYPES_INVOICED',
  Reminder = 'REMINDER',
  SaveEstimate = 'SAVE_ESTIMATE',
  SignEncounter = 'SIGN_ENCOUNTER',
  UpdateClient = 'UPDATE_CLIENT',
  UpdatePatient = 'UPDATE_PATIENT',
  WellnessPlanNotRenewed = 'WELLNESS_PLAN_NOT_RENEWED',
  WellnessPlanPaymentFailed = 'WELLNESS_PLAN_PAYMENT_FAILED'
}

export type TriggerIgnoreProvider = {
  __typename?: 'TriggerIgnoreProvider';
  id?: Maybe<Scalars['String']['output']>;
  username?: Maybe<Scalars['String']['output']>;
};

export type TriggerInput = {
  if?: InputMaybe<TriggerIf>;
  on?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<Scalars['JSON']['input']>;
  then?: InputMaybe<TriggerThen>;
};

export type TriggerOptions = {
  ignoreProviders?: Maybe<Array<Maybe<TriggerIgnoreProvider>>>;
  productTypeIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  products?: Maybe<Array<Maybe<TriggerProduct>>>;
  providerIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  type?: Maybe<Scalars['String']['output']>;
};

export type TriggerProduct = {
  __typename?: 'TriggerProduct';
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type TriggerSendEmailOptions = TriggerOptions & {
  __typename?: 'TriggerSendEmailOptions';
  body?: Maybe<Scalars['String']['output']>;
  ignoreProviders?: Maybe<Array<Maybe<TriggerIgnoreProvider>>>;
  productTypeIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  products?: Maybe<Array<Maybe<TriggerProduct>>>;
  providerIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  subject?: Maybe<Scalars['String']['output']>;
  to?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export enum TriggerThen {
  AddOrderItem = 'ADD_ORDER_ITEM',
  CreateTask = 'CREATE_TASK',
  SendEmail = 'SEND_EMAIL',
  Webhook = 'WEBHOOK',
  WebhookPost = 'WEBHOOK_POST'
}

export type TriggerWebhookOptions = TriggerOptions & {
  __typename?: 'TriggerWebhookOptions';
  headers?: Maybe<Scalars['String']['output']>;
  ignoreProviders?: Maybe<Array<Maybe<TriggerIgnoreProvider>>>;
  productTypeIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  products?: Maybe<Array<Maybe<TriggerProduct>>>;
  providerIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  type?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export enum TriggeredProtocolsSortFieldEnum {
  Date = 'DATE',
  DueDate = 'DUE_DATE',
  InsertedAt = 'INSERTED_AT',
  UpdatedAt = 'UPDATED_AT'
}

export type UpdateAppointmentPositionsResult = {
  __typename?: 'UpdateAppointmentPositionsResult';
  message?: Maybe<Scalars['String']['output']>;
  /** Result of update appointment positions */
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdateCareTeamRoleInput = {
  locationIds: Array<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Input for updating a lab order from Harvest (UPenn LIS) lifecycle event. */
export type UpdateHarvestLabOrderInput = {
  comments?: InputMaybe<Scalars['String']['input']>;
  eventType: IguanaLabOrderEventType;
  exams?: InputMaybe<Array<InputMaybe<HarvestExamInput>>>;
  providerId?: InputMaybe<Scalars['ID']['input']>;
  sampleId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<IguanaRisOrderUpdateStatus>;
  vetspireOrderId?: InputMaybe<Scalars['ID']['input']>;
};

/** Input for updating a lab order from Iguana/Penn RIS order lifecycle event. */
export type UpdateIguanaLabOrderInput = {
  accessionNumber?: InputMaybe<Scalars['Int']['input']>;
  eventType: IguanaLabOrderEventType;
  exams?: InputMaybe<Array<InputMaybe<IguanaExamInput>>>;
  history?: InputMaybe<Scalars['String']['input']>;
  modality?: InputMaybe<Scalars['String']['input']>;
  resource?: InputMaybe<Scalars['String']['input']>;
  scheduleDateTime?: InputMaybe<Scalars['String']['input']>;
  stat?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<IguanaRisOrderUpdateStatus>;
  vetspireOrderId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateProviderTransferInput = {
  departmentId?: InputMaybe<Scalars['ID']['input']>;
  locationId: Scalars['ID']['input'];
  providerId?: InputMaybe<Scalars['ID']['input']>;
  startTime?: InputMaybe<Scalars['DateTime']['input']>;
};

export type UpdateStockTransferFulfillmentItemInput = {
  expirationDate?: InputMaybe<Scalars['Date']['input']>;
  fulfillmentNote?: InputMaybe<Scalars['String']['input']>;
  lotNumber?: InputMaybe<Scalars['String']['input']>;
  quantityChangeReason?: InputMaybe<Scalars['String']['input']>;
  receivedQuantity?: InputMaybe<Scalars['Decimal']['input']>;
  status?: InputMaybe<StockTransferFulfillmentItemStatus>;
};

export type UpdateStockTransferReportRecipientInput = {
  email?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateStockTransferRequestInput = {
  collectionNotes?: InputMaybe<Scalars['String']['input']>;
  fromStockLocationId?: InputMaybe<Scalars['ID']['input']>;
  fulfillmentNotes?: InputMaybe<Scalars['String']['input']>;
  isPriority?: InputMaybe<Scalars['Boolean']['input']>;
  isReturn?: InputMaybe<Scalars['Boolean']['input']>;
  orderDate?: InputMaybe<Scalars['DateTime']['input']>;
  requestItems?: InputMaybe<Array<UpdateStockTransferRequestItemInput>>;
  requestNotes?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<StockTransferRequestStatus>;
  toStockLocationId?: InputMaybe<Scalars['ID']['input']>;
  transferDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type UpdateStockTransferRequestItemInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  productId?: InputMaybe<Scalars['ID']['input']>;
  requestedQuantity?: InputMaybe<Scalars['Decimal']['input']>;
};

export type UpdateStockTransferTemplateInput = {
  isPriority?: InputMaybe<Scalars['Boolean']['input']>;
  locationId?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  templateItems?: InputMaybe<Array<UpdateStockTransferTemplateItemInput>>;
  toStockLocationId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateStockTransferTemplateItemInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  productId?: InputMaybe<Scalars['ID']['input']>;
  requestedQuantity?: InputMaybe<Scalars['Decimal']['input']>;
};

export type UpsertProductConfigInput = {
  defaultNotes?: InputMaybe<Scalars['String']['input']>;
  dosageConfig?: InputMaybe<DosageConfigInput>;
};

export type UsageReport = {
  __typename?: 'UsageReport';
  orderItems?: Maybe<Array<Maybe<OrderItem>>>;
  totals?: Maybe<Array<Maybe<UsageReportTotals>>>;
};

export type UsageReportTotals = {
  __typename?: 'UsageReportTotals';
  aggregateType?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  provider?: Maybe<Provider>;
  totalQuantity?: Maybe<Scalars['Decimal']['output']>;
  totalSpend?: Maybe<Scalars['Decimal']['output']>;
};

export type ValuesetDatum = Datum & {
  __typename?: 'ValuesetDatum';
  full?: Maybe<Scalars['Truthy']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  normalDefault?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  options?: Maybe<Array<Maybe<ValuesetDatumOption>>>;
  required?: Maybe<Scalars['Truthy']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type ValuesetDatumOption = {
  __typename?: 'ValuesetDatumOption';
  flag?: Maybe<Scalars['String']['output']>;
  required?: Maybe<Scalars['Truthy']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type Vendor = {
  __typename?: 'Vendor';
  accountNumber?: Maybe<Scalars['String']['output']>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
};

export type VendorInput = {
  accountNumber?: InputMaybe<Scalars['String']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};

export type VetspireSubscription = {
  __typename?: 'VetspireSubscription';
  costPerFaxMillicents: Scalars['Int']['output'];
  costPerSmsMillicents: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  model: SubscriptionModel;
  tiers: Array<VetspireSubscriptionTier>;
};

export type VetspireSubscriptionTier = {
  __typename?: 'VetspireSubscriptionTier';
  cost: Scalars['Price']['output'];
  id: Scalars['String']['output'];
  tier: Scalars['Int']['output'];
  tierEnd?: Maybe<Scalars['Int']['output']>;
};

export type Viewer = {
  __typename?: 'Viewer';
  bridgeUserId?: Maybe<Scalars['ID']['output']>;
  chatLastReadAt?: Maybe<Scalars['DateTime']['output']>;
  commissions?: Maybe<Array<Maybe<ProviderCommission>>>;
  controlledDrugsPin?: Maybe<Scalars['String']['output']>;
  dailySurgeryLimit?: Maybe<Scalars['Int']['output']>;
  defaultLocationId?: Maybe<Scalars['ID']['output']>;
  departments?: Maybe<Array<Maybe<Department>>>;
  electronicSignature?: Maybe<ElectronicSignature>;
  email?: Maybe<Scalars['String']['output']>;
  familyName?: Maybe<Scalars['String']['output']>;
  freshchatRestoreId?: Maybe<Scalars['String']['output']>;
  givenName?: Maybe<Scalars['String']['output']>;
  /** Does this viewer have a certain permission? Returns true if so, false if otherwise. */
  hasPerm?: Maybe<Scalars['Boolean']['output']>;
  historicalId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  insertedAt?: Maybe<Scalars['NaiveDateTime']['output']>;
  isActive?: Maybe<Scalars['Boolean']['output']>;
  isCallCenter?: Maybe<Scalars['Boolean']['output']>;
  isGroomer?: Maybe<Scalars['Boolean']['output']>;
  isOrgAdmin?: Maybe<Scalars['Boolean']['output']>;
  isRelief?: Maybe<Scalars['Boolean']['output']>;
  isSsoEnabled?: Maybe<Scalars['Boolean']['output']>;
  isVeterinarian?: Maybe<Scalars['Boolean']['output']>;
  lastLoginAt?: Maybe<Scalars['NaiveDateTime']['output']>;
  /** @deprecated Please use the field licenses instead. */
  licenseNumber?: Maybe<Scalars['String']['output']>;
  licenses?: Maybe<Array<Maybe<License>>>;
  locations?: Maybe<Array<Maybe<Location>>>;
  missingVetLicense?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  openPunches?: Maybe<Array<Maybe<ProviderPunch>>>;
  org?: Maybe<Org>;
  orgId?: Maybe<Scalars['ID']['output']>;
  outlookEmail?: Maybe<Scalars['String']['output']>;
  outlookVerifiedDate?: Maybe<Scalars['NaiveDateTime']['output']>;
  payrollId?: Maybe<Scalars['String']['output']>;
  position?: Maybe<Scalars['Int']['output']>;
  preferences?: Maybe<ProviderPreferences>;
  profileImageUrl?: Maybe<Scalars['String']['output']>;
  providerRole?: Maybe<ProviderRole>;
  providerRoleId?: Maybe<Scalars['ID']['output']>;
  punches?: Maybe<Array<Maybe<ProviderPunch>>>;
  scheduleTemplate?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  sentOutlookVerificationDate?: Maybe<Scalars['NaiveDateTime']['output']>;
  shortBio?: Maybe<Scalars['String']['output']>;
  suffix?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['NaiveDateTime']['output']>;
  username?: Maybe<Scalars['String']['output']>;
  verified?: Maybe<Scalars['Boolean']['output']>;
  vetsourcePin?: Maybe<Scalars['String']['output']>;
};


export type ViewerHasPermArgs = {
  perm: Scalars['String']['input'];
};


export type ViewerLicenseNumberArgs = {
  field?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};


export type ViewerPunchesArgs = {
  end: Scalars['DateTime']['input'];
  start: Scalars['DateTime']['input'];
};

export type Visit = {
  __typename?: 'Visit';
  externalId?: Maybe<Scalars['String']['output']>;
  headerConfig?: Maybe<VisitHeaderConfig>;
  id: Scalars['ID']['output'];
  location?: Maybe<Location>;
  patient?: Maybe<Patient>;
  /** Ward and kennel linked to this visit (latest placement across its encounters and treatment sheets), including after those records are signed or closed. Null if this visit never had a linked placement. For where the patient is now, use Patient.lastKnownLocation. */
  patientLocation?: Maybe<PatientLocation>;
  readyForDischarge?: Maybe<Scalars['Boolean']['output']>;
  start: Scalars['DateTime']['output'];
  startDate?: Maybe<Scalars['Date']['output']>;
  startTime?: Maybe<Scalars['Time']['output']>;
  stop?: Maybe<Scalars['DateTime']['output']>;
  stopDate?: Maybe<Scalars['Date']['output']>;
  stopTime?: Maybe<Scalars['Time']['output']>;
  timezone?: Maybe<Scalars['String']['output']>;
  visitType?: Maybe<VisitType>;
};

export type VisitHeaderConfig = {
  __typename?: 'VisitHeaderConfig';
  diagnosisSelections?: Maybe<Array<Maybe<VisitHeaderDiagnosisSelection>>>;
  id: Scalars['ID']['output'];
  primaryContactClient?: Maybe<Client>;
  primaryContactClientId?: Maybe<Scalars['ID']['output']>;
  rdvmSelections?: Maybe<Array<Maybe<VisitHeaderRdvmSelection>>>;
  selectedDiagnoses?: Maybe<Array<Maybe<PatientDiagnosis>>>;
  selectedRdvms?: Maybe<Array<Maybe<Rdvm>>>;
  showDiagnosis?: Maybe<Scalars['Boolean']['output']>;
  showPrimaryContact?: Maybe<Scalars['Boolean']['output']>;
  showRdvm?: Maybe<Scalars['Boolean']['output']>;
};

export type VisitHeaderDiagnosisSelection = {
  __typename?: 'VisitHeaderDiagnosisSelection';
  id: Scalars['ID']['output'];
  patientDiagnosis?: Maybe<PatientDiagnosis>;
  patientDiagnosisId: Scalars['ID']['output'];
  visitHeaderConfigId: Scalars['ID']['output'];
};

export type VisitHeaderRdvmSelection = {
  __typename?: 'VisitHeaderRdvmSelection';
  id: Scalars['ID']['output'];
  rdvm?: Maybe<Rdvm>;
  rdvmId: Scalars['ID']['output'];
  visitHeaderConfigId: Scalars['ID']['output'];
};

export type VisitItemInput = {
  id: Scalars['ID']['input'];
  itemType: VisitItemType;
};

export enum VisitItemType {
  ClinicalNote = 'CLINICAL_NOTE',
  Conversation = 'CONVERSATION',
  Encounter = 'ENCOUNTER',
  LabResult = 'LAB_RESULT',
  Medication = 'MEDICATION',
  PatientDocument = 'PATIENT_DOCUMENT',
  ReminderSilence = 'REMINDER_SILENCE',
  Task = 'TASK',
  TreatmentSheet = 'TREATMENT_SHEET'
}

export enum VisitType {
  Ambulatory = 'AMBULATORY',
  Boarding = 'BOARDING',
  Emergency = 'EMERGENCY',
  EConsult = 'E_CONSULT',
  FieldService = 'FIELD_SERVICE',
  InPatient = 'IN_PATIENT',
  MedicalBoarding = 'MEDICAL_BOARDING',
  OutPatient = 'OUT_PATIENT'
}

export type VisitsReportItem = {
  __typename?: 'VisitsReportItem';
  clientId?: Maybe<Scalars['ID']['output']>;
  clientName?: Maybe<Scalars['String']['output']>;
  encounterId?: Maybe<Scalars['ID']['output']>;
  encounterSigned?: Maybe<Scalars['Boolean']['output']>;
  locationName?: Maybe<Scalars['String']['output']>;
  patientId?: Maybe<Scalars['ID']['output']>;
  patientName?: Maybe<Scalars['String']['output']>;
  patientSpecies?: Maybe<Scalars['String']['output']>;
  providerId?: Maybe<Scalars['ID']['output']>;
  providerName?: Maybe<Scalars['String']['output']>;
  visitEndDate?: Maybe<Scalars['Date']['output']>;
  visitEndTime?: Maybe<Scalars['Time']['output']>;
  visitId?: Maybe<Scalars['ID']['output']>;
  visitIdentifier?: Maybe<Scalars['String']['output']>;
  visitReason?: Maybe<Scalars['String']['output']>;
  visitStartDate?: Maybe<Scalars['Date']['output']>;
  visitStartTime?: Maybe<Scalars['Time']['output']>;
  visitType?: Maybe<Scalars['String']['output']>;
};

export type VisitsReportItemConnection = {
  __typename?: 'VisitsReportItemConnection';
  edges?: Maybe<Array<Maybe<VisitsReportItemEdge>>>;
  pageInfo: PageInfo;
};

export type VisitsReportItemEdge = {
  __typename?: 'VisitsReportItemEdge';
  cursor?: Maybe<Scalars['String']['output']>;
  node?: Maybe<VisitsReportItem>;
};

export type VitalDatum = Datum & {
  __typename?: 'VitalDatum';
  field?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  required?: Maybe<Scalars['Truthy']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  unit?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** Vitals */
export type Vitals = {
  __typename?: 'Vitals';
  appointment?: Maybe<Appointment>;
  attitude?: Maybe<Scalars['String']['output']>;
  crt?: Maybe<Scalars['String']['output']>;
  customs?: Maybe<Array<Maybe<CustomVital>>>;
  datetime?: Maybe<Scalars['NaiveDateTime']['output']>;
  encounter?: Maybe<Encounter>;
  encounterId?: Maybe<Scalars['ID']['output']>;
  heartRate?: Maybe<Scalars['Decimal']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  insertedAt?: Maybe<Scalars['NaiveDateTime']['output']>;
  mm?: Maybe<Scalars['String']['output']>;
  pain?: Maybe<Scalars['Int']['output']>;
  patient?: Maybe<Patient>;
  respRate?: Maybe<Scalars['Decimal']['output']>;
  temp?: Maybe<Scalars['Decimal']['output']>;
  updatedAt?: Maybe<Scalars['NaiveDateTime']['output']>;
  weight?: Maybe<Scalars['Decimal']['output']>;
  weightUnit?: Maybe<WeightUnit>;
};

export type VitalsInput = {
  attitude?: InputMaybe<Scalars['String']['input']>;
  crt?: InputMaybe<Scalars['String']['input']>;
  customs?: InputMaybe<Array<InputMaybe<CustomVitalInput>>>;
  datetime?: InputMaybe<Scalars['DateTime']['input']>;
  encounterId?: InputMaybe<Scalars['ID']['input']>;
  heartRate?: InputMaybe<Scalars['Decimal']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  mm?: InputMaybe<Scalars['String']['input']>;
  pain?: InputMaybe<Scalars['Int']['input']>;
  patientId?: InputMaybe<Scalars['ID']['input']>;
  respRate?: InputMaybe<Scalars['Decimal']['input']>;
  temp?: InputMaybe<Scalars['Decimal']['input']>;
  weight?: InputMaybe<Scalars['Decimal']['input']>;
  weightUnit?: InputMaybe<WeightUnit>;
};

export type VitalsTemplate = {
  __typename?: 'VitalsTemplate';
  field?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type VitalsTemplateInput = {
  field?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type VoiceCall = {
  __typename?: 'VoiceCall';
  callForwardedName?: Maybe<Scalars['String']['output']>;
  callLog?: Maybe<CallLog>;
  client?: Maybe<Client>;
  clientId?: Maybe<Scalars['ID']['output']>;
  dismissed?: Maybe<Scalars['Boolean']['output']>;
  duration?: Maybe<Scalars['Int']['output']>;
  fromLocation?: Maybe<Scalars['String']['output']>;
  fromName?: Maybe<Scalars['String']['output']>;
  fromPhoneNumber?: Maybe<Scalars['String']['output']>;
  handledByRemoteVet?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  insertedAt?: Maybe<Scalars['NaiveDateTime']['output']>;
  location?: Maybe<Location>;
  locationId?: Maybe<Scalars['ID']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  teleSessionCreated?: Maybe<Scalars['Boolean']['output']>;
  telephonyId?: Maybe<Scalars['String']['output']>;
  telephonySessionId?: Maybe<Scalars['String']['output']>;
  toPhoneNumber?: Maybe<Scalars['String']['output']>;
  voicemailTranscription?: Maybe<Scalars['String']['output']>;
};

export type VoiceCallInput = {
  callLogId?: InputMaybe<Scalars['ID']['input']>;
  clientId?: InputMaybe<Scalars['ID']['input']>;
  dismissed?: InputMaybe<Scalars['Boolean']['input']>;
  handledByRemoteVet?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  teleSessionCreated?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum WastageReason {
  Expired = 'EXPIRED',
  Other = 'OTHER',
  ValidatedCount = 'VALIDATED_COUNT',
  Wastage = 'WASTAGE'
}

export enum WeekOfMonth {
  /** First week of the month */
  First = 'FIRST',
  /** Fourth week of the month */
  Fourth = 'FOURTH',
  /** Last week of the month */
  Last = 'LAST',
  /** Second week of the month */
  Second = 'SECOND',
  /** Third week of the month */
  Third = 'THIRD'
}

export type Weight = {
  __typename?: 'Weight';
  id: Scalars['ID']['output'];
  unit?: Maybe<WeightUnit>;
  value?: Maybe<Scalars['Decimal']['output']>;
};

export enum WeightUnit {
  G = 'G',
  Kg = 'KG',
  Lb = 'LB',
  M2 = 'M2'
}
